'use client';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { useMediaQuery, Box, useTheme as useTheme$1, Paper, Typography, Tooltip, IconButton, Snackbar, Alert, CircularProgress, Button as Button$1, Container as Container$9, Stack, Skeleton, Avatar, Chip, Menu as Menu$1, MenuItem, Card, CardContent, ButtonGroup, Collapse, TextField as TextField$1, FormControl, InputLabel, Select, FormHelperText, FormControlLabel, Switch, Grid, Divider, Link, Rating, Modal, ListItemIcon, ListItemText, Dialog as Dialog$1, DialogTitle as DialogTitle$1, DialogContent as DialogContent$1, DialogActions as DialogActions$1, DialogContentText as DialogContentText$1, Input as Input$5, InputAdornment, Checkbox } from '@mui/material';
import React, { useMemo, useContext, useState, useCallback, useEffect, createContext, useReducer, useRef, isValidElement, createElement, useId, useLayoutEffect, Component, cloneElement } from 'react';
import { MustacheTemplateProvider, MemoryCacheProvider, CachedDataProvider, Field, Editor, FieldType, Schema, Model, DataType } from '@qwickapps/schema';
import { createTheme, ThemeProvider as ThemeProvider$1 } from '@mui/material/styles';
import ContentCopy from '@mui/icons-material/ContentCopy';
import Check from '@mui/icons-material/Check';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Add from '@mui/icons-material/Add';
import Architecture from '@mui/icons-material/Architecture';
import ArrowBack from '@mui/icons-material/ArrowBack';
import ArrowForward from '@mui/icons-material/ArrowForward';
import Article$1 from '@mui/icons-material/Article';
import AttachMoney from '@mui/icons-material/AttachMoney';
import Autorenew from '@mui/icons-material/Autorenew';
import Block from '@mui/icons-material/Block';
import Book from '@mui/icons-material/Book';
import Business from '@mui/icons-material/Business';
import CheckCircle from '@mui/icons-material/CheckCircle';
import Close from '@mui/icons-material/Close';
import Cloud from '@mui/icons-material/Cloud';
import CloudDownload from '@mui/icons-material/CloudDownload';
import CloudUpload from '@mui/icons-material/CloudUpload';
import Code$1 from '@mui/icons-material/Code';
import Computer from '@mui/icons-material/Computer';
import Construction from '@mui/icons-material/Construction';
import Dashboard from '@mui/icons-material/Dashboard';
import Delete from '@mui/icons-material/Delete';
import Download from '@mui/icons-material/Download';
import Edit from '@mui/icons-material/Edit';
import Email from '@mui/icons-material/Email';
import Explore from '@mui/icons-material/Explore';
import Favorite from '@mui/icons-material/Favorite';
import Group from '@mui/icons-material/Group';
import Help from '@mui/icons-material/Help';
import HelpOutline from '@mui/icons-material/HelpOutline';
import Home from '@mui/icons-material/Home';
import Info from '@mui/icons-material/Info';
import InsertPhoto from '@mui/icons-material/InsertPhoto';
import IntegrationInstructions from '@mui/icons-material/IntegrationInstructions';
import Inventory from '@mui/icons-material/Inventory';
import Inventory2 from '@mui/icons-material/Inventory2';
import Key from '@mui/icons-material/Key';
import Layers from '@mui/icons-material/Layers';
import LibraryBooks from '@mui/icons-material/LibraryBooks';
import LocalOffer from '@mui/icons-material/LocalOffer';
import Lock from '@mui/icons-material/Lock';
import LockOpen from '@mui/icons-material/LockOpen';
import Login from '@mui/icons-material/Login';
import Logout from '@mui/icons-material/Logout';
import ManageAccounts from '@mui/icons-material/ManageAccounts';
import Memory from '@mui/icons-material/Memory';
import Menu from '@mui/icons-material/Menu';
import Notifications from '@mui/icons-material/Notifications';
import People from '@mui/icons-material/People';
import Person from '@mui/icons-material/Person';
import PersonSearch from '@mui/icons-material/PersonSearch';
import Phone from '@mui/icons-material/Phone';
import PhotoLibrary from '@mui/icons-material/PhotoLibrary';
import PlayArrow from '@mui/icons-material/PlayArrow';
import Psychology from '@mui/icons-material/Psychology';
import Refresh from '@mui/icons-material/Refresh';
import Rocket from '@mui/icons-material/Rocket';
import RotateRight from '@mui/icons-material/RotateRight';
import Route from '@mui/icons-material/Route';
import Save from '@mui/icons-material/Save';
import Search from '@mui/icons-material/Search';
import Security from '@mui/icons-material/Security';
import Send from '@mui/icons-material/Send';
import Settings from '@mui/icons-material/Settings';
import Share from '@mui/icons-material/Share';
import Shield from '@mui/icons-material/Shield';
import ShoppingCart from '@mui/icons-material/ShoppingCart';
import Speed from '@mui/icons-material/Speed';
import Star from '@mui/icons-material/Star';
import Storage from '@mui/icons-material/Storage';
import SupportAgent from '@mui/icons-material/SupportAgent';
import Sync from '@mui/icons-material/Sync';
import TrendingUp from '@mui/icons-material/TrendingUp';
import Tune from '@mui/icons-material/Tune';
import VerifiedUser from '@mui/icons-material/VerifiedUser';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import VpnKey from '@mui/icons-material/VpnKey';
import Work from '@mui/icons-material/Work';
import WorkspacePremium from '@mui/icons-material/WorkspacePremium';
import Accessibility from '@mui/icons-material/Accessibility';
import BrokenImage from '@mui/icons-material/BrokenImage';
import Circle from '@mui/icons-material/Circle';
import DarkMode from '@mui/icons-material/DarkMode';
import Error$1 from '@mui/icons-material/Error';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import FormatBold from '@mui/icons-material/FormatBold';
import FormatItalic from '@mui/icons-material/FormatItalic';
import FormatUnderlined from '@mui/icons-material/FormatUnderlined';
import Launch from '@mui/icons-material/Launch';
import LightMode from '@mui/icons-material/LightMode';
import MoreVert from '@mui/icons-material/MoreVert';
import Palette from '@mui/icons-material/Palette';
import RadioButtonUnchecked from '@mui/icons-material/RadioButtonUnchecked';
import Schedule from '@mui/icons-material/Schedule';
import SettingsSystemDaydream from '@mui/icons-material/SettingsSystemDaydream';
import Warning$3 from '@mui/icons-material/Warning';
import { IsOptional, ValidateIf, IsIn, IsInt, Min, IsString, IsBoolean, IsArray, ValidateNested, IsUrl, IsNumber, IsObject, IsNotEmpty, Max } from 'class-validator';
import { Type } from 'class-transformer';
import 'reflect-metadata';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useInRouterContext, useNavigate, useLocation } from 'react-router-dom';

/**
 * Breakpoint utilities for QwickApps React Framework
 *
 * Consolidates all breakpoint-related logic and type conversions
 * to ensure consistency across components.
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
/**
 * Standard MUI breakpoint pixel values
 */
const MUI_BREAKPOINT_VALUES = {
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1536
};
/**
 * Mapping from extended names to MUI breakpoint names
 */
const EXTENDED_TO_MUI_MAP = {
  'extra-small': 'xs',
  'small': 'sm',
  'medium': 'md',
  'large': 'lg',
  'extra-large': 'xl'
};
/**
 * Converts any breakpoint value to MUI breakpoint format
 * Handles extended names, MUI names, and false values
 */
function mapToMUIBreakpoint(value) {
  if (value === false || value === undefined) {
    return false;
  }
  // Direct MUI breakpoint
  if (value in MUI_BREAKPOINT_VALUES) {
    return value;
  }
  // Extended breakpoint name
  if (value in EXTENDED_TO_MUI_MAP) {
    return EXTENDED_TO_MUI_MAP[value];
  }
  // Default fallback
  return 'lg';
}

/**
 * Dimension utilities for QwickApps React Framework
 *
 * Provides standardized dimension value resolution with t-shirt sizing
 * and MUI breakpoint compatibility
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
/**
 * T-shirt size mappings for different dimension contexts
 */
const TSHIRT_SIZES = {
  width: {
    tiny: 120,
    small: 200,
    medium: 300,
    large: 400,
    'x-large': 500,
    huge: 600
  },
  height: {
    tiny: 200,
    small: 300,
    medium: 400,
    large: 500,
    'x-large': 600,
    huge: 800
  },
  maxWidth: {
    tiny: 300,
    small: 600,
    medium: 900,
    large: 1200,
    'x-large': 1536,
    huge: 1920
  },
  maxHeight: {
    tiny: 200,
    small: 400,
    medium: 600,
    large: 800,
    'x-large': 1000,
    huge: 1200
  },
  minWidth: {
    tiny: 50,
    small: 100,
    medium: 200,
    large: 300,
    'x-large': 400,
    huge: 500
  },
  minHeight: {
    tiny: 50,
    small: 100,
    medium: 200,
    large: 300,
    'x-large': 400,
    huge: 500
  }
};
/**
 * CSS value pattern for validation
 */
const CSS_VALUE_PATTERN = /^(\d+(\.\d+)?(px|%|em|rem|vh|vw|fr|ch|ex)|auto|inherit|initial|unset|min-content|max-content|fit-content)$/;
/**
 * Resolves a dimension value to a valid CSS value
 */
function resolveDimension(value, context = 'width') {
  if (value === undefined || value === null) {
    return undefined;
  }
  // Number values are returned as-is
  if (typeof value === 'number') {
    return value;
  }
  // Auto and grow are always valid
  if (value === 'auto') {
    return 'auto';
  }
  if (value === 'grow') {
    return '1'; // Flex grow: 1 for CSS flexbox
  }
  // Check for t-shirt sizes
  const tshirtSizes = TSHIRT_SIZES[context];
  if (tshirtSizes && value in tshirtSizes) {
    return tshirtSizes[value];
  }
  // Check for MUI breakpoint values (for maxWidth/width contexts)
  if ((context === 'maxWidth' || context === 'width') && value in MUI_BREAKPOINT_VALUES) {
    return MUI_BREAKPOINT_VALUES[value];
  }
  // Validate CSS string values
  if (typeof value === 'string') {
    if (CSS_VALUE_PATTERN.test(value)) {
      return value;
    } else {
      console.warn(`[QwickApps] Invalid CSS dimension value: "${value}". Using as-is but consider using a valid CSS value or t-shirt size.`);
      return value;
    }
  }
  return undefined;
}
/**
 * Resolves multiple dimension props at once
 */
function resolveDimensions(props) {
  return {
    width: resolveDimension(props.width, 'width'),
    height: resolveDimension(props.height, 'height'),
    minWidth: resolveDimension(props.minWidth, 'minWidth'),
    minHeight: resolveDimension(props.minHeight, 'minHeight'),
    maxWidth: resolveDimension(props.maxWidth, 'maxWidth'),
    maxHeight: resolveDimension(props.maxHeight, 'maxHeight')
  };
}

/**
 * Spacing utilities for QwickApps React Framework
 *
 * Provides standardized spacing value resolution with t-shirt sizing
 * Based on Material-UI's 8px spacing system
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
/**
 * T-shirt size mappings for spacing (based on MUI's 8px system)
 * Numbers represent multipliers for the base spacing unit
 */
const SPACING_SIZES = {
  none: 0,
  tiny: 0.5,
  // 4px
  small: 1,
  // 8px
  medium: 2,
  // 16px
  large: 3,
  // 24px
  huge: 4 // 32px
};
/**
 * CSS spacing value pattern for validation
 */
const CSS_SPACING_PATTERN = /^(\d+(\.\d+)?(px|em|rem|%)|0|auto|inherit|initial|unset)$/;
/**
 * Resolves a spacing value to MUI spacing units or CSS value
 */
function resolveSpacing(value) {
  if (value === undefined || value === null) {
    return undefined;
  }
  // Number values are returned as-is (MUI spacing units)
  if (typeof value === 'number') {
    return value;
  }
  // Check for t-shirt sizes
  if (value in SPACING_SIZES) {
    return SPACING_SIZES[value];
  }
  // Validate CSS string values
  if (typeof value === 'string') {
    // Check if it's a space-separated value (for margin/padding shorthand)
    const parts = value.split(' ');
    if (parts.length > 1) {
      // Validate each part
      const validParts = parts.every(part => CSS_SPACING_PATTERN.test(part) || part in SPACING_SIZES);
      if (validParts) {
        // Convert t-shirt sizes in the string
        return parts.map(part => {
          if (part in SPACING_SIZES) {
            return `${SPACING_SIZES[part] * 8}px`;
          }
          return part;
        }).join(' ');
      }
    }
    // Single value validation
    if (CSS_SPACING_PATTERN.test(value)) {
      return value;
    } else {
      console.warn(`[QwickApps] Invalid CSS spacing value: "${value}". Using as-is but consider using a valid CSS value or t-shirt size.`);
      return value;
    }
  }
  return undefined;
}
/**
 * Resolves spacing props with support for directional values
 */
function resolveSpacingProps(props) {
  const resolved = {};
  // Padding
  if (props.padding !== undefined) {
    resolved.p = resolveSpacing(props.padding);
  }
  if (props.paddingTop !== undefined) {
    resolved.pt = resolveSpacing(props.paddingTop);
  }
  if (props.paddingRight !== undefined) {
    resolved.pr = resolveSpacing(props.paddingRight);
  }
  if (props.paddingBottom !== undefined) {
    resolved.pb = resolveSpacing(props.paddingBottom);
  }
  if (props.paddingLeft !== undefined) {
    resolved.pl = resolveSpacing(props.paddingLeft);
  }
  if (props.paddingX !== undefined) {
    resolved.px = resolveSpacing(props.paddingX);
  }
  if (props.paddingY !== undefined) {
    resolved.py = resolveSpacing(props.paddingY);
  }
  // Margin
  if (props.margin !== undefined) {
    resolved.m = resolveSpacing(props.margin);
  }
  if (props.marginTop !== undefined) {
    resolved.mt = resolveSpacing(props.marginTop);
  }
  if (props.marginRight !== undefined) {
    resolved.mr = resolveSpacing(props.marginRight);
  }
  if (props.marginBottom !== undefined) {
    resolved.mb = resolveSpacing(props.marginBottom);
  }
  if (props.marginLeft !== undefined) {
    resolved.ml = resolveSpacing(props.marginLeft);
  }
  if (props.marginX !== undefined) {
    resolved.mx = resolveSpacing(props.marginX);
  }
  if (props.marginY !== undefined) {
    resolved.my = resolveSpacing(props.marginY);
  }
  return resolved;
}

/**
 * Base props hook for QwickApps React Framework components
 *
 * Provides standardized prop handling for all framework components
 * including grid behavior, dimensions, spacing, and styling
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
/**
 * Marker to identify QwickApps components
 */
const QWICKAPP_COMPONENT = Symbol('QwickAppComponent');
/**
 * Hook to process base component props
 */
function useBaseProps(props) {
  const {
    // Grid props
    span,
    xs,
    sm,
    md,
    lg,
    xl,
    // Style props
    className,
    sx,
    style,
    // Dimension props
    width,
    height,
    minWidth,
    minHeight,
    maxWidth,
    maxHeight,
    // Spacing props
    padding,
    paddingTop,
    paddingRight,
    paddingBottom,
    paddingLeft,
    paddingX,
    paddingY,
    margin,
    marginTop,
    marginRight,
    marginBottom,
    marginLeft,
    marginX,
    marginY,
    // Background props
    background,
    backgroundImage,
    backgroundGradient,
    // Text alignment
    textAlign,
    // HTML attributes
    id,
    role,
    'aria-label': ariaLabel,
    'aria-labelledby': ariaLabelledby,
    'aria-describedby': ariaDescribedby,
    'data-testid': dataTestId,
    // Event handlers
    onClick,
    onMouseEnter,
    onMouseLeave,
    onFocus,
    onBlur,
    // Rest of the props
    ...restProps
  } = props;
  // Memoize grid props
  const gridProps = useMemo(() => {
    if (span || xs || sm || md || lg || xl) {
      return {
        span,
        xs: span || xs,
        sm: span || sm,
        md: span || md,
        lg: span || lg,
        xl: span || xl
      };
    }
    return null;
  }, [span, xs, sm, md, lg, xl]);
  // Memoize resolved dimensions
  const dimensions = useMemo(() => {
    return resolveDimensions({
      width,
      height,
      minWidth,
      minHeight,
      maxWidth,
      maxHeight
    });
  }, [width, height, minWidth, minHeight, maxWidth, maxHeight]);
  // Memoize resolved spacing
  const spacing = useMemo(() => {
    return resolveSpacingProps({
      padding,
      paddingTop,
      paddingRight,
      paddingBottom,
      paddingLeft,
      paddingX,
      paddingY,
      margin,
      marginTop,
      marginRight,
      marginBottom,
      marginLeft,
      marginX,
      marginY
    });
  }, [padding, paddingTop, paddingRight, paddingBottom, paddingLeft, paddingX, paddingY, margin, marginTop, marginRight, marginBottom, marginLeft, marginX, marginY]);
  // Memoize background and text styles
  const backgroundAndTextStyles = useMemo(() => {
    const styles = {};
    if (backgroundGradient) {
      styles.background = backgroundGradient;
    } else if (backgroundImage) {
      styles.backgroundImage = `url(${backgroundImage})`;
      styles.backgroundSize = 'cover';
      styles.backgroundPosition = 'center';
      styles.backgroundRepeat = 'no-repeat';
    } else if (background) {
      // Could be a color or theme path
      styles.background = background;
    }
    if (textAlign) {
      styles.textAlign = textAlign;
    }
    return styles;
  }, [background, backgroundImage, backgroundGradient, textAlign]);
  // Combine all style props
  const combinedSx = useMemo(() => {
    return {
      ...dimensions,
      ...spacing,
      ...backgroundAndTextStyles,
      ...sx
    };
  }, [dimensions, spacing, backgroundAndTextStyles, sx]);
  // HTML attributes and event handlers
  const htmlProps = {
    id,
    role,
    'aria-label': ariaLabel,
    'aria-labelledby': ariaLabelledby,
    'aria-describedby': ariaDescribedby,
    'data-testid': dataTestId,
    onClick,
    onMouseEnter,
    onMouseLeave,
    onFocus,
    onBlur
  };
  return {
    gridProps,
    styleProps: {
      className,
      sx: combinedSx,
      style
    },
    htmlProps,
    restProps: restProps
  };
}

/**
 * QwickApps React Framework - Logger Utility
 *
 * Optional logging with fallback to console when @qwickapps/logging is not available
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
/**
 * Console-based logger fallback
 */
class ConsoleLogger {
  constructor(name) {
    this.name = name;
  }
  debug(message, ...args) {
  }
  info(message, ...args) {
    console.info(`[${this.name}] ${message}`, ...args);
  }
  warn(message, ...args) {
    console.warn(`[${this.name}] ${message}`, ...args);
  }
  error(message, ...args) {
    console.error(`[${this.name}] ${message}`, ...args);
  }
}
/**
 * No-op logger for when logging should be disabled
 * Not currently used but available for future configuration options
 */
// class NoOpLogger implements Logger {
//   // intentionally empty - no-op logger
//   debug(): void {}
//   // intentionally empty - no-op logger
//   info(): void {}
//   // intentionally empty - no-op logger
//   warn(): void {}
//   // intentionally empty - no-op logger
//   error(): void {}
// }
/**
 * Create logger with optional @qwickapps/logging dependency
 */
function getLogger(name) {
  try {
    // Try to use @qwickapps/logging if available
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const logging = require('@qwickapps/logging');
    return logging.getLogger(name);
  } catch {
    // Fallback to console-based logger
    return new ConsoleLogger(name);
  }
}
/**
 * Framework-specific loggers
 */
const loggers = {
  scaffold: getLogger('Scaffold'),
  navigation: getLogger('Navigation'),
  auth: getLogger('Auth'),
  theme: getLogger('Theme'),
  palette: getLogger('Palette'),
  form: getLogger('Form'),
  layout: getLogger('Layout'),
  menu: getLogger('Menu'),
  router: getLogger('Router')
};

/**
* ContentResolver provides a unified interface to fetch and render content
* using data providers, template resolvers, and optional caching.
*
* Copyright (c) 2025 QwickApps.com. All rights reserved.
*/
/**
 * ContentResolver - Combines data, template, and cache providers
 *
 * This class follows the orchestrator pattern:
 * - Delegates data fetching to IDataProvider
 * - Delegates template resolution to ITemplateResolver
 * - Optionally wraps data provider with ICacheProvider
 * - Creates ContentProxy objects for framework compatibility
 *
 * Usage:
 * ```typescript
 * const resolver = new ContentResolver({
 *   dataProvider: new JsonDataProvider({ data: {...} }),
 *   templateResolver: new MustacheTemplateResolver(),
 *   cacheProvider: new MemoryCacheProvider({ maxSize: 50, defaultTtl: 60000 })
 * });
 *
 * // Or with boolean cacheProvider (uses default MemoryCacheProvider)
 * const resolver = new ContentResolver({
 *   dataProvider: new JsonDataProvider({ data: {...} }),
 *   cacheProvider: true
 * });
 *
 * // Or no caching
 * const resolver = new ContentResolver({
 *   dataProvider: new JsonDataProvider({ data: {...} }),
 *   cacheProvider: false // or omit entirely
 * });
 * ```
 */
class TemplateResolver {
  constructor(config) {
    this.log = getLogger('ContentResolver');
    this.enableLogging = config.enableLogging || false;
    this.templateResolver = config.templateResolver || new MustacheTemplateProvider();
    if (config.cacheProvider === true) {
      new MemoryCacheProvider({
        enableLogging: config.enableLogging || false
      });
      this.dataProvider = new CachedDataProvider(config.dataProvider);
    } else if (config.cacheProvider === false) {
      this.dataProvider = config.dataProvider;
    } else {
      new MemoryCacheProvider({
        enableLogging: config.enableLogging || false
      });
      this.dataProvider = new CachedDataProvider(config.dataProvider);
    }
    this.log.debug('ContentResolver initialized', {
      dataProvider: config.dataProvider ? config.dataProvider.constructor.name : 'none',
      templateResolver: this.templateResolver.constructor.name,
      cacheProvider: config.cacheProvider ? config.cacheProvider === true ? 'MemoryCacheProvider(default)' : config.cacheProvider.constructor.name : 'disabled'
    });
  }
  async get(slug) {
    return this.dataProvider.get(slug);
  }
  async select(schema, options) {
    return this.dataProvider.select(schema, options);
  }
  /**
   * Resolve template with lazy context loading
   */
  async resolveTemplate(template) {
    this.log.debug(`Resolving template: ${template}`);
    if (!template || !template.includes('{{')) {
      // No mustache syntax, return as-is
      return template;
    }
    // Create lazy context proxy
    const context = await this.createLazyContext(template);
    // Resolve using template resolver
    try {
      const resolved = this.templateResolver.resolve(template, context);
      this.log.debug(`Template resolved: ${template} -> ${resolved}`);
      return resolved;
    } catch (error) {
      this.log.debug(`Template resolution failed: ${error instanceof Error ? error.message : String(error)}`);
      throw error;
    }
  }
  /**
   * Create lazy loading context for template resolution
   * Only fetches data when accessed by mustache template
   */
  async createLazyContext(template) {
    // Extract field group IDs from template
    const mustachePattern = /\{\{([^}]+)\}\}/g;
    const matches = Array.from(template.matchAll(mustachePattern));
    const fieldGroups = new Set();
    for (const match of matches) {
      const fullPath = match[1].trim();
      const [fieldGroupId] = fullPath.split('.');
      fieldGroups.add(fieldGroupId);
    }
    // Fetch all needed data
    const contextData = {};
    for (const fieldGroupId of fieldGroups) {
      try {
        // First try to get it as an array using select
        const arrayData = await this.select(fieldGroupId);
        if (arrayData.data && arrayData.data.length > 0) {
          // Use first item for template context - use data directly
          contextData[fieldGroupId] = arrayData.data[0];
        } else {
          // Fallback to get single item
          const data = await this.get(fieldGroupId);
          if (data.data) {
            contextData[fieldGroupId] = data.data;
          }
        }
      } catch (error) {
        this.log.error(`Failed to load data for ${fieldGroupId}: ${error instanceof Error ? error.message : String(error)}`);
        // Continue with other field groups
      }
    }
    return contextData;
  }
}

/**
 * React Context for data provider
 */
const DataContext = /*#__PURE__*/createContext(null);
/**
 * DataProvider component that wraps children with data templating capabilities
 *
 * Enables JSX components to use mustache syntax for data interpolation:
 * - {t`Welcome {{company.name}}!`}
 * - {useData('users')} for data fetching
 * - Template resolution with caching support
 *
 * Usage (new SRP architecture):
 * ```tsx
 * <DataProvider dataSource={{
 *   dataProvider: new JsonDataProvider({ data: { ... } }),
 *   cache: true,
 *   templateResolver: new MustacheTemplateResolver()
 * }}>
 *   <MyComponent /> // Can use useData() hooks and t`` templates
 * </DataProvider>
 * ```
 */
function DataProvider({
  dataSource,
  children
}) {
  // Create TemplateResolver internally
  const dataProvider = new TemplateResolver(dataSource);
  const contextValue = {
    provider: dataProvider,
    get: async slug => {
      const result = await dataProvider.get(slug);
      return result && result.data ? result.data : undefined;
    },
    select: async (schema, options) => {
      const result = await dataProvider.select(schema, options);
      return result && Array.isArray(result.data) ? result.data : [];
    },
    resolveTemplate: template => dataProvider.resolveTemplate(template)
  };
  return jsx(DataContext.Provider, {
    value: contextValue,
    children: children
  });
}
/**
 * Hook to access the data context
 *
 * @throws Error if used outside of DataProvider
 */
function useDataContext() {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error('useDataContext must be used within a DataProvider. Did you wrap your component with <DataProvider>?');
  }
  return context;
}
/**
 * Hook to get data by unique slug (safe version that doesn't throw)
 *
 * @param slug - The unique slug to fetch data for
 * @returns Data with loading state information
 */
function useDataSafe(slug) {
  const context = useContext(DataContext);
  // Always call hooks before any returns
  const [data, setData] = useState(undefined);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // Always call useEffect unconditionally
  useEffect(() => {
    // Only fetch if context exists
    if (!context) {
      setLoading(false);
      return;
    }
    const fetchData = async () => {
      if (!slug) {
        setLoading(false);
        return;
      }
      try {
        setLoading(true);
        setError(null);
        const result = await context.get(slug);
        setData(result);
        setLoading(false);
      } catch (err) {
        setError(err instanceof Error ? err : new Error(String(err)));
        setLoading(false);
      }
    };
    fetchData();
  }, [context, slug]);
  // Return early if no context
  if (!context) {
    return {
      data: undefined,
      loading: false,
      error: null
    };
  }
  return {
    data,
    loading,
    error
  };
}
/**
 * Hook to get data by field group ID
 *
 * @param fieldGroupId - The field group to fetch
 * @returns Data and loading state
 */
function useData(fieldGroupId) {
  const {
    get
  } = useDataContext();
  const [data, setData] = useState(undefined);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const fetchData = useCallback(async () => {
    if (!fieldGroupId) {
      setLoading(false);
      return;
    }
    try {
      setLoading(true);
      setError(null);
      const result = await get(fieldGroupId);
      setData(result ? result : undefined);
      setLoading(false);
    } catch (err) {
      setError(err instanceof Error ? err : new Error(String(err)));
      setLoading(false);
    }
  }, [fieldGroupId, get]);
  useEffect(() => {
    fetchData();
  }, [fetchData]);
  return {
    data,
    loading,
    error,
    refetch: fetchData
  };
}
/**
 * Hook to resolve a template string with mustache syntax
 *
 * @param template - Template string with {{fieldGroup.property}} syntax
 * @returns Resolved template string and loading state
 */
function useResolveTemplate(template) {
  const {
    resolveTemplate
  } = useDataContext();
  const [resolved, setResolved] = useState(template);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  useEffect(() => {
    let isMounted = true;
    async function resolve() {
      if (!template) {
        setResolved(template);
        return;
      }
      try {
        setLoading(true);
        setError(null);
        const result = await resolveTemplate(template);
        if (isMounted) {
          setResolved(result);
          setLoading(false);
        }
      } catch (err) {
        if (isMounted) {
          setError(err instanceof Error ? err : new Error(String(err)));
          setResolved(template); // Fallback to original template
          setLoading(false);
        }
      }
    }
    resolve();
    return () => {
      isMounted = false;
    };
  }, [template, resolveTemplate]);
  return {
    resolved,
    loading,
    error
  };
}
/**
 * Hook to access data provider directly for advanced use cases
 */
function useDataProvider() {
  const {
    provider
  } = useDataContext();
  if (!provider) {
    throw new Error('Data provider not available');
  }
  return provider;
}
/**
 * Template component for inline template resolution
 *
 * This is a React-friendly component for template resolution
 * that works well with conditional rendering and fallbacks.
 *
 * Usage:
 * ```tsx
 * <T template="Welcome to {{company.name}}!" fallback="Loading..." />
 * <T template="Hello {{user.name}}" fallback="Guest" />
 * ```
 */
const T = ({
  template,
  fallback,
  wrapper: Wrapper
}) => {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error('T component must be used within a DataProvider. Did you wrap your component with <DataProvider>?');
  }
  const {
    resolved,
    loading,
    error
  } = useResolveTemplate(template);
  if (loading) {
    return fallback ? jsx(Fragment, {
      children: fallback
    }) : null;
  } else if (error) {
    {
      return fallback ? jsx(Fragment, {
        children: fallback
      }) : null;
    }
  } else {
    const content = jsx(Fragment, {
      children: resolved
    });
    return Wrapper ? jsx(Wrapper, {
      children: content
    }) : content;
  }
};
/**
 * Hook to resolve template with tagged template literal syntax
 *
 * This returns the resolved value directly so it can be used with || operator
 */
function useTemplate(template) {
  const {
    resolved,
    loading,
    error
  } = useResolveTemplate(template);
  if (loading) {
    return null;
  } else if (error) {
    {
      return null;
    }
  } else {
    return resolved;
  }
}
/**
 * Tagged template function for inline data templating
 *
 * Enables JSX components to use mustache syntax for data interpolation:
 *
 * Usage:
 * ```tsx
 * {t`Welcome to {{company.name}}!`}
 * {t`Hello {{user.name}}` || 'Loading...'}
 * {t.wrap(CustomComponent)`{{company.slogan}}`}
 * ```
 */
function t(strings, ...values) {
  // First do regular template literal interpolation
  const template = String.raw(strings, ...values);
  // Return a component that uses the hook
  const TemplateResolver = () => {
    const resolved = useTemplate(template);
    return resolved;
  };
  return jsx(TemplateResolver, {});
}
/**
 * Tagged template function with custom wrapper component
 *
 * Usage:
 * ```tsx
 * {t.wrap(QuoteComponent)`{{company.slogan}}`}
 * ```
 */
t.wrap = WrapperComponent => (strings, ...values) => {
  const template = String.raw(strings, ...values);
  const WrappedTemplate = () => {
    const resolved = useTemplate(template);
    return resolved ? jsx(WrapperComponent, {
      children: resolved
    }) : null;
  };
  return jsx(WrappedTemplate, {});
};

/**
 * Data Binding Hook for AI-Driven Component System
 *
 * This hook enables components to resolve props from CMS data sources
 * instead of hardcoded props, allowing AI agents to generate both
 * content and presentation dynamically.
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
/**
 * Hook for resolving component props from data sources
 *
 * @param dataSource - Data source identifier (e.g., "company.description", "pages.home.hero-block")
 * @param fallbackProps - Props to use when dataSource is unavailable
 * @param schema - Component schema for validation
 * @param options - Data binding configuration options
 * @returns Resolved props with data binding metadata
 */
function useDataBinding(dataSource, fallbackProps) {
  // Determine if we should use data binding
  const isDataSourceAvailable = dataSource && dataSource.trim().length > 0;
  // Get data - always call the hook unconditionally, but pass empty string if not available
  const safeDataResult = useDataSafe(isDataSourceAvailable ? dataSource : '');
  // Resolve the final props
  const resolvedData = useMemo(() => {
    if (!isDataSourceAvailable || safeDataResult.data === undefined) {
      // No data source provided, use fallback props as-is
      return fallbackProps || {};
    }
    const resolved = {
      ...(fallbackProps || {}),
      ...safeDataResult.data
    };
    return resolved;
  }, [isDataSourceAvailable, safeDataResult.data, fallbackProps]);
  // Build the data binding metadata (not currently returned but available for future use)
  // const metadata: DataBindingMeta = {
  //   loading: safeDataResult.loading,
  //   error: safeDataResult.error,
  //   dataSource,
  //   cached: false // TODO: Implement cache detection
  // };
  // Return resolved data with metadata, ensuring data properties aren't overridden
  return {
    ...resolvedData,
    // Metadata with explicit property names to avoid conflicts with data
    $loading: safeDataResult.loading,
    $error: safeDataResult.error,
    $dataSource: dataSource,
    $cached: false,
    // Keep old names for backward compatibility, but data takes precedence
    ...(Object.prototype.hasOwnProperty.call(resolvedData, 'loading') ? {} : {
      loading: safeDataResult.loading
    }),
    ...(Object.prototype.hasOwnProperty.call(resolvedData, 'error') ? {} : {
      error: safeDataResult.error
    }),
    cached: false
  };
}

/**
 * QwickApp Context - Application-level context for QwickApp configuration
 *
 * Provides app-level state and configuration that can be accessed by components
 * within the QwickApp provider hierarchy.
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
const QwickAppContext = /*#__PURE__*/React.createContext({
  appName: 'QwickApps',
  logo: undefined,
  appId: true,
  enableScaffolding: false,
  navigationItems: [],
  appBar: undefined,
  showAppBar: true,
  appBarHeight: 64,
  showThemeSwitcher: false,
  showPaletteSwitcher: false,
  updateConfig: () => {}
});
const useQwickApp$1 = () => {
  const context = React.useContext(QwickAppContext);
  if (!context) {
    throw new Error('useQwickApp must be used within a QwickApp provider');
  }
  return context;
};

// Theme utilities for QwickApps Theme System
/**
 * Get the current theme mode from CSS variables
 */
const getCurrentTheme = () => {
  if (typeof document === 'undefined') {
    return 'system'; // SSR fallback
  }
  const root = document.documentElement;
  const theme = root.getAttribute('data-theme');
  return theme || 'system';
};
/**
 * Set theme mode and update CSS variables
 */
const setTheme = theme => {
  if (typeof document === 'undefined' || typeof window === 'undefined') {
    return; // SSR - no-op
  }
  const root = document.documentElement;
  root.setAttribute('data-theme', theme);
  // Trigger custom event for theme change
  window.dispatchEvent(new CustomEvent('themeChange', {
    detail: {
      theme
    }
  }));
};
/**
 * Get system preference for dark mode
 */
const getSystemTheme = () => {
  if (typeof window === 'undefined') {
    return 'light'; // SSR fallback
  }
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
};
/**
 * Get computed theme (resolves 'system' to actual light/dark)
 */
const getComputedTheme = (theme = getCurrentTheme()) => {
  if (theme === 'system') {
    return getSystemTheme();
  }
  return theme;
};
/**
 * Initialize theme system
 */
const initializeTheme = () => {
  if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
    return; // SSR - no-op
  }
  const savedTheme = localStorage.getItem('theme') || 'system';
  setTheme(savedTheme);
  // Listen for system theme changes
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
    if (getCurrentTheme() === 'system') {
      // Trigger re-render for system theme changes
      window.dispatchEvent(new CustomEvent('themeChange', {
        detail: {
          theme: 'system'
        }
      }));
    }
  });
};
/**
 * Save theme preference to localStorage
 */
const saveThemePreference = theme => {
  if (typeof localStorage === 'undefined') {
    return; // SSR - no-op
  }
  localStorage.setItem('theme', theme);
  setTheme(theme);
};

/**
 * Default Palette Configuration
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
const PaletteDefault = {
  id: 'default',
  name: 'Default',
  description: 'Classic blue and neutral colors',
  primaryColor: '#007bff'
};

/**
 * Autumn Palette Configuration
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
const PaletteAutumn = {
  id: 'autumn',
  name: 'Autumn',
  description: 'Warm oranges and golden yellows',
  primaryColor: '#ea580c'
};

/**
 * Boutique Palette Configuration
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
const PaletteBoutique = {
  id: 'boutique',
  name: 'Boutique',
  description: 'Sophisticated teal, bronze, and navy - perfect for premium retail and fashion brands',
  primaryColor: '#3ca6b6'
};

/**
 * Ocean Palette Configuration
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
const PaletteOcean = {
  id: 'ocean',
  name: 'Ocean',
  description: 'Deep blues and aqua teals',
  primaryColor: '#0891b2'
};

/**
 * Spring Palette Configuration
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
const PaletteSpring = {
  id: 'spring',
  name: 'Spring',
  description: 'Fresh greens and soft pinks',
  primaryColor: '#16a34a'
};

/**
 * Winter Palette Configuration
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
const PaletteWinter = {
  id: 'winter',
  name: 'Winter',
  description: 'Cool blues and icy whites',
  primaryColor: '#0077be'
};

/**
 * Cosmic Palette Configuration
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
const PaletteCosmic = {
  id: 'cosmic',
  name: 'Cosmic',
  description: 'Modern purple gradient for creative and tech brands',
  primaryColor: '#8b5cf6'
};

/**
 * Palette Configurations Export
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
const AllPalettes = [PaletteDefault, PaletteBoutique, PaletteOcean, PaletteCosmic, PaletteWinter, PaletteAutumn, PaletteSpring];

/**
 * Persistence utilities for theme and palette preferences
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
/**
 * Load user theme preference from localStorage
 */
const loadUserThemePreference = storageKey => {
  if (!storageKey || typeof window === 'undefined') {
    return null;
  }
  try {
    const saved = localStorage.getItem(storageKey);
    if (saved && ['light', 'dark', 'system'].includes(saved)) {
      return saved;
    }
  } catch (error) {
    console.warn('[persistenceUtils] Theme localStorage read failed:', error);
  }
  return null;
};
/**
 * Save user theme preference to localStorage
 */
const saveUserThemePreference = (storageKey, theme) => {
  if (!storageKey || typeof window === 'undefined') {
    return;
  }
  try {
    localStorage.setItem(storageKey, theme);
  } catch (error) {
    console.warn('[persistenceUtils] Theme localStorage write failed:', error);
  }
};
/**
 * Clear user theme preference from localStorage
 */
const clearUserThemePreference = storageKey => {
  if (!storageKey || typeof window === 'undefined') {
    return;
  }
  try {
    localStorage.removeItem(storageKey);
  } catch (error) {
    console.warn('[persistenceUtils] Theme localStorage clear failed:', error);
  }
};
/**
 * Load user palette preference from localStorage
 */
const loadUserPalettePreference = (storageKey, availablePalettes) => {
  if (!storageKey || typeof window === 'undefined') {
    return null;
  }
  try {
    const saved = localStorage.getItem(storageKey);
    if (saved && availablePalettes.includes(saved)) {
      return saved;
    }
  } catch (error) {
    console.warn('[persistenceUtils] Palette localStorage read failed:', error);
  }
  return null;
};
/**
 * Save user palette preference to localStorage
 */
const saveUserPalettePreference = (storageKey, palette) => {
  if (!storageKey || typeof window === 'undefined') {
    return;
  }
  try {
    localStorage.setItem(storageKey, palette);
  } catch (error) {
    console.warn('[persistenceUtils] Palette localStorage write failed:', error);
  }
};
/**
 * Clear user palette preference from localStorage
 */
const clearUserPalettePreference = storageKey => {
  if (!storageKey || typeof window === 'undefined') {
    return;
  }
  try {
    localStorage.removeItem(storageKey);
  } catch (error) {
    console.warn('[persistenceUtils] Palette localStorage clear failed:', error);
  }
};

/**
 * Palette Manifest Utilities - Fetch and manage palette manifests
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
// Default configuration
const DEFAULT_CONFIG = {
  enableRemote: true,
  remoteUrl: 'https://qwickapps.com/palettes/manifest.json',
  localPath: '/palettes/manifest.json'
};
// Cache for loaded manifests
let cachedManifest = null;
let manifestLoadAttempted = false;
/**
 * Fetch a manifest from a URL
 */
async function fetchManifestFromUrl(url) {
  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      },
      // Short timeout for better UX
      signal: AbortSignal.timeout(5000)
    });
    if (!response.ok) {
      console.warn(`[PaletteManifest] Failed to fetch from ${url}: ${response.status} ${response.statusText}`);
      return null;
    }
    const manifest = await response.json();
    // Basic validation
    if (!manifest.version || !Array.isArray(manifest.palettes)) {
      console.warn(`[PaletteManifest] Invalid manifest structure from ${url}`);
      return null;
    }
    return manifest;
  } catch (error) {
    // Only log in development
    if (import.meta.env?.DEV) {
      console.warn(`[PaletteManifest] Error fetching from ${url}:`, error);
    }
    return null;
  }
}
/**
 * Merge multiple manifests, with later manifests overriding earlier ones
 */
function mergeManifests(...manifests) {
  const paletteMap = new Map();
  let latestVersion = '0.0.0';
  for (const manifest of manifests) {
    if (!manifest) continue;
    // Track latest version
    if (manifest.version > latestVersion) {
      latestVersion = manifest.version;
    }
    // Merge palettes (later manifests override)
    for (const palette of manifest.palettes) {
      paletteMap.set(palette.id, palette);
    }
  }
  return {
    version: latestVersion,
    palettes: Array.from(paletteMap.values())
  };
}
/**
 * Load palette manifest from configured sources
 */
async function loadPaletteManifest(config = {}) {
  // Return cached manifest if available
  if (cachedManifest) {
    return cachedManifest;
  }
  // Only attempt once
  if (manifestLoadAttempted) {
    return getFallbackManifest();
  }
  manifestLoadAttempted = true;
  const finalConfig = {
    ...DEFAULT_CONFIG,
    ...config
  };
  const manifests = [];
  // Try remote manifest first (if enabled)
  if (finalConfig.enableRemote) {
    const remoteManifest = await fetchManifestFromUrl(finalConfig.remoteUrl);
    manifests.push(remoteManifest);
  }
  // Try local manifest
  if (typeof window !== 'undefined') {
    const localManifest = await fetchManifestFromUrl(finalConfig.localPath);
    manifests.push(localManifest);
  }
  // Merge all loaded manifests
  const mergedManifest = mergeManifests(...manifests);
  // If no manifests loaded, use fallback
  if (mergedManifest.palettes.length === 0) {
    if (import.meta.env?.DEV) {
      console.warn('[PaletteManifest] No manifests loaded, using fallback');
    }
    cachedManifest = getFallbackManifest();
    return cachedManifest;
  }
  cachedManifest = mergedManifest;
  return cachedManifest;
}
/**
 * Get fallback manifest with built-in palettes
 */
function getFallbackManifest() {
  return {
    version: '1.4.9',
    palettes: [{
      id: 'default',
      name: 'Default',
      description: 'Classic blue and neutral color scheme',
      version: '1.4.9',
      file: 'PaletteDefault.css',
      primaryColor: '#007bff',
      inlined: true
    }, {
      id: 'autumn',
      name: 'Autumn',
      description: 'Warm oranges, golden yellows, and earthy browns',
      version: '1.4.9',
      file: 'PaletteAutumn.css',
      primaryColor: '#ea580c',
      inlined: false
    }, {
      id: 'cosmic',
      name: 'Cosmic',
      description: 'Modern purple gradient for creative and tech brands',
      version: '1.4.9',
      file: 'PaletteCosmic.css',
      primaryColor: '#8b5cf6',
      inlined: false
    }, {
      id: 'ocean',
      name: 'Ocean',
      description: 'Deep blues, aqua teals, and seafoam greens',
      version: '1.4.9',
      file: 'PaletteOcean.css',
      primaryColor: '#0891b2',
      inlined: false
    }, {
      id: 'spring',
      name: 'Spring',
      description: 'Fresh greens, soft pinks, and bright yellows',
      version: '1.4.9',
      file: 'PaletteSpring.css',
      primaryColor: '#16a34a',
      inlined: false
    }, {
      id: 'winter',
      name: 'Winter',
      description: 'Cool blues, icy whites, and frosty grays',
      version: '1.4.9',
      file: 'PaletteWinter.css',
      primaryColor: '#0077be',
      inlined: false
    }]
  };
}
/**
 * Get a specific palette from the manifest
 */
async function getPaletteFromManifest(paletteId, config) {
  const manifest = await loadPaletteManifest(config);
  return manifest.palettes.find(p => p.id === paletteId) || null;
}
/**
 * Get all available palettes
 */
async function getAvailablePalettes(config) {
  const manifest = await loadPaletteManifest(config);
  return manifest.palettes;
}
/**
 * Clear the cached manifest (useful for testing)
 */
function clearManifestCache() {
  cachedManifest = null;
  manifestLoadAttempted = false;
}
/**
 * Register a custom palette dynamically
 */
function registerCustomPalette(palette) {
  if (!cachedManifest) {
    cachedManifest = getFallbackManifest();
  }
  // Remove existing palette with same ID
  cachedManifest.palettes = cachedManifest.palettes.filter(p => p.id !== palette.id);
  // Add new palette
  cachedManifest.palettes.push(palette);
}

/**
 * Palette CSS Loader - Dynamically loads palette CSS files on demand using manifest
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
// Track loaded palettes to avoid duplicate loading
const loadedPalettes = new Set();
// Track loading promises to avoid race conditions
const loadingPalettes = new Map();
// Default CDN URLs (prioritized)
const DEFAULT_CDN_URLS = ['https://qwickapps.com/palettes/',
// Primary CDN (Cloudflare)
'/palettes/' // Local fallback
];
// Global configuration
let globalConfig = {
  enableRemote: true
};
/**
 * Configure palette loader
 */
function configurePaletteLoader(config) {
  globalConfig = {
    ...globalConfig,
    ...config
  };
}
/**
 * Dynamically load a palette CSS file
 *
 * @param paletteId - The ID of the palette to load (e.g., 'autumn', 'ocean')
 * @param config - Optional configuration override
 * @returns Promise that resolves when the palette is loaded
 */
async function loadPalette(paletteId, config) {
  // Skip if already loaded
  if (loadedPalettes.has(paletteId)) {
    return Promise.resolve();
  }
  // Return existing loading promise if already loading
  if (loadingPalettes.has(paletteId)) {
    return loadingPalettes.get(paletteId);
  }
  // Create new loading promise
  const loadingPromise = loadPaletteInternal(paletteId, config);
  // Store the loading promise
  loadingPalettes.set(paletteId, loadingPromise);
  return loadingPromise;
}
/**
 * Internal palette loading logic
 */
async function loadPaletteInternal(paletteId, config) {
  const finalConfig = {
    ...globalConfig,
    ...config
  };
  // Don't load the default palette as it's already inlined in QwickApp.css
  if (paletteId === 'default') {
    loadedPalettes.add(paletteId);
    loadingPalettes.delete(paletteId);
    return;
  }
  // Check if we're in a browser environment
  if (typeof document === 'undefined') {
    // SSR environment - mark as loaded and continue
    loadedPalettes.add(paletteId);
    loadingPalettes.delete(paletteId);
    return;
  }
  // Check if the palette link already exists
  const existingLink = document.querySelector(`link[data-palette-id="${paletteId}"]`);
  if (existingLink) {
    loadedPalettes.add(paletteId);
    loadingPalettes.delete(paletteId);
    return;
  }
  try {
    // Get palette metadata from manifest
    const paletteEntry = await getPaletteFromManifest(paletteId, finalConfig);
    if (!paletteEntry) {
      // Palette not found in manifest
      if (import.meta.env?.DEV) {
        console.warn(`[PaletteLoader] Palette "${paletteId}" not found in manifest. ` + `Available palettes will be limited. Falling back to default palette.`);
      }
      loadedPalettes.add(paletteId);
      loadingPalettes.delete(paletteId);
      return;
    }
    // Skip if inlined (already available)
    if (paletteEntry.inlined) {
      loadedPalettes.add(paletteId);
      loadingPalettes.delete(paletteId);
      return;
    }
    // Determine which CSS file to use (minified in production, unminified in dev)
    const isDevelopment = import.meta.env?.DEV ?? false;
    const useMinified = !isDevelopment && paletteEntry.fileMinified;
    const filename = useMinified ? paletteEntry.fileMinified : paletteEntry.file;
    // Build list of URLs to try
    const urlsToTry = [];
    // Add remote CDN URLs if enabled
    if (finalConfig.enableRemote) {
      urlsToTry.push(`${DEFAULT_CDN_URLS[0]}${filename}`);
    }
    // Add local URL
    urlsToTry.push(`${DEFAULT_CDN_URLS[1]}${filename}`);
    // Try loading from each URL in order
    let loaded = false;
    for (const url of urlsToTry) {
      const success = await tryLoadPaletteFromUrl(url, paletteId);
      if (success) {
        loaded = true;
        break;
      }
    }
    if (!loaded) {
      // All attempts failed
      if (import.meta.env?.DEV) {
        console.warn(`[PaletteLoader] Failed to load palette "${paletteId}" from all sources. ` + `Falling back to default palette. Tried URLs:`, urlsToTry);
      }
    }
    loadedPalettes.add(paletteId);
    loadingPalettes.delete(paletteId);
  } catch (error) {
    if (import.meta.env?.DEV) {
      console.error(`[PaletteLoader] Error loading palette "${paletteId}":`, error);
    }
    loadedPalettes.add(paletteId);
    loadingPalettes.delete(paletteId);
  }
}
/**
 * Try to load a palette from a specific URL
 */
function tryLoadPaletteFromUrl(url, paletteId) {
  return new Promise(resolve => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = url;
    link.setAttribute('data-palette-id', paletteId);
    link.onload = () => {
      resolve(true);
    };
    link.onerror = () => {
      // Remove failed link
      document.head.removeChild(link);
      resolve(false);
    };
    document.head.appendChild(link);
  });
}
/**
 * Preload multiple palettes at once
 * @param paletteIds - Array of palette IDs to preload
 * @param config - Optional configuration
 */
async function preloadPalettes(paletteIds, config) {
  await Promise.all(paletteIds.map(id => loadPalette(id, config)));
}
/**
 * Check if a palette is loaded
 * @param paletteId - The palette ID to check
 */
function isPaletteLoaded(paletteId) {
  return loadedPalettes.has(paletteId);
}
/**
 * Clear loaded palettes cache (useful for testing)
 */
function clearPaletteCache() {
  loadedPalettes.clear();
  loadingPalettes.clear();
}

// Create context with proper typing
const PaletteContext = /*#__PURE__*/createContext(null);
const usePalette = () => {
  const context = useContext(PaletteContext);
  if (!context) {
    throw new Error('usePalette must be used within a PaletteProvider');
  }
  return context;
};
// Use imported palette configurations
const AVAILABLE_PALETTES$1 = AllPalettes;
/**
 * Resolve the default palette ID based on user preference or fallback
 * @param paletteId - The desired palette ID
 * @param warn - Whether to issue a warning for invalid palette IDs
 * @returns The resolved palette ID
 */
const resolveDefaultPalette = (paletteId, warn = true) => {
  if (paletteId && AVAILABLE_PALETTES$1.some(p => p.id === paletteId)) {
    return paletteId;
  }
  if (warn) {
    console.warn(`[PaletteProvider] Invalid defaultPalette '${paletteId}'. Using 'default'.`);
  }
  return 'default';
};
const PaletteProvider = ({
  children,
  appId,
  defaultPalette = 'default'
}) => {
  // Determine storage key based on appId
  const actualStorageKey = React.useMemo(() => {
    if (appId === false) {
      return null; // No persistence
    }
    if (typeof appId === 'string') {
      return `${appId}.palette`;
    }
    // appId is true or undefined - use default key with warning
    const defaultKey = 'qwickapps-react-framework-palette';
    console.warn(`[PaletteProvider] Using default storage key '${defaultKey}'. ` + `Consider providing an appId for production apps to avoid conflicts. ` + `Example: <PaletteProvider appId="com.mycompany.myapp">`);
    return defaultKey;
  }, [appId]);
  // Available palette IDs for validation
  const availablePaletteIds = AVAILABLE_PALETTES$1.map(p => p.id);
  // User's preferred palette (what they explicitly chose)
  const [preferredPalette, setPreferredPaletteState] = useState(() => {
    return loadUserPalettePreference(actualStorageKey, availablePaletteIds);
  });
  // Current palette being applied (resolved from preferred/default)
  const [currentPalette, setCurrentPaletteState] = useState(() => {
    const userPreference = loadUserPalettePreference(actualStorageKey, availablePaletteIds);
    return userPreference || resolveDefaultPalette(defaultPalette);
  });
  // Apply palette to document root immediately and on changes
  useEffect(() => {
    if (typeof document !== 'undefined') {
      // Dynamically load the palette CSS if not already loaded
      loadPalette(currentPalette).then(() => {
        // Set the data-palette attribute after CSS is loaded
        document.documentElement.setAttribute('data-palette', currentPalette);
        // Dispatch custom event to notify theme system (with small delay to ensure CSS is applied)
        setTimeout(() => {
          const event = new CustomEvent('palette-changed', {
            detail: {
              palette: currentPalette
            }
          });
          window.dispatchEvent(event);
        }, 50);
      }).catch(error => {
        console.error(`[PaletteContext] Failed to load palette "${currentPalette}":`, error);
        // Still set the attribute and dispatch event even if loading fails
        document.documentElement.setAttribute('data-palette', currentPalette);
        const event = new CustomEvent('palette-changed', {
          detail: {
            palette: currentPalette
          }
        });
        window.dispatchEvent(event);
      });
    }
  }, [currentPalette]);
  // Note: We no longer automatically save to localStorage on every change
  // localStorage is only updated via setPreferredPalette() method
  // Palette preference management methods
  const setPreferredPalette = paletteId => {
    const targetPalette = AVAILABLE_PALETTES$1.find(p => p.id === paletteId);
    if (targetPalette) {
      setPreferredPaletteState(paletteId);
      setCurrentPaletteState(paletteId);
      saveUserPalettePreference(actualStorageKey, paletteId);
    } else {
      console.warn(`Palette "${paletteId}" not found. Available palettes:`, AVAILABLE_PALETTES$1.map(p => p.id));
    }
  };
  const clearPreferredPalette = () => {
    setPreferredPaletteState(null);
    clearUserPalettePreference(actualStorageKey);
    // Reset to default palette
    const fallbackPalette = resolveDefaultPalette(defaultPalette, false);
    setCurrentPaletteState(fallbackPalette);
  };
  const getPreferredPalette = () => {
    return preferredPalette;
  };
  // Current palette management methods (for admin/preview overrides)
  const getCurrentPalette = () => {
    return currentPalette;
  };
  const setCurrentPalette = paletteId => {
    const targetPalette = AVAILABLE_PALETTES$1.find(p => p.id === paletteId);
    if (targetPalette) {
      setCurrentPaletteState(paletteId);
      // Note: This does NOT update preferredPalette or localStorage
    } else {
      console.warn(`Palette "${paletteId}" not found. Available palettes:`, AVAILABLE_PALETTES$1.map(p => p.id));
    }
  };
  const value = {
    currentPalette,
    preferredPalette,
    availablePalettes: AVAILABLE_PALETTES$1,
    isPersistent: actualStorageKey !== null,
    // Palette preference management
    setPreferredPalette,
    clearPreferredPalette,
    getPreferredPalette,
    // Current palette management
    getCurrentPalette,
    setCurrentPalette
  };
  return jsx(PaletteContext.Provider, {
    value: value,
    children: children
  });
};

// Create context with proper typing
const ThemeContext = /*#__PURE__*/createContext(null);
const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
/**
 * Resolve the default theme based on user preference or fallback
 * @param defaultTheme - The desired default theme
 * @param warn - Whether to issue a warning for invalid themes
 * @returns The resolved theme mode
 */
const resolveDefaultTheme = (defaultTheme, warn = true) => {
  if (defaultTheme && ['light', 'dark', 'system'].includes(defaultTheme)) {
    return defaultTheme;
  }
  // Fallback to 'system' if defaultTheme is invalid
  if (warn) {
    console.warn(`[ThemeProvider] Invalid defaultTheme '${defaultTheme}'. Using 'system'.`);
  }
  return 'system';
};
const ThemeProvider = ({
  children,
  appId,
  includePalette = true,
  defaultTheme = 'light',
  defaultPalette
}) => {
  // Determine storage key based on appId
  const themeStorageKey = React.useMemo(() => {
    if (appId === false) {
      return null; // No persistence
    }
    if (typeof appId === 'string') {
      return `${appId}.theme`;
    }
    // appId is true or undefined - use default key with warning
    const defaultKey = 'qwickapps-react-framework-theme';
    console.warn(`[ThemeProvider] Using default storage key '${defaultKey}'. ` + `Consider providing an appId for production apps to avoid conflicts. ` + `Example: <ThemeProvider appId="com.mycompany.myapp">`);
    return defaultKey;
  }, [appId]);
  // Resolve the actual storage key based on strategy
  const actualStorageKey = themeStorageKey;
  // User's preferred theme (what they explicitly chose)
  const [preferredTheme, setPreferredThemeState] = useState(() => {
    return loadUserThemePreference(actualStorageKey);
  });
  // Current theme being applied (resolved from preferred/system/default)
  const [currentTheme, setCurrentThemeState] = useState(() => {
    const userPreference = loadUserThemePreference(actualStorageKey);
    return userPreference || resolveDefaultTheme(defaultTheme);
  });
  // Force re-render when palette changes
  const [paletteChangeCounter, setPaletteChangeCounter] = useState(0);
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  // Calculate actual theme mode (resolve 'system' to 'light' or 'dark')
  const actualThemeMode = currentTheme === 'system' ? prefersDarkMode ? 'dark' : 'light' : currentTheme;
  // Listen for both theme and palette changes
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const handlePaletteChange = () => {
        setPaletteChangeCounter(prev => prev + 1);
      };
      const handleThemeChange = () => {
        setPaletteChangeCounter(prev => prev + 1);
      };
      // Listen for custom palette change events
      window.addEventListener('palette-changed', handlePaletteChange);
      window.addEventListener('theme-changed', handleThemeChange);
      return () => {
        window.removeEventListener('palette-changed', handlePaletteChange);
        window.removeEventListener('theme-changed', handleThemeChange);
      };
    }
  }, []);
  // Dispatch theme change event when actualThemeMode changes
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const event = new CustomEvent('theme-changed', {
        detail: {
          theme: actualThemeMode
        }
      });
      window.dispatchEvent(event);
    }
  }, [actualThemeMode]);
  // Update HTML data-theme attribute when actual theme mode changes
  useEffect(() => {
    if (typeof window !== 'undefined') {
      setTheme(actualThemeMode);
    }
  }, [actualThemeMode]);
  // Helper function to get CSS custom property value
  const getCSSCustomProperty = property => {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      const value = getComputedStyle(document.documentElement).getPropertyValue(property).trim();
      return value;
    }
    return '';
  };
  // Create MUI theme
  const theme = React.useMemo(() => {
    const isDark = actualThemeMode === 'dark';
    // Get colors from CSS theme variables (not palette variables)
    const primaryLight = getCSSCustomProperty('--theme-primary-light') || (isDark ? '#87ceeb' : '#4a90e2');
    const primaryMain = getCSSCustomProperty('--theme-primary') || (isDark ? '#90caf9' : '#1976d2');
    const primaryDark = getCSSCustomProperty('--theme-primary-dark') || (isDark ? '#1a365d' : '#0056b3');
    const primaryContrastText = getCSSCustomProperty('--theme-on-primary') || (isDark ? '#000000' : '#ffffff');
    const secondaryLight = getCSSCustomProperty('--theme-secondary-light') || (isDark ? '#adb5bd' : '#868e96');
    const secondaryMain = getCSSCustomProperty('--theme-secondary') || (isDark ? '#f48fb1' : '#dc004e');
    const secondaryDark = getCSSCustomProperty('--theme-secondary-dark') || (isDark ? '#6c757d' : '#495057');
    const secondaryContrastText = getCSSCustomProperty('--theme-on-secondary') || (isDark ? '#b0b0b0' : '#666666');
    const errorLight = getCSSCustomProperty('--theme-error-light') || (isDark ? '#f9c2c2' : '#f5c6cb');
    const errorMain = getCSSCustomProperty('--theme-error') || (isDark ? '#f87171' : '#dc3545');
    const errorDark = getCSSCustomProperty('--theme-error-dark') || (isDark ? '#b91c1c' : '#a71d2a');
    const warningLight = getCSSCustomProperty('--theme-warning-light') || (isDark ? '#fbbf24' : '#ffc107');
    const warningMain = getCSSCustomProperty('--theme-warning') || (isDark ? '#fbbf24' : '#ffc107');
    const warningDark = getCSSCustomProperty('--theme-warning-dark') || (isDark ? '#b57c00' : '#856404');
    const infoLight = getCSSCustomProperty('--theme-info-light') || (isDark ? '#60a5fa' : '#007acc');
    const infoMain = getCSSCustomProperty('--theme-info') || (isDark ? '#60a5fa' : '#007acc');
    const infoDark = getCSSCustomProperty('--theme-info-dark') || (isDark ? '#1e3a8a' : '#0d6efd');
    const successLight = getCSSCustomProperty('--theme-success-light') || (isDark ? '#4ade80' : '#28a745');
    const successMain = getCSSCustomProperty('--theme-success') || (isDark ? '#4ade80' : '#28a745');
    const successDark = getCSSCustomProperty('--theme-success-dark') || (isDark ? '#1f9e3d' : '#1c7430');
    const backgroundMain = getCSSCustomProperty('--theme-background') || (isDark ? '#121212' : '#ffffff');
    const surfaceMain = getCSSCustomProperty('--theme-surface') || (isDark ? '#1e1e1e' : '#ffffff');
    const textPrimary = getCSSCustomProperty('--theme-text-primary') || (isDark ? '#ffffff' : '#000000');
    const textSecondary = getCSSCustomProperty('--theme-text-secondary') || (isDark ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.6)');
    const textDisabled = getCSSCustomProperty('--theme-on-disabled') || (isDark ? 'rgba(255, 255, 255, 0.38)' : 'rgba(0, 0, 0, 0.38)');
    return createTheme({
      palette: {
        mode: actualThemeMode,
        primary: {
          main: primaryMain,
          light: primaryLight,
          dark: primaryDark,
          contrastText: primaryContrastText
        },
        secondary: {
          main: secondaryMain,
          light: secondaryLight,
          dark: secondaryDark,
          contrastText: secondaryContrastText
        },
        error: {
          light: errorLight,
          main: errorMain,
          dark: errorDark
        },
        warning: {
          light: warningLight,
          main: warningMain,
          dark: warningDark
        },
        info: {
          light: infoLight,
          main: infoMain,
          dark: infoDark
        },
        background: {
          default: backgroundMain,
          paper: surfaceMain
        },
        text: {
          primary: textPrimary,
          secondary: textSecondary,
          disabled: textDisabled
        },
        success: {
          light: successLight,
          main: successMain,
          dark: successDark
        }
      },
      typography: {
        fontFamily: '"Segoe UI", "Roboto", "Arial", sans-serif'
      },
      components: {
        MuiButton: {
          styleOverrides: {
            root: {
              textTransform: 'none'
            }
          }
        }
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actualThemeMode, paletteChangeCounter]); // paletteChangeCounter is needed to force theme rebuild
  // Theme preference management methods
  const setPreferredTheme = theme => {
    setPreferredThemeState(theme);
    setCurrentThemeState(theme);
    saveUserThemePreference(actualStorageKey, theme);
  };
  const clearPreferredTheme = () => {
    setPreferredThemeState(null);
    clearUserThemePreference(actualStorageKey);
    // Reset to default theme
    const fallbackTheme = resolveDefaultTheme(defaultTheme, false);
    setCurrentThemeState(fallbackTheme);
  };
  const getPreferredTheme = () => {
    return preferredTheme;
  };
  // Current theme management methods (for admin/preview overrides)
  const getCurrentTheme = () => {
    return currentTheme;
  };
  const setCurrentTheme = theme => {
    setCurrentThemeState(theme);
    // Note: This does NOT update preferredTheme or localStorage
  };
  const value = {
    currentTheme,
    preferredTheme,
    actualThemeMode,
    theme,
    isDark: actualThemeMode === 'dark',
    isPersistent: actualStorageKey !== null,
    // Theme preference management
    setPreferredTheme,
    clearPreferredTheme,
    getPreferredTheme,
    // Current theme management
    getCurrentTheme,
    setCurrentTheme
  };
  const content = jsx(ThemeContext.Provider, {
    value: value,
    children: jsx(ThemeProvider$1, {
      theme: theme,
      children: children
    })
  });
  // Conditionally wrap with PaletteProvider if enabled
  if (includePalette) {
    return jsx(PaletteProvider, {
      appId: appId,
      defaultPalette: defaultPalette,
      children: content
    });
  }
  // No palette provider
  return content;
};

const DEFAULT_PRINT_CONFIG = {
  theme: 'light',
  palette: undefined,
  hideScaffolding: true,
  hideInteractiveElements: false,
  optimizeForMonochrome: false,
  showPrintDate: true,
  pageMargins: '12mm'
};
function printModeReducer(state, action) {
  switch (action.type) {
    case 'TRIGGER_PRINT':
      if (state.printModeState === 'normal') {
        return {
          ...state,
          printModeState: 'applying_print_config',
          printConfig: action.config ? {
            ...DEFAULT_PRINT_CONFIG,
            ...action.config
          } : DEFAULT_PRINT_CONFIG
        };
      }
      return state;
    case 'APPLY_CONFIG':
      if (state.printModeState === 'applying_print_config') {
        return {
          ...state,
          printModeState: 'entering_print_mode'
        };
      }
      return state;
    case 'VIEW_LOADING':
      // Can transition to view_loading from entering_print_mode
      // Ignore if already in view_loading or other states
      if (state.printModeState === 'entering_print_mode') {
        return {
          ...state,
          printModeState: 'view_loading'
        };
      }
      return state;
    case 'VIEW_READY':
      // Can transition to config_applied from view_loading, then wait for theme/palette changes
      if (state.printModeState === 'view_loading') {
        return {
          ...state,
          printModeState: 'config_applied'
        };
      } else if (state.printModeState === 'exiting_print_mode') {
        return {
          ...state,
          printModeState: 'restoring_config'
        };
      }
      return state;
    case 'CONFIG_APPLIED':
      if (state.printModeState === 'config_applied') {
        return {
          ...state,
          printModeState: 'print_mode'
        };
      }
      return state;
    case 'EXIT_PRINT_MODE':
      // Exit from any print-related state
      if (state.printModeState !== 'normal' && state.printModeState !== 'exiting_print_mode' && state.printModeState !== 'restoring_config') {
        return {
          ...state,
          printModeState: 'exiting_print_mode'
        };
      }
      return state;
    case 'RESTORE_CONFIG':
      if (state.printModeState === 'restoring_config') {
        return {
          ...state,
          printModeState: 'normal'
        };
      }
      return state;
    case 'SET_ORIGINAL_THEME':
      return {
        ...state,
        originalTheme: action.theme
      };
    case 'SET_ORIGINAL_PALETTE':
      return {
        ...state,
        originalPalette: action.palette
      };
    default:
      return state;
  }
}
const PrintModeContext = /*#__PURE__*/createContext(null);
const usePrintMode$1 = () => {
  const context = useContext(PrintModeContext);
  if (!context) {
    throw new Error('usePrintMode must be used within a PrintModeProvider');
  }
  return context;
};
const PrintModeProvider = ({
  children
}) => {
  const [state, dispatch] = useReducer(printModeReducer, {
    printModeState: 'normal',
    printConfig: DEFAULT_PRINT_CONFIG,
    originalTheme: null,
    originalPalette: null
  });
  const {
    updateConfig: updateQwickAppConfig
  } = useQwickApp$1();
  const {
    setCurrentTheme,
    getCurrentTheme
  } = useTheme();
  const {
    setCurrentPalette,
    getCurrentPalette
  } = usePalette();
  // Computed derived state - only true when actually in print view
  const isPrintMode = state.printModeState === 'entering_print_mode' || state.printModeState === 'view_loading' || state.printModeState === 'config_applied' || state.printModeState === 'print_mode';
  // Actions
  const triggerPrint = useCallback(config => {
    dispatch({
      type: 'TRIGGER_PRINT',
      config
    });
  }, []);
  const exitPrintMode = useCallback(() => {
    dispatch({
      type: 'EXIT_PRINT_MODE'
    });
  }, []);
  const onViewLoading = useCallback(() => {
    dispatch({
      type: 'VIEW_LOADING'
    });
  }, []);
  const onViewReady = useCallback(() => {
    dispatch({
      type: 'VIEW_READY'
    });
  }, []);
  // Effect to handle configuration application
  useEffect(() => {
    if (state.printModeState === 'applying_print_config') {
      // Apply print configuration
      if (state.printConfig.hideScaffolding) {
        updateQwickAppConfig({
          enableScaffolding: false
        });
      }
      if (state.printConfig.theme) {
        dispatch({
          type: 'SET_ORIGINAL_THEME',
          theme: getCurrentTheme()
        });
        setCurrentTheme(state.printConfig.theme);
      }
      if (state.printConfig.palette) {
        dispatch({
          type: 'SET_ORIGINAL_PALETTE',
          palette: getCurrentPalette()
        });
        setCurrentPalette(state.printConfig.palette);
      }
      if (typeof document !== 'undefined') {
        document.body.classList.add('print-mode');
        if (state.printConfig.optimizeForMonochrome) {
          document.body.classList.add('print-monochrome');
        }
        if (state.printConfig.hideInteractiveElements) {
          document.body.classList.add('print-hide-interactive');
        }
        // Apply custom page margins if specified
        if (state.printConfig.pageMargins && state.printConfig.pageMargins !== '12mm') {
          let printStyleElement = document.querySelector('#qwick-print-margins');
          if (!printStyleElement) {
            printStyleElement = document.createElement('style');
            printStyleElement.id = 'qwick-print-margins';
            document.head.appendChild(printStyleElement);
          }
          printStyleElement.textContent = `
            @media print {
              @page {
                margin: ${state.printConfig.pageMargins};
              }
            }
          `;
        }
      }
      // Transition to entering print mode
      dispatch({
        type: 'APPLY_CONFIG'
      });
    }
  }, [state.printModeState, state.printConfig, updateQwickAppConfig, getCurrentTheme, getCurrentPalette, setCurrentTheme, setCurrentPalette]);
  // Effect to detect when theme/palette changes are complete
  useEffect(() => {
    if (state.printModeState === 'config_applied') {
      // Wait one render cycle to ensure theme/palette changes are applied
      const rafId = requestAnimationFrame(() => {
        dispatch({
          type: 'CONFIG_APPLIED'
        });
      });
      return () => cancelAnimationFrame(rafId);
    }
  }, [state.printModeState]);
  // Effect to transition from exiting_print_mode to restoring_config
  useEffect(() => {
    if (state.printModeState === 'exiting_print_mode') {
      // Use VIEW_READY action to transition to restoring_config
      dispatch({
        type: 'VIEW_READY'
      });
    }
  }, [state.printModeState]);
  // Effect to handle configuration restoration  
  useEffect(() => {
    if (state.printModeState === 'restoring_config') {
      // Restore QwickApp configuration
      updateQwickAppConfig({
        enableScaffolding: true
      });
      // Restore original theme and palette
      if (state.originalTheme) {
        setCurrentTheme(state.originalTheme);
      }
      if (state.originalPalette) {
        setCurrentPalette(state.originalPalette);
      }
      // Remove print mode classes and custom styles
      if (typeof document !== 'undefined') {
        document.body.classList.remove('print-mode', 'print-monochrome', 'print-hide-interactive');
        // Remove custom margins style
        const printStyleElement = document.querySelector('#qwick-print-margins');
        if (printStyleElement) {
          printStyleElement.remove();
        }
      }
      // Return to normal
      dispatch({
        type: 'RESTORE_CONFIG'
      });
    }
  }, [state.printModeState, state.originalTheme, state.originalPalette, updateQwickAppConfig, setCurrentTheme, setCurrentPalette]);
  // Effect to handle print dialog
  useEffect(() => {
    if (state.printModeState === 'print_mode') {
      if (typeof window !== 'undefined') {
        window.print();
      }
    }
  }, [state.printModeState]);
  // Effect to handle browser print events
  useEffect(() => {
    const handleBeforePrint = () => {
      triggerPrint();
    };
    const handleAfterPrint = () => {
      exitPrintMode();
    };
    if (typeof window !== 'undefined') {
      window.addEventListener('beforeprint', handleBeforePrint);
      window.addEventListener('afterprint', handleAfterPrint);
      return () => {
        window.removeEventListener('beforeprint', handleBeforePrint);
        window.removeEventListener('afterprint', handleAfterPrint);
      };
    }
  }, [exitPrintMode, triggerPrint]);
  const contextValue = {
    printModeState: state.printModeState,
    isPrintMode,
    printConfig: state.printConfig,
    triggerPrint,
    exitPrintMode,
    onViewLoading,
    onViewReady
  };
  return jsx(PrintModeContext.Provider, {
    value: contextValue,
    children: children
  });
};

/**
 * usePrintMode hook - Simple wrapper around PrintModeContext
 *
 * @deprecated Use usePrintMode from PrintModeContext directly
 * This file maintained for backward compatibility during migration
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
/**
 * Hook to access print mode state from app-level context
 *
 * @param _initialConfig - Initial print configuration (ignored, use context provider config)
 * @returns Print mode state and controls
 */
function usePrintMode() {
  const context = usePrintMode$1();
  // Map context interface to legacy interface
  return {
    isPrintMode: context.isPrintMode,
    printConfig: context.printConfig,
    printModeState: context.printModeState,
    enterPrintMode: context.triggerPrint,
    exitPrintMode: context.exitPrintMode,
    togglePrintMode: config => {
      if (context.isPrintMode) {
        context.exitPrintMode();
      } else {
        context.triggerPrint(config);
      }
    },
    triggerPrint: context.triggerPrint,
    onViewLoading: context.onViewLoading,
    onViewReady: context.onViewReady
  };
}

/**
 * ViewProps - Runtime-friendly props derived from ViewSchema
 *
 * Provides normalized view props that integrate seamlessly with the existing
 * BaseComponentProps system and useBaseProps hook. Handles type conversion
 * from schema strings to proper React prop types including event handlers,
 * styling props, and grid values.
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
/**
 * Convert string event handlers to React function handlers
 * @param eventHandlers - Object containing string or function event handlers
 * @returns Object with converted function handlers
 */
function parseEventHandlers(eventHandlers) {
  const result = {};
  for (const [key, value] of Object.entries(eventHandlers)) {
    if (typeof value === 'string' && value.trim()) {
      try {
        // Convert string to function - safe eval for event handlers
        // This creates a function that executes the string as code
        const func = new Function('event', value);
        result[key] = func;
      } catch (error) {
        console.warn(`Invalid event handler string for ${key}:`, value, error);
        // Keep as undefined for invalid handlers
      }
    } else if (typeof value === 'function') {
      // Already a function, use as-is
      result[key] = value;
    }
  }
  return result;
}
/**
 * Parse SX props from string or object
 * @param sx - SX prop as string or object
 * @returns Parsed SX props
 */
function parseSxProps(sx) {
  if (!sx) return undefined;
  if (typeof sx === 'string') {
    try {
      return JSON.parse(sx);
    } catch (error) {
      console.warn('Invalid sx JSON string:', sx, error);
      return undefined;
    }
  }
  return sx;
}
/**
 * Parse style props from string or object
 * @param style - Style prop as string or object
 * @returns Parsed style props
 */
function parseStyleProps(style) {
  if (!style) return undefined;
  if (typeof style === 'string') {
    try {
      return JSON.parse(style);
    } catch (error) {
      console.warn('Invalid style JSON string:', style, error);
      return undefined;
    }
  }
  return style;
}
/**
 * Coerce grid values from strings to numbers/keywords
 * @param value - Grid value as string or number
 * @returns Coerced value
 */
function coerceGridValue(value) {
  if (value === undefined || value === null) return undefined;
  if (typeof value === 'number') return value;
  if (typeof value === 'string') {
    // Handle keyword values
    if (value === 'auto' || value === 'grow') return value;
    // Try to parse as number
    const parsed = parseInt(value, 10);
    if (!isNaN(parsed) && parsed > 0) return parsed;
  }
  return undefined;
}
/**
 * Normalize ViewProps for runtime use
 *
 * Converts schema-friendly string props to runtime-friendly React props:
 * - Parses sx/style JSON strings
 * - Converts string event handlers to functions
 * - Coerces grid span/breakpoint values from strings to numbers/keywords
 * - Maintains compatibility with BaseComponentProps system
 *
 * @param props - Raw ViewProps from schema
 * @returns Normalized props compatible with useBaseProps
 */
function normalizeViewProps(props) {
  const {
    sx,
    style,
    onClick,
    onMouseEnter,
    onMouseLeave,
    onFocus,
    onBlur,
    span,
    xs,
    sm,
    md,
    lg,
    xl,
    backgroundColor,
    ...restProps
  } = props;
  // Parse style and sx props
  const normalizedSx = parseSxProps(sx);
  const normalizedStyle = parseStyleProps(style);
  // Parse event handlers
  const eventHandlers = parseEventHandlers({
    onClick,
    onMouseEnter,
    onMouseLeave,
    onFocus,
    onBlur
  });
  // Coerce grid values
  const normalizedGridProps = {
    span: coerceGridValue(span),
    xs: coerceGridValue(xs),
    sm: coerceGridValue(sm),
    md: coerceGridValue(md),
    lg: coerceGridValue(lg),
    xl: coerceGridValue(xl)
  };
  // Canonicalize background prop (backgroundColor → background)
  const canonicalBackground = restProps.background ?? backgroundColor;
  // Return normalized props with proper typing
  const normalized = {
    ...restProps,
    ...normalizedGridProps,
    sx: normalizedSx,
    style: normalizedStyle,
    ...eventHandlers,
    // Set canonical background prop
    background: canonicalBackground
  };
  // Remove backgroundColor to avoid duplication
  delete normalized.backgroundColor;
  return normalized;
}

/**
 * Helper function to convert React children to text content
 * Used for content-prop strategy to map JSX children to content strings
 */
function toText(node) {
  if (node == null || typeof node === 'boolean') return undefined;
  if (typeof node === 'string' || typeof node === 'number') return String(node);
  if (Array.isArray(node)) return node.map(toText).filter(Boolean).join('');
  return undefined;
}
/**
 * Create a serializable view component using the factory pattern
 *
 * @param config - Factory configuration
 * @returns Serializable component with attached static methods
 */
function createSerializableView(config) {
  const {
    tagName,
    version,
    role,
    View,
    childrenStrategy = {
      mode: 'react-children'
    },
    finalize
  } = config;
  // Create the main component function
  function SerializableViewComponent(props) {
    const {
      dataSource,
      bindingOptions,
      children,
      ...schemaProps
    } = props;
    // Step 1: Handle content-prop strategy (map JSX children → content)
    let propsForProcessing = schemaProps;
    if (childrenStrategy.mode === 'content-prop') {
      const propName = childrenStrategy.propName || 'content';
      if (propsForProcessing[propName] == null) {
        const textContent = toText(children);
        if (typeof textContent === 'string') {
          propsForProcessing = {
            ...propsForProcessing,
            [propName]: textContent
          };
        }
      }
    }
    // Step 2: Normalize schema props to runtime-friendly format
    const normalizedProps = normalizeViewProps(propsForProcessing);
    // Step 2: ALWAYS call all hooks first (Rules of Hooks)
    const {
      loading,
      error,
      ...resolvedProps
    } = useDataBinding(dataSource || undefined,
    // Pass undefined if no dataSource
    normalizedProps, undefined,
    // Schema - let the hook infer it
    dataSource ? {
      cache: true,
      cacheTTL: 300000,
      strict: false,
      ...bindingOptions
    } : {
      enabled: false
    });
    // Determine which props to use based on data binding state
    let boundProps = normalizedProps;
    if (dataSource && !error) {
      boundProps = {
        ...normalizedProps,
        ...resolvedProps
      };
    }
    // Step 3: Apply useBaseProps for style/html/grid processing (ALWAYS call this hook)
    const {
      gridProps,
      styleProps,
      htmlProps,
      restProps
    } = useBaseProps(boundProps);
    // Step 4: Handle special states AFTER all hooks have been called
    if (dataSource && loading) {
      return jsx("div", {
        children: "Loading..."
      });
    }
    if (dataSource && error) {
      console.error('Data binding error:', error);
      // In production, continue with fallback props (already set above)
    }
    // Step 5: Prepare final props and apply optional finalize function
    let viewProps = {
      ...restProps,
      ...styleProps,
      ...htmlProps,
      // Grid props are passed separately if needed by container components
      ...(role === 'container' && gridProps ? {
        gridProps
      } : {})
    };
    // Apply finalize function if provided
    if (finalize) {
      viewProps = finalize(viewProps);
    }
    // Step 6: Render with appropriate children strategy
    if (childrenStrategy.mode === 'content-prop') {
      // For content-prop components, don't pass children to the view
      return jsx(View, {
        ...viewProps
      });
    } else {
      // For react-children components, pass children through
      return jsx(View, {
        ...viewProps,
        children: children
      });
    }
  }
  // Attach static properties for serialization
  const component = SerializableViewComponent;
  // Component identification
  component.tagName = tagName;
  component.version = version;
  Object.assign(component, {
    [QWICKAPP_COMPONENT]: QWICKAPP_COMPONENT
  });
  // Serialization methods
  component.fromJson = function fromJson(data) {
    const typedData = data;
    const {
      tagName: dataTagName,
      version: dataVersion,
      data: componentData
    } = typedData;
    // Validate deserialization data
    if (dataTagName !== tagName) {
      throw new Error(`Tag name mismatch: expected ${tagName}, got ${dataTagName}`);
    }
    if (dataVersion !== version) {
      console.warn(`Version mismatch for ${tagName}: expected ${version}, got ${dataVersion}`);
    }
    // Handle deserialization based on children strategy
    if (childrenStrategy.mode === 'content-prop') {
      const propName = childrenStrategy.propName || 'content';
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const typedComponentData = componentData || {};
      const {
        children,
        ...rest
      } = typedComponentData;
      const contentData = {
        ...rest,
        [propName]: typedComponentData[propName] || ''
      };
      return /*#__PURE__*/React.createElement(component, contentData);
    } else {
      // For react-children strategy, recursively deserialize children
      const deserializedData = {
        ...componentData
      };
      if (componentData.children !== undefined) {
        // Recursively deserialize children using ComponentTransformer
        deserializedData.children = ComponentTransformer.deserialize(componentData.children);
      }
      return /*#__PURE__*/React.createElement(component, deserializedData);
    }
  };
  component.toJson = function toJson(props) {
    // Handle serialization based on children strategy
    if (childrenStrategy.mode === 'content-prop') {
      const propName = childrenStrategy.propName || 'content';
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const typedProps = props || {};
      const {
        children,
        ...rest
      } = typedProps;
      const contentValue = typedProps[propName] ?? toText(typedProps.children);
      // Clean props for content-prop serialization
      const cleanProps = {};
      for (const [key, value] of Object.entries(rest)) {
        if (typeof value === 'function' && key.startsWith('on')) {
          cleanProps[key] = value.toString();
        } else if (typeof value !== 'function' && value !== undefined && value !== null) {
          cleanProps[key] = value;
        }
      }
      return {
        tagName,
        version,
        data: {
          ...cleanProps,
          [propName]: contentValue || ''
        }
      };
    } else {
      // Handle react-children strategy (existing logic)
      const cleanProps = {};
      for (const [key, value] of Object.entries(props)) {
        if (typeof value === 'function' && key.startsWith('on')) {
          // Convert event handlers to string representation
          cleanProps[key] = value.toString();
        } else if (typeof value === 'function') {
          // Skip non-event handler functions
          continue;
        } else if (key === 'children') {
          // IMPORTANT: Include children as-is for recursive serialization by ComponentTransformer
          // The ComponentTransformer.serializeNode() will handle the recursive serialization
          cleanProps[key] = value;
        } else if (value !== undefined && value !== null) {
          // Include all other serializable props
          cleanProps[key] = value;
        }
      }
      return {
        tagName,
        version,
        data: cleanProps
      };
    }
  };
  // Set display name for debugging
  component.displayName = `SerializableView(${tagName})`;
  return component;
}

/**
 * ContainerView - Pure view component that renders the actual container
 *
 * This component receives fully processed props from createSerializableView
 * and renders the container using Material-UI Box with all styling applied.
 */
function ContainerView({
  children,
  gridProps,
  ...props
}) {
  // Render the component as a Box with all processed props
  return jsx(Box, {
    ...props,
    ...(gridProps ? {
      'data-grid': JSON.stringify(gridProps)
    } : {}),
    component: "div",
    children: children
  });
}
/**
 * Create Container component using the factory pattern
 */
const Container$8 = createSerializableView({
  tagName: 'Container',
  version: '1.0.0',
  role: 'container',
  View: ContainerView
});

const CopyIcon = ContentCopy;
const CheckIcon = Check;
/**
 * CodeView - Pure view component that renders the code display
 *
 * This component receives fully processed props from createSerializableView
 * and renders the code using Material-UI components with all features preserved.
 */
function CodeView({
  content,
  language: _language = 'text',
  showCopy = true,
  showLineNumbers = false,
  title,
  wrapLines = false,
  codeBackground,
  ...restProps
}) {
  const theme = useTheme$1();
  const [copied, setCopied] = useState(false);
  const [showCopiedAlert, setShowCopiedAlert] = useState(false);
  const codeMaxHeight = restProps.sx?.maxHeight || 400;
  // Use content prop directly (already a string from content-prop strategy)
  const codeContent = content || '';
  // Return empty state if no code content
  if (!codeContent?.trim()) {
    return jsx(Paper, {
      ...restProps,
      variant: "outlined",
      sx: {
        p: 3,
        textAlign: 'center',
        opacity: 0.6,
        ...restProps.sx
      },
      children: jsx(Typography, {
        variant: "body2",
        color: "text.secondary",
        children: "No code content provided"
      })
    });
  }
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(codeContent);
      setCopied(true);
      setShowCopiedAlert(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy code:', err);
    }
  };
  const codeLines = codeContent.split('\n');
  const getBackgroundColor = () => {
    if (codeBackground) return codeBackground;
    return theme.palette.grey[theme.palette.mode === 'dark' ? 900 : 50];
  };
  const getHeaderBackgroundColor = () => {
    return theme.palette.grey[theme.palette.mode === 'dark' ? 800 : 200];
  };
  const getTextColor = () => {
    return theme.palette.text.primary;
  };
  const getBorderColor = () => {
    return theme.palette.divider;
  };
  return jsxs(Paper, {
    ...restProps,
    variant: "outlined",
    sx: {
      backgroundColor: getBackgroundColor(),
      border: `1px solid ${getBorderColor()}`,
      borderRadius: 1,
      overflow: 'hidden',
      position: 'relative',
      ...restProps.sx
    },
    children: [(title || showCopy) && jsxs(Box, {
      sx: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        px: 2,
        py: 1,
        backgroundColor: getHeaderBackgroundColor(),
        borderBottom: `1px solid ${getBorderColor()}`
      },
      children: [title && jsx(Typography, {
        variant: "body2",
        sx: {
          fontFamily: 'Monaco, Consolas, "Ubuntu Mono", monospace',
          color: getTextColor(),
          opacity: 0.8
        },
        children: title
      }), jsx(Box, {
        sx: {
          ml: 'auto'
        },
        children: showCopy && jsx(Tooltip, {
          title: copied ? 'Copied!' : 'Copy code',
          children: jsx(IconButton, {
            size: "small",
            onClick: handleCopy,
            sx: {
              color: getTextColor(),
              opacity: 0.7,
              '&:hover': {
                opacity: 1,
                backgroundColor: theme.palette.action.hover
              }
            },
            children: copied ? jsx(CheckIcon, {
              fontSize: "small"
            }) : jsx(CopyIcon, {
              fontSize: "small"
            })
          })
        })
      })]
    }), jsx(Box, {
      sx: {
        maxHeight: codeMaxHeight,
        overflow: 'auto',
        position: 'relative'
      },
      children: jsx(Box, {
        component: "pre",
        sx: {
          margin: 0,
          padding: 2,
          fontFamily: 'Monaco, Consolas, "Ubuntu Mono", monospace',
          fontSize: '0.875rem',
          lineHeight: 1.5,
          color: getTextColor(),
          backgroundColor: 'transparent',
          overflow: wrapLines ? 'visible' : 'auto',
          whiteSpace: wrapLines ? 'pre-wrap' : 'pre',
          wordBreak: wrapLines ? 'break-word' : 'normal'
        },
        children: showLineNumbers ? jsxs(Box, {
          sx: {
            display: 'flex'
          },
          children: [jsx(Box, {
            sx: {
              pr: 2,
              mr: 2,
              borderRight: `1px solid ${getBorderColor()}`,
              color: getTextColor(),
              opacity: 0.5,
              userSelect: 'none',
              minWidth: `${String(codeLines.length).length + 1}ch`
            },
            children: codeLines.map((_, index) => jsx(Box, {
              sx: {
                textAlign: 'right'
              },
              children: index + 1
            }, index))
          }), jsx(Box, {
            sx: {
              flex: 1,
              minWidth: 0
            },
            children: jsx("code", {
              children: codeContent
            })
          })]
        }) : jsx("code", {
          children: codeContent
        })
      })
    }), jsx(Snackbar, {
      open: showCopiedAlert,
      autoHideDuration: 2000,
      onClose: () => setShowCopiedAlert(false),
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right'
      },
      children: jsx(Alert, {
        onClose: () => setShowCopiedAlert(false),
        severity: "success",
        variant: "filled",
        children: "Code copied to clipboard!"
      })
    })]
  });
}
/**
 * Create Code component using the factory pattern
 */
const Code = createSerializableView({
  tagName: 'Code',
  version: '1.0.0',
  role: 'view',
  View: CodeView,
  childrenStrategy: {
    mode: 'content-prop',
    propName: 'content'
  }
});
// Register HTML patterns that Code component can handle
Code.registerPatternHandlers = registry => {
  const typedRegistry = registry;
  // Register pre + code pattern
  if (typedRegistry.hasPattern && !typedRegistry.hasPattern('pre code')) {
    typedRegistry.registerPattern?.('pre code', Code.transformPreCode);
  }
  // Register standalone code pattern for complex code blocks
  if (typedRegistry.hasPattern && !typedRegistry.hasPattern('code.highlight')) {
    typedRegistry.registerPattern?.('code.highlight', Code.transformCodeHighlight);
  }
};
// Transform pre + code elements to Code component
Code.transformPreCode = element => {
  const codeChild = element.querySelector('code');
  if (!codeChild) return null;
  const language = Array.from(codeChild.classList).find(cls => cls.startsWith('language-'))?.replace('language-', '') || 'text';
  return {
    tagName: 'Code',
    props: {
      language,
      showCopy: true,
      showLineNumbers: false,
      content: codeChild.textContent || ''
    }
  };
};
// Transform highlighted code elements to Code component
Code.transformCodeHighlight = element => {
  const language = Array.from(element.classList).find(cls => cls.startsWith('language-'))?.replace('language-', '') || 'text';
  return {
    tagName: 'Code',
    props: {
      language,
      showCopy: true,
      showLineNumbers: false,
      content: element.textContent || ''
    }
  };
};

/**
 * Centralized icon registry mapping icon names to their representations.
 * Sorted alphabetically by category, then by key within each category.
 *
 * For icons not in this map, getIconComponent() will return a HelpOutline fallback
 * and log a warning. Use registerIcon() to add app-specific icons at runtime.
 */
const iconMap = {
  // === Actions ===
  add: {
    emoji: '➕',
    component: Add
  },
  check: {
    emoji: '✓',
    component: Check
  },
  check_circle: {
    emoji: '✅',
    component: CheckCircle
  },
  close: {
    emoji: '✕',
    component: Close
  },
  delete: {
    emoji: '🗑️',
    component: Delete
  },
  edit: {
    emoji: '✏️',
    component: Edit
  },
  refresh: {
    emoji: '🔄',
    component: Refresh
  },
  rotate_right: {
    emoji: '🔄',
    component: RotateRight
  },
  save: {
    emoji: '💾',
    component: Save
  },
  search: {
    emoji: '🔍',
    component: Search
  },
  send: {
    emoji: '📤',
    component: Send
  },
  share: {
    emoji: '🔗',
    component: Share
  },
  sync: {
    emoji: '🔄',
    component: Sync
  },
  // === Authentication & Security ===
  block: {
    emoji: '🚫',
    component: Block
  },
  key: {
    emoji: '🔑',
    component: Key
  },
  lock: {
    emoji: '🔒',
    component: Lock
  },
  lock_open: {
    emoji: '🔓',
    component: LockOpen
  },
  lockopen: {
    emoji: '🔓',
    component: LockOpen
  },
  // alias
  login: {
    emoji: '🔑',
    component: Login
  },
  logout: {
    emoji: '🚪',
    component: Logout
  },
  security: {
    emoji: '🔐',
    component: Security
  },
  shield: {
    emoji: '🛡️',
    component: Shield
  },
  verified_user: {
    emoji: '✅',
    component: VerifiedUser
  },
  visibility: {
    emoji: '👁️',
    component: Visibility
  },
  visibility_off: {
    emoji: '🙈',
    component: VisibilityOff
  },
  visibilityoff: {
    emoji: '🙈',
    component: VisibilityOff
  },
  // alias
  vpn_key: {
    emoji: '🔐',
    component: VpnKey
  },
  // === Business & Commerce ===
  attach_money: {
    emoji: '💰',
    component: AttachMoney
  },
  attachmoney: {
    emoji: '💰',
    component: AttachMoney
  },
  // alias
  business: {
    emoji: '🏢',
    component: Business
  },
  cart: {
    emoji: '🛒',
    component: ShoppingCart
  },
  // alias
  shopping_cart: {
    emoji: '🛒',
    component: ShoppingCart
  },
  shoppingcart: {
    emoji: '🛒',
    component: ShoppingCart
  },
  // alias
  work: {
    emoji: '💼',
    component: Work
  },
  workspace_premium: {
    emoji: '⭐',
    component: WorkspacePremium
  },
  // === Communication ===
  contact: {
    emoji: '📧',
    component: Email
  },
  // alias
  email: {
    emoji: '📧',
    component: Email
  },
  mail: {
    emoji: '📧',
    component: Email
  },
  // alias
  notifications: {
    emoji: '🔔',
    component: Notifications
  },
  phone: {
    emoji: '📱',
    component: Phone
  },
  support_agent: {
    emoji: '🛎️',
    component: SupportAgent
  },
  // === Content & Media ===
  article: {
    emoji: '📰',
    component: Article$1
  },
  blog: {
    emoji: '📝',
    component: Book
  },
  // alias
  book: {
    emoji: '📖',
    component: Book
  },
  gallery: {
    emoji: '🖼️',
    component: InsertPhoto
  },
  // alias
  image: {
    emoji: '🖼️',
    component: InsertPhoto
  },
  insert_photo: {
    emoji: '🖼️',
    component: InsertPhoto
  },
  library_books: {
    emoji: '📚',
    component: LibraryBooks
  },
  news: {
    emoji: '📰',
    component: Article$1
  },
  // alias
  photo_library: {
    emoji: '📸',
    component: PhotoLibrary
  },
  play: {
    emoji: '▶️',
    component: PlayArrow
  },
  // alias
  play_arrow: {
    emoji: '▶️',
    component: PlayArrow
  },
  portfolio: {
    emoji: '💼',
    component: Business
  },
  // alias
  // === Development & Technology ===
  architecture: {
    emoji: '🏛️',
    component: Architecture
  },
  autorenew: {
    emoji: '🔄',
    component: Autorenew
  },
  cloud: {
    emoji: '☁️',
    component: Cloud
  },
  cloud_download: {
    emoji: '☁️⬇️',
    component: CloudDownload
  },
  cloud_upload: {
    emoji: '☁️⬆️',
    component: CloudUpload
  },
  clouddownload: {
    emoji: '☁️⬇️',
    component: CloudDownload
  },
  // alias
  cloudupload: {
    emoji: '☁️⬆️',
    component: CloudUpload
  },
  // alias
  code: {
    emoji: '💻',
    component: Code$1
  },
  computer: {
    emoji: '💻',
    component: Computer
  },
  construction: {
    emoji: '🚧',
    component: Construction
  },
  integration_instructions: {
    emoji: '🔌',
    component: IntegrationInstructions
  },
  memory: {
    emoji: '🧠',
    component: Memory
  },
  psychology: {
    emoji: '🧠',
    component: Psychology
  },
  rocket: {
    emoji: '🚀',
    component: Rocket
  },
  storage: {
    emoji: '💾',
    component: Storage
  },
  // === Navigation & Layout ===
  arrow_back: {
    emoji: '←',
    component: ArrowBack
  },
  arrow_forward: {
    emoji: '→',
    component: ArrowForward
  },
  arrowback: {
    emoji: '←',
    component: ArrowBack
  },
  // alias
  arrowforward: {
    emoji: '→',
    component: ArrowForward
  },
  // alias
  dashboard: {
    emoji: '📊',
    component: Dashboard
  },
  download: {
    emoji: '⬇️',
    component: Download
  },
  explore: {
    emoji: '🧭',
    component: Explore
  },
  home: {
    emoji: '🏠',
    component: Home
  },
  layers: {
    emoji: '📚',
    component: Layers
  },
  menu: {
    emoji: '☰',
    component: Menu
  },
  route: {
    emoji: '🗺️',
    component: Route
  },
  settings: {
    emoji: '⚙️',
    component: Settings
  },
  trending_up: {
    emoji: '📈',
    component: TrendingUp
  },
  tune: {
    emoji: '🎛️',
    component: Tune
  },
  // === Products & Inventory ===
  inventory: {
    emoji: '📦',
    component: Inventory
  },
  inventory_2: {
    emoji: '📦',
    component: Inventory2
  },
  local_offer: {
    emoji: '🏷️',
    component: LocalOffer
  },
  products: {
    emoji: '🛍️',
    component: ShoppingCart
  },
  // alias
  services: {
    emoji: '⚙️',
    component: Settings
  },
  // alias
  speed: {
    emoji: '⚡',
    component: Speed
  },
  // === Status & Feedback ===
  about: {
    emoji: 'ℹ️',
    component: Info
  },
  // alias
  favorite: {
    emoji: '❤️',
    component: Favorite
  },
  heart: {
    emoji: '❤️',
    component: Favorite
  },
  // alias
  help: {
    emoji: '❓',
    component: Help
  },
  info: {
    emoji: 'ℹ️',
    component: Info
  },
  star: {
    emoji: '⭐',
    component: Star
  },
  // === Users & People ===
  account_circle: {
    emoji: '👤',
    component: AccountCircle
  },
  group: {
    emoji: '👥',
    component: Group
  },
  manage_accounts: {
    emoji: '👤',
    component: ManageAccounts
  },
  people: {
    emoji: '👥',
    component: People
  },
  person: {
    emoji: '👤',
    component: Person
  },
  person_search: {
    emoji: '🔍',
    component: PersonSearch
  },
  user: {
    emoji: '👤',
    component: Person
  },
  // alias
  users: {
    emoji: '👥',
    component: People
  },
  // alias
  // === UI & Interaction ===
  accessibility: {
    emoji: '♿',
    component: Accessibility
  },
  broken_image: {
    emoji: '🖼️',
    component: BrokenImage
  },
  brokenimage: {
    emoji: '🖼️',
    component: BrokenImage
  },
  // alias
  circle: {
    emoji: '⭕',
    component: Circle
  },
  content_copy: {
    emoji: '📋',
    component: ContentCopy
  },
  contentcopy: {
    emoji: '📋',
    component: ContentCopy
  },
  // alias
  copy: {
    emoji: '📋',
    component: ContentCopy
  },
  // alias
  dark_mode: {
    emoji: '🌙',
    component: DarkMode
  },
  darkmode: {
    emoji: '🌙',
    component: DarkMode
  },
  // alias
  error: {
    emoji: '❌',
    component: Error$1
  },
  expand_less: {
    emoji: '▲',
    component: ExpandLess
  },
  expandless: {
    emoji: '▲',
    component: ExpandLess
  },
  // alias
  expand_more: {
    emoji: '▼',
    component: ExpandMore
  },
  expandmore: {
    emoji: '▼',
    component: ExpandMore
  },
  // alias
  format_bold: {
    emoji: '𝐁',
    component: FormatBold
  },
  formatbold: {
    emoji: '𝐁',
    component: FormatBold
  },
  // alias
  bold: {
    emoji: '𝐁',
    component: FormatBold
  },
  // alias
  format_italic: {
    emoji: '𝐼',
    component: FormatItalic
  },
  formatitalic: {
    emoji: '𝐼',
    component: FormatItalic
  },
  // alias
  italic: {
    emoji: '𝐼',
    component: FormatItalic
  },
  // alias
  format_underlined: {
    emoji: 'U̲',
    component: FormatUnderlined
  },
  formatunderlined: {
    emoji: 'U̲',
    component: FormatUnderlined
  },
  // alias
  underline: {
    emoji: 'U̲',
    component: FormatUnderlined
  },
  // alias
  launch: {
    emoji: '🚀',
    component: Launch
  },
  open: {
    emoji: '🚀',
    component: Launch
  },
  // alias
  light_mode: {
    emoji: '☀️',
    component: LightMode
  },
  lightmode: {
    emoji: '☀️',
    component: LightMode
  },
  // alias
  more_vert: {
    emoji: '⋮',
    component: MoreVert
  },
  morevert: {
    emoji: '⋮',
    component: MoreVert
  },
  // alias
  more: {
    emoji: '⋮',
    component: MoreVert
  },
  // alias
  palette: {
    emoji: '🎨',
    component: Palette
  },
  radio_button_unchecked: {
    emoji: '○',
    component: RadioButtonUnchecked
  },
  radiobuttonunchecked: {
    emoji: '○',
    component: RadioButtonUnchecked
  },
  // alias
  schedule: {
    emoji: '📅',
    component: Schedule
  },
  calendar: {
    emoji: '📅',
    component: Schedule
  },
  // alias
  settings_system_daydream: {
    emoji: '💻',
    component: SettingsSystemDaydream
  },
  settingssystemdaydream: {
    emoji: '💻',
    component: SettingsSystemDaydream
  },
  // alias
  system: {
    emoji: '💻',
    component: SettingsSystemDaydream
  },
  // alias
  warning: {
    emoji: '⚠️',
    component: Warning$3
  }
};
/**
 * Get emoji representation of an icon
 * @param iconName - Icon name (case-insensitive, supports snake_case)
 * @param fallback - Fallback emoji if icon not found (default: 🔗)
 * @returns Emoji string
 */
function getIconEmoji(iconName, fallback = '🔗') {
  if (!iconName) return fallback;
  const normalized = iconName.toLowerCase();
  const mapping = iconMap[normalized];
  return mapping?.emoji || fallback;
}
/**
 * Get Material-UI component representation of an icon.
 *
 * Uses the static iconMap for known icons. For unmapped icons,
 * returns a HelpOutline fallback and logs a warning.
 *
 * @param iconName - Icon name (case-insensitive, supports snake_case)
 * @returns React element (mapped icon or HelpOutline fallback), or null if no name provided
 */
function getIconComponent(iconName) {
  if (!iconName) return null;
  const normalized = iconName.toLowerCase();
  const mapping = iconMap[normalized];
  if (mapping?.component) {
    const IconComponent = mapping.component;
    return jsx(IconComponent, {});
  }
  return jsx(HelpOutline, {});
}
/**
 * Register a new icon or override an existing one
 * Useful for application-specific icon extensions
 */
function registerIcon(name, mapping) {
  iconMap[name.toLowerCase()] = mapping;
}
/**
 * Check if an icon is registered in the static map
 * If false, getIconComponent will return HelpOutline fallback
 */
function hasIcon(iconName) {
  return iconName.toLowerCase() in iconMap;
}
/**
 * Get all registered icon names from the static map
 */
function getRegisteredIcons() {
  return Object.keys(iconMap);
}

// View component - handles the actual rendering
const ButtonView = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    label,
    variant = 'primary',
    color,
    buttonSize = 'medium',
    icon,
    endIcon,
    href,
    target = '_self',
    onClick,
    action,
    disabled = false,
    loading = false,
    fullWidth = false,
    children,
    ...restProps
  } = props;
  // Map our variants to MUI variants
  const getMuiVariant = () => {
    switch (variant) {
      case 'primary':
        return 'contained';
      case 'secondary':
        return 'contained';
      case 'outlined':
        return 'outlined';
      case 'text':
        return 'text';
      case 'contained':
        return 'contained';
      default:
        return 'contained';
    }
  };
  // Get theme color name - prioritize explicit color prop over variant-derived color
  const getThemeColorName = () => {
    // If color prop is explicitly provided, use it
    if (color) {
      return color;
    }
    // Otherwise derive from variant
    switch (variant) {
      case 'primary':
        return 'primary';
      case 'secondary':
        return 'secondary';
      case 'outlined':
        return 'primary';
      case 'text':
        return 'primary';
      case 'contained':
        return 'primary';
      default:
        return 'primary';
    }
  };
  // Get CSS theme variable styles based on variant and color
  const getColorStyles = () => {
    const muiVariant = getMuiVariant();
    const colorName = getThemeColorName();
    // For contained buttons: use solid background
    if (muiVariant === 'contained') {
      return {
        backgroundColor: `var(--theme-${colorName})`,
        color: `var(--theme-on-${colorName})`,
        '&:hover': {
          backgroundColor: `var(--theme-${colorName}-dark)`
        },
        '&.Mui-disabled': {
          backgroundColor: 'var(--theme-text-disabled)',
          color: 'var(--theme-on-surface)'
        }
      };
    }
    // For outlined buttons: border and text color
    if (muiVariant === 'outlined') {
      return {
        borderColor: `var(--theme-${colorName})`,
        color: `var(--theme-${colorName})`,
        '&:hover': {
          borderColor: `var(--theme-${colorName}-dark)`,
          backgroundColor: `var(--theme-${colorName}-light)`
        },
        '&.Mui-disabled': {
          borderColor: 'var(--theme-border-main)',
          color: 'var(--theme-text-disabled)'
        }
      };
    }
    // For text buttons: just text color
    return {
      color: `var(--theme-${colorName})`,
      '&:hover': {
        backgroundColor: `var(--theme-${colorName}-light)`
      },
      '&.Mui-disabled': {
        color: 'var(--theme-text-disabled)'
      }
    };
  };
  // Handle action serialization pattern for onClick
  const handleActionClick = React.useCallback(event => {
    if (action) {
      event.preventDefault();
      switch (action.type) {
        case 'navigate':
          if (action.url) {
            if (action.target === '_blank') {
              window.open(action.url, '_blank', 'noopener,noreferrer');
            } else {
              // Fallback to regular navigation
              window.location.href = action.url;
            }
          }
          break;
        case 'submit':
          if (action.form) {
            const form = document.getElementById(action.form);
            if (form instanceof HTMLFormElement) {
              form.requestSubmit();
            }
          }
          break;
        case 'external':
          if (action.url) {
            window.open(action.url, action.target || '_blank', 'noopener,noreferrer');
          }
          break;
        case 'custom':
          if (action.customHandler && typeof window !== 'undefined') {
            // Look for custom handler function on window
            const handler = window[action.customHandler];
            if (typeof handler === 'function') {
              handler(event);
            }
          }
          break;
      }
    }
    // Call original onClick if provided
    if (onClick) {
      onClick(event);
    }
  }, [action, onClick]);
  // Determine if this should be a link (prioritize href over action)
  const isLink = Boolean(href && !disabled && !loading);
  // Base button props
  const baseProps = {
    variant: getMuiVariant(),
    size: buttonSize,
    disabled: disabled || loading,
    fullWidth,
    ...restProps,
    sx: {
      // Apply CSS theme variable colors
      ...getColorStyles(),
      // Ensure consistent text transform
      textTransform: 'none',
      // Loading state adjustments
      ...(loading && {
        '& .MuiButton-startIcon': {
          marginRight: 1
        }
      }),
      // Merge user-provided sx prop last to allow overrides
      ...(restProps.sx || {})
    },
    startIcon: loading ? jsx(CircularProgress, {
      size: 16,
      color: "inherit",
      "aria-label": "Loading"
    }) : icon,
    endIcon: loading ? undefined : endIcon
  };
  // Link-specific props
  if (isLink) {
    const linkProps = {
      ...baseProps,
      component: 'a',
      href,
      target,
      rel: target === '_blank' ? 'noopener noreferrer' : undefined,
      onClick: undefined // Links don't use onClick
    };
    return jsx(Button$1, {
      ref: ref,
      ...linkProps,
      children: label || children
    });
  }
  // Button-specific props with action handling
  const buttonProps = {
    ...baseProps,
    onClick: disabled || loading ? undefined : action ? handleActionClick : onClick
  };
  return jsx(Button$1, {
    ref: ref,
    ...buttonProps,
    children: label || children
  });
});
ButtonView.displayName = 'ButtonView';
// Create the serializable Button component using the factory
const Button = createSerializableView({
  tagName: 'Button',
  version: '1.0.0',
  role: 'view',
  View: ButtonView,
  // Button component uses default react-children strategy for potential child content
  finalize: props => {
    // Transform icon string names to React icon components
    const transformedProps = {
      ...props
    };
    if (typeof props.icon === 'string') {
      const iconComponent = getIconComponent(props.icon);
      // Always transform: use the component if found, otherwise clear the string to prevent text rendering
      transformedProps.icon = iconComponent || undefined;
    }
    if (typeof props.endIcon === 'string') {
      const endIconComponent = getIconComponent(props.endIcon);
      // Always transform: use the component if found, otherwise clear the string to prevent text rendering
      transformedProps.endIcon = endIconComponent || undefined;
    }
    return transformedProps;
  }
});
// Register HTML patterns that Button component can handle
Button.registerPatternHandlers = registry => {
  const typedRegistry = registry;
  // Register button elements
  if (typedRegistry.hasPattern && !typedRegistry.hasPattern('button')) {
    typedRegistry.registerPattern?.('button', transformButton);
  }
  // Register input type="button" elements
  if (typedRegistry.hasPattern && !typedRegistry.hasPattern('input[type="button"]')) {
    typedRegistry.registerPattern?.('input[type="button"]', transformInputButton);
  }
  // Register input type="submit" elements
  if (typedRegistry.hasPattern && !typedRegistry.hasPattern('input[type="submit"]')) {
    typedRegistry.registerPattern?.('input[type="submit"]', transformSubmitButton);
  }
};
// Transform button elements to Button component
function transformButton(element) {
  const variant = element.getAttribute('data-variant') || (element.className.includes('btn-primary') ? 'primary' : element.className.includes('btn-outlined') ? 'outlined' : 'secondary');
  const disabled = element.hasAttribute('disabled');
  const href = element.getAttribute('data-href');
  const target = element.getAttribute('data-target');
  return {
    tagName: 'Button',
    props: {
      label: element.textContent || 'Button',
      variant,
      disabled,
      href: href || undefined,
      target: target || undefined
    }
  };
}
// Transform input type="button" elements to Button component
function transformInputButton(element) {
  const disabled = element.hasAttribute('disabled');
  const value = element.getAttribute('value') || 'Button';
  return {
    tagName: 'Button',
    props: {
      label: value,
      variant: 'secondary',
      disabled
    }
  };
}
// Transform input type="submit" elements to Button component
function transformSubmitButton(element) {
  const disabled = element.hasAttribute('disabled');
  const value = element.getAttribute('value') || 'Submit';
  return {
    tagName: 'Button',
    props: {
      label: value,
      variant: 'primary',
      disabled,
      type: 'submit'
    }
  };
}

/**
 * TextView - Pure view component that renders the typography
 *
 * This component receives fully processed props from createSerializableView
 * and renders the text using Material-UI Typography with all styling applied.
 */
function TextView({
  content,
  variant = 'body1',
  color = 'inherit',
  align = 'inherit',
  component = 'p',
  fontWeight = 'inherit',
  textDecoration = 'none',
  textTransform = 'none',
  noWrap = false,
  paragraph = false,
  gutterBottom = false,
  fontSize,
  lineHeight,
  letterSpacing,
  fontFamily,
  customColor,
  maxWidth,
  className,
  style,
  ...restProps
}) {
  // Use content prop directly (already a string from content-prop strategy)
  const textContent = content || '';
  // Early return if no content provided
  if (!textContent) {
    return null;
  }
  // Build custom styles
  const customStyles = {
    ...style
  };
  // Apply custom typography overrides
  if (fontSize) customStyles.fontSize = fontSize;
  if (lineHeight) customStyles.lineHeight = lineHeight;
  if (letterSpacing) customStyles.letterSpacing = letterSpacing;
  if (fontFamily) customStyles.fontFamily = fontFamily;
  if (customColor) customStyles.color = customColor;
  if (maxWidth) customStyles.maxWidth = maxWidth;
  // Apply text formatting
  if (fontWeight !== 'inherit') customStyles.fontWeight = fontWeight;
  if (textDecoration !== 'none') customStyles.textDecoration = textDecoration;
  if (textTransform !== 'none') customStyles.textTransform = textTransform;
  // Handle onClick cursor if onClick is provided
  if (restProps.onClick) customStyles.cursor = 'pointer';
  return jsx(Typography, {
    ...restProps,
    variant: variant,
    color: color,
    align: align,
    component: component,
    noWrap: noWrap,
    paragraph: paragraph,
    gutterBottom: gutterBottom,
    className: `text ${className || ''}`.trim(),
    style: customStyles,
    children: textContent
  });
}
/**
 * Create Text component using the factory pattern
 */
const Text$1 = createSerializableView({
  tagName: 'Text',
  version: '1.0.0',
  role: 'view',
  View: TextView,
  childrenStrategy: {
    mode: 'content-prop',
    propName: 'content'
  }
});
// Register HTML patterns that Text component can handle
Text$1.registerPatternHandlers = registry => {
  const typedRegistry = registry;
  const textComponent = Text$1;
  // Register paragraph elements
  if (typedRegistry.hasPattern && !typedRegistry.hasPattern('p')) {
    typedRegistry.registerPattern?.('p', textComponent.transformParagraph);
  }
  // Register heading elements
  const headings = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
  headings.forEach(heading => {
    if (typedRegistry.hasPattern && !typedRegistry.hasPattern(heading)) {
      typedRegistry.registerPattern?.(heading, element => textComponent.transformHeading(element, heading));
    }
  });
  // Register span elements
  if (typedRegistry.hasPattern && !typedRegistry.hasPattern('span')) {
    typedRegistry.registerPattern?.('span', textComponent.transformSpan);
  }
};
// Transform paragraph elements to Text component
Text$1.transformParagraph = element => {
  return {
    tagName: 'Text',
    version: '1.0.0',
    data: {
      variant: 'body1',
      component: 'p',
      content: element.textContent || ''
    }
  };
};
// Transform heading elements to Text component
Text$1.transformHeading = (element, tagName) => {
  const variantMap = {
    'h1': 'h1',
    'h2': 'h2',
    'h3': 'h3',
    'h4': 'h4',
    'h5': 'h5',
    'h6': 'h6'
  };
  return {
    tagName: 'Text',
    version: '1.0.0',
    data: {
      variant: variantMap[tagName] || 'h4',
      component: tagName,
      content: element.textContent || ''
    }
  };
};
// Transform span elements to Text component
Text$1.transformSpan = element => {
  return {
    tagName: 'Text',
    version: '1.0.0',
    data: {
      variant: 'body2',
      component: 'span',
      content: element.textContent || ''
    }
  };
};

/**
 * HeroBlockView - Pure view component that renders the actual hero block
 *
 * This component receives fully processed props from createSerializableView
 * and renders the hero block using Material-UI components with all styling applied.
 */
function HeroBlockView({
  title = '',
  subtitle,
  backgroundImage,
  backgroundGradient,
  backgroundColor = 'primary',
  actions = [],
  children,
  textAlign = 'center',
  blockHeight = 'medium',
  overlayOpacity = 0.5,
  gridProps,
  ...props
}) {
  const theme = useTheme$1();
  // Map height variants to actual heights
  const getHeight = () => {
    switch (blockHeight) {
      case 'small':
        return 300;
      case 'medium':
        return 400;
      case 'large':
        return 600;
      case 'viewport':
        return '100vh';
      default:
        return 400;
    }
  };
  // Get background color from theme
  const getBackgroundColor = () => {
    if (backgroundImage || backgroundGradient) {
      return 'transparent';
    }
    switch (backgroundColor) {
      case 'primary':
        return theme.palette.primary.main;
      case 'secondary':
        return theme.palette.secondary.main;
      case 'surface':
        return theme.palette.background.paper;
      default:
        return theme.palette.background.default;
    }
  };
  // Get text color based on background
  const getTextColor = () => {
    switch (backgroundColor) {
      case 'primary':
        return theme.palette.primary.contrastText;
      case 'secondary':
        return theme.palette.secondary.contrastText;
      case 'surface':
        return theme.palette.getContrastText(theme.palette.background.paper);
      default:
        return theme.palette.text.primary;
    }
  };
  return jsxs(Box, {
    component: "section",
    ...props,
    ...(gridProps ? {
      'data-grid': JSON.stringify(gridProps)
    } : {}),
    sx: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: getHeight(),
      backgroundColor: getBackgroundColor(),
      color: getTextColor(),
      backgroundImage: backgroundImage ? `url(${backgroundImage})` : backgroundGradient || 'none',
      backgroundSize: backgroundImage ? 'cover' : 'auto',
      backgroundPosition: backgroundImage ? 'center' : 'initial',
      backgroundRepeat: 'no-repeat',
      overflow: 'hidden',
      ...props.sx
    },
    children: [backgroundImage && jsx(Box, {
      sx: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        opacity: overlayOpacity,
        zIndex: 1
      }
    }), jsx(Container$9, {
      maxWidth: "md",
      sx: {
        position: 'relative',
        zIndex: 2,
        textAlign,
        py: 4
      },
      children: jsxs(Stack, {
        spacing: 3,
        alignItems: textAlign === 'center' ? 'center' : textAlign === 'right' ? 'flex-end' : 'flex-start',
        children: [jsx(Text$1, {
          variant: "h2",
          component: "h1",
          customColor: 'var(--theme-on-primary)',
          sx: {
            fontWeight: 700,
            fontSize: {
              xs: '2rem',
              sm: '2.5rem',
              md: '3rem',
              lg: '3.5rem'
            },
            lineHeight: 1.2,
            maxWidth: '800px'
          },
          children: title
        }), subtitle && jsx(Text$1, {
          variant: "h5",
          component: "p",
          customColor: 'var(--theme-on-primary)',
          fontWeight: '400',
          sx: {
            opacity: 0.9,
            maxWidth: '600px'
          },
          children: subtitle
        }), actions.length > 0 && jsx(Stack, {
          direction: "row",
          spacing: 2,
          sx: {
            mt: 2,
            flexWrap: 'wrap',
            gap: 1,
            justifyContent: textAlign === 'center' ? 'center' : textAlign === 'right' ? 'flex-end' : 'flex-start'
          },
          children: actions.map((action, index) => jsx(Button, {
            buttonSize: "large",
            ...action
          }, `hero-action-${index}`))
        }), children && jsx(Box, {
          sx: {
            maxWidth: '800px'
          },
          children: children
        })]
      })
    })]
  });
}
/**
 * Create HeroBlock component using the factory pattern
 */
const HeroBlock = createSerializableView({
  tagName: 'HeroBlock',
  version: '1.0.0',
  role: 'container',
  View: HeroBlockView
});

const BrokenImageIcon = BrokenImage;
// View component - handles the actual rendering
function ImageView({
  src,
  alt = '',
  width,
  height,
  objectFit = 'cover',
  objectPosition = 'center',
  loading = 'lazy',
  title,
  draggable = false,
  borderRadius,
  showLoading = false,
  showError = false,
  fallbackSrc,
  sizes,
  srcSet,
  loadingPlaceholder,
  errorPlaceholder,
  onClick,
  style,
  className,
  ...restProps
}) {
  const theme = useTheme$1();
  const [imageState, setImageState] = useState('loading');
  const [currentSrc, setCurrentSrc] = useState(src);
  const handleLoad = useCallback(() => {
    setImageState('loaded');
  }, []);
  const handleError = useCallback(() => {
    // Try fallback source if available and not already using it
    if (fallbackSrc && currentSrc !== fallbackSrc) {
      setCurrentSrc(fallbackSrc);
      return;
    }
    setImageState('error');
  }, [fallbackSrc, currentSrc]);
  // Early return if no src provided
  if (!src) {
    if (showError) {
      return jsx(Box, {
        ...restProps,
        className: `image-error ${className || ''}`.trim(),
        style: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: theme.palette.grey[100],
          color: theme.palette.text.secondary,
          width: width || 200,
          height: height || 150,
          borderRadius,
          ...style
        },
        children: errorPlaceholder || jsxs(Box, {
          sx: {
            textAlign: 'center'
          },
          children: [jsx(BrokenImageIcon, {
            sx: {
              fontSize: 48,
              mb: 1,
              opacity: 0.5
            }
          }), jsx(Typography, {
            variant: "body2",
            color: "text.secondary",
            children: "No image source"
          })]
        })
      });
    }
    return null;
  }
  // Loading state
  if (imageState === 'loading' && showLoading) {
    return jsx(Box, {
      ...restProps,
      className: `image-loading ${className || ''}`.trim(),
      style: {
        width: width || '100%',
        height: height || 200,
        borderRadius,
        ...style
      },
      children: loadingPlaceholder || jsx(Skeleton, {
        variant: "rectangular",
        width: "100%",
        height: "100%",
        sx: {
          borderRadius
        }
      })
    });
  }
  // Error state
  if (imageState === 'error' && showError) {
    return jsx(Box, {
      ...restProps,
      className: `image-error ${className || ''}`.trim(),
      style: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.palette.grey[100],
        color: theme.palette.text.secondary,
        width: width || '100%',
        height: height || 200,
        borderRadius,
        ...style
      },
      children: errorPlaceholder || jsxs(Box, {
        sx: {
          textAlign: 'center',
          p: 2
        },
        children: [jsx(BrokenImageIcon, {
          sx: {
            fontSize: 48,
            mb: 1,
            opacity: 0.5
          }
        }), jsx(Typography, {
          variant: "body2",
          color: "text.secondary",
          children: "Failed to load image"
        }), fallbackSrc && jsx(Typography, {
          variant: "caption",
          color: "text.secondary",
          children: "Fallback image also failed"
        })]
      })
    });
  }
  const imageStyles = {
    display: 'block',
    maxWidth: '100%',
    height: 'auto',
    objectFit,
    objectPosition,
    borderRadius,
    cursor: onClick ? 'pointer' : 'default',
    ...style
  };
  // Apply dimensions if provided
  if (width) imageStyles.width = width;
  if (height) imageStyles.height = height;
  return jsx("img", {
    ...restProps,
    src: currentSrc,
    alt: alt,
    width: width,
    height: height,
    loading: loading,
    title: title,
    draggable: draggable,
    sizes: sizes,
    srcSet: srcSet,
    className: `image ${className || ''}`.trim(),
    style: imageStyles,
    onClick: onClick,
    onLoad: handleLoad,
    onError: handleError
  });
}
// Create the serializable Image component using the factory
const Image = createSerializableView({
  tagName: 'Image',
  version: '1.0.0',
  role: 'view',
  View: ImageView
  // Image component uses default react-children strategy
});
// Register HTML patterns that Image component can handle
Image.registerPatternHandlers = registry => {
  const typedRegistry = registry;
  // Register img elements
  if (typedRegistry.hasPattern && !typedRegistry.hasPattern('img')) {
    typedRegistry.registerPattern?.('img', transformImage);
  }
  // Register figure elements with img
  if (typedRegistry.hasPattern && !typedRegistry.hasPattern('figure img')) {
    typedRegistry.registerPattern?.('figure img', transformFigureImage);
  }
};
// Transform img elements to Image component
function transformImage(element) {
  const src = element.getAttribute('src') || '';
  const alt = element.getAttribute('alt') || '';
  const width = element.getAttribute('width');
  const height = element.getAttribute('height');
  const loading = element.getAttribute('loading');
  return {
    tagName: 'Image',
    props: {
      src,
      alt,
      width: width ? parseInt(width) : undefined,
      height: height ? parseInt(height) : undefined,
      loading: loading || 'lazy'
    }
  };
}
// Transform figure > img elements to Image component with caption support
function transformFigureImage(element) {
  const figure = element.closest('figure');
  const figcaption = figure?.querySelector('figcaption');
  const caption = figcaption?.textContent || '';
  const src = element.getAttribute('src') || '';
  const alt = element.getAttribute('alt') || caption;
  const width = element.getAttribute('width');
  const height = element.getAttribute('height');
  return {
    tagName: 'Image',
    props: {
      src,
      alt,
      caption: caption || undefined,
      width: width ? parseInt(width) : undefined,
      height: height ? parseInt(height) : undefined,
      loading: 'lazy'
    }
  };
}

/**
 * SectionView - Pure view component that renders the actual section
 *
 * This component receives fully processed props from createSerializableView
 * and renders the section using Material-UI Box with all styling applied.
 */
function SectionView({
  children,
  background = 'var(--theme-surface)',
  color = 'var(--theme-on-surface)',
  padding = 'medium',
  contentMaxWidth = 'lg',
  component = 'section',
  gridProps,
  ...props
}) {
  // Return empty state if no content
  if (!children) {
    return jsx(Box, {
      component: component,
      ...props,
      ...(gridProps ? {
        'data-grid': JSON.stringify(gridProps)
      } : {}),
      sx: {
        backgroundColor: background,
        color,
        position: 'static',
        py: 2,
        px: 0,
        ...props.sx
      },
      children: jsx(Container$9, {
        maxWidth: mapToMUIBreakpoint(contentMaxWidth),
        sx: {
          position: 'relative',
          textAlign: 'center',
          opacity: 0.6,
          ...(contentMaxWidth === false && {
            maxWidth: 'none !important',
            px: 3
          })
        },
        children: "No content provided for this section"
      })
    });
  }
  /**
   * Returns MUI spacing units for vertical padding based on spacing preset.
   */
  const getPadding = () => {
    switch (padding) {
      case 'none':
        return 0;
      case 'tiny':
        return {
          py: 1,
          px: 0
        };
      //  8px bottom only (avoiding double spacing)
      case 'small':
        return {
          py: 2,
          px: 0
        };
      // 16px vertical, no horizontal (Container handles)
      case 'medium':
        return {
          py: 4,
          px: 0
        };
      // 32px vertical
      case 'large':
        return {
          py: 8,
          px: 0
        };
      // 64px vertical
      case 'extra-large':
        return {
          py: 12,
          px: 0
        };
      // 96px vertical
      default:
        return {
          py: 4,
          px: 0
        };
      // Default to medium if unknown
    }
  };
  return jsx(Box, {
    component: component,
    ...props,
    ...(gridProps ? {
      'data-grid': JSON.stringify(gridProps)
    } : {}),
    sx: {
      backgroundColor: background,
      color,
      position: 'static',
      ...getPadding(),
      ...props.sx
    },
    children: jsx(Container$9, {
      maxWidth: mapToMUIBreakpoint(contentMaxWidth),
      sx: {
        position: 'relative',
        ...(contentMaxWidth === false && {
          maxWidth: 'none !important',
          px: 3 // Add some padding when no max width
        })
      },
      children: children
    })
  });
}
/**
 * Create Section component using the factory pattern
 */
const Section = createSerializableView({
  tagName: 'Section',
  version: '1.0.0',
  role: 'container',
  View: SectionView,
  finalize: props => {
    // Handle type conversion for contentMaxWidth - convert "false" string to boolean false
    if (props.contentMaxWidth === "false") {
      return {
        ...props,
        contentMaxWidth: false
      };
    }
    return props;
  }
});
// Register HTML patterns that Section component can handle
Section.registerPatternHandlers = registry => {
  const typedRegistry = registry;
  // Register section element pattern
  if (typedRegistry.hasPattern && !typedRegistry.hasPattern('section')) {
    typedRegistry.registerPattern?.('section', Section.transformSection);
  }
  // Register section with specific classes
  if (typedRegistry.hasPattern && !typedRegistry.hasPattern('section.blog-section')) {
    typedRegistry.registerPattern?.('section.blog-section', Section.transformBlogSection);
  }
};
// Transform generic section elements to Section component
Section.transformSection = element => {
  const padding = element.getAttribute('data-padding') || 'medium';
  const background = element.getAttribute('data-background');
  const contentMaxWidth = element.getAttribute('data-max-width') || 'lg';
  return {
    tagName: 'Section',
    version: '1.0.0',
    data: {
      padding,
      background,
      contentMaxWidth,
      children: element.innerHTML
    }
  };
};
// Transform blog section elements to Section component with specific styling
Section.transformBlogSection = element => {
  const padding = element.getAttribute('data-padding') || 'large';
  const background = element.getAttribute('data-background') || 'var(--theme-surface)';
  return {
    tagName: 'Section',
    version: '1.0.0',
    data: {
      padding,
      background,
      contentMaxWidth: 'md',
      children: element.innerHTML
    }
  };
};

/**
 * QwickApps React Framework - React Utilities
 * This module provides utility functions for React components in the QwickApps React Framework.
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
/**
 * Extract text content from ReactNode for code processing
 * Handles natural React usage like <Code>const x = 1;</Code>
 *
 * @param node - The ReactNode to extract text from
 * @returns String representation of the node's text content
 */
function extractTextFromReactNode(node) {
  if (node === null || node === undefined) {
    return '';
  }
  if (typeof node === 'string' || typeof node === 'number') {
    return String(node);
  }
  if (typeof node === 'boolean') {
    return node ? 'true' : 'false';
  }
  if (Array.isArray(node)) {
    return node.map(child => extractTextFromReactNode(child)).join('');
  }
  // For React elements, try to extract text content
  if (typeof node === 'object' && node !== null && 'props' in node) {
    const element = node;
    if (element.props && element.props.children) {
      return extractTextFromReactNode(element.props.children);
    }
  }
  // Fallback: convert to string
  return String(node);
}

/**
 * ModelView - Abstract Base Class implementing ViewSchema
 *
 * This abstract base class processes ViewSchema props and provides them
 * to subclasses through processed props. All concrete components should
 * extend this class to get consistent ViewSchema prop handling.
 *
 * Key Features:
 * - Processes all ViewSchema properties (grid, spacing, styling, etc.)
 * - Provides processed props to subclasses via getProcessedProps()
 * - Maintains abstract pattern for component-specific rendering
 * - Handles serialization and data binding
 */
/**
 * Convert ViewSchema props to BaseComponentProps format
 */
function convertSchemaToBaseProps(schema) {
  const {
    // Grid props - convert strings to proper types
    span,
    xs,
    sm,
    md,
    lg,
    xl,
    // Style props - convert JSON strings to objects
    sx,
    style,
    // All other props pass through directly
    ...restProps
  } = schema;
  return {
    // Convert grid span values
    span: span === 'auto' ? 'auto' : span === 'grow' ? 'grow' : span && typeof span === 'string' ? parseInt(span, 10) : span,
    xs: xs === 'auto' ? 'auto' : xs && typeof xs === 'string' ? parseInt(xs, 10) : xs,
    sm: sm === 'auto' ? 'auto' : sm && typeof sm === 'string' ? parseInt(sm, 10) : sm,
    md: md === 'auto' ? 'auto' : md && typeof md === 'string' ? parseInt(md, 10) : md,
    lg: lg === 'auto' ? 'auto' : lg && typeof lg === 'string' ? parseInt(lg, 10) : lg,
    xl: xl === 'auto' ? 'auto' : xl && typeof xl === 'string' ? parseInt(xl, 10) : xl,
    // Parse JSON strings for sx and style
    sx: typeof sx === 'string' ? (() => {
      try {
        return JSON.parse(sx);
      } catch {
        return sx;
      }
    })() : sx,
    style: typeof style === 'string' ? (() => {
      try {
        return JSON.parse(style);
      } catch {
        return style;
      }
    })() : style,
    // Convert event handlers from strings to functions
    onClick: typeof schema.onClick === 'string' ? convertEventHandler(schema.onClick) : schema.onClick,
    onMouseEnter: typeof schema.onMouseEnter === 'string' ? convertEventHandler(schema.onMouseEnter) : schema.onMouseEnter,
    onMouseLeave: typeof schema.onMouseLeave === 'string' ? convertEventHandler(schema.onMouseLeave) : schema.onMouseLeave,
    onFocus: typeof schema.onFocus === 'string' ? convertEventHandler(schema.onFocus) : schema.onFocus,
    onBlur: typeof schema.onBlur === 'string' ? convertEventHandler(schema.onBlur) : schema.onBlur,
    // Pass through all other props directly
    ...restProps
  };
}
/**
 * Convert string event handler to function
 */
function convertEventHandler(handlerStr) {
  if (!handlerStr || typeof handlerStr !== 'string') {
    return undefined;
  }
  try {
    // Create function from string - handle both function declarations and expressions
    let func;
    if (handlerStr.trim().startsWith('function')) {
      func = new Function(`return (${handlerStr})`)();
    } else {
      func = new Function('event', handlerStr);
    }
    return event => func(event);
  } catch (error) {
    console.error('Error parsing event handler:', error);
    return undefined;
  }
}
/**
 * Abstract base class implementing ViewSchema
 * All concrete components should extend this class
 */
class ModelView extends React.Component {
  /**
   * Common fromJson implementation
   */
  static fromJson(jsonData) {
    const typedData = jsonData;
    const {
      tagName,
      version,
      data
    } = typedData;
    if (tagName !== this.tagName) {
      throw new Error(`Cannot deserialize: Expected tagName '${this.tagName}' but got '${tagName}'`);
    }
    if (version !== this.version) {
      console.warn(`Version mismatch: Expected ${this.version} but got ${version}`);
    }
    return /*#__PURE__*/React.createElement(this, data || {});
  }
  /**
   * Common toJson implementation with hooks for customization
   */
  toJson() {
    const baseProps = this.getBaseSerializableProps();
    const componentProps = this.getComponentSpecificProps();
    return {
      tagName: this.constructor.tagName,
      version: this.constructor.version,
      data: {
        ...baseProps,
        ...componentProps
      }
    };
  }
  /**
   * Get processed props for subclasses to use
   * This converts ViewSchema props and processes them through useBaseProps
   */
  getProcessedProps() {
    const {
      dataSource: _dataSource,
      bindingOptions: _bindingOptions,
      ...schemaProps
    } = this.props;
    // Convert ViewSchema props to BaseComponentProps format
    const convertedProps = convertSchemaToBaseProps(schemaProps);
    // Process through useBaseProps utility (this is a bit of a hack since we're in a class component)
    // We'll simulate what useBaseProps does
    const mockProps = {
      gridProps: {
        span: convertedProps.span,
        xs: convertedProps.xs,
        sm: convertedProps.sm,
        md: convertedProps.md,
        lg: convertedProps.lg,
        xl: convertedProps.xl
      },
      styleProps: {
        className: convertedProps.className,
        sx: convertedProps.sx,
        style: convertedProps.style
      },
      htmlProps: {
        id: convertedProps.id,
        role: convertedProps.role,
        'aria-label': convertedProps['aria-label'],
        'aria-labelledby': convertedProps['aria-labelledby'],
        'aria-describedby': convertedProps['aria-describedby'],
        'data-testid': convertedProps['data-testid'],
        onClick: convertedProps.onClick,
        onMouseEnter: convertedProps.onMouseEnter,
        onMouseLeave: convertedProps.onMouseLeave,
        onFocus: convertedProps.onFocus,
        onBlur: convertedProps.onBlur
      },
      restProps: {
        // All the spacing, dimension, and background props
        width: convertedProps.width,
        height: convertedProps.height,
        minWidth: convertedProps.minWidth,
        minHeight: convertedProps.minHeight,
        maxWidth: convertedProps.maxWidth,
        maxHeight: convertedProps.maxHeight,
        padding: convertedProps.padding,
        paddingTop: convertedProps.paddingTop,
        paddingRight: convertedProps.paddingRight,
        paddingBottom: convertedProps.paddingBottom,
        paddingLeft: convertedProps.paddingLeft,
        paddingX: convertedProps.paddingX,
        paddingY: convertedProps.paddingY,
        margin: convertedProps.margin,
        marginTop: convertedProps.marginTop,
        marginRight: convertedProps.marginRight,
        marginBottom: convertedProps.marginBottom,
        marginLeft: convertedProps.marginLeft,
        marginX: convertedProps.marginX,
        marginY: convertedProps.marginY,
        background: convertedProps.background,
        backgroundImage: convertedProps.backgroundImage,
        backgroundGradient: convertedProps.backgroundGradient,
        textAlign: convertedProps.textAlign
      }
    };
    return mockProps;
  }
  /**
   * Common base props that all components serialize
   */
  getBaseSerializableProps() {
    const props = this.props;
    return {
      children: props.children ? this.serializeChildren(props.children) : undefined,
      dataSource: props.dataSource,
      bindingOptions: props.bindingOptions,
      // Include all ViewSchema props in serialization
      ...props
    };
  }
  /**
   * Common children serialization logic
   */
  serializeChildren(children) {
    if (typeof children === 'string') {
      return children;
    }
    if (this.hasNestedComponents(children)) {
      throw new Error('Components with nested components must override serializeChildren method');
    }
    return extractTextFromReactNode(children);
  }
  /**
   * Helper to determine if children contain other serializable components
   */
  hasNestedComponents(_children) {
    return false;
  }
  /**
   * Common render pattern
   */
  render() {
    const props = this.props;
    if (props.dataSource) {
      return this.renderWithDataBinding();
    }
    return this.renderView();
  }
  /**
   * Register HTML pattern handlers for this component
   */
  static registerPatternHandlers(_registry) {
    // Default: no patterns to register
  }
}
// Static properties - must be overridden by subclasses
ModelView.tagName = '';
ModelView.version = '';
/**
 * Helper function for creating ModelView component classes with ViewSchema support
 * Updated to work with the new ViewSchema processing system
 */
function createModelViewClass(config) {
  class DynamicModelView extends ModelView {
    getComponentSpecificProps() {
      const processedProps = this.getProcessedProps();
      return config.getComponentSpecificProps(this.props, processedProps);
    }
    hasNestedComponents(children) {
      return config.hasNestedComponents ? config.hasNestedComponents(children) : false;
    }
    renderView() {
      const processedProps = this.getProcessedProps();
      return config.renderView(this.props, processedProps);
    }
    renderWithDataBinding() {
      const processedProps = this.getProcessedProps();
      return config.renderWithDataBinding(this.props, processedProps);
    }
  }
  DynamicModelView.tagName = config.tagName;
  DynamicModelView.version = config.version;
  return DynamicModelView;
}

const MoreIcon$1 = MoreVert;
function CoverImageHeaderView({
  image,
  imageAlt = '',
  imageSize = 'medium',
  imageShape = 'rounded',
  imageBackgroundColor = 'transparent',
  overline,
  title,
  subtitle,
  tags = [],
  actions = [],
  maxVisibleActions = 3,
  variant = 'default',
  background,
  color,
  ...restProps
}) {
  const {
    gridProps,
    styleProps,
    htmlProps
  } = useBaseProps(restProps);
  const [anchorEl, setAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);
  // Sort actions by priority (lower number = higher priority)
  const sortedActions = [...actions].sort((a, b) => (a.priority || 999) - (b.priority || 999));
  // Split actions into visible and overflow
  const visibleActions = sortedActions.slice(0, maxVisibleActions);
  const overflowActions = sortedActions.slice(maxVisibleActions);
  const handleMenuOpen = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const getAvatarSize = () => {
    switch (imageSize) {
      case 'small':
        return 48;
      case 'large':
        return 80;
      default:
        return 64;
    }
  };
  const getAvatarVariant = () => {
    switch (imageShape) {
      case 'circle':
        return 'circular';
      case 'square':
        return 'square';
      default:
        return 'rounded';
    }
  };
  const renderImage = () => {
    if (!image) return null;
    const size = getAvatarSize();
    if (typeof image === 'string') {
      return jsx(Avatar, {
        src: image,
        alt: imageAlt,
        variant: getAvatarVariant(),
        sx: {
          width: size,
          height: size
        }
      });
    }
    return jsx(Avatar, {
      variant: getAvatarVariant(),
      sx: {
        width: size,
        height: size,
        backgroundColor: imageBackgroundColor || 'transparent'
      },
      children: image
    });
  };
  const renderTags = () => {
    if (tags.length === 0) return null;
    return jsx(Box, {
      sx: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 0.5,
        mt: 0.5
      },
      children: tags.map((tag, index) => jsx(Chip, {
        label: tag,
        size: "small",
        color: "primary",
        sx: {
          fontSize: '0.75rem',
          height: '24px'
        }
      }, index))
    });
  };
  const renderActions = () => {
    if (actions.length === 0) return null;
    return jsxs(Box, {
      sx: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: 0.5
      },
      children: [visibleActions.map(action => jsx(Button$1, {
        variant: "outlined",
        size: "small",
        startIcon: action.icon,
        onClick: action.onClick,
        disabled: action.disabled,
        color: action.destructive ? 'error' : 'primary',
        sx: {
          minHeight: 36,
          whiteSpace: 'nowrap',
          '& .MuiButton-startIcon': {
            mr: 0.5
          }
        },
        children: action.label
      }, action.id)), overflowActions.length > 0 && jsxs(Fragment, {
        children: [jsx(IconButton, {
          size: "small",
          onClick: handleMenuOpen,
          "aria-label": "More actions",
          color: 'info',
          sx: {
            minHeight: 36,
            minWidth: 36
          },
          children: jsx(MoreIcon$1, {})
        }), jsx(Menu$1, {
          anchorEl: anchorEl,
          open: isMenuOpen,
          onClose: handleMenuClose,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right'
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'right'
          },
          children: overflowActions.map(action => jsxs(MenuItem, {
            onClick: () => {
              action.onClick();
              handleMenuClose();
            },
            disabled: action.disabled,
            sx: {
              color: action.destructive ? 'error.main' : 'inherit',
              gap: 1.5,
              minWidth: 200
            },
            children: [action.icon && jsx(Box, {
              component: "span",
              sx: {
                display: 'flex'
              },
              children: action.icon
            }), action.label]
          }, action.id))
        })]
      })]
    });
  };
  const getPadding = () => {
    switch (variant) {
      case 'compact':
        return 2;
      case 'prominent':
        return 3;
      default:
        return 2.5;
    }
  };
  const getGap = () => {
    switch (variant) {
      case 'compact':
        return 1.5;
      case 'prominent':
        return 2;
      default:
        return 2;
    }
  };
  const getElevation = () => {
    switch (variant) {
      case 'default':
        return 0;
      case 'compact':
        return 1;
      case 'prominent':
        return 1;
      default:
        return 0;
    }
  };
  const backgroundStyle = background ? {
    background: background.startsWith('http') || background.startsWith('data:') ? `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url(${background})` : background,
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  } : {
    'background': '-var(--theme-primary)'
  };
  return jsx(Paper, {
    component: "header",
    ...htmlProps,
    ...(gridProps && {
      'data-grid-span': gridProps.span,
      'data-grid-xs': gridProps.xs,
      'data-grid-sm': gridProps.sm,
      'data-grid-md': gridProps.md,
      'data-grid-lg': gridProps.lg,
      'data-grid-xl': gridProps.xl
    }),
    sx: {
      p: getPadding(),
      borderRadius: getElevation() > 0 ? 2 : 0,
      // No border radius when elevation is 0
      ...backgroundStyle,
      color: background ? 'white' : 'inherit',
      ...styleProps.sx
    },
    elevation: getElevation(),
    children: jsxs(Box, {
      sx: {
        display: 'flex',
        alignItems: variant === 'prominent' ? 'center' : 'flex-start',
        gap: getGap(),
        flexWrap: {
          xs: 'wrap',
          sm: 'nowrap'
        },
        minHeight: variant === 'prominent' ? 120 : 'auto'
      },
      children: [renderImage(), jsxs(Box, {
        sx: {
          flex: 1,
          minWidth: 0
        },
        children: [overline && jsx(Typography, {
          variant: "overline",
          color: color || '--var(--theme-on-primary)',
          sx: {
            display: 'block',
            fontSize: '0.75rem',
            fontWeight: 600,
            lineHeight: 1.2,
            mb: 0.25
          },
          children: overline
        }), jsx(Typography, {
          variant: "h5",
          component: "h1",
          sx: {
            fontWeight: 600,
            lineHeight: 1.3,
            wordBreak: 'break-word',
            mb: subtitle ? 0.25 : 0
          },
          children: title
        }), subtitle && jsx(Typography, {
          variant: "body2",
          color: color || '--var(--theme-on-primary)',
          sx: {
            lineHeight: 1.4,
            mb: tags.length > 0 ? 0 : 0
          },
          children: subtitle
        }), renderTags()]
      }), jsx(Box, {
        sx: {
          flexShrink: 0,
          width: {
            xs: '100%',
            sm: 'auto'
          },
          display: 'flex',
          justifyContent: {
            xs: 'flex-end',
            sm: 'flex-start'
          },
          mt: {
            xs: 1,
            sm: 0
          }
        },
        children: renderActions()
      })]
    })
  });
}
// Loading state component
function LoadingState() {
  return jsxs(Paper, {
    variant: "outlined",
    sx: {
      p: 3,
      textAlign: 'center'
    },
    children: [jsx(Typography, {
      variant: "body2",
      children: "Loading Cover Image Header..."
    }), jsx(Typography, {
      variant: "caption",
      color: "text.secondary",
      children: "Loading header content from data source..."
    })]
  });
}
function CoverImageHeader(props) {
  const {
    dataSource,
    bindingOptions,
    ...restProps
  } = props;
  // Always call hooks unconditionally
  const bindingResult = useDataBinding(dataSource || '', restProps);
  // If no dataSource, use traditional props
  if (!dataSource) {
    return jsx(CoverImageHeaderView, {
      ...restProps
    });
  }
  // Use data binding result
  const {
    loading,
    error,
    ...coverImageHeaderProps
  } = bindingResult;
  // Show loading state
  if (loading) {
    return jsx(LoadingState, {});
  }
  if (error) {
    console.error('Error loading cover image header:', error);
    return null;
  }
  // Convert HeaderActionModel[] to HeaderAction[] if actions exist
  const {
    actions: modelActions,
    ...viewProps
  } = coverImageHeaderProps;
  const convertedActions = modelActions ? modelActions.filter(action => typeof action.id === 'string' && !!action.id).map(action => ({
    ...action,
    id: action.id,
    onClick: () => console.debug(`Action clicked: ${action.id}`) // Default handler for data-driven actions
  })) : [];
  return jsx(CoverImageHeaderView, {
    ...viewProps,
    actions: convertedActions
  });
}

// View component - handles the actual rendering
function LogoView({
  name = 'Qwick Apps',
  variant = 'default',
  size = 'medium',
  badge = 'top-right',
  badgeShape = 'circle',
  badgeOffsetX,
  badgeOffsetY,
  fontFamily = 'Segoe UI, sans-serif',
  fontWeight = 'bold',
  firstPartClass = 'logo-first-part',
  secondPartClass = 'logo-second-part',
  image,
  imagePosition = 'start',
  onClick,
  style,
  className,
  ...restProps
}) {
  const {
    styleProps,
    htmlProps
  } = useBaseProps(restProps);
  // Convert separate offset values to BadgeOffset object - memoize to prevent unnecessary re-renders
  const badgeOffset = useMemo(() => badgeOffsetX !== undefined || badgeOffsetY !== undefined ? {
    x: badgeOffsetX,
    y: badgeOffsetY
  } : undefined, [badgeOffsetX, badgeOffsetY]);
  const textRef = useRef(null);
  const [calculatedBadgePosition, setCalculatedBadgePosition] = useState({
    x: 155,
    y: 20
  });
  const [svgWidth, setSvgWidth] = useState(180);
  // Parse name with support for escape sequences to determine structure
  const parseNameParts = useCallback(text => {
    // Handle line breaks first
    if (text.includes('\\n')) {
      const [first, ...rest] = text.split('\\n');
      return {
        firstPart: first.replace(/\\s/g, ' '),
        secondPart: rest.join('\\n').replace(/\\s/g, ' '),
        isNewLine: true
      };
    }
    // Check if text contains explicit \s sequences
    if (text.includes('\\s')) {
      // Handle explicit spaces - split by \s and treat as two parts
      const parts = text.split('\\s');
      if (parts.length >= 2) {
        return {
          firstPart: parts[0],
          secondPart: parts.slice(1).join(' '),
          // Join remaining parts with spaces
          isNewLine: false
        };
      } else {
        return {
          firstPart: parts[0],
          secondPart: '',
          isNewLine: false
        };
      }
    }
    // Regular word splitting (no explicit \s)
    const nameParts = text.trim().split(/\s+/);
    if (nameParts.length === 1) {
      return {
        firstPart: nameParts[0],
        secondPart: '',
        isNewLine: false
      };
    } else if (nameParts.length === 2) {
      return {
        firstPart: nameParts[0],
        secondPart: nameParts[1],
        isNewLine: false
      };
    } else {
      // More than 2 words: everything except last word goes to first part
      return {
        firstPart: nameParts.slice(0, -1).join(' '),
        secondPart: nameParts[nameParts.length - 1],
        isNewLine: false
      };
    }
  }, []);
  const {
    firstPart,
    secondPart,
    isNewLine
  } = parseNameParts(name);
  // Check if original name contained explicit spaces
  const hasExplicitSpaces = name.includes('\\s');
  // Determine size class, font size, and component height (accounting for line breaks)
  const sizeClass = `logo-${size}`;
  const getSizeConfig = (size, hasLineBreak) => {
    const baseConfig = {
      'tiny': {
        fontSize: 16,
        height: 32
      },
      'small': {
        fontSize: 20,
        height: 40
      },
      'medium': {
        fontSize: 28,
        height: 50
      },
      'large': {
        fontSize: 36,
        height: 64
      },
      'extra-large': {
        fontSize: 48,
        height: 84
      }
    };
    const config = baseConfig[size] || baseConfig.medium;
    // Add extra height for line breaks (approximately 1.4x the font size for proper spacing)
    if (hasLineBreak) {
      config.height += Math.round(config.fontSize * 1.4);
    }
    return config;
  };
  const {
    fontSize,
    height
  } = getSizeConfig(size, isNewLine);
  // Calculate badge position based on semantic positioning system
  const calculateBadgePosition = useCallback(textBBox => {
    // Scale factor based on font size (medium/28px is the baseline)
    const scale = fontSize / 28; // 28 is the medium/default font size
    const scaledOffset = 8 * scale;
    // Scale custom offset based on size
    const scaledOffsetX = (badgeOffset?.x ?? 0) * scale;
    const scaledOffsetY = (badgeOffset?.y ?? 0) * scale;
    // Calculate position based on semantic positioning
    let x, y;
    switch (badge) {
      case 'top-left':
        x = textBBox.x - scaledOffset;
        y = textBBox.y + scaledOffset;
        break;
      case 'top-center':
        x = textBBox.x + textBBox.width / 2;
        y = textBBox.y + scaledOffset;
        break;
      case 'top-right':
        x = textBBox.x + textBBox.width + scaledOffset;
        y = textBBox.y + scaledOffset;
        break;
      case 'start':
        // was 'center-left'
        x = textBBox.x - scaledOffset;
        y = textBBox.y + textBBox.height / 2;
        break;
      case 'center':
        x = textBBox.x + textBBox.width / 2;
        y = textBBox.y + textBBox.height / 2;
        break;
      case 'end':
        // was 'center-right'
        x = textBBox.x + textBBox.width + scaledOffset;
        y = textBBox.y + textBBox.height / 2;
        break;
      case 'bottom-left':
        x = textBBox.x - scaledOffset;
        y = textBBox.y + textBBox.height - scaledOffset;
        break;
      case 'bottom-center':
        x = textBBox.x + textBBox.width / 2;
        y = textBBox.y + textBBox.height - scaledOffset;
        break;
      case 'bottom-right':
        x = textBBox.x + textBBox.width + scaledOffset;
        y = textBBox.y + textBBox.height - scaledOffset;
        break;
      default:
        // Default: top-right of text
        x = textBBox.x + textBBox.width + scaledOffset;
        y = textBBox.y + scaledOffset;
        break;
    }
    return {
      x: x + scaledOffsetX,
      y: y + scaledOffsetY
    };
  }, [badge, badgeOffset, fontSize]);
  // Calculate badge position and SVG width based on text width
  useEffect(() => {
    if (textRef.current) {
      const textBBox = textRef.current.getBBox();
      // Calculate badge position using semantic positioning
      const badgePos = calculateBadgePosition(textBBox);
      // Ensure SVG is wide enough to accommodate text and badge
      const requiredWidth = Math.max(180, textBBox.x + textBBox.width + 20);
      setCalculatedBadgePosition(badgePos);
      setSvgWidth(requiredWidth);
    }
  }, [name, badge, badgeOffset, calculateBadgePosition, fontSize, height, parseNameParts]);
  // Determine CSS class for variant
  let variantClass = '';
  if (variant === 'high-contrast' || variant === 'monochrome' || variant === 'on-primary') {
    variantClass = `logo-${variant}`;
  } else if (variant !== 'default') {
    variantClass = `logo-${variant}`;
  } else {
    variantClass = 'logo-default';
  }
  // Create aria-label from the logo name
  const ariaLabel = `${name} Logo`;
  // Render badge shape
  const renderBadgeShape = () => {
    if (badge === 'none') return null;
    const baseProps = {
      className: `logo-badge logo-badge-${badgeShape}`
    };
    // Use the calculated position (which includes custom position logic)
    const {
      x,
      y
    } = calculatedBadgePosition;
    // Scale badge size based on font size
    const scale = fontSize / 28; // 28 is the medium/default font size
    const badgeRadius = 5 * scale;
    const badgeSize = 10 * scale;
    switch (badgeShape) {
      case 'circle':
        return jsx("circle", {
          cx: x,
          cy: y,
          r: badgeRadius,
          ...baseProps,
          children: jsx("animate", {
            attributeName: "r",
            values: `${badgeRadius};${badgeRadius + 1};${badgeRadius}`,
            dur: "1.5s",
            repeatCount: "indefinite"
          })
        });
      case 'star':
        {
          const starScale = scale;
          return jsx("polygon", {
            points: `${x},${y - 5 * starScale} ${x + 2 * starScale},${y} ${x + 7 * starScale},${y} ${x + 3 * starScale},${y + 3 * starScale} ${x + 5 * starScale},${y + 8 * starScale} ${x},${y + 5 * starScale} ${x - 5 * starScale},${y + 8 * starScale} ${x - 3 * starScale},${y + 3 * starScale} ${x - 7 * starScale},${y} ${x - 2 * starScale},${y}`,
            ...baseProps,
            children: jsx("animate", {
              attributeName: "opacity",
              values: "0.8;1;0.8",
              dur: "1.5s",
              repeatCount: "indefinite"
            })
          });
        }
      case 'square':
        return jsx("rect", {
          x: x - badgeRadius,
          y: y - badgeRadius,
          width: badgeSize,
          height: badgeSize,
          ...baseProps,
          children: jsx("animate", {
            attributeName: "opacity",
            values: "0.8;1;0.8",
            dur: "1.5s",
            repeatCount: "indefinite"
          })
        });
      case 'heart':
        {
          const heartScale = scale;
          return jsx("path", {
            d: `M${x},${y + 6 * heartScale} C${x},${y + 6 * heartScale} ${x - 7 * heartScale},${y} ${x - 7 * heartScale},${y - 4 * heartScale} C${x - 7 * heartScale},${y - 6 * heartScale} ${x - 5 * heartScale},${y - 8 * heartScale} ${x - 3 * heartScale},${y - 8 * heartScale} C${x - 2 * heartScale},${y - 8 * heartScale} ${x},${y - 7 * heartScale} ${x},${y - 5 * heartScale} C${x},${y - 7 * heartScale} ${x + 2 * heartScale},${y - 8 * heartScale} ${x + 3 * heartScale},${y - 8 * heartScale} C${x + 5 * heartScale},${y - 8 * heartScale} ${x + 7 * heartScale},${y - 6 * heartScale} ${x + 7 * heartScale},${y - 4 * heartScale} C${x + 7 * heartScale},${y} ${x},${y + 6 * heartScale} ${x},${y + 6 * heartScale} Z`,
            ...baseProps,
            children: jsx("animate", {
              attributeName: "fill-opacity",
              values: "0.7;1;0.7",
              dur: "1.5s",
              repeatCount: "indefinite"
            })
          });
        }
      default:
        return jsx("circle", {
          cx: x,
          cy: y,
          r: badgeRadius,
          ...baseProps,
          children: jsx("animate", {
            attributeName: "r",
            values: `${badgeRadius};${badgeRadius + 1};${badgeRadius}`,
            dur: "1.5s",
            repeatCount: "indefinite"
          })
        });
    }
  };
  // Render image if provided
  const renderImage = () => {
    if (!image || imagePosition === 'none') return null;
    // If image is a string, assume it's an image path
    if (typeof image === 'string') {
      const imageSize = fontSize; // Scale image with font size
      return jsx("img", {
        src: image,
        alt: "",
        style: {
          width: imageSize,
          height: imageSize,
          objectFit: 'contain'
        },
        className: "logo-image"
      });
    }
    // If image is a React node, render it directly
    return jsx("div", {
      className: "logo-image-container",
      style: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      children: image
    });
  };
  // Determine layout based on image position
  const renderWithImage = () => {
    const logoSvg = jsxs("svg", {
      width: svgWidth,
      height: height,
      viewBox: `0 0 ${svgWidth} ${height}`,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: `logo-svg dynamic-logo ${sizeClass} ${variantClass}`.trim(),
      style: {
        height: `${height}px`,
        ...style
      },
      role: "img",
      "aria-label": ariaLabel,
      children: [jsxs("text", {
        ref: textRef,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeight: fontWeight,
        children: [jsx("tspan", {
          x: "15",
          y: isNewLine ? height * 0.4 : height * 0.7,
          className: firstPartClass,
          children: firstPart
        }), secondPart && jsx("tspan", {
          x: isNewLine ? "15" : undefined,
          dy: isNewLine ? fontSize * 1.2 : undefined,
          className: secondPartClass,
          children: isNewLine ? secondPart : hasExplicitSpaces ? ` ${secondPart}` : secondPart
        })]
      }), renderBadgeShape()]
    });
    const imageElement = renderImage();
    if (!imageElement) {
      return logoSvg;
    }
    // Create container with image positioned based on imagePosition
    const containerStyle = {
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    };
    let containerClass = 'logo-container';
    switch (imagePosition) {
      case 'start':
        containerStyle.flexDirection = 'row';
        containerClass += ' logo-image-start';
        break;
      case 'end':
        containerStyle.flexDirection = 'row-reverse';
        containerClass += ' logo-image-end';
        break;
      case 'top-center':
        containerStyle.flexDirection = 'column';
        containerClass += ' logo-image-top';
        break;
      case 'bottom-center':
        containerStyle.flexDirection = 'column-reverse';
        containerClass += ' logo-image-bottom';
        break;
      default:
        // For other positions, default to start
        containerStyle.flexDirection = 'row';
        containerClass += ' logo-image-start';
        break;
    }
    return jsxs("div", {
      ...htmlProps,
      ...styleProps,
      className: `${containerClass} ${className || ''}`.trim(),
      style: {
        ...containerStyle,
        cursor: onClick ? 'pointer' : 'default',
        ...style
      },
      onClick: onClick,
      children: [imageElement, logoSvg]
    });
  };
  return renderWithImage();
}
// Main Logo component with data binding support
function Logo(props) {
  const {
    dataSource,
    bindingOptions,
    ...restProps
  } = props;
  // Always call hooks unconditionally
  const bindingResult = useDataBinding(dataSource || '', restProps);
  // If no dataSource, use traditional props
  if (!dataSource) {
    return jsx(LogoView, {
      ...restProps
    });
  }
  // Use data binding result
  const {
    loading,
    error,
    ...logoProps
  } = bindingResult;
  // Show loading state
  if (loading) {
    return jsx("div", {
      style: {
        opacity: 0.5,
        textAlign: 'center',
        padding: '16px'
      },
      children: "Loading logo..."
    });
  }
  // Show error state
  if (error) {
    return jsxs("div", {
      style: {
        color: 'red',
        textAlign: 'center',
        padding: '16px'
      },
      children: ["Error loading logo: ", error.message]
    });
  }
  return jsx(LogoView, {
    ...logoProps
  });
}
// Mark as QwickApp component
Object.defineProperty(Logo, QWICKAPP_COMPONENT, {
  value: true,
  enumerable: false,
  configurable: true
});

/**
 * Default header component that uses CoverImageHeader and Logo
 */
const DefaultHeader = ({
  title,
  subtitle,
  coverImage
}) => {
  const {
    appName
  } = useQwickApp$1();
  // Create image element - either coverImage (URL or React element) or Logo component
  const image = coverImage ? coverImage : jsx(Logo, {
    name: appName || 'Qwick Apps',
    size: "medium",
    variant: "default"
  });
  return jsx(CoverImageHeader, {
    image: image,
    imageSize: "medium",
    imageShape: "square",
    title: title || 'Welcome',
    subtitle: subtitle,
    variant: "default"
  });
};
// View component - handles the actual rendering
function FormBlockView({
  header,
  title,
  description,
  coverImage,
  children: form,
  footer,
  status,
  message,
  maxWidth = 'sm',
  background = '--theme-surface',
  backgroundImage,
  ...restProps
}) {
  const {
    styleProps,
    htmlProps
  } = useBaseProps(restProps);
  const theme = useTheme$1();
  // Return empty state if no form content
  if (!form) {
    return jsx(Paper, {
      ...htmlProps,
      ...styleProps,
      variant: "outlined",
      sx: {
        p: 3,
        textAlign: 'center',
        opacity: 0.6,
        ...styleProps.sx
      },
      children: jsx(Typography, {
        variant: "body2",
        color: "text.secondary",
        children: "No form content provided"
      })
    });
  }
  const getBackgroundStyle = () => {
    switch (background) {
      case 'gradient':
        return {
          background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`
        };
      case 'image':
        return backgroundImage ? {
          backgroundImage: `linear-gradient(${theme.palette.action.hover}, ${theme.palette.action.hover}), url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        } : {};
      default:
        return {
          backgroundColor: theme.palette.background.default
        };
    }
  };
  return jsx(Box, {
    ...htmlProps,
    ...styleProps,
    className: `${styleProps.className || ''}`,
    sx: {
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      py: 3,
      ...getBackgroundStyle(),
      ...styleProps.sx
    },
    children: jsx(Container$9, {
      maxWidth: maxWidth,
      children: jsxs(Card, {
        elevation: background === 'default' ? 1 : 8,
        sx: {
          borderRadius: 3,
          overflow: 'hidden',
          // Changed from 'visible' to 'hidden' to clip the corners
          backgroundColor: background === 'default' ? theme.palette.background.paper : theme.palette.mode === 'dark' ? 'rgba(18, 18, 18, 0.95)' // Dark mode background with transparency
          : 'rgba(255, 255, 255, 0.95)',
          // Light mode background with transparency
          backdropFilter: background !== 'default' ? 'blur(10px)' : 'none'
        },
        children: [header || title || description ? header || jsx(DefaultHeader, {
          title: title,
          subtitle: description,
          coverImage: coverImage
        }) : null, jsxs(CardContent, {
          sx: {
            p: {
              xs: 3,
              sm: 4,
              md: 5
            }
          },
          children: [status && message && jsx(Alert, {
            severity: status,
            sx: {
              mb: 3
            },
            variant: "outlined",
            children: message
          }), jsx(Box, {
            sx: {
              mb: footer ? 3 : 0
            },
            children: form
          }), footer && jsx(Box, {
            sx: {
              textAlign: 'center'
            },
            children: footer
          })]
        })]
      })
    })
  });
}
// Main component with data binding support and serialization capability
class FormBlock extends ModelView {
  // Deserialization: JSON data → React element
  static fromJson(jsonData) {
    return jsx(FormBlock, {
      ...jsonData
    });
  }
  // FormBlock components have nested ReactNode children (form content)
  hasNestedComponents(_children) {
    // FormBlock may contain other serializable components as children
    return true;
  }
  // Custom children serialization for FormBlock
  serializeChildren(children) {
    if (/*#__PURE__*/React.isValidElement(children) && children.type.prototype?.toJson) {
      // If it's a serializable component, serialize it
      const childType = children.type;
      return childType.fromJson ? {
        component: childType.tagName,
        props: children.props
      } : children;
    }
    // For non-serializable children (regular JSX), extract text or return as-is
    return super.serializeChildren(children);
  }
  // Component-specific serialization properties
  getComponentSpecificProps() {
    return {
      title: this.props.title,
      description: this.props.description,
      status: this.props.status,
      message: this.props.message,
      maxWidth: this.props.maxWidth,
      background: this.props.background,
      backgroundImage: this.props.backgroundImage
      // header, coverImage, footer are ReactNode (handled by base serialization if needed)
      // children is handled by serializeChildren override
    };
  }
  // FormBlock component renders traditional props view
  renderView() {
    const {
      dataSource: _dataSource,
      bindingOptions: _bindingOptions,
      ...restProps
    } = this.props;
    return jsx(FormBlockView, {
      ...restProps
    });
  }
  // FormBlock component renders data-bound view
  renderWithDataBinding() {
    return jsx(FormBlockWithDataBinding, {
      ...this.props
    });
  }
}
// Component self-declaration for serialization
FormBlock.tagName = 'FormBlock';
FormBlock.version = '1.0.0';
// Helper component to handle data binding with hooks (since we can't use hooks in class components)
function FormBlockWithDataBinding(props) {
  const {
    dataSource,
    bindingOptions,
    ...restProps
  } = props;
  // Use data binding
  const {
    loading,
    error,
    ...formBlockProps
  } = useDataBinding(dataSource, restProps);
  // Show loading state
  if (loading) {
    return jsxs(Paper, {
      variant: "outlined",
      sx: {
        p: 3,
        textAlign: 'center'
      },
      children: [jsx(Typography, {
        variant: "body2",
        children: "Loading Form..."
      }), jsx(Typography, {
        variant: "caption",
        color: "text.secondary",
        children: "Loading form content from data source..."
      })]
    });
  }
  if (error) {
    console.error('Error loading form block:', error);
    return null;
  }
  return jsx(FormBlockView, {
    ...formBlockProps
  });
}
// Mark as QwickApp component
Object.assign(FormBlock, {
  [QWICKAPP_COMPONENT]: true
});

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
	if (typeof f == "function") {
		var a = function a () {
			if (this instanceof a) {
        return Reflect.construct(f, arguments, this.constructor);
			}
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var lib$5 = {};

var Parser$4 = {};

var Tokenizer$1 = {};

var decode = {};

var decodeDataHtml = {};

// Generated using scripts/write-decode-map.ts
Object.defineProperty(decodeDataHtml, "__esModule", { value: true });
decodeDataHtml.default = new Uint16Array(
// prettier-ignore
"\u1d41<\xd5\u0131\u028a\u049d\u057b\u05d0\u0675\u06de\u07a2\u07d6\u080f\u0a4a\u0a91\u0da1\u0e6d\u0f09\u0f26\u10ca\u1228\u12e1\u1415\u149d\u14c3\u14df\u1525\0\0\0\0\0\0\u156b\u16cd\u198d\u1c12\u1ddd\u1f7e\u2060\u21b0\u228d\u23c0\u23fb\u2442\u2824\u2912\u2d08\u2e48\u2fce\u3016\u32ba\u3639\u37ac\u38fe\u3a28\u3a71\u3ae0\u3b2e\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803b\xc6\u40c6P\u803b&\u4026cute\u803b\xc1\u40c1reve;\u4102\u0100iyx}rc\u803b\xc2\u40c2;\u4410r;\uc000\ud835\udd04rave\u803b\xc0\u40c0pha;\u4391acr;\u4100d;\u6a53\u0100gp\x9d\xa1on;\u4104f;\uc000\ud835\udd38plyFunction;\u6061ing\u803b\xc5\u40c5\u0100cs\xbe\xc3r;\uc000\ud835\udc9cign;\u6254ilde\u803b\xc3\u40c3ml\u803b\xc4\u40c4\u0400aceforsu\xe5\xfb\xfe\u0117\u011c\u0122\u0127\u012a\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6ae7ed;\u6306y;\u4411\u0180crt\u0105\u010b\u0114ause;\u6235noullis;\u612ca;\u4392r;\uc000\ud835\udd05pf;\uc000\ud835\udd39eve;\u42d8c\xf2\u0113mpeq;\u624e\u0700HOacdefhilorsu\u014d\u0151\u0156\u0180\u019e\u01a2\u01b5\u01b7\u01ba\u01dc\u0215\u0273\u0278\u027ecy;\u4427PY\u803b\xa9\u40a9\u0180cpy\u015d\u0162\u017aute;\u4106\u0100;i\u0167\u0168\u62d2talDifferentialD;\u6145leys;\u612d\u0200aeio\u0189\u018e\u0194\u0198ron;\u410cdil\u803b\xc7\u40c7rc;\u4108nint;\u6230ot;\u410a\u0100dn\u01a7\u01adilla;\u40b8terDot;\u40b7\xf2\u017fi;\u43a7rcle\u0200DMPT\u01c7\u01cb\u01d1\u01d6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01e2\u01f8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020foubleQuote;\u601duote;\u6019\u0200lnpu\u021e\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6a74\u0180git\u022f\u0236\u023aruent;\u6261nt;\u622fourIntegral;\u622e\u0100fr\u024c\u024e;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6a2fcr;\uc000\ud835\udc9ep\u0100;C\u0284\u0285\u62d3ap;\u624d\u0580DJSZacefios\u02a0\u02ac\u02b0\u02b4\u02b8\u02cb\u02d7\u02e1\u02e6\u0333\u048d\u0100;o\u0179\u02a5trahd;\u6911cy;\u4402cy;\u4405cy;\u440f\u0180grs\u02bf\u02c4\u02c7ger;\u6021r;\u61a1hv;\u6ae4\u0100ay\u02d0\u02d5ron;\u410e;\u4414l\u0100;t\u02dd\u02de\u6207a;\u4394r;\uc000\ud835\udd07\u0100af\u02eb\u0327\u0100cm\u02f0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031ccute;\u40b4o\u0174\u030b\u030d;\u42d9bleAcute;\u42ddrave;\u4060ilde;\u42dcond;\u62c4ferentialD;\u6146\u0470\u033d\0\0\0\u0342\u0354\0\u0405f;\uc000\ud835\udd3b\u0180;DE\u0348\u0349\u034d\u40a8ot;\u60dcqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03cf\u03e2\u03f8ontourIntegra\xec\u0239o\u0274\u0379\0\0\u037b\xbb\u0349nArrow;\u61d3\u0100eo\u0387\u03a4ft\u0180ART\u0390\u0396\u03a1rrow;\u61d0ightArrow;\u61d4e\xe5\u02cang\u0100LR\u03ab\u03c4eft\u0100AR\u03b3\u03b9rrow;\u67f8ightArrow;\u67faightArrow;\u67f9ight\u0100AT\u03d8\u03derrow;\u61d2ee;\u62a8p\u0241\u03e9\0\0\u03efrrow;\u61d1ownArrow;\u61d5erticalBar;\u6225n\u0300ABLRTa\u0412\u042a\u0430\u045e\u047f\u037crrow\u0180;BU\u041d\u041e\u0422\u6193ar;\u6913pArrow;\u61f5reve;\u4311eft\u02d2\u043a\0\u0446\0\u0450ightVector;\u6950eeVector;\u695eector\u0100;B\u0459\u045a\u61bdar;\u6956ight\u01d4\u0467\0\u0471eeVector;\u695fector\u0100;B\u047a\u047b\u61c1ar;\u6957ee\u0100;A\u0486\u0487\u62a4rrow;\u61a7\u0100ct\u0492\u0497r;\uc000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04bd\u04c0\u04c4\u04cb\u04de\u04e2\u04e7\u04ee\u04f5\u0521\u052f\u0536\u0552\u055d\u0560\u0565G;\u414aH\u803b\xd0\u40d0cute\u803b\xc9\u40c9\u0180aiy\u04d2\u04d7\u04dcron;\u411arc\u803b\xca\u40ca;\u442dot;\u4116r;\uc000\ud835\udd08rave\u803b\xc8\u40c8ement;\u6208\u0100ap\u04fa\u04fecr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65fberySmallSquare;\u65ab\u0100gp\u0526\u052aon;\u4118f;\uc000\ud835\udd3csilon;\u4395u\u0100ai\u053c\u0549l\u0100;T\u0542\u0543\u6a75ilde;\u6242librium;\u61cc\u0100ci\u0557\u055ar;\u6130m;\u6a73a;\u4397ml\u803b\xcb\u40cb\u0100ip\u056a\u056fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058d\u05b2\u05ccy;\u4424r;\uc000\ud835\udd09lled\u0253\u0597\0\0\u05a3mallSquare;\u65fcerySmallSquare;\u65aa\u0370\u05ba\0\u05bf\0\0\u05c4f;\uc000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05cb\u0600JTabcdfgorst\u05e8\u05ec\u05ef\u05fa\u0600\u0612\u0616\u061b\u061d\u0623\u066c\u0672cy;\u4403\u803b>\u403emma\u0100;d\u05f7\u05f8\u4393;\u43dcreve;\u411e\u0180eiy\u0607\u060c\u0610dil;\u4122rc;\u411c;\u4413ot;\u4120r;\uc000\ud835\udd0a;\u62d9pf;\uc000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064e\u0656\u065b\u0666qual\u0100;L\u063e\u063f\u6265ess;\u62dbullEqual;\u6267reater;\u6aa2ess;\u6277lantEqual;\u6a7eilde;\u6273cr;\uc000\ud835\udca2;\u626b\u0400Aacfiosu\u0685\u068b\u0696\u069b\u069e\u06aa\u06be\u06caRDcy;\u442a\u0100ct\u0690\u0694ek;\u42c7;\u405eirc;\u4124r;\u610clbertSpace;\u610b\u01f0\u06af\0\u06b2f;\u610dizontalLine;\u6500\u0100ct\u06c3\u06c5\xf2\u06a9rok;\u4126mp\u0144\u06d0\u06d8ownHum\xf0\u012fqual;\u624f\u0700EJOacdfgmnostu\u06fa\u06fe\u0703\u0707\u070e\u071a\u071e\u0721\u0728\u0744\u0778\u078b\u078f\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803b\xcd\u40cd\u0100iy\u0713\u0718rc\u803b\xce\u40ce;\u4418ot;\u4130r;\u6111rave\u803b\xcc\u40cc\u0180;ap\u0720\u072f\u073f\u0100cg\u0734\u0737r;\u412ainaryI;\u6148lie\xf3\u03dd\u01f4\u0749\0\u0762\u0100;e\u074d\u074e\u622c\u0100gr\u0753\u0758ral;\u622bsection;\u62c2isible\u0100CT\u076c\u0772omma;\u6063imes;\u6062\u0180gpt\u077f\u0783\u0788on;\u412ef;\uc000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01eb\u079a\0\u079ecy;\u4406l\u803b\xcf\u40cf\u0280cfosu\u07ac\u07b7\u07bc\u07c2\u07d0\u0100iy\u07b1\u07b5rc;\u4134;\u4419r;\uc000\ud835\udd0dpf;\uc000\ud835\udd41\u01e3\u07c7\0\u07ccr;\uc000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07e4\u07e8\u07ec\u07f1\u07fd\u0802\u0808cy;\u4425cy;\u440cppa;\u439a\u0100ey\u07f6\u07fbdil;\u4136;\u441ar;\uc000\ud835\udd0epf;\uc000\ud835\udd42cr;\uc000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082c\u0850\u0863\u09b3\u09b8\u09c7\u09cd\u0a37\u0a47cy;\u4409\u803b<\u403c\u0280cmnpr\u0837\u083c\u0841\u0844\u084dute;\u4139bda;\u439bg;\u67ealacetrf;\u6112r;\u619e\u0180aey\u0857\u085c\u0861ron;\u413ddil;\u413b;\u441b\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087e\u08a9\u08b1\u08e0\u08e6\u08fc\u092f\u095b\u0390\u096a\u0100nr\u0883\u088fgleBracket;\u67e8row\u0180;BR\u0899\u089a\u089e\u6190ar;\u61e4ightArrow;\u61c6eiling;\u6308o\u01f5\u08b7\0\u08c3bleBracket;\u67e6n\u01d4\u08c8\0\u08d2eeVector;\u6961ector\u0100;B\u08db\u08dc\u61c3ar;\u6959loor;\u630aight\u0100AV\u08ef\u08f5rrow;\u6194ector;\u694e\u0100er\u0901\u0917e\u0180;AV\u0909\u090a\u0910\u62a3rrow;\u61a4ector;\u695aiangle\u0180;BE\u0924\u0925\u0929\u62b2ar;\u69cfqual;\u62b4p\u0180DTV\u0937\u0942\u094cownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61bfar;\u6958ector\u0100;B\u0965\u0966\u61bcar;\u6952ight\xe1\u039cs\u0300EFGLST\u097e\u098b\u0995\u099d\u09a2\u09adqualGreater;\u62daullEqual;\u6266reater;\u6276ess;\u6aa1lantEqual;\u6a7dilde;\u6272r;\uc000\ud835\udd0f\u0100;e\u09bd\u09be\u62d8ftarrow;\u61daidot;\u413f\u0180npw\u09d4\u0a16\u0a1bg\u0200LRlr\u09de\u09f7\u0a02\u0a10eft\u0100AR\u09e6\u09ecrrow;\u67f5ightArrow;\u67f7ightArrow;\u67f6eft\u0100ar\u03b3\u0a0aight\xe1\u03bfight\xe1\u03caf;\uc000\ud835\udd43er\u0100LR\u0a22\u0a2ceftArrow;\u6199ightArrow;\u6198\u0180cht\u0a3e\u0a40\u0a42\xf2\u084c;\u61b0rok;\u4141;\u626a\u0400acefiosu\u0a5a\u0a5d\u0a60\u0a77\u0a7c\u0a85\u0a8b\u0a8ep;\u6905y;\u441c\u0100dl\u0a65\u0a6fiumSpace;\u605flintrf;\u6133r;\uc000\ud835\udd10nusPlus;\u6213pf;\uc000\ud835\udd44c\xf2\u0a76;\u439c\u0480Jacefostu\u0aa3\u0aa7\u0aad\u0ac0\u0b14\u0b19\u0d91\u0d97\u0d9ecy;\u440acute;\u4143\u0180aey\u0ab4\u0ab9\u0aberon;\u4147dil;\u4145;\u441d\u0180gsw\u0ac7\u0af0\u0b0eative\u0180MTV\u0ad3\u0adf\u0ae8ediumSpace;\u600bhi\u0100cn\u0ae6\u0ad8\xeb\u0ad9eryThi\xee\u0ad9ted\u0100GL\u0af8\u0b06reaterGreate\xf2\u0673essLes\xf3\u0a48Line;\u400ar;\uc000\ud835\udd11\u0200Bnpt\u0b22\u0b28\u0b37\u0b3areak;\u6060BreakingSpace;\u40a0f;\u6115\u0680;CDEGHLNPRSTV\u0b55\u0b56\u0b6a\u0b7c\u0ba1\u0beb\u0c04\u0c5e\u0c84\u0ca6\u0cd8\u0d61\u0d85\u6aec\u0100ou\u0b5b\u0b64ngruent;\u6262pCap;\u626doubleVerticalBar;\u6226\u0180lqx\u0b83\u0b8a\u0b9bement;\u6209ual\u0100;T\u0b92\u0b93\u6260ilde;\uc000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0bb6\u0bb7\u0bbd\u0bc9\u0bd3\u0bd8\u0be5\u626fqual;\u6271ullEqual;\uc000\u2267\u0338reater;\uc000\u226b\u0338ess;\u6279lantEqual;\uc000\u2a7e\u0338ilde;\u6275ump\u0144\u0bf2\u0bfdownHump;\uc000\u224e\u0338qual;\uc000\u224f\u0338e\u0100fs\u0c0a\u0c27tTriangle\u0180;BE\u0c1a\u0c1b\u0c21\u62eaar;\uc000\u29cf\u0338qual;\u62ecs\u0300;EGLST\u0c35\u0c36\u0c3c\u0c44\u0c4b\u0c58\u626equal;\u6270reater;\u6278ess;\uc000\u226a\u0338lantEqual;\uc000\u2a7d\u0338ilde;\u6274ested\u0100GL\u0c68\u0c79reaterGreater;\uc000\u2aa2\u0338essLess;\uc000\u2aa1\u0338recedes\u0180;ES\u0c92\u0c93\u0c9b\u6280qual;\uc000\u2aaf\u0338lantEqual;\u62e0\u0100ei\u0cab\u0cb9verseElement;\u620cghtTriangle\u0180;BE\u0ccb\u0ccc\u0cd2\u62ebar;\uc000\u29d0\u0338qual;\u62ed\u0100qu\u0cdd\u0d0cuareSu\u0100bp\u0ce8\u0cf9set\u0100;E\u0cf0\u0cf3\uc000\u228f\u0338qual;\u62e2erset\u0100;E\u0d03\u0d06\uc000\u2290\u0338qual;\u62e3\u0180bcp\u0d13\u0d24\u0d4eset\u0100;E\u0d1b\u0d1e\uc000\u2282\u20d2qual;\u6288ceeds\u0200;EST\u0d32\u0d33\u0d3b\u0d46\u6281qual;\uc000\u2ab0\u0338lantEqual;\u62e1ilde;\uc000\u227f\u0338erset\u0100;E\u0d58\u0d5b\uc000\u2283\u20d2qual;\u6289ilde\u0200;EFT\u0d6e\u0d6f\u0d75\u0d7f\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uc000\ud835\udca9ilde\u803b\xd1\u40d1;\u439d\u0700Eacdfgmoprstuv\u0dbd\u0dc2\u0dc9\u0dd5\u0ddb\u0de0\u0de7\u0dfc\u0e02\u0e20\u0e22\u0e32\u0e3f\u0e44lig;\u4152cute\u803b\xd3\u40d3\u0100iy\u0dce\u0dd3rc\u803b\xd4\u40d4;\u441eblac;\u4150r;\uc000\ud835\udd12rave\u803b\xd2\u40d2\u0180aei\u0dee\u0df2\u0df6cr;\u414cga;\u43a9cron;\u439fpf;\uc000\ud835\udd46enCurly\u0100DQ\u0e0e\u0e1aoubleQuote;\u601cuote;\u6018;\u6a54\u0100cl\u0e27\u0e2cr;\uc000\ud835\udcaaash\u803b\xd8\u40d8i\u016c\u0e37\u0e3cde\u803b\xd5\u40d5es;\u6a37ml\u803b\xd6\u40d6er\u0100BP\u0e4b\u0e60\u0100ar\u0e50\u0e53r;\u603eac\u0100ek\u0e5a\u0e5c;\u63deet;\u63b4arenthesis;\u63dc\u0480acfhilors\u0e7f\u0e87\u0e8a\u0e8f\u0e92\u0e94\u0e9d\u0eb0\u0efcrtialD;\u6202y;\u441fr;\uc000\ud835\udd13i;\u43a6;\u43a0usMinus;\u40b1\u0100ip\u0ea2\u0eadncareplan\xe5\u069df;\u6119\u0200;eio\u0eb9\u0eba\u0ee0\u0ee4\u6abbcedes\u0200;EST\u0ec8\u0ec9\u0ecf\u0eda\u627aqual;\u6aaflantEqual;\u627cilde;\u627eme;\u6033\u0100dp\u0ee9\u0eeeuct;\u620fortion\u0100;a\u0225\u0ef9l;\u621d\u0100ci\u0f01\u0f06r;\uc000\ud835\udcab;\u43a8\u0200Ufos\u0f11\u0f16\u0f1b\u0f1fOT\u803b\"\u4022r;\uc000\ud835\udd14pf;\u611acr;\uc000\ud835\udcac\u0600BEacefhiorsu\u0f3e\u0f43\u0f47\u0f60\u0f73\u0fa7\u0faa\u0fad\u1096\u10a9\u10b4\u10bearr;\u6910G\u803b\xae\u40ae\u0180cnr\u0f4e\u0f53\u0f56ute;\u4154g;\u67ebr\u0100;t\u0f5c\u0f5d\u61a0l;\u6916\u0180aey\u0f67\u0f6c\u0f71ron;\u4158dil;\u4156;\u4420\u0100;v\u0f78\u0f79\u611cerse\u0100EU\u0f82\u0f99\u0100lq\u0f87\u0f8eement;\u620builibrium;\u61cbpEquilibrium;\u696fr\xbb\u0f79o;\u43a1ght\u0400ACDFTUVa\u0fc1\u0feb\u0ff3\u1022\u1028\u105b\u1087\u03d8\u0100nr\u0fc6\u0fd2gleBracket;\u67e9row\u0180;BL\u0fdc\u0fdd\u0fe1\u6192ar;\u61e5eftArrow;\u61c4eiling;\u6309o\u01f5\u0ff9\0\u1005bleBracket;\u67e7n\u01d4\u100a\0\u1014eeVector;\u695dector\u0100;B\u101d\u101e\u61c2ar;\u6955loor;\u630b\u0100er\u102d\u1043e\u0180;AV\u1035\u1036\u103c\u62a2rrow;\u61a6ector;\u695biangle\u0180;BE\u1050\u1051\u1055\u62b3ar;\u69d0qual;\u62b5p\u0180DTV\u1063\u106e\u1078ownVector;\u694feeVector;\u695cector\u0100;B\u1082\u1083\u61bear;\u6954ector\u0100;B\u1091\u1092\u61c0ar;\u6953\u0100pu\u109b\u109ef;\u611dndImplies;\u6970ightarrow;\u61db\u0100ch\u10b9\u10bcr;\u611b;\u61b1leDelayed;\u69f4\u0680HOacfhimoqstu\u10e4\u10f1\u10f7\u10fd\u1119\u111e\u1151\u1156\u1161\u1167\u11b5\u11bb\u11bf\u0100Cc\u10e9\u10eeHcy;\u4429y;\u4428FTcy;\u442ccute;\u415a\u0280;aeiy\u1108\u1109\u110e\u1113\u1117\u6abcron;\u4160dil;\u415erc;\u415c;\u4421r;\uc000\ud835\udd16ort\u0200DLRU\u112a\u1134\u113e\u1149ownArrow\xbb\u041eeftArrow\xbb\u089aightArrow\xbb\u0fddpArrow;\u6191gma;\u43a3allCircle;\u6218pf;\uc000\ud835\udd4a\u0272\u116d\0\0\u1170t;\u621aare\u0200;ISU\u117b\u117c\u1189\u11af\u65a1ntersection;\u6293u\u0100bp\u118f\u119eset\u0100;E\u1197\u1198\u628fqual;\u6291erset\u0100;E\u11a8\u11a9\u6290qual;\u6292nion;\u6294cr;\uc000\ud835\udcaear;\u62c6\u0200bcmp\u11c8\u11db\u1209\u120b\u0100;s\u11cd\u11ce\u62d0et\u0100;E\u11cd\u11d5qual;\u6286\u0100ch\u11e0\u1205eeds\u0200;EST\u11ed\u11ee\u11f4\u11ff\u627bqual;\u6ab0lantEqual;\u627dilde;\u627fTh\xe1\u0f8c;\u6211\u0180;es\u1212\u1213\u1223\u62d1rset\u0100;E\u121c\u121d\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123e\u1244\u1249\u1255\u125e\u1271\u1276\u129f\u12c2\u12c8\u12d1ORN\u803b\xde\u40deADE;\u6122\u0100Hc\u124e\u1252cy;\u440by;\u4426\u0100bu\u125a\u125c;\u4009;\u43a4\u0180aey\u1265\u126a\u126fron;\u4164dil;\u4162;\u4422r;\uc000\ud835\udd17\u0100ei\u127b\u1289\u01f2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128e\u1298kSpace;\uc000\u205f\u200aSpace;\u6009lde\u0200;EFT\u12ab\u12ac\u12b2\u12bc\u623cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uc000\ud835\udd4bipleDot;\u60db\u0100ct\u12d6\u12dbr;\uc000\ud835\udcafrok;\u4166\u0ae1\u12f7\u130e\u131a\u1326\0\u132c\u1331\0\0\0\0\0\u1338\u133d\u1377\u1385\0\u13ff\u1404\u140a\u1410\u0100cr\u12fb\u1301ute\u803b\xda\u40dar\u0100;o\u1307\u1308\u619fcir;\u6949r\u01e3\u1313\0\u1316y;\u440eve;\u416c\u0100iy\u131e\u1323rc\u803b\xdb\u40db;\u4423blac;\u4170r;\uc000\ud835\udd18rave\u803b\xd9\u40d9acr;\u416a\u0100di\u1341\u1369er\u0100BP\u1348\u135d\u0100ar\u134d\u1350r;\u405fac\u0100ek\u1357\u1359;\u63dfet;\u63b5arenthesis;\u63ddon\u0100;P\u1370\u1371\u62c3lus;\u628e\u0100gp\u137b\u137fon;\u4172f;\uc000\ud835\udd4c\u0400ADETadps\u1395\u13ae\u13b8\u13c4\u03e8\u13d2\u13d7\u13f3rrow\u0180;BD\u1150\u13a0\u13a4ar;\u6912ownArrow;\u61c5ownArrow;\u6195quilibrium;\u696eee\u0100;A\u13cb\u13cc\u62a5rrow;\u61a5own\xe1\u03f3er\u0100LR\u13de\u13e8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13f9\u13fa\u43d2on;\u43a5ing;\u416ecr;\uc000\ud835\udcb0ilde;\u4168ml\u803b\xdc\u40dc\u0480Dbcdefosv\u1427\u142c\u1430\u1433\u143e\u1485\u148a\u1490\u1496ash;\u62abar;\u6aeby;\u4412ash\u0100;l\u143b\u143c\u62a9;\u6ae6\u0100er\u1443\u1445;\u62c1\u0180bty\u144c\u1450\u147aar;\u6016\u0100;i\u144f\u1455cal\u0200BLST\u1461\u1465\u146a\u1474ar;\u6223ine;\u407ceparator;\u6758ilde;\u6240ThinSpace;\u600ar;\uc000\ud835\udd19pf;\uc000\ud835\udd4dcr;\uc000\ud835\udcb1dash;\u62aa\u0280cefos\u14a7\u14ac\u14b1\u14b6\u14bcirc;\u4174dge;\u62c0r;\uc000\ud835\udd1apf;\uc000\ud835\udd4ecr;\uc000\ud835\udcb2\u0200fios\u14cb\u14d0\u14d2\u14d8r;\uc000\ud835\udd1b;\u439epf;\uc000\ud835\udd4fcr;\uc000\ud835\udcb3\u0480AIUacfosu\u14f1\u14f5\u14f9\u14fd\u1504\u150f\u1514\u151a\u1520cy;\u442fcy;\u4407cy;\u442ecute\u803b\xdd\u40dd\u0100iy\u1509\u150drc;\u4176;\u442br;\uc000\ud835\udd1cpf;\uc000\ud835\udd50cr;\uc000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153f\u154b\u154f\u155d\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417d;\u4417ot;\u417b\u01f2\u1554\0\u155boWidt\xe8\u0ad9a;\u4396r;\u6128pf;\u6124cr;\uc000\ud835\udcb5\u0be1\u1583\u158a\u1590\0\u15b0\u15b6\u15bf\0\0\0\0\u15c6\u15db\u15eb\u165f\u166d\0\u1695\u169b\u16b2\u16b9\0\u16becute\u803b\xe1\u40e1reve;\u4103\u0300;Ediuy\u159c\u159d\u15a1\u15a3\u15a8\u15ad\u623e;\uc000\u223e\u0333;\u623frc\u803b\xe2\u40e2te\u80bb\xb4\u0306;\u4430lig\u803b\xe6\u40e6\u0100;r\xb2\u15ba;\uc000\ud835\udd1erave\u803b\xe0\u40e0\u0100ep\u15ca\u15d6\u0100fp\u15cf\u15d4sym;\u6135\xe8\u15d3ha;\u43b1\u0100ap\u15dfc\u0100cl\u15e4\u15e7r;\u4101g;\u6a3f\u0264\u15f0\0\0\u160a\u0280;adsv\u15fa\u15fb\u15ff\u1601\u1607\u6227nd;\u6a55;\u6a5clope;\u6a58;\u6a5a\u0380;elmrsz\u1618\u1619\u161b\u161e\u163f\u164f\u1659\u6220;\u69a4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163a\u163c\u163e;\u69a8;\u69a9;\u69aa;\u69ab;\u69ac;\u69ad;\u69ae;\u69aft\u0100;v\u1645\u1646\u621fb\u0100;d\u164c\u164d\u62be;\u699d\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637c\u0100gp\u1663\u1667on;\u4105f;\uc000\ud835\udd52\u0380;Eaeiop\u12c1\u167b\u167d\u1682\u1684\u1687\u168a;\u6a70cir;\u6a6f;\u624ad;\u624bs;\u4027rox\u0100;e\u12c1\u1692\xf1\u1683ing\u803b\xe5\u40e5\u0180cty\u16a1\u16a6\u16a8r;\uc000\ud835\udcb6;\u402amp\u0100;e\u12c1\u16af\xf1\u0288ilde\u803b\xe3\u40e3ml\u803b\xe4\u40e4\u0100ci\u16c2\u16c8onin\xf4\u0272nt;\u6a11\u0800Nabcdefiklnoprsu\u16ed\u16f1\u1730\u173c\u1743\u1748\u1778\u177d\u17e0\u17e6\u1839\u1850\u170d\u193d\u1948\u1970ot;\u6aed\u0100cr\u16f6\u171ek\u0200ceps\u1700\u1705\u170d\u1713ong;\u624cpsilon;\u43f6rime;\u6035im\u0100;e\u171a\u171b\u623dq;\u62cd\u0176\u1722\u1726ee;\u62bded\u0100;g\u172c\u172d\u6305e\xbb\u172drk\u0100;t\u135c\u1737brk;\u63b6\u0100oy\u1701\u1741;\u4431quo;\u601e\u0280cmprt\u1753\u175b\u1761\u1764\u1768aus\u0100;e\u010a\u0109ptyv;\u69b0s\xe9\u170cno\xf5\u0113\u0180ahw\u176f\u1771\u1773;\u43b2;\u6136een;\u626cr;\uc000\ud835\udd1fg\u0380costuvw\u178d\u179d\u17b3\u17c1\u17d5\u17db\u17de\u0180aiu\u1794\u1796\u179a\xf0\u0760rc;\u65efp\xbb\u1371\u0180dpt\u17a4\u17a8\u17adot;\u6a00lus;\u6a01imes;\u6a02\u0271\u17b9\0\0\u17becup;\u6a06ar;\u6605riangle\u0100du\u17cd\u17d2own;\u65bdp;\u65b3plus;\u6a04e\xe5\u1444\xe5\u14adarow;\u690d\u0180ako\u17ed\u1826\u1835\u0100cn\u17f2\u1823k\u0180lst\u17fa\u05ab\u1802ozenge;\u69ebriangle\u0200;dlr\u1812\u1813\u1818\u181d\u65b4own;\u65beeft;\u65c2ight;\u65b8k;\u6423\u01b1\u182b\0\u1833\u01b2\u182f\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183e\u184d\u0100;q\u1843\u1846\uc000=\u20e5uiv;\uc000\u2261\u20e5t;\u6310\u0200ptwx\u1859\u185e\u1867\u186cf;\uc000\ud835\udd53\u0100;t\u13cb\u1863om\xbb\u13cctie;\u62c8\u0600DHUVbdhmptuv\u1885\u1896\u18aa\u18bb\u18d7\u18db\u18ec\u18ff\u1905\u190a\u1910\u1921\u0200LRlr\u188e\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18a1\u18a2\u18a4\u18a6\u18a8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18b3\u18b5\u18b7\u18b9;\u655d;\u655a;\u655c;\u6559\u0380;HLRhlr\u18ca\u18cb\u18cd\u18cf\u18d1\u18d3\u18d5\u6551;\u656c;\u6563;\u6560;\u656b;\u6562;\u655fox;\u69c9\u0200LRlr\u18e4\u18e6\u18e8\u18ea;\u6555;\u6552;\u6510;\u650c\u0280;DUdu\u06bd\u18f7\u18f9\u18fb\u18fd;\u6565;\u6568;\u652c;\u6534inus;\u629flus;\u629eimes;\u62a0\u0200LRlr\u1919\u191b\u191d\u191f;\u655b;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193b\u6502;\u656a;\u6561;\u655e;\u653c;\u6524;\u651c\u0100ev\u0123\u1942bar\u803b\xa6\u40a6\u0200ceio\u1951\u1956\u195a\u1960r;\uc000\ud835\udcb7mi;\u604fm\u0100;e\u171a\u171cl\u0180;bh\u1968\u1969\u196b\u405c;\u69c5sub;\u67c8\u016c\u1974\u197el\u0100;e\u1979\u197a\u6022t\xbb\u197ap\u0180;Ee\u012f\u1985\u1987;\u6aae\u0100;q\u06dc\u06db\u0ce1\u19a7\0\u19e8\u1a11\u1a15\u1a32\0\u1a37\u1a50\0\0\u1ab4\0\0\u1ac1\0\0\u1b21\u1b2e\u1b4d\u1b52\0\u1bfd\0\u1c0c\u0180cpr\u19ad\u19b2\u19ddute;\u4107\u0300;abcds\u19bf\u19c0\u19c4\u19ca\u19d5\u19d9\u6229nd;\u6a44rcup;\u6a49\u0100au\u19cf\u19d2p;\u6a4bp;\u6a47ot;\u6a40;\uc000\u2229\ufe00\u0100eo\u19e2\u19e5t;\u6041\xee\u0693\u0200aeiu\u19f0\u19fb\u1a01\u1a05\u01f0\u19f5\0\u19f8s;\u6a4don;\u410ddil\u803b\xe7\u40e7rc;\u4109ps\u0100;s\u1a0c\u1a0d\u6a4cm;\u6a50ot;\u410b\u0180dmn\u1a1b\u1a20\u1a26il\u80bb\xb8\u01adptyv;\u69b2t\u8100\xa2;e\u1a2d\u1a2e\u40a2r\xe4\u01b2r;\uc000\ud835\udd20\u0180cei\u1a3d\u1a40\u1a4dy;\u4447ck\u0100;m\u1a47\u1a48\u6713ark\xbb\u1a48;\u43c7r\u0380;Ecefms\u1a5f\u1a60\u1a62\u1a6b\u1aa4\u1aaa\u1aae\u65cb;\u69c3\u0180;el\u1a69\u1a6a\u1a6d\u42c6q;\u6257e\u0261\u1a74\0\0\u1a88rrow\u0100lr\u1a7c\u1a81eft;\u61baight;\u61bb\u0280RSacd\u1a92\u1a94\u1a96\u1a9a\u1a9f\xbb\u0f47;\u64c8st;\u629birc;\u629aash;\u629dnint;\u6a10id;\u6aefcir;\u69c2ubs\u0100;u\u1abb\u1abc\u6663it\xbb\u1abc\u02ec\u1ac7\u1ad4\u1afa\0\u1b0aon\u0100;e\u1acd\u1ace\u403a\u0100;q\xc7\xc6\u026d\u1ad9\0\0\u1ae2a\u0100;t\u1ade\u1adf\u402c;\u4040\u0180;fl\u1ae8\u1ae9\u1aeb\u6201\xee\u1160e\u0100mx\u1af1\u1af6ent\xbb\u1ae9e\xf3\u024d\u01e7\u1afe\0\u1b07\u0100;d\u12bb\u1b02ot;\u6a6dn\xf4\u0246\u0180fry\u1b10\u1b14\u1b17;\uc000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1b1dr;\u6117\u0100ao\u1b25\u1b29rr;\u61b5ss;\u6717\u0100cu\u1b32\u1b37r;\uc000\ud835\udcb8\u0100bp\u1b3c\u1b44\u0100;e\u1b41\u1b42\u6acf;\u6ad1\u0100;e\u1b49\u1b4a\u6ad0;\u6ad2dot;\u62ef\u0380delprvw\u1b60\u1b6c\u1b77\u1b82\u1bac\u1bd4\u1bf9arr\u0100lr\u1b68\u1b6a;\u6938;\u6935\u0270\u1b72\0\0\u1b75r;\u62dec;\u62dfarr\u0100;p\u1b7f\u1b80\u61b6;\u693d\u0300;bcdos\u1b8f\u1b90\u1b96\u1ba1\u1ba5\u1ba8\u622arcap;\u6a48\u0100au\u1b9b\u1b9ep;\u6a46p;\u6a4aot;\u628dr;\u6a45;\uc000\u222a\ufe00\u0200alrv\u1bb5\u1bbf\u1bde\u1be3rr\u0100;m\u1bbc\u1bbd\u61b7;\u693cy\u0180evw\u1bc7\u1bd4\u1bd8q\u0270\u1bce\0\0\u1bd2re\xe3\u1b73u\xe3\u1b75ee;\u62ceedge;\u62cfen\u803b\xa4\u40a4earrow\u0100lr\u1bee\u1bf3eft\xbb\u1b80ight\xbb\u1bbde\xe4\u1bdd\u0100ci\u1c01\u1c07onin\xf4\u01f7nt;\u6231lcty;\u632d\u0980AHabcdefhijlorstuwz\u1c38\u1c3b\u1c3f\u1c5d\u1c69\u1c75\u1c8a\u1c9e\u1cac\u1cb7\u1cfb\u1cff\u1d0d\u1d7b\u1d91\u1dab\u1dbb\u1dc6\u1dcdr\xf2\u0381ar;\u6965\u0200glrs\u1c48\u1c4d\u1c52\u1c54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1c5a\u1c5b\u6010\xbb\u090a\u016b\u1c61\u1c67arow;\u690fa\xe3\u0315\u0100ay\u1c6e\u1c73ron;\u410f;\u4434\u0180;ao\u0332\u1c7c\u1c84\u0100gr\u02bf\u1c81r;\u61catseq;\u6a77\u0180glm\u1c91\u1c94\u1c98\u803b\xb0\u40b0ta;\u43b4ptyv;\u69b1\u0100ir\u1ca3\u1ca8sht;\u697f;\uc000\ud835\udd21ar\u0100lr\u1cb3\u1cb5\xbb\u08dc\xbb\u101e\u0280aegsv\u1cc2\u0378\u1cd6\u1cdc\u1ce0m\u0180;os\u0326\u1cca\u1cd4nd\u0100;s\u0326\u1cd1uit;\u6666amma;\u43ddin;\u62f2\u0180;io\u1ce7\u1ce8\u1cf8\u40f7de\u8100\xf7;o\u1ce7\u1cf0ntimes;\u62c7n\xf8\u1cf7cy;\u4452c\u026f\u1d06\0\0\u1d0arn;\u631eop;\u630d\u0280lptuw\u1d18\u1d1d\u1d22\u1d49\u1d55lar;\u4024f;\uc000\ud835\udd55\u0280;emps\u030b\u1d2d\u1d37\u1d3d\u1d42q\u0100;d\u0352\u1d33ot;\u6251inus;\u6238lus;\u6214quare;\u62a1blebarwedg\xe5\xfan\u0180adh\u112e\u1d5d\u1d67ownarrow\xf3\u1c83arpoon\u0100lr\u1d72\u1d76ef\xf4\u1cb4igh\xf4\u1cb6\u0162\u1d7f\u1d85karo\xf7\u0f42\u026f\u1d8a\0\0\u1d8ern;\u631fop;\u630c\u0180cot\u1d98\u1da3\u1da6\u0100ry\u1d9d\u1da1;\uc000\ud835\udcb9;\u4455l;\u69f6rok;\u4111\u0100dr\u1db0\u1db4ot;\u62f1i\u0100;f\u1dba\u1816\u65bf\u0100ah\u1dc0\u1dc3r\xf2\u0429a\xf2\u0fa6angle;\u69a6\u0100ci\u1dd2\u1dd5y;\u445fgrarr;\u67ff\u0900Dacdefglmnopqrstux\u1e01\u1e09\u1e19\u1e38\u0578\u1e3c\u1e49\u1e61\u1e7e\u1ea5\u1eaf\u1ebd\u1ee1\u1f2a\u1f37\u1f44\u1f4e\u1f5a\u0100Do\u1e06\u1d34o\xf4\u1c89\u0100cs\u1e0e\u1e14ute\u803b\xe9\u40e9ter;\u6a6e\u0200aioy\u1e22\u1e27\u1e31\u1e36ron;\u411br\u0100;c\u1e2d\u1e2e\u6256\u803b\xea\u40ealon;\u6255;\u444dot;\u4117\u0100Dr\u1e41\u1e45ot;\u6252;\uc000\ud835\udd22\u0180;rs\u1e50\u1e51\u1e57\u6a9aave\u803b\xe8\u40e8\u0100;d\u1e5c\u1e5d\u6a96ot;\u6a98\u0200;ils\u1e6a\u1e6b\u1e72\u1e74\u6a99nters;\u63e7;\u6113\u0100;d\u1e79\u1e7a\u6a95ot;\u6a97\u0180aps\u1e85\u1e89\u1e97cr;\u4113ty\u0180;sv\u1e92\u1e93\u1e95\u6205et\xbb\u1e93p\u01001;\u1e9d\u1ea4\u0133\u1ea1\u1ea3;\u6004;\u6005\u6003\u0100gs\u1eaa\u1eac;\u414bp;\u6002\u0100gp\u1eb4\u1eb8on;\u4119f;\uc000\ud835\udd56\u0180als\u1ec4\u1ece\u1ed2r\u0100;s\u1eca\u1ecb\u62d5l;\u69e3us;\u6a71i\u0180;lv\u1eda\u1edb\u1edf\u43b5on\xbb\u1edb;\u43f5\u0200csuv\u1eea\u1ef3\u1f0b\u1f23\u0100io\u1eef\u1e31rc\xbb\u1e2e\u0269\u1ef9\0\0\u1efb\xed\u0548ant\u0100gl\u1f02\u1f06tr\xbb\u1e5dess\xbb\u1e7a\u0180aei\u1f12\u1f16\u1f1als;\u403dst;\u625fv\u0100;D\u0235\u1f20D;\u6a78parsl;\u69e5\u0100Da\u1f2f\u1f33ot;\u6253rr;\u6971\u0180cdi\u1f3e\u1f41\u1ef8r;\u612fo\xf4\u0352\u0100ah\u1f49\u1f4b;\u43b7\u803b\xf0\u40f0\u0100mr\u1f53\u1f57l\u803b\xeb\u40ebo;\u60ac\u0180cip\u1f61\u1f64\u1f67l;\u4021s\xf4\u056e\u0100eo\u1f6c\u1f74ctatio\xee\u0559nential\xe5\u0579\u09e1\u1f92\0\u1f9e\0\u1fa1\u1fa7\0\0\u1fc6\u1fcc\0\u1fd3\0\u1fe6\u1fea\u2000\0\u2008\u205allingdotse\xf1\u1e44y;\u4444male;\u6640\u0180ilr\u1fad\u1fb3\u1fc1lig;\u8000\ufb03\u0269\u1fb9\0\0\u1fbdg;\u8000\ufb00ig;\u8000\ufb04;\uc000\ud835\udd23lig;\u8000\ufb01lig;\uc000fj\u0180alt\u1fd9\u1fdc\u1fe1t;\u666dig;\u8000\ufb02ns;\u65b1of;\u4192\u01f0\u1fee\0\u1ff3f;\uc000\ud835\udd57\u0100ak\u05bf\u1ff7\u0100;v\u1ffc\u1ffd\u62d4;\u6ad9artint;\u6a0d\u0100ao\u200c\u2055\u0100cs\u2011\u2052\u03b1\u201a\u2030\u2038\u2045\u2048\0\u2050\u03b2\u2022\u2025\u2027\u202a\u202c\0\u202e\u803b\xbd\u40bd;\u6153\u803b\xbc\u40bc;\u6155;\u6159;\u615b\u01b3\u2034\0\u2036;\u6154;\u6156\u02b4\u203e\u2041\0\0\u2043\u803b\xbe\u40be;\u6157;\u615c5;\u6158\u01b6\u204c\0\u204e;\u615a;\u615d8;\u615el;\u6044wn;\u6322cr;\uc000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209f\u20a5\u20b0\u20b4\u20f0\u20f5\u20fa\u20ff\u2103\u2112\u2138\u0317\u213e\u2152\u219e\u0100;l\u064d\u2087;\u6a8c\u0180cmp\u2090\u2095\u209dute;\u41f5ma\u0100;d\u209c\u1cda\u43b3;\u6a86reve;\u411f\u0100iy\u20aa\u20aerc;\u411d;\u4433ot;\u4121\u0200;lqs\u063e\u0642\u20bd\u20c9\u0180;qs\u063e\u064c\u20c4lan\xf4\u0665\u0200;cdl\u0665\u20d2\u20d5\u20e5c;\u6aa9ot\u0100;o\u20dc\u20dd\u6a80\u0100;l\u20e2\u20e3\u6a82;\u6a84\u0100;e\u20ea\u20ed\uc000\u22db\ufe00s;\u6a94r;\uc000\ud835\udd24\u0100;g\u0673\u061bmel;\u6137cy;\u4453\u0200;Eaj\u065a\u210c\u210e\u2110;\u6a92;\u6aa5;\u6aa4\u0200Eaes\u211b\u211d\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6a8arox\xbb\u2124\u0100;q\u212e\u212f\u6a88\u0100;q\u212e\u211bim;\u62e7pf;\uc000\ud835\udd58\u0100ci\u2143\u2146r;\u610am\u0180;el\u066b\u214e\u2150;\u6a8e;\u6a90\u8300>;cdlqr\u05ee\u2160\u216a\u216e\u2173\u2179\u0100ci\u2165\u2167;\u6aa7r;\u6a7aot;\u62d7Par;\u6995uest;\u6a7c\u0280adels\u2184\u216a\u2190\u0656\u219b\u01f0\u2189\0\u218epro\xf8\u209er;\u6978q\u0100lq\u063f\u2196les\xf3\u2088i\xed\u066b\u0100en\u21a3\u21adrtneqq;\uc000\u2269\ufe00\xc5\u21aa\u0500Aabcefkosy\u21c4\u21c7\u21f1\u21f5\u21fa\u2218\u221d\u222f\u2268\u227dr\xf2\u03a0\u0200ilmr\u21d0\u21d4\u21d7\u21dbrs\xf0\u1484f\xbb\u2024il\xf4\u06a9\u0100dr\u21e0\u21e4cy;\u444a\u0180;cw\u08f4\u21eb\u21efir;\u6948;\u61adar;\u610firc;\u4125\u0180alr\u2201\u220e\u2213rts\u0100;u\u2209\u220a\u6665it\xbb\u220alip;\u6026con;\u62b9r;\uc000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223a\u223e\u2243\u225e\u2263rr;\u61fftht;\u623bk\u0100lr\u2249\u2253eftarrow;\u61a9ightarrow;\u61aaf;\uc000\ud835\udd59bar;\u6015\u0180clt\u226f\u2274\u2278r;\uc000\ud835\udcbdas\xe8\u21f4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1c5b\u0ae1\u22a3\0\u22aa\0\u22b8\u22c5\u22ce\0\u22d5\u22f3\0\0\u22f8\u2322\u2367\u2362\u237f\0\u2386\u23aa\u23b4cute\u803b\xed\u40ed\u0180;iy\u0771\u22b0\u22b5rc\u803b\xee\u40ee;\u4438\u0100cx\u22bc\u22bfy;\u4435cl\u803b\xa1\u40a1\u0100fr\u039f\u22c9;\uc000\ud835\udd26rave\u803b\xec\u40ec\u0200;ino\u073e\u22dd\u22e9\u22ee\u0100in\u22e2\u22e6nt;\u6a0ct;\u622dfin;\u69dcta;\u6129lig;\u4133\u0180aop\u22fe\u231a\u231d\u0180cgt\u2305\u2308\u2317r;\u412b\u0180elp\u071f\u230f\u2313in\xe5\u078ear\xf4\u0720h;\u4131f;\u62b7ed;\u41b5\u0280;cfot\u04f4\u232c\u2331\u233d\u2341are;\u6105in\u0100;t\u2338\u2339\u621eie;\u69dddo\xf4\u2319\u0280;celp\u0757\u234c\u2350\u235b\u2361al;\u62ba\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234darhk;\u6a17rod;\u6a3c\u0200cgpt\u236f\u2372\u2376\u237by;\u4451on;\u412ff;\uc000\ud835\udd5aa;\u43b9uest\u803b\xbf\u40bf\u0100ci\u238a\u238fr;\uc000\ud835\udcben\u0280;Edsv\u04f4\u239b\u239d\u23a1\u04f3;\u62f9ot;\u62f5\u0100;v\u23a6\u23a7\u62f4;\u62f3\u0100;i\u0777\u23aelde;\u4129\u01eb\u23b8\0\u23bccy;\u4456l\u803b\xef\u40ef\u0300cfmosu\u23cc\u23d7\u23dc\u23e1\u23e7\u23f5\u0100iy\u23d1\u23d5rc;\u4135;\u4439r;\uc000\ud835\udd27ath;\u4237pf;\uc000\ud835\udd5b\u01e3\u23ec\0\u23f1r;\uc000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240b\u2416\u2422\u2427\u242d\u2431\u2435\u243bppa\u0100;v\u2413\u2414\u43ba;\u43f0\u0100ey\u241b\u2420dil;\u4137;\u443ar;\uc000\ud835\udd28reen;\u4138cy;\u4445cy;\u445cpf;\uc000\ud835\udd5ccr;\uc000\ud835\udcc0\u0b80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248d\u2491\u250e\u253d\u255a\u2580\u264e\u265e\u2665\u2679\u267d\u269a\u26b2\u26d8\u275d\u2768\u278b\u27c0\u2801\u2812\u0180art\u2477\u247a\u247cr\xf2\u09c6\xf2\u0395ail;\u691barr;\u690e\u0100;g\u0994\u248b;\u6a8bar;\u6962\u0963\u24a5\0\u24aa\0\u24b1\0\0\0\0\0\u24b5\u24ba\0\u24c6\u24c8\u24cd\0\u24f9ute;\u413amptyv;\u69b4ra\xee\u084cbda;\u43bbg\u0180;dl\u088e\u24c1\u24c3;\u6991\xe5\u088e;\u6a85uo\u803b\xab\u40abr\u0400;bfhlpst\u0899\u24de\u24e6\u24e9\u24eb\u24ee\u24f1\u24f5\u0100;f\u089d\u24e3s;\u691fs;\u691d\xeb\u2252p;\u61abl;\u6939im;\u6973l;\u61a2\u0180;ae\u24ff\u2500\u2504\u6aabil;\u6919\u0100;s\u2509\u250a\u6aad;\uc000\u2aad\ufe00\u0180abr\u2515\u2519\u251drr;\u690crk;\u6772\u0100ak\u2522\u252cc\u0100ek\u2528\u252a;\u407b;\u405b\u0100es\u2531\u2533;\u698bl\u0100du\u2539\u253b;\u698f;\u698d\u0200aeuy\u2546\u254b\u2556\u2558ron;\u413e\u0100di\u2550\u2554il;\u413c\xec\u08b0\xe2\u2529;\u443b\u0200cqrs\u2563\u2566\u256d\u257da;\u6936uo\u0100;r\u0e19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694bh;\u61b2\u0280;fgqs\u258b\u258c\u0989\u25f3\u25ff\u6264t\u0280ahlrt\u2598\u25a4\u25b7\u25c2\u25e8rrow\u0100;t\u0899\u25a1a\xe9\u24f6arpoon\u0100du\u25af\u25b4own\xbb\u045ap\xbb\u0966eftarrows;\u61c7ight\u0180ahs\u25cd\u25d6\u25derrow\u0100;s\u08f4\u08a7arpoon\xf3\u0f98quigarro\xf7\u21f0hreetimes;\u62cb\u0180;qs\u258b\u0993\u25falan\xf4\u09ac\u0280;cdgs\u09ac\u260a\u260d\u261d\u2628c;\u6aa8ot\u0100;o\u2614\u2615\u6a7f\u0100;r\u261a\u261b\u6a81;\u6a83\u0100;e\u2622\u2625\uc000\u22da\ufe00s;\u6a93\u0280adegs\u2633\u2639\u263d\u2649\u264bppro\xf8\u24c6ot;\u62d6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248c\xf4\u099bi\xed\u09b2\u0180ilr\u2655\u08e1\u265asht;\u697c;\uc000\ud835\udd29\u0100;E\u099c\u2663;\u6a91\u0161\u2669\u2676r\u0100du\u25b2\u266e\u0100;l\u0965\u2673;\u696alk;\u6584cy;\u4459\u0280;acht\u0a48\u2688\u268b\u2691\u2696r\xf2\u25c1orne\xf2\u1d08ard;\u696bri;\u65fa\u0100io\u269f\u26a4dot;\u4140ust\u0100;a\u26ac\u26ad\u63b0che\xbb\u26ad\u0200Eaes\u26bb\u26bd\u26c9\u26d4;\u6268p\u0100;p\u26c3\u26c4\u6a89rox\xbb\u26c4\u0100;q\u26ce\u26cf\u6a87\u0100;q\u26ce\u26bbim;\u62e6\u0400abnoptwz\u26e9\u26f4\u26f7\u271a\u272f\u2741\u2747\u2750\u0100nr\u26ee\u26f1g;\u67ecr;\u61fdr\xeb\u08c1g\u0180lmr\u26ff\u270d\u2714eft\u0100ar\u09e6\u2707ight\xe1\u09f2apsto;\u67fcight\xe1\u09fdparrow\u0100lr\u2725\u2729ef\xf4\u24edight;\u61ac\u0180afl\u2736\u2739\u273dr;\u6985;\uc000\ud835\udd5dus;\u6a2dimes;\u6a34\u0161\u274b\u274fst;\u6217\xe1\u134e\u0180;ef\u2757\u2758\u1800\u65cange\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277c\u2785\u2787r\xf2\u08a8orne\xf2\u1d8car\u0100;d\u0f98\u2783;\u696d;\u600eri;\u62bf\u0300achiqt\u2798\u279d\u0a40\u27a2\u27ae\u27bbquo;\u6039r;\uc000\ud835\udcc1m\u0180;eg\u09b2\u27aa\u27ac;\u6a8d;\u6a8f\u0100bu\u252a\u27b3o\u0100;r\u0e1f\u27b9;\u601arok;\u4142\u8400<;cdhilqr\u082b\u27d2\u2639\u27dc\u27e0\u27e5\u27ea\u27f0\u0100ci\u27d7\u27d9;\u6aa6r;\u6a79re\xe5\u25f2mes;\u62c9arr;\u6976uest;\u6a7b\u0100Pi\u27f5\u27f9ar;\u6996\u0180;ef\u2800\u092d\u181b\u65c3r\u0100du\u2807\u280dshar;\u694ahar;\u6966\u0100en\u2817\u2821rtneqq;\uc000\u2268\ufe00\xc5\u281e\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288e\u2893\u28a0\u28a5\u28a8\u28da\u28e2\u28e4\u0a83\u28f3\u2902Dot;\u623a\u0200clpr\u284e\u2852\u2863\u287dr\u803b\xaf\u40af\u0100et\u2857\u2859;\u6642\u0100;e\u285e\u285f\u6720se\xbb\u285f\u0100;s\u103b\u2868to\u0200;dlu\u103b\u2873\u2877\u287bow\xee\u048cef\xf4\u090f\xf0\u13d1ker;\u65ae\u0100oy\u2887\u288cmma;\u6a29;\u443cash;\u6014asuredangle\xbb\u1626r;\uc000\ud835\udd2ao;\u6127\u0180cdn\u28af\u28b4\u28c9ro\u803b\xb5\u40b5\u0200;acd\u1464\u28bd\u28c0\u28c4s\xf4\u16a7ir;\u6af0ot\u80bb\xb7\u01b5us\u0180;bd\u28d2\u1903\u28d3\u6212\u0100;u\u1d3c\u28d8;\u6a2a\u0163\u28de\u28e1p;\u6adb\xf2\u2212\xf0\u0a81\u0100dp\u28e9\u28eeels;\u62a7f;\uc000\ud835\udd5e\u0100ct\u28f8\u28fdr;\uc000\ud835\udcc2pos\xbb\u159d\u0180;lm\u2909\u290a\u290d\u43bctimap;\u62b8\u0c00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297e\u2989\u2998\u29da\u29e9\u2a15\u2a1a\u2a58\u2a5d\u2a83\u2a95\u2aa4\u2aa8\u2b04\u2b07\u2b44\u2b7f\u2bae\u2c34\u2c67\u2c7c\u2ce9\u0100gt\u2947\u294b;\uc000\u22d9\u0338\u0100;v\u2950\u0bcf\uc000\u226b\u20d2\u0180elt\u295a\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61cdightarrow;\u61ce;\uc000\u22d8\u0338\u0100;v\u297b\u0c47\uc000\u226a\u20d2ightarrow;\u61cf\u0100Dd\u298e\u2993ash;\u62afash;\u62ae\u0280bcnpt\u29a3\u29a7\u29ac\u29b1\u29ccla\xbb\u02deute;\u4144g;\uc000\u2220\u20d2\u0280;Eiop\u0d84\u29bc\u29c0\u29c5\u29c8;\uc000\u2a70\u0338d;\uc000\u224b\u0338s;\u4149ro\xf8\u0d84ur\u0100;a\u29d3\u29d4\u666el\u0100;s\u29d3\u0b38\u01f3\u29df\0\u29e3p\u80bb\xa0\u0b37mp\u0100;e\u0bf9\u0c00\u0280aeouy\u29f4\u29fe\u2a03\u2a10\u2a13\u01f0\u29f9\0\u29fb;\u6a43on;\u4148dil;\u4146ng\u0100;d\u0d7e\u2a0aot;\uc000\u2a6d\u0338p;\u6a42;\u443dash;\u6013\u0380;Aadqsx\u0b92\u2a29\u2a2d\u2a3b\u2a41\u2a45\u2a50rr;\u61d7r\u0100hr\u2a33\u2a36k;\u6924\u0100;o\u13f2\u13f0ot;\uc000\u2250\u0338ui\xf6\u0b63\u0100ei\u2a4a\u2a4ear;\u6928\xed\u0b98ist\u0100;s\u0ba0\u0b9fr;\uc000\ud835\udd2b\u0200Eest\u0bc5\u2a66\u2a79\u2a7c\u0180;qs\u0bbc\u2a6d\u0be1\u0180;qs\u0bbc\u0bc5\u2a74lan\xf4\u0be2i\xed\u0bea\u0100;r\u0bb6\u2a81\xbb\u0bb7\u0180Aap\u2a8a\u2a8d\u2a91r\xf2\u2971rr;\u61aear;\u6af2\u0180;sv\u0f8d\u2a9c\u0f8c\u0100;d\u2aa1\u2aa2\u62fc;\u62facy;\u445a\u0380AEadest\u2ab7\u2aba\u2abe\u2ac2\u2ac5\u2af6\u2af9r\xf2\u2966;\uc000\u2266\u0338rr;\u619ar;\u6025\u0200;fqs\u0c3b\u2ace\u2ae3\u2aeft\u0100ar\u2ad4\u2ad9rro\xf7\u2ac1ightarro\xf7\u2a90\u0180;qs\u0c3b\u2aba\u2aealan\xf4\u0c55\u0100;s\u0c55\u2af4\xbb\u0c36i\xed\u0c5d\u0100;r\u0c35\u2afei\u0100;e\u0c1a\u0c25i\xe4\u0d90\u0100pt\u2b0c\u2b11f;\uc000\ud835\udd5f\u8180\xac;in\u2b19\u2b1a\u2b36\u40acn\u0200;Edv\u0b89\u2b24\u2b28\u2b2e;\uc000\u22f9\u0338ot;\uc000\u22f5\u0338\u01e1\u0b89\u2b33\u2b35;\u62f7;\u62f6i\u0100;v\u0cb8\u2b3c\u01e1\u0cb8\u2b41\u2b43;\u62fe;\u62fd\u0180aor\u2b4b\u2b63\u2b69r\u0200;ast\u0b7b\u2b55\u2b5a\u2b5flle\xec\u0b7bl;\uc000\u2afd\u20e5;\uc000\u2202\u0338lint;\u6a14\u0180;ce\u0c92\u2b70\u2b73u\xe5\u0ca5\u0100;c\u0c98\u2b78\u0100;e\u0c92\u2b7d\xf1\u0c98\u0200Aait\u2b88\u2b8b\u2b9d\u2ba7r\xf2\u2988rr\u0180;cw\u2b94\u2b95\u2b99\u619b;\uc000\u2933\u0338;\uc000\u219d\u0338ghtarrow\xbb\u2b95ri\u0100;e\u0ccb\u0cd6\u0380chimpqu\u2bbd\u2bcd\u2bd9\u2b04\u0b78\u2be4\u2bef\u0200;cer\u0d32\u2bc6\u0d37\u2bc9u\xe5\u0d45;\uc000\ud835\udcc3ort\u026d\u2b05\0\0\u2bd6ar\xe1\u2b56m\u0100;e\u0d6e\u2bdf\u0100;q\u0d74\u0d73su\u0100bp\u2beb\u2bed\xe5\u0cf8\xe5\u0d0b\u0180bcp\u2bf6\u2c11\u2c19\u0200;Ees\u2bff\u2c00\u0d22\u2c04\u6284;\uc000\u2ac5\u0338et\u0100;e\u0d1b\u2c0bq\u0100;q\u0d23\u2c00c\u0100;e\u0d32\u2c17\xf1\u0d38\u0200;Ees\u2c22\u2c23\u0d5f\u2c27\u6285;\uc000\u2ac6\u0338et\u0100;e\u0d58\u2c2eq\u0100;q\u0d60\u2c23\u0200gilr\u2c3d\u2c3f\u2c45\u2c47\xec\u0bd7lde\u803b\xf1\u40f1\xe7\u0c43iangle\u0100lr\u2c52\u2c5ceft\u0100;e\u0c1a\u2c5a\xf1\u0c26ight\u0100;e\u0ccb\u2c65\xf1\u0cd7\u0100;m\u2c6c\u2c6d\u43bd\u0180;es\u2c74\u2c75\u2c79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2c8f\u2c94\u2c99\u2c9e\u2ca3\u2cb0\u2cb6\u2cd3\u2ce3ash;\u62adarr;\u6904p;\uc000\u224d\u20d2ash;\u62ac\u0100et\u2ca8\u2cac;\uc000\u2265\u20d2;\uc000>\u20d2nfin;\u69de\u0180Aet\u2cbd\u2cc1\u2cc5rr;\u6902;\uc000\u2264\u20d2\u0100;r\u2cca\u2ccd\uc000<\u20d2ie;\uc000\u22b4\u20d2\u0100At\u2cd8\u2cdcrr;\u6903rie;\uc000\u22b5\u20d2im;\uc000\u223c\u20d2\u0180Aan\u2cf0\u2cf4\u2d02rr;\u61d6r\u0100hr\u2cfa\u2cfdk;\u6923\u0100;o\u13e7\u13e5ear;\u6927\u1253\u1a95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2d2d\0\u2d38\u2d48\u2d60\u2d65\u2d72\u2d84\u1b07\0\0\u2d8d\u2dab\0\u2dc8\u2dce\0\u2ddc\u2e19\u2e2b\u2e3e\u2e43\u0100cs\u2d31\u1a97ute\u803b\xf3\u40f3\u0100iy\u2d3c\u2d45r\u0100;c\u1a9e\u2d42\u803b\xf4\u40f4;\u443e\u0280abios\u1aa0\u2d52\u2d57\u01c8\u2d5alac;\u4151v;\u6a38old;\u69bclig;\u4153\u0100cr\u2d69\u2d6dir;\u69bf;\uc000\ud835\udd2c\u036f\u2d79\0\0\u2d7c\0\u2d82n;\u42dbave\u803b\xf2\u40f2;\u69c1\u0100bm\u2d88\u0df4ar;\u69b5\u0200acit\u2d95\u2d98\u2da5\u2da8r\xf2\u1a80\u0100ir\u2d9d\u2da0r;\u69beoss;\u69bbn\xe5\u0e52;\u69c0\u0180aei\u2db1\u2db5\u2db9cr;\u414dga;\u43c9\u0180cdn\u2dc0\u2dc5\u01cdron;\u43bf;\u69b6pf;\uc000\ud835\udd60\u0180ael\u2dd4\u2dd7\u01d2r;\u69b7rp;\u69b9\u0380;adiosv\u2dea\u2deb\u2dee\u2e08\u2e0d\u2e10\u2e16\u6228r\xf2\u1a86\u0200;efm\u2df7\u2df8\u2e02\u2e05\u6a5dr\u0100;o\u2dfe\u2dff\u6134f\xbb\u2dff\u803b\xaa\u40aa\u803b\xba\u40bagof;\u62b6r;\u6a56lope;\u6a57;\u6a5b\u0180clo\u2e1f\u2e21\u2e27\xf2\u2e01ash\u803b\xf8\u40f8l;\u6298i\u016c\u2e2f\u2e34de\u803b\xf5\u40f5es\u0100;a\u01db\u2e3as;\u6a36ml\u803b\xf6\u40f6bar;\u633d\u0ae1\u2e5e\0\u2e7d\0\u2e80\u2e9d\0\u2ea2\u2eb9\0\0\u2ecb\u0e9c\0\u2f13\0\0\u2f2b\u2fbc\0\u2fc8r\u0200;ast\u0403\u2e67\u2e72\u0e85\u8100\xb6;l\u2e6d\u2e6e\u40b6le\xec\u0403\u0269\u2e78\0\0\u2e7bm;\u6af3;\u6afdy;\u443fr\u0280cimpt\u2e8b\u2e8f\u2e93\u1865\u2e97nt;\u4025od;\u402eil;\u6030enk;\u6031r;\uc000\ud835\udd2d\u0180imo\u2ea8\u2eb0\u2eb4\u0100;v\u2ead\u2eae\u43c6;\u43d5ma\xf4\u0a76ne;\u660e\u0180;tv\u2ebf\u2ec0\u2ec8\u43c0chfork\xbb\u1ffd;\u43d6\u0100au\u2ecf\u2edfn\u0100ck\u2ed5\u2eddk\u0100;h\u21f4\u2edb;\u610e\xf6\u21f4s\u0480;abcdemst\u2ef3\u2ef4\u1908\u2ef9\u2efd\u2f04\u2f06\u2f0a\u2f0e\u402bcir;\u6a23ir;\u6a22\u0100ou\u1d40\u2f02;\u6a25;\u6a72n\u80bb\xb1\u0e9dim;\u6a26wo;\u6a27\u0180ipu\u2f19\u2f20\u2f25ntint;\u6a15f;\uc000\ud835\udd61nd\u803b\xa3\u40a3\u0500;Eaceinosu\u0ec8\u2f3f\u2f41\u2f44\u2f47\u2f81\u2f89\u2f92\u2f7e\u2fb6;\u6ab3p;\u6ab7u\xe5\u0ed9\u0100;c\u0ece\u2f4c\u0300;acens\u0ec8\u2f59\u2f5f\u2f66\u2f68\u2f7eppro\xf8\u2f43urlye\xf1\u0ed9\xf1\u0ece\u0180aes\u2f6f\u2f76\u2f7approx;\u6ab9qq;\u6ab5im;\u62e8i\xed\u0edfme\u0100;s\u2f88\u0eae\u6032\u0180Eas\u2f78\u2f90\u2f7a\xf0\u2f75\u0180dfp\u0eec\u2f99\u2faf\u0180als\u2fa0\u2fa5\u2faalar;\u632eine;\u6312urf;\u6313\u0100;t\u0efb\u2fb4\xef\u0efbrel;\u62b0\u0100ci\u2fc0\u2fc5r;\uc000\ud835\udcc5;\u43c8ncsp;\u6008\u0300fiopsu\u2fda\u22e2\u2fdf\u2fe5\u2feb\u2ff1r;\uc000\ud835\udd2epf;\uc000\ud835\udd62rime;\u6057cr;\uc000\ud835\udcc6\u0180aeo\u2ff8\u3009\u3013t\u0100ei\u2ffe\u3005rnion\xf3\u06b0nt;\u6a16st\u0100;e\u3010\u3011\u403f\xf1\u1f19\xf4\u0f14\u0a80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30e0\u310e\u312b\u3147\u3162\u3172\u318e\u3206\u3215\u3224\u3229\u3258\u326e\u3272\u3290\u32b0\u32b7\u0180art\u3047\u304a\u304cr\xf2\u10b3\xf2\u03ddail;\u691car\xf2\u1c65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307f\u308f\u3094\u30cc\u0100eu\u306d\u3071;\uc000\u223d\u0331te;\u4155i\xe3\u116emptyv;\u69b3g\u0200;del\u0fd1\u3089\u308b\u308d;\u6992;\u69a5\xe5\u0fd1uo\u803b\xbb\u40bbr\u0580;abcfhlpstw\u0fdc\u30ac\u30af\u30b7\u30b9\u30bc\u30be\u30c0\u30c3\u30c7\u30cap;\u6975\u0100;f\u0fe0\u30b4s;\u6920;\u6933s;\u691e\xeb\u225d\xf0\u272el;\u6945im;\u6974l;\u61a3;\u619d\u0100ai\u30d1\u30d5il;\u691ao\u0100;n\u30db\u30dc\u6236al\xf3\u0f1e\u0180abr\u30e7\u30ea\u30eer\xf2\u17e5rk;\u6773\u0100ak\u30f3\u30fdc\u0100ek\u30f9\u30fb;\u407d;\u405d\u0100es\u3102\u3104;\u698cl\u0100du\u310a\u310c;\u698e;\u6990\u0200aeuy\u3117\u311c\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0ff2\xe2\u30fa;\u4440\u0200clqs\u3134\u3137\u313d\u3144a;\u6937dhar;\u6969uo\u0100;r\u020e\u020dh;\u61b3\u0180acg\u314e\u315f\u0f44l\u0200;ips\u0f78\u3158\u315b\u109cn\xe5\u10bbar\xf4\u0fa9t;\u65ad\u0180ilr\u3169\u1023\u316esht;\u697d;\uc000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317d\u317f\xbb\u047b\u0100;l\u1091\u3184;\u696c\u0100;v\u318b\u318c\u43c1;\u43f1\u0180gns\u3195\u31f9\u31fcht\u0300ahlrst\u31a4\u31b0\u31c2\u31d8\u31e4\u31eerrow\u0100;t\u0fdc\u31ada\xe9\u30c8arpoon\u0100du\u31bb\u31bfow\xee\u317ep\xbb\u1092eft\u0100ah\u31ca\u31d0rrow\xf3\u0feaarpoon\xf3\u0551ightarrows;\u61c9quigarro\xf7\u30cbhreetimes;\u62ccg;\u42daingdotse\xf1\u1f32\u0180ahm\u320d\u3210\u3213r\xf2\u0feaa\xf2\u0551;\u600foust\u0100;a\u321e\u321f\u63b1che\xbb\u321fmid;\u6aee\u0200abpt\u3232\u323d\u3240\u3252\u0100nr\u3237\u323ag;\u67edr;\u61fer\xeb\u1003\u0180afl\u3247\u324a\u324er;\u6986;\uc000\ud835\udd63us;\u6a2eimes;\u6a35\u0100ap\u325d\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6a12ar\xf2\u31e3\u0200achq\u327b\u3280\u10bc\u3285quo;\u603ar;\uc000\ud835\udcc7\u0100bu\u30fb\u328ao\u0100;r\u0214\u0213\u0180hir\u3297\u329b\u32a0re\xe5\u31f8mes;\u62cai\u0200;efl\u32aa\u1059\u1821\u32ab\u65b9tri;\u69celuhar;\u6968;\u611e\u0d61\u32d5\u32db\u32df\u332c\u3338\u3371\0\u337a\u33a4\0\0\u33ec\u33f0\0\u3428\u3448\u345a\u34ad\u34b1\u34ca\u34f1\0\u3616\0\0\u3633cute;\u415bqu\xef\u27ba\u0500;Eaceinpsy\u11ed\u32f3\u32f5\u32ff\u3302\u330b\u330f\u331f\u3326\u3329;\u6ab4\u01f0\u32fa\0\u32fc;\u6ab8on;\u4161u\xe5\u11fe\u0100;d\u11f3\u3307il;\u415frc;\u415d\u0180Eas\u3316\u3318\u331b;\u6ab6p;\u6abaim;\u62e9olint;\u6a13i\xed\u1204;\u4441ot\u0180;be\u3334\u1d47\u3335\u62c5;\u6a66\u0380Aacmstx\u3346\u334a\u3357\u335b\u335e\u3363\u336drr;\u61d8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0a36\u0a34t\u803b\xa7\u40a7i;\u403bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uc000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33a0rp;\u666f\u0100hy\u338b\u338fcy;\u4449;\u4448rt\u026d\u3399\0\0\u339ci\xe4\u1464ara\xec\u2e6f\u803b\xad\u40ad\u0100gm\u33a8\u33b4ma\u0180;fv\u33b1\u33b2\u33b2\u43c3;\u43c2\u0400;deglnpr\u12ab\u33c5\u33c9\u33ce\u33d6\u33de\u33e1\u33e6ot;\u6a6a\u0100;q\u12b1\u12b0\u0100;E\u33d3\u33d4\u6a9e;\u6aa0\u0100;E\u33db\u33dc\u6a9d;\u6a9fe;\u6246lus;\u6a24arr;\u6972ar\xf2\u113d\u0200aeit\u33f8\u3408\u340f\u3417\u0100ls\u33fd\u3404lsetm\xe9\u336ahp;\u6a33parsl;\u69e4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341c\u341d\u6aaa\u0100;s\u3422\u3423\u6aac;\uc000\u2aac\ufe00\u0180flp\u342e\u3433\u3442tcy;\u444c\u0100;b\u3438\u3439\u402f\u0100;a\u343e\u343f\u69c4r;\u633ff;\uc000\ud835\udd64a\u0100dr\u344d\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349f\u0100au\u3465\u346fp\u0100;s\u1188\u346b;\uc000\u2293\ufe00p\u0100;s\u11b4\u3475;\uc000\u2294\ufe00u\u0100bp\u347f\u348f\u0180;es\u1197\u119c\u3486et\u0100;e\u1197\u348d\xf1\u119d\u0180;es\u11a8\u11ad\u3496et\u0100;e\u11a8\u349d\xf1\u11ae\u0180;af\u117b\u34a6\u05b0r\u0165\u34ab\u05b1\xbb\u117car\xf2\u1148\u0200cemt\u34b9\u34be\u34c2\u34c5r;\uc000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11be\u0100ar\u34ce\u34d5r\u0100;f\u34d4\u17bf\u6606\u0100an\u34da\u34edight\u0100ep\u34e3\u34eapsilo\xee\u1ee0h\xe9\u2eafs\xbb\u2852\u0280bcmnp\u34fb\u355e\u1209\u358b\u358e\u0480;Edemnprs\u350e\u350f\u3511\u3515\u351e\u3523\u352c\u3531\u3536\u6282;\u6ac5ot;\u6abd\u0100;d\u11da\u351aot;\u6ac3ult;\u6ac1\u0100Ee\u3528\u352a;\u6acb;\u628alus;\u6abfarr;\u6979\u0180eiu\u353d\u3552\u3555t\u0180;en\u350e\u3545\u354bq\u0100;q\u11da\u350feq\u0100;q\u352b\u3528m;\u6ac7\u0100bp\u355a\u355c;\u6ad5;\u6ad3c\u0300;acens\u11ed\u356c\u3572\u3579\u357b\u3326ppro\xf8\u32faurlye\xf1\u11fe\xf1\u11f3\u0180aes\u3582\u3588\u331bppro\xf8\u331aq\xf1\u3317g;\u666a\u0680123;Edehlmnps\u35a9\u35ac\u35af\u121c\u35b2\u35b4\u35c0\u35c9\u35d5\u35da\u35df\u35e8\u35ed\u803b\xb9\u40b9\u803b\xb2\u40b2\u803b\xb3\u40b3;\u6ac6\u0100os\u35b9\u35bct;\u6abeub;\u6ad8\u0100;d\u1222\u35c5ot;\u6ac4s\u0100ou\u35cf\u35d2l;\u67c9b;\u6ad7arr;\u697bult;\u6ac2\u0100Ee\u35e4\u35e6;\u6acc;\u628blus;\u6ac0\u0180eiu\u35f4\u3609\u360ct\u0180;en\u121c\u35fc\u3602q\u0100;q\u1222\u35b2eq\u0100;q\u35e7\u35e4m;\u6ac8\u0100bp\u3611\u3613;\u6ad4;\u6ad6\u0180Aan\u361c\u3620\u362drr;\u61d9r\u0100hr\u3626\u3628\xeb\u222e\u0100;o\u0a2b\u0a29war;\u692alig\u803b\xdf\u40df\u0be1\u3651\u365d\u3660\u12ce\u3673\u3679\0\u367e\u36c2\0\0\0\0\0\u36db\u3703\0\u3709\u376c\0\0\0\u3787\u0272\u3656\0\0\u365bget;\u6316;\u43c4r\xeb\u0e5f\u0180aey\u3666\u366b\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uc000\ud835\udd31\u0200eiko\u3686\u369d\u36b5\u36bc\u01f2\u368b\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369b\u43b8ym;\u43d1\u0100cn\u36a2\u36b2k\u0100as\u36a8\u36aeppro\xf8\u12c1im\xbb\u12acs\xf0\u129e\u0100as\u36ba\u36ae\xf0\u12c1rn\u803b\xfe\u40fe\u01ec\u031f\u36c6\u22e7es\u8180\xd7;bd\u36cf\u36d0\u36d8\u40d7\u0100;a\u190f\u36d5r;\u6a31;\u6a30\u0180eps\u36e1\u36e3\u3700\xe1\u2a4d\u0200;bcf\u0486\u36ec\u36f0\u36f4ot;\u6336ir;\u6af1\u0100;o\u36f9\u36fc\uc000\ud835\udd65rk;\u6ada\xe1\u3362rime;\u6034\u0180aip\u370f\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374d\u3740\u3751\u3757\u375c\u375fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65b5own\xbb\u1dbbeft\u0100;e\u2800\u373e\xf1\u092e;\u625cight\u0100;e\u32aa\u374b\xf1\u105aot;\u65ecinus;\u6a3alus;\u6a39b;\u69cdime;\u6a3bezium;\u63e2\u0180cht\u3772\u377d\u3781\u0100ry\u3777\u377b;\uc000\ud835\udcc9;\u4446cy;\u445brok;\u4167\u0100io\u378b\u378ex\xf4\u1777head\u0100lr\u3797\u37a0eftarro\xf7\u084fightarrow\xbb\u0f5d\u0900AHabcdfghlmoprstuw\u37d0\u37d3\u37d7\u37e4\u37f0\u37fc\u380e\u381c\u3823\u3834\u3851\u385d\u386b\u38a9\u38cc\u38d2\u38ea\u38f6r\xf2\u03edar;\u6963\u0100cr\u37dc\u37e2ute\u803b\xfa\u40fa\xf2\u1150r\u01e3\u37ea\0\u37edy;\u445eve;\u416d\u0100iy\u37f5\u37farc\u803b\xfb\u40fb;\u4443\u0180abh\u3803\u3806\u380br\xf2\u13adlac;\u4171a\xf2\u13c3\u0100ir\u3813\u3818sht;\u697e;\uc000\ud835\udd32rave\u803b\xf9\u40f9\u0161\u3827\u3831r\u0100lr\u382c\u382e\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384d\u026f\u383f\0\0\u384arn\u0100;e\u3845\u3846\u631cr\xbb\u3846op;\u630fri;\u65f8\u0100al\u3856\u385acr;\u416b\u80bb\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uc000\ud835\udd66\u0300adhlsu\u114b\u3878\u387d\u1372\u3891\u38a0own\xe1\u13b3arpoon\u0100lr\u3888\u388cef\xf4\u382digh\xf4\u382fi\u0180;hl\u3899\u389a\u389c\u43c5\xbb\u13faon\xbb\u389aparrows;\u61c8\u0180cit\u38b0\u38c4\u38c8\u026f\u38b6\0\0\u38c1rn\u0100;e\u38bc\u38bd\u631dr\xbb\u38bdop;\u630eng;\u416fri;\u65f9cr;\uc000\ud835\udcca\u0180dir\u38d9\u38dd\u38e2ot;\u62f0lde;\u4169i\u0100;f\u3730\u38e8\xbb\u1813\u0100am\u38ef\u38f2r\xf2\u38a8l\u803b\xfc\u40fcangle;\u69a7\u0780ABDacdeflnoprsz\u391c\u391f\u3929\u392d\u39b5\u39b8\u39bd\u39df\u39e4\u39e8\u39f3\u39f9\u39fd\u3a01\u3a20r\xf2\u03f7ar\u0100;v\u3926\u3927\u6ae8;\u6ae9as\xe8\u03e1\u0100nr\u3932\u3937grt;\u699c\u0380eknprst\u34e3\u3946\u394b\u3952\u395d\u3964\u3996app\xe1\u2415othin\xe7\u1e96\u0180hir\u34eb\u2ec8\u3959op\xf4\u2fb5\u0100;h\u13b7\u3962\xef\u318d\u0100iu\u3969\u396dgm\xe1\u33b3\u0100bp\u3972\u3984setneq\u0100;q\u397d\u3980\uc000\u228a\ufe00;\uc000\u2acb\ufe00setneq\u0100;q\u398f\u3992\uc000\u228b\ufe00;\uc000\u2acc\ufe00\u0100hr\u399b\u399fet\xe1\u369ciangle\u0100lr\u39aa\u39afeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39c4\u39d2\u39d7\u0180;be\u2dea\u39cb\u39cfar;\u62bbq;\u625alip;\u62ee\u0100bt\u39dc\u1468a\xf2\u1469r;\uc000\ud835\udd33tr\xe9\u39aesu\u0100bp\u39ef\u39f1\xbb\u0d1c\xbb\u0d59pf;\uc000\ud835\udd67ro\xf0\u0efbtr\xe9\u39b4\u0100cu\u3a06\u3a0br;\uc000\ud835\udccb\u0100bp\u3a10\u3a18n\u0100Ee\u3980\u3a16\xbb\u397en\u0100Ee\u3992\u3a1e\xbb\u3990igzag;\u699a\u0380cefoprs\u3a36\u3a3b\u3a56\u3a5b\u3a54\u3a61\u3a6airc;\u4175\u0100di\u3a40\u3a51\u0100bg\u3a45\u3a49ar;\u6a5fe\u0100;q\u15fa\u3a4f;\u6259erp;\u6118r;\uc000\ud835\udd34pf;\uc000\ud835\udd68\u0100;e\u1479\u3a66at\xe8\u1479cr;\uc000\ud835\udccc\u0ae3\u178e\u3a87\0\u3a8b\0\u3a90\u3a9b\0\0\u3a9d\u3aa8\u3aab\u3aaf\0\0\u3ac3\u3ace\0\u3ad8\u17dc\u17dftr\xe9\u17d1r;\uc000\ud835\udd35\u0100Aa\u3a94\u3a97r\xf2\u03c3r\xf2\u09f6;\u43be\u0100Aa\u3aa1\u3aa4r\xf2\u03b8r\xf2\u09eba\xf0\u2713is;\u62fb\u0180dpt\u17a4\u3ab5\u3abe\u0100fl\u3aba\u17a9;\uc000\ud835\udd69im\xe5\u17b2\u0100Aa\u3ac7\u3acar\xf2\u03cer\xf2\u0a01\u0100cq\u3ad2\u17b8r;\uc000\ud835\udccd\u0100pt\u17d6\u3adcr\xe9\u17d4\u0400acefiosu\u3af0\u3afd\u3b08\u3b0c\u3b11\u3b15\u3b1b\u3b21c\u0100uy\u3af6\u3afbte\u803b\xfd\u40fd;\u444f\u0100iy\u3b02\u3b06rc;\u4177;\u444bn\u803b\xa5\u40a5r;\uc000\ud835\udd36cy;\u4457pf;\uc000\ud835\udd6acr;\uc000\ud835\udcce\u0100cm\u3b26\u3b29y;\u444el\u803b\xff\u40ff\u0500acdefhiosw\u3b42\u3b48\u3b54\u3b58\u3b64\u3b69\u3b6d\u3b74\u3b7a\u3b80cute;\u417a\u0100ay\u3b4d\u3b52ron;\u417e;\u4437ot;\u417c\u0100et\u3b5d\u3b61tr\xe6\u155fa;\u43b6r;\uc000\ud835\udd37cy;\u4436grarr;\u61ddpf;\uc000\ud835\udd6bcr;\uc000\ud835\udccf\u0100jn\u3b85\u3b87;\u600dj;\u600c"
    .split("")
    .map(function (c) { return c.charCodeAt(0); }));

var decodeDataXml = {};

// Generated using scripts/write-decode-map.ts
Object.defineProperty(decodeDataXml, "__esModule", { value: true });
decodeDataXml.default = new Uint16Array(
// prettier-ignore
"\u0200aglq\t\x15\x18\x1b\u026d\x0f\0\0\x12p;\u4026os;\u4027t;\u403et;\u403cuot;\u4022"
    .split("")
    .map(function (c) { return c.charCodeAt(0); }));

var decode_codepoint = {};

(function (exports) {
	// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
	var _a;
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.replaceCodePoint = exports.fromCodePoint = void 0;
	var decodeMap = new Map([
	    [0, 65533],
	    // C1 Unicode control character reference replacements
	    [128, 8364],
	    [130, 8218],
	    [131, 402],
	    [132, 8222],
	    [133, 8230],
	    [134, 8224],
	    [135, 8225],
	    [136, 710],
	    [137, 8240],
	    [138, 352],
	    [139, 8249],
	    [140, 338],
	    [142, 381],
	    [145, 8216],
	    [146, 8217],
	    [147, 8220],
	    [148, 8221],
	    [149, 8226],
	    [150, 8211],
	    [151, 8212],
	    [152, 732],
	    [153, 8482],
	    [154, 353],
	    [155, 8250],
	    [156, 339],
	    [158, 382],
	    [159, 376],
	]);
	/**
	 * Polyfill for `String.fromCodePoint`. It is used to create a string from a Unicode code point.
	 */
	exports.fromCodePoint = 
	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
	(_a = String.fromCodePoint) !== null && _a !== void 0 ? _a : function (codePoint) {
	    var output = "";
	    if (codePoint > 0xffff) {
	        codePoint -= 0x10000;
	        output += String.fromCharCode(((codePoint >>> 10) & 0x3ff) | 0xd800);
	        codePoint = 0xdc00 | (codePoint & 0x3ff);
	    }
	    output += String.fromCharCode(codePoint);
	    return output;
	};
	/**
	 * Replace the given code point with a replacement character if it is a
	 * surrogate or is outside the valid range. Otherwise return the code
	 * point unchanged.
	 */
	function replaceCodePoint(codePoint) {
	    var _a;
	    if ((codePoint >= 0xd800 && codePoint <= 0xdfff) || codePoint > 0x10ffff) {
	        return 0xfffd;
	    }
	    return (_a = decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
	}
	exports.replaceCodePoint = replaceCodePoint;
	/**
	 * Replace the code point if relevant, then convert it to a string.
	 *
	 * @deprecated Use `fromCodePoint(replaceCodePoint(codePoint))` instead.
	 * @param codePoint The code point to decode.
	 * @returns The decoded code point.
	 */
	function decodeCodePoint(codePoint) {
	    return (0, exports.fromCodePoint)(replaceCodePoint(codePoint));
	}
	exports.default = decodeCodePoint;
	
} (decode_codepoint));

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.decodeXML = exports.decodeHTMLStrict = exports.decodeHTMLAttribute = exports.decodeHTML = exports.determineBranch = exports.EntityDecoder = exports.DecodingMode = exports.BinTrieFlags = exports.fromCodePoint = exports.replaceCodePoint = exports.decodeCodePoint = exports.xmlDecodeTree = exports.htmlDecodeTree = void 0;
	var decode_data_html_js_1 = __importDefault(decodeDataHtml);
	exports.htmlDecodeTree = decode_data_html_js_1.default;
	var decode_data_xml_js_1 = __importDefault(decodeDataXml);
	exports.xmlDecodeTree = decode_data_xml_js_1.default;
	var decode_codepoint_js_1 = __importStar(decode_codepoint);
	exports.decodeCodePoint = decode_codepoint_js_1.default;
	var decode_codepoint_js_2 = decode_codepoint;
	Object.defineProperty(exports, "replaceCodePoint", { enumerable: true, get: function () { return decode_codepoint_js_2.replaceCodePoint; } });
	Object.defineProperty(exports, "fromCodePoint", { enumerable: true, get: function () { return decode_codepoint_js_2.fromCodePoint; } });
	var CharCodes;
	(function (CharCodes) {
	    CharCodes[CharCodes["NUM"] = 35] = "NUM";
	    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
	    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
	    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
	    CharCodes[CharCodes["NINE"] = 57] = "NINE";
	    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
	    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
	    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
	    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
	    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
	    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
	    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
	})(CharCodes || (CharCodes = {}));
	/** Bit that needs to be set to convert an upper case ASCII character to lower case */
	var TO_LOWER_BIT = 32;
	var BinTrieFlags;
	(function (BinTrieFlags) {
	    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
	    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
	    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
	})(BinTrieFlags = exports.BinTrieFlags || (exports.BinTrieFlags = {}));
	function isNumber(code) {
	    return code >= CharCodes.ZERO && code <= CharCodes.NINE;
	}
	function isHexadecimalCharacter(code) {
	    return ((code >= CharCodes.UPPER_A && code <= CharCodes.UPPER_F) ||
	        (code >= CharCodes.LOWER_A && code <= CharCodes.LOWER_F));
	}
	function isAsciiAlphaNumeric(code) {
	    return ((code >= CharCodes.UPPER_A && code <= CharCodes.UPPER_Z) ||
	        (code >= CharCodes.LOWER_A && code <= CharCodes.LOWER_Z) ||
	        isNumber(code));
	}
	/**
	 * Checks if the given character is a valid end character for an entity in an attribute.
	 *
	 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
	 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
	 */
	function isEntityInAttributeInvalidEnd(code) {
	    return code === CharCodes.EQUALS || isAsciiAlphaNumeric(code);
	}
	var EntityDecoderState;
	(function (EntityDecoderState) {
	    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
	    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
	    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
	    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
	    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
	})(EntityDecoderState || (EntityDecoderState = {}));
	var DecodingMode;
	(function (DecodingMode) {
	    /** Entities in text nodes that can end with any character. */
	    DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
	    /** Only allow entities terminated with a semicolon. */
	    DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
	    /** Entities in attributes have limitations on ending characters. */
	    DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
	})(DecodingMode = exports.DecodingMode || (exports.DecodingMode = {}));
	/**
	 * Token decoder with support of writing partial entities.
	 */
	var EntityDecoder = /** @class */ (function () {
	    function EntityDecoder(
	    /** The tree used to decode entities. */
	    decodeTree, 
	    /**
	     * The function that is called when a codepoint is decoded.
	     *
	     * For multi-byte named entities, this will be called multiple times,
	     * with the second codepoint, and the same `consumed` value.
	     *
	     * @param codepoint The decoded codepoint.
	     * @param consumed The number of bytes consumed by the decoder.
	     */
	    emitCodePoint, 
	    /** An object that is used to produce errors. */
	    errors) {
	        this.decodeTree = decodeTree;
	        this.emitCodePoint = emitCodePoint;
	        this.errors = errors;
	        /** The current state of the decoder. */
	        this.state = EntityDecoderState.EntityStart;
	        /** Characters that were consumed while parsing an entity. */
	        this.consumed = 1;
	        /**
	         * The result of the entity.
	         *
	         * Either the result index of a numeric entity, or the codepoint of a
	         * numeric entity.
	         */
	        this.result = 0;
	        /** The current index in the decode tree. */
	        this.treeIndex = 0;
	        /** The number of characters that were consumed in excess. */
	        this.excess = 1;
	        /** The mode in which the decoder is operating. */
	        this.decodeMode = DecodingMode.Strict;
	    }
	    /** Resets the instance to make it reusable. */
	    EntityDecoder.prototype.startEntity = function (decodeMode) {
	        this.decodeMode = decodeMode;
	        this.state = EntityDecoderState.EntityStart;
	        this.result = 0;
	        this.treeIndex = 0;
	        this.excess = 1;
	        this.consumed = 1;
	    };
	    /**
	     * Write an entity to the decoder. This can be called multiple times with partial entities.
	     * If the entity is incomplete, the decoder will return -1.
	     *
	     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
	     * entity is incomplete, and resume when the next string is written.
	     *
	     * @param string The string containing the entity (or a continuation of the entity).
	     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
	     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
	     */
	    EntityDecoder.prototype.write = function (str, offset) {
	        switch (this.state) {
	            case EntityDecoderState.EntityStart: {
	                if (str.charCodeAt(offset) === CharCodes.NUM) {
	                    this.state = EntityDecoderState.NumericStart;
	                    this.consumed += 1;
	                    return this.stateNumericStart(str, offset + 1);
	                }
	                this.state = EntityDecoderState.NamedEntity;
	                return this.stateNamedEntity(str, offset);
	            }
	            case EntityDecoderState.NumericStart: {
	                return this.stateNumericStart(str, offset);
	            }
	            case EntityDecoderState.NumericDecimal: {
	                return this.stateNumericDecimal(str, offset);
	            }
	            case EntityDecoderState.NumericHex: {
	                return this.stateNumericHex(str, offset);
	            }
	            case EntityDecoderState.NamedEntity: {
	                return this.stateNamedEntity(str, offset);
	            }
	        }
	    };
	    /**
	     * Switches between the numeric decimal and hexadecimal states.
	     *
	     * Equivalent to the `Numeric character reference state` in the HTML spec.
	     *
	     * @param str The string containing the entity (or a continuation of the entity).
	     * @param offset The current offset.
	     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
	     */
	    EntityDecoder.prototype.stateNumericStart = function (str, offset) {
	        if (offset >= str.length) {
	            return -1;
	        }
	        if ((str.charCodeAt(offset) | TO_LOWER_BIT) === CharCodes.LOWER_X) {
	            this.state = EntityDecoderState.NumericHex;
	            this.consumed += 1;
	            return this.stateNumericHex(str, offset + 1);
	        }
	        this.state = EntityDecoderState.NumericDecimal;
	        return this.stateNumericDecimal(str, offset);
	    };
	    EntityDecoder.prototype.addToNumericResult = function (str, start, end, base) {
	        if (start !== end) {
	            var digitCount = end - start;
	            this.result =
	                this.result * Math.pow(base, digitCount) +
	                    parseInt(str.substr(start, digitCount), base);
	            this.consumed += digitCount;
	        }
	    };
	    /**
	     * Parses a hexadecimal numeric entity.
	     *
	     * Equivalent to the `Hexademical character reference state` in the HTML spec.
	     *
	     * @param str The string containing the entity (or a continuation of the entity).
	     * @param offset The current offset.
	     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
	     */
	    EntityDecoder.prototype.stateNumericHex = function (str, offset) {
	        var startIdx = offset;
	        while (offset < str.length) {
	            var char = str.charCodeAt(offset);
	            if (isNumber(char) || isHexadecimalCharacter(char)) {
	                offset += 1;
	            }
	            else {
	                this.addToNumericResult(str, startIdx, offset, 16);
	                return this.emitNumericEntity(char, 3);
	            }
	        }
	        this.addToNumericResult(str, startIdx, offset, 16);
	        return -1;
	    };
	    /**
	     * Parses a decimal numeric entity.
	     *
	     * Equivalent to the `Decimal character reference state` in the HTML spec.
	     *
	     * @param str The string containing the entity (or a continuation of the entity).
	     * @param offset The current offset.
	     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
	     */
	    EntityDecoder.prototype.stateNumericDecimal = function (str, offset) {
	        var startIdx = offset;
	        while (offset < str.length) {
	            var char = str.charCodeAt(offset);
	            if (isNumber(char)) {
	                offset += 1;
	            }
	            else {
	                this.addToNumericResult(str, startIdx, offset, 10);
	                return this.emitNumericEntity(char, 2);
	            }
	        }
	        this.addToNumericResult(str, startIdx, offset, 10);
	        return -1;
	    };
	    /**
	     * Validate and emit a numeric entity.
	     *
	     * Implements the logic from the `Hexademical character reference start
	     * state` and `Numeric character reference end state` in the HTML spec.
	     *
	     * @param lastCp The last code point of the entity. Used to see if the
	     *               entity was terminated with a semicolon.
	     * @param expectedLength The minimum number of characters that should be
	     *                       consumed. Used to validate that at least one digit
	     *                       was consumed.
	     * @returns The number of characters that were consumed.
	     */
	    EntityDecoder.prototype.emitNumericEntity = function (lastCp, expectedLength) {
	        var _a;
	        // Ensure we consumed at least one digit.
	        if (this.consumed <= expectedLength) {
	            (_a = this.errors) === null || _a === void 0 ? void 0 : _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
	            return 0;
	        }
	        // Figure out if this is a legit end of the entity
	        if (lastCp === CharCodes.SEMI) {
	            this.consumed += 1;
	        }
	        else if (this.decodeMode === DecodingMode.Strict) {
	            return 0;
	        }
	        this.emitCodePoint((0, decode_codepoint_js_1.replaceCodePoint)(this.result), this.consumed);
	        if (this.errors) {
	            if (lastCp !== CharCodes.SEMI) {
	                this.errors.missingSemicolonAfterCharacterReference();
	            }
	            this.errors.validateNumericCharacterReference(this.result);
	        }
	        return this.consumed;
	    };
	    /**
	     * Parses a named entity.
	     *
	     * Equivalent to the `Named character reference state` in the HTML spec.
	     *
	     * @param str The string containing the entity (or a continuation of the entity).
	     * @param offset The current offset.
	     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
	     */
	    EntityDecoder.prototype.stateNamedEntity = function (str, offset) {
	        var decodeTree = this.decodeTree;
	        var current = decodeTree[this.treeIndex];
	        // The mask is the number of bytes of the value, including the current byte.
	        var valueLength = (current & BinTrieFlags.VALUE_LENGTH) >> 14;
	        for (; offset < str.length; offset++, this.excess++) {
	            var char = str.charCodeAt(offset);
	            this.treeIndex = determineBranch(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
	            if (this.treeIndex < 0) {
	                return this.result === 0 ||
	                    // If we are parsing an attribute
	                    (this.decodeMode === DecodingMode.Attribute &&
	                        // We shouldn't have consumed any characters after the entity,
	                        (valueLength === 0 ||
	                            // And there should be no invalid characters.
	                            isEntityInAttributeInvalidEnd(char)))
	                    ? 0
	                    : this.emitNotTerminatedNamedEntity();
	            }
	            current = decodeTree[this.treeIndex];
	            valueLength = (current & BinTrieFlags.VALUE_LENGTH) >> 14;
	            // If the branch is a value, store it and continue
	            if (valueLength !== 0) {
	                // If the entity is terminated by a semicolon, we are done.
	                if (char === CharCodes.SEMI) {
	                    return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
	                }
	                // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
	                if (this.decodeMode !== DecodingMode.Strict) {
	                    this.result = this.treeIndex;
	                    this.consumed += this.excess;
	                    this.excess = 0;
	                }
	            }
	        }
	        return -1;
	    };
	    /**
	     * Emit a named entity that was not terminated with a semicolon.
	     *
	     * @returns The number of characters consumed.
	     */
	    EntityDecoder.prototype.emitNotTerminatedNamedEntity = function () {
	        var _a;
	        var _b = this, result = _b.result, decodeTree = _b.decodeTree;
	        var valueLength = (decodeTree[result] & BinTrieFlags.VALUE_LENGTH) >> 14;
	        this.emitNamedEntityData(result, valueLength, this.consumed);
	        (_a = this.errors) === null || _a === void 0 ? void 0 : _a.missingSemicolonAfterCharacterReference();
	        return this.consumed;
	    };
	    /**
	     * Emit a named entity.
	     *
	     * @param result The index of the entity in the decode tree.
	     * @param valueLength The number of bytes in the entity.
	     * @param consumed The number of characters consumed.
	     *
	     * @returns The number of characters consumed.
	     */
	    EntityDecoder.prototype.emitNamedEntityData = function (result, valueLength, consumed) {
	        var decodeTree = this.decodeTree;
	        this.emitCodePoint(valueLength === 1
	            ? decodeTree[result] & ~BinTrieFlags.VALUE_LENGTH
	            : decodeTree[result + 1], consumed);
	        if (valueLength === 3) {
	            // For multi-byte values, we need to emit the second byte.
	            this.emitCodePoint(decodeTree[result + 2], consumed);
	        }
	        return consumed;
	    };
	    /**
	     * Signal to the parser that the end of the input was reached.
	     *
	     * Remaining data will be emitted and relevant errors will be produced.
	     *
	     * @returns The number of characters consumed.
	     */
	    EntityDecoder.prototype.end = function () {
	        var _a;
	        switch (this.state) {
	            case EntityDecoderState.NamedEntity: {
	                // Emit a named entity if we have one.
	                return this.result !== 0 &&
	                    (this.decodeMode !== DecodingMode.Attribute ||
	                        this.result === this.treeIndex)
	                    ? this.emitNotTerminatedNamedEntity()
	                    : 0;
	            }
	            // Otherwise, emit a numeric entity if we have one.
	            case EntityDecoderState.NumericDecimal: {
	                return this.emitNumericEntity(0, 2);
	            }
	            case EntityDecoderState.NumericHex: {
	                return this.emitNumericEntity(0, 3);
	            }
	            case EntityDecoderState.NumericStart: {
	                (_a = this.errors) === null || _a === void 0 ? void 0 : _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
	                return 0;
	            }
	            case EntityDecoderState.EntityStart: {
	                // Return 0 if we have no entity.
	                return 0;
	            }
	        }
	    };
	    return EntityDecoder;
	}());
	exports.EntityDecoder = EntityDecoder;
	/**
	 * Creates a function that decodes entities in a string.
	 *
	 * @param decodeTree The decode tree.
	 * @returns A function that decodes entities in a string.
	 */
	function getDecoder(decodeTree) {
	    var ret = "";
	    var decoder = new EntityDecoder(decodeTree, function (str) { return (ret += (0, decode_codepoint_js_1.fromCodePoint)(str)); });
	    return function decodeWithTrie(str, decodeMode) {
	        var lastIndex = 0;
	        var offset = 0;
	        while ((offset = str.indexOf("&", offset)) >= 0) {
	            ret += str.slice(lastIndex, offset);
	            decoder.startEntity(decodeMode);
	            var len = decoder.write(str, 
	            // Skip the "&"
	            offset + 1);
	            if (len < 0) {
	                lastIndex = offset + decoder.end();
	                break;
	            }
	            lastIndex = offset + len;
	            // If `len` is 0, skip the current `&` and continue.
	            offset = len === 0 ? lastIndex + 1 : lastIndex;
	        }
	        var result = ret + str.slice(lastIndex);
	        // Make sure we don't keep a reference to the final string.
	        ret = "";
	        return result;
	    };
	}
	/**
	 * Determines the branch of the current node that is taken given the current
	 * character. This function is used to traverse the trie.
	 *
	 * @param decodeTree The trie.
	 * @param current The current node.
	 * @param nodeIdx The index right after the current node and its value.
	 * @param char The current character.
	 * @returns The index of the next node, or -1 if no branch is taken.
	 */
	function determineBranch(decodeTree, current, nodeIdx, char) {
	    var branchCount = (current & BinTrieFlags.BRANCH_LENGTH) >> 7;
	    var jumpOffset = current & BinTrieFlags.JUMP_TABLE;
	    // Case 1: Single branch encoded in jump offset
	    if (branchCount === 0) {
	        return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
	    }
	    // Case 2: Multiple branches encoded in jump table
	    if (jumpOffset) {
	        var value = char - jumpOffset;
	        return value < 0 || value >= branchCount
	            ? -1
	            : decodeTree[nodeIdx + value] - 1;
	    }
	    // Case 3: Multiple branches encoded in dictionary
	    // Binary search for the character.
	    var lo = nodeIdx;
	    var hi = lo + branchCount - 1;
	    while (lo <= hi) {
	        var mid = (lo + hi) >>> 1;
	        var midVal = decodeTree[mid];
	        if (midVal < char) {
	            lo = mid + 1;
	        }
	        else if (midVal > char) {
	            hi = mid - 1;
	        }
	        else {
	            return decodeTree[mid + branchCount];
	        }
	    }
	    return -1;
	}
	exports.determineBranch = determineBranch;
	var htmlDecoder = getDecoder(decode_data_html_js_1.default);
	var xmlDecoder = getDecoder(decode_data_xml_js_1.default);
	/**
	 * Decodes an HTML string.
	 *
	 * @param str The string to decode.
	 * @param mode The decoding mode.
	 * @returns The decoded string.
	 */
	function decodeHTML(str, mode) {
	    if (mode === void 0) { mode = DecodingMode.Legacy; }
	    return htmlDecoder(str, mode);
	}
	exports.decodeHTML = decodeHTML;
	/**
	 * Decodes an HTML string in an attribute.
	 *
	 * @param str The string to decode.
	 * @returns The decoded string.
	 */
	function decodeHTMLAttribute(str) {
	    return htmlDecoder(str, DecodingMode.Attribute);
	}
	exports.decodeHTMLAttribute = decodeHTMLAttribute;
	/**
	 * Decodes an HTML string, requiring all entities to be terminated by a semicolon.
	 *
	 * @param str The string to decode.
	 * @returns The decoded string.
	 */
	function decodeHTMLStrict(str) {
	    return htmlDecoder(str, DecodingMode.Strict);
	}
	exports.decodeHTMLStrict = decodeHTMLStrict;
	/**
	 * Decodes an XML string, requiring all entities to be terminated by a semicolon.
	 *
	 * @param str The string to decode.
	 * @returns The decoded string.
	 */
	function decodeXML(str) {
	    return xmlDecoder(str, DecodingMode.Strict);
	}
	exports.decodeXML = decodeXML;
	
} (decode));

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.QuoteType = void 0;
	var decode_js_1 = decode;
	var CharCodes;
	(function (CharCodes) {
	    CharCodes[CharCodes["Tab"] = 9] = "Tab";
	    CharCodes[CharCodes["NewLine"] = 10] = "NewLine";
	    CharCodes[CharCodes["FormFeed"] = 12] = "FormFeed";
	    CharCodes[CharCodes["CarriageReturn"] = 13] = "CarriageReturn";
	    CharCodes[CharCodes["Space"] = 32] = "Space";
	    CharCodes[CharCodes["ExclamationMark"] = 33] = "ExclamationMark";
	    CharCodes[CharCodes["Number"] = 35] = "Number";
	    CharCodes[CharCodes["Amp"] = 38] = "Amp";
	    CharCodes[CharCodes["SingleQuote"] = 39] = "SingleQuote";
	    CharCodes[CharCodes["DoubleQuote"] = 34] = "DoubleQuote";
	    CharCodes[CharCodes["Dash"] = 45] = "Dash";
	    CharCodes[CharCodes["Slash"] = 47] = "Slash";
	    CharCodes[CharCodes["Zero"] = 48] = "Zero";
	    CharCodes[CharCodes["Nine"] = 57] = "Nine";
	    CharCodes[CharCodes["Semi"] = 59] = "Semi";
	    CharCodes[CharCodes["Lt"] = 60] = "Lt";
	    CharCodes[CharCodes["Eq"] = 61] = "Eq";
	    CharCodes[CharCodes["Gt"] = 62] = "Gt";
	    CharCodes[CharCodes["Questionmark"] = 63] = "Questionmark";
	    CharCodes[CharCodes["UpperA"] = 65] = "UpperA";
	    CharCodes[CharCodes["LowerA"] = 97] = "LowerA";
	    CharCodes[CharCodes["UpperF"] = 70] = "UpperF";
	    CharCodes[CharCodes["LowerF"] = 102] = "LowerF";
	    CharCodes[CharCodes["UpperZ"] = 90] = "UpperZ";
	    CharCodes[CharCodes["LowerZ"] = 122] = "LowerZ";
	    CharCodes[CharCodes["LowerX"] = 120] = "LowerX";
	    CharCodes[CharCodes["OpeningSquareBracket"] = 91] = "OpeningSquareBracket";
	})(CharCodes || (CharCodes = {}));
	/** All the states the tokenizer can be in. */
	var State;
	(function (State) {
	    State[State["Text"] = 1] = "Text";
	    State[State["BeforeTagName"] = 2] = "BeforeTagName";
	    State[State["InTagName"] = 3] = "InTagName";
	    State[State["InSelfClosingTag"] = 4] = "InSelfClosingTag";
	    State[State["BeforeClosingTagName"] = 5] = "BeforeClosingTagName";
	    State[State["InClosingTagName"] = 6] = "InClosingTagName";
	    State[State["AfterClosingTagName"] = 7] = "AfterClosingTagName";
	    // Attributes
	    State[State["BeforeAttributeName"] = 8] = "BeforeAttributeName";
	    State[State["InAttributeName"] = 9] = "InAttributeName";
	    State[State["AfterAttributeName"] = 10] = "AfterAttributeName";
	    State[State["BeforeAttributeValue"] = 11] = "BeforeAttributeValue";
	    State[State["InAttributeValueDq"] = 12] = "InAttributeValueDq";
	    State[State["InAttributeValueSq"] = 13] = "InAttributeValueSq";
	    State[State["InAttributeValueNq"] = 14] = "InAttributeValueNq";
	    // Declarations
	    State[State["BeforeDeclaration"] = 15] = "BeforeDeclaration";
	    State[State["InDeclaration"] = 16] = "InDeclaration";
	    // Processing instructions
	    State[State["InProcessingInstruction"] = 17] = "InProcessingInstruction";
	    // Comments & CDATA
	    State[State["BeforeComment"] = 18] = "BeforeComment";
	    State[State["CDATASequence"] = 19] = "CDATASequence";
	    State[State["InSpecialComment"] = 20] = "InSpecialComment";
	    State[State["InCommentLike"] = 21] = "InCommentLike";
	    // Special tags
	    State[State["BeforeSpecialS"] = 22] = "BeforeSpecialS";
	    State[State["SpecialStartSequence"] = 23] = "SpecialStartSequence";
	    State[State["InSpecialTag"] = 24] = "InSpecialTag";
	    State[State["BeforeEntity"] = 25] = "BeforeEntity";
	    State[State["BeforeNumericEntity"] = 26] = "BeforeNumericEntity";
	    State[State["InNamedEntity"] = 27] = "InNamedEntity";
	    State[State["InNumericEntity"] = 28] = "InNumericEntity";
	    State[State["InHexEntity"] = 29] = "InHexEntity";
	})(State || (State = {}));
	function isWhitespace(c) {
	    return (c === CharCodes.Space ||
	        c === CharCodes.NewLine ||
	        c === CharCodes.Tab ||
	        c === CharCodes.FormFeed ||
	        c === CharCodes.CarriageReturn);
	}
	function isEndOfTagSection(c) {
	    return c === CharCodes.Slash || c === CharCodes.Gt || isWhitespace(c);
	}
	function isNumber(c) {
	    return c >= CharCodes.Zero && c <= CharCodes.Nine;
	}
	function isASCIIAlpha(c) {
	    return ((c >= CharCodes.LowerA && c <= CharCodes.LowerZ) ||
	        (c >= CharCodes.UpperA && c <= CharCodes.UpperZ));
	}
	function isHexDigit(c) {
	    return ((c >= CharCodes.UpperA && c <= CharCodes.UpperF) ||
	        (c >= CharCodes.LowerA && c <= CharCodes.LowerF));
	}
	var QuoteType;
	(function (QuoteType) {
	    QuoteType[QuoteType["NoValue"] = 0] = "NoValue";
	    QuoteType[QuoteType["Unquoted"] = 1] = "Unquoted";
	    QuoteType[QuoteType["Single"] = 2] = "Single";
	    QuoteType[QuoteType["Double"] = 3] = "Double";
	})(QuoteType = exports.QuoteType || (exports.QuoteType = {}));
	/**
	 * Sequences used to match longer strings.
	 *
	 * We don't have `Script`, `Style`, or `Title` here. Instead, we re-use the *End
	 * sequences with an increased offset.
	 */
	var Sequences = {
	    Cdata: new Uint8Array([0x43, 0x44, 0x41, 0x54, 0x41, 0x5b]),
	    CdataEnd: new Uint8Array([0x5d, 0x5d, 0x3e]),
	    CommentEnd: new Uint8Array([0x2d, 0x2d, 0x3e]),
	    ScriptEnd: new Uint8Array([0x3c, 0x2f, 0x73, 0x63, 0x72, 0x69, 0x70, 0x74]),
	    StyleEnd: new Uint8Array([0x3c, 0x2f, 0x73, 0x74, 0x79, 0x6c, 0x65]),
	    TitleEnd: new Uint8Array([0x3c, 0x2f, 0x74, 0x69, 0x74, 0x6c, 0x65]), // `</title`
	};
	var Tokenizer = /** @class */ (function () {
	    function Tokenizer(_a, cbs) {
	        var _b = _a.xmlMode, xmlMode = _b === void 0 ? false : _b, _c = _a.decodeEntities, decodeEntities = _c === void 0 ? true : _c;
	        this.cbs = cbs;
	        /** The current state the tokenizer is in. */
	        this.state = State.Text;
	        /** The read buffer. */
	        this.buffer = "";
	        /** The beginning of the section that is currently being read. */
	        this.sectionStart = 0;
	        /** The index within the buffer that we are currently looking at. */
	        this.index = 0;
	        /** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */
	        this.baseState = State.Text;
	        /** For special parsing behavior inside of script and style tags. */
	        this.isSpecial = false;
	        /** Indicates whether the tokenizer has been paused. */
	        this.running = true;
	        /** The offset of the current buffer. */
	        this.offset = 0;
	        this.currentSequence = undefined;
	        this.sequenceIndex = 0;
	        this.trieIndex = 0;
	        this.trieCurrent = 0;
	        /** For named entities, the index of the value. For numeric entities, the code point. */
	        this.entityResult = 0;
	        this.entityExcess = 0;
	        this.xmlMode = xmlMode;
	        this.decodeEntities = decodeEntities;
	        this.entityTrie = xmlMode ? decode_js_1.xmlDecodeTree : decode_js_1.htmlDecodeTree;
	    }
	    Tokenizer.prototype.reset = function () {
	        this.state = State.Text;
	        this.buffer = "";
	        this.sectionStart = 0;
	        this.index = 0;
	        this.baseState = State.Text;
	        this.currentSequence = undefined;
	        this.running = true;
	        this.offset = 0;
	    };
	    Tokenizer.prototype.write = function (chunk) {
	        this.offset += this.buffer.length;
	        this.buffer = chunk;
	        this.parse();
	    };
	    Tokenizer.prototype.end = function () {
	        if (this.running)
	            this.finish();
	    };
	    Tokenizer.prototype.pause = function () {
	        this.running = false;
	    };
	    Tokenizer.prototype.resume = function () {
	        this.running = true;
	        if (this.index < this.buffer.length + this.offset) {
	            this.parse();
	        }
	    };
	    /**
	     * The current index within all of the written data.
	     */
	    Tokenizer.prototype.getIndex = function () {
	        return this.index;
	    };
	    /**
	     * The start of the current section.
	     */
	    Tokenizer.prototype.getSectionStart = function () {
	        return this.sectionStart;
	    };
	    Tokenizer.prototype.stateText = function (c) {
	        if (c === CharCodes.Lt ||
	            (!this.decodeEntities && this.fastForwardTo(CharCodes.Lt))) {
	            if (this.index > this.sectionStart) {
	                this.cbs.ontext(this.sectionStart, this.index);
	            }
	            this.state = State.BeforeTagName;
	            this.sectionStart = this.index;
	        }
	        else if (this.decodeEntities && c === CharCodes.Amp) {
	            this.state = State.BeforeEntity;
	        }
	    };
	    Tokenizer.prototype.stateSpecialStartSequence = function (c) {
	        var isEnd = this.sequenceIndex === this.currentSequence.length;
	        var isMatch = isEnd
	            ? // If we are at the end of the sequence, make sure the tag name has ended
	                isEndOfTagSection(c)
	            : // Otherwise, do a case-insensitive comparison
	                (c | 0x20) === this.currentSequence[this.sequenceIndex];
	        if (!isMatch) {
	            this.isSpecial = false;
	        }
	        else if (!isEnd) {
	            this.sequenceIndex++;
	            return;
	        }
	        this.sequenceIndex = 0;
	        this.state = State.InTagName;
	        this.stateInTagName(c);
	    };
	    /** Look for an end tag. For <title> tags, also decode entities. */
	    Tokenizer.prototype.stateInSpecialTag = function (c) {
	        if (this.sequenceIndex === this.currentSequence.length) {
	            if (c === CharCodes.Gt || isWhitespace(c)) {
	                var endOfText = this.index - this.currentSequence.length;
	                if (this.sectionStart < endOfText) {
	                    // Spoof the index so that reported locations match up.
	                    var actualIndex = this.index;
	                    this.index = endOfText;
	                    this.cbs.ontext(this.sectionStart, endOfText);
	                    this.index = actualIndex;
	                }
	                this.isSpecial = false;
	                this.sectionStart = endOfText + 2; // Skip over the `</`
	                this.stateInClosingTagName(c);
	                return; // We are done; skip the rest of the function.
	            }
	            this.sequenceIndex = 0;
	        }
	        if ((c | 0x20) === this.currentSequence[this.sequenceIndex]) {
	            this.sequenceIndex += 1;
	        }
	        else if (this.sequenceIndex === 0) {
	            if (this.currentSequence === Sequences.TitleEnd) {
	                // We have to parse entities in <title> tags.
	                if (this.decodeEntities && c === CharCodes.Amp) {
	                    this.state = State.BeforeEntity;
	                }
	            }
	            else if (this.fastForwardTo(CharCodes.Lt)) {
	                // Outside of <title> tags, we can fast-forward.
	                this.sequenceIndex = 1;
	            }
	        }
	        else {
	            // If we see a `<`, set the sequence index to 1; useful for eg. `<</script>`.
	            this.sequenceIndex = Number(c === CharCodes.Lt);
	        }
	    };
	    Tokenizer.prototype.stateCDATASequence = function (c) {
	        if (c === Sequences.Cdata[this.sequenceIndex]) {
	            if (++this.sequenceIndex === Sequences.Cdata.length) {
	                this.state = State.InCommentLike;
	                this.currentSequence = Sequences.CdataEnd;
	                this.sequenceIndex = 0;
	                this.sectionStart = this.index + 1;
	            }
	        }
	        else {
	            this.sequenceIndex = 0;
	            this.state = State.InDeclaration;
	            this.stateInDeclaration(c); // Reconsume the character
	        }
	    };
	    /**
	     * When we wait for one specific character, we can speed things up
	     * by skipping through the buffer until we find it.
	     *
	     * @returns Whether the character was found.
	     */
	    Tokenizer.prototype.fastForwardTo = function (c) {
	        while (++this.index < this.buffer.length + this.offset) {
	            if (this.buffer.charCodeAt(this.index - this.offset) === c) {
	                return true;
	            }
	        }
	        /*
	         * We increment the index at the end of the `parse` loop,
	         * so set it to `buffer.length - 1` here.
	         *
	         * TODO: Refactor `parse` to increment index before calling states.
	         */
	        this.index = this.buffer.length + this.offset - 1;
	        return false;
	    };
	    /**
	     * Comments and CDATA end with `-->` and `]]>`.
	     *
	     * Their common qualities are:
	     * - Their end sequences have a distinct character they start with.
	     * - That character is then repeated, so we have to check multiple repeats.
	     * - All characters but the start character of the sequence can be skipped.
	     */
	    Tokenizer.prototype.stateInCommentLike = function (c) {
	        if (c === this.currentSequence[this.sequenceIndex]) {
	            if (++this.sequenceIndex === this.currentSequence.length) {
	                if (this.currentSequence === Sequences.CdataEnd) {
	                    this.cbs.oncdata(this.sectionStart, this.index, 2);
	                }
	                else {
	                    this.cbs.oncomment(this.sectionStart, this.index, 2);
	                }
	                this.sequenceIndex = 0;
	                this.sectionStart = this.index + 1;
	                this.state = State.Text;
	            }
	        }
	        else if (this.sequenceIndex === 0) {
	            // Fast-forward to the first character of the sequence
	            if (this.fastForwardTo(this.currentSequence[0])) {
	                this.sequenceIndex = 1;
	            }
	        }
	        else if (c !== this.currentSequence[this.sequenceIndex - 1]) {
	            // Allow long sequences, eg. --->, ]]]>
	            this.sequenceIndex = 0;
	        }
	    };
	    /**
	     * HTML only allows ASCII alpha characters (a-z and A-Z) at the beginning of a tag name.
	     *
	     * XML allows a lot more characters here (@see https://www.w3.org/TR/REC-xml/#NT-NameStartChar).
	     * We allow anything that wouldn't end the tag.
	     */
	    Tokenizer.prototype.isTagStartChar = function (c) {
	        return this.xmlMode ? !isEndOfTagSection(c) : isASCIIAlpha(c);
	    };
	    Tokenizer.prototype.startSpecial = function (sequence, offset) {
	        this.isSpecial = true;
	        this.currentSequence = sequence;
	        this.sequenceIndex = offset;
	        this.state = State.SpecialStartSequence;
	    };
	    Tokenizer.prototype.stateBeforeTagName = function (c) {
	        if (c === CharCodes.ExclamationMark) {
	            this.state = State.BeforeDeclaration;
	            this.sectionStart = this.index + 1;
	        }
	        else if (c === CharCodes.Questionmark) {
	            this.state = State.InProcessingInstruction;
	            this.sectionStart = this.index + 1;
	        }
	        else if (this.isTagStartChar(c)) {
	            var lower = c | 0x20;
	            this.sectionStart = this.index;
	            if (!this.xmlMode && lower === Sequences.TitleEnd[2]) {
	                this.startSpecial(Sequences.TitleEnd, 3);
	            }
	            else {
	                this.state =
	                    !this.xmlMode && lower === Sequences.ScriptEnd[2]
	                        ? State.BeforeSpecialS
	                        : State.InTagName;
	            }
	        }
	        else if (c === CharCodes.Slash) {
	            this.state = State.BeforeClosingTagName;
	        }
	        else {
	            this.state = State.Text;
	            this.stateText(c);
	        }
	    };
	    Tokenizer.prototype.stateInTagName = function (c) {
	        if (isEndOfTagSection(c)) {
	            this.cbs.onopentagname(this.sectionStart, this.index);
	            this.sectionStart = -1;
	            this.state = State.BeforeAttributeName;
	            this.stateBeforeAttributeName(c);
	        }
	    };
	    Tokenizer.prototype.stateBeforeClosingTagName = function (c) {
	        if (isWhitespace(c)) ;
	        else if (c === CharCodes.Gt) {
	            this.state = State.Text;
	        }
	        else {
	            this.state = this.isTagStartChar(c)
	                ? State.InClosingTagName
	                : State.InSpecialComment;
	            this.sectionStart = this.index;
	        }
	    };
	    Tokenizer.prototype.stateInClosingTagName = function (c) {
	        if (c === CharCodes.Gt || isWhitespace(c)) {
	            this.cbs.onclosetag(this.sectionStart, this.index);
	            this.sectionStart = -1;
	            this.state = State.AfterClosingTagName;
	            this.stateAfterClosingTagName(c);
	        }
	    };
	    Tokenizer.prototype.stateAfterClosingTagName = function (c) {
	        // Skip everything until ">"
	        if (c === CharCodes.Gt || this.fastForwardTo(CharCodes.Gt)) {
	            this.state = State.Text;
	            this.baseState = State.Text;
	            this.sectionStart = this.index + 1;
	        }
	    };
	    Tokenizer.prototype.stateBeforeAttributeName = function (c) {
	        if (c === CharCodes.Gt) {
	            this.cbs.onopentagend(this.index);
	            if (this.isSpecial) {
	                this.state = State.InSpecialTag;
	                this.sequenceIndex = 0;
	            }
	            else {
	                this.state = State.Text;
	            }
	            this.baseState = this.state;
	            this.sectionStart = this.index + 1;
	        }
	        else if (c === CharCodes.Slash) {
	            this.state = State.InSelfClosingTag;
	        }
	        else if (!isWhitespace(c)) {
	            this.state = State.InAttributeName;
	            this.sectionStart = this.index;
	        }
	    };
	    Tokenizer.prototype.stateInSelfClosingTag = function (c) {
	        if (c === CharCodes.Gt) {
	            this.cbs.onselfclosingtag(this.index);
	            this.state = State.Text;
	            this.baseState = State.Text;
	            this.sectionStart = this.index + 1;
	            this.isSpecial = false; // Reset special state, in case of self-closing special tags
	        }
	        else if (!isWhitespace(c)) {
	            this.state = State.BeforeAttributeName;
	            this.stateBeforeAttributeName(c);
	        }
	    };
	    Tokenizer.prototype.stateInAttributeName = function (c) {
	        if (c === CharCodes.Eq || isEndOfTagSection(c)) {
	            this.cbs.onattribname(this.sectionStart, this.index);
	            this.sectionStart = -1;
	            this.state = State.AfterAttributeName;
	            this.stateAfterAttributeName(c);
	        }
	    };
	    Tokenizer.prototype.stateAfterAttributeName = function (c) {
	        if (c === CharCodes.Eq) {
	            this.state = State.BeforeAttributeValue;
	        }
	        else if (c === CharCodes.Slash || c === CharCodes.Gt) {
	            this.cbs.onattribend(QuoteType.NoValue, this.index);
	            this.state = State.BeforeAttributeName;
	            this.stateBeforeAttributeName(c);
	        }
	        else if (!isWhitespace(c)) {
	            this.cbs.onattribend(QuoteType.NoValue, this.index);
	            this.state = State.InAttributeName;
	            this.sectionStart = this.index;
	        }
	    };
	    Tokenizer.prototype.stateBeforeAttributeValue = function (c) {
	        if (c === CharCodes.DoubleQuote) {
	            this.state = State.InAttributeValueDq;
	            this.sectionStart = this.index + 1;
	        }
	        else if (c === CharCodes.SingleQuote) {
	            this.state = State.InAttributeValueSq;
	            this.sectionStart = this.index + 1;
	        }
	        else if (!isWhitespace(c)) {
	            this.sectionStart = this.index;
	            this.state = State.InAttributeValueNq;
	            this.stateInAttributeValueNoQuotes(c); // Reconsume token
	        }
	    };
	    Tokenizer.prototype.handleInAttributeValue = function (c, quote) {
	        if (c === quote ||
	            (!this.decodeEntities && this.fastForwardTo(quote))) {
	            this.cbs.onattribdata(this.sectionStart, this.index);
	            this.sectionStart = -1;
	            this.cbs.onattribend(quote === CharCodes.DoubleQuote
	                ? QuoteType.Double
	                : QuoteType.Single, this.index);
	            this.state = State.BeforeAttributeName;
	        }
	        else if (this.decodeEntities && c === CharCodes.Amp) {
	            this.baseState = this.state;
	            this.state = State.BeforeEntity;
	        }
	    };
	    Tokenizer.prototype.stateInAttributeValueDoubleQuotes = function (c) {
	        this.handleInAttributeValue(c, CharCodes.DoubleQuote);
	    };
	    Tokenizer.prototype.stateInAttributeValueSingleQuotes = function (c) {
	        this.handleInAttributeValue(c, CharCodes.SingleQuote);
	    };
	    Tokenizer.prototype.stateInAttributeValueNoQuotes = function (c) {
	        if (isWhitespace(c) || c === CharCodes.Gt) {
	            this.cbs.onattribdata(this.sectionStart, this.index);
	            this.sectionStart = -1;
	            this.cbs.onattribend(QuoteType.Unquoted, this.index);
	            this.state = State.BeforeAttributeName;
	            this.stateBeforeAttributeName(c);
	        }
	        else if (this.decodeEntities && c === CharCodes.Amp) {
	            this.baseState = this.state;
	            this.state = State.BeforeEntity;
	        }
	    };
	    Tokenizer.prototype.stateBeforeDeclaration = function (c) {
	        if (c === CharCodes.OpeningSquareBracket) {
	            this.state = State.CDATASequence;
	            this.sequenceIndex = 0;
	        }
	        else {
	            this.state =
	                c === CharCodes.Dash
	                    ? State.BeforeComment
	                    : State.InDeclaration;
	        }
	    };
	    Tokenizer.prototype.stateInDeclaration = function (c) {
	        if (c === CharCodes.Gt || this.fastForwardTo(CharCodes.Gt)) {
	            this.cbs.ondeclaration(this.sectionStart, this.index);
	            this.state = State.Text;
	            this.sectionStart = this.index + 1;
	        }
	    };
	    Tokenizer.prototype.stateInProcessingInstruction = function (c) {
	        if (c === CharCodes.Gt || this.fastForwardTo(CharCodes.Gt)) {
	            this.cbs.onprocessinginstruction(this.sectionStart, this.index);
	            this.state = State.Text;
	            this.sectionStart = this.index + 1;
	        }
	    };
	    Tokenizer.prototype.stateBeforeComment = function (c) {
	        if (c === CharCodes.Dash) {
	            this.state = State.InCommentLike;
	            this.currentSequence = Sequences.CommentEnd;
	            // Allow short comments (eg. <!-->)
	            this.sequenceIndex = 2;
	            this.sectionStart = this.index + 1;
	        }
	        else {
	            this.state = State.InDeclaration;
	        }
	    };
	    Tokenizer.prototype.stateInSpecialComment = function (c) {
	        if (c === CharCodes.Gt || this.fastForwardTo(CharCodes.Gt)) {
	            this.cbs.oncomment(this.sectionStart, this.index, 0);
	            this.state = State.Text;
	            this.sectionStart = this.index + 1;
	        }
	    };
	    Tokenizer.prototype.stateBeforeSpecialS = function (c) {
	        var lower = c | 0x20;
	        if (lower === Sequences.ScriptEnd[3]) {
	            this.startSpecial(Sequences.ScriptEnd, 4);
	        }
	        else if (lower === Sequences.StyleEnd[3]) {
	            this.startSpecial(Sequences.StyleEnd, 4);
	        }
	        else {
	            this.state = State.InTagName;
	            this.stateInTagName(c); // Consume the token again
	        }
	    };
	    Tokenizer.prototype.stateBeforeEntity = function (c) {
	        // Start excess with 1 to include the '&'
	        this.entityExcess = 1;
	        this.entityResult = 0;
	        if (c === CharCodes.Number) {
	            this.state = State.BeforeNumericEntity;
	        }
	        else if (c === CharCodes.Amp) ;
	        else {
	            this.trieIndex = 0;
	            this.trieCurrent = this.entityTrie[0];
	            this.state = State.InNamedEntity;
	            this.stateInNamedEntity(c);
	        }
	    };
	    Tokenizer.prototype.stateInNamedEntity = function (c) {
	        this.entityExcess += 1;
	        this.trieIndex = (0, decode_js_1.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, c);
	        if (this.trieIndex < 0) {
	            this.emitNamedEntity();
	            this.index--;
	            return;
	        }
	        this.trieCurrent = this.entityTrie[this.trieIndex];
	        var masked = this.trieCurrent & decode_js_1.BinTrieFlags.VALUE_LENGTH;
	        // If the branch is a value, store it and continue
	        if (masked) {
	            // The mask is the number of bytes of the value, including the current byte.
	            var valueLength = (masked >> 14) - 1;
	            // If we have a legacy entity while parsing strictly, just skip the number of bytes
	            if (!this.allowLegacyEntity() && c !== CharCodes.Semi) {
	                this.trieIndex += valueLength;
	            }
	            else {
	                // Add 1 as we have already incremented the excess
	                var entityStart = this.index - this.entityExcess + 1;
	                if (entityStart > this.sectionStart) {
	                    this.emitPartial(this.sectionStart, entityStart);
	                }
	                // If this is a surrogate pair, consume the next two bytes
	                this.entityResult = this.trieIndex;
	                this.trieIndex += valueLength;
	                this.entityExcess = 0;
	                this.sectionStart = this.index + 1;
	                if (valueLength === 0) {
	                    this.emitNamedEntity();
	                }
	            }
	        }
	    };
	    Tokenizer.prototype.emitNamedEntity = function () {
	        this.state = this.baseState;
	        if (this.entityResult === 0) {
	            return;
	        }
	        var valueLength = (this.entityTrie[this.entityResult] & decode_js_1.BinTrieFlags.VALUE_LENGTH) >>
	            14;
	        switch (valueLength) {
	            case 1: {
	                this.emitCodePoint(this.entityTrie[this.entityResult] &
	                    ~decode_js_1.BinTrieFlags.VALUE_LENGTH);
	                break;
	            }
	            case 2: {
	                this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
	                break;
	            }
	            case 3: {
	                this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
	                this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
	            }
	        }
	    };
	    Tokenizer.prototype.stateBeforeNumericEntity = function (c) {
	        if ((c | 0x20) === CharCodes.LowerX) {
	            this.entityExcess++;
	            this.state = State.InHexEntity;
	        }
	        else {
	            this.state = State.InNumericEntity;
	            this.stateInNumericEntity(c);
	        }
	    };
	    Tokenizer.prototype.emitNumericEntity = function (strict) {
	        var entityStart = this.index - this.entityExcess - 1;
	        var numberStart = entityStart + 2 + Number(this.state === State.InHexEntity);
	        if (numberStart !== this.index) {
	            // Emit leading data if any
	            if (entityStart > this.sectionStart) {
	                this.emitPartial(this.sectionStart, entityStart);
	            }
	            this.sectionStart = this.index + Number(strict);
	            this.emitCodePoint((0, decode_js_1.replaceCodePoint)(this.entityResult));
	        }
	        this.state = this.baseState;
	    };
	    Tokenizer.prototype.stateInNumericEntity = function (c) {
	        if (c === CharCodes.Semi) {
	            this.emitNumericEntity(true);
	        }
	        else if (isNumber(c)) {
	            this.entityResult = this.entityResult * 10 + (c - CharCodes.Zero);
	            this.entityExcess++;
	        }
	        else {
	            if (this.allowLegacyEntity()) {
	                this.emitNumericEntity(false);
	            }
	            else {
	                this.state = this.baseState;
	            }
	            this.index--;
	        }
	    };
	    Tokenizer.prototype.stateInHexEntity = function (c) {
	        if (c === CharCodes.Semi) {
	            this.emitNumericEntity(true);
	        }
	        else if (isNumber(c)) {
	            this.entityResult = this.entityResult * 16 + (c - CharCodes.Zero);
	            this.entityExcess++;
	        }
	        else if (isHexDigit(c)) {
	            this.entityResult =
	                this.entityResult * 16 + ((c | 0x20) - CharCodes.LowerA + 10);
	            this.entityExcess++;
	        }
	        else {
	            if (this.allowLegacyEntity()) {
	                this.emitNumericEntity(false);
	            }
	            else {
	                this.state = this.baseState;
	            }
	            this.index--;
	        }
	    };
	    Tokenizer.prototype.allowLegacyEntity = function () {
	        return (!this.xmlMode &&
	            (this.baseState === State.Text ||
	                this.baseState === State.InSpecialTag));
	    };
	    /**
	     * Remove data that has already been consumed from the buffer.
	     */
	    Tokenizer.prototype.cleanup = function () {
	        // If we are inside of text or attributes, emit what we already have.
	        if (this.running && this.sectionStart !== this.index) {
	            if (this.state === State.Text ||
	                (this.state === State.InSpecialTag && this.sequenceIndex === 0)) {
	                this.cbs.ontext(this.sectionStart, this.index);
	                this.sectionStart = this.index;
	            }
	            else if (this.state === State.InAttributeValueDq ||
	                this.state === State.InAttributeValueSq ||
	                this.state === State.InAttributeValueNq) {
	                this.cbs.onattribdata(this.sectionStart, this.index);
	                this.sectionStart = this.index;
	            }
	        }
	    };
	    Tokenizer.prototype.shouldContinue = function () {
	        return this.index < this.buffer.length + this.offset && this.running;
	    };
	    /**
	     * Iterates through the buffer, calling the function corresponding to the current state.
	     *
	     * States that are more likely to be hit are higher up, as a performance improvement.
	     */
	    Tokenizer.prototype.parse = function () {
	        while (this.shouldContinue()) {
	            var c = this.buffer.charCodeAt(this.index - this.offset);
	            switch (this.state) {
	                case State.Text: {
	                    this.stateText(c);
	                    break;
	                }
	                case State.SpecialStartSequence: {
	                    this.stateSpecialStartSequence(c);
	                    break;
	                }
	                case State.InSpecialTag: {
	                    this.stateInSpecialTag(c);
	                    break;
	                }
	                case State.CDATASequence: {
	                    this.stateCDATASequence(c);
	                    break;
	                }
	                case State.InAttributeValueDq: {
	                    this.stateInAttributeValueDoubleQuotes(c);
	                    break;
	                }
	                case State.InAttributeName: {
	                    this.stateInAttributeName(c);
	                    break;
	                }
	                case State.InCommentLike: {
	                    this.stateInCommentLike(c);
	                    break;
	                }
	                case State.InSpecialComment: {
	                    this.stateInSpecialComment(c);
	                    break;
	                }
	                case State.BeforeAttributeName: {
	                    this.stateBeforeAttributeName(c);
	                    break;
	                }
	                case State.InTagName: {
	                    this.stateInTagName(c);
	                    break;
	                }
	                case State.InClosingTagName: {
	                    this.stateInClosingTagName(c);
	                    break;
	                }
	                case State.BeforeTagName: {
	                    this.stateBeforeTagName(c);
	                    break;
	                }
	                case State.AfterAttributeName: {
	                    this.stateAfterAttributeName(c);
	                    break;
	                }
	                case State.InAttributeValueSq: {
	                    this.stateInAttributeValueSingleQuotes(c);
	                    break;
	                }
	                case State.BeforeAttributeValue: {
	                    this.stateBeforeAttributeValue(c);
	                    break;
	                }
	                case State.BeforeClosingTagName: {
	                    this.stateBeforeClosingTagName(c);
	                    break;
	                }
	                case State.AfterClosingTagName: {
	                    this.stateAfterClosingTagName(c);
	                    break;
	                }
	                case State.BeforeSpecialS: {
	                    this.stateBeforeSpecialS(c);
	                    break;
	                }
	                case State.InAttributeValueNq: {
	                    this.stateInAttributeValueNoQuotes(c);
	                    break;
	                }
	                case State.InSelfClosingTag: {
	                    this.stateInSelfClosingTag(c);
	                    break;
	                }
	                case State.InDeclaration: {
	                    this.stateInDeclaration(c);
	                    break;
	                }
	                case State.BeforeDeclaration: {
	                    this.stateBeforeDeclaration(c);
	                    break;
	                }
	                case State.BeforeComment: {
	                    this.stateBeforeComment(c);
	                    break;
	                }
	                case State.InProcessingInstruction: {
	                    this.stateInProcessingInstruction(c);
	                    break;
	                }
	                case State.InNamedEntity: {
	                    this.stateInNamedEntity(c);
	                    break;
	                }
	                case State.BeforeEntity: {
	                    this.stateBeforeEntity(c);
	                    break;
	                }
	                case State.InHexEntity: {
	                    this.stateInHexEntity(c);
	                    break;
	                }
	                case State.InNumericEntity: {
	                    this.stateInNumericEntity(c);
	                    break;
	                }
	                default: {
	                    // `this._state === State.BeforeNumericEntity`
	                    this.stateBeforeNumericEntity(c);
	                }
	            }
	            this.index++;
	        }
	        this.cleanup();
	    };
	    Tokenizer.prototype.finish = function () {
	        if (this.state === State.InNamedEntity) {
	            this.emitNamedEntity();
	        }
	        // If there is remaining data, emit it in a reasonable way
	        if (this.sectionStart < this.index) {
	            this.handleTrailingData();
	        }
	        this.cbs.onend();
	    };
	    /** Handle any trailing data. */
	    Tokenizer.prototype.handleTrailingData = function () {
	        var endIndex = this.buffer.length + this.offset;
	        if (this.state === State.InCommentLike) {
	            if (this.currentSequence === Sequences.CdataEnd) {
	                this.cbs.oncdata(this.sectionStart, endIndex, 0);
	            }
	            else {
	                this.cbs.oncomment(this.sectionStart, endIndex, 0);
	            }
	        }
	        else if (this.state === State.InNumericEntity &&
	            this.allowLegacyEntity()) {
	            this.emitNumericEntity(false);
	            // All trailing data will have been consumed
	        }
	        else if (this.state === State.InHexEntity &&
	            this.allowLegacyEntity()) {
	            this.emitNumericEntity(false);
	            // All trailing data will have been consumed
	        }
	        else if (this.state === State.InTagName ||
	            this.state === State.BeforeAttributeName ||
	            this.state === State.BeforeAttributeValue ||
	            this.state === State.AfterAttributeName ||
	            this.state === State.InAttributeName ||
	            this.state === State.InAttributeValueSq ||
	            this.state === State.InAttributeValueDq ||
	            this.state === State.InAttributeValueNq ||
	            this.state === State.InClosingTagName) ;
	        else {
	            this.cbs.ontext(this.sectionStart, endIndex);
	        }
	    };
	    Tokenizer.prototype.emitPartial = function (start, endIndex) {
	        if (this.baseState !== State.Text &&
	            this.baseState !== State.InSpecialTag) {
	            this.cbs.onattribdata(start, endIndex);
	        }
	        else {
	            this.cbs.ontext(start, endIndex);
	        }
	    };
	    Tokenizer.prototype.emitCodePoint = function (cp) {
	        if (this.baseState !== State.Text &&
	            this.baseState !== State.InSpecialTag) {
	            this.cbs.onattribentity(cp);
	        }
	        else {
	            this.cbs.ontextentity(cp);
	        }
	    };
	    return Tokenizer;
	}());
	exports.default = Tokenizer;
	
} (Tokenizer$1));

var __createBinding$1 = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault$1 = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar$1 = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1(result, mod, k);
    __setModuleDefault$1(result, mod);
    return result;
};
Object.defineProperty(Parser$4, "__esModule", { value: true });
Parser$4.Parser = void 0;
var Tokenizer_js_1 = __importStar$1(Tokenizer$1);
var decode_js_1 = decode;
var formTags = new Set([
    "input",
    "option",
    "optgroup",
    "select",
    "button",
    "datalist",
    "textarea",
]);
var pTag = new Set(["p"]);
var tableSectionTags = new Set(["thead", "tbody"]);
var ddtTags = new Set(["dd", "dt"]);
var rtpTags = new Set(["rt", "rp"]);
var openImpliesClose = new Map([
    ["tr", new Set(["tr", "th", "td"])],
    ["th", new Set(["th"])],
    ["td", new Set(["thead", "th", "td"])],
    ["body", new Set(["head", "link", "script"])],
    ["li", new Set(["li"])],
    ["p", pTag],
    ["h1", pTag],
    ["h2", pTag],
    ["h3", pTag],
    ["h4", pTag],
    ["h5", pTag],
    ["h6", pTag],
    ["select", formTags],
    ["input", formTags],
    ["output", formTags],
    ["button", formTags],
    ["datalist", formTags],
    ["textarea", formTags],
    ["option", new Set(["option"])],
    ["optgroup", new Set(["optgroup", "option"])],
    ["dd", ddtTags],
    ["dt", ddtTags],
    ["address", pTag],
    ["article", pTag],
    ["aside", pTag],
    ["blockquote", pTag],
    ["details", pTag],
    ["div", pTag],
    ["dl", pTag],
    ["fieldset", pTag],
    ["figcaption", pTag],
    ["figure", pTag],
    ["footer", pTag],
    ["form", pTag],
    ["header", pTag],
    ["hr", pTag],
    ["main", pTag],
    ["nav", pTag],
    ["ol", pTag],
    ["pre", pTag],
    ["section", pTag],
    ["table", pTag],
    ["ul", pTag],
    ["rt", rtpTags],
    ["rp", rtpTags],
    ["tbody", tableSectionTags],
    ["tfoot", tableSectionTags],
]);
var voidElements = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr",
]);
var foreignContextElements = new Set(["math", "svg"]);
var htmlIntegrationElements = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignobject",
    "desc",
    "title",
]);
var reNameEnd = /\s|\//;
var Parser$3 = /** @class */ (function () {
    function Parser(cbs, options) {
        if (options === void 0) { options = {}; }
        var _a, _b, _c, _d, _e;
        this.options = options;
        /** The start index of the last event. */
        this.startIndex = 0;
        /** The end index of the last event. */
        this.endIndex = 0;
        /**
         * Store the start index of the current open tag,
         * so we can update the start index for attributes.
         */
        this.openTagStart = 0;
        this.tagname = "";
        this.attribname = "";
        this.attribvalue = "";
        this.attribs = null;
        this.stack = [];
        this.foreignContext = [];
        this.buffers = [];
        this.bufferOffset = 0;
        /** The index of the last written buffer. Used when resuming after a `pause()`. */
        this.writeIndex = 0;
        /** Indicates whether the parser has finished running / `.end` has been called. */
        this.ended = false;
        this.cbs = cbs !== null && cbs !== void 0 ? cbs : {};
        this.lowerCaseTagNames = (_a = options.lowerCaseTags) !== null && _a !== void 0 ? _a : !options.xmlMode;
        this.lowerCaseAttributeNames =
            (_b = options.lowerCaseAttributeNames) !== null && _b !== void 0 ? _b : !options.xmlMode;
        this.tokenizer = new ((_c = options.Tokenizer) !== null && _c !== void 0 ? _c : Tokenizer_js_1.default)(this.options, this);
        (_e = (_d = this.cbs).onparserinit) === null || _e === void 0 ? void 0 : _e.call(_d, this);
    }
    // Tokenizer event handlers
    /** @internal */
    Parser.prototype.ontext = function (start, endIndex) {
        var _a, _b;
        var data = this.getSlice(start, endIndex);
        this.endIndex = endIndex - 1;
        (_b = (_a = this.cbs).ontext) === null || _b === void 0 ? void 0 : _b.call(_a, data);
        this.startIndex = endIndex;
    };
    /** @internal */
    Parser.prototype.ontextentity = function (cp) {
        var _a, _b;
        /*
         * Entities can be emitted on the character, or directly after.
         * We use the section start here to get accurate indices.
         */
        var index = this.tokenizer.getSectionStart();
        this.endIndex = index - 1;
        (_b = (_a = this.cbs).ontext) === null || _b === void 0 ? void 0 : _b.call(_a, (0, decode_js_1.fromCodePoint)(cp));
        this.startIndex = index;
    };
    Parser.prototype.isVoidElement = function (name) {
        return !this.options.xmlMode && voidElements.has(name);
    };
    /** @internal */
    Parser.prototype.onopentagname = function (start, endIndex) {
        this.endIndex = endIndex;
        var name = this.getSlice(start, endIndex);
        if (this.lowerCaseTagNames) {
            name = name.toLowerCase();
        }
        this.emitOpenTag(name);
    };
    Parser.prototype.emitOpenTag = function (name) {
        var _a, _b, _c, _d;
        this.openTagStart = this.startIndex;
        this.tagname = name;
        var impliesClose = !this.options.xmlMode && openImpliesClose.get(name);
        if (impliesClose) {
            while (this.stack.length > 0 &&
                impliesClose.has(this.stack[this.stack.length - 1])) {
                var element = this.stack.pop();
                (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 ? void 0 : _b.call(_a, element, true);
            }
        }
        if (!this.isVoidElement(name)) {
            this.stack.push(name);
            if (foreignContextElements.has(name)) {
                this.foreignContext.push(true);
            }
            else if (htmlIntegrationElements.has(name)) {
                this.foreignContext.push(false);
            }
        }
        (_d = (_c = this.cbs).onopentagname) === null || _d === void 0 ? void 0 : _d.call(_c, name);
        if (this.cbs.onopentag)
            this.attribs = {};
    };
    Parser.prototype.endOpenTag = function (isImplied) {
        var _a, _b;
        this.startIndex = this.openTagStart;
        if (this.attribs) {
            (_b = (_a = this.cbs).onopentag) === null || _b === void 0 ? void 0 : _b.call(_a, this.tagname, this.attribs, isImplied);
            this.attribs = null;
        }
        if (this.cbs.onclosetag && this.isVoidElement(this.tagname)) {
            this.cbs.onclosetag(this.tagname, true);
        }
        this.tagname = "";
    };
    /** @internal */
    Parser.prototype.onopentagend = function (endIndex) {
        this.endIndex = endIndex;
        this.endOpenTag(false);
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    };
    /** @internal */
    Parser.prototype.onclosetag = function (start, endIndex) {
        var _a, _b, _c, _d, _e, _f;
        this.endIndex = endIndex;
        var name = this.getSlice(start, endIndex);
        if (this.lowerCaseTagNames) {
            name = name.toLowerCase();
        }
        if (foreignContextElements.has(name) ||
            htmlIntegrationElements.has(name)) {
            this.foreignContext.pop();
        }
        if (!this.isVoidElement(name)) {
            var pos = this.stack.lastIndexOf(name);
            if (pos !== -1) {
                if (this.cbs.onclosetag) {
                    var count = this.stack.length - pos;
                    while (count--) {
                        // We know the stack has sufficient elements.
                        this.cbs.onclosetag(this.stack.pop(), count !== 0);
                    }
                }
                else
                    this.stack.length = pos;
            }
            else if (!this.options.xmlMode && name === "p") {
                // Implicit open before close
                this.emitOpenTag("p");
                this.closeCurrentTag(true);
            }
        }
        else if (!this.options.xmlMode && name === "br") {
            // We can't use `emitOpenTag` for implicit open, as `br` would be implicitly closed.
            (_b = (_a = this.cbs).onopentagname) === null || _b === void 0 ? void 0 : _b.call(_a, "br");
            (_d = (_c = this.cbs).onopentag) === null || _d === void 0 ? void 0 : _d.call(_c, "br", {}, true);
            (_f = (_e = this.cbs).onclosetag) === null || _f === void 0 ? void 0 : _f.call(_e, "br", false);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    };
    /** @internal */
    Parser.prototype.onselfclosingtag = function (endIndex) {
        this.endIndex = endIndex;
        if (this.options.xmlMode ||
            this.options.recognizeSelfClosing ||
            this.foreignContext[this.foreignContext.length - 1]) {
            this.closeCurrentTag(false);
            // Set `startIndex` for next node
            this.startIndex = endIndex + 1;
        }
        else {
            // Ignore the fact that the tag is self-closing.
            this.onopentagend(endIndex);
        }
    };
    Parser.prototype.closeCurrentTag = function (isOpenImplied) {
        var _a, _b;
        var name = this.tagname;
        this.endOpenTag(isOpenImplied);
        // Self-closing tags will be on the top of the stack
        if (this.stack[this.stack.length - 1] === name) {
            // If the opening tag isn't implied, the closing tag has to be implied.
            (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 ? void 0 : _b.call(_a, name, !isOpenImplied);
            this.stack.pop();
        }
    };
    /** @internal */
    Parser.prototype.onattribname = function (start, endIndex) {
        this.startIndex = start;
        var name = this.getSlice(start, endIndex);
        this.attribname = this.lowerCaseAttributeNames
            ? name.toLowerCase()
            : name;
    };
    /** @internal */
    Parser.prototype.onattribdata = function (start, endIndex) {
        this.attribvalue += this.getSlice(start, endIndex);
    };
    /** @internal */
    Parser.prototype.onattribentity = function (cp) {
        this.attribvalue += (0, decode_js_1.fromCodePoint)(cp);
    };
    /** @internal */
    Parser.prototype.onattribend = function (quote, endIndex) {
        var _a, _b;
        this.endIndex = endIndex;
        (_b = (_a = this.cbs).onattribute) === null || _b === void 0 ? void 0 : _b.call(_a, this.attribname, this.attribvalue, quote === Tokenizer_js_1.QuoteType.Double
            ? '"'
            : quote === Tokenizer_js_1.QuoteType.Single
                ? "'"
                : quote === Tokenizer_js_1.QuoteType.NoValue
                    ? undefined
                    : null);
        if (this.attribs &&
            !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname)) {
            this.attribs[this.attribname] = this.attribvalue;
        }
        this.attribvalue = "";
    };
    Parser.prototype.getInstructionName = function (value) {
        var index = value.search(reNameEnd);
        var name = index < 0 ? value : value.substr(0, index);
        if (this.lowerCaseTagNames) {
            name = name.toLowerCase();
        }
        return name;
    };
    /** @internal */
    Parser.prototype.ondeclaration = function (start, endIndex) {
        this.endIndex = endIndex;
        var value = this.getSlice(start, endIndex);
        if (this.cbs.onprocessinginstruction) {
            var name = this.getInstructionName(value);
            this.cbs.onprocessinginstruction("!".concat(name), "!".concat(value));
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    };
    /** @internal */
    Parser.prototype.onprocessinginstruction = function (start, endIndex) {
        this.endIndex = endIndex;
        var value = this.getSlice(start, endIndex);
        if (this.cbs.onprocessinginstruction) {
            var name = this.getInstructionName(value);
            this.cbs.onprocessinginstruction("?".concat(name), "?".concat(value));
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    };
    /** @internal */
    Parser.prototype.oncomment = function (start, endIndex, offset) {
        var _a, _b, _c, _d;
        this.endIndex = endIndex;
        (_b = (_a = this.cbs).oncomment) === null || _b === void 0 ? void 0 : _b.call(_a, this.getSlice(start, endIndex - offset));
        (_d = (_c = this.cbs).oncommentend) === null || _d === void 0 ? void 0 : _d.call(_c);
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    };
    /** @internal */
    Parser.prototype.oncdata = function (start, endIndex, offset) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.endIndex = endIndex;
        var value = this.getSlice(start, endIndex - offset);
        if (this.options.xmlMode || this.options.recognizeCDATA) {
            (_b = (_a = this.cbs).oncdatastart) === null || _b === void 0 ? void 0 : _b.call(_a);
            (_d = (_c = this.cbs).ontext) === null || _d === void 0 ? void 0 : _d.call(_c, value);
            (_f = (_e = this.cbs).oncdataend) === null || _f === void 0 ? void 0 : _f.call(_e);
        }
        else {
            (_h = (_g = this.cbs).oncomment) === null || _h === void 0 ? void 0 : _h.call(_g, "[CDATA[".concat(value, "]]"));
            (_k = (_j = this.cbs).oncommentend) === null || _k === void 0 ? void 0 : _k.call(_j);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    };
    /** @internal */
    Parser.prototype.onend = function () {
        var _a, _b;
        if (this.cbs.onclosetag) {
            // Set the end index for all remaining tags
            this.endIndex = this.startIndex;
            for (var index = this.stack.length; index > 0; this.cbs.onclosetag(this.stack[--index], true))
                ;
        }
        (_b = (_a = this.cbs).onend) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    /**
     * Resets the parser to a blank state, ready to parse a new HTML document
     */
    Parser.prototype.reset = function () {
        var _a, _b, _c, _d;
        (_b = (_a = this.cbs).onreset) === null || _b === void 0 ? void 0 : _b.call(_a);
        this.tokenizer.reset();
        this.tagname = "";
        this.attribname = "";
        this.attribs = null;
        this.stack.length = 0;
        this.startIndex = 0;
        this.endIndex = 0;
        (_d = (_c = this.cbs).onparserinit) === null || _d === void 0 ? void 0 : _d.call(_c, this);
        this.buffers.length = 0;
        this.bufferOffset = 0;
        this.writeIndex = 0;
        this.ended = false;
    };
    /**
     * Resets the parser, then parses a complete document and
     * pushes it to the handler.
     *
     * @param data Document to parse.
     */
    Parser.prototype.parseComplete = function (data) {
        this.reset();
        this.end(data);
    };
    Parser.prototype.getSlice = function (start, end) {
        while (start - this.bufferOffset >= this.buffers[0].length) {
            this.shiftBuffer();
        }
        var slice = this.buffers[0].slice(start - this.bufferOffset, end - this.bufferOffset);
        while (end - this.bufferOffset > this.buffers[0].length) {
            this.shiftBuffer();
            slice += this.buffers[0].slice(0, end - this.bufferOffset);
        }
        return slice;
    };
    Parser.prototype.shiftBuffer = function () {
        this.bufferOffset += this.buffers[0].length;
        this.writeIndex--;
        this.buffers.shift();
    };
    /**
     * Parses a chunk of data and calls the corresponding callbacks.
     *
     * @param chunk Chunk to parse.
     */
    Parser.prototype.write = function (chunk) {
        var _a, _b;
        if (this.ended) {
            (_b = (_a = this.cbs).onerror) === null || _b === void 0 ? void 0 : _b.call(_a, new Error(".write() after done!"));
            return;
        }
        this.buffers.push(chunk);
        if (this.tokenizer.running) {
            this.tokenizer.write(chunk);
            this.writeIndex++;
        }
    };
    /**
     * Parses the end of the buffer and clears the stack, calls onend.
     *
     * @param chunk Optional final chunk to parse.
     */
    Parser.prototype.end = function (chunk) {
        var _a, _b;
        if (this.ended) {
            (_b = (_a = this.cbs).onerror) === null || _b === void 0 ? void 0 : _b.call(_a, new Error(".end() after done!"));
            return;
        }
        if (chunk)
            this.write(chunk);
        this.ended = true;
        this.tokenizer.end();
    };
    /**
     * Pauses parsing. The parser won't emit events until `resume` is called.
     */
    Parser.prototype.pause = function () {
        this.tokenizer.pause();
    };
    /**
     * Resumes parsing after `pause` was called.
     */
    Parser.prototype.resume = function () {
        this.tokenizer.resume();
        while (this.tokenizer.running &&
            this.writeIndex < this.buffers.length) {
            this.tokenizer.write(this.buffers[this.writeIndex++]);
        }
        if (this.ended)
            this.tokenizer.end();
    };
    /**
     * Alias of `write`, for backwards compatibility.
     *
     * @param chunk Chunk to parse.
     * @deprecated
     */
    Parser.prototype.parseChunk = function (chunk) {
        this.write(chunk);
    };
    /**
     * Alias of `end`, for backwards compatibility.
     *
     * @param chunk Optional final chunk to parse.
     * @deprecated
     */
    Parser.prototype.done = function (chunk) {
        this.end(chunk);
    };
    return Parser;
}());
Parser$4.Parser = Parser$3;

var lib$4 = {};

var lib$3 = {};

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Doctype = exports.CDATA = exports.Tag = exports.Style = exports.Script = exports.Comment = exports.Directive = exports.Text = exports.Root = exports.isTag = exports.ElementType = void 0;
	/** Types of elements found in htmlparser2's DOM */
	var ElementType;
	(function (ElementType) {
	    /** Type for the root element of a document */
	    ElementType["Root"] = "root";
	    /** Type for Text */
	    ElementType["Text"] = "text";
	    /** Type for <? ... ?> */
	    ElementType["Directive"] = "directive";
	    /** Type for <!-- ... --> */
	    ElementType["Comment"] = "comment";
	    /** Type for <script> tags */
	    ElementType["Script"] = "script";
	    /** Type for <style> tags */
	    ElementType["Style"] = "style";
	    /** Type for Any tag */
	    ElementType["Tag"] = "tag";
	    /** Type for <![CDATA[ ... ]]> */
	    ElementType["CDATA"] = "cdata";
	    /** Type for <!doctype ...> */
	    ElementType["Doctype"] = "doctype";
	})(ElementType = exports.ElementType || (exports.ElementType = {}));
	/**
	 * Tests whether an element is a tag or not.
	 *
	 * @param elem Element to test
	 */
	function isTag(elem) {
	    return (elem.type === ElementType.Tag ||
	        elem.type === ElementType.Script ||
	        elem.type === ElementType.Style);
	}
	exports.isTag = isTag;
	// Exports for backwards compatibility
	/** Type for the root element of a document */
	exports.Root = ElementType.Root;
	/** Type for Text */
	exports.Text = ElementType.Text;
	/** Type for <? ... ?> */
	exports.Directive = ElementType.Directive;
	/** Type for <!-- ... --> */
	exports.Comment = ElementType.Comment;
	/** Type for <script> tags */
	exports.Script = ElementType.Script;
	/** Type for <style> tags */
	exports.Style = ElementType.Style;
	/** Type for Any tag */
	exports.Tag = ElementType.Tag;
	/** Type for <![CDATA[ ... ]]> */
	exports.CDATA = ElementType.CDATA;
	/** Type for <!doctype ...> */
	exports.Doctype = ElementType.Doctype; 
} (lib$3));

var node$1 = {};

var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$1 = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign$1 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};
Object.defineProperty(node$1, "__esModule", { value: true });
node$1.cloneNode = node$1.hasChildren = node$1.isDocument = node$1.isDirective = node$1.isComment = node$1.isText = node$1.isCDATA = node$1.isTag = node$1.Element = node$1.Document = node$1.CDATA = node$1.NodeWithChildren = node$1.ProcessingInstruction = node$1.Comment = node$1.Text = node$1.DataNode = node$1.Node = void 0;
var domelementtype_1$1 = lib$3;
/**
 * This object will be used as the prototype for Nodes when creating a
 * DOM-Level-1-compliant structure.
 */
var Node$5 = /** @class */ (function () {
    function Node() {
        /** Parent of the node */
        this.parent = null;
        /** Previous sibling */
        this.prev = null;
        /** Next sibling */
        this.next = null;
        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */
        this.startIndex = null;
        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */
        this.endIndex = null;
    }
    Object.defineProperty(Node.prototype, "parentNode", {
        // Read-write aliases for properties
        /**
         * Same as {@link parent}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.parent;
        },
        set: function (parent) {
            this.parent = parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "previousSibling", {
        /**
         * Same as {@link prev}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.prev;
        },
        set: function (prev) {
            this.prev = prev;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "nextSibling", {
        /**
         * Same as {@link next}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.next;
        },
        set: function (next) {
            this.next = next;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */
    Node.prototype.cloneNode = function (recursive) {
        if (recursive === void 0) { recursive = false; }
        return cloneNode$1(this, recursive);
    };
    return Node;
}());
node$1.Node = Node$5;
/**
 * A node that contains some data.
 */
var DataNode = /** @class */ (function (_super) {
    __extends(DataNode, _super);
    /**
     * @param data The content of the data node
     */
    function DataNode(data) {
        var _this = _super.call(this) || this;
        _this.data = data;
        return _this;
    }
    Object.defineProperty(DataNode.prototype, "nodeValue", {
        /**
         * Same as {@link data}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.data;
        },
        set: function (data) {
            this.data = data;
        },
        enumerable: false,
        configurable: true
    });
    return DataNode;
}(Node$5));
node$1.DataNode = DataNode;
/**
 * Text within the document.
 */
var Text = /** @class */ (function (_super) {
    __extends(Text, _super);
    function Text() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = domelementtype_1$1.ElementType.Text;
        return _this;
    }
    Object.defineProperty(Text.prototype, "nodeType", {
        get: function () {
            return 3;
        },
        enumerable: false,
        configurable: true
    });
    return Text;
}(DataNode));
node$1.Text = Text;
/**
 * Comments within the document.
 */
var Comment$5 = /** @class */ (function (_super) {
    __extends(Comment, _super);
    function Comment() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = domelementtype_1$1.ElementType.Comment;
        return _this;
    }
    Object.defineProperty(Comment.prototype, "nodeType", {
        get: function () {
            return 8;
        },
        enumerable: false,
        configurable: true
    });
    return Comment;
}(DataNode));
node$1.Comment = Comment$5;
/**
 * Processing instructions, including doc types.
 */
var ProcessingInstruction = /** @class */ (function (_super) {
    __extends(ProcessingInstruction, _super);
    function ProcessingInstruction(name, data) {
        var _this = _super.call(this, data) || this;
        _this.name = name;
        _this.type = domelementtype_1$1.ElementType.Directive;
        return _this;
    }
    Object.defineProperty(ProcessingInstruction.prototype, "nodeType", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    return ProcessingInstruction;
}(DataNode));
node$1.ProcessingInstruction = ProcessingInstruction;
/**
 * A `Node` that can have children.
 */
var NodeWithChildren = /** @class */ (function (_super) {
    __extends(NodeWithChildren, _super);
    /**
     * @param children Children of the node. Only certain node types can have children.
     */
    function NodeWithChildren(children) {
        var _this = _super.call(this) || this;
        _this.children = children;
        return _this;
    }
    Object.defineProperty(NodeWithChildren.prototype, "firstChild", {
        // Aliases
        /** First child of the node. */
        get: function () {
            var _a;
            return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "lastChild", {
        /** Last child of the node. */
        get: function () {
            return this.children.length > 0
                ? this.children[this.children.length - 1]
                : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "childNodes", {
        /**
         * Same as {@link children}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.children;
        },
        set: function (children) {
            this.children = children;
        },
        enumerable: false,
        configurable: true
    });
    return NodeWithChildren;
}(Node$5));
node$1.NodeWithChildren = NodeWithChildren;
var CDATA = /** @class */ (function (_super) {
    __extends(CDATA, _super);
    function CDATA() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = domelementtype_1$1.ElementType.CDATA;
        return _this;
    }
    Object.defineProperty(CDATA.prototype, "nodeType", {
        get: function () {
            return 4;
        },
        enumerable: false,
        configurable: true
    });
    return CDATA;
}(NodeWithChildren));
node$1.CDATA = CDATA;
/**
 * The root node of the document.
 */
var Document$4 = /** @class */ (function (_super) {
    __extends(Document, _super);
    function Document() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = domelementtype_1$1.ElementType.Root;
        return _this;
    }
    Object.defineProperty(Document.prototype, "nodeType", {
        get: function () {
            return 9;
        },
        enumerable: false,
        configurable: true
    });
    return Document;
}(NodeWithChildren));
node$1.Document = Document$4;
/**
 * An element within the DOM.
 */
var Element = /** @class */ (function (_super) {
    __extends(Element, _super);
    /**
     * @param name Name of the tag, eg. `div`, `span`.
     * @param attribs Object mapping attribute names to attribute values.
     * @param children Children of the node.
     */
    function Element(name, attribs, children, type) {
        if (children === void 0) { children = []; }
        if (type === void 0) { type = name === "script"
            ? domelementtype_1$1.ElementType.Script
            : name === "style"
                ? domelementtype_1$1.ElementType.Style
                : domelementtype_1$1.ElementType.Tag; }
        var _this = _super.call(this, children) || this;
        _this.name = name;
        _this.attribs = attribs;
        _this.type = type;
        return _this;
    }
    Object.defineProperty(Element.prototype, "nodeType", {
        get: function () {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Element.prototype, "tagName", {
        // DOM Level 1 aliases
        /**
         * Same as {@link name}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.name;
        },
        set: function (name) {
            this.name = name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Element.prototype, "attributes", {
        get: function () {
            var _this = this;
            return Object.keys(this.attribs).map(function (name) {
                var _a, _b;
                return ({
                    name: name,
                    value: _this.attribs[name],
                    namespace: (_a = _this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                    prefix: (_b = _this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name],
                });
            });
        },
        enumerable: false,
        configurable: true
    });
    return Element;
}(NodeWithChildren));
node$1.Element = Element;
/**
 * @param node Node to check.
 * @returns `true` if the node is a `Element`, `false` otherwise.
 */
function isTag(node) {
    return (0, domelementtype_1$1.isTag)(node);
}
node$1.isTag = isTag;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `CDATA`, `false` otherwise.
 */
function isCDATA(node) {
    return node.type === domelementtype_1$1.ElementType.CDATA;
}
node$1.isCDATA = isCDATA;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Text`, `false` otherwise.
 */
function isText(node) {
    return node.type === domelementtype_1$1.ElementType.Text;
}
node$1.isText = isText;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Comment`, `false` otherwise.
 */
function isComment(node) {
    return node.type === domelementtype_1$1.ElementType.Comment;
}
node$1.isComment = isComment;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */
function isDirective(node) {
    return node.type === domelementtype_1$1.ElementType.Directive;
}
node$1.isDirective = isDirective;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */
function isDocument(node) {
    return node.type === domelementtype_1$1.ElementType.Root;
}
node$1.isDocument = isDocument;
/**
 * @param node Node to check.
 * @returns `true` if the node has children, `false` otherwise.
 */
function hasChildren(node) {
    return Object.prototype.hasOwnProperty.call(node, "children");
}
node$1.hasChildren = hasChildren;
/**
 * Clone a node, and optionally its children.
 *
 * @param recursive Clone child nodes as well.
 * @returns A clone of the node.
 */
function cloneNode$1(node, recursive) {
    if (recursive === void 0) { recursive = false; }
    var result;
    if (isText(node)) {
        result = new Text(node.data);
    }
    else if (isComment(node)) {
        result = new Comment$5(node.data);
    }
    else if (isTag(node)) {
        var children = recursive ? cloneChildren(node.children) : [];
        var clone_1 = new Element(node.name, __assign$1({}, node.attribs), children);
        children.forEach(function (child) { return (child.parent = clone_1); });
        if (node.namespace != null) {
            clone_1.namespace = node.namespace;
        }
        if (node["x-attribsNamespace"]) {
            clone_1["x-attribsNamespace"] = __assign$1({}, node["x-attribsNamespace"]);
        }
        if (node["x-attribsPrefix"]) {
            clone_1["x-attribsPrefix"] = __assign$1({}, node["x-attribsPrefix"]);
        }
        result = clone_1;
    }
    else if (isCDATA(node)) {
        var children = recursive ? cloneChildren(node.children) : [];
        var clone_2 = new CDATA(children);
        children.forEach(function (child) { return (child.parent = clone_2); });
        result = clone_2;
    }
    else if (isDocument(node)) {
        var children = recursive ? cloneChildren(node.children) : [];
        var clone_3 = new Document$4(children);
        children.forEach(function (child) { return (child.parent = clone_3); });
        if (node["x-mode"]) {
            clone_3["x-mode"] = node["x-mode"];
        }
        result = clone_3;
    }
    else if (isDirective(node)) {
        var instruction = new ProcessingInstruction(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    }
    else {
        throw new Error("Not implemented yet: ".concat(node.type));
    }
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) {
        result.sourceCodeLocation = node.sourceCodeLocation;
    }
    return result;
}
node$1.cloneNode = cloneNode$1;
function cloneChildren(childs) {
    var children = childs.map(function (child) { return cloneNode$1(child, true); });
    for (var i = 1; i < children.length; i++) {
        children[i].prev = children[i - 1];
        children[i - 1].next = children[i];
    }
    return children;
}

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.DomHandler = void 0;
	var domelementtype_1 = lib$3;
	var node_js_1 = node$1;
	__exportStar(node$1, exports);
	// Default options
	var defaultOpts = {
	    withStartIndices: false,
	    withEndIndices: false,
	    xmlMode: false,
	};
	var DomHandler = /** @class */ (function () {
	    /**
	     * @param callback Called once parsing has completed.
	     * @param options Settings for the handler.
	     * @param elementCB Callback whenever a tag is closed.
	     */
	    function DomHandler(callback, options, elementCB) {
	        /** The elements of the DOM */
	        this.dom = [];
	        /** The root element for the DOM */
	        this.root = new node_js_1.Document(this.dom);
	        /** Indicated whether parsing has been completed. */
	        this.done = false;
	        /** Stack of open tags. */
	        this.tagStack = [this.root];
	        /** A data node that is still being written to. */
	        this.lastNode = null;
	        /** Reference to the parser instance. Used for location information. */
	        this.parser = null;
	        // Make it possible to skip arguments, for backwards-compatibility
	        if (typeof options === "function") {
	            elementCB = options;
	            options = defaultOpts;
	        }
	        if (typeof callback === "object") {
	            options = callback;
	            callback = undefined;
	        }
	        this.callback = callback !== null && callback !== void 0 ? callback : null;
	        this.options = options !== null && options !== void 0 ? options : defaultOpts;
	        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
	    }
	    DomHandler.prototype.onparserinit = function (parser) {
	        this.parser = parser;
	    };
	    // Resets the handler back to starting state
	    DomHandler.prototype.onreset = function () {
	        this.dom = [];
	        this.root = new node_js_1.Document(this.dom);
	        this.done = false;
	        this.tagStack = [this.root];
	        this.lastNode = null;
	        this.parser = null;
	    };
	    // Signals the handler that parsing is done
	    DomHandler.prototype.onend = function () {
	        if (this.done)
	            return;
	        this.done = true;
	        this.parser = null;
	        this.handleCallback(null);
	    };
	    DomHandler.prototype.onerror = function (error) {
	        this.handleCallback(error);
	    };
	    DomHandler.prototype.onclosetag = function () {
	        this.lastNode = null;
	        var elem = this.tagStack.pop();
	        if (this.options.withEndIndices) {
	            elem.endIndex = this.parser.endIndex;
	        }
	        if (this.elementCB)
	            this.elementCB(elem);
	    };
	    DomHandler.prototype.onopentag = function (name, attribs) {
	        var type = this.options.xmlMode ? domelementtype_1.ElementType.Tag : undefined;
	        var element = new node_js_1.Element(name, attribs, undefined, type);
	        this.addNode(element);
	        this.tagStack.push(element);
	    };
	    DomHandler.prototype.ontext = function (data) {
	        var lastNode = this.lastNode;
	        if (lastNode && lastNode.type === domelementtype_1.ElementType.Text) {
	            lastNode.data += data;
	            if (this.options.withEndIndices) {
	                lastNode.endIndex = this.parser.endIndex;
	            }
	        }
	        else {
	            var node = new node_js_1.Text(data);
	            this.addNode(node);
	            this.lastNode = node;
	        }
	    };
	    DomHandler.prototype.oncomment = function (data) {
	        if (this.lastNode && this.lastNode.type === domelementtype_1.ElementType.Comment) {
	            this.lastNode.data += data;
	            return;
	        }
	        var node = new node_js_1.Comment(data);
	        this.addNode(node);
	        this.lastNode = node;
	    };
	    DomHandler.prototype.oncommentend = function () {
	        this.lastNode = null;
	    };
	    DomHandler.prototype.oncdatastart = function () {
	        var text = new node_js_1.Text("");
	        var node = new node_js_1.CDATA([text]);
	        this.addNode(node);
	        text.parent = node;
	        this.lastNode = text;
	    };
	    DomHandler.prototype.oncdataend = function () {
	        this.lastNode = null;
	    };
	    DomHandler.prototype.onprocessinginstruction = function (name, data) {
	        var node = new node_js_1.ProcessingInstruction(name, data);
	        this.addNode(node);
	    };
	    DomHandler.prototype.handleCallback = function (error) {
	        if (typeof this.callback === "function") {
	            this.callback(error, this.dom);
	        }
	        else if (error) {
	            throw error;
	        }
	    };
	    DomHandler.prototype.addNode = function (node) {
	        var parent = this.tagStack[this.tagStack.length - 1];
	        var previousSibling = parent.children[parent.children.length - 1];
	        if (this.options.withStartIndices) {
	            node.startIndex = this.parser.startIndex;
	        }
	        if (this.options.withEndIndices) {
	            node.endIndex = this.parser.endIndex;
	        }
	        parent.children.push(node);
	        if (previousSibling) {
	            node.prev = previousSibling;
	            previousSibling.next = node;
	        }
	        node.parent = parent;
	        this.lastNode = null;
	    };
	    return DomHandler;
	}());
	exports.DomHandler = DomHandler;
	exports.default = DomHandler; 
} (lib$4));

var lib$2 = {};

var stringify$5 = {};

var lib$1 = {};

var lib = {};

var encode = {};

var encodeHtml = {};

// Generated using scripts/write-encode-map.ts
Object.defineProperty(encodeHtml, "__esModule", { value: true });
function restoreDiff(arr) {
    for (var i = 1; i < arr.length; i++) {
        arr[i][0] += arr[i - 1][0] + 1;
    }
    return arr;
}
// prettier-ignore
encodeHtml.default = new Map(/* #__PURE__ */ restoreDiff([[9, "&Tab;"], [0, "&NewLine;"], [22, "&excl;"], [0, "&quot;"], [0, "&num;"], [0, "&dollar;"], [0, "&percnt;"], [0, "&amp;"], [0, "&apos;"], [0, "&lpar;"], [0, "&rpar;"], [0, "&ast;"], [0, "&plus;"], [0, "&comma;"], [1, "&period;"], [0, "&sol;"], [10, "&colon;"], [0, "&semi;"], [0, { v: "&lt;", n: 8402, o: "&nvlt;" }], [0, { v: "&equals;", n: 8421, o: "&bne;" }], [0, { v: "&gt;", n: 8402, o: "&nvgt;" }], [0, "&quest;"], [0, "&commat;"], [26, "&lbrack;"], [0, "&bsol;"], [0, "&rbrack;"], [0, "&Hat;"], [0, "&lowbar;"], [0, "&DiacriticalGrave;"], [5, { n: 106, o: "&fjlig;" }], [20, "&lbrace;"], [0, "&verbar;"], [0, "&rbrace;"], [34, "&nbsp;"], [0, "&iexcl;"], [0, "&cent;"], [0, "&pound;"], [0, "&curren;"], [0, "&yen;"], [0, "&brvbar;"], [0, "&sect;"], [0, "&die;"], [0, "&copy;"], [0, "&ordf;"], [0, "&laquo;"], [0, "&not;"], [0, "&shy;"], [0, "&circledR;"], [0, "&macr;"], [0, "&deg;"], [0, "&PlusMinus;"], [0, "&sup2;"], [0, "&sup3;"], [0, "&acute;"], [0, "&micro;"], [0, "&para;"], [0, "&centerdot;"], [0, "&cedil;"], [0, "&sup1;"], [0, "&ordm;"], [0, "&raquo;"], [0, "&frac14;"], [0, "&frac12;"], [0, "&frac34;"], [0, "&iquest;"], [0, "&Agrave;"], [0, "&Aacute;"], [0, "&Acirc;"], [0, "&Atilde;"], [0, "&Auml;"], [0, "&angst;"], [0, "&AElig;"], [0, "&Ccedil;"], [0, "&Egrave;"], [0, "&Eacute;"], [0, "&Ecirc;"], [0, "&Euml;"], [0, "&Igrave;"], [0, "&Iacute;"], [0, "&Icirc;"], [0, "&Iuml;"], [0, "&ETH;"], [0, "&Ntilde;"], [0, "&Ograve;"], [0, "&Oacute;"], [0, "&Ocirc;"], [0, "&Otilde;"], [0, "&Ouml;"], [0, "&times;"], [0, "&Oslash;"], [0, "&Ugrave;"], [0, "&Uacute;"], [0, "&Ucirc;"], [0, "&Uuml;"], [0, "&Yacute;"], [0, "&THORN;"], [0, "&szlig;"], [0, "&agrave;"], [0, "&aacute;"], [0, "&acirc;"], [0, "&atilde;"], [0, "&auml;"], [0, "&aring;"], [0, "&aelig;"], [0, "&ccedil;"], [0, "&egrave;"], [0, "&eacute;"], [0, "&ecirc;"], [0, "&euml;"], [0, "&igrave;"], [0, "&iacute;"], [0, "&icirc;"], [0, "&iuml;"], [0, "&eth;"], [0, "&ntilde;"], [0, "&ograve;"], [0, "&oacute;"], [0, "&ocirc;"], [0, "&otilde;"], [0, "&ouml;"], [0, "&div;"], [0, "&oslash;"], [0, "&ugrave;"], [0, "&uacute;"], [0, "&ucirc;"], [0, "&uuml;"], [0, "&yacute;"], [0, "&thorn;"], [0, "&yuml;"], [0, "&Amacr;"], [0, "&amacr;"], [0, "&Abreve;"], [0, "&abreve;"], [0, "&Aogon;"], [0, "&aogon;"], [0, "&Cacute;"], [0, "&cacute;"], [0, "&Ccirc;"], [0, "&ccirc;"], [0, "&Cdot;"], [0, "&cdot;"], [0, "&Ccaron;"], [0, "&ccaron;"], [0, "&Dcaron;"], [0, "&dcaron;"], [0, "&Dstrok;"], [0, "&dstrok;"], [0, "&Emacr;"], [0, "&emacr;"], [2, "&Edot;"], [0, "&edot;"], [0, "&Eogon;"], [0, "&eogon;"], [0, "&Ecaron;"], [0, "&ecaron;"], [0, "&Gcirc;"], [0, "&gcirc;"], [0, "&Gbreve;"], [0, "&gbreve;"], [0, "&Gdot;"], [0, "&gdot;"], [0, "&Gcedil;"], [1, "&Hcirc;"], [0, "&hcirc;"], [0, "&Hstrok;"], [0, "&hstrok;"], [0, "&Itilde;"], [0, "&itilde;"], [0, "&Imacr;"], [0, "&imacr;"], [2, "&Iogon;"], [0, "&iogon;"], [0, "&Idot;"], [0, "&imath;"], [0, "&IJlig;"], [0, "&ijlig;"], [0, "&Jcirc;"], [0, "&jcirc;"], [0, "&Kcedil;"], [0, "&kcedil;"], [0, "&kgreen;"], [0, "&Lacute;"], [0, "&lacute;"], [0, "&Lcedil;"], [0, "&lcedil;"], [0, "&Lcaron;"], [0, "&lcaron;"], [0, "&Lmidot;"], [0, "&lmidot;"], [0, "&Lstrok;"], [0, "&lstrok;"], [0, "&Nacute;"], [0, "&nacute;"], [0, "&Ncedil;"], [0, "&ncedil;"], [0, "&Ncaron;"], [0, "&ncaron;"], [0, "&napos;"], [0, "&ENG;"], [0, "&eng;"], [0, "&Omacr;"], [0, "&omacr;"], [2, "&Odblac;"], [0, "&odblac;"], [0, "&OElig;"], [0, "&oelig;"], [0, "&Racute;"], [0, "&racute;"], [0, "&Rcedil;"], [0, "&rcedil;"], [0, "&Rcaron;"], [0, "&rcaron;"], [0, "&Sacute;"], [0, "&sacute;"], [0, "&Scirc;"], [0, "&scirc;"], [0, "&Scedil;"], [0, "&scedil;"], [0, "&Scaron;"], [0, "&scaron;"], [0, "&Tcedil;"], [0, "&tcedil;"], [0, "&Tcaron;"], [0, "&tcaron;"], [0, "&Tstrok;"], [0, "&tstrok;"], [0, "&Utilde;"], [0, "&utilde;"], [0, "&Umacr;"], [0, "&umacr;"], [0, "&Ubreve;"], [0, "&ubreve;"], [0, "&Uring;"], [0, "&uring;"], [0, "&Udblac;"], [0, "&udblac;"], [0, "&Uogon;"], [0, "&uogon;"], [0, "&Wcirc;"], [0, "&wcirc;"], [0, "&Ycirc;"], [0, "&ycirc;"], [0, "&Yuml;"], [0, "&Zacute;"], [0, "&zacute;"], [0, "&Zdot;"], [0, "&zdot;"], [0, "&Zcaron;"], [0, "&zcaron;"], [19, "&fnof;"], [34, "&imped;"], [63, "&gacute;"], [65, "&jmath;"], [142, "&circ;"], [0, "&caron;"], [16, "&breve;"], [0, "&DiacriticalDot;"], [0, "&ring;"], [0, "&ogon;"], [0, "&DiacriticalTilde;"], [0, "&dblac;"], [51, "&DownBreve;"], [127, "&Alpha;"], [0, "&Beta;"], [0, "&Gamma;"], [0, "&Delta;"], [0, "&Epsilon;"], [0, "&Zeta;"], [0, "&Eta;"], [0, "&Theta;"], [0, "&Iota;"], [0, "&Kappa;"], [0, "&Lambda;"], [0, "&Mu;"], [0, "&Nu;"], [0, "&Xi;"], [0, "&Omicron;"], [0, "&Pi;"], [0, "&Rho;"], [1, "&Sigma;"], [0, "&Tau;"], [0, "&Upsilon;"], [0, "&Phi;"], [0, "&Chi;"], [0, "&Psi;"], [0, "&ohm;"], [7, "&alpha;"], [0, "&beta;"], [0, "&gamma;"], [0, "&delta;"], [0, "&epsi;"], [0, "&zeta;"], [0, "&eta;"], [0, "&theta;"], [0, "&iota;"], [0, "&kappa;"], [0, "&lambda;"], [0, "&mu;"], [0, "&nu;"], [0, "&xi;"], [0, "&omicron;"], [0, "&pi;"], [0, "&rho;"], [0, "&sigmaf;"], [0, "&sigma;"], [0, "&tau;"], [0, "&upsi;"], [0, "&phi;"], [0, "&chi;"], [0, "&psi;"], [0, "&omega;"], [7, "&thetasym;"], [0, "&Upsi;"], [2, "&phiv;"], [0, "&piv;"], [5, "&Gammad;"], [0, "&digamma;"], [18, "&kappav;"], [0, "&rhov;"], [3, "&epsiv;"], [0, "&backepsilon;"], [10, "&IOcy;"], [0, "&DJcy;"], [0, "&GJcy;"], [0, "&Jukcy;"], [0, "&DScy;"], [0, "&Iukcy;"], [0, "&YIcy;"], [0, "&Jsercy;"], [0, "&LJcy;"], [0, "&NJcy;"], [0, "&TSHcy;"], [0, "&KJcy;"], [1, "&Ubrcy;"], [0, "&DZcy;"], [0, "&Acy;"], [0, "&Bcy;"], [0, "&Vcy;"], [0, "&Gcy;"], [0, "&Dcy;"], [0, "&IEcy;"], [0, "&ZHcy;"], [0, "&Zcy;"], [0, "&Icy;"], [0, "&Jcy;"], [0, "&Kcy;"], [0, "&Lcy;"], [0, "&Mcy;"], [0, "&Ncy;"], [0, "&Ocy;"], [0, "&Pcy;"], [0, "&Rcy;"], [0, "&Scy;"], [0, "&Tcy;"], [0, "&Ucy;"], [0, "&Fcy;"], [0, "&KHcy;"], [0, "&TScy;"], [0, "&CHcy;"], [0, "&SHcy;"], [0, "&SHCHcy;"], [0, "&HARDcy;"], [0, "&Ycy;"], [0, "&SOFTcy;"], [0, "&Ecy;"], [0, "&YUcy;"], [0, "&YAcy;"], [0, "&acy;"], [0, "&bcy;"], [0, "&vcy;"], [0, "&gcy;"], [0, "&dcy;"], [0, "&iecy;"], [0, "&zhcy;"], [0, "&zcy;"], [0, "&icy;"], [0, "&jcy;"], [0, "&kcy;"], [0, "&lcy;"], [0, "&mcy;"], [0, "&ncy;"], [0, "&ocy;"], [0, "&pcy;"], [0, "&rcy;"], [0, "&scy;"], [0, "&tcy;"], [0, "&ucy;"], [0, "&fcy;"], [0, "&khcy;"], [0, "&tscy;"], [0, "&chcy;"], [0, "&shcy;"], [0, "&shchcy;"], [0, "&hardcy;"], [0, "&ycy;"], [0, "&softcy;"], [0, "&ecy;"], [0, "&yucy;"], [0, "&yacy;"], [1, "&iocy;"], [0, "&djcy;"], [0, "&gjcy;"], [0, "&jukcy;"], [0, "&dscy;"], [0, "&iukcy;"], [0, "&yicy;"], [0, "&jsercy;"], [0, "&ljcy;"], [0, "&njcy;"], [0, "&tshcy;"], [0, "&kjcy;"], [1, "&ubrcy;"], [0, "&dzcy;"], [7074, "&ensp;"], [0, "&emsp;"], [0, "&emsp13;"], [0, "&emsp14;"], [1, "&numsp;"], [0, "&puncsp;"], [0, "&ThinSpace;"], [0, "&hairsp;"], [0, "&NegativeMediumSpace;"], [0, "&zwnj;"], [0, "&zwj;"], [0, "&lrm;"], [0, "&rlm;"], [0, "&dash;"], [2, "&ndash;"], [0, "&mdash;"], [0, "&horbar;"], [0, "&Verbar;"], [1, "&lsquo;"], [0, "&CloseCurlyQuote;"], [0, "&lsquor;"], [1, "&ldquo;"], [0, "&CloseCurlyDoubleQuote;"], [0, "&bdquo;"], [1, "&dagger;"], [0, "&Dagger;"], [0, "&bull;"], [2, "&nldr;"], [0, "&hellip;"], [9, "&permil;"], [0, "&pertenk;"], [0, "&prime;"], [0, "&Prime;"], [0, "&tprime;"], [0, "&backprime;"], [3, "&lsaquo;"], [0, "&rsaquo;"], [3, "&oline;"], [2, "&caret;"], [1, "&hybull;"], [0, "&frasl;"], [10, "&bsemi;"], [7, "&qprime;"], [7, { v: "&MediumSpace;", n: 8202, o: "&ThickSpace;" }], [0, "&NoBreak;"], [0, "&af;"], [0, "&InvisibleTimes;"], [0, "&ic;"], [72, "&euro;"], [46, "&tdot;"], [0, "&DotDot;"], [37, "&complexes;"], [2, "&incare;"], [4, "&gscr;"], [0, "&hamilt;"], [0, "&Hfr;"], [0, "&Hopf;"], [0, "&planckh;"], [0, "&hbar;"], [0, "&imagline;"], [0, "&Ifr;"], [0, "&lagran;"], [0, "&ell;"], [1, "&naturals;"], [0, "&numero;"], [0, "&copysr;"], [0, "&weierp;"], [0, "&Popf;"], [0, "&Qopf;"], [0, "&realine;"], [0, "&real;"], [0, "&reals;"], [0, "&rx;"], [3, "&trade;"], [1, "&integers;"], [2, "&mho;"], [0, "&zeetrf;"], [0, "&iiota;"], [2, "&bernou;"], [0, "&Cayleys;"], [1, "&escr;"], [0, "&Escr;"], [0, "&Fouriertrf;"], [1, "&Mellintrf;"], [0, "&order;"], [0, "&alefsym;"], [0, "&beth;"], [0, "&gimel;"], [0, "&daleth;"], [12, "&CapitalDifferentialD;"], [0, "&dd;"], [0, "&ee;"], [0, "&ii;"], [10, "&frac13;"], [0, "&frac23;"], [0, "&frac15;"], [0, "&frac25;"], [0, "&frac35;"], [0, "&frac45;"], [0, "&frac16;"], [0, "&frac56;"], [0, "&frac18;"], [0, "&frac38;"], [0, "&frac58;"], [0, "&frac78;"], [49, "&larr;"], [0, "&ShortUpArrow;"], [0, "&rarr;"], [0, "&darr;"], [0, "&harr;"], [0, "&updownarrow;"], [0, "&nwarr;"], [0, "&nearr;"], [0, "&LowerRightArrow;"], [0, "&LowerLeftArrow;"], [0, "&nlarr;"], [0, "&nrarr;"], [1, { v: "&rarrw;", n: 824, o: "&nrarrw;" }], [0, "&Larr;"], [0, "&Uarr;"], [0, "&Rarr;"], [0, "&Darr;"], [0, "&larrtl;"], [0, "&rarrtl;"], [0, "&LeftTeeArrow;"], [0, "&mapstoup;"], [0, "&map;"], [0, "&DownTeeArrow;"], [1, "&hookleftarrow;"], [0, "&hookrightarrow;"], [0, "&larrlp;"], [0, "&looparrowright;"], [0, "&harrw;"], [0, "&nharr;"], [1, "&lsh;"], [0, "&rsh;"], [0, "&ldsh;"], [0, "&rdsh;"], [1, "&crarr;"], [0, "&cularr;"], [0, "&curarr;"], [2, "&circlearrowleft;"], [0, "&circlearrowright;"], [0, "&leftharpoonup;"], [0, "&DownLeftVector;"], [0, "&RightUpVector;"], [0, "&LeftUpVector;"], [0, "&rharu;"], [0, "&DownRightVector;"], [0, "&dharr;"], [0, "&dharl;"], [0, "&RightArrowLeftArrow;"], [0, "&udarr;"], [0, "&LeftArrowRightArrow;"], [0, "&leftleftarrows;"], [0, "&upuparrows;"], [0, "&rightrightarrows;"], [0, "&ddarr;"], [0, "&leftrightharpoons;"], [0, "&Equilibrium;"], [0, "&nlArr;"], [0, "&nhArr;"], [0, "&nrArr;"], [0, "&DoubleLeftArrow;"], [0, "&DoubleUpArrow;"], [0, "&DoubleRightArrow;"], [0, "&dArr;"], [0, "&DoubleLeftRightArrow;"], [0, "&DoubleUpDownArrow;"], [0, "&nwArr;"], [0, "&neArr;"], [0, "&seArr;"], [0, "&swArr;"], [0, "&lAarr;"], [0, "&rAarr;"], [1, "&zigrarr;"], [6, "&larrb;"], [0, "&rarrb;"], [15, "&DownArrowUpArrow;"], [7, "&loarr;"], [0, "&roarr;"], [0, "&hoarr;"], [0, "&forall;"], [0, "&comp;"], [0, { v: "&part;", n: 824, o: "&npart;" }], [0, "&exist;"], [0, "&nexist;"], [0, "&empty;"], [1, "&Del;"], [0, "&Element;"], [0, "&NotElement;"], [1, "&ni;"], [0, "&notni;"], [2, "&prod;"], [0, "&coprod;"], [0, "&sum;"], [0, "&minus;"], [0, "&MinusPlus;"], [0, "&dotplus;"], [1, "&Backslash;"], [0, "&lowast;"], [0, "&compfn;"], [1, "&radic;"], [2, "&prop;"], [0, "&infin;"], [0, "&angrt;"], [0, { v: "&ang;", n: 8402, o: "&nang;" }], [0, "&angmsd;"], [0, "&angsph;"], [0, "&mid;"], [0, "&nmid;"], [0, "&DoubleVerticalBar;"], [0, "&NotDoubleVerticalBar;"], [0, "&and;"], [0, "&or;"], [0, { v: "&cap;", n: 65024, o: "&caps;" }], [0, { v: "&cup;", n: 65024, o: "&cups;" }], [0, "&int;"], [0, "&Int;"], [0, "&iiint;"], [0, "&conint;"], [0, "&Conint;"], [0, "&Cconint;"], [0, "&cwint;"], [0, "&ClockwiseContourIntegral;"], [0, "&awconint;"], [0, "&there4;"], [0, "&becaus;"], [0, "&ratio;"], [0, "&Colon;"], [0, "&dotminus;"], [1, "&mDDot;"], [0, "&homtht;"], [0, { v: "&sim;", n: 8402, o: "&nvsim;" }], [0, { v: "&backsim;", n: 817, o: "&race;" }], [0, { v: "&ac;", n: 819, o: "&acE;" }], [0, "&acd;"], [0, "&VerticalTilde;"], [0, "&NotTilde;"], [0, { v: "&eqsim;", n: 824, o: "&nesim;" }], [0, "&sime;"], [0, "&NotTildeEqual;"], [0, "&cong;"], [0, "&simne;"], [0, "&ncong;"], [0, "&ap;"], [0, "&nap;"], [0, "&ape;"], [0, { v: "&apid;", n: 824, o: "&napid;" }], [0, "&backcong;"], [0, { v: "&asympeq;", n: 8402, o: "&nvap;" }], [0, { v: "&bump;", n: 824, o: "&nbump;" }], [0, { v: "&bumpe;", n: 824, o: "&nbumpe;" }], [0, { v: "&doteq;", n: 824, o: "&nedot;" }], [0, "&doteqdot;"], [0, "&efDot;"], [0, "&erDot;"], [0, "&Assign;"], [0, "&ecolon;"], [0, "&ecir;"], [0, "&circeq;"], [1, "&wedgeq;"], [0, "&veeeq;"], [1, "&triangleq;"], [2, "&equest;"], [0, "&ne;"], [0, { v: "&Congruent;", n: 8421, o: "&bnequiv;" }], [0, "&nequiv;"], [1, { v: "&le;", n: 8402, o: "&nvle;" }], [0, { v: "&ge;", n: 8402, o: "&nvge;" }], [0, { v: "&lE;", n: 824, o: "&nlE;" }], [0, { v: "&gE;", n: 824, o: "&ngE;" }], [0, { v: "&lnE;", n: 65024, o: "&lvertneqq;" }], [0, { v: "&gnE;", n: 65024, o: "&gvertneqq;" }], [0, { v: "&ll;", n: new Map(/* #__PURE__ */ restoreDiff([[824, "&nLtv;"], [7577, "&nLt;"]])) }], [0, { v: "&gg;", n: new Map(/* #__PURE__ */ restoreDiff([[824, "&nGtv;"], [7577, "&nGt;"]])) }], [0, "&between;"], [0, "&NotCupCap;"], [0, "&nless;"], [0, "&ngt;"], [0, "&nle;"], [0, "&nge;"], [0, "&lesssim;"], [0, "&GreaterTilde;"], [0, "&nlsim;"], [0, "&ngsim;"], [0, "&LessGreater;"], [0, "&gl;"], [0, "&NotLessGreater;"], [0, "&NotGreaterLess;"], [0, "&pr;"], [0, "&sc;"], [0, "&prcue;"], [0, "&sccue;"], [0, "&PrecedesTilde;"], [0, { v: "&scsim;", n: 824, o: "&NotSucceedsTilde;" }], [0, "&NotPrecedes;"], [0, "&NotSucceeds;"], [0, { v: "&sub;", n: 8402, o: "&NotSubset;" }], [0, { v: "&sup;", n: 8402, o: "&NotSuperset;" }], [0, "&nsub;"], [0, "&nsup;"], [0, "&sube;"], [0, "&supe;"], [0, "&NotSubsetEqual;"], [0, "&NotSupersetEqual;"], [0, { v: "&subne;", n: 65024, o: "&varsubsetneq;" }], [0, { v: "&supne;", n: 65024, o: "&varsupsetneq;" }], [1, "&cupdot;"], [0, "&UnionPlus;"], [0, { v: "&sqsub;", n: 824, o: "&NotSquareSubset;" }], [0, { v: "&sqsup;", n: 824, o: "&NotSquareSuperset;" }], [0, "&sqsube;"], [0, "&sqsupe;"], [0, { v: "&sqcap;", n: 65024, o: "&sqcaps;" }], [0, { v: "&sqcup;", n: 65024, o: "&sqcups;" }], [0, "&CirclePlus;"], [0, "&CircleMinus;"], [0, "&CircleTimes;"], [0, "&osol;"], [0, "&CircleDot;"], [0, "&circledcirc;"], [0, "&circledast;"], [1, "&circleddash;"], [0, "&boxplus;"], [0, "&boxminus;"], [0, "&boxtimes;"], [0, "&dotsquare;"], [0, "&RightTee;"], [0, "&dashv;"], [0, "&DownTee;"], [0, "&bot;"], [1, "&models;"], [0, "&DoubleRightTee;"], [0, "&Vdash;"], [0, "&Vvdash;"], [0, "&VDash;"], [0, "&nvdash;"], [0, "&nvDash;"], [0, "&nVdash;"], [0, "&nVDash;"], [0, "&prurel;"], [1, "&LeftTriangle;"], [0, "&RightTriangle;"], [0, { v: "&LeftTriangleEqual;", n: 8402, o: "&nvltrie;" }], [0, { v: "&RightTriangleEqual;", n: 8402, o: "&nvrtrie;" }], [0, "&origof;"], [0, "&imof;"], [0, "&multimap;"], [0, "&hercon;"], [0, "&intcal;"], [0, "&veebar;"], [1, "&barvee;"], [0, "&angrtvb;"], [0, "&lrtri;"], [0, "&bigwedge;"], [0, "&bigvee;"], [0, "&bigcap;"], [0, "&bigcup;"], [0, "&diam;"], [0, "&sdot;"], [0, "&sstarf;"], [0, "&divideontimes;"], [0, "&bowtie;"], [0, "&ltimes;"], [0, "&rtimes;"], [0, "&leftthreetimes;"], [0, "&rightthreetimes;"], [0, "&backsimeq;"], [0, "&curlyvee;"], [0, "&curlywedge;"], [0, "&Sub;"], [0, "&Sup;"], [0, "&Cap;"], [0, "&Cup;"], [0, "&fork;"], [0, "&epar;"], [0, "&lessdot;"], [0, "&gtdot;"], [0, { v: "&Ll;", n: 824, o: "&nLl;" }], [0, { v: "&Gg;", n: 824, o: "&nGg;" }], [0, { v: "&leg;", n: 65024, o: "&lesg;" }], [0, { v: "&gel;", n: 65024, o: "&gesl;" }], [2, "&cuepr;"], [0, "&cuesc;"], [0, "&NotPrecedesSlantEqual;"], [0, "&NotSucceedsSlantEqual;"], [0, "&NotSquareSubsetEqual;"], [0, "&NotSquareSupersetEqual;"], [2, "&lnsim;"], [0, "&gnsim;"], [0, "&precnsim;"], [0, "&scnsim;"], [0, "&nltri;"], [0, "&NotRightTriangle;"], [0, "&nltrie;"], [0, "&NotRightTriangleEqual;"], [0, "&vellip;"], [0, "&ctdot;"], [0, "&utdot;"], [0, "&dtdot;"], [0, "&disin;"], [0, "&isinsv;"], [0, "&isins;"], [0, { v: "&isindot;", n: 824, o: "&notindot;" }], [0, "&notinvc;"], [0, "&notinvb;"], [1, { v: "&isinE;", n: 824, o: "&notinE;" }], [0, "&nisd;"], [0, "&xnis;"], [0, "&nis;"], [0, "&notnivc;"], [0, "&notnivb;"], [6, "&barwed;"], [0, "&Barwed;"], [1, "&lceil;"], [0, "&rceil;"], [0, "&LeftFloor;"], [0, "&rfloor;"], [0, "&drcrop;"], [0, "&dlcrop;"], [0, "&urcrop;"], [0, "&ulcrop;"], [0, "&bnot;"], [1, "&profline;"], [0, "&profsurf;"], [1, "&telrec;"], [0, "&target;"], [5, "&ulcorn;"], [0, "&urcorn;"], [0, "&dlcorn;"], [0, "&drcorn;"], [2, "&frown;"], [0, "&smile;"], [9, "&cylcty;"], [0, "&profalar;"], [7, "&topbot;"], [6, "&ovbar;"], [1, "&solbar;"], [60, "&angzarr;"], [51, "&lmoustache;"], [0, "&rmoustache;"], [2, "&OverBracket;"], [0, "&bbrk;"], [0, "&bbrktbrk;"], [37, "&OverParenthesis;"], [0, "&UnderParenthesis;"], [0, "&OverBrace;"], [0, "&UnderBrace;"], [2, "&trpezium;"], [4, "&elinters;"], [59, "&blank;"], [164, "&circledS;"], [55, "&boxh;"], [1, "&boxv;"], [9, "&boxdr;"], [3, "&boxdl;"], [3, "&boxur;"], [3, "&boxul;"], [3, "&boxvr;"], [7, "&boxvl;"], [7, "&boxhd;"], [7, "&boxhu;"], [7, "&boxvh;"], [19, "&boxH;"], [0, "&boxV;"], [0, "&boxdR;"], [0, "&boxDr;"], [0, "&boxDR;"], [0, "&boxdL;"], [0, "&boxDl;"], [0, "&boxDL;"], [0, "&boxuR;"], [0, "&boxUr;"], [0, "&boxUR;"], [0, "&boxuL;"], [0, "&boxUl;"], [0, "&boxUL;"], [0, "&boxvR;"], [0, "&boxVr;"], [0, "&boxVR;"], [0, "&boxvL;"], [0, "&boxVl;"], [0, "&boxVL;"], [0, "&boxHd;"], [0, "&boxhD;"], [0, "&boxHD;"], [0, "&boxHu;"], [0, "&boxhU;"], [0, "&boxHU;"], [0, "&boxvH;"], [0, "&boxVh;"], [0, "&boxVH;"], [19, "&uhblk;"], [3, "&lhblk;"], [3, "&block;"], [8, "&blk14;"], [0, "&blk12;"], [0, "&blk34;"], [13, "&square;"], [8, "&blacksquare;"], [0, "&EmptyVerySmallSquare;"], [1, "&rect;"], [0, "&marker;"], [2, "&fltns;"], [1, "&bigtriangleup;"], [0, "&blacktriangle;"], [0, "&triangle;"], [2, "&blacktriangleright;"], [0, "&rtri;"], [3, "&bigtriangledown;"], [0, "&blacktriangledown;"], [0, "&dtri;"], [2, "&blacktriangleleft;"], [0, "&ltri;"], [6, "&loz;"], [0, "&cir;"], [32, "&tridot;"], [2, "&bigcirc;"], [8, "&ultri;"], [0, "&urtri;"], [0, "&lltri;"], [0, "&EmptySmallSquare;"], [0, "&FilledSmallSquare;"], [8, "&bigstar;"], [0, "&star;"], [7, "&phone;"], [49, "&female;"], [1, "&male;"], [29, "&spades;"], [2, "&clubs;"], [1, "&hearts;"], [0, "&diamondsuit;"], [3, "&sung;"], [2, "&flat;"], [0, "&natural;"], [0, "&sharp;"], [163, "&check;"], [3, "&cross;"], [8, "&malt;"], [21, "&sext;"], [33, "&VerticalSeparator;"], [25, "&lbbrk;"], [0, "&rbbrk;"], [84, "&bsolhsub;"], [0, "&suphsol;"], [28, "&LeftDoubleBracket;"], [0, "&RightDoubleBracket;"], [0, "&lang;"], [0, "&rang;"], [0, "&Lang;"], [0, "&Rang;"], [0, "&loang;"], [0, "&roang;"], [7, "&longleftarrow;"], [0, "&longrightarrow;"], [0, "&longleftrightarrow;"], [0, "&DoubleLongLeftArrow;"], [0, "&DoubleLongRightArrow;"], [0, "&DoubleLongLeftRightArrow;"], [1, "&longmapsto;"], [2, "&dzigrarr;"], [258, "&nvlArr;"], [0, "&nvrArr;"], [0, "&nvHarr;"], [0, "&Map;"], [6, "&lbarr;"], [0, "&bkarow;"], [0, "&lBarr;"], [0, "&dbkarow;"], [0, "&drbkarow;"], [0, "&DDotrahd;"], [0, "&UpArrowBar;"], [0, "&DownArrowBar;"], [2, "&Rarrtl;"], [2, "&latail;"], [0, "&ratail;"], [0, "&lAtail;"], [0, "&rAtail;"], [0, "&larrfs;"], [0, "&rarrfs;"], [0, "&larrbfs;"], [0, "&rarrbfs;"], [2, "&nwarhk;"], [0, "&nearhk;"], [0, "&hksearow;"], [0, "&hkswarow;"], [0, "&nwnear;"], [0, "&nesear;"], [0, "&seswar;"], [0, "&swnwar;"], [8, { v: "&rarrc;", n: 824, o: "&nrarrc;" }], [1, "&cudarrr;"], [0, "&ldca;"], [0, "&rdca;"], [0, "&cudarrl;"], [0, "&larrpl;"], [2, "&curarrm;"], [0, "&cularrp;"], [7, "&rarrpl;"], [2, "&harrcir;"], [0, "&Uarrocir;"], [0, "&lurdshar;"], [0, "&ldrushar;"], [2, "&LeftRightVector;"], [0, "&RightUpDownVector;"], [0, "&DownLeftRightVector;"], [0, "&LeftUpDownVector;"], [0, "&LeftVectorBar;"], [0, "&RightVectorBar;"], [0, "&RightUpVectorBar;"], [0, "&RightDownVectorBar;"], [0, "&DownLeftVectorBar;"], [0, "&DownRightVectorBar;"], [0, "&LeftUpVectorBar;"], [0, "&LeftDownVectorBar;"], [0, "&LeftTeeVector;"], [0, "&RightTeeVector;"], [0, "&RightUpTeeVector;"], [0, "&RightDownTeeVector;"], [0, "&DownLeftTeeVector;"], [0, "&DownRightTeeVector;"], [0, "&LeftUpTeeVector;"], [0, "&LeftDownTeeVector;"], [0, "&lHar;"], [0, "&uHar;"], [0, "&rHar;"], [0, "&dHar;"], [0, "&luruhar;"], [0, "&ldrdhar;"], [0, "&ruluhar;"], [0, "&rdldhar;"], [0, "&lharul;"], [0, "&llhard;"], [0, "&rharul;"], [0, "&lrhard;"], [0, "&udhar;"], [0, "&duhar;"], [0, "&RoundImplies;"], [0, "&erarr;"], [0, "&simrarr;"], [0, "&larrsim;"], [0, "&rarrsim;"], [0, "&rarrap;"], [0, "&ltlarr;"], [1, "&gtrarr;"], [0, "&subrarr;"], [1, "&suplarr;"], [0, "&lfisht;"], [0, "&rfisht;"], [0, "&ufisht;"], [0, "&dfisht;"], [5, "&lopar;"], [0, "&ropar;"], [4, "&lbrke;"], [0, "&rbrke;"], [0, "&lbrkslu;"], [0, "&rbrksld;"], [0, "&lbrksld;"], [0, "&rbrkslu;"], [0, "&langd;"], [0, "&rangd;"], [0, "&lparlt;"], [0, "&rpargt;"], [0, "&gtlPar;"], [0, "&ltrPar;"], [3, "&vzigzag;"], [1, "&vangrt;"], [0, "&angrtvbd;"], [6, "&ange;"], [0, "&range;"], [0, "&dwangle;"], [0, "&uwangle;"], [0, "&angmsdaa;"], [0, "&angmsdab;"], [0, "&angmsdac;"], [0, "&angmsdad;"], [0, "&angmsdae;"], [0, "&angmsdaf;"], [0, "&angmsdag;"], [0, "&angmsdah;"], [0, "&bemptyv;"], [0, "&demptyv;"], [0, "&cemptyv;"], [0, "&raemptyv;"], [0, "&laemptyv;"], [0, "&ohbar;"], [0, "&omid;"], [0, "&opar;"], [1, "&operp;"], [1, "&olcross;"], [0, "&odsold;"], [1, "&olcir;"], [0, "&ofcir;"], [0, "&olt;"], [0, "&ogt;"], [0, "&cirscir;"], [0, "&cirE;"], [0, "&solb;"], [0, "&bsolb;"], [3, "&boxbox;"], [3, "&trisb;"], [0, "&rtriltri;"], [0, { v: "&LeftTriangleBar;", n: 824, o: "&NotLeftTriangleBar;" }], [0, { v: "&RightTriangleBar;", n: 824, o: "&NotRightTriangleBar;" }], [11, "&iinfin;"], [0, "&infintie;"], [0, "&nvinfin;"], [4, "&eparsl;"], [0, "&smeparsl;"], [0, "&eqvparsl;"], [5, "&blacklozenge;"], [8, "&RuleDelayed;"], [1, "&dsol;"], [9, "&bigodot;"], [0, "&bigoplus;"], [0, "&bigotimes;"], [1, "&biguplus;"], [1, "&bigsqcup;"], [5, "&iiiint;"], [0, "&fpartint;"], [2, "&cirfnint;"], [0, "&awint;"], [0, "&rppolint;"], [0, "&scpolint;"], [0, "&npolint;"], [0, "&pointint;"], [0, "&quatint;"], [0, "&intlarhk;"], [10, "&pluscir;"], [0, "&plusacir;"], [0, "&simplus;"], [0, "&plusdu;"], [0, "&plussim;"], [0, "&plustwo;"], [1, "&mcomma;"], [0, "&minusdu;"], [2, "&loplus;"], [0, "&roplus;"], [0, "&Cross;"], [0, "&timesd;"], [0, "&timesbar;"], [1, "&smashp;"], [0, "&lotimes;"], [0, "&rotimes;"], [0, "&otimesas;"], [0, "&Otimes;"], [0, "&odiv;"], [0, "&triplus;"], [0, "&triminus;"], [0, "&tritime;"], [0, "&intprod;"], [2, "&amalg;"], [0, "&capdot;"], [1, "&ncup;"], [0, "&ncap;"], [0, "&capand;"], [0, "&cupor;"], [0, "&cupcap;"], [0, "&capcup;"], [0, "&cupbrcap;"], [0, "&capbrcup;"], [0, "&cupcup;"], [0, "&capcap;"], [0, "&ccups;"], [0, "&ccaps;"], [2, "&ccupssm;"], [2, "&And;"], [0, "&Or;"], [0, "&andand;"], [0, "&oror;"], [0, "&orslope;"], [0, "&andslope;"], [1, "&andv;"], [0, "&orv;"], [0, "&andd;"], [0, "&ord;"], [1, "&wedbar;"], [6, "&sdote;"], [3, "&simdot;"], [2, { v: "&congdot;", n: 824, o: "&ncongdot;" }], [0, "&easter;"], [0, "&apacir;"], [0, { v: "&apE;", n: 824, o: "&napE;" }], [0, "&eplus;"], [0, "&pluse;"], [0, "&Esim;"], [0, "&Colone;"], [0, "&Equal;"], [1, "&ddotseq;"], [0, "&equivDD;"], [0, "&ltcir;"], [0, "&gtcir;"], [0, "&ltquest;"], [0, "&gtquest;"], [0, { v: "&leqslant;", n: 824, o: "&nleqslant;" }], [0, { v: "&geqslant;", n: 824, o: "&ngeqslant;" }], [0, "&lesdot;"], [0, "&gesdot;"], [0, "&lesdoto;"], [0, "&gesdoto;"], [0, "&lesdotor;"], [0, "&gesdotol;"], [0, "&lap;"], [0, "&gap;"], [0, "&lne;"], [0, "&gne;"], [0, "&lnap;"], [0, "&gnap;"], [0, "&lEg;"], [0, "&gEl;"], [0, "&lsime;"], [0, "&gsime;"], [0, "&lsimg;"], [0, "&gsiml;"], [0, "&lgE;"], [0, "&glE;"], [0, "&lesges;"], [0, "&gesles;"], [0, "&els;"], [0, "&egs;"], [0, "&elsdot;"], [0, "&egsdot;"], [0, "&el;"], [0, "&eg;"], [2, "&siml;"], [0, "&simg;"], [0, "&simlE;"], [0, "&simgE;"], [0, { v: "&LessLess;", n: 824, o: "&NotNestedLessLess;" }], [0, { v: "&GreaterGreater;", n: 824, o: "&NotNestedGreaterGreater;" }], [1, "&glj;"], [0, "&gla;"], [0, "&ltcc;"], [0, "&gtcc;"], [0, "&lescc;"], [0, "&gescc;"], [0, "&smt;"], [0, "&lat;"], [0, { v: "&smte;", n: 65024, o: "&smtes;" }], [0, { v: "&late;", n: 65024, o: "&lates;" }], [0, "&bumpE;"], [0, { v: "&PrecedesEqual;", n: 824, o: "&NotPrecedesEqual;" }], [0, { v: "&sce;", n: 824, o: "&NotSucceedsEqual;" }], [2, "&prE;"], [0, "&scE;"], [0, "&precneqq;"], [0, "&scnE;"], [0, "&prap;"], [0, "&scap;"], [0, "&precnapprox;"], [0, "&scnap;"], [0, "&Pr;"], [0, "&Sc;"], [0, "&subdot;"], [0, "&supdot;"], [0, "&subplus;"], [0, "&supplus;"], [0, "&submult;"], [0, "&supmult;"], [0, "&subedot;"], [0, "&supedot;"], [0, { v: "&subE;", n: 824, o: "&nsubE;" }], [0, { v: "&supE;", n: 824, o: "&nsupE;" }], [0, "&subsim;"], [0, "&supsim;"], [2, { v: "&subnE;", n: 65024, o: "&varsubsetneqq;" }], [0, { v: "&supnE;", n: 65024, o: "&varsupsetneqq;" }], [2, "&csub;"], [0, "&csup;"], [0, "&csube;"], [0, "&csupe;"], [0, "&subsup;"], [0, "&supsub;"], [0, "&subsub;"], [0, "&supsup;"], [0, "&suphsub;"], [0, "&supdsub;"], [0, "&forkv;"], [0, "&topfork;"], [0, "&mlcp;"], [8, "&Dashv;"], [1, "&Vdashl;"], [0, "&Barv;"], [0, "&vBar;"], [0, "&vBarv;"], [1, "&Vbar;"], [0, "&Not;"], [0, "&bNot;"], [0, "&rnmid;"], [0, "&cirmid;"], [0, "&midcir;"], [0, "&topcir;"], [0, "&nhpar;"], [0, "&parsim;"], [9, { v: "&parsl;", n: 8421, o: "&nparsl;" }], [44343, { n: new Map(/* #__PURE__ */ restoreDiff([[56476, "&Ascr;"], [1, "&Cscr;"], [0, "&Dscr;"], [2, "&Gscr;"], [2, "&Jscr;"], [0, "&Kscr;"], [2, "&Nscr;"], [0, "&Oscr;"], [0, "&Pscr;"], [0, "&Qscr;"], [1, "&Sscr;"], [0, "&Tscr;"], [0, "&Uscr;"], [0, "&Vscr;"], [0, "&Wscr;"], [0, "&Xscr;"], [0, "&Yscr;"], [0, "&Zscr;"], [0, "&ascr;"], [0, "&bscr;"], [0, "&cscr;"], [0, "&dscr;"], [1, "&fscr;"], [1, "&hscr;"], [0, "&iscr;"], [0, "&jscr;"], [0, "&kscr;"], [0, "&lscr;"], [0, "&mscr;"], [0, "&nscr;"], [1, "&pscr;"], [0, "&qscr;"], [0, "&rscr;"], [0, "&sscr;"], [0, "&tscr;"], [0, "&uscr;"], [0, "&vscr;"], [0, "&wscr;"], [0, "&xscr;"], [0, "&yscr;"], [0, "&zscr;"], [52, "&Afr;"], [0, "&Bfr;"], [1, "&Dfr;"], [0, "&Efr;"], [0, "&Ffr;"], [0, "&Gfr;"], [2, "&Jfr;"], [0, "&Kfr;"], [0, "&Lfr;"], [0, "&Mfr;"], [0, "&Nfr;"], [0, "&Ofr;"], [0, "&Pfr;"], [0, "&Qfr;"], [1, "&Sfr;"], [0, "&Tfr;"], [0, "&Ufr;"], [0, "&Vfr;"], [0, "&Wfr;"], [0, "&Xfr;"], [0, "&Yfr;"], [1, "&afr;"], [0, "&bfr;"], [0, "&cfr;"], [0, "&dfr;"], [0, "&efr;"], [0, "&ffr;"], [0, "&gfr;"], [0, "&hfr;"], [0, "&ifr;"], [0, "&jfr;"], [0, "&kfr;"], [0, "&lfr;"], [0, "&mfr;"], [0, "&nfr;"], [0, "&ofr;"], [0, "&pfr;"], [0, "&qfr;"], [0, "&rfr;"], [0, "&sfr;"], [0, "&tfr;"], [0, "&ufr;"], [0, "&vfr;"], [0, "&wfr;"], [0, "&xfr;"], [0, "&yfr;"], [0, "&zfr;"], [0, "&Aopf;"], [0, "&Bopf;"], [1, "&Dopf;"], [0, "&Eopf;"], [0, "&Fopf;"], [0, "&Gopf;"], [1, "&Iopf;"], [0, "&Jopf;"], [0, "&Kopf;"], [0, "&Lopf;"], [0, "&Mopf;"], [1, "&Oopf;"], [3, "&Sopf;"], [0, "&Topf;"], [0, "&Uopf;"], [0, "&Vopf;"], [0, "&Wopf;"], [0, "&Xopf;"], [0, "&Yopf;"], [1, "&aopf;"], [0, "&bopf;"], [0, "&copf;"], [0, "&dopf;"], [0, "&eopf;"], [0, "&fopf;"], [0, "&gopf;"], [0, "&hopf;"], [0, "&iopf;"], [0, "&jopf;"], [0, "&kopf;"], [0, "&lopf;"], [0, "&mopf;"], [0, "&nopf;"], [0, "&oopf;"], [0, "&popf;"], [0, "&qopf;"], [0, "&ropf;"], [0, "&sopf;"], [0, "&topf;"], [0, "&uopf;"], [0, "&vopf;"], [0, "&wopf;"], [0, "&xopf;"], [0, "&yopf;"], [0, "&zopf;"]])) }], [8906, "&fflig;"], [0, "&filig;"], [0, "&fllig;"], [0, "&ffilig;"], [0, "&ffllig;"]]));

var _escape = {};

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.escapeText = exports.escapeAttribute = exports.escapeUTF8 = exports.escape = exports.encodeXML = exports.getCodePoint = exports.xmlReplacer = void 0;
	exports.xmlReplacer = /["&'<>$\x80-\uFFFF]/g;
	var xmlCodeMap = new Map([
	    [34, "&quot;"],
	    [38, "&amp;"],
	    [39, "&apos;"],
	    [60, "&lt;"],
	    [62, "&gt;"],
	]);
	// For compatibility with node < 4, we wrap `codePointAt`
	exports.getCodePoint = 
	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
	String.prototype.codePointAt != null
	    ? function (str, index) { return str.codePointAt(index); }
	    : // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
	        function (c, index) {
	            return (c.charCodeAt(index) & 0xfc00) === 0xd800
	                ? (c.charCodeAt(index) - 0xd800) * 0x400 +
	                    c.charCodeAt(index + 1) -
	                    0xdc00 +
	                    0x10000
	                : c.charCodeAt(index);
	        };
	/**
	 * Encodes all non-ASCII characters, as well as characters not valid in XML
	 * documents using XML entities.
	 *
	 * If a character has no equivalent entity, a
	 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
	 */
	function encodeXML(str) {
	    var ret = "";
	    var lastIdx = 0;
	    var match;
	    while ((match = exports.xmlReplacer.exec(str)) !== null) {
	        var i = match.index;
	        var char = str.charCodeAt(i);
	        var next = xmlCodeMap.get(char);
	        if (next !== undefined) {
	            ret += str.substring(lastIdx, i) + next;
	            lastIdx = i + 1;
	        }
	        else {
	            ret += "".concat(str.substring(lastIdx, i), "&#x").concat((0, exports.getCodePoint)(str, i).toString(16), ";");
	            // Increase by 1 if we have a surrogate pair
	            lastIdx = exports.xmlReplacer.lastIndex += Number((char & 0xfc00) === 0xd800);
	        }
	    }
	    return ret + str.substr(lastIdx);
	}
	exports.encodeXML = encodeXML;
	/**
	 * Encodes all non-ASCII characters, as well as characters not valid in XML
	 * documents using numeric hexadecimal reference (eg. `&#xfc;`).
	 *
	 * Have a look at `escapeUTF8` if you want a more concise output at the expense
	 * of reduced transportability.
	 *
	 * @param data String to escape.
	 */
	exports.escape = encodeXML;
	/**
	 * Creates a function that escapes all characters matched by the given regular
	 * expression using the given map of characters to escape to their entities.
	 *
	 * @param regex Regular expression to match characters to escape.
	 * @param map Map of characters to escape to their entities.
	 *
	 * @returns Function that escapes all characters matched by the given regular
	 * expression using the given map of characters to escape to their entities.
	 */
	function getEscaper(regex, map) {
	    return function escape(data) {
	        var match;
	        var lastIdx = 0;
	        var result = "";
	        while ((match = regex.exec(data))) {
	            if (lastIdx !== match.index) {
	                result += data.substring(lastIdx, match.index);
	            }
	            // We know that this character will be in the map.
	            result += map.get(match[0].charCodeAt(0));
	            // Every match will be of length 1
	            lastIdx = match.index + 1;
	        }
	        return result + data.substring(lastIdx);
	    };
	}
	/**
	 * Encodes all characters not valid in XML documents using XML entities.
	 *
	 * Note that the output will be character-set dependent.
	 *
	 * @param data String to escape.
	 */
	exports.escapeUTF8 = getEscaper(/[&<>'"]/g, xmlCodeMap);
	/**
	 * Encodes all characters that have to be escaped in HTML attributes,
	 * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
	 *
	 * @param data String to escape.
	 */
	exports.escapeAttribute = getEscaper(/["&\u00A0]/g, new Map([
	    [34, "&quot;"],
	    [38, "&amp;"],
	    [160, "&nbsp;"],
	]));
	/**
	 * Encodes all characters that have to be escaped in HTML text,
	 * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
	 *
	 * @param data String to escape.
	 */
	exports.escapeText = getEscaper(/[&<>\u00A0]/g, new Map([
	    [38, "&amp;"],
	    [60, "&lt;"],
	    [62, "&gt;"],
	    [160, "&nbsp;"],
	]));
	
} (_escape));

var __importDefault$1 = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(encode, "__esModule", { value: true });
encode.encodeNonAsciiHTML = encode.encodeHTML = void 0;
var encode_html_js_1 = __importDefault$1(encodeHtml);
var escape_js_1 = _escape;
var htmlReplacer = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
/**
 * Encodes all characters in the input using HTML entities. This includes
 * characters that are valid ASCII characters in HTML documents, such as `#`.
 *
 * To get a more compact output, consider using the `encodeNonAsciiHTML`
 * function, which will only encode characters that are not valid in HTML
 * documents, as well as non-ASCII characters.
 *
 * If a character has no equivalent entity, a numeric hexadecimal reference
 * (eg. `&#xfc;`) will be used.
 */
function encodeHTML(data) {
    return encodeHTMLTrieRe(htmlReplacer, data);
}
encode.encodeHTML = encodeHTML;
/**
 * Encodes all non-ASCII characters, as well as characters not valid in HTML
 * documents using HTML entities. This function will not encode characters that
 * are valid in HTML documents, such as `#`.
 *
 * If a character has no equivalent entity, a numeric hexadecimal reference
 * (eg. `&#xfc;`) will be used.
 */
function encodeNonAsciiHTML(data) {
    return encodeHTMLTrieRe(escape_js_1.xmlReplacer, data);
}
encode.encodeNonAsciiHTML = encodeNonAsciiHTML;
function encodeHTMLTrieRe(regExp, str) {
    var ret = "";
    var lastIdx = 0;
    var match;
    while ((match = regExp.exec(str)) !== null) {
        var i = match.index;
        ret += str.substring(lastIdx, i);
        var char = str.charCodeAt(i);
        var next = encode_html_js_1.default.get(char);
        if (typeof next === "object") {
            // We are in a branch. Try to match the next char.
            if (i + 1 < str.length) {
                var nextChar = str.charCodeAt(i + 1);
                var value = typeof next.n === "number"
                    ? next.n === nextChar
                        ? next.o
                        : undefined
                    : next.n.get(nextChar);
                if (value !== undefined) {
                    ret += value;
                    lastIdx = regExp.lastIndex += 1;
                    continue;
                }
            }
            next = next.v;
        }
        // We might have a tree node without a value; skip and use a numeric entity.
        if (next !== undefined) {
            ret += next;
            lastIdx = i + 1;
        }
        else {
            var cp = (0, escape_js_1.getCodePoint)(str, i);
            ret += "&#x".concat(cp.toString(16), ";");
            // Increase by 1 if we have a surrogate pair
            lastIdx = regExp.lastIndex += Number(cp !== char);
        }
    }
    return ret + str.substr(lastIdx);
}

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.decodeXMLStrict = exports.decodeHTML5Strict = exports.decodeHTML4Strict = exports.decodeHTML5 = exports.decodeHTML4 = exports.decodeHTMLAttribute = exports.decodeHTMLStrict = exports.decodeHTML = exports.decodeXML = exports.DecodingMode = exports.EntityDecoder = exports.encodeHTML5 = exports.encodeHTML4 = exports.encodeNonAsciiHTML = exports.encodeHTML = exports.escapeText = exports.escapeAttribute = exports.escapeUTF8 = exports.escape = exports.encodeXML = exports.encode = exports.decodeStrict = exports.decode = exports.EncodingMode = exports.EntityLevel = void 0;
	var decode_js_1 = decode;
	var encode_js_1 = encode;
	var escape_js_1 = _escape;
	/** The level of entities to support. */
	var EntityLevel;
	(function (EntityLevel) {
	    /** Support only XML entities. */
	    EntityLevel[EntityLevel["XML"] = 0] = "XML";
	    /** Support HTML entities, which are a superset of XML entities. */
	    EntityLevel[EntityLevel["HTML"] = 1] = "HTML";
	})(EntityLevel = exports.EntityLevel || (exports.EntityLevel = {}));
	var EncodingMode;
	(function (EncodingMode) {
	    /**
	     * The output is UTF-8 encoded. Only characters that need escaping within
	     * XML will be escaped.
	     */
	    EncodingMode[EncodingMode["UTF8"] = 0] = "UTF8";
	    /**
	     * The output consists only of ASCII characters. Characters that need
	     * escaping within HTML, and characters that aren't ASCII characters will
	     * be escaped.
	     */
	    EncodingMode[EncodingMode["ASCII"] = 1] = "ASCII";
	    /**
	     * Encode all characters that have an equivalent entity, as well as all
	     * characters that are not ASCII characters.
	     */
	    EncodingMode[EncodingMode["Extensive"] = 2] = "Extensive";
	    /**
	     * Encode all characters that have to be escaped in HTML attributes,
	     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
	     */
	    EncodingMode[EncodingMode["Attribute"] = 3] = "Attribute";
	    /**
	     * Encode all characters that have to be escaped in HTML text,
	     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
	     */
	    EncodingMode[EncodingMode["Text"] = 4] = "Text";
	})(EncodingMode = exports.EncodingMode || (exports.EncodingMode = {}));
	/**
	 * Decodes a string with entities.
	 *
	 * @param data String to decode.
	 * @param options Decoding options.
	 */
	function decode$1(data, options) {
	    if (options === void 0) { options = EntityLevel.XML; }
	    var level = typeof options === "number" ? options : options.level;
	    if (level === EntityLevel.HTML) {
	        var mode = typeof options === "object" ? options.mode : undefined;
	        return (0, decode_js_1.decodeHTML)(data, mode);
	    }
	    return (0, decode_js_1.decodeXML)(data);
	}
	exports.decode = decode$1;
	/**
	 * Decodes a string with entities. Does not allow missing trailing semicolons for entities.
	 *
	 * @param data String to decode.
	 * @param options Decoding options.
	 * @deprecated Use `decode` with the `mode` set to `Strict`.
	 */
	function decodeStrict(data, options) {
	    var _a;
	    if (options === void 0) { options = EntityLevel.XML; }
	    var opts = typeof options === "number" ? { level: options } : options;
	    (_a = opts.mode) !== null && _a !== void 0 ? _a : (opts.mode = decode_js_1.DecodingMode.Strict);
	    return decode$1(data, opts);
	}
	exports.decodeStrict = decodeStrict;
	/**
	 * Encodes a string with entities.
	 *
	 * @param data String to encode.
	 * @param options Encoding options.
	 */
	function encode$1(data, options) {
	    if (options === void 0) { options = EntityLevel.XML; }
	    var opts = typeof options === "number" ? { level: options } : options;
	    // Mode `UTF8` just escapes XML entities
	    if (opts.mode === EncodingMode.UTF8)
	        return (0, escape_js_1.escapeUTF8)(data);
	    if (opts.mode === EncodingMode.Attribute)
	        return (0, escape_js_1.escapeAttribute)(data);
	    if (opts.mode === EncodingMode.Text)
	        return (0, escape_js_1.escapeText)(data);
	    if (opts.level === EntityLevel.HTML) {
	        if (opts.mode === EncodingMode.ASCII) {
	            return (0, encode_js_1.encodeNonAsciiHTML)(data);
	        }
	        return (0, encode_js_1.encodeHTML)(data);
	    }
	    // ASCII and Extensive are equivalent
	    return (0, escape_js_1.encodeXML)(data);
	}
	exports.encode = encode$1;
	var escape_js_2 = _escape;
	Object.defineProperty(exports, "encodeXML", { enumerable: true, get: function () { return escape_js_2.encodeXML; } });
	Object.defineProperty(exports, "escape", { enumerable: true, get: function () { return escape_js_2.escape; } });
	Object.defineProperty(exports, "escapeUTF8", { enumerable: true, get: function () { return escape_js_2.escapeUTF8; } });
	Object.defineProperty(exports, "escapeAttribute", { enumerable: true, get: function () { return escape_js_2.escapeAttribute; } });
	Object.defineProperty(exports, "escapeText", { enumerable: true, get: function () { return escape_js_2.escapeText; } });
	var encode_js_2 = encode;
	Object.defineProperty(exports, "encodeHTML", { enumerable: true, get: function () { return encode_js_2.encodeHTML; } });
	Object.defineProperty(exports, "encodeNonAsciiHTML", { enumerable: true, get: function () { return encode_js_2.encodeNonAsciiHTML; } });
	// Legacy aliases (deprecated)
	Object.defineProperty(exports, "encodeHTML4", { enumerable: true, get: function () { return encode_js_2.encodeHTML; } });
	Object.defineProperty(exports, "encodeHTML5", { enumerable: true, get: function () { return encode_js_2.encodeHTML; } });
	var decode_js_2 = decode;
	Object.defineProperty(exports, "EntityDecoder", { enumerable: true, get: function () { return decode_js_2.EntityDecoder; } });
	Object.defineProperty(exports, "DecodingMode", { enumerable: true, get: function () { return decode_js_2.DecodingMode; } });
	Object.defineProperty(exports, "decodeXML", { enumerable: true, get: function () { return decode_js_2.decodeXML; } });
	Object.defineProperty(exports, "decodeHTML", { enumerable: true, get: function () { return decode_js_2.decodeHTML; } });
	Object.defineProperty(exports, "decodeHTMLStrict", { enumerable: true, get: function () { return decode_js_2.decodeHTMLStrict; } });
	Object.defineProperty(exports, "decodeHTMLAttribute", { enumerable: true, get: function () { return decode_js_2.decodeHTMLAttribute; } });
	// Legacy aliases (deprecated)
	Object.defineProperty(exports, "decodeHTML4", { enumerable: true, get: function () { return decode_js_2.decodeHTML; } });
	Object.defineProperty(exports, "decodeHTML5", { enumerable: true, get: function () { return decode_js_2.decodeHTML; } });
	Object.defineProperty(exports, "decodeHTML4Strict", { enumerable: true, get: function () { return decode_js_2.decodeHTMLStrict; } });
	Object.defineProperty(exports, "decodeHTML5Strict", { enumerable: true, get: function () { return decode_js_2.decodeHTMLStrict; } });
	Object.defineProperty(exports, "decodeXMLStrict", { enumerable: true, get: function () { return decode_js_2.decodeXML; } });
	
} (lib));

var foreignNames = {};

Object.defineProperty(foreignNames, "__esModule", { value: true });
foreignNames.attributeNames = foreignNames.elementNames = void 0;
foreignNames.elementNames = new Map([
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "clipPath",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "foreignObject",
    "glyphRef",
    "linearGradient",
    "radialGradient",
    "textPath",
].map(function (val) { return [val.toLowerCase(), val]; }));
foreignNames.attributeNames = new Map([
    "definitionURL",
    "attributeName",
    "attributeType",
    "baseFrequency",
    "baseProfile",
    "calcMode",
    "clipPathUnits",
    "diffuseConstant",
    "edgeMode",
    "filterUnits",
    "glyphRef",
    "gradientTransform",
    "gradientUnits",
    "kernelMatrix",
    "kernelUnitLength",
    "keyPoints",
    "keySplines",
    "keyTimes",
    "lengthAdjust",
    "limitingConeAngle",
    "markerHeight",
    "markerUnits",
    "markerWidth",
    "maskContentUnits",
    "maskUnits",
    "numOctaves",
    "pathLength",
    "patternContentUnits",
    "patternTransform",
    "patternUnits",
    "pointsAtX",
    "pointsAtY",
    "pointsAtZ",
    "preserveAlpha",
    "preserveAspectRatio",
    "primitiveUnits",
    "refX",
    "refY",
    "repeatCount",
    "repeatDur",
    "requiredExtensions",
    "requiredFeatures",
    "specularConstant",
    "specularExponent",
    "spreadMethod",
    "startOffset",
    "stdDeviation",
    "stitchTiles",
    "surfaceScale",
    "systemLanguage",
    "tableValues",
    "targetX",
    "targetY",
    "textLength",
    "viewBox",
    "viewTarget",
    "xChannelSelector",
    "yChannelSelector",
    "zoomAndPan",
].map(function (val) { return [val.toLowerCase(), val]; }));

var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(lib$1, "__esModule", { value: true });
lib$1.render = void 0;
/*
 * Module dependencies
 */
var ElementType = __importStar(lib$3);
var entities_1 = lib;
/**
 * Mixed-case SVG and MathML tags & attributes
 * recognized by the HTML parser.
 *
 * @see https://html.spec.whatwg.org/multipage/parsing.html#parsing-main-inforeign
 */
var foreignNames_js_1 = foreignNames;
var unencodedElements = new Set([
    "style",
    "script",
    "xmp",
    "iframe",
    "noembed",
    "noframes",
    "plaintext",
    "noscript",
]);
function replaceQuotes(value) {
    return value.replace(/"/g, "&quot;");
}
/**
 * Format attributes
 */
function formatAttributes(attributes, opts) {
    var _a;
    if (!attributes)
        return;
    var encode = ((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) === false
        ? replaceQuotes
        : opts.xmlMode || opts.encodeEntities !== "utf8"
            ? entities_1.encodeXML
            : entities_1.escapeAttribute;
    return Object.keys(attributes)
        .map(function (key) {
        var _a, _b;
        var value = (_a = attributes[key]) !== null && _a !== void 0 ? _a : "";
        if (opts.xmlMode === "foreign") {
            /* Fix up mixed-case attribute names */
            key = (_b = foreignNames_js_1.attributeNames.get(key)) !== null && _b !== void 0 ? _b : key;
        }
        if (!opts.emptyAttrs && !opts.xmlMode && value === "") {
            return key;
        }
        return "".concat(key, "=\"").concat(encode(value), "\"");
    })
        .join(" ");
}
/**
 * Self-enclosing tags
 */
var singleTag = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr",
]);
/**
 * Renders a DOM node or an array of DOM nodes to a string.
 *
 * Can be thought of as the equivalent of the `outerHTML` of the passed node(s).
 *
 * @param node Node to be rendered.
 * @param options Changes serialization behavior
 */
function render(node, options) {
    if (options === void 0) { options = {}; }
    var nodes = "length" in node ? node : [node];
    var output = "";
    for (var i = 0; i < nodes.length; i++) {
        output += renderNode(nodes[i], options);
    }
    return output;
}
lib$1.render = render;
lib$1.default = render;
function renderNode(node, options) {
    switch (node.type) {
        case ElementType.Root:
            return render(node.children, options);
        // @ts-expect-error We don't use `Doctype` yet
        case ElementType.Doctype:
        case ElementType.Directive:
            return renderDirective(node);
        case ElementType.Comment:
            return renderComment(node);
        case ElementType.CDATA:
            return renderCdata(node);
        case ElementType.Script:
        case ElementType.Style:
        case ElementType.Tag:
            return renderTag(node, options);
        case ElementType.Text:
            return renderText(node, options);
    }
}
var foreignModeIntegrationPoints = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignObject",
    "desc",
    "title",
]);
var foreignElements = new Set(["svg", "math"]);
function renderTag(elem, opts) {
    var _a;
    // Handle SVG / MathML in HTML
    if (opts.xmlMode === "foreign") {
        /* Fix up mixed-case element names */
        elem.name = (_a = foreignNames_js_1.elementNames.get(elem.name)) !== null && _a !== void 0 ? _a : elem.name;
        /* Exit foreign mode at integration points */
        if (elem.parent &&
            foreignModeIntegrationPoints.has(elem.parent.name)) {
            opts = __assign(__assign({}, opts), { xmlMode: false });
        }
    }
    if (!opts.xmlMode && foreignElements.has(elem.name)) {
        opts = __assign(__assign({}, opts), { xmlMode: "foreign" });
    }
    var tag = "<".concat(elem.name);
    var attribs = formatAttributes(elem.attribs, opts);
    if (attribs) {
        tag += " ".concat(attribs);
    }
    if (elem.children.length === 0 &&
        (opts.xmlMode
            ? // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
                opts.selfClosingTags !== false
            : // User explicitly asked for self-closing tags, even in HTML mode
                opts.selfClosingTags && singleTag.has(elem.name))) {
        if (!opts.xmlMode)
            tag += " ";
        tag += "/>";
    }
    else {
        tag += ">";
        if (elem.children.length > 0) {
            tag += render(elem.children, opts);
        }
        if (opts.xmlMode || !singleTag.has(elem.name)) {
            tag += "</".concat(elem.name, ">");
        }
    }
    return tag;
}
function renderDirective(elem) {
    return "<".concat(elem.data, ">");
}
function renderText(elem, opts) {
    var _a;
    var data = elem.data || "";
    // If entities weren't decoded, no need to encode them back
    if (((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) !== false &&
        !(!opts.xmlMode &&
            elem.parent &&
            unencodedElements.has(elem.parent.name))) {
        data =
            opts.xmlMode || opts.encodeEntities !== "utf8"
                ? (0, entities_1.encodeXML)(data)
                : (0, entities_1.escapeText)(data);
    }
    return data;
}
function renderCdata(elem) {
    return "<![CDATA[".concat(elem.children[0].data, "]]>");
}
function renderComment(elem) {
    return "<!--".concat(elem.data, "-->");
}

var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(stringify$5, "__esModule", { value: true });
stringify$5.getOuterHTML = getOuterHTML;
stringify$5.getInnerHTML = getInnerHTML;
stringify$5.getText = getText;
stringify$5.textContent = textContent;
stringify$5.innerText = innerText;
var domhandler_1$4 = lib$4;
var dom_serializer_1 = __importDefault(lib$1);
var domelementtype_1 = lib$3;
/**
 * @category Stringify
 * @deprecated Use the `dom-serializer` module directly.
 * @param node Node to get the outer HTML of.
 * @param options Options for serialization.
 * @returns `node`'s outer HTML.
 */
function getOuterHTML(node, options) {
    return (0, dom_serializer_1.default)(node, options);
}
/**
 * @category Stringify
 * @deprecated Use the `dom-serializer` module directly.
 * @param node Node to get the inner HTML of.
 * @param options Options for serialization.
 * @returns `node`'s inner HTML.
 */
function getInnerHTML(node, options) {
    return (0, domhandler_1$4.hasChildren)(node)
        ? node.children.map(function (node) { return getOuterHTML(node, options); }).join("")
        : "";
}
/**
 * Get a node's inner text. Same as `textContent`, but inserts newlines for `<br>` tags. Ignores comments.
 *
 * @category Stringify
 * @deprecated Use `textContent` instead.
 * @param node Node to get the inner text of.
 * @returns `node`'s inner text.
 */
function getText(node) {
    if (Array.isArray(node))
        return node.map(getText).join("");
    if ((0, domhandler_1$4.isTag)(node))
        return node.name === "br" ? "\n" : getText(node.children);
    if ((0, domhandler_1$4.isCDATA)(node))
        return getText(node.children);
    if ((0, domhandler_1$4.isText)(node))
        return node.data;
    return "";
}
/**
 * Get a node's text content. Ignores comments.
 *
 * @category Stringify
 * @param node Node to get the text content of.
 * @returns `node`'s text content.
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Node/textContent}
 */
function textContent(node) {
    if (Array.isArray(node))
        return node.map(textContent).join("");
    if ((0, domhandler_1$4.hasChildren)(node) && !(0, domhandler_1$4.isComment)(node)) {
        return textContent(node.children);
    }
    if ((0, domhandler_1$4.isText)(node))
        return node.data;
    return "";
}
/**
 * Get a node's inner text, ignoring `<script>` and `<style>` tags. Ignores comments.
 *
 * @category Stringify
 * @param node Node to get the inner text of.
 * @returns `node`'s inner text.
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Node/innerText}
 */
function innerText(node) {
    if (Array.isArray(node))
        return node.map(innerText).join("");
    if ((0, domhandler_1$4.hasChildren)(node) && (node.type === domelementtype_1.ElementType.Tag || (0, domhandler_1$4.isCDATA)(node))) {
        return innerText(node.children);
    }
    if ((0, domhandler_1$4.isText)(node))
        return node.data;
    return "";
}

var traversal = {};

Object.defineProperty(traversal, "__esModule", { value: true });
traversal.getChildren = getChildren;
traversal.getParent = getParent;
traversal.getSiblings = getSiblings;
traversal.getAttributeValue = getAttributeValue;
traversal.hasAttrib = hasAttrib;
traversal.getName = getName;
traversal.nextElementSibling = nextElementSibling;
traversal.prevElementSibling = prevElementSibling;
var domhandler_1$3 = lib$4;
/**
 * Get a node's children.
 *
 * @category Traversal
 * @param elem Node to get the children of.
 * @returns `elem`'s children, or an empty array.
 */
function getChildren(elem) {
    return (0, domhandler_1$3.hasChildren)(elem) ? elem.children : [];
}
/**
 * Get a node's parent.
 *
 * @category Traversal
 * @param elem Node to get the parent of.
 * @returns `elem`'s parent node, or `null` if `elem` is a root node.
 */
function getParent(elem) {
    return elem.parent || null;
}
/**
 * Gets an elements siblings, including the element itself.
 *
 * Attempts to get the children through the element's parent first. If we don't
 * have a parent (the element is a root node), we walk the element's `prev` &
 * `next` to get all remaining nodes.
 *
 * @category Traversal
 * @param elem Element to get the siblings of.
 * @returns `elem`'s siblings, including `elem`.
 */
function getSiblings(elem) {
    var _a, _b;
    var parent = getParent(elem);
    if (parent != null)
        return getChildren(parent);
    var siblings = [elem];
    var prev = elem.prev, next = elem.next;
    while (prev != null) {
        siblings.unshift(prev);
        (_a = prev, prev = _a.prev);
    }
    while (next != null) {
        siblings.push(next);
        (_b = next, next = _b.next);
    }
    return siblings;
}
/**
 * Gets an attribute from an element.
 *
 * @category Traversal
 * @param elem Element to check.
 * @param name Attribute name to retrieve.
 * @returns The element's attribute value, or `undefined`.
 */
function getAttributeValue(elem, name) {
    var _a;
    return (_a = elem.attribs) === null || _a === void 0 ? void 0 : _a[name];
}
/**
 * Checks whether an element has an attribute.
 *
 * @category Traversal
 * @param elem Element to check.
 * @param name Attribute name to look for.
 * @returns Returns whether `elem` has the attribute `name`.
 */
function hasAttrib(elem, name) {
    return (elem.attribs != null &&
        Object.prototype.hasOwnProperty.call(elem.attribs, name) &&
        elem.attribs[name] != null);
}
/**
 * Get the tag name of an element.
 *
 * @category Traversal
 * @param elem The element to get the name for.
 * @returns The tag name of `elem`.
 */
function getName(elem) {
    return elem.name;
}
/**
 * Returns the next element sibling of a node.
 *
 * @category Traversal
 * @param elem The element to get the next sibling of.
 * @returns `elem`'s next sibling that is a tag, or `null` if there is no next
 * sibling.
 */
function nextElementSibling(elem) {
    var _a;
    var next = elem.next;
    while (next !== null && !(0, domhandler_1$3.isTag)(next))
        (_a = next, next = _a.next);
    return next;
}
/**
 * Returns the previous element sibling of a node.
 *
 * @category Traversal
 * @param elem The element to get the previous sibling of.
 * @returns `elem`'s previous sibling that is a tag, or `null` if there is no
 * previous sibling.
 */
function prevElementSibling(elem) {
    var _a;
    var prev = elem.prev;
    while (prev !== null && !(0, domhandler_1$3.isTag)(prev))
        (_a = prev, prev = _a.prev);
    return prev;
}

var manipulation = {};

Object.defineProperty(manipulation, "__esModule", { value: true });
manipulation.removeElement = removeElement;
manipulation.replaceElement = replaceElement;
manipulation.appendChild = appendChild;
manipulation.append = append;
manipulation.prependChild = prependChild;
manipulation.prepend = prepend;
/**
 * Remove an element from the dom
 *
 * @category Manipulation
 * @param elem The element to be removed
 */
function removeElement(elem) {
    if (elem.prev)
        elem.prev.next = elem.next;
    if (elem.next)
        elem.next.prev = elem.prev;
    if (elem.parent) {
        var childs = elem.parent.children;
        var childsIndex = childs.lastIndexOf(elem);
        if (childsIndex >= 0) {
            childs.splice(childsIndex, 1);
        }
    }
    elem.next = null;
    elem.prev = null;
    elem.parent = null;
}
/**
 * Replace an element in the dom
 *
 * @category Manipulation
 * @param elem The element to be replaced
 * @param replacement The element to be added
 */
function replaceElement(elem, replacement) {
    var prev = (replacement.prev = elem.prev);
    if (prev) {
        prev.next = replacement;
    }
    var next = (replacement.next = elem.next);
    if (next) {
        next.prev = replacement;
    }
    var parent = (replacement.parent = elem.parent);
    if (parent) {
        var childs = parent.children;
        childs[childs.lastIndexOf(elem)] = replacement;
        elem.parent = null;
    }
}
/**
 * Append a child to an element.
 *
 * @category Manipulation
 * @param parent The element to append to.
 * @param child The element to be added as a child.
 */
function appendChild(parent, child) {
    removeElement(child);
    child.next = null;
    child.parent = parent;
    if (parent.children.push(child) > 1) {
        var sibling = parent.children[parent.children.length - 2];
        sibling.next = child;
        child.prev = sibling;
    }
    else {
        child.prev = null;
    }
}
/**
 * Append an element after another.
 *
 * @category Manipulation
 * @param elem The element to append after.
 * @param next The element be added.
 */
function append(elem, next) {
    removeElement(next);
    var parent = elem.parent;
    var currNext = elem.next;
    next.next = currNext;
    next.prev = elem;
    elem.next = next;
    next.parent = parent;
    if (currNext) {
        currNext.prev = next;
        if (parent) {
            var childs = parent.children;
            childs.splice(childs.lastIndexOf(currNext), 0, next);
        }
    }
    else if (parent) {
        parent.children.push(next);
    }
}
/**
 * Prepend a child to an element.
 *
 * @category Manipulation
 * @param parent The element to prepend before.
 * @param child The element to be added as a child.
 */
function prependChild(parent, child) {
    removeElement(child);
    child.parent = parent;
    child.prev = null;
    if (parent.children.unshift(child) !== 1) {
        var sibling = parent.children[1];
        sibling.prev = child;
        child.next = sibling;
    }
    else {
        child.next = null;
    }
}
/**
 * Prepend an element before another.
 *
 * @category Manipulation
 * @param elem The element to prepend before.
 * @param prev The element be added.
 */
function prepend(elem, prev) {
    removeElement(prev);
    var parent = elem.parent;
    if (parent) {
        var childs = parent.children;
        childs.splice(childs.indexOf(elem), 0, prev);
    }
    if (elem.prev) {
        elem.prev.next = prev;
    }
    prev.parent = parent;
    prev.prev = elem.prev;
    prev.next = elem;
    elem.prev = prev;
}

var querying = {};

Object.defineProperty(querying, "__esModule", { value: true });
querying.filter = filter$1;
querying.find = find;
querying.findOneChild = findOneChild;
querying.findOne = findOne;
querying.existsOne = existsOne;
querying.findAll = findAll;
var domhandler_1$2 = lib$4;
/**
 * Search a node and its children for nodes passing a test function. If `node` is not an array, it will be wrapped in one.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param node Node to search. Will be included in the result set if it matches.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes passing `test`.
 */
function filter$1(test, node, recurse, limit) {
    if (recurse === void 0) { recurse = true; }
    if (limit === void 0) { limit = Infinity; }
    return find(test, Array.isArray(node) ? node : [node], recurse, limit);
}
/**
 * Search an array of nodes and their children for nodes passing a test function.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes passing `test`.
 */
function find(test, nodes, recurse, limit) {
    var result = [];
    /** Stack of the arrays we are looking at. */
    var nodeStack = [Array.isArray(nodes) ? nodes : [nodes]];
    /** Stack of the indices within the arrays. */
    var indexStack = [0];
    for (;;) {
        // First, check if the current array has any more elements to look at.
        if (indexStack[0] >= nodeStack[0].length) {
            // If we have no more arrays to look at, we are done.
            if (indexStack.length === 1) {
                return result;
            }
            // Otherwise, remove the current array from the stack.
            nodeStack.shift();
            indexStack.shift();
            // Loop back to the start to continue with the next array.
            continue;
        }
        var elem = nodeStack[0][indexStack[0]++];
        if (test(elem)) {
            result.push(elem);
            if (--limit <= 0)
                return result;
        }
        if (recurse && (0, domhandler_1$2.hasChildren)(elem) && elem.children.length > 0) {
            /*
             * Add the children to the stack. We are depth-first, so this is
             * the next array we look at.
             */
            indexStack.unshift(0);
            nodeStack.unshift(elem.children);
        }
    }
}
/**
 * Finds the first element inside of an array that matches a test function. This is an alias for `Array.prototype.find`.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @returns The first node in the array that passes `test`.
 * @deprecated Use `Array.prototype.find` directly.
 */
function findOneChild(test, nodes) {
    return nodes.find(test);
}
/**
 * Finds one element in a tree that passes a test.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param nodes Node or array of nodes to search.
 * @param recurse Also consider child nodes.
 * @returns The first node that passes `test`.
 */
function findOne(test, nodes, recurse) {
    if (recurse === void 0) { recurse = true; }
    var searchedNodes = Array.isArray(nodes) ? nodes : [nodes];
    for (var i = 0; i < searchedNodes.length; i++) {
        var node = searchedNodes[i];
        if ((0, domhandler_1$2.isTag)(node) && test(node)) {
            return node;
        }
        if (recurse && (0, domhandler_1$2.hasChildren)(node) && node.children.length > 0) {
            var found = findOne(test, node.children, true);
            if (found)
                return found;
        }
    }
    return null;
}
/**
 * Checks if a tree of nodes contains at least one node passing a test.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @returns Whether a tree of nodes contains at least one node passing the test.
 */
function existsOne(test, nodes) {
    return (Array.isArray(nodes) ? nodes : [nodes]).some(function (node) {
        return ((0, domhandler_1$2.isTag)(node) && test(node)) ||
            ((0, domhandler_1$2.hasChildren)(node) && existsOne(test, node.children));
    });
}
/**
 * Search an array of nodes and their children for elements passing a test function.
 *
 * Same as `find`, but limited to elements and with less options, leading to reduced complexity.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @returns All nodes passing `test`.
 */
function findAll(test, nodes) {
    var result = [];
    var nodeStack = [Array.isArray(nodes) ? nodes : [nodes]];
    var indexStack = [0];
    for (;;) {
        if (indexStack[0] >= nodeStack[0].length) {
            if (nodeStack.length === 1) {
                return result;
            }
            // Otherwise, remove the current array from the stack.
            nodeStack.shift();
            indexStack.shift();
            // Loop back to the start to continue with the next array.
            continue;
        }
        var elem = nodeStack[0][indexStack[0]++];
        if ((0, domhandler_1$2.isTag)(elem) && test(elem))
            result.push(elem);
        if ((0, domhandler_1$2.hasChildren)(elem) && elem.children.length > 0) {
            indexStack.unshift(0);
            nodeStack.unshift(elem.children);
        }
    }
}

var legacy = {};

Object.defineProperty(legacy, "__esModule", { value: true });
legacy.testElement = testElement;
legacy.getElements = getElements;
legacy.getElementById = getElementById;
legacy.getElementsByTagName = getElementsByTagName;
legacy.getElementsByClassName = getElementsByClassName;
legacy.getElementsByTagType = getElementsByTagType;
var domhandler_1$1 = lib$4;
var querying_js_1 = querying;
/**
 * A map of functions to check nodes against.
 */
var Checks = {
    tag_name: function (name) {
        if (typeof name === "function") {
            return function (elem) { return (0, domhandler_1$1.isTag)(elem) && name(elem.name); };
        }
        else if (name === "*") {
            return domhandler_1$1.isTag;
        }
        return function (elem) { return (0, domhandler_1$1.isTag)(elem) && elem.name === name; };
    },
    tag_type: function (type) {
        if (typeof type === "function") {
            return function (elem) { return type(elem.type); };
        }
        return function (elem) { return elem.type === type; };
    },
    tag_contains: function (data) {
        if (typeof data === "function") {
            return function (elem) { return (0, domhandler_1$1.isText)(elem) && data(elem.data); };
        }
        return function (elem) { return (0, domhandler_1$1.isText)(elem) && elem.data === data; };
    },
};
/**
 * Returns a function to check whether a node has an attribute with a particular
 * value.
 *
 * @param attrib Attribute to check.
 * @param value Attribute value to look for.
 * @returns A function to check whether the a node has an attribute with a
 *   particular value.
 */
function getAttribCheck(attrib, value) {
    if (typeof value === "function") {
        return function (elem) { return (0, domhandler_1$1.isTag)(elem) && value(elem.attribs[attrib]); };
    }
    return function (elem) { return (0, domhandler_1$1.isTag)(elem) && elem.attribs[attrib] === value; };
}
/**
 * Returns a function that returns `true` if either of the input functions
 * returns `true` for a node.
 *
 * @param a First function to combine.
 * @param b Second function to combine.
 * @returns A function taking a node and returning `true` if either of the input
 *   functions returns `true` for the node.
 */
function combineFuncs(a, b) {
    return function (elem) { return a(elem) || b(elem); };
}
/**
 * Returns a function that executes all checks in `options` and returns `true`
 * if any of them match a node.
 *
 * @param options An object describing nodes to look for.
 * @returns A function that executes all checks in `options` and returns `true`
 *   if any of them match a node.
 */
function compileTest(options) {
    var funcs = Object.keys(options).map(function (key) {
        var value = options[key];
        return Object.prototype.hasOwnProperty.call(Checks, key)
            ? Checks[key](value)
            : getAttribCheck(key, value);
    });
    return funcs.length === 0 ? null : funcs.reduce(combineFuncs);
}
/**
 * Checks whether a node matches the description in `options`.
 *
 * @category Legacy Query Functions
 * @param options An object describing nodes to look for.
 * @param node The element to test.
 * @returns Whether the element matches the description in `options`.
 */
function testElement(options, node) {
    var test = compileTest(options);
    return test ? test(node) : true;
}
/**
 * Returns all nodes that match `options`.
 *
 * @category Legacy Query Functions
 * @param options An object describing nodes to look for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes that match `options`.
 */
function getElements(options, nodes, recurse, limit) {
    if (limit === void 0) { limit = Infinity; }
    var test = compileTest(options);
    return test ? (0, querying_js_1.filter)(test, nodes, recurse, limit) : [];
}
/**
 * Returns the node with the supplied ID.
 *
 * @category Legacy Query Functions
 * @param id The unique ID attribute value to look for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @returns The node with the supplied ID.
 */
function getElementById(id, nodes, recurse) {
    if (recurse === void 0) { recurse = true; }
    if (!Array.isArray(nodes))
        nodes = [nodes];
    return (0, querying_js_1.findOne)(getAttribCheck("id", id), nodes, recurse);
}
/**
 * Returns all nodes with the supplied `tagName`.
 *
 * @category Legacy Query Functions
 * @param tagName Tag name to search for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes with the supplied `tagName`.
 */
function getElementsByTagName(tagName, nodes, recurse, limit) {
    if (recurse === void 0) { recurse = true; }
    if (limit === void 0) { limit = Infinity; }
    return (0, querying_js_1.filter)(Checks["tag_name"](tagName), nodes, recurse, limit);
}
/**
 * Returns all nodes with the supplied `className`.
 *
 * @category Legacy Query Functions
 * @param className Class name to search for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes with the supplied `className`.
 */
function getElementsByClassName(className, nodes, recurse, limit) {
    if (recurse === void 0) { recurse = true; }
    if (limit === void 0) { limit = Infinity; }
    return (0, querying_js_1.filter)(getAttribCheck("class", className), nodes, recurse, limit);
}
/**
 * Returns all nodes with the supplied `type`.
 *
 * @category Legacy Query Functions
 * @param type Element type to look for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes with the supplied `type`.
 */
function getElementsByTagType(type, nodes, recurse, limit) {
    if (recurse === void 0) { recurse = true; }
    if (limit === void 0) { limit = Infinity; }
    return (0, querying_js_1.filter)(Checks["tag_type"](type), nodes, recurse, limit);
}

var helpers = {};

Object.defineProperty(helpers, "__esModule", { value: true });
helpers.DocumentPosition = void 0;
helpers.removeSubsets = removeSubsets;
helpers.compareDocumentPosition = compareDocumentPosition;
helpers.uniqueSort = uniqueSort;
var domhandler_1 = lib$4;
/**
 * Given an array of nodes, remove any member that is contained by another
 * member.
 *
 * @category Helpers
 * @param nodes Nodes to filter.
 * @returns Remaining nodes that aren't contained by other nodes.
 */
function removeSubsets(nodes) {
    var idx = nodes.length;
    /*
     * Check if each node (or one of its ancestors) is already contained in the
     * array.
     */
    while (--idx >= 0) {
        var node = nodes[idx];
        /*
         * Remove the node if it is not unique.
         * We are going through the array from the end, so we only
         * have to check nodes that preceed the node under consideration in the array.
         */
        if (idx > 0 && nodes.lastIndexOf(node, idx - 1) >= 0) {
            nodes.splice(idx, 1);
            continue;
        }
        for (var ancestor = node.parent; ancestor; ancestor = ancestor.parent) {
            if (nodes.includes(ancestor)) {
                nodes.splice(idx, 1);
                break;
            }
        }
    }
    return nodes;
}
/**
 * @category Helpers
 * @see {@link http://dom.spec.whatwg.org/#dom-node-comparedocumentposition}
 */
var DocumentPosition;
(function (DocumentPosition) {
    DocumentPosition[DocumentPosition["DISCONNECTED"] = 1] = "DISCONNECTED";
    DocumentPosition[DocumentPosition["PRECEDING"] = 2] = "PRECEDING";
    DocumentPosition[DocumentPosition["FOLLOWING"] = 4] = "FOLLOWING";
    DocumentPosition[DocumentPosition["CONTAINS"] = 8] = "CONTAINS";
    DocumentPosition[DocumentPosition["CONTAINED_BY"] = 16] = "CONTAINED_BY";
})(DocumentPosition || (helpers.DocumentPosition = DocumentPosition = {}));
/**
 * Compare the position of one node against another node in any other document,
 * returning a bitmask with the values from {@link DocumentPosition}.
 *
 * Document order:
 * > There is an ordering, document order, defined on all the nodes in the
 * > document corresponding to the order in which the first character of the
 * > XML representation of each node occurs in the XML representation of the
 * > document after expansion of general entities. Thus, the document element
 * > node will be the first node. Element nodes occur before their children.
 * > Thus, document order orders element nodes in order of the occurrence of
 * > their start-tag in the XML (after expansion of entities). The attribute
 * > nodes of an element occur after the element and before its children. The
 * > relative order of attribute nodes is implementation-dependent.
 *
 * Source:
 * http://www.w3.org/TR/DOM-Level-3-Core/glossary.html#dt-document-order
 *
 * @category Helpers
 * @param nodeA The first node to use in the comparison
 * @param nodeB The second node to use in the comparison
 * @returns A bitmask describing the input nodes' relative position.
 *
 * See http://dom.spec.whatwg.org/#dom-node-comparedocumentposition for
 * a description of these values.
 */
function compareDocumentPosition(nodeA, nodeB) {
    var aParents = [];
    var bParents = [];
    if (nodeA === nodeB) {
        return 0;
    }
    var current = (0, domhandler_1.hasChildren)(nodeA) ? nodeA : nodeA.parent;
    while (current) {
        aParents.unshift(current);
        current = current.parent;
    }
    current = (0, domhandler_1.hasChildren)(nodeB) ? nodeB : nodeB.parent;
    while (current) {
        bParents.unshift(current);
        current = current.parent;
    }
    var maxIdx = Math.min(aParents.length, bParents.length);
    var idx = 0;
    while (idx < maxIdx && aParents[idx] === bParents[idx]) {
        idx++;
    }
    if (idx === 0) {
        return DocumentPosition.DISCONNECTED;
    }
    var sharedParent = aParents[idx - 1];
    var siblings = sharedParent.children;
    var aSibling = aParents[idx];
    var bSibling = bParents[idx];
    if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
        if (sharedParent === nodeB) {
            return DocumentPosition.FOLLOWING | DocumentPosition.CONTAINED_BY;
        }
        return DocumentPosition.FOLLOWING;
    }
    if (sharedParent === nodeA) {
        return DocumentPosition.PRECEDING | DocumentPosition.CONTAINS;
    }
    return DocumentPosition.PRECEDING;
}
/**
 * Sort an array of nodes based on their relative position in the document,
 * removing any duplicate nodes. If the array contains nodes that do not belong
 * to the same document, sort order is unspecified.
 *
 * @category Helpers
 * @param nodes Array of DOM nodes.
 * @returns Collection of unique nodes, sorted in document order.
 */
function uniqueSort(nodes) {
    nodes = nodes.filter(function (node, i, arr) { return !arr.includes(node, i + 1); });
    nodes.sort(function (a, b) {
        var relative = compareDocumentPosition(a, b);
        if (relative & DocumentPosition.PRECEDING) {
            return -1;
        }
        else if (relative & DocumentPosition.FOLLOWING) {
            return 1;
        }
        return 0;
    });
    return nodes;
}

var feeds = {};

Object.defineProperty(feeds, "__esModule", { value: true });
feeds.getFeed = getFeed;
var stringify_js_1 = stringify$5;
var legacy_js_1 = legacy;
/**
 * Get the feed object from the root of a DOM tree.
 *
 * @category Feeds
 * @param doc - The DOM to to extract the feed from.
 * @returns The feed.
 */
function getFeed(doc) {
    var feedRoot = getOneElement(isValidFeed, doc);
    return !feedRoot
        ? null
        : feedRoot.name === "feed"
            ? getAtomFeed(feedRoot)
            : getRssFeed(feedRoot);
}
/**
 * Parse an Atom feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */
function getAtomFeed(feedRoot) {
    var _a;
    var childs = feedRoot.children;
    var feed = {
        type: "atom",
        items: (0, legacy_js_1.getElementsByTagName)("entry", childs).map(function (item) {
            var _a;
            var children = item.children;
            var entry = { media: getMediaElements(children) };
            addConditionally(entry, "id", "id", children);
            addConditionally(entry, "title", "title", children);
            var href = (_a = getOneElement("link", children)) === null || _a === void 0 ? void 0 : _a.attribs["href"];
            if (href) {
                entry.link = href;
            }
            var description = fetch$1("summary", children) || fetch$1("content", children);
            if (description) {
                entry.description = description;
            }
            var pubDate = fetch$1("updated", children);
            if (pubDate) {
                entry.pubDate = new Date(pubDate);
            }
            return entry;
        }),
    };
    addConditionally(feed, "id", "id", childs);
    addConditionally(feed, "title", "title", childs);
    var href = (_a = getOneElement("link", childs)) === null || _a === void 0 ? void 0 : _a.attribs["href"];
    if (href) {
        feed.link = href;
    }
    addConditionally(feed, "description", "subtitle", childs);
    var updated = fetch$1("updated", childs);
    if (updated) {
        feed.updated = new Date(updated);
    }
    addConditionally(feed, "author", "email", childs, true);
    return feed;
}
/**
 * Parse a RSS feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */
function getRssFeed(feedRoot) {
    var _a, _b;
    var childs = (_b = (_a = getOneElement("channel", feedRoot.children)) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : [];
    var feed = {
        type: feedRoot.name.substr(0, 3),
        id: "",
        items: (0, legacy_js_1.getElementsByTagName)("item", feedRoot.children).map(function (item) {
            var children = item.children;
            var entry = { media: getMediaElements(children) };
            addConditionally(entry, "id", "guid", children);
            addConditionally(entry, "title", "title", children);
            addConditionally(entry, "link", "link", children);
            addConditionally(entry, "description", "description", children);
            var pubDate = fetch$1("pubDate", children) || fetch$1("dc:date", children);
            if (pubDate)
                entry.pubDate = new Date(pubDate);
            return entry;
        }),
    };
    addConditionally(feed, "title", "title", childs);
    addConditionally(feed, "link", "link", childs);
    addConditionally(feed, "description", "description", childs);
    var updated = fetch$1("lastBuildDate", childs);
    if (updated) {
        feed.updated = new Date(updated);
    }
    addConditionally(feed, "author", "managingEditor", childs, true);
    return feed;
}
var MEDIA_KEYS_STRING = ["url", "type", "lang"];
var MEDIA_KEYS_INT = [
    "fileSize",
    "bitrate",
    "framerate",
    "samplingrate",
    "channels",
    "duration",
    "height",
    "width",
];
/**
 * Get all media elements of a feed item.
 *
 * @param where Nodes to search in.
 * @returns Media elements.
 */
function getMediaElements(where) {
    return (0, legacy_js_1.getElementsByTagName)("media:content", where).map(function (elem) {
        var attribs = elem.attribs;
        var media = {
            medium: attribs["medium"],
            isDefault: !!attribs["isDefault"],
        };
        for (var _i = 0, MEDIA_KEYS_STRING_1 = MEDIA_KEYS_STRING; _i < MEDIA_KEYS_STRING_1.length; _i++) {
            var attrib = MEDIA_KEYS_STRING_1[_i];
            if (attribs[attrib]) {
                media[attrib] = attribs[attrib];
            }
        }
        for (var _a = 0, MEDIA_KEYS_INT_1 = MEDIA_KEYS_INT; _a < MEDIA_KEYS_INT_1.length; _a++) {
            var attrib = MEDIA_KEYS_INT_1[_a];
            if (attribs[attrib]) {
                media[attrib] = parseInt(attribs[attrib], 10);
            }
        }
        if (attribs["expression"]) {
            media.expression = attribs["expression"];
        }
        return media;
    });
}
/**
 * Get one element by tag name.
 *
 * @param tagName Tag name to look for
 * @param node Node to search in
 * @returns The element or null
 */
function getOneElement(tagName, node) {
    return (0, legacy_js_1.getElementsByTagName)(tagName, node, true, 1)[0];
}
/**
 * Get the text content of an element with a certain tag name.
 *
 * @param tagName Tag name to look for.
 * @param where Node to search in.
 * @param recurse Whether to recurse into child nodes.
 * @returns The text content of the element.
 */
function fetch$1(tagName, where, recurse) {
    if (recurse === void 0) { recurse = false; }
    return (0, stringify_js_1.textContent)((0, legacy_js_1.getElementsByTagName)(tagName, where, recurse, 1)).trim();
}
/**
 * Adds a property to an object if it has a value.
 *
 * @param obj Object to be extended
 * @param prop Property name
 * @param tagName Tag name that contains the conditionally added property
 * @param where Element to search for the property
 * @param recurse Whether to recurse into child nodes.
 */
function addConditionally(obj, prop, tagName, where, recurse) {
    if (recurse === void 0) { recurse = false; }
    var val = fetch$1(tagName, where, recurse);
    if (val)
        obj[prop] = val;
}
/**
 * Checks if an element is a feed root node.
 *
 * @param value The name of the element to check.
 * @returns Whether an element is a feed root node.
 */
function isValidFeed(value) {
    return value === "rss" || value === "feed" || value === "rdf:RDF";
}

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.hasChildren = exports.isDocument = exports.isComment = exports.isText = exports.isCDATA = exports.isTag = void 0;
	__exportStar(stringify$5, exports);
	__exportStar(traversal, exports);
	__exportStar(manipulation, exports);
	__exportStar(querying, exports);
	__exportStar(legacy, exports);
	__exportStar(helpers, exports);
	__exportStar(feeds, exports);
	/** @deprecated Use these methods from `domhandler` directly. */
	var domhandler_1 = lib$4;
	Object.defineProperty(exports, "isTag", { enumerable: true, get: function () { return domhandler_1.isTag; } });
	Object.defineProperty(exports, "isCDATA", { enumerable: true, get: function () { return domhandler_1.isCDATA; } });
	Object.defineProperty(exports, "isText", { enumerable: true, get: function () { return domhandler_1.isText; } });
	Object.defineProperty(exports, "isComment", { enumerable: true, get: function () { return domhandler_1.isComment; } });
	Object.defineProperty(exports, "isDocument", { enumerable: true, get: function () { return domhandler_1.isDocument; } });
	Object.defineProperty(exports, "hasChildren", { enumerable: true, get: function () { return domhandler_1.hasChildren; } });
	
} (lib$2));

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.DomUtils = exports.parseFeed = exports.getFeed = exports.ElementType = exports.Tokenizer = exports.createDomStream = exports.parseDOM = exports.parseDocument = exports.DefaultHandler = exports.DomHandler = exports.Parser = void 0;
	var Parser_js_1 = Parser$4;
	var Parser_js_2 = Parser$4;
	Object.defineProperty(exports, "Parser", { enumerable: true, get: function () { return Parser_js_2.Parser; } });
	var domhandler_1 = lib$4;
	var domhandler_2 = lib$4;
	Object.defineProperty(exports, "DomHandler", { enumerable: true, get: function () { return domhandler_2.DomHandler; } });
	// Old name for DomHandler
	Object.defineProperty(exports, "DefaultHandler", { enumerable: true, get: function () { return domhandler_2.DomHandler; } });
	// Helper methods
	/**
	 * Parses the data, returns the resulting document.
	 *
	 * @param data The data that should be parsed.
	 * @param options Optional options for the parser and DOM builder.
	 */
	function parseDocument(data, options) {
	    var handler = new domhandler_1.DomHandler(undefined, options);
	    new Parser_js_1.Parser(handler, options).end(data);
	    return handler.root;
	}
	exports.parseDocument = parseDocument;
	/**
	 * Parses data, returns an array of the root nodes.
	 *
	 * Note that the root nodes still have a `Document` node as their parent.
	 * Use `parseDocument` to get the `Document` node instead.
	 *
	 * @param data The data that should be parsed.
	 * @param options Optional options for the parser and DOM builder.
	 * @deprecated Use `parseDocument` instead.
	 */
	function parseDOM(data, options) {
	    return parseDocument(data, options).children;
	}
	exports.parseDOM = parseDOM;
	/**
	 * Creates a parser instance, with an attached DOM handler.
	 *
	 * @param callback A callback that will be called once parsing has been completed.
	 * @param options Optional options for the parser and DOM builder.
	 * @param elementCallback An optional callback that will be called every time a tag has been completed inside of the DOM.
	 */
	function createDomStream(callback, options, elementCallback) {
	    var handler = new domhandler_1.DomHandler(callback, options, elementCallback);
	    return new Parser_js_1.Parser(handler, options);
	}
	exports.createDomStream = createDomStream;
	var Tokenizer_js_1 = Tokenizer$1;
	Object.defineProperty(exports, "Tokenizer", { enumerable: true, get: function () { return __importDefault(Tokenizer_js_1).default; } });
	/*
	 * All of the following exports exist for backwards-compatibility.
	 * They should probably be removed eventually.
	 */
	exports.ElementType = __importStar(lib$3);
	var domutils_1 = lib$2;
	var domutils_2 = lib$2;
	Object.defineProperty(exports, "getFeed", { enumerable: true, get: function () { return domutils_2.getFeed; } });
	var parseFeedDefaultOptions = { xmlMode: true };
	/**
	 * Parse a feed.
	 *
	 * @param feed The feed that should be parsed, as a string.
	 * @param options Optionally, options for parsing. When using this, you should set `xmlMode` to `true`.
	 */
	function parseFeed(feed, options) {
	    if (options === void 0) { options = parseFeedDefaultOptions; }
	    return (0, domutils_1.getFeed)(parseDOM(feed, options));
	}
	exports.parseFeed = parseFeed;
	exports.DomUtils = __importStar(lib$2);
	
} (lib$5));

var escapeStringRegexp$1 = string => {
	if (typeof string !== 'string') {
		throw new TypeError('Expected a string');
	}

	// Escape characters with special meaning either inside or outside character sets.
	// Use a simple backslash escape when it’s always valid, and a \unnnn escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
	return string
		.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&')
		.replace(/-/g, '\\x2d');
};

var isPlainObject$2 = {};

Object.defineProperty(isPlainObject$2, '__esModule', { value: true });

/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */

function isObject(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}

function isPlainObject$1(o) {
  var ctor,prot;

  if (isObject(o) === false) return false;

  // If has modified constructor
  ctor = o.constructor;
  if (ctor === undefined) return true;

  // If has modified prototype
  prot = ctor.prototype;
  if (isObject(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
}

isPlainObject$2.isPlainObject = isPlainObject$1;

var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge$1(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function getMergeFunction(key, options) {
	if (!options.customMerge) {
		return deepmerge$1
	}
	var customMerge = options.customMerge(key);
	return typeof customMerge === 'function' ? customMerge : deepmerge$1
}

function getEnumerableOwnPropertySymbols(target) {
	return Object.getOwnPropertySymbols
		? Object.getOwnPropertySymbols(target).filter(function(symbol) {
			return Object.propertyIsEnumerable.call(target, symbol)
		})
		: []
}

function getKeys(target) {
	return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
}

function propertyIsOnObject(object, property) {
	try {
		return property in object
	} catch(_) {
		return false
	}
}

// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
	return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
		&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
			&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		getKeys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	getKeys(source).forEach(function(key) {
		if (propertyIsUnsafe(target, key)) {
			return
		}

		if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
		} else {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		}
	});
	return destination
}

function deepmerge$1(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
	// implementations can use it. The caller may not replace it.
	options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge$1.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge$1(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge$1;

var cjs = deepmerge_1;

var parseSrcset$1 = {exports: {}};

/**
 * Srcset Parser
 *
 * By Alex Bell |  MIT License
 *
 * JS Parser for the string value that appears in markup <img srcset="here">
 *
 * @returns Array [{url: _, d: _, w: _, h:_}, ...]
 *
 * Based super duper closely on the reference algorithm at:
 * https://html.spec.whatwg.org/multipage/embedded-content.html#parse-a-srcset-attribute
 *
 * Most comments are copied in directly from the spec
 * (except for comments in parens).
 */

(function (module) {
	(function (root, factory) {
		if (module.exports) {
			// Node. Does not work with strict CommonJS, but
			// only CommonJS-like environments that support module.exports,
			// like Node.
			module.exports = factory();
		} else {
			// Browser globals (root is window)
			root.parseSrcset = factory();
		}
	}(commonjsGlobal, function () {

		// 1. Let input be the value passed to this algorithm.
		return function (input) {

			// UTILITY FUNCTIONS

			// Manual is faster than RegEx
			// http://bjorn.tipling.com/state-and-regular-expressions-in-javascript
			// http://jsperf.com/whitespace-character/5
			function isSpace(c) {
				return (c === "\u0020" || // space
				c === "\u0009" || // horizontal tab
				c === "\u000A" || // new line
				c === "\u000C" || // form feed
				c === "\u000D");  // carriage return
			}

			function collectCharacters(regEx) {
				var chars,
					match = regEx.exec(input.substring(pos));
				if (match) {
					chars = match[ 0 ];
					pos += chars.length;
					return chars;
				}
			}

			var inputLength = input.length,

				// (Don't use \s, to avoid matching non-breaking space)
				regexLeadingSpaces = /^[ \t\n\r\u000c]+/,
				regexLeadingCommasOrSpaces = /^[, \t\n\r\u000c]+/,
				regexLeadingNotSpaces = /^[^ \t\n\r\u000c]+/,
				regexTrailingCommas = /[,]+$/,
				regexNonNegativeInteger = /^\d+$/,

				// ( Positive or negative or unsigned integers or decimals, without or without exponents.
				// Must include at least one digit.
				// According to spec tests any decimal point must be followed by a digit.
				// No leading plus sign is allowed.)
				// https://html.spec.whatwg.org/multipage/infrastructure.html#valid-floating-point-number
				regexFloatingPoint = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/,

				url,
				descriptors,
				currentDescriptor,
				state,
				c,

				// 2. Let position be a pointer into input, initially pointing at the start
				//    of the string.
				pos = 0,

				// 3. Let candidates be an initially empty source set.
				candidates = [];

			// 4. Splitting loop: Collect a sequence of characters that are space
			//    characters or U+002C COMMA characters. If any U+002C COMMA characters
			//    were collected, that is a parse error.
			while (true) {
				collectCharacters(regexLeadingCommasOrSpaces);

				// 5. If position is past the end of input, return candidates and abort these steps.
				if (pos >= inputLength) {
					return candidates; // (we're done, this is the sole return path)
				}

				// 6. Collect a sequence of characters that are not space characters,
				//    and let that be url.
				url = collectCharacters(regexLeadingNotSpaces);

				// 7. Let descriptors be a new empty list.
				descriptors = [];

				// 8. If url ends with a U+002C COMMA character (,), follow these substeps:
				//		(1). Remove all trailing U+002C COMMA characters from url. If this removed
				//         more than one character, that is a parse error.
				if (url.slice(-1) === ",") {
					url = url.replace(regexTrailingCommas, "");
					// (Jump ahead to step 9 to skip tokenization and just push the candidate).
					parseDescriptors();

					//	Otherwise, follow these substeps:
				} else {
					tokenize();
				} // (close else of step 8)

				// 16. Return to the step labeled splitting loop.
			} // (Close of big while loop.)

			/**
			 * Tokenizes descriptor properties prior to parsing
			 * Returns undefined.
			 */
			function tokenize() {

				// 8.1. Descriptor tokeniser: Skip whitespace
				collectCharacters(regexLeadingSpaces);

				// 8.2. Let current descriptor be the empty string.
				currentDescriptor = "";

				// 8.3. Let state be in descriptor.
				state = "in descriptor";

				while (true) {

					// 8.4. Let c be the character at position.
					c = input.charAt(pos);

					//  Do the following depending on the value of state.
					//  For the purpose of this step, "EOF" is a special character representing
					//  that position is past the end of input.

					// In descriptor
					if (state === "in descriptor") {
						// Do the following, depending on the value of c:

						// Space character
						// If current descriptor is not empty, append current descriptor to
						// descriptors and let current descriptor be the empty string.
						// Set state to after descriptor.
						if (isSpace(c)) {
							if (currentDescriptor) {
								descriptors.push(currentDescriptor);
								currentDescriptor = "";
								state = "after descriptor";
							}

							// U+002C COMMA (,)
							// Advance position to the next character in input. If current descriptor
							// is not empty, append current descriptor to descriptors. Jump to the step
							// labeled descriptor parser.
						} else if (c === ",") {
							pos += 1;
							if (currentDescriptor) {
								descriptors.push(currentDescriptor);
							}
							parseDescriptors();
							return;

							// U+0028 LEFT PARENTHESIS (()
							// Append c to current descriptor. Set state to in parens.
						} else if (c === "\u0028") {
							currentDescriptor = currentDescriptor + c;
							state = "in parens";

							// EOF
							// If current descriptor is not empty, append current descriptor to
							// descriptors. Jump to the step labeled descriptor parser.
						} else if (c === "") {
							if (currentDescriptor) {
								descriptors.push(currentDescriptor);
							}
							parseDescriptors();
							return;

							// Anything else
							// Append c to current descriptor.
						} else {
							currentDescriptor = currentDescriptor + c;
						}
						// (end "in descriptor"

						// In parens
					} else if (state === "in parens") {

						// U+0029 RIGHT PARENTHESIS ())
						// Append c to current descriptor. Set state to in descriptor.
						if (c === ")") {
							currentDescriptor = currentDescriptor + c;
							state = "in descriptor";

							// EOF
							// Append current descriptor to descriptors. Jump to the step labeled
							// descriptor parser.
						} else if (c === "") {
							descriptors.push(currentDescriptor);
							parseDescriptors();
							return;

							// Anything else
							// Append c to current descriptor.
						} else {
							currentDescriptor = currentDescriptor + c;
						}

						// After descriptor
					} else if (state === "after descriptor") {

						// Do the following, depending on the value of c:
						// Space character: Stay in this state.
						if (isSpace(c)) ; else if (c === "") {
							parseDescriptors();
							return;

							// Anything else
							// Set state to in descriptor. Set position to the previous character in input.
						} else {
							state = "in descriptor";
							pos -= 1;

						}
					}

					// Advance position to the next character in input.
					pos += 1;

					// Repeat this step.
				} // (close while true loop)
			}

			/**
			 * Adds descriptor properties to a candidate, pushes to the candidates array
			 * @return undefined
			 */
			// Declared outside of the while loop so that it's only created once.
			function parseDescriptors() {

				// 9. Descriptor parser: Let error be no.
				var pError = false,

					// 10. Let width be absent.
					// 11. Let density be absent.
					// 12. Let future-compat-h be absent. (We're implementing it now as h)
					w, d, h, i,
					candidate = {},
					desc, lastChar, value, intVal, floatVal;

				// 13. For each descriptor in descriptors, run the appropriate set of steps
				// from the following list:
				for (i = 0 ; i < descriptors.length; i++) {
					desc = descriptors[ i ];

					lastChar = desc[ desc.length - 1 ];
					value = desc.substring(0, desc.length - 1);
					intVal = parseInt(value, 10);
					floatVal = parseFloat(value);

					// If the descriptor consists of a valid non-negative integer followed by
					// a U+0077 LATIN SMALL LETTER W character
					if (regexNonNegativeInteger.test(value) && (lastChar === "w")) {

						// If width and density are not both absent, then let error be yes.
						if (w || d) {pError = true;}

						// Apply the rules for parsing non-negative integers to the descriptor.
						// If the result is zero, let error be yes.
						// Otherwise, let width be the result.
						if (intVal === 0) {pError = true;} else {w = intVal;}

						// If the descriptor consists of a valid floating-point number followed by
						// a U+0078 LATIN SMALL LETTER X character
					} else if (regexFloatingPoint.test(value) && (lastChar === "x")) {

						// If width, density and future-compat-h are not all absent, then let error
						// be yes.
						if (w || d || h) {pError = true;}

						// Apply the rules for parsing floating-point number values to the descriptor.
						// If the result is less than zero, let error be yes. Otherwise, let density
						// be the result.
						if (floatVal < 0) {pError = true;} else {d = floatVal;}

						// If the descriptor consists of a valid non-negative integer followed by
						// a U+0068 LATIN SMALL LETTER H character
					} else if (regexNonNegativeInteger.test(value) && (lastChar === "h")) {

						// If height and density are not both absent, then let error be yes.
						if (h || d) {pError = true;}

						// Apply the rules for parsing non-negative integers to the descriptor.
						// If the result is zero, let error be yes. Otherwise, let future-compat-h
						// be the result.
						if (intVal === 0) {pError = true;} else {h = intVal;}

						// Anything else, Let error be yes.
					} else {pError = true;}
				} // (close step 13 for loop)

				// 15. If error is still no, then append a new image source to candidates whose
				// URL is url, associated with a width width if not absent and a pixel
				// density density if not absent. Otherwise, there is a parse error.
				if (!pError) {
					candidate.url = url;
					if (w) { candidate.w = w;}
					if (d) { candidate.d = d;}
					if (h) { candidate.h = h;}
					candidates.push(candidate);
				} else if (console && console.log) {
					console.log("Invalid srcset descriptor found in '" +
						input + "' at '" + desc + "'.");
				}
			} // (close parseDescriptors fn)

		}
	})); 
} (parseSrcset$1));

var parseSrcsetExports = parseSrcset$1.exports;

var picocolors_browser = {exports: {}};

var x=String;
var create=function() {return {isColorSupported:false,reset:x,bold:x,dim:x,italic:x,underline:x,inverse:x,hidden:x,strikethrough:x,black:x,red:x,green:x,yellow:x,blue:x,magenta:x,cyan:x,white:x,gray:x,bgBlack:x,bgRed:x,bgGreen:x,bgYellow:x,bgBlue:x,bgMagenta:x,bgCyan:x,bgWhite:x,blackBright:x,redBright:x,greenBright:x,yellowBright:x,blueBright:x,magentaBright:x,cyanBright:x,whiteBright:x,bgBlackBright:x,bgRedBright:x,bgGreenBright:x,bgYellowBright:x,bgBlueBright:x,bgMagentaBright:x,bgCyanBright:x,bgWhiteBright:x}};
picocolors_browser.exports=create();
picocolors_browser.exports.createColors = create;

var picocolors_browserExports = picocolors_browser.exports;

var _nodeResolve_empty = {};

var _nodeResolve_empty$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: _nodeResolve_empty
});

var require$$2 = /*@__PURE__*/getAugmentedNamespace(_nodeResolve_empty$1);

let pico = picocolors_browserExports;

let terminalHighlight$1 = require$$2;

let CssSyntaxError$3 = class CssSyntaxError extends Error {
  constructor(message, line, column, source, file, plugin) {
    super(message);
    this.name = 'CssSyntaxError';
    this.reason = message;

    if (file) {
      this.file = file;
    }
    if (source) {
      this.source = source;
    }
    if (plugin) {
      this.plugin = plugin;
    }
    if (typeof line !== 'undefined' && typeof column !== 'undefined') {
      if (typeof line === 'number') {
        this.line = line;
        this.column = column;
      } else {
        this.line = line.line;
        this.column = line.column;
        this.endLine = column.line;
        this.endColumn = column.column;
      }
    }

    this.setMessage();

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, CssSyntaxError);
    }
  }

  setMessage() {
    this.message = this.plugin ? this.plugin + ': ' : '';
    this.message += this.file ? this.file : '<css input>';
    if (typeof this.line !== 'undefined') {
      this.message += ':' + this.line + ':' + this.column;
    }
    this.message += ': ' + this.reason;
  }

  showSourceCode(color) {
    if (!this.source) return ''

    let css = this.source;
    if (color == null) color = pico.isColorSupported;

    let aside = text => text;
    let mark = text => text;
    let highlight = text => text;
    if (color) {
      let { bold, gray, red } = pico.createColors(true);
      mark = text => bold(red(text));
      aside = text => gray(text);
      if (terminalHighlight$1) {
        highlight = text => terminalHighlight$1(text);
      }
    }

    let lines = css.split(/\r?\n/);
    let start = Math.max(this.line - 3, 0);
    let end = Math.min(this.line + 2, lines.length);
    let maxWidth = String(end).length;

    return lines
      .slice(start, end)
      .map((line, index) => {
        let number = start + 1 + index;
        let gutter = ' ' + (' ' + number).slice(-maxWidth) + ' | ';
        if (number === this.line) {
          if (line.length > 160) {
            let padding = 20;
            let subLineStart = Math.max(0, this.column - padding);
            let subLineEnd = Math.max(
              this.column + padding,
              this.endColumn + padding
            );
            let subLine = line.slice(subLineStart, subLineEnd);

            let spacing =
              aside(gutter.replace(/\d/g, ' ')) +
              line
                .slice(0, Math.min(this.column - 1, padding - 1))
                .replace(/[^\t]/g, ' ');

            return (
              mark('>') +
              aside(gutter) +
              highlight(subLine) +
              '\n ' +
              spacing +
              mark('^')
            )
          }

          let spacing =
            aside(gutter.replace(/\d/g, ' ')) +
            line.slice(0, this.column - 1).replace(/[^\t]/g, ' ');

          return (
            mark('>') +
            aside(gutter) +
            highlight(line) +
            '\n ' +
            spacing +
            mark('^')
          )
        }

        return ' ' + aside(gutter) + highlight(line)
      })
      .join('\n')
  }

  toString() {
    let code = this.showSourceCode();
    if (code) {
      code = '\n\n' + code + '\n';
    }
    return this.name + ': ' + this.message + code
  }
};

var cssSyntaxError = CssSyntaxError$3;
CssSyntaxError$3.default = CssSyntaxError$3;

const DEFAULT_RAW = {
  after: '\n',
  beforeClose: '\n',
  beforeComment: '\n',
  beforeDecl: '\n',
  beforeOpen: ' ',
  beforeRule: '\n',
  colon: ': ',
  commentLeft: ' ',
  commentRight: ' ',
  emptyBody: '',
  indent: '    ',
  semicolon: false
};

function capitalize(str) {
  return str[0].toUpperCase() + str.slice(1)
}

let Stringifier$2 = class Stringifier {
  constructor(builder) {
    this.builder = builder;
  }

  atrule(node, semicolon) {
    let name = '@' + node.name;
    let params = node.params ? this.rawValue(node, 'params') : '';

    if (typeof node.raws.afterName !== 'undefined') {
      name += node.raws.afterName;
    } else if (params) {
      name += ' ';
    }

    if (node.nodes) {
      this.block(node, name + params);
    } else {
      let end = (node.raws.between || '') + (semicolon ? ';' : '');
      this.builder(name + params + end, node);
    }
  }

  beforeAfter(node, detect) {
    let value;
    if (node.type === 'decl') {
      value = this.raw(node, null, 'beforeDecl');
    } else if (node.type === 'comment') {
      value = this.raw(node, null, 'beforeComment');
    } else if (detect === 'before') {
      value = this.raw(node, null, 'beforeRule');
    } else {
      value = this.raw(node, null, 'beforeClose');
    }

    let buf = node.parent;
    let depth = 0;
    while (buf && buf.type !== 'root') {
      depth += 1;
      buf = buf.parent;
    }

    if (value.includes('\n')) {
      let indent = this.raw(node, null, 'indent');
      if (indent.length) {
        for (let step = 0; step < depth; step++) value += indent;
      }
    }

    return value
  }

  block(node, start) {
    let between = this.raw(node, 'between', 'beforeOpen');
    this.builder(start + between + '{', node, 'start');

    let after;
    if (node.nodes && node.nodes.length) {
      this.body(node);
      after = this.raw(node, 'after');
    } else {
      after = this.raw(node, 'after', 'emptyBody');
    }

    if (after) this.builder(after);
    this.builder('}', node, 'end');
  }

  body(node) {
    let last = node.nodes.length - 1;
    while (last > 0) {
      if (node.nodes[last].type !== 'comment') break
      last -= 1;
    }

    let semicolon = this.raw(node, 'semicolon');
    for (let i = 0; i < node.nodes.length; i++) {
      let child = node.nodes[i];
      let before = this.raw(child, 'before');
      if (before) this.builder(before);
      this.stringify(child, last !== i || semicolon);
    }
  }

  comment(node) {
    let left = this.raw(node, 'left', 'commentLeft');
    let right = this.raw(node, 'right', 'commentRight');
    this.builder('/*' + left + node.text + right + '*/', node);
  }

  decl(node, semicolon) {
    let between = this.raw(node, 'between', 'colon');
    let string = node.prop + between + this.rawValue(node, 'value');

    if (node.important) {
      string += node.raws.important || ' !important';
    }

    if (semicolon) string += ';';
    this.builder(string, node);
  }

  document(node) {
    this.body(node);
  }

  raw(node, own, detect) {
    let value;
    if (!detect) detect = own;

    // Already had
    if (own) {
      value = node.raws[own];
      if (typeof value !== 'undefined') return value
    }

    let parent = node.parent;

    if (detect === 'before') {
      // Hack for first rule in CSS
      if (!parent || (parent.type === 'root' && parent.first === node)) {
        return ''
      }

      // `root` nodes in `document` should use only their own raws
      if (parent && parent.type === 'document') {
        return ''
      }
    }

    // Floating child without parent
    if (!parent) return DEFAULT_RAW[detect]

    // Detect style by other nodes
    let root = node.root();
    if (!root.rawCache) root.rawCache = {};
    if (typeof root.rawCache[detect] !== 'undefined') {
      return root.rawCache[detect]
    }

    if (detect === 'before' || detect === 'after') {
      return this.beforeAfter(node, detect)
    } else {
      let method = 'raw' + capitalize(detect);
      if (this[method]) {
        value = this[method](root, node);
      } else {
        root.walk(i => {
          value = i.raws[own];
          if (typeof value !== 'undefined') return false
        });
      }
    }

    if (typeof value === 'undefined') value = DEFAULT_RAW[detect];

    root.rawCache[detect] = value;
    return value
  }

  rawBeforeClose(root) {
    let value;
    root.walk(i => {
      if (i.nodes && i.nodes.length > 0) {
        if (typeof i.raws.after !== 'undefined') {
          value = i.raws.after;
          if (value.includes('\n')) {
            value = value.replace(/[^\n]+$/, '');
          }
          return false
        }
      }
    });
    if (value) value = value.replace(/\S/g, '');
    return value
  }

  rawBeforeComment(root, node) {
    let value;
    root.walkComments(i => {
      if (typeof i.raws.before !== 'undefined') {
        value = i.raws.before;
        if (value.includes('\n')) {
          value = value.replace(/[^\n]+$/, '');
        }
        return false
      }
    });
    if (typeof value === 'undefined') {
      value = this.raw(node, null, 'beforeDecl');
    } else if (value) {
      value = value.replace(/\S/g, '');
    }
    return value
  }

  rawBeforeDecl(root, node) {
    let value;
    root.walkDecls(i => {
      if (typeof i.raws.before !== 'undefined') {
        value = i.raws.before;
        if (value.includes('\n')) {
          value = value.replace(/[^\n]+$/, '');
        }
        return false
      }
    });
    if (typeof value === 'undefined') {
      value = this.raw(node, null, 'beforeRule');
    } else if (value) {
      value = value.replace(/\S/g, '');
    }
    return value
  }

  rawBeforeOpen(root) {
    let value;
    root.walk(i => {
      if (i.type !== 'decl') {
        value = i.raws.between;
        if (typeof value !== 'undefined') return false
      }
    });
    return value
  }

  rawBeforeRule(root) {
    let value;
    root.walk(i => {
      if (i.nodes && (i.parent !== root || root.first !== i)) {
        if (typeof i.raws.before !== 'undefined') {
          value = i.raws.before;
          if (value.includes('\n')) {
            value = value.replace(/[^\n]+$/, '');
          }
          return false
        }
      }
    });
    if (value) value = value.replace(/\S/g, '');
    return value
  }

  rawColon(root) {
    let value;
    root.walkDecls(i => {
      if (typeof i.raws.between !== 'undefined') {
        value = i.raws.between.replace(/[^\s:]/g, '');
        return false
      }
    });
    return value
  }

  rawEmptyBody(root) {
    let value;
    root.walk(i => {
      if (i.nodes && i.nodes.length === 0) {
        value = i.raws.after;
        if (typeof value !== 'undefined') return false
      }
    });
    return value
  }

  rawIndent(root) {
    if (root.raws.indent) return root.raws.indent
    let value;
    root.walk(i => {
      let p = i.parent;
      if (p && p !== root && p.parent && p.parent === root) {
        if (typeof i.raws.before !== 'undefined') {
          let parts = i.raws.before.split('\n');
          value = parts[parts.length - 1];
          value = value.replace(/\S/g, '');
          return false
        }
      }
    });
    return value
  }

  rawSemicolon(root) {
    let value;
    root.walk(i => {
      if (i.nodes && i.nodes.length && i.last.type === 'decl') {
        value = i.raws.semicolon;
        if (typeof value !== 'undefined') return false
      }
    });
    return value
  }

  rawValue(node, prop) {
    let value = node[prop];
    let raw = node.raws[prop];
    if (raw && raw.value === value) {
      return raw.raw
    }

    return value
  }

  root(node) {
    this.body(node);
    if (node.raws.after) this.builder(node.raws.after);
  }

  rule(node) {
    this.block(node, this.rawValue(node, 'selector'));
    if (node.raws.ownSemicolon) {
      this.builder(node.raws.ownSemicolon, node, 'end');
    }
  }

  stringify(node, semicolon) {
    /* c8 ignore start */
    if (!this[node.type]) {
      throw new Error(
        'Unknown AST node type ' +
          node.type +
          '. ' +
          'Maybe you need to change PostCSS stringifier.'
      )
    }
    /* c8 ignore stop */
    this[node.type](node, semicolon);
  }
};

var stringifier = Stringifier$2;
Stringifier$2.default = Stringifier$2;

let Stringifier$1 = stringifier;

function stringify$4(node, builder) {
  let str = new Stringifier$1(builder);
  str.stringify(node);
}

var stringify_1 = stringify$4;
stringify$4.default = stringify$4;

var symbols = {};

symbols.isClean = Symbol('isClean');

symbols.my = Symbol('my');

let CssSyntaxError$2 = cssSyntaxError;
let Stringifier = stringifier;
let stringify$3 = stringify_1;
let { isClean: isClean$2, my: my$2 } = symbols;

function cloneNode(obj, parent) {
  let cloned = new obj.constructor();

  for (let i in obj) {
    if (!Object.prototype.hasOwnProperty.call(obj, i)) {
      /* c8 ignore next 2 */
      continue
    }
    if (i === 'proxyCache') continue
    let value = obj[i];
    let type = typeof value;

    if (i === 'parent' && type === 'object') {
      if (parent) cloned[i] = parent;
    } else if (i === 'source') {
      cloned[i] = value;
    } else if (Array.isArray(value)) {
      cloned[i] = value.map(j => cloneNode(j, cloned));
    } else {
      if (type === 'object' && value !== null) value = cloneNode(value);
      cloned[i] = value;
    }
  }

  return cloned
}

function sourceOffset(inputCSS, position) {
  // Not all custom syntaxes support `offset` in `source.start` and `source.end`
  if (position && typeof position.offset !== 'undefined') {
    return position.offset
  }

  let column = 1;
  let line = 1;
  let offset = 0;

  for (let i = 0; i < inputCSS.length; i++) {
    if (line === position.line && column === position.column) {
      offset = i;
      break
    }

    if (inputCSS[i] === '\n') {
      column = 1;
      line += 1;
    } else {
      column += 1;
    }
  }

  return offset
}

let Node$4 = class Node {
  get proxyOf() {
    return this
  }

  constructor(defaults = {}) {
    this.raws = {};
    this[isClean$2] = false;
    this[my$2] = true;

    for (let name in defaults) {
      if (name === 'nodes') {
        this.nodes = [];
        for (let node of defaults[name]) {
          if (typeof node.clone === 'function') {
            this.append(node.clone());
          } else {
            this.append(node);
          }
        }
      } else {
        this[name] = defaults[name];
      }
    }
  }

  addToError(error) {
    error.postcssNode = this;
    if (error.stack && this.source && /\n\s{4}at /.test(error.stack)) {
      let s = this.source;
      error.stack = error.stack.replace(
        /\n\s{4}at /,
        `$&${s.input.from}:${s.start.line}:${s.start.column}$&`
      );
    }
    return error
  }

  after(add) {
    this.parent.insertAfter(this, add);
    return this
  }

  assign(overrides = {}) {
    for (let name in overrides) {
      this[name] = overrides[name];
    }
    return this
  }

  before(add) {
    this.parent.insertBefore(this, add);
    return this
  }

  cleanRaws(keepBetween) {
    delete this.raws.before;
    delete this.raws.after;
    if (!keepBetween) delete this.raws.between;
  }

  clone(overrides = {}) {
    let cloned = cloneNode(this);
    for (let name in overrides) {
      cloned[name] = overrides[name];
    }
    return cloned
  }

  cloneAfter(overrides = {}) {
    let cloned = this.clone(overrides);
    this.parent.insertAfter(this, cloned);
    return cloned
  }

  cloneBefore(overrides = {}) {
    let cloned = this.clone(overrides);
    this.parent.insertBefore(this, cloned);
    return cloned
  }

  error(message, opts = {}) {
    if (this.source) {
      let { end, start } = this.rangeBy(opts);
      return this.source.input.error(
        message,
        { column: start.column, line: start.line },
        { column: end.column, line: end.line },
        opts
      )
    }
    return new CssSyntaxError$2(message)
  }

  getProxyProcessor() {
    return {
      get(node, prop) {
        if (prop === 'proxyOf') {
          return node
        } else if (prop === 'root') {
          return () => node.root().toProxy()
        } else {
          return node[prop]
        }
      },

      set(node, prop, value) {
        if (node[prop] === value) return true
        node[prop] = value;
        if (
          prop === 'prop' ||
          prop === 'value' ||
          prop === 'name' ||
          prop === 'params' ||
          prop === 'important' ||
          /* c8 ignore next */
          prop === 'text'
        ) {
          node.markDirty();
        }
        return true
      }
    }
  }

  /* c8 ignore next 3 */
  markClean() {
    this[isClean$2] = true;
  }

  markDirty() {
    if (this[isClean$2]) {
      this[isClean$2] = false;
      let next = this;
      while ((next = next.parent)) {
        next[isClean$2] = false;
      }
    }
  }

  next() {
    if (!this.parent) return undefined
    let index = this.parent.index(this);
    return this.parent.nodes[index + 1]
  }

  positionBy(opts = {}) {
    let pos = this.source.start;
    if (opts.index) {
      pos = this.positionInside(opts.index);
    } else if (opts.word) {
      let inputString =
        'document' in this.source.input
          ? this.source.input.document
          : this.source.input.css;
      let stringRepresentation = inputString.slice(
        sourceOffset(inputString, this.source.start),
        sourceOffset(inputString, this.source.end)
      );
      let index = stringRepresentation.indexOf(opts.word);
      if (index !== -1) pos = this.positionInside(index);
    }
    return pos
  }

  positionInside(index) {
    let column = this.source.start.column;
    let line = this.source.start.line;
    let inputString =
      'document' in this.source.input
        ? this.source.input.document
        : this.source.input.css;
    let offset = sourceOffset(inputString, this.source.start);
    let end = offset + index;

    for (let i = offset; i < end; i++) {
      if (inputString[i] === '\n') {
        column = 1;
        line += 1;
      } else {
        column += 1;
      }
    }

    return { column, line, offset: end }
  }

  prev() {
    if (!this.parent) return undefined
    let index = this.parent.index(this);
    return this.parent.nodes[index - 1]
  }

  rangeBy(opts = {}) {
    let inputString =
      'document' in this.source.input
        ? this.source.input.document
        : this.source.input.css;
    let start = {
      column: this.source.start.column,
      line: this.source.start.line,
      offset: sourceOffset(inputString, this.source.start)
    };
    let end = this.source.end
      ? {
          column: this.source.end.column + 1,
          line: this.source.end.line,
          offset:
            typeof this.source.end.offset === 'number'
              ? // `source.end.offset` is exclusive, so we don't need to add 1
                this.source.end.offset
              : // Since line/column in this.source.end is inclusive,
                // the `sourceOffset(... , this.source.end)` returns an inclusive offset.
                // So, we add 1 to convert it to exclusive.
                sourceOffset(inputString, this.source.end) + 1
        }
      : {
          column: start.column + 1,
          line: start.line,
          offset: start.offset + 1
        };

    if (opts.word) {
      let stringRepresentation = inputString.slice(
        sourceOffset(inputString, this.source.start),
        sourceOffset(inputString, this.source.end)
      );
      let index = stringRepresentation.indexOf(opts.word);
      if (index !== -1) {
        start = this.positionInside(index);
        end = this.positionInside(index + opts.word.length);
      }
    } else {
      if (opts.start) {
        start = {
          column: opts.start.column,
          line: opts.start.line,
          offset: sourceOffset(inputString, opts.start)
        };
      } else if (opts.index) {
        start = this.positionInside(opts.index);
      }

      if (opts.end) {
        end = {
          column: opts.end.column,
          line: opts.end.line,
          offset: sourceOffset(inputString, opts.end)
        };
      } else if (typeof opts.endIndex === 'number') {
        end = this.positionInside(opts.endIndex);
      } else if (opts.index) {
        end = this.positionInside(opts.index + 1);
      }
    }

    if (
      end.line < start.line ||
      (end.line === start.line && end.column <= start.column)
    ) {
      end = {
        column: start.column + 1,
        line: start.line,
        offset: start.offset + 1
      };
    }

    return { end, start }
  }

  raw(prop, defaultType) {
    let str = new Stringifier();
    return str.raw(this, prop, defaultType)
  }

  remove() {
    if (this.parent) {
      this.parent.removeChild(this);
    }
    this.parent = undefined;
    return this
  }

  replaceWith(...nodes) {
    if (this.parent) {
      let bookmark = this;
      let foundSelf = false;
      for (let node of nodes) {
        if (node === this) {
          foundSelf = true;
        } else if (foundSelf) {
          this.parent.insertAfter(bookmark, node);
          bookmark = node;
        } else {
          this.parent.insertBefore(bookmark, node);
        }
      }

      if (!foundSelf) {
        this.remove();
      }
    }

    return this
  }

  root() {
    let result = this;
    while (result.parent && result.parent.type !== 'document') {
      result = result.parent;
    }
    return result
  }

  toJSON(_, inputs) {
    let fixed = {};
    let emitInputs = inputs == null;
    inputs = inputs || new Map();
    let inputsNextIndex = 0;

    for (let name in this) {
      if (!Object.prototype.hasOwnProperty.call(this, name)) {
        /* c8 ignore next 2 */
        continue
      }
      if (name === 'parent' || name === 'proxyCache') continue
      let value = this[name];

      if (Array.isArray(value)) {
        fixed[name] = value.map(i => {
          if (typeof i === 'object' && i.toJSON) {
            return i.toJSON(null, inputs)
          } else {
            return i
          }
        });
      } else if (typeof value === 'object' && value.toJSON) {
        fixed[name] = value.toJSON(null, inputs);
      } else if (name === 'source') {
        if (value == null) continue
        let inputId = inputs.get(value.input);
        if (inputId == null) {
          inputId = inputsNextIndex;
          inputs.set(value.input, inputsNextIndex);
          inputsNextIndex++;
        }
        fixed[name] = {
          end: value.end,
          inputId,
          start: value.start
        };
      } else {
        fixed[name] = value;
      }
    }

    if (emitInputs) {
      fixed.inputs = [...inputs.keys()].map(input => input.toJSON());
    }

    return fixed
  }

  toProxy() {
    if (!this.proxyCache) {
      this.proxyCache = new Proxy(this, this.getProxyProcessor());
    }
    return this.proxyCache
  }

  toString(stringifier = stringify$3) {
    if (stringifier.stringify) stringifier = stringifier.stringify;
    let result = '';
    stringifier(this, i => {
      result += i;
    });
    return result
  }

  warn(result, text, opts = {}) {
    let data = { node: this };
    for (let i in opts) data[i] = opts[i];
    return result.warn(text, data)
  }
};

var node = Node$4;
Node$4.default = Node$4;

let Node$3 = node;

let Comment$4 = class Comment extends Node$3 {
  constructor(defaults) {
    super(defaults);
    this.type = 'comment';
  }
};

var comment = Comment$4;
Comment$4.default = Comment$4;

let Node$2 = node;

let Declaration$4 = class Declaration extends Node$2 {
  get variable() {
    return this.prop.startsWith('--') || this.prop[0] === '$'
  }

  constructor(defaults) {
    if (
      defaults &&
      typeof defaults.value !== 'undefined' &&
      typeof defaults.value !== 'string'
    ) {
      defaults = { ...defaults, value: String(defaults.value) };
    }
    super(defaults);
    this.type = 'decl';
  }
};

var declaration = Declaration$4;
Declaration$4.default = Declaration$4;

let Comment$3 = comment;
let Declaration$3 = declaration;
let Node$1 = node;
let { isClean: isClean$1, my: my$1 } = symbols;

let AtRule$4, parse$4, Root$6, Rule$4;

function cleanSource(nodes) {
  return nodes.map(i => {
    if (i.nodes) i.nodes = cleanSource(i.nodes);
    delete i.source;
    return i
  })
}

function markTreeDirty(node) {
  node[isClean$1] = false;
  if (node.proxyOf.nodes) {
    for (let i of node.proxyOf.nodes) {
      markTreeDirty(i);
    }
  }
}

let Container$7 = class Container extends Node$1 {
  get first() {
    if (!this.proxyOf.nodes) return undefined
    return this.proxyOf.nodes[0]
  }

  get last() {
    if (!this.proxyOf.nodes) return undefined
    return this.proxyOf.nodes[this.proxyOf.nodes.length - 1]
  }

  append(...children) {
    for (let child of children) {
      let nodes = this.normalize(child, this.last);
      for (let node of nodes) this.proxyOf.nodes.push(node);
    }

    this.markDirty();

    return this
  }

  cleanRaws(keepBetween) {
    super.cleanRaws(keepBetween);
    if (this.nodes) {
      for (let node of this.nodes) node.cleanRaws(keepBetween);
    }
  }

  each(callback) {
    if (!this.proxyOf.nodes) return undefined
    let iterator = this.getIterator();

    let index, result;
    while (this.indexes[iterator] < this.proxyOf.nodes.length) {
      index = this.indexes[iterator];
      result = callback(this.proxyOf.nodes[index], index);
      if (result === false) break

      this.indexes[iterator] += 1;
    }

    delete this.indexes[iterator];
    return result
  }

  every(condition) {
    return this.nodes.every(condition)
  }

  getIterator() {
    if (!this.lastEach) this.lastEach = 0;
    if (!this.indexes) this.indexes = {};

    this.lastEach += 1;
    let iterator = this.lastEach;
    this.indexes[iterator] = 0;

    return iterator
  }

  getProxyProcessor() {
    return {
      get(node, prop) {
        if (prop === 'proxyOf') {
          return node
        } else if (!node[prop]) {
          return node[prop]
        } else if (
          prop === 'each' ||
          (typeof prop === 'string' && prop.startsWith('walk'))
        ) {
          return (...args) => {
            return node[prop](
              ...args.map(i => {
                if (typeof i === 'function') {
                  return (child, index) => i(child.toProxy(), index)
                } else {
                  return i
                }
              })
            )
          }
        } else if (prop === 'every' || prop === 'some') {
          return cb => {
            return node[prop]((child, ...other) =>
              cb(child.toProxy(), ...other)
            )
          }
        } else if (prop === 'root') {
          return () => node.root().toProxy()
        } else if (prop === 'nodes') {
          return node.nodes.map(i => i.toProxy())
        } else if (prop === 'first' || prop === 'last') {
          return node[prop].toProxy()
        } else {
          return node[prop]
        }
      },

      set(node, prop, value) {
        if (node[prop] === value) return true
        node[prop] = value;
        if (prop === 'name' || prop === 'params' || prop === 'selector') {
          node.markDirty();
        }
        return true
      }
    }
  }

  index(child) {
    if (typeof child === 'number') return child
    if (child.proxyOf) child = child.proxyOf;
    return this.proxyOf.nodes.indexOf(child)
  }

  insertAfter(exist, add) {
    let existIndex = this.index(exist);
    let nodes = this.normalize(add, this.proxyOf.nodes[existIndex]).reverse();
    existIndex = this.index(exist);
    for (let node of nodes) this.proxyOf.nodes.splice(existIndex + 1, 0, node);

    let index;
    for (let id in this.indexes) {
      index = this.indexes[id];
      if (existIndex < index) {
        this.indexes[id] = index + nodes.length;
      }
    }

    this.markDirty();

    return this
  }

  insertBefore(exist, add) {
    let existIndex = this.index(exist);
    let type = existIndex === 0 ? 'prepend' : false;
    let nodes = this.normalize(
      add,
      this.proxyOf.nodes[existIndex],
      type
    ).reverse();
    existIndex = this.index(exist);
    for (let node of nodes) this.proxyOf.nodes.splice(existIndex, 0, node);

    let index;
    for (let id in this.indexes) {
      index = this.indexes[id];
      if (existIndex <= index) {
        this.indexes[id] = index + nodes.length;
      }
    }

    this.markDirty();

    return this
  }

  normalize(nodes, sample) {
    if (typeof nodes === 'string') {
      nodes = cleanSource(parse$4(nodes).nodes);
    } else if (typeof nodes === 'undefined') {
      nodes = [];
    } else if (Array.isArray(nodes)) {
      nodes = nodes.slice(0);
      for (let i of nodes) {
        if (i.parent) i.parent.removeChild(i, 'ignore');
      }
    } else if (nodes.type === 'root' && this.type !== 'document') {
      nodes = nodes.nodes.slice(0);
      for (let i of nodes) {
        if (i.parent) i.parent.removeChild(i, 'ignore');
      }
    } else if (nodes.type) {
      nodes = [nodes];
    } else if (nodes.prop) {
      if (typeof nodes.value === 'undefined') {
        throw new Error('Value field is missed in node creation')
      } else if (typeof nodes.value !== 'string') {
        nodes.value = String(nodes.value);
      }
      nodes = [new Declaration$3(nodes)];
    } else if (nodes.selector || nodes.selectors) {
      nodes = [new Rule$4(nodes)];
    } else if (nodes.name) {
      nodes = [new AtRule$4(nodes)];
    } else if (nodes.text) {
      nodes = [new Comment$3(nodes)];
    } else {
      throw new Error('Unknown node type in node creation')
    }

    let processed = nodes.map(i => {
      /* c8 ignore next */
      if (!i[my$1]) Container.rebuild(i);
      i = i.proxyOf;
      if (i.parent) i.parent.removeChild(i);
      if (i[isClean$1]) markTreeDirty(i);

      if (!i.raws) i.raws = {};
      if (typeof i.raws.before === 'undefined') {
        if (sample && typeof sample.raws.before !== 'undefined') {
          i.raws.before = sample.raws.before.replace(/\S/g, '');
        }
      }
      i.parent = this.proxyOf;
      return i
    });

    return processed
  }

  prepend(...children) {
    children = children.reverse();
    for (let child of children) {
      let nodes = this.normalize(child, this.first, 'prepend').reverse();
      for (let node of nodes) this.proxyOf.nodes.unshift(node);
      for (let id in this.indexes) {
        this.indexes[id] = this.indexes[id] + nodes.length;
      }
    }

    this.markDirty();

    return this
  }

  push(child) {
    child.parent = this;
    this.proxyOf.nodes.push(child);
    return this
  }

  removeAll() {
    for (let node of this.proxyOf.nodes) node.parent = undefined;
    this.proxyOf.nodes = [];

    this.markDirty();

    return this
  }

  removeChild(child) {
    child = this.index(child);
    this.proxyOf.nodes[child].parent = undefined;
    this.proxyOf.nodes.splice(child, 1);

    let index;
    for (let id in this.indexes) {
      index = this.indexes[id];
      if (index >= child) {
        this.indexes[id] = index - 1;
      }
    }

    this.markDirty();

    return this
  }

  replaceValues(pattern, opts, callback) {
    if (!callback) {
      callback = opts;
      opts = {};
    }

    this.walkDecls(decl => {
      if (opts.props && !opts.props.includes(decl.prop)) return
      if (opts.fast && !decl.value.includes(opts.fast)) return

      decl.value = decl.value.replace(pattern, callback);
    });

    this.markDirty();

    return this
  }

  some(condition) {
    return this.nodes.some(condition)
  }

  walk(callback) {
    return this.each((child, i) => {
      let result;
      try {
        result = callback(child, i);
      } catch (e) {
        throw child.addToError(e)
      }
      if (result !== false && child.walk) {
        result = child.walk(callback);
      }

      return result
    })
  }

  walkAtRules(name, callback) {
    if (!callback) {
      callback = name;
      return this.walk((child, i) => {
        if (child.type === 'atrule') {
          return callback(child, i)
        }
      })
    }
    if (name instanceof RegExp) {
      return this.walk((child, i) => {
        if (child.type === 'atrule' && name.test(child.name)) {
          return callback(child, i)
        }
      })
    }
    return this.walk((child, i) => {
      if (child.type === 'atrule' && child.name === name) {
        return callback(child, i)
      }
    })
  }

  walkComments(callback) {
    return this.walk((child, i) => {
      if (child.type === 'comment') {
        return callback(child, i)
      }
    })
  }

  walkDecls(prop, callback) {
    if (!callback) {
      callback = prop;
      return this.walk((child, i) => {
        if (child.type === 'decl') {
          return callback(child, i)
        }
      })
    }
    if (prop instanceof RegExp) {
      return this.walk((child, i) => {
        if (child.type === 'decl' && prop.test(child.prop)) {
          return callback(child, i)
        }
      })
    }
    return this.walk((child, i) => {
      if (child.type === 'decl' && child.prop === prop) {
        return callback(child, i)
      }
    })
  }

  walkRules(selector, callback) {
    if (!callback) {
      callback = selector;

      return this.walk((child, i) => {
        if (child.type === 'rule') {
          return callback(child, i)
        }
      })
    }
    if (selector instanceof RegExp) {
      return this.walk((child, i) => {
        if (child.type === 'rule' && selector.test(child.selector)) {
          return callback(child, i)
        }
      })
    }
    return this.walk((child, i) => {
      if (child.type === 'rule' && child.selector === selector) {
        return callback(child, i)
      }
    })
  }
};

Container$7.registerParse = dependant => {
  parse$4 = dependant;
};

Container$7.registerRule = dependant => {
  Rule$4 = dependant;
};

Container$7.registerAtRule = dependant => {
  AtRule$4 = dependant;
};

Container$7.registerRoot = dependant => {
  Root$6 = dependant;
};

var container = Container$7;
Container$7.default = Container$7;

/* c8 ignore start */
Container$7.rebuild = node => {
  if (node.type === 'atrule') {
    Object.setPrototypeOf(node, AtRule$4.prototype);
  } else if (node.type === 'rule') {
    Object.setPrototypeOf(node, Rule$4.prototype);
  } else if (node.type === 'decl') {
    Object.setPrototypeOf(node, Declaration$3.prototype);
  } else if (node.type === 'comment') {
    Object.setPrototypeOf(node, Comment$3.prototype);
  } else if (node.type === 'root') {
    Object.setPrototypeOf(node, Root$6.prototype);
  }

  node[my$1] = true;

  if (node.nodes) {
    node.nodes.forEach(child => {
      Container$7.rebuild(child);
    });
  }
};

let Container$6 = container;

let AtRule$3 = class AtRule extends Container$6 {
  constructor(defaults) {
    super(defaults);
    this.type = 'atrule';
  }

  append(...children) {
    if (!this.proxyOf.nodes) this.nodes = [];
    return super.append(...children)
  }

  prepend(...children) {
    if (!this.proxyOf.nodes) this.nodes = [];
    return super.prepend(...children)
  }
};

var atRule = AtRule$3;
AtRule$3.default = AtRule$3;

Container$6.registerAtRule(AtRule$3);

let Container$5 = container;

let LazyResult$4, Processor$3;

let Document$3 = class Document extends Container$5 {
  constructor(defaults) {
    // type needs to be passed to super, otherwise child roots won't be normalized correctly
    super({ type: 'document', ...defaults });

    if (!this.nodes) {
      this.nodes = [];
    }
  }

  toResult(opts = {}) {
    let lazy = new LazyResult$4(new Processor$3(), this, opts);

    return lazy.stringify()
  }
};

Document$3.registerLazyResult = dependant => {
  LazyResult$4 = dependant;
};

Document$3.registerProcessor = dependant => {
  Processor$3 = dependant;
};

var document$1 = Document$3;
Document$3.default = Document$3;

// This alphabet uses `A-Za-z0-9_-` symbols.
// The order of characters is optimized for better gzip and brotli compression.
// References to the same file (works both for gzip and brotli):
// `'use`, `andom`, and `rict'`
// References to the brotli default dictionary:
// `-26T`, `1983`, `40px`, `75px`, `bush`, `jack`, `mind`, `very`, and `wolf`
let urlAlphabet =
  'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';

let customAlphabet = (alphabet, defaultSize = 21) => {
  return (size = defaultSize) => {
    let id = '';
    // A compact alternative for `for (var i = 0; i < step; i++)`.
    let i = size | 0;
    while (i--) {
      // `| 0` is more compact and faster than `Math.floor()`.
      id += alphabet[(Math.random() * alphabet.length) | 0];
    }
    return id
  }
};

let nanoid$1 = (size = 21) => {
  let id = '';
  // A compact alternative for `for (var i = 0; i < step; i++)`.
  let i = size | 0;
  while (i--) {
    // `| 0` is more compact and faster than `Math.floor()`.
    id += urlAlphabet[(Math.random() * 64) | 0];
  }
  return id
};

var nonSecure = { nanoid: nanoid$1, customAlphabet };

let { existsSync, readFileSync } = require$$2;
let { dirname: dirname$1, join } = require$$2;
let { SourceMapConsumer: SourceMapConsumer$2, SourceMapGenerator: SourceMapGenerator$2 } = require$$2;

function fromBase64(str) {
  if (Buffer) {
    return Buffer.from(str, 'base64').toString()
  } else {
    /* c8 ignore next 2 */
    return window.atob(str)
  }
}

let PreviousMap$2 = class PreviousMap {
  constructor(css, opts) {
    if (opts.map === false) return
    this.loadAnnotation(css);
    this.inline = this.startWith(this.annotation, 'data:');

    let prev = opts.map ? opts.map.prev : undefined;
    let text = this.loadMap(opts.from, prev);
    if (!this.mapFile && opts.from) {
      this.mapFile = opts.from;
    }
    if (this.mapFile) this.root = dirname$1(this.mapFile);
    if (text) this.text = text;
  }

  consumer() {
    if (!this.consumerCache) {
      this.consumerCache = new SourceMapConsumer$2(this.text);
    }
    return this.consumerCache
  }

  decodeInline(text) {
    let baseCharsetUri = /^data:application\/json;charset=utf-?8;base64,/;
    let baseUri = /^data:application\/json;base64,/;
    let charsetUri = /^data:application\/json;charset=utf-?8,/;
    let uri = /^data:application\/json,/;

    let uriMatch = text.match(charsetUri) || text.match(uri);
    if (uriMatch) {
      return decodeURIComponent(text.substr(uriMatch[0].length))
    }

    let baseUriMatch = text.match(baseCharsetUri) || text.match(baseUri);
    if (baseUriMatch) {
      return fromBase64(text.substr(baseUriMatch[0].length))
    }

    let encoding = text.match(/data:application\/json;([^,]+),/)[1];
    throw new Error('Unsupported source map encoding ' + encoding)
  }

  getAnnotationURL(sourceMapString) {
    return sourceMapString.replace(/^\/\*\s*# sourceMappingURL=/, '').trim()
  }

  isMap(map) {
    if (typeof map !== 'object') return false
    return (
      typeof map.mappings === 'string' ||
      typeof map._mappings === 'string' ||
      Array.isArray(map.sections)
    )
  }

  loadAnnotation(css) {
    let comments = css.match(/\/\*\s*# sourceMappingURL=/g);
    if (!comments) return

    // sourceMappingURLs from comments, strings, etc.
    let start = css.lastIndexOf(comments.pop());
    let end = css.indexOf('*/', start);

    if (start > -1 && end > -1) {
      // Locate the last sourceMappingURL to avoid pickin
      this.annotation = this.getAnnotationURL(css.substring(start, end));
    }
  }

  loadFile(path) {
    this.root = dirname$1(path);
    if (existsSync(path)) {
      this.mapFile = path;
      return readFileSync(path, 'utf-8').toString().trim()
    }
  }

  loadMap(file, prev) {
    if (prev === false) return false

    if (prev) {
      if (typeof prev === 'string') {
        return prev
      } else if (typeof prev === 'function') {
        let prevPath = prev(file);
        if (prevPath) {
          let map = this.loadFile(prevPath);
          if (!map) {
            throw new Error(
              'Unable to load previous source map: ' + prevPath.toString()
            )
          }
          return map
        }
      } else if (prev instanceof SourceMapConsumer$2) {
        return SourceMapGenerator$2.fromSourceMap(prev).toString()
      } else if (prev instanceof SourceMapGenerator$2) {
        return prev.toString()
      } else if (this.isMap(prev)) {
        return JSON.stringify(prev)
      } else {
        throw new Error(
          'Unsupported previous source map format: ' + prev.toString()
        )
      }
    } else if (this.inline) {
      return this.decodeInline(this.annotation)
    } else if (this.annotation) {
      let map = this.annotation;
      if (file) map = join(dirname$1(file), map);
      return this.loadFile(map)
    }
  }

  startWith(string, start) {
    if (!string) return false
    return string.substr(0, start.length) === start
  }

  withContent() {
    return !!(
      this.consumer().sourcesContent &&
      this.consumer().sourcesContent.length > 0
    )
  }
};

var previousMap = PreviousMap$2;
PreviousMap$2.default = PreviousMap$2;

let { nanoid } = nonSecure;
let { isAbsolute, resolve: resolve$1 } = require$$2;
let { SourceMapConsumer: SourceMapConsumer$1, SourceMapGenerator: SourceMapGenerator$1 } = require$$2;
let { fileURLToPath, pathToFileURL: pathToFileURL$1 } = require$$2;

let CssSyntaxError$1 = cssSyntaxError;
let PreviousMap$1 = previousMap;
let terminalHighlight = require$$2;

let lineToIndexCache = Symbol('lineToIndexCache');

let sourceMapAvailable$1 = Boolean(SourceMapConsumer$1 && SourceMapGenerator$1);
let pathAvailable$1 = Boolean(resolve$1 && isAbsolute);

function getLineToIndex(input) {
  if (input[lineToIndexCache]) return input[lineToIndexCache]
  let lines = input.css.split('\n');
  let lineToIndex = new Array(lines.length);
  let prevIndex = 0;

  for (let i = 0, l = lines.length; i < l; i++) {
    lineToIndex[i] = prevIndex;
    prevIndex += lines[i].length + 1;
  }

  input[lineToIndexCache] = lineToIndex;
  return lineToIndex
}

let Input$4 = class Input {
  get from() {
    return this.file || this.id
  }

  constructor(css, opts = {}) {
    if (
      css === null ||
      typeof css === 'undefined' ||
      (typeof css === 'object' && !css.toString)
    ) {
      throw new Error(`PostCSS received ${css} instead of CSS string`)
    }

    this.css = css.toString();

    if (this.css[0] === '\uFEFF' || this.css[0] === '\uFFFE') {
      this.hasBOM = true;
      this.css = this.css.slice(1);
    } else {
      this.hasBOM = false;
    }

    this.document = this.css;
    if (opts.document) this.document = opts.document.toString();

    if (opts.from) {
      if (
        !pathAvailable$1 ||
        /^\w+:\/\//.test(opts.from) ||
        isAbsolute(opts.from)
      ) {
        this.file = opts.from;
      } else {
        this.file = resolve$1(opts.from);
      }
    }

    if (pathAvailable$1 && sourceMapAvailable$1) {
      let map = new PreviousMap$1(this.css, opts);
      if (map.text) {
        this.map = map;
        let file = map.consumer().file;
        if (!this.file && file) this.file = this.mapResolve(file);
      }
    }

    if (!this.file) {
      this.id = '<input css ' + nanoid(6) + '>';
    }
    if (this.map) this.map.file = this.from;
  }

  error(message, line, column, opts = {}) {
    let endColumn, endLine, endOffset, offset, result;

    if (line && typeof line === 'object') {
      let start = line;
      let end = column;
      if (typeof start.offset === 'number') {
        offset = start.offset;
        let pos = this.fromOffset(offset);
        line = pos.line;
        column = pos.col;
      } else {
        line = start.line;
        column = start.column;
        offset = this.fromLineAndColumn(line, column);
      }
      if (typeof end.offset === 'number') {
        endOffset = end.offset;
        let pos = this.fromOffset(endOffset);
        endLine = pos.line;
        endColumn = pos.col;
      } else {
        endLine = end.line;
        endColumn = end.column;
        endOffset = this.fromLineAndColumn(end.line, end.column);
      }
    } else if (!column) {
      offset = line;
      let pos = this.fromOffset(offset);
      line = pos.line;
      column = pos.col;
    } else {
      offset = this.fromLineAndColumn(line, column);
    }

    let origin = this.origin(line, column, endLine, endColumn);
    if (origin) {
      result = new CssSyntaxError$1(
        message,
        origin.endLine === undefined
          ? origin.line
          : { column: origin.column, line: origin.line },
        origin.endLine === undefined
          ? origin.column
          : { column: origin.endColumn, line: origin.endLine },
        origin.source,
        origin.file,
        opts.plugin
      );
    } else {
      result = new CssSyntaxError$1(
        message,
        endLine === undefined ? line : { column, line },
        endLine === undefined ? column : { column: endColumn, line: endLine },
        this.css,
        this.file,
        opts.plugin
      );
    }

    result.input = { column, endColumn, endLine, endOffset, line, offset, source: this.css };
    if (this.file) {
      if (pathToFileURL$1) {
        result.input.url = pathToFileURL$1(this.file).toString();
      }
      result.input.file = this.file;
    }

    return result
  }

  fromLineAndColumn(line, column) {
    let lineToIndex = getLineToIndex(this);
    let index = lineToIndex[line - 1];
    return index + column - 1
  }

  fromOffset(offset) {
    let lineToIndex = getLineToIndex(this);
    let lastLine = lineToIndex[lineToIndex.length - 1];

    let min = 0;
    if (offset >= lastLine) {
      min = lineToIndex.length - 1;
    } else {
      let max = lineToIndex.length - 2;
      let mid;
      while (min < max) {
        mid = min + ((max - min) >> 1);
        if (offset < lineToIndex[mid]) {
          max = mid - 1;
        } else if (offset >= lineToIndex[mid + 1]) {
          min = mid + 1;
        } else {
          min = mid;
          break
        }
      }
    }
    return {
      col: offset - lineToIndex[min] + 1,
      line: min + 1
    }
  }

  mapResolve(file) {
    if (/^\w+:\/\//.test(file)) {
      return file
    }
    return resolve$1(this.map.consumer().sourceRoot || this.map.root || '.', file)
  }

  origin(line, column, endLine, endColumn) {
    if (!this.map) return false
    let consumer = this.map.consumer();

    let from = consumer.originalPositionFor({ column, line });
    if (!from.source) return false

    let to;
    if (typeof endLine === 'number') {
      to = consumer.originalPositionFor({ column: endColumn, line: endLine });
    }

    let fromUrl;

    if (isAbsolute(from.source)) {
      fromUrl = pathToFileURL$1(from.source);
    } else {
      fromUrl = new URL(
        from.source,
        this.map.consumer().sourceRoot || pathToFileURL$1(this.map.mapFile)
      );
    }

    let result = {
      column: from.column,
      endColumn: to && to.column,
      endLine: to && to.line,
      line: from.line,
      url: fromUrl.toString()
    };

    if (fromUrl.protocol === 'file:') {
      if (fileURLToPath) {
        result.file = fileURLToPath(fromUrl);
      } else {
        /* c8 ignore next 2 */
        throw new Error(`file: protocol is not available in this PostCSS build`)
      }
    }

    let source = consumer.sourceContentFor(from.source);
    if (source) result.source = source;

    return result
  }

  toJSON() {
    let json = {};
    for (let name of ['hasBOM', 'css', 'file', 'id']) {
      if (this[name] != null) {
        json[name] = this[name];
      }
    }
    if (this.map) {
      json.map = { ...this.map };
      if (json.map.consumerCache) {
        json.map.consumerCache = undefined;
      }
    }
    return json
  }
};

var input = Input$4;
Input$4.default = Input$4;

if (terminalHighlight && terminalHighlight.registerInput) {
  terminalHighlight.registerInput(Input$4);
}

let Container$4 = container;

let LazyResult$3, Processor$2;

let Root$5 = class Root extends Container$4 {
  constructor(defaults) {
    super(defaults);
    this.type = 'root';
    if (!this.nodes) this.nodes = [];
  }

  normalize(child, sample, type) {
    let nodes = super.normalize(child);

    if (sample) {
      if (type === 'prepend') {
        if (this.nodes.length > 1) {
          sample.raws.before = this.nodes[1].raws.before;
        } else {
          delete sample.raws.before;
        }
      } else if (this.first !== sample) {
        for (let node of nodes) {
          node.raws.before = sample.raws.before;
        }
      }
    }

    return nodes
  }

  removeChild(child, ignore) {
    let index = this.index(child);

    if (!ignore && index === 0 && this.nodes.length > 1) {
      this.nodes[1].raws.before = this.nodes[index].raws.before;
    }

    return super.removeChild(child)
  }

  toResult(opts = {}) {
    let lazy = new LazyResult$3(new Processor$2(), this, opts);
    return lazy.stringify()
  }
};

Root$5.registerLazyResult = dependant => {
  LazyResult$3 = dependant;
};

Root$5.registerProcessor = dependant => {
  Processor$2 = dependant;
};

var root = Root$5;
Root$5.default = Root$5;

Container$4.registerRoot(Root$5);

let list$2 = {
  comma(string) {
    return list$2.split(string, [','], true)
  },

  space(string) {
    let spaces = [' ', '\n', '\t'];
    return list$2.split(string, spaces)
  },

  split(string, separators, last) {
    let array = [];
    let current = '';
    let split = false;

    let func = 0;
    let inQuote = false;
    let prevQuote = '';
    let escape = false;

    for (let letter of string) {
      if (escape) {
        escape = false;
      } else if (letter === '\\') {
        escape = true;
      } else if (inQuote) {
        if (letter === prevQuote) {
          inQuote = false;
        }
      } else if (letter === '"' || letter === "'") {
        inQuote = true;
        prevQuote = letter;
      } else if (letter === '(') {
        func += 1;
      } else if (letter === ')') {
        if (func > 0) func -= 1;
      } else if (func === 0) {
        if (separators.includes(letter)) split = true;
      }

      if (split) {
        if (current !== '') array.push(current.trim());
        current = '';
        split = false;
      } else {
        current += letter;
      }
    }

    if (last || current !== '') array.push(current.trim());
    return array
  }
};

var list_1 = list$2;
list$2.default = list$2;

let Container$3 = container;
let list$1 = list_1;

let Rule$3 = class Rule extends Container$3 {
  get selectors() {
    return list$1.comma(this.selector)
  }

  set selectors(values) {
    let match = this.selector ? this.selector.match(/,\s*/) : null;
    let sep = match ? match[0] : ',' + this.raw('between', 'beforeOpen');
    this.selector = values.join(sep);
  }

  constructor(defaults) {
    super(defaults);
    this.type = 'rule';
    if (!this.nodes) this.nodes = [];
  }
};

var rule = Rule$3;
Rule$3.default = Rule$3;

Container$3.registerRule(Rule$3);

let AtRule$2 = atRule;
let Comment$2 = comment;
let Declaration$2 = declaration;
let Input$3 = input;
let PreviousMap = previousMap;
let Root$4 = root;
let Rule$2 = rule;

function fromJSON$1(json, inputs) {
  if (Array.isArray(json)) return json.map(n => fromJSON$1(n))

  let { inputs: ownInputs, ...defaults } = json;
  if (ownInputs) {
    inputs = [];
    for (let input of ownInputs) {
      let inputHydrated = { ...input, __proto__: Input$3.prototype };
      if (inputHydrated.map) {
        inputHydrated.map = {
          ...inputHydrated.map,
          __proto__: PreviousMap.prototype
        };
      }
      inputs.push(inputHydrated);
    }
  }
  if (defaults.nodes) {
    defaults.nodes = json.nodes.map(n => fromJSON$1(n, inputs));
  }
  if (defaults.source) {
    let { inputId, ...source } = defaults.source;
    defaults.source = source;
    if (inputId != null) {
      defaults.source.input = inputs[inputId];
    }
  }
  if (defaults.type === 'root') {
    return new Root$4(defaults)
  } else if (defaults.type === 'decl') {
    return new Declaration$2(defaults)
  } else if (defaults.type === 'rule') {
    return new Rule$2(defaults)
  } else if (defaults.type === 'comment') {
    return new Comment$2(defaults)
  } else if (defaults.type === 'atrule') {
    return new AtRule$2(defaults)
  } else {
    throw new Error('Unknown node type: ' + json.type)
  }
}

var fromJSON_1 = fromJSON$1;
fromJSON$1.default = fromJSON$1;

let { dirname, relative, resolve, sep } = require$$2;
let { SourceMapConsumer, SourceMapGenerator } = require$$2;
let { pathToFileURL } = require$$2;

let Input$2 = input;

let sourceMapAvailable = Boolean(SourceMapConsumer && SourceMapGenerator);
let pathAvailable = Boolean(dirname && resolve && relative && sep);

let MapGenerator$2 = class MapGenerator {
  constructor(stringify, root, opts, cssString) {
    this.stringify = stringify;
    this.mapOpts = opts.map || {};
    this.root = root;
    this.opts = opts;
    this.css = cssString;
    this.originalCSS = cssString;
    this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute;

    this.memoizedFileURLs = new Map();
    this.memoizedPaths = new Map();
    this.memoizedURLs = new Map();
  }

  addAnnotation() {
    let content;

    if (this.isInline()) {
      content =
        'data:application/json;base64,' + this.toBase64(this.map.toString());
    } else if (typeof this.mapOpts.annotation === 'string') {
      content = this.mapOpts.annotation;
    } else if (typeof this.mapOpts.annotation === 'function') {
      content = this.mapOpts.annotation(this.opts.to, this.root);
    } else {
      content = this.outputFile() + '.map';
    }
    let eol = '\n';
    if (this.css.includes('\r\n')) eol = '\r\n';

    this.css += eol + '/*# sourceMappingURL=' + content + ' */';
  }

  applyPrevMaps() {
    for (let prev of this.previous()) {
      let from = this.toUrl(this.path(prev.file));
      let root = prev.root || dirname(prev.file);
      let map;

      if (this.mapOpts.sourcesContent === false) {
        map = new SourceMapConsumer(prev.text);
        if (map.sourcesContent) {
          map.sourcesContent = null;
        }
      } else {
        map = prev.consumer();
      }

      this.map.applySourceMap(map, from, this.toUrl(this.path(root)));
    }
  }

  clearAnnotation() {
    if (this.mapOpts.annotation === false) return

    if (this.root) {
      let node;
      for (let i = this.root.nodes.length - 1; i >= 0; i--) {
        node = this.root.nodes[i];
        if (node.type !== 'comment') continue
        if (node.text.startsWith('# sourceMappingURL=')) {
          this.root.removeChild(i);
        }
      }
    } else if (this.css) {
      this.css = this.css.replace(/\n*\/\*#[\S\s]*?\*\/$/gm, '');
    }
  }

  generate() {
    this.clearAnnotation();
    if (pathAvailable && sourceMapAvailable && this.isMap()) {
      return this.generateMap()
    } else {
      let result = '';
      this.stringify(this.root, i => {
        result += i;
      });
      return [result]
    }
  }

  generateMap() {
    if (this.root) {
      this.generateString();
    } else if (this.previous().length === 1) {
      let prev = this.previous()[0].consumer();
      prev.file = this.outputFile();
      this.map = SourceMapGenerator.fromSourceMap(prev, {
        ignoreInvalidMapping: true
      });
    } else {
      this.map = new SourceMapGenerator({
        file: this.outputFile(),
        ignoreInvalidMapping: true
      });
      this.map.addMapping({
        generated: { column: 0, line: 1 },
        original: { column: 0, line: 1 },
        source: this.opts.from
          ? this.toUrl(this.path(this.opts.from))
          : '<no source>'
      });
    }

    if (this.isSourcesContent()) this.setSourcesContent();
    if (this.root && this.previous().length > 0) this.applyPrevMaps();
    if (this.isAnnotation()) this.addAnnotation();

    if (this.isInline()) {
      return [this.css]
    } else {
      return [this.css, this.map]
    }
  }

  generateString() {
    this.css = '';
    this.map = new SourceMapGenerator({
      file: this.outputFile(),
      ignoreInvalidMapping: true
    });

    let line = 1;
    let column = 1;

    let noSource = '<no source>';
    let mapping = {
      generated: { column: 0, line: 0 },
      original: { column: 0, line: 0 },
      source: ''
    };

    let last, lines;
    this.stringify(this.root, (str, node, type) => {
      this.css += str;

      if (node && type !== 'end') {
        mapping.generated.line = line;
        mapping.generated.column = column - 1;
        if (node.source && node.source.start) {
          mapping.source = this.sourcePath(node);
          mapping.original.line = node.source.start.line;
          mapping.original.column = node.source.start.column - 1;
          this.map.addMapping(mapping);
        } else {
          mapping.source = noSource;
          mapping.original.line = 1;
          mapping.original.column = 0;
          this.map.addMapping(mapping);
        }
      }

      lines = str.match(/\n/g);
      if (lines) {
        line += lines.length;
        last = str.lastIndexOf('\n');
        column = str.length - last;
      } else {
        column += str.length;
      }

      if (node && type !== 'start') {
        let p = node.parent || { raws: {} };
        let childless =
          node.type === 'decl' || (node.type === 'atrule' && !node.nodes);
        if (!childless || node !== p.last || p.raws.semicolon) {
          if (node.source && node.source.end) {
            mapping.source = this.sourcePath(node);
            mapping.original.line = node.source.end.line;
            mapping.original.column = node.source.end.column - 1;
            mapping.generated.line = line;
            mapping.generated.column = column - 2;
            this.map.addMapping(mapping);
          } else {
            mapping.source = noSource;
            mapping.original.line = 1;
            mapping.original.column = 0;
            mapping.generated.line = line;
            mapping.generated.column = column - 1;
            this.map.addMapping(mapping);
          }
        }
      }
    });
  }

  isAnnotation() {
    if (this.isInline()) {
      return true
    }
    if (typeof this.mapOpts.annotation !== 'undefined') {
      return this.mapOpts.annotation
    }
    if (this.previous().length) {
      return this.previous().some(i => i.annotation)
    }
    return true
  }

  isInline() {
    if (typeof this.mapOpts.inline !== 'undefined') {
      return this.mapOpts.inline
    }

    let annotation = this.mapOpts.annotation;
    if (typeof annotation !== 'undefined' && annotation !== true) {
      return false
    }

    if (this.previous().length) {
      return this.previous().some(i => i.inline)
    }
    return true
  }

  isMap() {
    if (typeof this.opts.map !== 'undefined') {
      return !!this.opts.map
    }
    return this.previous().length > 0
  }

  isSourcesContent() {
    if (typeof this.mapOpts.sourcesContent !== 'undefined') {
      return this.mapOpts.sourcesContent
    }
    if (this.previous().length) {
      return this.previous().some(i => i.withContent())
    }
    return true
  }

  outputFile() {
    if (this.opts.to) {
      return this.path(this.opts.to)
    } else if (this.opts.from) {
      return this.path(this.opts.from)
    } else {
      return 'to.css'
    }
  }

  path(file) {
    if (this.mapOpts.absolute) return file
    if (file.charCodeAt(0) === 60 /* `<` */) return file
    if (/^\w+:\/\//.test(file)) return file
    let cached = this.memoizedPaths.get(file);
    if (cached) return cached

    let from = this.opts.to ? dirname(this.opts.to) : '.';

    if (typeof this.mapOpts.annotation === 'string') {
      from = dirname(resolve(from, this.mapOpts.annotation));
    }

    let path = relative(from, file);
    this.memoizedPaths.set(file, path);

    return path
  }

  previous() {
    if (!this.previousMaps) {
      this.previousMaps = [];
      if (this.root) {
        this.root.walk(node => {
          if (node.source && node.source.input.map) {
            let map = node.source.input.map;
            if (!this.previousMaps.includes(map)) {
              this.previousMaps.push(map);
            }
          }
        });
      } else {
        let input = new Input$2(this.originalCSS, this.opts);
        if (input.map) this.previousMaps.push(input.map);
      }
    }

    return this.previousMaps
  }

  setSourcesContent() {
    let already = {};
    if (this.root) {
      this.root.walk(node => {
        if (node.source) {
          let from = node.source.input.from;
          if (from && !already[from]) {
            already[from] = true;
            let fromUrl = this.usesFileUrls
              ? this.toFileUrl(from)
              : this.toUrl(this.path(from));
            this.map.setSourceContent(fromUrl, node.source.input.css);
          }
        }
      });
    } else if (this.css) {
      let from = this.opts.from
        ? this.toUrl(this.path(this.opts.from))
        : '<no source>';
      this.map.setSourceContent(from, this.css);
    }
  }

  sourcePath(node) {
    if (this.mapOpts.from) {
      return this.toUrl(this.mapOpts.from)
    } else if (this.usesFileUrls) {
      return this.toFileUrl(node.source.input.from)
    } else {
      return this.toUrl(this.path(node.source.input.from))
    }
  }

  toBase64(str) {
    if (Buffer) {
      return Buffer.from(str).toString('base64')
    } else {
      return window.btoa(unescape(encodeURIComponent(str)))
    }
  }

  toFileUrl(path) {
    let cached = this.memoizedFileURLs.get(path);
    if (cached) return cached

    if (pathToFileURL) {
      let fileURL = pathToFileURL(path).toString();
      this.memoizedFileURLs.set(path, fileURL);

      return fileURL
    } else {
      throw new Error(
        '`map.absolute` option is not available in this PostCSS build'
      )
    }
  }

  toUrl(path) {
    let cached = this.memoizedURLs.get(path);
    if (cached) return cached

    if (sep === '\\') {
      path = path.replace(/\\/g, '/');
    }

    let url = encodeURI(path).replace(/[#?]/g, encodeURIComponent);
    this.memoizedURLs.set(path, url);

    return url
  }
};

var mapGenerator = MapGenerator$2;

const SINGLE_QUOTE = "'".charCodeAt(0);
const DOUBLE_QUOTE = '"'.charCodeAt(0);
const BACKSLASH = '\\'.charCodeAt(0);
const SLASH = '/'.charCodeAt(0);
const NEWLINE = '\n'.charCodeAt(0);
const SPACE = ' '.charCodeAt(0);
const FEED = '\f'.charCodeAt(0);
const TAB = '\t'.charCodeAt(0);
const CR = '\r'.charCodeAt(0);
const OPEN_SQUARE = '['.charCodeAt(0);
const CLOSE_SQUARE = ']'.charCodeAt(0);
const OPEN_PARENTHESES = '('.charCodeAt(0);
const CLOSE_PARENTHESES = ')'.charCodeAt(0);
const OPEN_CURLY = '{'.charCodeAt(0);
const CLOSE_CURLY = '}'.charCodeAt(0);
const SEMICOLON = ';'.charCodeAt(0);
const ASTERISK = '*'.charCodeAt(0);
const COLON = ':'.charCodeAt(0);
const AT = '@'.charCodeAt(0);

const RE_AT_END = /[\t\n\f\r "#'()/;[\\\]{}]/g;
const RE_WORD_END = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g;
const RE_BAD_BRACKET = /.[\r\n"'(/\\]/;
const RE_HEX_ESCAPE = /[\da-f]/i;

var tokenize = function tokenizer(input, options = {}) {
  let css = input.css.valueOf();
  let ignore = options.ignoreErrors;

  let code, content, escape, next, quote;
  let currentToken, escaped, escapePos, n, prev;

  let length = css.length;
  let pos = 0;
  let buffer = [];
  let returned = [];

  function position() {
    return pos
  }

  function unclosed(what) {
    throw input.error('Unclosed ' + what, pos)
  }

  function endOfFile() {
    return returned.length === 0 && pos >= length
  }

  function nextToken(opts) {
    if (returned.length) return returned.pop()
    if (pos >= length) return

    let ignoreUnclosed = opts ? opts.ignoreUnclosed : false;

    code = css.charCodeAt(pos);

    switch (code) {
      case NEWLINE:
      case SPACE:
      case TAB:
      case CR:
      case FEED: {
        next = pos;
        do {
          next += 1;
          code = css.charCodeAt(next);
        } while (
          code === SPACE ||
          code === NEWLINE ||
          code === TAB ||
          code === CR ||
          code === FEED
        )

        currentToken = ['space', css.slice(pos, next)];
        pos = next - 1;
        break
      }

      case OPEN_SQUARE:
      case CLOSE_SQUARE:
      case OPEN_CURLY:
      case CLOSE_CURLY:
      case COLON:
      case SEMICOLON:
      case CLOSE_PARENTHESES: {
        let controlChar = String.fromCharCode(code);
        currentToken = [controlChar, controlChar, pos];
        break
      }

      case OPEN_PARENTHESES: {
        prev = buffer.length ? buffer.pop()[1] : '';
        n = css.charCodeAt(pos + 1);
        if (
          prev === 'url' &&
          n !== SINGLE_QUOTE &&
          n !== DOUBLE_QUOTE &&
          n !== SPACE &&
          n !== NEWLINE &&
          n !== TAB &&
          n !== FEED &&
          n !== CR
        ) {
          next = pos;
          do {
            escaped = false;
            next = css.indexOf(')', next + 1);
            if (next === -1) {
              if (ignore || ignoreUnclosed) {
                next = pos;
                break
              } else {
                unclosed('bracket');
              }
            }
            escapePos = next;
            while (css.charCodeAt(escapePos - 1) === BACKSLASH) {
              escapePos -= 1;
              escaped = !escaped;
            }
          } while (escaped)

          currentToken = ['brackets', css.slice(pos, next + 1), pos, next];

          pos = next;
        } else {
          next = css.indexOf(')', pos + 1);
          content = css.slice(pos, next + 1);

          if (next === -1 || RE_BAD_BRACKET.test(content)) {
            currentToken = ['(', '(', pos];
          } else {
            currentToken = ['brackets', content, pos, next];
            pos = next;
          }
        }

        break
      }

      case SINGLE_QUOTE:
      case DOUBLE_QUOTE: {
        quote = code === SINGLE_QUOTE ? "'" : '"';
        next = pos;
        do {
          escaped = false;
          next = css.indexOf(quote, next + 1);
          if (next === -1) {
            if (ignore || ignoreUnclosed) {
              next = pos + 1;
              break
            } else {
              unclosed('string');
            }
          }
          escapePos = next;
          while (css.charCodeAt(escapePos - 1) === BACKSLASH) {
            escapePos -= 1;
            escaped = !escaped;
          }
        } while (escaped)

        currentToken = ['string', css.slice(pos, next + 1), pos, next];
        pos = next;
        break
      }

      case AT: {
        RE_AT_END.lastIndex = pos + 1;
        RE_AT_END.test(css);
        if (RE_AT_END.lastIndex === 0) {
          next = css.length - 1;
        } else {
          next = RE_AT_END.lastIndex - 2;
        }

        currentToken = ['at-word', css.slice(pos, next + 1), pos, next];

        pos = next;
        break
      }

      case BACKSLASH: {
        next = pos;
        escape = true;
        while (css.charCodeAt(next + 1) === BACKSLASH) {
          next += 1;
          escape = !escape;
        }
        code = css.charCodeAt(next + 1);
        if (
          escape &&
          code !== SLASH &&
          code !== SPACE &&
          code !== NEWLINE &&
          code !== TAB &&
          code !== CR &&
          code !== FEED
        ) {
          next += 1;
          if (RE_HEX_ESCAPE.test(css.charAt(next))) {
            while (RE_HEX_ESCAPE.test(css.charAt(next + 1))) {
              next += 1;
            }
            if (css.charCodeAt(next + 1) === SPACE) {
              next += 1;
            }
          }
        }

        currentToken = ['word', css.slice(pos, next + 1), pos, next];

        pos = next;
        break
      }

      default: {
        if (code === SLASH && css.charCodeAt(pos + 1) === ASTERISK) {
          next = css.indexOf('*/', pos + 2) + 1;
          if (next === 0) {
            if (ignore || ignoreUnclosed) {
              next = css.length;
            } else {
              unclosed('comment');
            }
          }

          currentToken = ['comment', css.slice(pos, next + 1), pos, next];
          pos = next;
        } else {
          RE_WORD_END.lastIndex = pos + 1;
          RE_WORD_END.test(css);
          if (RE_WORD_END.lastIndex === 0) {
            next = css.length - 1;
          } else {
            next = RE_WORD_END.lastIndex - 2;
          }

          currentToken = ['word', css.slice(pos, next + 1), pos, next];
          buffer.push(currentToken);
          pos = next;
        }

        break
      }
    }

    pos++;
    return currentToken
  }

  function back(token) {
    returned.push(token);
  }

  return {
    back,
    endOfFile,
    nextToken,
    position
  }
};

let AtRule$1 = atRule;
let Comment$1 = comment;
let Declaration$1 = declaration;
let Root$3 = root;
let Rule$1 = rule;
let tokenizer = tokenize;

const SAFE_COMMENT_NEIGHBOR = {
  empty: true,
  space: true
};

function findLastWithPosition(tokens) {
  for (let i = tokens.length - 1; i >= 0; i--) {
    let token = tokens[i];
    let pos = token[3] || token[2];
    if (pos) return pos
  }
}

let Parser$2 = class Parser {
  constructor(input) {
    this.input = input;

    this.root = new Root$3();
    this.current = this.root;
    this.spaces = '';
    this.semicolon = false;

    this.createTokenizer();
    this.root.source = { input, start: { column: 1, line: 1, offset: 0 } };
  }

  atrule(token) {
    let node = new AtRule$1();
    node.name = token[1].slice(1);
    if (node.name === '') {
      this.unnamedAtrule(node, token);
    }
    this.init(node, token[2]);

    let type;
    let prev;
    let shift;
    let last = false;
    let open = false;
    let params = [];
    let brackets = [];

    while (!this.tokenizer.endOfFile()) {
      token = this.tokenizer.nextToken();
      type = token[0];

      if (type === '(' || type === '[') {
        brackets.push(type === '(' ? ')' : ']');
      } else if (type === '{' && brackets.length > 0) {
        brackets.push('}');
      } else if (type === brackets[brackets.length - 1]) {
        brackets.pop();
      }

      if (brackets.length === 0) {
        if (type === ';') {
          node.source.end = this.getPosition(token[2]);
          node.source.end.offset++;
          this.semicolon = true;
          break
        } else if (type === '{') {
          open = true;
          break
        } else if (type === '}') {
          if (params.length > 0) {
            shift = params.length - 1;
            prev = params[shift];
            while (prev && prev[0] === 'space') {
              prev = params[--shift];
            }
            if (prev) {
              node.source.end = this.getPosition(prev[3] || prev[2]);
              node.source.end.offset++;
            }
          }
          this.end(token);
          break
        } else {
          params.push(token);
        }
      } else {
        params.push(token);
      }

      if (this.tokenizer.endOfFile()) {
        last = true;
        break
      }
    }

    node.raws.between = this.spacesAndCommentsFromEnd(params);
    if (params.length) {
      node.raws.afterName = this.spacesAndCommentsFromStart(params);
      this.raw(node, 'params', params);
      if (last) {
        token = params[params.length - 1];
        node.source.end = this.getPosition(token[3] || token[2]);
        node.source.end.offset++;
        this.spaces = node.raws.between;
        node.raws.between = '';
      }
    } else {
      node.raws.afterName = '';
      node.params = '';
    }

    if (open) {
      node.nodes = [];
      this.current = node;
    }
  }

  checkMissedSemicolon(tokens) {
    let colon = this.colon(tokens);
    if (colon === false) return

    let founded = 0;
    let token;
    for (let j = colon - 1; j >= 0; j--) {
      token = tokens[j];
      if (token[0] !== 'space') {
        founded += 1;
        if (founded === 2) break
      }
    }
    // If the token is a word, e.g. `!important`, `red` or any other valid property's value.
    // Then we need to return the colon after that word token. [3] is the "end" colon of that word.
    // And because we need it after that one we do +1 to get the next one.
    throw this.input.error(
      'Missed semicolon',
      token[0] === 'word' ? token[3] + 1 : token[2]
    )
  }

  colon(tokens) {
    let brackets = 0;
    let prev, token, type;
    for (let [i, element] of tokens.entries()) {
      token = element;
      type = token[0];

      if (type === '(') {
        brackets += 1;
      }
      if (type === ')') {
        brackets -= 1;
      }
      if (brackets === 0 && type === ':') {
        if (!prev) {
          this.doubleColon(token);
        } else if (prev[0] === 'word' && prev[1] === 'progid') {
          continue
        } else {
          return i
        }
      }

      prev = token;
    }
    return false
  }

  comment(token) {
    let node = new Comment$1();
    this.init(node, token[2]);
    node.source.end = this.getPosition(token[3] || token[2]);
    node.source.end.offset++;

    let text = token[1].slice(2, -2);
    if (/^\s*$/.test(text)) {
      node.text = '';
      node.raws.left = text;
      node.raws.right = '';
    } else {
      let match = text.match(/^(\s*)([^]*\S)(\s*)$/);
      node.text = match[2];
      node.raws.left = match[1];
      node.raws.right = match[3];
    }
  }

  createTokenizer() {
    this.tokenizer = tokenizer(this.input);
  }

  decl(tokens, customProperty) {
    let node = new Declaration$1();
    this.init(node, tokens[0][2]);

    let last = tokens[tokens.length - 1];
    if (last[0] === ';') {
      this.semicolon = true;
      tokens.pop();
    }

    node.source.end = this.getPosition(
      last[3] || last[2] || findLastWithPosition(tokens)
    );
    node.source.end.offset++;

    while (tokens[0][0] !== 'word') {
      if (tokens.length === 1) this.unknownWord(tokens);
      node.raws.before += tokens.shift()[1];
    }
    node.source.start = this.getPosition(tokens[0][2]);

    node.prop = '';
    while (tokens.length) {
      let type = tokens[0][0];
      if (type === ':' || type === 'space' || type === 'comment') {
        break
      }
      node.prop += tokens.shift()[1];
    }

    node.raws.between = '';

    let token;
    while (tokens.length) {
      token = tokens.shift();

      if (token[0] === ':') {
        node.raws.between += token[1];
        break
      } else {
        if (token[0] === 'word' && /\w/.test(token[1])) {
          this.unknownWord([token]);
        }
        node.raws.between += token[1];
      }
    }

    if (node.prop[0] === '_' || node.prop[0] === '*') {
      node.raws.before += node.prop[0];
      node.prop = node.prop.slice(1);
    }

    let firstSpaces = [];
    let next;
    while (tokens.length) {
      next = tokens[0][0];
      if (next !== 'space' && next !== 'comment') break
      firstSpaces.push(tokens.shift());
    }

    this.precheckMissedSemicolon(tokens);

    for (let i = tokens.length - 1; i >= 0; i--) {
      token = tokens[i];
      if (token[1].toLowerCase() === '!important') {
        node.important = true;
        let string = this.stringFrom(tokens, i);
        string = this.spacesFromEnd(tokens) + string;
        if (string !== ' !important') node.raws.important = string;
        break
      } else if (token[1].toLowerCase() === 'important') {
        let cache = tokens.slice(0);
        let str = '';
        for (let j = i; j > 0; j--) {
          let type = cache[j][0];
          if (str.trim().startsWith('!') && type !== 'space') {
            break
          }
          str = cache.pop()[1] + str;
        }
        if (str.trim().startsWith('!')) {
          node.important = true;
          node.raws.important = str;
          tokens = cache;
        }
      }

      if (token[0] !== 'space' && token[0] !== 'comment') {
        break
      }
    }

    let hasWord = tokens.some(i => i[0] !== 'space' && i[0] !== 'comment');

    if (hasWord) {
      node.raws.between += firstSpaces.map(i => i[1]).join('');
      firstSpaces = [];
    }
    this.raw(node, 'value', firstSpaces.concat(tokens), customProperty);

    if (node.value.includes(':') && !customProperty) {
      this.checkMissedSemicolon(tokens);
    }
  }

  doubleColon(token) {
    throw this.input.error(
      'Double colon',
      { offset: token[2] },
      { offset: token[2] + token[1].length }
    )
  }

  emptyRule(token) {
    let node = new Rule$1();
    this.init(node, token[2]);
    node.selector = '';
    node.raws.between = '';
    this.current = node;
  }

  end(token) {
    if (this.current.nodes && this.current.nodes.length) {
      this.current.raws.semicolon = this.semicolon;
    }
    this.semicolon = false;

    this.current.raws.after = (this.current.raws.after || '') + this.spaces;
    this.spaces = '';

    if (this.current.parent) {
      this.current.source.end = this.getPosition(token[2]);
      this.current.source.end.offset++;
      this.current = this.current.parent;
    } else {
      this.unexpectedClose(token);
    }
  }

  endFile() {
    if (this.current.parent) this.unclosedBlock();
    if (this.current.nodes && this.current.nodes.length) {
      this.current.raws.semicolon = this.semicolon;
    }
    this.current.raws.after = (this.current.raws.after || '') + this.spaces;
    this.root.source.end = this.getPosition(this.tokenizer.position());
  }

  freeSemicolon(token) {
    this.spaces += token[1];
    if (this.current.nodes) {
      let prev = this.current.nodes[this.current.nodes.length - 1];
      if (prev && prev.type === 'rule' && !prev.raws.ownSemicolon) {
        prev.raws.ownSemicolon = this.spaces;
        this.spaces = '';
        prev.source.end = this.getPosition(token[2]);
        prev.source.end.offset += prev.raws.ownSemicolon.length;
      }
    }
  }

  // Helpers

  getPosition(offset) {
    let pos = this.input.fromOffset(offset);
    return {
      column: pos.col,
      line: pos.line,
      offset
    }
  }

  init(node, offset) {
    this.current.push(node);
    node.source = {
      input: this.input,
      start: this.getPosition(offset)
    };
    node.raws.before = this.spaces;
    this.spaces = '';
    if (node.type !== 'comment') this.semicolon = false;
  }

  other(start) {
    let end = false;
    let type = null;
    let colon = false;
    let bracket = null;
    let brackets = [];
    let customProperty = start[1].startsWith('--');

    let tokens = [];
    let token = start;
    while (token) {
      type = token[0];
      tokens.push(token);

      if (type === '(' || type === '[') {
        if (!bracket) bracket = token;
        brackets.push(type === '(' ? ')' : ']');
      } else if (customProperty && colon && type === '{') {
        if (!bracket) bracket = token;
        brackets.push('}');
      } else if (brackets.length === 0) {
        if (type === ';') {
          if (colon) {
            this.decl(tokens, customProperty);
            return
          } else {
            break
          }
        } else if (type === '{') {
          this.rule(tokens);
          return
        } else if (type === '}') {
          this.tokenizer.back(tokens.pop());
          end = true;
          break
        } else if (type === ':') {
          colon = true;
        }
      } else if (type === brackets[brackets.length - 1]) {
        brackets.pop();
        if (brackets.length === 0) bracket = null;
      }

      token = this.tokenizer.nextToken();
    }

    if (this.tokenizer.endOfFile()) end = true;
    if (brackets.length > 0) this.unclosedBracket(bracket);

    if (end && colon) {
      if (!customProperty) {
        while (tokens.length) {
          token = tokens[tokens.length - 1][0];
          if (token !== 'space' && token !== 'comment') break
          this.tokenizer.back(tokens.pop());
        }
      }
      this.decl(tokens, customProperty);
    } else {
      this.unknownWord(tokens);
    }
  }

  parse() {
    let token;
    while (!this.tokenizer.endOfFile()) {
      token = this.tokenizer.nextToken();

      switch (token[0]) {
        case 'space':
          this.spaces += token[1];
          break

        case ';':
          this.freeSemicolon(token);
          break

        case '}':
          this.end(token);
          break

        case 'comment':
          this.comment(token);
          break

        case 'at-word':
          this.atrule(token);
          break

        case '{':
          this.emptyRule(token);
          break

        default:
          this.other(token);
          break
      }
    }
    this.endFile();
  }

  precheckMissedSemicolon(/* tokens */) {
    // Hook for Safe Parser
  }

  raw(node, prop, tokens, customProperty) {
    let token, type;
    let length = tokens.length;
    let value = '';
    let clean = true;
    let next, prev;

    for (let i = 0; i < length; i += 1) {
      token = tokens[i];
      type = token[0];
      if (type === 'space' && i === length - 1 && !customProperty) {
        clean = false;
      } else if (type === 'comment') {
        prev = tokens[i - 1] ? tokens[i - 1][0] : 'empty';
        next = tokens[i + 1] ? tokens[i + 1][0] : 'empty';
        if (!SAFE_COMMENT_NEIGHBOR[prev] && !SAFE_COMMENT_NEIGHBOR[next]) {
          if (value.slice(-1) === ',') {
            clean = false;
          } else {
            value += token[1];
          }
        } else {
          clean = false;
        }
      } else {
        value += token[1];
      }
    }
    if (!clean) {
      let raw = tokens.reduce((all, i) => all + i[1], '');
      node.raws[prop] = { raw, value };
    }
    node[prop] = value;
  }

  rule(tokens) {
    tokens.pop();

    let node = new Rule$1();
    this.init(node, tokens[0][2]);

    node.raws.between = this.spacesAndCommentsFromEnd(tokens);
    this.raw(node, 'selector', tokens);
    this.current = node;
  }

  spacesAndCommentsFromEnd(tokens) {
    let lastTokenType;
    let spaces = '';
    while (tokens.length) {
      lastTokenType = tokens[tokens.length - 1][0];
      if (lastTokenType !== 'space' && lastTokenType !== 'comment') break
      spaces = tokens.pop()[1] + spaces;
    }
    return spaces
  }

  // Errors

  spacesAndCommentsFromStart(tokens) {
    let next;
    let spaces = '';
    while (tokens.length) {
      next = tokens[0][0];
      if (next !== 'space' && next !== 'comment') break
      spaces += tokens.shift()[1];
    }
    return spaces
  }

  spacesFromEnd(tokens) {
    let lastTokenType;
    let spaces = '';
    while (tokens.length) {
      lastTokenType = tokens[tokens.length - 1][0];
      if (lastTokenType !== 'space') break
      spaces = tokens.pop()[1] + spaces;
    }
    return spaces
  }

  stringFrom(tokens, from) {
    let result = '';
    for (let i = from; i < tokens.length; i++) {
      result += tokens[i][1];
    }
    tokens.splice(from, tokens.length - from);
    return result
  }

  unclosedBlock() {
    let pos = this.current.source.start;
    throw this.input.error('Unclosed block', pos.line, pos.column)
  }

  unclosedBracket(bracket) {
    throw this.input.error(
      'Unclosed bracket',
      { offset: bracket[2] },
      { offset: bracket[2] + 1 }
    )
  }

  unexpectedClose(token) {
    throw this.input.error(
      'Unexpected }',
      { offset: token[2] },
      { offset: token[2] + 1 }
    )
  }

  unknownWord(tokens) {
    throw this.input.error(
      'Unknown word ' + tokens[0][1],
      { offset: tokens[0][2] },
      { offset: tokens[0][2] + tokens[0][1].length }
    )
  }

  unnamedAtrule(node, token) {
    throw this.input.error(
      'At-rule without name',
      { offset: token[2] },
      { offset: token[2] + token[1].length }
    )
  }
};

var parser = Parser$2;

let Container$2 = container;
let Input$1 = input;
let Parser$1 = parser;

function parse$3(css, opts) {
  let input = new Input$1(css, opts);
  let parser = new Parser$1(input);
  try {
    parser.parse();
  } catch (e) {
    throw e
  }

  return parser.root
}

var parse_1 = parse$3;
parse$3.default = parse$3;

Container$2.registerParse(parse$3);

let Warning$2 = class Warning {
  constructor(text, opts = {}) {
    this.type = 'warning';
    this.text = text;

    if (opts.node && opts.node.source) {
      let range = opts.node.rangeBy(opts);
      this.line = range.start.line;
      this.column = range.start.column;
      this.endLine = range.end.line;
      this.endColumn = range.end.column;
    }

    for (let opt in opts) this[opt] = opts[opt];
  }

  toString() {
    if (this.node) {
      return this.node.error(this.text, {
        index: this.index,
        plugin: this.plugin,
        word: this.word
      }).message
    }

    if (this.plugin) {
      return this.plugin + ': ' + this.text
    }

    return this.text
  }
};

var warning = Warning$2;
Warning$2.default = Warning$2;

let Warning$1 = warning;

let Result$3 = class Result {
  get content() {
    return this.css
  }

  constructor(processor, root, opts) {
    this.processor = processor;
    this.messages = [];
    this.root = root;
    this.opts = opts;
    this.css = '';
    this.map = undefined;
  }

  toString() {
    return this.css
  }

  warn(text, opts = {}) {
    if (!opts.plugin) {
      if (this.lastPlugin && this.lastPlugin.postcssPlugin) {
        opts.plugin = this.lastPlugin.postcssPlugin;
      }
    }

    let warning = new Warning$1(text, opts);
    this.messages.push(warning);

    return warning
  }

  warnings() {
    return this.messages.filter(i => i.type === 'warning')
  }
};

var result = Result$3;
Result$3.default = Result$3;

let Container$1 = container;
let Document$2 = document$1;
let MapGenerator$1 = mapGenerator;
let parse$2 = parse_1;
let Result$2 = result;
let Root$2 = root;
let stringify$2 = stringify_1;
let { isClean, my } = symbols;

const TYPE_TO_CLASS_NAME = {
  atrule: 'AtRule',
  comment: 'Comment',
  decl: 'Declaration',
  document: 'Document',
  root: 'Root',
  rule: 'Rule'
};

const PLUGIN_PROPS = {
  AtRule: true,
  AtRuleExit: true,
  Comment: true,
  CommentExit: true,
  Declaration: true,
  DeclarationExit: true,
  Document: true,
  DocumentExit: true,
  Once: true,
  OnceExit: true,
  postcssPlugin: true,
  prepare: true,
  Root: true,
  RootExit: true,
  Rule: true,
  RuleExit: true
};

const NOT_VISITORS = {
  Once: true,
  postcssPlugin: true,
  prepare: true
};

const CHILDREN = 0;

function isPromise(obj) {
  return typeof obj === 'object' && typeof obj.then === 'function'
}

function getEvents(node) {
  let key = false;
  let type = TYPE_TO_CLASS_NAME[node.type];
  if (node.type === 'decl') {
    key = node.prop.toLowerCase();
  } else if (node.type === 'atrule') {
    key = node.name.toLowerCase();
  }

  if (key && node.append) {
    return [
      type,
      type + '-' + key,
      CHILDREN,
      type + 'Exit',
      type + 'Exit-' + key
    ]
  } else if (key) {
    return [type, type + '-' + key, type + 'Exit', type + 'Exit-' + key]
  } else if (node.append) {
    return [type, CHILDREN, type + 'Exit']
  } else {
    return [type, type + 'Exit']
  }
}

function toStack(node) {
  let events;
  if (node.type === 'document') {
    events = ['Document', CHILDREN, 'DocumentExit'];
  } else if (node.type === 'root') {
    events = ['Root', CHILDREN, 'RootExit'];
  } else {
    events = getEvents(node);
  }

  return {
    eventIndex: 0,
    events,
    iterator: 0,
    node,
    visitorIndex: 0,
    visitors: []
  }
}

function cleanMarks(node) {
  node[isClean] = false;
  if (node.nodes) node.nodes.forEach(i => cleanMarks(i));
  return node
}

let postcss$1 = {};

let LazyResult$2 = class LazyResult {
  get content() {
    return this.stringify().content
  }

  get css() {
    return this.stringify().css
  }

  get map() {
    return this.stringify().map
  }

  get messages() {
    return this.sync().messages
  }

  get opts() {
    return this.result.opts
  }

  get processor() {
    return this.result.processor
  }

  get root() {
    return this.sync().root
  }

  get [Symbol.toStringTag]() {
    return 'LazyResult'
  }

  constructor(processor, css, opts) {
    this.stringified = false;
    this.processed = false;

    let root;
    if (
      typeof css === 'object' &&
      css !== null &&
      (css.type === 'root' || css.type === 'document')
    ) {
      root = cleanMarks(css);
    } else if (css instanceof LazyResult || css instanceof Result$2) {
      root = cleanMarks(css.root);
      if (css.map) {
        if (typeof opts.map === 'undefined') opts.map = {};
        if (!opts.map.inline) opts.map.inline = false;
        opts.map.prev = css.map;
      }
    } else {
      let parser = parse$2;
      if (opts.syntax) parser = opts.syntax.parse;
      if (opts.parser) parser = opts.parser;
      if (parser.parse) parser = parser.parse;

      try {
        root = parser(css, opts);
      } catch (error) {
        this.processed = true;
        this.error = error;
      }

      if (root && !root[my]) {
        /* c8 ignore next 2 */
        Container$1.rebuild(root);
      }
    }

    this.result = new Result$2(processor, root, opts);
    this.helpers = { ...postcss$1, postcss: postcss$1, result: this.result };
    this.plugins = this.processor.plugins.map(plugin => {
      if (typeof plugin === 'object' && plugin.prepare) {
        return { ...plugin, ...plugin.prepare(this.result) }
      } else {
        return plugin
      }
    });
  }

  async() {
    if (this.error) return Promise.reject(this.error)
    if (this.processed) return Promise.resolve(this.result)
    if (!this.processing) {
      this.processing = this.runAsync();
    }
    return this.processing
  }

  catch(onRejected) {
    return this.async().catch(onRejected)
  }

  finally(onFinally) {
    return this.async().then(onFinally, onFinally)
  }

  getAsyncError() {
    throw new Error('Use process(css).then(cb) to work with async plugins')
  }

  handleError(error, node) {
    let plugin = this.result.lastPlugin;
    try {
      if (node) node.addToError(error);
      this.error = error;
      if (error.name === 'CssSyntaxError' && !error.plugin) {
        error.plugin = plugin.postcssPlugin;
        error.setMessage();
      } else if (plugin.postcssVersion) {
        if ("production" !== 'production') ;
      }
    } catch (err) {
      /* c8 ignore next 3 */
      // eslint-disable-next-line no-console
      if (console && console.error) console.error(err);
    }
    return error
  }

  prepareVisitors() {
    this.listeners = {};
    let add = (plugin, type, cb) => {
      if (!this.listeners[type]) this.listeners[type] = [];
      this.listeners[type].push([plugin, cb]);
    };
    for (let plugin of this.plugins) {
      if (typeof plugin === 'object') {
        for (let event in plugin) {
          if (!PLUGIN_PROPS[event] && /^[A-Z]/.test(event)) {
            throw new Error(
              `Unknown event ${event} in ${plugin.postcssPlugin}. ` +
                `Try to update PostCSS (${this.processor.version} now).`
            )
          }
          if (!NOT_VISITORS[event]) {
            if (typeof plugin[event] === 'object') {
              for (let filter in plugin[event]) {
                if (filter === '*') {
                  add(plugin, event, plugin[event][filter]);
                } else {
                  add(
                    plugin,
                    event + '-' + filter.toLowerCase(),
                    plugin[event][filter]
                  );
                }
              }
            } else if (typeof plugin[event] === 'function') {
              add(plugin, event, plugin[event]);
            }
          }
        }
      }
    }
    this.hasListener = Object.keys(this.listeners).length > 0;
  }

  async runAsync() {
    this.plugin = 0;
    for (let i = 0; i < this.plugins.length; i++) {
      let plugin = this.plugins[i];
      let promise = this.runOnRoot(plugin);
      if (isPromise(promise)) {
        try {
          await promise;
        } catch (error) {
          throw this.handleError(error)
        }
      }
    }

    this.prepareVisitors();
    if (this.hasListener) {
      let root = this.result.root;
      while (!root[isClean]) {
        root[isClean] = true;
        let stack = [toStack(root)];
        while (stack.length > 0) {
          let promise = this.visitTick(stack);
          if (isPromise(promise)) {
            try {
              await promise;
            } catch (e) {
              let node = stack[stack.length - 1].node;
              throw this.handleError(e, node)
            }
          }
        }
      }

      if (this.listeners.OnceExit) {
        for (let [plugin, visitor] of this.listeners.OnceExit) {
          this.result.lastPlugin = plugin;
          try {
            if (root.type === 'document') {
              let roots = root.nodes.map(subRoot =>
                visitor(subRoot, this.helpers)
              );

              await Promise.all(roots);
            } else {
              await visitor(root, this.helpers);
            }
          } catch (e) {
            throw this.handleError(e)
          }
        }
      }
    }

    this.processed = true;
    return this.stringify()
  }

  runOnRoot(plugin) {
    this.result.lastPlugin = plugin;
    try {
      if (typeof plugin === 'object' && plugin.Once) {
        if (this.result.root.type === 'document') {
          let roots = this.result.root.nodes.map(root =>
            plugin.Once(root, this.helpers)
          );

          if (isPromise(roots[0])) {
            return Promise.all(roots)
          }

          return roots
        }

        return plugin.Once(this.result.root, this.helpers)
      } else if (typeof plugin === 'function') {
        return plugin(this.result.root, this.result)
      }
    } catch (error) {
      throw this.handleError(error)
    }
  }

  stringify() {
    if (this.error) throw this.error
    if (this.stringified) return this.result
    this.stringified = true;

    this.sync();

    let opts = this.result.opts;
    let str = stringify$2;
    if (opts.syntax) str = opts.syntax.stringify;
    if (opts.stringifier) str = opts.stringifier;
    if (str.stringify) str = str.stringify;

    let map = new MapGenerator$1(str, this.result.root, this.result.opts);
    let data = map.generate();
    this.result.css = data[0];
    this.result.map = data[1];

    return this.result
  }

  sync() {
    if (this.error) throw this.error
    if (this.processed) return this.result
    this.processed = true;

    if (this.processing) {
      throw this.getAsyncError()
    }

    for (let plugin of this.plugins) {
      let promise = this.runOnRoot(plugin);
      if (isPromise(promise)) {
        throw this.getAsyncError()
      }
    }

    this.prepareVisitors();
    if (this.hasListener) {
      let root = this.result.root;
      while (!root[isClean]) {
        root[isClean] = true;
        this.walkSync(root);
      }
      if (this.listeners.OnceExit) {
        if (root.type === 'document') {
          for (let subRoot of root.nodes) {
            this.visitSync(this.listeners.OnceExit, subRoot);
          }
        } else {
          this.visitSync(this.listeners.OnceExit, root);
        }
      }
    }

    return this.result
  }

  then(onFulfilled, onRejected) {
    return this.async().then(onFulfilled, onRejected)
  }

  toString() {
    return this.css
  }

  visitSync(visitors, node) {
    for (let [plugin, visitor] of visitors) {
      this.result.lastPlugin = plugin;
      let promise;
      try {
        promise = visitor(node, this.helpers);
      } catch (e) {
        throw this.handleError(e, node.proxyOf)
      }
      if (node.type !== 'root' && node.type !== 'document' && !node.parent) {
        return true
      }
      if (isPromise(promise)) {
        throw this.getAsyncError()
      }
    }
  }

  visitTick(stack) {
    let visit = stack[stack.length - 1];
    let { node, visitors } = visit;

    if (node.type !== 'root' && node.type !== 'document' && !node.parent) {
      stack.pop();
      return
    }

    if (visitors.length > 0 && visit.visitorIndex < visitors.length) {
      let [plugin, visitor] = visitors[visit.visitorIndex];
      visit.visitorIndex += 1;
      if (visit.visitorIndex === visitors.length) {
        visit.visitors = [];
        visit.visitorIndex = 0;
      }
      this.result.lastPlugin = plugin;
      try {
        return visitor(node.toProxy(), this.helpers)
      } catch (e) {
        throw this.handleError(e, node)
      }
    }

    if (visit.iterator !== 0) {
      let iterator = visit.iterator;
      let child;
      while ((child = node.nodes[node.indexes[iterator]])) {
        node.indexes[iterator] += 1;
        if (!child[isClean]) {
          child[isClean] = true;
          stack.push(toStack(child));
          return
        }
      }
      visit.iterator = 0;
      delete node.indexes[iterator];
    }

    let events = visit.events;
    while (visit.eventIndex < events.length) {
      let event = events[visit.eventIndex];
      visit.eventIndex += 1;
      if (event === CHILDREN) {
        if (node.nodes && node.nodes.length) {
          node[isClean] = true;
          visit.iterator = node.getIterator();
        }
        return
      } else if (this.listeners[event]) {
        visit.visitors = this.listeners[event];
        return
      }
    }
    stack.pop();
  }

  walkSync(node) {
    node[isClean] = true;
    let events = getEvents(node);
    for (let event of events) {
      if (event === CHILDREN) {
        if (node.nodes) {
          node.each(child => {
            if (!child[isClean]) this.walkSync(child);
          });
        }
      } else {
        let visitors = this.listeners[event];
        if (visitors) {
          if (this.visitSync(visitors, node.toProxy())) return
        }
      }
    }
  }

  warnings() {
    return this.sync().warnings()
  }
};

LazyResult$2.registerPostcss = dependant => {
  postcss$1 = dependant;
};

var lazyResult = LazyResult$2;
LazyResult$2.default = LazyResult$2;

Root$2.registerLazyResult(LazyResult$2);
Document$2.registerLazyResult(LazyResult$2);

let MapGenerator = mapGenerator;
let parse$1 = parse_1;
const Result$1 = result;
let stringify$1 = stringify_1;

let NoWorkResult$1 = class NoWorkResult {
  get content() {
    return this.result.css
  }

  get css() {
    return this.result.css
  }

  get map() {
    return this.result.map
  }

  get messages() {
    return []
  }

  get opts() {
    return this.result.opts
  }

  get processor() {
    return this.result.processor
  }

  get root() {
    if (this._root) {
      return this._root
    }

    let root;
    let parser = parse$1;

    try {
      root = parser(this._css, this._opts);
    } catch (error) {
      this.error = error;
    }

    if (this.error) {
      throw this.error
    } else {
      this._root = root;
      return root
    }
  }

  get [Symbol.toStringTag]() {
    return 'NoWorkResult'
  }

  constructor(processor, css, opts) {
    css = css.toString();
    this.stringified = false;

    this._processor = processor;
    this._css = css;
    this._opts = opts;
    this._map = undefined;
    let root;

    let str = stringify$1;
    this.result = new Result$1(this._processor, root, this._opts);
    this.result.css = css;

    let self = this;
    Object.defineProperty(this.result, 'root', {
      get() {
        return self.root
      }
    });

    let map = new MapGenerator(str, root, this._opts, css);
    if (map.isMap()) {
      let [generatedCSS, generatedMap] = map.generate();
      if (generatedCSS) {
        this.result.css = generatedCSS;
      }
      if (generatedMap) {
        this.result.map = generatedMap;
      }
    } else {
      map.clearAnnotation();
      this.result.css = map.css;
    }
  }

  async() {
    if (this.error) return Promise.reject(this.error)
    return Promise.resolve(this.result)
  }

  catch(onRejected) {
    return this.async().catch(onRejected)
  }

  finally(onFinally) {
    return this.async().then(onFinally, onFinally)
  }

  sync() {
    if (this.error) throw this.error
    return this.result
  }

  then(onFulfilled, onRejected) {

    return this.async().then(onFulfilled, onRejected)
  }

  toString() {
    return this._css
  }

  warnings() {
    return []
  }
};

var noWorkResult = NoWorkResult$1;
NoWorkResult$1.default = NoWorkResult$1;

let Document$1 = document$1;
let LazyResult$1 = lazyResult;
let NoWorkResult = noWorkResult;
let Root$1 = root;

let Processor$1 = class Processor {
  constructor(plugins = []) {
    this.version = '8.5.6';
    this.plugins = this.normalize(plugins);
  }

  normalize(plugins) {
    let normalized = [];
    for (let i of plugins) {
      if (i.postcss === true) {
        i = i();
      } else if (i.postcss) {
        i = i.postcss;
      }

      if (typeof i === 'object' && Array.isArray(i.plugins)) {
        normalized = normalized.concat(i.plugins);
      } else if (typeof i === 'object' && i.postcssPlugin) {
        normalized.push(i);
      } else if (typeof i === 'function') {
        normalized.push(i);
      } else if (typeof i === 'object' && (i.parse || i.stringify)) ; else {
        throw new Error(i + ' is not a PostCSS plugin')
      }
    }
    return normalized
  }

  process(css, opts = {}) {
    if (
      !this.plugins.length &&
      !opts.parser &&
      !opts.stringifier &&
      !opts.syntax
    ) {
      return new NoWorkResult(this, css, opts)
    } else {
      return new LazyResult$1(this, css, opts)
    }
  }

  use(plugin) {
    this.plugins = this.plugins.concat(this.normalize([plugin]));
    return this
  }
};

var processor = Processor$1;
Processor$1.default = Processor$1;

Root$1.registerProcessor(Processor$1);
Document$1.registerProcessor(Processor$1);

let AtRule = atRule;
let Comment = comment;
let Container = container;
let CssSyntaxError = cssSyntaxError;
let Declaration = declaration;
let Document = document$1;
let fromJSON = fromJSON_1;
let Input = input;
let LazyResult = lazyResult;
let list = list_1;
let Node = node;
let parse = parse_1;
let Processor = processor;
let Result = result;
let Root = root;
let Rule = rule;
let stringify = stringify_1;
let Warning = warning;

function postcss(...plugins) {
  if (plugins.length === 1 && Array.isArray(plugins[0])) {
    plugins = plugins[0];
  }
  return new Processor(plugins)
}

postcss.plugin = function plugin(name, initializer) {
  let warningPrinted = false;
  function creator(...args) {
    // eslint-disable-next-line no-console
    if (console && console.warn && !warningPrinted) {
      warningPrinted = true;
      // eslint-disable-next-line no-console
      console.warn(
        name +
          ': postcss.plugin was deprecated. Migration guide:\n' +
          'https://evilmartians.com/chronicles/postcss-8-plugin-migration'
      );
      if (process.env.LANG && process.env.LANG.startsWith('cn')) {
        /* c8 ignore next 7 */
        // eslint-disable-next-line no-console
        console.warn(
          name +
            ': 里面 postcss.plugin 被弃用. 迁移指南:\n' +
            'https://www.w3ctech.com/topic/2226'
        );
      }
    }
    let transformer = initializer(...args);
    transformer.postcssPlugin = name;
    transformer.postcssVersion = new Processor().version;
    return transformer
  }

  let cache;
  Object.defineProperty(creator, 'postcss', {
    get() {
      if (!cache) cache = creator();
      return cache
    }
  });

  creator.process = function (css, processOpts, pluginOpts) {
    return postcss([creator(pluginOpts)]).process(css, processOpts)
  };

  return creator
};

postcss.stringify = stringify;
postcss.parse = parse;
postcss.fromJSON = fromJSON;
postcss.list = list;

postcss.comment = defaults => new Comment(defaults);
postcss.atRule = defaults => new AtRule(defaults);
postcss.decl = defaults => new Declaration(defaults);
postcss.rule = defaults => new Rule(defaults);
postcss.root = defaults => new Root(defaults);
postcss.document = defaults => new Document(defaults);

postcss.CssSyntaxError = CssSyntaxError;
postcss.Declaration = Declaration;
postcss.Container = Container;
postcss.Processor = Processor;
postcss.Document = Document;
postcss.Comment = Comment;
postcss.Warning = Warning;
postcss.AtRule = AtRule;
postcss.Result = Result;
postcss.Input = Input;
postcss.Rule = Rule;
postcss.Root = Root;
postcss.Node = Node;

LazyResult.registerPostcss(postcss);

var postcss_1 = postcss;
postcss.default = postcss;

const htmlparser = lib$5;
const escapeStringRegexp = escapeStringRegexp$1;
const { isPlainObject } = isPlainObject$2;
const deepmerge = cjs;
const parseSrcset = parseSrcsetExports;
const { parse: postcssParse } = postcss_1;
// Tags that can conceivably represent stand-alone media.
const mediaTags = [
  'img', 'audio', 'video', 'picture', 'svg',
  'object', 'map', 'iframe', 'embed'
];
// Tags that are inherently vulnerable to being used in XSS attacks.
const vulnerableTags = [ 'script', 'style' ];

function each(obj, cb) {
  if (obj) {
    Object.keys(obj).forEach(function (key) {
      cb(obj[key], key);
    });
  }
}

// Avoid false positives with .__proto__, .hasOwnProperty, etc.
function has(obj, key) {
  return ({}).hasOwnProperty.call(obj, key);
}

// Returns those elements of `a` for which `cb(a)` returns truthy
function filter(a, cb) {
  const n = [];
  each(a, function(v) {
    if (cb(v)) {
      n.push(v);
    }
  });
  return n;
}

function isEmptyObject(obj) {
  for (const key in obj) {
    if (has(obj, key)) {
      return false;
    }
  }
  return true;
}

function stringifySrcset(parsedSrcset) {
  return parsedSrcset.map(function(part) {
    if (!part.url) {
      throw new Error('URL missing');
    }

    return (
      part.url +
      (part.w ? ` ${part.w}w` : '') +
      (part.h ? ` ${part.h}h` : '') +
      (part.d ? ` ${part.d}x` : '')
    );
  }).join(', ');
}

var sanitizeHtml_1 = sanitizeHtml;

// A valid attribute name.
// We use a tolerant definition based on the set of strings defined by
// html.spec.whatwg.org/multipage/parsing.html#before-attribute-name-state
// and html.spec.whatwg.org/multipage/parsing.html#attribute-name-state .
// The characters accepted are ones which can be appended to the attribute
// name buffer without triggering a parse error:
//   * unexpected-equals-sign-before-attribute-name
//   * unexpected-null-character
//   * unexpected-character-in-attribute-name
// We exclude the empty string because it's impossible to get to the after
// attribute name state with an empty attribute name buffer.
const VALID_HTML_ATTRIBUTE_NAME = /^[^\0\t\n\f\r /<=>]+$/;

// Ignore the _recursing flag; it's there for recursive
// invocation as a guard against this exploit:
// https://github.com/fb55/htmlparser2/issues/105

function sanitizeHtml(html, options, _recursing) {
  if (html == null) {
    return '';
  }
  if (typeof html === 'number') {
    html = html.toString();
  }

  let result = '';
  // Used for hot swapping the result variable with an empty string
  // in order to "capture" the text written to it.
  let tempResult = '';

  function Frame(tag, attribs) {
    const that = this;
    this.tag = tag;
    this.attribs = attribs || {};
    this.tagPosition = result.length;
    this.text = ''; // Node inner text
    this.openingTagLength = 0;
    this.mediaChildren = [];

    this.updateParentNodeText = function() {
      if (stack.length) {
        const parentFrame = stack[stack.length - 1];
        parentFrame.text += that.text;
      }
    };

    this.updateParentNodeMediaChildren = function() {
      if (stack.length && mediaTags.includes(this.tag)) {
        const parentFrame = stack[stack.length - 1];
        parentFrame.mediaChildren.push(this.tag);
      }
    };
  }

  options = Object.assign({}, sanitizeHtml.defaults, options);
  options.parser = Object.assign({}, htmlParserDefaults, options.parser);

  const tagAllowed = function (name) {
    return options.allowedTags === false ||
      (options.allowedTags || []).indexOf(name) > -1;
  };

  // vulnerableTags
  vulnerableTags.forEach(function (tag) {
    if (tagAllowed(tag) && !options.allowVulnerableTags) {
      console.warn(`\n\n⚠️ Your \`allowedTags\` option includes, \`${tag}\`, which is inherently\nvulnerable to XSS attacks. Please remove it from \`allowedTags\`.\nOr, to disable this warning, add the \`allowVulnerableTags\` option\nand ensure you are accounting for this risk.\n\n`);
    }
  });

  // Tags that contain something other than HTML, or where discarding
  // the text when the tag is disallowed makes sense for other reasons.
  // If we are not allowing these tags, we should drop their content too.
  // For other tags you would drop the tag but keep its content.
  const nonTextTagsArray = options.nonTextTags || [
    'script',
    'style',
    'textarea',
    'option'
  ];
  let allowedAttributesMap;
  let allowedAttributesGlobMap;
  if (options.allowedAttributes) {
    allowedAttributesMap = {};
    allowedAttributesGlobMap = {};
    each(options.allowedAttributes, function(attributes, tag) {
      allowedAttributesMap[tag] = [];
      const globRegex = [];
      attributes.forEach(function(obj) {
        if (typeof obj === 'string' && obj.indexOf('*') >= 0) {
          globRegex.push(escapeStringRegexp(obj).replace(/\\\*/g, '.*'));
        } else {
          allowedAttributesMap[tag].push(obj);
        }
      });
      if (globRegex.length) {
        allowedAttributesGlobMap[tag] = new RegExp('^(' + globRegex.join('|') + ')$');
      }
    });
  }
  const allowedClassesMap = {};
  const allowedClassesGlobMap = {};
  const allowedClassesRegexMap = {};
  each(options.allowedClasses, function(classes, tag) {
    // Implicitly allows the class attribute
    if (allowedAttributesMap) {
      if (!has(allowedAttributesMap, tag)) {
        allowedAttributesMap[tag] = [];
      }
      allowedAttributesMap[tag].push('class');
    }

    allowedClassesMap[tag] = classes;

    if (Array.isArray(classes)) {
      const globRegex = [];
      allowedClassesMap[tag] = [];
      allowedClassesRegexMap[tag] = [];
      classes.forEach(function(obj) {
        if (typeof obj === 'string' && obj.indexOf('*') >= 0) {
          globRegex.push(escapeStringRegexp(obj).replace(/\\\*/g, '.*'));
        } else if (obj instanceof RegExp) {
          allowedClassesRegexMap[tag].push(obj);
        } else {
          allowedClassesMap[tag].push(obj);
        }
      });
      if (globRegex.length) {
        allowedClassesGlobMap[tag] = new RegExp('^(' + globRegex.join('|') + ')$');
      }
    }
  });

  const transformTagsMap = {};
  let transformTagsAll;
  each(options.transformTags, function(transform, tag) {
    let transFun;
    if (typeof transform === 'function') {
      transFun = transform;
    } else if (typeof transform === 'string') {
      transFun = sanitizeHtml.simpleTransform(transform);
    }
    if (tag === '*') {
      transformTagsAll = transFun;
    } else {
      transformTagsMap[tag] = transFun;
    }
  });

  let depth;
  let stack;
  let skipMap;
  let transformMap;
  let skipText;
  let skipTextDepth;
  let addedText = false;

  initializeState();

  const parser = new htmlparser.Parser({
    onopentag: function(name, attribs) {
      if (options.onOpenTag) {
        options.onOpenTag(name, attribs);
      }

      // If `enforceHtmlBoundary` is `true` and this has found the opening
      // `html` tag, reset the state.
      if (options.enforceHtmlBoundary && name === 'html') {
        initializeState();
      }

      if (skipText) {
        skipTextDepth++;
        return;
      }
      const frame = new Frame(name, attribs);
      stack.push(frame);

      let skip = false;
      const hasText = !!frame.text;
      let transformedTag;
      if (has(transformTagsMap, name)) {
        transformedTag = transformTagsMap[name](name, attribs);

        frame.attribs = attribs = transformedTag.attribs;

        if (transformedTag.text !== undefined) {
          frame.innerText = transformedTag.text;
        }

        if (name !== transformedTag.tagName) {
          frame.name = name = transformedTag.tagName;
          transformMap[depth] = transformedTag.tagName;
        }
      }
      if (transformTagsAll) {
        transformedTag = transformTagsAll(name, attribs);

        frame.attribs = attribs = transformedTag.attribs;
        if (name !== transformedTag.tagName) {
          frame.name = name = transformedTag.tagName;
          transformMap[depth] = transformedTag.tagName;
        }
      }

      if (!tagAllowed(name) || (options.disallowedTagsMode === 'recursiveEscape' && !isEmptyObject(skipMap)) || (options.nestingLimit != null && depth >= options.nestingLimit)) {
        skip = true;
        skipMap[depth] = true;
        if (options.disallowedTagsMode === 'discard' || options.disallowedTagsMode === 'completelyDiscard') {
          if (nonTextTagsArray.indexOf(name) !== -1) {
            skipText = true;
            skipTextDepth = 1;
          }
        }
      }
      depth++;
      if (skip) {
        if (options.disallowedTagsMode === 'discard' || options.disallowedTagsMode === 'completelyDiscard') {
          // We want the contents but not this tag
          if (frame.innerText && !hasText) {
            const escaped = escapeHtml(frame.innerText);
            if (options.textFilter) {
              result += options.textFilter(escaped, name);
            } else {
              result += escaped;
            }
            addedText = true;
          }
          return;
        }
        tempResult = result;
        result = '';
      }
      result += '<' + name;

      if (name === 'script') {
        if (options.allowedScriptHostnames || options.allowedScriptDomains) {
          frame.innerText = '';
        }
      }

      const isBeingEscaped = skip && (options.disallowedTagsMode === 'escape' || options.disallowedTagsMode === 'recursiveEscape');
      const shouldPreserveEscapedAttributes = isBeingEscaped &&
        options.preserveEscapedAttributes;

      if (shouldPreserveEscapedAttributes) {
        each(attribs, function(value, a) {
          result += ' ' + a + '="' + escapeHtml((value || ''), true) + '"';
        });
      } else if (!allowedAttributesMap || has(allowedAttributesMap, name) || allowedAttributesMap['*']) {
        each(attribs, function(value, a) {
          if (!VALID_HTML_ATTRIBUTE_NAME.test(a)) {
            // This prevents part of an attribute name in the output from being
            // interpreted as the end of an attribute, or end of a tag.
            delete frame.attribs[a];
            return;
          }
          // If the value is empty, check if the attribute is
          // in the allowedEmptyAttributes array.
          // If it is not in the allowedEmptyAttributes array,
          // and it is a known non-boolean attribute, delete it
          // List taken from https://html.spec.whatwg.org/multipage/indices.html#attributes-3
          if (value === '' && (!options.allowedEmptyAttributes.includes(a)) &&
            (options.nonBooleanAttributes.includes(a) || options.nonBooleanAttributes.includes('*'))) {
            delete frame.attribs[a];
            return;
          }
          // check allowedAttributesMap for the element and attribute and modify the value
          // as necessary if there are specific values defined.
          let passedAllowedAttributesMapCheck = false;
          if (!allowedAttributesMap ||
            (has(allowedAttributesMap, name) &&
              allowedAttributesMap[name].indexOf(a) !== -1) ||
            (allowedAttributesMap['*'] && allowedAttributesMap['*'].indexOf(a) !== -1) ||
            (has(allowedAttributesGlobMap, name) &&
              allowedAttributesGlobMap[name].test(a)) ||
            (allowedAttributesGlobMap['*'] && allowedAttributesGlobMap['*'].test(a))) {
            passedAllowedAttributesMapCheck = true;
          } else if (allowedAttributesMap && allowedAttributesMap[name]) {
            for (const o of allowedAttributesMap[name]) {
              if (isPlainObject(o) && o.name && (o.name === a)) {
                passedAllowedAttributesMapCheck = true;
                let newValue = '';
                if (o.multiple === true) {
                  // verify the values that are allowed
                  const splitStrArray = value.split(' ');
                  for (const s of splitStrArray) {
                    if (o.values.indexOf(s) !== -1) {
                      if (newValue === '') {
                        newValue = s;
                      } else {
                        newValue += ' ' + s;
                      }
                    }
                  }
                } else if (o.values.indexOf(value) >= 0) {
                  // verified an allowed value matches the entire attribute value
                  newValue = value;
                }
                value = newValue;
              }
            }
          }
          if (passedAllowedAttributesMapCheck) {
            if (options.allowedSchemesAppliedToAttributes.indexOf(a) !== -1) {
              if (naughtyHref(name, value)) {
                delete frame.attribs[a];
                return;
              }
            }

            if (name === 'script' && a === 'src') {

              let allowed = true;

              try {
                const parsed = parseUrl(value);

                if (options.allowedScriptHostnames || options.allowedScriptDomains) {
                  const allowedHostname = (options.allowedScriptHostnames || [])
                    .find(function (hostname) {
                      return hostname === parsed.url.hostname;
                    });
                  const allowedDomain = (options.allowedScriptDomains || [])
                    .find(function(domain) {
                      return parsed.url.hostname === domain || parsed.url.hostname.endsWith(`.${domain}`);
                    });
                  allowed = allowedHostname || allowedDomain;
                }
              } catch (e) {
                allowed = false;
              }

              if (!allowed) {
                delete frame.attribs[a];
                return;
              }
            }

            if (name === 'iframe' && a === 'src') {
              let allowed = true;
              try {
                const parsed = parseUrl(value);

                if (parsed.isRelativeUrl) {
                  // default value of allowIframeRelativeUrls is true
                  // unless allowedIframeHostnames or allowedIframeDomains specified
                  allowed = has(options, 'allowIframeRelativeUrls')
                    ? options.allowIframeRelativeUrls
                    : (!options.allowedIframeHostnames && !options.allowedIframeDomains);
                } else if (
                  options.allowedIframeHostnames ||
                  options.allowedIframeDomains
                ) {
                  const allowedHostname = (options.allowedIframeHostnames || [])
                    .find(function (hostname) {
                      return hostname === parsed.url.hostname;
                    });
                  const allowedDomain = (options.allowedIframeDomains || [])
                    .find(function(domain) {
                      return parsed.url.hostname === domain || parsed.url.hostname.endsWith(`.${domain}`);
                    });
                  allowed = allowedHostname || allowedDomain;
                }
              } catch (e) {
                // Unparseable iframe src
                allowed = false;
              }
              if (!allowed) {
                delete frame.attribs[a];
                return;
              }
            }
            if (a === 'srcset') {
              try {
                let parsed = parseSrcset(value);
                parsed.forEach(function(value) {
                  if (naughtyHref('srcset', value.url)) {
                    value.evil = true;
                  }
                });
                parsed = filter(parsed, function(v) {
                  return !v.evil;
                });
                if (!parsed.length) {
                  delete frame.attribs[a];
                  return;
                } else {
                  value = stringifySrcset(filter(parsed, function(v) {
                    return !v.evil;
                  }));
                  frame.attribs[a] = value;
                }
              } catch (e) {
                // Unparseable srcset
                delete frame.attribs[a];
                return;
              }
            }
            if (a === 'class') {
              const allowedSpecificClasses = allowedClassesMap[name];
              const allowedWildcardClasses = allowedClassesMap['*'];
              const allowedSpecificClassesGlob = allowedClassesGlobMap[name];
              const allowedSpecificClassesRegex = allowedClassesRegexMap[name];
              const allowedWildcardClassesRegex = allowedClassesRegexMap['*'];
              const allowedWildcardClassesGlob = allowedClassesGlobMap['*'];
              const allowedClassesGlobs = [
                allowedSpecificClassesGlob,
                allowedWildcardClassesGlob
              ]
                .concat(allowedSpecificClassesRegex, allowedWildcardClassesRegex)
                .filter(function (t) {
                  return t;
                });
              if (allowedSpecificClasses && allowedWildcardClasses) {
                value = filterClasses(
                  value,
                  deepmerge(allowedSpecificClasses, allowedWildcardClasses),
                  allowedClassesGlobs
                );
              } else {
                value = filterClasses(
                  value,
                  allowedSpecificClasses || allowedWildcardClasses,
                  allowedClassesGlobs
                );
              }
              if (!value.length) {
                delete frame.attribs[a];
                return;
              }
            }
            if (a === 'style') {
              if (options.parseStyleAttributes) {
                try {
                  const abstractSyntaxTree = postcssParse(name + ' {' + value + '}', { map: false });
                  const filteredAST = filterCss(
                    abstractSyntaxTree,
                    options.allowedStyles
                  );

                  value = stringifyStyleAttributes(filteredAST);

                  if (value.length === 0) {
                    delete frame.attribs[a];
                    return;
                  }
                } catch (e) {
                  if (typeof window !== 'undefined') {
                    console.warn('Failed to parse "' + name + ' {' + value + '}' + '", If you\'re running this in a browser, we recommend to disable style parsing: options.parseStyleAttributes: false, since this only works in a node environment due to a postcss dependency, More info: https://github.com/apostrophecms/sanitize-html/issues/547');
                  }
                  delete frame.attribs[a];
                  return;
                }
              } else if (options.allowedStyles) {
                throw new Error('allowedStyles option cannot be used together with parseStyleAttributes: false.');
              }
            }
            result += ' ' + a;
            if (value && value.length) {
              result += '="' + escapeHtml(value, true) + '"';
            } else if (options.allowedEmptyAttributes.includes(a)) {
              result += '=""';
            }
          } else {
            delete frame.attribs[a];
          }
        });
      }
      if (options.selfClosing.indexOf(name) !== -1) {
        result += ' />';
      } else {
        result += '>';
        if (frame.innerText && !hasText && !options.textFilter) {
          result += escapeHtml(frame.innerText);
          addedText = true;
        }
      }
      if (skip) {
        result = tempResult + escapeHtml(result);
        tempResult = '';
      }
      frame.openingTagLength = result.length - frame.tagPosition;
    },
    ontext: function(text) {
      if (skipText) {
        return;
      }
      const lastFrame = stack[stack.length - 1];
      let tag;

      if (lastFrame) {
        tag = lastFrame.tag;
        // If inner text was set by transform function then let's use it
        text = lastFrame.innerText !== undefined ? lastFrame.innerText : text;
      }

      if (options.disallowedTagsMode === 'completelyDiscard' && !tagAllowed(tag)) {
        text = '';
      } else if ((options.disallowedTagsMode === 'discard' || options.disallowedTagsMode === 'completelyDiscard') && ((tag === 'script') || (tag === 'style'))) {
        // htmlparser2 gives us these as-is. Escaping them ruins the content. Allowing
        // script tags is, by definition, game over for XSS protection, so if that's
        // your concern, don't allow them. The same is essentially true for style tags
        // which have their own collection of XSS vectors.
        result += text;
      } else if (!addedText) {
        const escaped = escapeHtml(text, false);
        if (options.textFilter) {
          result += options.textFilter(escaped, tag);
        } else {
          result += escaped;
        }
      }
      if (stack.length) {
        const frame = stack[stack.length - 1];
        frame.text += text;
      }
    },
    onclosetag: function(name, isImplied) {
      if (options.onCloseTag) {
        options.onCloseTag(name, isImplied);
      }

      if (skipText) {
        skipTextDepth--;
        if (!skipTextDepth) {
          skipText = false;
        } else {
          return;
        }
      }

      const frame = stack.pop();
      if (!frame) {
        // Do not crash on bad markup
        return;
      }

      if (frame.tag !== name) {
        // Another case of bad markup.
        // Push to stack, so that it will be used in future closing tags.
        stack.push(frame);
        return;
      }

      skipText = options.enforceHtmlBoundary ? name === 'html' : false;
      depth--;
      const skip = skipMap[depth];
      if (skip) {
        delete skipMap[depth];
        if (options.disallowedTagsMode === 'discard' || options.disallowedTagsMode === 'completelyDiscard') {
          frame.updateParentNodeText();
          return;
        }
        tempResult = result;
        result = '';
      }

      if (transformMap[depth]) {
        name = transformMap[depth];
        delete transformMap[depth];
      }

      if (options.exclusiveFilter) {
        const filterResult = options.exclusiveFilter(frame);
        if (filterResult === 'excludeTag') {
          if (skip) {
            // no longer escaping the tag since it's not added at all
            result = tempResult;
            tempResult = '';
          }
          // remove the opening tag from the result
          result = result.substring(0, frame.tagPosition) +
            result.substring(frame.tagPosition + frame.openingTagLength);
          return;
        } else if (filterResult) {
          result = result.substring(0, frame.tagPosition);
          return;
        }
      }

      frame.updateParentNodeMediaChildren();
      frame.updateParentNodeText();

      if (
        // Already output />
        options.selfClosing.indexOf(name) !== -1 ||
        // Escaped tag, closing tag is implied
        (isImplied && !tagAllowed(name) && [ 'escape', 'recursiveEscape' ].indexOf(options.disallowedTagsMode) >= 0)
      ) {
        if (skip) {
          result = tempResult;
          tempResult = '';
        }
        return;
      }

      result += '</' + name + '>';
      if (skip) {
        result = tempResult + escapeHtml(result);
        tempResult = '';
      }
      addedText = false;
    }
  }, options.parser);
  parser.write(html);
  parser.end();

  if (options.disallowedTagsMode === 'escape' || options.disallowedTagsMode === 'recursiveEscape') {
    const lastParsedIndex = parser.endIndex;
    if (lastParsedIndex != null && lastParsedIndex >= 0 && lastParsedIndex < html.length) {
      const unparsed = html.substring(lastParsedIndex);
      result += escapeHtml(unparsed);
    } else if ((lastParsedIndex == null || lastParsedIndex < 0) && html.length > 0 && result === '') {
      result = escapeHtml(html);
    }
  }

  return result;

  function initializeState() {
    result = '';
    depth = 0;
    stack = [];
    skipMap = {};
    transformMap = {};
    skipText = false;
    skipTextDepth = 0;
  }

  function escapeHtml(s, quote) {
    if (typeof (s) !== 'string') {
      s = s + '';
    }
    if (options.parser.decodeEntities) {
      s = s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      if (quote) {
        s = s.replace(/"/g, '&quot;');
      }
    }
    // TODO: this is inadequate because it will pass `&0;`. This approach
    // will not work, each & must be considered with regard to whether it
    // is followed by a 100% syntactically valid entity or not, and escaped
    // if it is not. If this bothers you, don't set parser.decodeEntities
    // to false. (The default is true.)
    s = s.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, '&amp;') // Match ampersands not part of existing HTML entity
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
    if (quote) {
      s = s.replace(/"/g, '&quot;');
    }
    return s;
  }

  function naughtyHref(name, href) {
    // Browsers ignore character codes of 32 (space) and below in a surprising
    // number of situations. Start reading here:
    // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet#Embedded_tab
    // eslint-disable-next-line no-control-regex
    href = href.replace(/[\x00-\x20]+/g, '');
    // Clobber any comments in URLs, which the browser might
    // interpret inside an XML data island, allowing
    // a javascript: URL to be snuck through
    while (true) {
      const firstIndex = href.indexOf('<!--');
      if (firstIndex === -1) {
        break;
      }
      const lastIndex = href.indexOf('-->', firstIndex + 4);
      if (lastIndex === -1) {
        break;
      }
      href = href.substring(0, firstIndex) + href.substring(lastIndex + 3);
    }
    // Case insensitive so we don't get faked out by JAVASCRIPT #1
    // Allow more characters after the first so we don't get faked
    // out by certain schemes browsers accept
    const matches = href.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);
    if (!matches) {
      // Protocol-relative URL starting with any combination of '/' and '\'
      if (href.match(/^[/\\]{2}/)) {
        return !options.allowProtocolRelative;
      }

      // No scheme
      return false;
    }
    const scheme = matches[1].toLowerCase();

    if (has(options.allowedSchemesByTag, name)) {
      return options.allowedSchemesByTag[name].indexOf(scheme) === -1;
    }

    return !options.allowedSchemes || options.allowedSchemes.indexOf(scheme) === -1;
  }

  function parseUrl(value) {
    value = value.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, '$1//');
    if (value.startsWith('relative:')) {
      // An attempt to exploit our workaround for base URLs being
      // mandatory for relative URL validation in the WHATWG
      // URL parser, reject it
      throw new Error('relative: exploit attempt');
    }
    // naughtyHref is in charge of whether protocol relative URLs
    // are cool. Here we are concerned just with allowed hostnames and
    // whether to allow relative URLs.
    //
    // Build a placeholder "base URL" against which any reasonable
    // relative URL may be parsed successfully
    let base = 'relative://relative-site';
    for (let i = 0; (i < 100); i++) {
      base += `/${i}`;
    }

    const parsed = new URL(value, base);

    const isRelativeUrl = parsed && parsed.hostname === 'relative-site' && parsed.protocol === 'relative:';
    return {
      isRelativeUrl,
      url: parsed
    };
  }
  /**
   * Filters user input css properties by allowlisted regex attributes.
   * Modifies the abstractSyntaxTree object.
   *
   * @param {object} abstractSyntaxTree  - Object representation of CSS attributes.
   * @property {array[Declaration]} abstractSyntaxTree.nodes[0] -
   * Each object contains prop and value key, i.e { prop: 'color', value: 'red' }.
   * @param {object} allowedStyles       - Keys are properties (i.e color),
   * value is list of permitted regex rules (i.e /green/i).
   * @return {object}                    - The modified tree.
   */
  function filterCss(abstractSyntaxTree, allowedStyles) {
    if (!allowedStyles) {
      return abstractSyntaxTree;
    }

    const astRules = abstractSyntaxTree.nodes[0];
    let selectedRule;

    // Merge global and tag-specific styles into new AST.
    if (allowedStyles[astRules.selector] && allowedStyles['*']) {
      selectedRule = deepmerge(
        allowedStyles[astRules.selector],
        allowedStyles['*']
      );
    } else {
      selectedRule = allowedStyles[astRules.selector] || allowedStyles['*'];
    }

    if (selectedRule) {
      abstractSyntaxTree.nodes[0].nodes = astRules.nodes
        .reduce(filterDeclarations(selectedRule), []);
    }

    return abstractSyntaxTree;
  }

  /**
   * Extracts the style attributes from an AbstractSyntaxTree and formats those
   * values in the inline style attribute format.
   *
   * @param  {AbstractSyntaxTree} filteredAST
   * @return {string}             - Example:
   * "color:yellow;text-align:center !important;font-family:helvetica;"
   */
  function stringifyStyleAttributes(filteredAST) {
    return filteredAST.nodes[0].nodes
      .reduce(function(extractedAttributes, attrObject) {
        extractedAttributes.push(
          `${attrObject.prop}:${attrObject.value}${attrObject.important ? ' !important' : ''}`
        );
        return extractedAttributes;
      }, [])
      .join(';');
  }

  /**
    * Filters the existing attributes for the given property. Discards any attributes
    * which don't match the allowlist.
    *
    * @param  {object} selectedRule - Example: { color: red, font-family: helvetica }
    * @param  {array} allowedDeclarationsList - List of declarations
    * which pass the allowlist.
    * @param  {object} attributeObject - Object representing the current css property.
    * @property {string} attributeObject.type - Typically 'declaration'.
    * @property {string} attributeObject.prop - The CSS property, i.e 'color'.
    * @property {string} attributeObject.value - The corresponding value to
    * the css property, i.e 'red'.
    * @return {function} - When used in Array.reduce,
    * will return an array of Declaration objects
    */
  function filterDeclarations(selectedRule) {
    return function (allowedDeclarationsList, attributeObject) {
      // If this property is allowlisted...
      if (has(selectedRule, attributeObject.prop)) {
        const matchesRegex = selectedRule[attributeObject.prop]
          .some(function(regularExpression) {
            return regularExpression.test(attributeObject.value);
          });

        if (matchesRegex) {
          allowedDeclarationsList.push(attributeObject);
        }
      }
      return allowedDeclarationsList;
    };
  }

  function filterClasses(classes, allowed, allowedGlobs) {
    if (!allowed) {
      // The class attribute is allowed without filtering on this tag
      return classes;
    }
    classes = classes.split(/\s+/);
    return classes.filter(function(clss) {
      return allowed.indexOf(clss) !== -1 || allowedGlobs.some(function(glob) {
        return glob.test(clss);
      });
    }).join(' ');
  }
}

// Defaults are accessible to you so that you can use them as a starting point
// programmatically if you wish

const htmlParserDefaults = {
  decodeEntities: true
};
sanitizeHtml.defaults = {
  allowedTags: [
    // Sections derived from MDN element categories and limited to the more
    // benign categories.
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
    // Content sectioning
    'address', 'article', 'aside', 'footer', 'header',
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'hgroup',
    'main', 'nav', 'section',
    // Text content
    'blockquote', 'dd', 'div', 'dl', 'dt', 'figcaption', 'figure',
    'hr', 'li', 'menu', 'ol', 'p', 'pre', 'ul',
    // Inline text semantics
    'a', 'abbr', 'b', 'bdi', 'bdo', 'br', 'cite', 'code', 'data', 'dfn',
    'em', 'i', 'kbd', 'mark', 'q',
    'rb', 'rp', 'rt', 'rtc', 'ruby',
    's', 'samp', 'small', 'span', 'strong', 'sub', 'sup', 'time', 'u', 'var', 'wbr',
    // Table content
    'caption', 'col', 'colgroup', 'table', 'tbody', 'td', 'tfoot', 'th',
    'thead', 'tr'
  ],
  // Tags that cannot be boolean
  nonBooleanAttributes: [
    'abbr', 'accept', 'accept-charset', 'accesskey', 'action',
    'allow', 'alt', 'as', 'autocapitalize', 'autocomplete',
    'blocking', 'charset', 'cite', 'class', 'color', 'cols',
    'colspan', 'content', 'contenteditable', 'coords', 'crossorigin',
    'data', 'datetime', 'decoding', 'dir', 'dirname', 'download',
    'draggable', 'enctype', 'enterkeyhint', 'fetchpriority', 'for',
    'form', 'formaction', 'formenctype', 'formmethod', 'formtarget',
    'headers', 'height', 'hidden', 'high', 'href', 'hreflang',
    'http-equiv', 'id', 'imagesizes', 'imagesrcset', 'inputmode',
    'integrity', 'is', 'itemid', 'itemprop', 'itemref', 'itemtype',
    'kind', 'label', 'lang', 'list', 'loading', 'low', 'max',
    'maxlength', 'media', 'method', 'min', 'minlength', 'name',
    'nonce', 'optimum', 'pattern', 'ping', 'placeholder', 'popover',
    'popovertarget', 'popovertargetaction', 'poster', 'preload',
    'referrerpolicy', 'rel', 'rows', 'rowspan', 'sandbox', 'scope',
    'shape', 'size', 'sizes', 'slot', 'span', 'spellcheck', 'src',
    'srcdoc', 'srclang', 'srcset', 'start', 'step', 'style',
    'tabindex', 'target', 'title', 'translate', 'type', 'usemap',
    'value', 'width', 'wrap',
    // Event handlers
    'onauxclick', 'onafterprint', 'onbeforematch', 'onbeforeprint',
    'onbeforeunload', 'onbeforetoggle', 'onblur', 'oncancel',
    'oncanplay', 'oncanplaythrough', 'onchange', 'onclick', 'onclose',
    'oncontextlost', 'oncontextmenu', 'oncontextrestored', 'oncopy',
    'oncuechange', 'oncut', 'ondblclick', 'ondrag', 'ondragend',
    'ondragenter', 'ondragleave', 'ondragover', 'ondragstart',
    'ondrop', 'ondurationchange', 'onemptied', 'onended',
    'onerror', 'onfocus', 'onformdata', 'onhashchange', 'oninput',
    'oninvalid', 'onkeydown', 'onkeypress', 'onkeyup',
    'onlanguagechange', 'onload', 'onloadeddata', 'onloadedmetadata',
    'onloadstart', 'onmessage', 'onmessageerror', 'onmousedown',
    'onmouseenter', 'onmouseleave', 'onmousemove', 'onmouseout',
    'onmouseover', 'onmouseup', 'onoffline', 'ononline', 'onpagehide',
    'onpageshow', 'onpaste', 'onpause', 'onplay', 'onplaying',
    'onpopstate', 'onprogress', 'onratechange', 'onreset', 'onresize',
    'onrejectionhandled', 'onscroll', 'onscrollend',
    'onsecuritypolicyviolation', 'onseeked', 'onseeking', 'onselect',
    'onslotchange', 'onstalled', 'onstorage', 'onsubmit', 'onsuspend',
    'ontimeupdate', 'ontoggle', 'onunhandledrejection', 'onunload',
    'onvolumechange', 'onwaiting', 'onwheel'
  ],
  disallowedTagsMode: 'discard',
  allowedAttributes: {
    a: [ 'href', 'name', 'target' ],
    // We don't currently allow img itself by default, but
    // these attributes would make sense if we did.
    img: [ 'src', 'srcset', 'alt', 'title', 'width', 'height', 'loading' ]
  },
  allowedEmptyAttributes: [
    'alt'
  ],
  // Lots of these won't come up by default because we don't allow them
  selfClosing: [ 'img', 'br', 'hr', 'area', 'base', 'basefont', 'input', 'link', 'meta' ],
  // URL schemes we permit
  allowedSchemes: [ 'http', 'https', 'ftp', 'mailto', 'tel' ],
  allowedSchemesByTag: {},
  allowedSchemesAppliedToAttributes: [ 'href', 'src', 'cite' ],
  allowProtocolRelative: true,
  enforceHtmlBoundary: false,
  parseStyleAttributes: true,
  preserveEscapedAttributes: false
};

sanitizeHtml.simpleTransform = function(newTagName, newAttribs, merge) {
  merge = (merge === undefined) ? true : merge;
  newAttribs = newAttribs || {};

  return function(tagName, attribs) {
    let attrib;
    if (merge) {
      for (attrib in newAttribs) {
        attribs[attrib] = newAttribs[attrib];
      }
    } else {
      attribs = newAttribs;
    }

    return {
      tagName: newTagName,
      attribs
    };
  };
};

var sanitizeHtml$1 = /*@__PURE__*/getDefaultExportFromCjs(sanitizeHtml_1);

// View component - handles the actual rendering
function SafeSpanView(props) {
  const {
    html,
    placeholder,
    ...restProps
  } = props;
  const {
    styleProps,
    htmlProps
  } = useBaseProps(restProps);
  // Mark as QwickApp component
  Object.assign(SafeSpanView, {
    [QWICKAPP_COMPONENT]: true
  });
  // Enhanced HTML sanitization with strict security configuration
  const sanitizeOptions = {
    allowedTags: ['p', 'br', 'strong', 'em', 'u', 'span', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'ol', 'li', 'blockquote', 'pre', 'code', 'a', 'img', 'hr', 'table', 'thead', 'tbody', 'tr', 'th', 'td'],
    allowedAttributes: {
      'a': ['href', 'title', 'target'],
      'img': ['src', 'alt', 'title', 'width', 'height'],
      'span': ['style', 'class'],
      'div': ['style', 'class'],
      'p': ['style', 'class']
    },
    allowedSchemes: ['http', 'https', 'mailto'],
    disallowedTagsMode: 'discard',
    allowedSchemesByTag: {
      'a': ['http', 'https', 'mailto'],
      'img': ['http', 'https']
    },
    transformTags: {
      'a': function (tagName, attribs) {
        // Add security attributes to external links
        if (attribs.href && (attribs.href.startsWith('http://') || attribs.href.startsWith('https://'))) {
          return {
            tagName: 'a',
            attribs: {
              ...attribs,
              rel: 'noopener noreferrer',
              target: '_blank'
            }
          };
        }
        return {
          tagName,
          attribs
        };
      }
    }
  };
  const sanitizedHtml = html ? sanitizeHtml$1(html, sanitizeOptions) : '';
  // If no content and no placeholder, return null
  if (!sanitizedHtml && !placeholder) {
    return null;
  }
  // If no content but has placeholder, render placeholder as plain text
  if (!sanitizedHtml && placeholder) {
    return jsx("span", {
      ...htmlProps,
      ...styleProps,
      children: placeholder
    });
  }
  // Render sanitized HTML content
  // Use div instead of span to allow block-level elements like <hr>, <table>, etc.
  // This prevents React error #137 (invalid element nesting) when HTML contains
  // block elements from markdown (e.g., --- becomes <hr>)
  return jsx("div", {
    ...htmlProps,
    ...styleProps,
    dangerouslySetInnerHTML: {
      __html: sanitizedHtml
    }
  });
}
// Main component with data binding support and serialization capability
class SafeSpan extends ModelView {
  // Component-specific serialization properties
  getComponentSpecificProps() {
    return {
      html: this.props.html,
      placeholder: this.props.placeholder
    };
  }
  // SafeSpan component renders traditional props view
  renderView() {
    const {
      ...restProps
    } = this.props;
    return jsx(SafeSpanView, {
      ...restProps
    });
  }
  // SafeSpan component renders data-bound view
  renderWithDataBinding() {
    return jsx(SafeSpanWithDataBinding, {
      ...this.props
    });
  }
  // Register HTML patterns that SafeSpan component can handle
  static registerPatternHandlers(registry) {
    const typedRegistry = registry;
    // Register span elements with specific classes or attributes
    if (typedRegistry.hasPattern && !typedRegistry.hasPattern('span.safe-content')) {
      typedRegistry.registerPattern?.('span.safe-content', SafeSpan.transformSafeSpan);
    }
    // Register span elements with data-safe attribute
    if (typedRegistry.hasPattern && !typedRegistry.hasPattern('span[data-safe]')) {
      typedRegistry.registerPattern?.('span[data-safe]', SafeSpan.transformSafeSpan);
    }
  }
  // Transform span elements to SafeSpan component
  static transformSafeSpan(element) {
    const placeholder = element.getAttribute('data-placeholder');
    return {
      tagName: 'SafeSpan',
      props: {
        html: element.innerHTML,
        placeholder: placeholder || undefined
      }
    };
  }
}
// Component self-declaration for serialization
SafeSpan.tagName = 'SafeSpan';
SafeSpan.version = '1.0.0';
// Helper component to handle data binding with hooks (since we can't use hooks in class components)
function SafeSpanWithDataBinding(props) {
  const {
    dataSource,
    bindingOptions,
    ...restProps
  } = props;
  // Use data binding
  const {
    loading,
    error,
    ...safeSpanProps
  } = useDataBinding(dataSource, restProps);
  // Show loading state
  if (loading) {
    return jsx("span", {
      children: "Loading..."
    });
  }
  if (error) {
    console.error('Error loading safe span:', error);
    return null;
  }
  return jsx(SafeSpanView, {
    ...safeSpanProps
  });
}

const BoldIcon = FormatBold;
const ItalicIcon = FormatItalic;
const UnderlineIcon = FormatUnderlined;
const CodeIcon = Code$1;
const PreviewIcon$1 = Visibility;
const EditIcon = VisibilityOff;
const HelpIcon = Help;
// View component - handles the actual rendering
function HtmlInputFieldView({
  label,
  value = '',
  onChange,
  onFocus,
  required = false,
  disabled = false,
  error,
  helperText,
  placeholder,
  rows = 4,
  maxLength,
  showPreview = true,
  showHelp = false,
  ...restProps
}) {
  const [previewMode, setPreviewMode] = useState(false);
  const [showHelpText, setShowHelpText] = useState(false);
  const handleChange = event => {
    onChange?.(event.target.value);
  };
  const insertTag = (tag, hasClosing = true) => {
    if (disabled) return;
    const textarea = document.activeElement;
    if (!textarea || textarea.tagName !== 'TEXTAREA') return;
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const selectedText = value.substring(start, end);
    let insertText = '';
    if (hasClosing) {
      insertText = `<${tag}>${selectedText}</${tag}>`;
    } else {
      insertText = `<${tag}>`;
    }
    const newValue = value.substring(0, start) + insertText + value.substring(end);
    onChange?.(newValue);
    // Set cursor position after insertion
    setTimeout(() => {
      if (hasClosing && !selectedText) {
        const newPos = start + tag.length + 2;
        textarea.setSelectionRange(newPos, newPos);
      }
    }, 0);
  };
  const sanitizedHtml = sanitizeHtml$1(value || '', {
    allowedTags: ['b', 'i', 'u', 'strong', 'em', 'p', 'br', 'code', 'pre', 'span', 'div'],
    allowedAttributes: {
      '*': ['style', 'class']
    }
  });
  return jsxs(Box, {
    ...restProps,
    children: [jsxs(Box, {
      sx: {
        display: 'flex',
        alignItems: 'center',
        mb: 1,
        flexWrap: 'wrap',
        gap: 1
      },
      children: [jsxs(Typography, {
        variant: "body2",
        color: "text.secondary",
        children: [label, required && jsx("span", {
          style: {
            color: 'error.main'
          },
          children: " *"
        })]
      }), jsx(Box, {
        sx: {
          flexGrow: 1
        }
      }), jsxs(ButtonGroup, {
        size: "small",
        disabled: disabled || previewMode,
        children: [jsx(Tooltip, {
          title: "Bold",
          children: jsx(IconButton, {
            onClick: () => insertTag('b'),
            children: jsx(BoldIcon, {})
          })
        }), jsx(Tooltip, {
          title: "Italic",
          children: jsx(IconButton, {
            onClick: () => insertTag('i'),
            children: jsx(ItalicIcon, {})
          })
        }), jsx(Tooltip, {
          title: "Underline",
          children: jsx(IconButton, {
            onClick: () => insertTag('u'),
            children: jsx(UnderlineIcon, {})
          })
        }), jsx(Tooltip, {
          title: "Code",
          children: jsx(IconButton, {
            onClick: () => insertTag('code'),
            children: jsx(CodeIcon, {})
          })
        })]
      }), showPreview && jsx(Tooltip, {
        title: previewMode ? "Edit Mode" : "Preview Mode",
        children: jsx(IconButton, {
          onClick: () => setPreviewMode(!previewMode),
          disabled: disabled,
          children: previewMode ? jsx(EditIcon, {}) : jsx(PreviewIcon$1, {})
        })
      }), showHelp && jsx(Tooltip, {
        title: "HTML Help",
        children: jsx(IconButton, {
          onClick: () => setShowHelpText(!showHelpText),
          children: jsx(HelpIcon, {})
        })
      })]
    }), jsx(Collapse, {
      in: showHelpText,
      children: jsx(Alert, {
        severity: "info",
        sx: {
          mb: 2
        },
        children: jsx(Typography, {
          variant: "body2",
          children: "Supported HTML tags: <b>, <i>, <u>, <strong>, <em>, <p>, <br>, <code>, <pre>"
        })
      })
    }), previewMode ? jsx(Box, {
      sx: {
        border: 1,
        borderColor: 'divider',
        borderRadius: 1,
        p: 2,
        minHeight: rows * 24,
        backgroundColor: 'background.paper'
      },
      children: jsx(SafeSpan, {
        html: sanitizedHtml,
        placeholder: "No content to preview"
      })
    }) : jsx(TextField$1, {
      fullWidth: true,
      multiline: true,
      rows: rows,
      value: value,
      onChange: handleChange,
      onFocus: onFocus,
      placeholder: placeholder,
      disabled: disabled,
      error: !!error,
      helperText: error || helperText || (maxLength ? `${value.length}/${maxLength}` : undefined),
      inputProps: {
        maxLength
      },
      sx: {
        '& .MuiInputBase-input': {
          fontFamily: 'monospace',
          fontSize: '0.875rem'
        }
      }
    })]
  });
}
// Create the serializable HtmlInputField component using the factory
const HtmlInputField = createSerializableView({
  tagName: 'HtmlInputField',
  version: '1.0.0',
  role: 'view',
  View: HtmlInputFieldView
  // HtmlInputField component uses default react-children strategy
});

const AddIcon = Add;
// View component - handles the actual rendering
function ChoiceInputFieldView({
  label = 'Options',
  options = [],
  onOptionChange,
  onAddOption,
  onChoiceFieldFocus,
  disabled = false,
  placeholder = 'Enter option text. HTML formatting supported.',
  optionLabelPrefix = 'Option',
  rows = 2,
  maxOptions = 10,
  ...restProps
}) {
  const handleOptionChange = optionIndex => value => {
    onOptionChange?.(optionIndex, value);
  };
  const handleOptionFocus = optionIndex => () => {
    onChoiceFieldFocus?.(optionIndex);
  };
  const handleAddOption = () => {
    if (options.length < maxOptions) {
      onAddOption?.();
    }
  };
  return jsxs(Box, {
    ...restProps,
    children: [jsx(Typography, {
      variant: "h6",
      gutterBottom: true,
      children: label
    }), options.length === 0 && jsx(Alert, {
      severity: "info",
      sx: {
        mb: 2
      },
      children: "No options added yet. Click \"Add Option\" to get started."
    }), options.map((optionValue, index) => jsx(Box, {
      sx: {
        mb: 2
      },
      children: jsx(HtmlInputField, {
        label: `${optionLabelPrefix} ${index + 1}`,
        value: optionValue,
        onChange: handleOptionChange(index),
        onFocus: handleOptionFocus(index),
        placeholder: placeholder,
        rows: rows,
        disabled: disabled,
        showPreview: true,
        showHelp: false
      })
    }, index)), options.length < maxOptions && jsx(Button$1, {
      variant: "outlined",
      startIcon: jsx(AddIcon, {}),
      onClick: handleAddOption,
      disabled: disabled,
      sx: {
        mt: 1
      },
      children: "Add Option"
    }), options.length >= maxOptions && jsxs(Typography, {
      variant: "caption",
      color: "text.secondary",
      sx: {
        display: 'block',
        mt: 1
      },
      children: ["Maximum number of options (", maxOptions, ") reached."]
    })]
  });
}
// Create the serializable ChoiceInputField component using the factory
const ChoiceInputField = createSerializableView({
  tagName: 'ChoiceInputField',
  version: '1.0.0',
  role: 'view',
  View: ChoiceInputFieldView
  // ChoiceInputField component uses default react-children strategy
});

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/**
 * ViewSchema - Comprehensive base class for all view components
 *
 * Provides ALL props from BaseComponentProps as schema fields including:
 * - Grid layout props (span, breakpoints)
 * - Dimension props (width, height with t-shirt sizing)
 * - Spacing props (padding, margin with t-shirt sizing)
 * - Background and styling props
 * - Accessibility and HTML attributes
 * - Event handlers
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
let ViewSchema = class ViewSchema extends Model {};
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Grid Span',
  description: 'Column span for grid layouts (number, auto, or grow)'
}), IsOptional(), ValidateIf((_, v) => typeof v === 'string'), IsIn(['auto', 'grow']), ValidateIf((_, v) => typeof v === 'number'), IsInt(), Min(1), __metadata("design:type", Object)], ViewSchema.prototype, "span", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Extra Small Breakpoint (xs)',
  description: 'Column span for extra small screens'
}), IsOptional(), ValidateIf((_, v) => typeof v === 'string'), IsIn(['auto']), ValidateIf((_, v) => typeof v === 'number'), IsInt(), Min(1), __metadata("design:type", Object)], ViewSchema.prototype, "xs", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Small Breakpoint (sm)',
  description: 'Column span for small screens'
}), IsOptional(), ValidateIf((_, v) => typeof v === 'string'), IsIn(['auto']), ValidateIf((_, v) => typeof v === 'number'), IsInt(), Min(1), __metadata("design:type", Object)], ViewSchema.prototype, "sm", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Medium Breakpoint (md)',
  description: 'Column span for medium screens'
}), IsOptional(), ValidateIf((_, v) => typeof v === 'string'), IsIn(['auto']), ValidateIf((_, v) => typeof v === 'number'), IsInt(), Min(1), __metadata("design:type", Object)], ViewSchema.prototype, "md", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Large Breakpoint (lg)',
  description: 'Column span for large screens'
}), IsOptional(), ValidateIf((_, v) => typeof v === 'string'), IsIn(['auto']), ValidateIf((_, v) => typeof v === 'number'), IsInt(), Min(1), __metadata("design:type", Object)], ViewSchema.prototype, "lg", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Extra Large Breakpoint (xl)',
  description: 'Column span for extra large screens'
}), IsOptional(), ValidateIf((_, v) => typeof v === 'string'), IsIn(['auto']), ValidateIf((_, v) => typeof v === 'number'), IsInt(), Min(1), __metadata("design:type", Object)], ViewSchema.prototype, "xl", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'CSS Class Name',
  description: 'Additional CSS class name for custom styling',
  placeholder: 'custom-class-name'
}), IsOptional(), IsString(), __metadata("design:type", String)], ViewSchema.prototype, "className", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXTAREA,
  label: 'MUI SX Props',
  description: 'MUI sx prop as JSON string for advanced styling',
  placeholder: '{"color": "primary.main", "fontWeight": "bold"}'
}), IsOptional(), IsString(), __metadata("design:type", Object)], ViewSchema.prototype, "sx", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXTAREA,
  label: 'Inline Styles',
  description: 'Inline CSS styles as JSON string',
  placeholder: '{"color": "red", "margin": "10px"}'
}), IsOptional(), IsString(), __metadata("design:type", Object)], ViewSchema.prototype, "style", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Width',
  description: 'Component width (t-shirt sizes, breakpoints, CSS values, or numbers)',
  placeholder: 'medium, 300px, 50%, auto, grow'
}), IsOptional(), IsString(), __metadata("design:type", Object)], ViewSchema.prototype, "width", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Height',
  description: 'Component height (t-shirt sizes, CSS values, or numbers)',
  placeholder: 'medium, 200px, 50vh, auto'
}), IsOptional(), IsString(), __metadata("design:type", Object)], ViewSchema.prototype, "height", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Minimum Width',
  description: 'Minimum width constraint',
  placeholder: 'small, 100px, auto'
}), IsOptional(), IsString(), __metadata("design:type", Object)], ViewSchema.prototype, "minWidth", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Minimum Height',
  description: 'Minimum height constraint',
  placeholder: 'small, 100px, auto'
}), IsOptional(), IsString(), __metadata("design:type", Object)], ViewSchema.prototype, "minHeight", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Maximum Width',
  description: 'Maximum width constraint',
  placeholder: 'large, lg, 1200px'
}), IsOptional(), IsString(), __metadata("design:type", Object)], ViewSchema.prototype, "maxWidth", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Maximum Height',
  description: 'Maximum height constraint',
  placeholder: 'large, 500px, 80vh'
}), IsOptional(), IsString(), __metadata("design:type", Object)], ViewSchema.prototype, "maxHeight", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Padding',
  description: 'Internal spacing for all sides'
}), IsOptional(), IsString(), IsIn(['none', 'tiny', 'small', 'medium', 'large', 'huge']), __metadata("design:type", Object)], ViewSchema.prototype, "padding", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Padding Top',
  description: 'Internal spacing for top side'
}), IsOptional(), IsString(), IsIn(['none', 'tiny', 'small', 'medium', 'large', 'huge']), __metadata("design:type", Object)], ViewSchema.prototype, "paddingTop", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Padding Right',
  description: 'Internal spacing for right side'
}), IsOptional(), IsString(), IsIn(['none', 'tiny', 'small', 'medium', 'large', 'huge']), __metadata("design:type", Object)], ViewSchema.prototype, "paddingRight", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Padding Bottom',
  description: 'Internal spacing for bottom side'
}), IsOptional(), IsString(), IsIn(['none', 'tiny', 'small', 'medium', 'large', 'huge']), __metadata("design:type", Object)], ViewSchema.prototype, "paddingBottom", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Padding Left',
  description: 'Internal spacing for left side'
}), IsOptional(), IsString(), IsIn(['none', 'tiny', 'small', 'medium', 'large', 'huge']), __metadata("design:type", Object)], ViewSchema.prototype, "paddingLeft", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Padding Horizontal (X)',
  description: 'Internal spacing for left and right sides'
}), IsOptional(), IsString(), IsIn(['none', 'tiny', 'small', 'medium', 'large', 'huge']), __metadata("design:type", Object)], ViewSchema.prototype, "paddingX", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Padding Vertical (Y)',
  description: 'Internal spacing for top and bottom sides'
}), IsOptional(), IsString(), IsIn(['none', 'tiny', 'small', 'medium', 'large', 'huge']), __metadata("design:type", Object)], ViewSchema.prototype, "paddingY", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Margin',
  description: 'External spacing for all sides'
}), IsOptional(), IsString(), IsIn(['none', 'tiny', 'small', 'medium', 'large', 'huge']), __metadata("design:type", Object)], ViewSchema.prototype, "margin", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Margin Top',
  description: 'External spacing for top side'
}), IsOptional(), IsString(), IsIn(['none', 'tiny', 'small', 'medium', 'large', 'huge']), __metadata("design:type", Object)], ViewSchema.prototype, "marginTop", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Margin Right',
  description: 'External spacing for right side'
}), IsOptional(), IsString(), IsIn(['none', 'tiny', 'small', 'medium', 'large', 'huge']), __metadata("design:type", Object)], ViewSchema.prototype, "marginRight", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Margin Bottom',
  description: 'External spacing for bottom side'
}), IsOptional(), IsString(), IsIn(['none', 'tiny', 'small', 'medium', 'large', 'huge']), __metadata("design:type", Object)], ViewSchema.prototype, "marginBottom", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Margin Left',
  description: 'External spacing for left side'
}), IsOptional(), IsString(), IsIn(['none', 'tiny', 'small', 'medium', 'large', 'huge']), __metadata("design:type", Object)], ViewSchema.prototype, "marginLeft", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Margin Horizontal (X)',
  description: 'External spacing for left and right sides'
}), IsOptional(), IsString(), IsIn(['none', 'tiny', 'small', 'medium', 'large', 'huge']), __metadata("design:type", Object)], ViewSchema.prototype, "marginX", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Margin Vertical (Y)',
  description: 'External spacing for top and bottom sides'
}), IsOptional(), IsString(), IsIn(['none', 'tiny', 'small', 'medium', 'large', 'huge']), __metadata("design:type", Object)], ViewSchema.prototype, "marginY", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Background',
  description: 'Background fill (color, gradient, image CSS). Canonical name.',
  placeholder: '#ffffff, primary.main, linear-gradient(...)'
}), IsOptional(), IsString(), __metadata("design:type", String)], ViewSchema.prototype, "background", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Background Color (Deprecated)',
  description: 'Use background instead. Kept for backward compatibility.',
  placeholder: '#ffffff, primary.main'
}), IsOptional(), IsString(), __metadata("design:type", String)], ViewSchema.prototype, "backgroundColor", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Background Image',
  description: 'Background image URL',
  placeholder: 'https://example.com/image.jpg'
}), IsOptional(), IsString(), __metadata("design:type", String)], ViewSchema.prototype, "backgroundImage", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Background Gradient',
  description: 'CSS gradient for background',
  placeholder: 'linear-gradient(45deg, #ff6b6b, #4ecdc4)'
}), IsOptional(), IsString(), __metadata("design:type", String)], ViewSchema.prototype, "backgroundGradient", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Text Alignment',
  description: 'Text alignment within the component'
}), IsOptional(), IsString(), IsIn(['left', 'center', 'right', 'justify']), __metadata("design:type", String)], ViewSchema.prototype, "textAlign", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Element ID',
  description: 'Unique HTML element ID',
  placeholder: 'unique-element-id'
}), IsOptional(), IsString(), __metadata("design:type", String)], ViewSchema.prototype, "id", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Role',
  description: 'ARIA role for accessibility',
  placeholder: 'button, navigation, main, etc.'
}), IsOptional(), IsString(), __metadata("design:type", String)], ViewSchema.prototype, "role", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'ARIA Label',
  description: 'Accessibility label for screen readers',
  placeholder: 'Describe this element...'
}), IsOptional(), IsString(), __metadata("design:type", String)], ViewSchema.prototype, "aria-label", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'ARIA Labelled By',
  description: 'IDs of elements that label this component',
  placeholder: 'label-element-id'
}), IsOptional(), IsString(), __metadata("design:type", String)], ViewSchema.prototype, "aria-labelledby", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'ARIA Described By',
  description: 'IDs of elements that describe this component',
  placeholder: 'element-id-1 element-id-2'
}), IsOptional(), IsString(), __metadata("design:type", String)], ViewSchema.prototype, "aria-describedby", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Data Test ID',
  description: 'Test automation identifier',
  placeholder: 'test-element-name'
}), IsOptional(), IsString(), __metadata("design:type", String)], ViewSchema.prototype, "data-testid", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXTAREA,
  label: 'Click Handler',
  description: 'JavaScript function for click events',
  placeholder: 'function(event) { console.debug("clicked"); }'
}), IsOptional(), IsString(), __metadata("design:type", Function)], ViewSchema.prototype, "onClick", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXTAREA,
  label: 'Mouse Enter Handler',
  description: 'JavaScript function for mouse enter events',
  placeholder: 'function(event) { /* hover start */ }'
}), IsOptional(), IsString(), __metadata("design:type", Function)], ViewSchema.prototype, "onMouseEnter", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXTAREA,
  label: 'Mouse Leave Handler',
  description: 'JavaScript function for mouse leave events',
  placeholder: 'function(event) { /* hover end */ }'
}), IsOptional(), IsString(), __metadata("design:type", Function)], ViewSchema.prototype, "onMouseLeave", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXTAREA,
  label: 'Focus Handler',
  description: 'JavaScript function for focus events',
  placeholder: 'function(event) { /* element focused */ }'
}), IsOptional(), IsString(), __metadata("design:type", Function)], ViewSchema.prototype, "onFocus", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXTAREA,
  label: 'Blur Handler',
  description: 'JavaScript function for blur events',
  placeholder: 'function(event) { /* element blurred */ }'
}), IsOptional(), IsString(), __metadata("design:type", Function)], ViewSchema.prototype, "onBlur", void 0);
ViewSchema = __decorate([Schema('ViewSchema', '1.0.0')], ViewSchema);
var ViewSchema$1 = ViewSchema;

/**
 * Schema for SelectInputField component - Select dropdown with options
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
/**
 * Select option definition for dropdown items
 */
class SelectOption {}
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Option Value',
  description: 'The value for this option'
}), IsString()
// Note: Can also be number, but class-validator will handle type coercion
, __metadata("design:type", Object)], SelectOption.prototype, "value", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Option Label',
  description: 'The display text for this option'
}), IsOptional(), IsString(), __metadata("design:type", String)], SelectOption.prototype, "label", void 0);
__decorate([Field({
  defaultValue: false
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Disabled',
  description: 'Whether this option is disabled'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], SelectOption.prototype, "disabled", void 0);
let SelectInputFieldModel = class SelectInputFieldModel extends ViewSchema {};
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Field Label',
  description: 'The label text displayed for this select field',
  placeholder: 'Enter field label...'
}), IsOptional(), IsString(), __metadata("design:type", String)], SelectInputFieldModel.prototype, "label", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Selected Value',
  description: 'The currently selected value'
}), IsOptional(), IsString()
// Note: Can also be number, but class-validator will handle type coercion
, __metadata("design:type", Object)], SelectInputFieldModel.prototype, "value", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXTAREA,
  label: 'Select Options',
  description: 'Array of options available in the dropdown (JSON format)'
}), IsOptional(), IsArray(), ValidateNested({
  each: true
}), Type(() => SelectOption), __metadata("design:type", Array)], SelectInputFieldModel.prototype, "options", void 0);
__decorate([Field({
  defaultValue: false
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Required',
  description: 'Whether this field is required'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], SelectInputFieldModel.prototype, "required", void 0);
__decorate([Field({
  defaultValue: false
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Disabled',
  description: 'Whether this field is disabled'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], SelectInputFieldModel.prototype, "disabled", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Error Message',
  description: 'Error message to display when field validation fails',
  placeholder: 'Error message...'
}), IsOptional(), IsString(), __metadata("design:type", String)], SelectInputFieldModel.prototype, "error", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Helper Text',
  description: 'Additional helpful text displayed below the field',
  placeholder: 'Helper text...'
}), IsOptional(), IsString(), __metadata("design:type", String)], SelectInputFieldModel.prototype, "helperText", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Placeholder Text',
  description: 'Placeholder text shown when no value is selected',
  placeholder: 'Select an option...'
}), IsOptional(), IsString(), __metadata("design:type", String)], SelectInputFieldModel.prototype, "placeholder", void 0);
SelectInputFieldModel = __decorate([Schema('SelectInputField', '1.0.0')], SelectInputFieldModel);

// View component - handles the actual rendering
function SelectInputFieldView({
  label,
  value = '',
  onChange,
  onFocus,
  options = [],
  required = false,
  disabled = false,
  error,
  helperText,
  placeholder,
  ...restProps
}) {
  const handleChange = event => {
    if (onChange) {
      onChange(event.target.value);
    }
  };
  // Filter out ViewProps that conflict with FormControl
  const {
    margin: _margin,
    padding: _padding,
    paddingX: _paddingX,
    paddingY: _paddingY,
    paddingTop: _paddingTop,
    paddingRight: _paddingRight,
    paddingBottom: _paddingBottom,
    paddingLeft: _paddingLeft,
    width: _width,
    height: _height,
    minWidth: _minWidth,
    maxWidth: _maxWidth,
    minHeight: _minHeight,
    maxHeight: _maxHeight,
    sx,
    style,
    span: _span,
    xs: _xs,
    sm: _sm,
    md: _md,
    lg: _lg,
    xl: _xl,
    background: _background,
    backgroundImage: _backgroundImage,
    backgroundGradient: _backgroundGradient,
    textAlign: _textAlign,
    className,
    ...filteredProps
  } = restProps;
  const labelId = label ? `select-label-${label.toLowerCase().replace(/\s+/g, '-')}` : undefined;
  return jsxs(FormControl, {
    fullWidth: true,
    required: required,
    disabled: disabled,
    error: !!error,
    sx: sx,
    style: style,
    className: className,
    ...filteredProps,
    children: [label && jsx(InputLabel, {
      id: labelId,
      children: label
    }), jsxs(Select, {
      labelId: labelId,
      label: label,
      value: value,
      onChange: handleChange,
      onFocus: onFocus,
      displayEmpty: !!placeholder,
      children: [placeholder && jsx(MenuItem, {
        value: "",
        disabled: true,
        children: jsx("em", {
          children: placeholder
        })
      }), options.map((option, index) => jsx(MenuItem, {
        value: option.value,
        disabled: option.disabled,
        children: option.label
      }, `${option.value}-${index}`))]
    }), (error || helperText) && jsx(FormHelperText, {
      children: error || helperText
    })]
  });
}
// Create the serializable SelectInputField component using the factory
const SelectInputField = createSerializableView({
  tagName: 'SelectInputField',
  version: '1.0.0',
  role: 'view',
  View: SelectInputFieldView
  // SelectInputField component uses default react-children strategy
});

// View component - handles the actual rendering
function SwitchInputFieldView({
  label,
  checked = false,
  onChange,
  onFocus,
  required = false,
  disabled = false,
  error,
  helperText,
  ...restProps
}) {
  const handleChange = event => {
    onChange?.(event.target.checked);
  };
  // Filter out ViewProps that conflict with FormControl
  const {
    margin: _margin,
    padding: _padding,
    paddingX: _paddingX,
    paddingY: _paddingY,
    paddingTop: _paddingTop,
    paddingRight: _paddingRight,
    paddingBottom: _paddingBottom,
    paddingLeft: _paddingLeft,
    width: _width,
    height: _height,
    minWidth: _minWidth,
    maxWidth: _maxWidth,
    minHeight: _minHeight,
    maxHeight: _maxHeight,
    sx,
    style,
    span: _span,
    xs: _xs,
    sm: _sm,
    md: _md,
    lg: _lg,
    xl: _xl,
    background: _background,
    backgroundImage: _backgroundImage,
    backgroundGradient: _backgroundGradient,
    textAlign: _textAlign,
    className,
    ...filteredProps
  } = restProps;
  return jsxs(FormControl, {
    component: "fieldset",
    error: !!error,
    disabled: disabled,
    sx: sx,
    style: style,
    className: className,
    ...filteredProps,
    children: [jsx(FormControlLabel, {
      control: jsx(Switch, {
        checked: checked,
        onChange: handleChange,
        onFocus: onFocus,
        required: required,
        disabled: disabled
      }),
      label: label
    }), (error || helperText) && jsx(FormHelperText, {
      children: error || helperText
    })]
  });
}
// Create the serializable SwitchInputField component using the factory
const SwitchInputField = createSerializableView({
  tagName: 'SwitchInputField',
  version: '1.0.0',
  role: 'view',
  View: SwitchInputFieldView
  // SwitchInputField component uses default react-children strategy
});

// View component - handles the actual rendering
function TextInputFieldView({
  label,
  value = '',
  onChange,
  onFocus,
  required = false,
  disabled = false,
  error,
  helperText,
  placeholder,
  type = 'text',
  multiline = false,
  rows,
  maxRows,
  textFieldProps,
  ...restProps
}) {
  const handleChange = event => {
    onChange?.(event.target.value);
  };
  // Filter out ViewProps that conflict with TextField
  const {
    margin: _margin,
    padding: _padding,
    paddingX: _paddingX,
    paddingY: _paddingY,
    paddingTop: _paddingTop,
    paddingRight: _paddingRight,
    paddingBottom: _paddingBottom,
    paddingLeft: _paddingLeft,
    width: _width,
    height: _height,
    minWidth: _minWidth,
    maxWidth: _maxWidth,
    minHeight: _minHeight,
    maxHeight: _maxHeight,
    sx,
    style,
    span: _span,
    xs: _xs,
    sm: _sm,
    md: _md,
    lg: _lg,
    xl: _xl,
    background: _background,
    backgroundImage: _backgroundImage,
    backgroundGradient: _backgroundGradient,
    textAlign: _textAlign,
    className,
    ...filteredProps
  } = restProps;
  return jsx(TextField$1, {
    ...filteredProps,
    fullWidth: true,
    label: label,
    value: value,
    onChange: handleChange,
    onFocus: onFocus,
    required: required,
    disabled: disabled,
    error: !!error,
    helperText: error || helperText,
    placeholder: placeholder,
    type: type,
    multiline: multiline,
    rows: rows,
    maxRows: maxRows,
    sx: sx,
    style: style,
    className: className,
    ...textFieldProps
  });
}
// Create the serializable TextInputField component using the factory
const TextInputField = createSerializableView({
  tagName: 'TextInputField',
  version: '1.0.0',
  role: 'view',
  View: TextInputFieldView
  // TextInputField component uses default react-children strategy
});

/**
 * GridCellView - Pure view component that renders the actual grid cell
 *
 * This component receives fully processed props from createSerializableView
 * and renders the grid cell using Material-UI Box with all styling applied.
 */
function GridCellView({
  children,
  gridProps,
  ...props
}) {
  const typedGridProps = gridProps;
  return jsx(Box, {
    ...props,
    ...(typedGridProps ? {
      'data-grid-span': typedGridProps.span,
      'data-grid-xs': typedGridProps.xs,
      'data-grid-sm': typedGridProps.sm,
      'data-grid-md': typedGridProps.md,
      'data-grid-lg': typedGridProps.lg,
      'data-grid-xl': typedGridProps.xl
    } : {}),
    children: children
  });
}
/**
 * Create GridCell component using the factory pattern
 */
const GridCell = createSerializableView({
  tagName: 'GridCell',
  version: '1.0.0',
  role: 'container',
  View: GridCellView
});

/**
 * GridLayoutView - Pure view component that renders the actual grid layout
 *
 * This component receives fully processed props from createSerializableView
 * and renders the grid layout using Material-UI Grid with all styling applied.
 */
function GridLayoutView({
  children,
  columns,
  spacing = 'small',
  equalHeight = false,
  height,
  width,
  minHeight,
  minWidth,
  maxHeight,
  maxWidth,
  gridProps,
  ...props
}) {
  const resolvedSpacing = resolveSpacing(spacing);
  // Process children to handle grid props
  const processChildren = () => {
    const childArray = React.Children.toArray(children);
    return childArray.map((child, index) => {
      if (! /*#__PURE__*/React.isValidElement(child)) {
        return child;
      }
      // Extract grid props from data attributes or props
      let childGridProps = {};
      // Extract grid props from both data attributes (QwickApp) and direct props (regular)
      const childProps = child.props;
      const span = childProps['data-grid-span'] || childProps.span;
      const xs = childProps['data-grid-xs'] || childProps.xs;
      const sm = childProps['data-grid-sm'] || childProps.sm;
      const md = childProps['data-grid-md'] || childProps.md;
      const lg = childProps['data-grid-lg'] || childProps.lg;
      const xl = childProps['data-grid-xl'] || childProps.xl;
      if (span || xs || sm || md || lg || xl) {
        // Use span if available, otherwise use breakpoint values
        if (span) {
          childGridProps = {
            size: span
          };
        } else {
          // Build responsive size object for MUI v6
          const sizeConfig = {};
          if (xs) sizeConfig.xs = xs;
          if (sm) sizeConfig.sm = sm;
          if (md) sizeConfig.md = md;
          if (lg) sizeConfig.lg = lg;
          if (xl) sizeConfig.xl = xl;
          childGridProps = {
            size: sizeConfig
          };
        }
      }
      // If columns prop is set and no grid props, auto-distribute responsively
      if (columns && Object.keys(childGridProps).length === 0) {
        // Make responsive: single column on mobile, fewer columns on tablet, full columns on desktop
        childGridProps = {
          size: {
            xs: 12,
            // Single column on mobile
            sm: columns >= 3 ? 6 : 12 / Math.min(columns, 2),
            // 2 columns max on small screens
            md: 12 / Math.min(columns, 3),
            // 3 columns max on medium screens
            lg: 12 / columns // Full columns on large screens
          }
        };
      }
      // If has grid props, wrap in Grid
      if (Object.keys(childGridProps).length > 0) {
        // Clean grid data attributes from child to avoid duplication
        const cleanedProps = {
          ...child.props
        };
        delete cleanedProps['data-grid-span'];
        delete cleanedProps['data-grid-xs'];
        delete cleanedProps['data-grid-sm'];
        delete cleanedProps['data-grid-md'];
        delete cleanedProps['data-grid-lg'];
        delete cleanedProps['data-grid-xl'];
        return jsx(Grid, {
          ...childGridProps,
          children: /*#__PURE__*/React.cloneElement(child, cleanedProps)
        }, child.key || index);
      }
      // Return child wrapped in Fragment with key
      return jsx(React.Fragment, {
        children: child
      }, child.key || index);
    });
  };
  return jsx(Grid, {
    container: true,
    spacing: resolvedSpacing,
    ...props,
    ...(gridProps ? {
      'data-grid': JSON.stringify(gridProps)
    } : {}),
    sx: {
      width: '100%',
      // Ensure full width by default in MUI v6
      height: resolveDimension(height, 'height'),
      minHeight: resolveDimension(minHeight, 'minHeight'),
      minWidth: resolveDimension(minWidth, 'minWidth'),
      maxHeight: resolveDimension(maxHeight, 'maxHeight'),
      maxWidth: resolveDimension(maxWidth, 'maxWidth'),
      ...(width && {
        width: resolveDimension(width, 'width')
      }),
      // Override only if explicitly set
      ...(equalHeight && {
        alignItems: 'stretch',
        // Target direct Grid children - MUI v6 uses .MuiGrid-root for grid items with size prop
        '& > .MuiGrid-root': {
          display: 'flex',
          '& > *': {
            width: '100%',
            height: '100%'
          }
        }
      }),
      ...props.sx
    },
    children: processChildren()
  });
}
/**
 * Create GridLayout component using the factory pattern
 */
const GridLayout = createSerializableView({
  tagName: 'GridLayout',
  version: '1.0.0',
  role: 'container',
  View: GridLayoutView
});

// View component - handles the actual rendering
function HtmlView({
  children = '',
  stripHeaders = false,
  placeholder,
  component = 'div',
  transformConfig,
  sanitize,
  sanitizeOptions,
  ...restProps
}) {
  const {
    styleProps,
    htmlProps,
    restProps: otherProps
  } = useBaseProps(restProps);
  // Mark as QwickApp component
  Object.assign(HtmlView, {
    [QWICKAPP_COMPONENT]: true
  });
  // Return placeholder if no HTML content
  if (!children || !children.trim()) {
    if (placeholder) {
      return jsx(Box, {
        component: component,
        ...htmlProps,
        ...styleProps,
        ...otherProps,
        sx: {
          opacity: 0.6,
          fontStyle: 'italic',
          ...styleProps.sx
        },
        children: placeholder
      });
    }
    return null;
  }
  try {
    // Process HTML content
    let processedHtml = children;
    if (stripHeaders) {
      // Simple header stripping - remove h1, h2, etc. tags
      processedHtml = processedHtml.replace(/<h[1-6][^>]*>.*?<\/h[1-6]>/gi, '');
    }
    // Note: transformConfig, sanitize, and sanitizeOptions are legacy props
    // maintained for backward compatibility. The new ComponentTransformer system
    // handles transformation through registered patterns automatically.
    // Transform HTML to React components using ComponentTransformer
    const components = ComponentTransformer$1.transformHTML(processedHtml);
    // Return transformed components
    return jsx(Box, {
      component: component,
      ...htmlProps,
      ...styleProps,
      ...otherProps,
      sx: {
        // Ensure proper spacing between elements
        '& > *:not(:last-child)': {
          mb: 1.5
        },
        // Header styling when headers are present
        '& h1, & h2, & h3, & h4, & h5, & h6': {
          mb: 1.5,
          mt: 2,
          '&:first-of-type': {
            mt: 0
          }
        },
        // Paragraph spacing
        '& p': {
          mb: 1.5,
          lineHeight: 1.6
        },
        // List styling
        '& ul, & ol': {
          mb: 1.5,
          pl: 3
        },
        ...styleProps.sx
      },
      children: Array.isArray(components) ? components.map((child, idx) => /*#__PURE__*/React.isValidElement(child) && child.key == null ? /*#__PURE__*/React.cloneElement(child, {
        key: `html-child-${idx}`
      }) : child) : components
    });
  } catch (error) {
    console.error('Error transforming HTML content:', error);
    // Production fallback - use SafeSpan
    return jsx(SafeSpan, {
      html: children,
      placeholder: placeholder || "Content unavailable",
      ...htmlProps,
      ...styleProps,
      ...otherProps
    });
  }
}
// Main component with data binding support and serialization capability
class Html extends ModelView {
  // Deserialization: JSON data → React element
  static fromJson(jsonData) {
    const {
      tagName,
      version,
      data
    } = jsonData;
    if (tagName !== Html.tagName) {
      throw new Error(`Cannot deserialize: Expected tagName 'Html' but got '${tagName}'`);
    }
    if (version !== Html.version) {
      console.warn(`Version mismatch: Expected ${Html.version} but got ${version}`);
    }
    const typedData = data || {};
    const {
      children,
      ...props
    } = typedData;
    // Children should be a string (HTML content), not deserialized React nodes
    return jsx(Html, {
      ...props,
      children: children
    });
  }
  // Component-specific serialization properties
  getComponentSpecificProps() {
    return {
      children: this.props.children,
      stripHeaders: this.props.stripHeaders,
      placeholder: this.props.placeholder
    };
  }
  // Html component renders traditional props view
  renderView() {
    const {
      ...restProps
    } = this.props;
    return jsx(HtmlView, {
      ...restProps
    });
  }
  // Html component renders data-bound view
  renderWithDataBinding() {
    return jsx(HtmlWithDataBinding, {
      ...this.props
    });
  }
  // Register HTML patterns that Html component can handle
  static registerPatternHandlers(registry) {
    const typedRegistry = registry;
    // Register div elements with specific classes for Html transformation
    if (typedRegistry.hasPattern && !typedRegistry.hasPattern('div.html-content')) {
      typedRegistry.registerPattern?.('div.html-content', Html.transformHtmlDiv);
    }
    // Register elements with data-html attribute
    if (typedRegistry.hasPattern && !typedRegistry.hasPattern('[data-html]')) {
      typedRegistry.registerPattern?.('[data-html]', Html.transformDataHtml);
    }
  }
  // Transform div with html-content class to Html component
  static transformHtmlDiv(element) {
    const stripHeaders = element.getAttribute('data-strip-headers') === 'true';
    const placeholder = element.getAttribute('data-placeholder');
    return {
      tagName: 'Html',
      props: {
        children: element.innerHTML,
        stripHeaders,
        placeholder: placeholder || undefined
      }
    };
  }
  // Transform elements with data-html attribute to Html component
  static transformDataHtml(element) {
    const htmlContent = element.getAttribute('data-html') || element.innerHTML;
    const stripHeaders = element.getAttribute('data-strip-headers') === 'true';
    const placeholder = element.getAttribute('data-placeholder');
    return {
      tagName: 'Html',
      props: {
        children: htmlContent,
        stripHeaders,
        placeholder: placeholder || undefined
      }
    };
  }
}
// Component self-declaration for serialization
Html.tagName = 'Html';
Html.version = '1.0.0';
// Helper component to handle data binding with hooks (since we can't use hooks in class components)
function HtmlWithDataBinding(props) {
  const {
    dataSource,
    bindingOptions,
    ...restProps
  } = props;
  // Use data binding
  const {
    loading,
    error,
    ...htmlProps
  } = useDataBinding(dataSource, restProps);
  // Show loading state
  if (loading) {
    return jsx(Box, {
      sx: {
        p: 2,
        textAlign: 'center',
        opacity: 0.6
      },
      children: "Loading HTML content..."
    });
  }
  if (error) {
    console.error('Error loading HTML content:', error);
    return null;
  }
  return jsx(HtmlView, {
    ...htmlProps
  });
}

/**
 * ReactNodeTransformer - Fallback transformer for standard React content
 *
 * Provides serialization/deserialization for unregistered React components,
 * HTML elements, and other React content that doesn't implement the
 * Serializable interface.
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
/**
 * Transformer for standard React content and HTML elements
 * Used as fallback when components are not registered in ComponentTransformer
 */
class ReactNodeTransformer {
  /**
   * Serialize a React node to JSON-compatible structure
   * @param node - React node to serialize
   * @returns Serializable data structure
   */
  static serialize(node) {
    if (node === null || node === undefined) {
      return null;
    }
    // Handle arrays of nodes
    if (Array.isArray(node)) {
      return {
        type: 'array',
        children: node.map(child => ReactNodeTransformer.serialize(child))
      };
    }
    // Handle primitive values
    if (typeof node === 'string' || typeof node === 'number' || typeof node === 'boolean') {
      return {
        type: 'primitive',
        value: node
      };
    }
    // Handle React elements
    if (/*#__PURE__*/isValidElement(node)) {
      const element = node;
      const comp = element.type;
      const rawName = typeof comp === 'string' ? comp : comp?.render?.name || comp?.name || comp?.muiName || comp?.displayName || 'Anonymous';
      // Normalize wrapper names like ForwardRef(Typography), Styled(Typography)
      const displayName = typeof rawName === 'string' ? rawName.match(/^[A-Za-z]+?\(([^)]+)\)$/)?.[1] || rawName : 'Anonymous';
      return {
        type: 'react-element',
        elementType: displayName,
        props: ReactNodeTransformer.serializeProps(element.props),
        key: element.key
      };
    }
    // Handle plain objects
    if (typeof node === 'object' && node !== null) {
      try {
        const serialized = {
          type: 'object',
          data: {}
        };
        for (const [key, value] of Object.entries(node)) {
          serialized.data[key] = ReactNodeTransformer.serialize(value);
        }
        return serialized;
      } catch {
        return {
          type: 'string',
          value: String(node)
        };
      }
    }
    // Fallback for other types
    return {
      type: 'string',
      value: String(node)
    };
  }
  /**
   * Deserialize data back to React node
   * @param data - Data to deserialize
   * @returns React node
   */
  static deserialize(data) {
    if (data === null || data === undefined) {
      return null;
    }
    // Handle serialized data with type information
    if (typeof data === 'object' && data.type) {
      switch (data.type) {
        case 'primitive':
          return data.value;
        case 'string':
          return data.value;
        case 'array':
          return data.children?.map(child => ReactNodeTransformer.deserialize(child)) || [];
        case 'react-element':
          return ReactNodeTransformer.deserializeReactElement(data);
        case 'object':
          {
            const result = {};
            if (data.data && typeof data.data === 'object') {
              for (const [key, value] of Object.entries(data.data)) {
                result[key] = ReactNodeTransformer.deserialize(value);
              }
            }
            return result;
          }
        default:
          return String(data.value || data);
      }
    }
    // Handle direct primitive values (backward compatibility)
    if (typeof data === 'string' || typeof data === 'number' || typeof data === 'boolean') {
      return data;
    }
    // Fallback
    return String(data);
  }
  /**
   * Serialize props object, handling nested React nodes
   * @param props - Props object to serialize
   * @returns Serialized props
   */
  static serializeProps(props) {
    if (!props || typeof props !== 'object') {
      return props;
    }
    const serialized = {};
    for (const [key, value] of Object.entries(props)) {
      if (key === 'children') {
        // Special handling for children prop
        serialized[key] = ReactNodeTransformer.serialize(value);
      } else if (typeof value === 'function') {
        // Skip functions in serialization
        serialized[key] = null;
      } else {
        serialized[key] = value;
      }
    }
    return serialized;
  }
  /**
   * Deserialize React element data back to React element
   * @param data - Serialized React element data
   * @returns React element or fallback content
   */
  static deserializeReactElement(data) {
    const typedData = data;
    const {
      elementType,
      props,
      key
    } = typedData;
    try {
      // Handle HTML elements
      if (typeof elementType === 'string') {
        const deserializedProps = ReactNodeTransformer.deserializeProps(props);
        return /*#__PURE__*/createElement(elementType, {
          key,
          ...deserializedProps
        });
      }
    } catch (error) {
      console.warn('Error deserializing React element:', error);
    }
    // Use Html component to render HTML content safely
    const typedProps = props;
    return /*#__PURE__*/createElement(Html, {
      key,
      children: typedProps.children
    });
  }
  /**
   * Deserialize props object, handling nested React nodes
   * @param props - Serialized props object
   * @returns Deserialized props
   */
  static deserializeProps(props) {
    if (!props || typeof props !== 'object') {
      return props;
    }
    const deserialized = {};
    for (const [key, value] of Object.entries(props)) {
      if (key === 'children') {
        // Special handling for children prop
        deserialized[key] = ReactNodeTransformer.deserialize(value);
      } else {
        deserialized[key] = value;
      }
    }
    return deserialized;
  }
  /**
   * Extract text content from props for fallback rendering
   * @param props - Props object
   * @returns Text content or null
   */
  static extractTextContent(props) {
    if (!props || typeof props !== 'object') return null;
    const typedProps = props;
    if (typeof typedProps.children === 'string') {
      return typedProps.children;
    }
    if (typedProps.title && typeof typedProps.title === 'string') {
      return typedProps.title;
    }
    if (typedProps.label && typeof typedProps.label === 'string') {
      return typedProps.label;
    }
    if (typedProps.text && typeof typedProps.text === 'string') {
      return typedProps.text;
    }
    return null;
  }
}

/**
 * ComponentTransformer - Core component serialization and HTML pattern transformation system
 *
 * Enables "WebView for React" functionality by providing serialization
 * and deserialization of React components to/from JSON structures.
 * Also supports HTML pattern-based transformations where components can
 * register HTML patterns they can handle.
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
// Import linkedom for server-side HTML parsing
let parseHTML = null;
if (typeof window === 'undefined') {
  // Server-side: use linkedom
  try {
    const {
      parseHTML: parse
    } = require('linkedom');
    parseHTML = html => parse(html).document;
  } catch (e) {
    // linkedom not available, will fall back to client-only rendering
    console.warn('linkedom not available for SSR HTML parsing');
  }
}
/**
 * Registry for component classes that support serialization
 */
const componentRegistry = new Map();
/**
 * Registry for HTML pattern handlers
 */
const patternRegistry = new Map();
/**
 * Strict mode: throw on unregistered components
 * When true, the transformer will throw errors instead of using fallback
 */
let strictMode = true;
/**
 * Fallback tag for unregistered components / html / text (legacy mode only)
 */
const FALLBACK_TAG = '__react_node__';
const FALLBACK_VERSION = '1.0.0';
/**
 * Core transformer for React component serialization
 * Provides static methods for component registration and transformation
 */
let ComponentTransformer$1 = class ComponentTransformer {
  /**
   * Enable or disable strict mode
   * @param enabled - Whether to enable strict mode (throws on unregistered components)
   */
  static setStrictMode(enabled) {
    strictMode = enabled;
  }
  /**
   * Check if strict mode is enabled
   * @returns True if strict mode is enabled
   */
  static isStrictMode() {
    return strictMode;
  }
  /**
   * Register a component class for serialization
   * Component must declare its own tagName and version via static properties
   * @param componentClass - Component class that implements Serializable interface
   */
  static registerComponent(componentClass) {
    const {
      tagName,
      version
    } = componentClass;
    if (!tagName || typeof tagName !== 'string') {
      throw new Error(`Component class must have a static 'tagName' property`);
    }
    if (!version || typeof version !== 'string') {
      throw new Error(`Component class '${tagName}' must have a static 'version' property`);
    }
    if (typeof componentClass.fromJson !== 'function') {
      throw new Error(`Component class '${tagName}' must implement static 'fromJson' method`);
    }
    if (componentRegistry.has(tagName)) {
      console.warn(`Component '${tagName}' is already registered. Overwriting existing registration.`);
    }
    componentRegistry.set(tagName, componentClass);
    // Register HTML patterns if component supports them
    const classWithPatterns = componentClass;
    if (typeof classWithPatterns.registerPatternHandlers === 'function') {
      classWithPatterns.registerPatternHandlers(ComponentTransformer);
    }
  }
  /**
   * Serialize React node(s) to JSON string
   * In strict mode: throws on unregistered components
   * In legacy mode: uses fallback tag for unregistered components/html/text
   */
  static serialize(node) {
    const serializedData = ComponentTransformer.serializeNode(node);
    return JSON.stringify(serializedData);
  }
  /**
   * Deserialize JSON input to React node(s)
   * In strict mode: throws on unregistered components
   * In legacy mode: never throws; always returns a valid ReactNode (or array) or null
   * - Strings: try JSON.parse; if fails, return the string as a text node
   * - Objects/arrays: only schema objects are transformed; non-schema become text via JSON.stringify
   */
  static deserialize(input) {
    if (typeof input === 'string') {
      try {
        const parsed = JSON.parse(input);
        return ComponentTransformer.deserializeData(parsed);
      } catch {
        // Not JSON; plain string is a valid ReactNode
        return input;
      }
    }
    if (input == null) return null;
    return ComponentTransformer.deserializeData(input);
  }
  /**
  * Type guard for serialized component schema objects
  * Requires: { tagName: string; version: string; data: unknown }
  * Optional: key?: string
  */
  static isSerializedComponent(obj) {
    return !!obj && typeof obj === 'object' && typeof obj.tagName === 'string' && typeof obj.version === 'string' && 'data' in obj;
  }
  /**
   * Internal method to deserialize data back to React nodes
   * @param data - Data to deserialize
   * @returns React node(s)
   */
  static deserializeData(data) {
    if (data == null) return null;
    // Arrays: map recursively
    if (Array.isArray(data)) {
      return data.map(item => ComponentTransformer.deserializeData(item));
    }
    if (ComponentTransformer.isSerializedComponent(data)) {
      const {
        key,
        tagName,
        data: componentData
      } = data;
      try {
        const componentClass = componentRegistry.get(tagName);
        if (!componentClass) {
          if (strictMode) {
            throw new Error(`Component '${tagName}' is not registered in strict mode`);
          }
          // Legacy fallback
          const node = ComponentTransformer.deserializeUnregisteredComponent(componentData);
          return key ? /*#__PURE__*/React.cloneElement(node, {
            key
          }) : node;
        }
        const node = componentClass.fromJson(data);
        // Apply key if provided
        return key ? /*#__PURE__*/React.cloneElement(node, {
          key
        }) : node;
      } catch (error) {
        if (strictMode) {
          throw error; // Re-throw in strict mode
        }
        console.error(`TEST: Error deserializing component '${tagName}':`, error);
      }
    }
    // Handle primitives that are valid React children
    if (typeof data === 'string' || typeof data === 'number' || typeof data === 'boolean') {
      return data;
    }
    // For objects, we can't render them directly
    console.warn(`TEST: Unrecognized data:`, data);
    return null;
  }
  /**
   * Internal method to serialize a single React node
   * @param node - React node to serialize
   * @returns Serializable data structure { tagName, version, data }
   */
  static serializeNode(node) {
    if (node == null) return null;
    // Handle arrays of nodes (produce array of schema objects/null)
    if (Array.isArray(node)) {
      return node.map(child => ComponentTransformer.serializeNode(child));
    }
    // Handle primitive values (strings, numbers, booleans) - these are valid React children
    if (typeof node === 'string' || typeof node === 'number' || typeof node === 'boolean') {
      return node;
    }
    // React elements
    if (typeof node === 'object' && 'type' in node) {
      const element = node;
      const key = element.key ? {
        key: String(element.key)
      } : {};
      // Registered component?
      const componentType = element.type;
      if (typeof componentType === 'function') {
        const tagName = ComponentTransformer.findTagNameForComponent(componentType);
        if (tagName) {
          const componentClass = componentRegistry.get(tagName);
          let serializedData = null;
          const classWithToJson = componentClass;
          if (typeof classWithToJson.toJson === 'function') {
            serializedData = classWithToJson.toJson(element.props);
          }
          if (serializedData !== null) {
            // Process children recursively if they exist in the data
            if (serializedData.data && serializedData.data.children !== undefined) {
              serializedData.data.children = ComponentTransformer.serializeNode(serializedData.data.children);
            }
            const result = {
              ...key,
              ...serializedData
            };
            return result;
          }
        } else if (strictMode) {
          // In strict mode, throw if we can't find a tag name for the component
          const typeWithName = componentType;
          const componentName = typeWithName.displayName || typeWithName.name || 'Unknown';
          throw new Error(`Unregistered component '${componentName}' cannot be serialized in strict mode`);
        }
      }
    }
    if (strictMode) {
      throw new Error(`Cannot serialize unregistered node in strict mode: ${typeof node === 'object' && node && 'type' in node ? node.type : typeof node}`);
    }
    const result = {
      tagName: FALLBACK_TAG,
      version: FALLBACK_VERSION,
      data: ReactNodeTransformer.serialize(node)
    };
    return result;
  }
  /**
   * Deserialize unregistered nodes using ReactNodeTransformer
   * @param data - Serialized data from ReactNodeTransformer
   * @returns React node
   */
  static deserializeUnregisteredComponent(data) {
    return ReactNodeTransformer.deserialize(data);
  }
  /**
   * Find the tag name for a given component constructor
   * @param componentType - Component constructor function
   * @returns Tag name or null if not found
   */
  static findTagNameForComponent(componentType) {
    // Direct constructor match
    for (const [tagName, registeredClass] of componentRegistry.entries()) {
      if (registeredClass === componentType) return tagName;
    }
    // If the component exposes a tagName, prefer it
    const explicitTag = componentType?.tagName;
    if (typeof explicitTag === 'string' && componentRegistry.has(explicitTag)) {
      return explicitTag;
    }
    // Unwrap common HOC/wrapper names
    const name = componentType?.displayName || componentType?.name;
    if (name) {
      // ForwardRef(Typography) -> Typography, Styled(Typography) -> Typography
      // WithDataBinding(Text) -> Text, TextWithDataBinding -> Text
      const unwrapped = name.replace(/^[A-Za-z]+?\(([^)]+)\)$/, '$1').replace(/WithDataBinding$/, '');
      if (componentRegistry.has(unwrapped)) return unwrapped;
      if (componentRegistry.has(name)) return name;
    }
    return null;
  }
  /**
   * Get list of registered component tags (for debugging/testing)
   * @returns Array of registered tag names
   */
  static getRegisteredComponents() {
    return Array.from(componentRegistry.keys());
  }
  /**
   * Clear all registered components (for testing)
   */
  static clearRegistry() {
    componentRegistry.clear();
    patternRegistry.clear();
  }
  // HTML Pattern Methods
  /**
   * Register an HTML pattern handler
   * @param pattern - CSS selector pattern (e.g., 'pre code', 'section.blog-section')
   * @param handler - Function to transform matching elements to component data
   */
  static registerPattern(pattern, handler) {
    if (patternRegistry.has(pattern)) {
      console.warn(`Pattern '${pattern}' is already registered. Overwriting existing handler.`);
    }
    patternRegistry.set(pattern, handler);
  }
  /**
   * Check if a pattern is registered
   * @param pattern - CSS selector pattern to check
   * @returns True if pattern is registered
   */
  static hasPattern(pattern) {
    return patternRegistry.has(pattern);
  }
  /**
   * Transform an HTML element to React component if a matching pattern exists
   * @param element - DOM Element to transform
   * @returns React node if pattern matches, null otherwise
   */
  static transformHTMLElement(element) {
    for (const [pattern, handler] of patternRegistry) {
      if (element.matches(pattern)) {
        try {
          const componentData = handler(element);
          return ComponentTransformer.deserialize(componentData);
        } catch (error) {
          console.warn(`Error transforming element with pattern '${pattern}':`, error);
          return null;
        }
      }
    }
    return null;
  }
  /**
   * Transform HTML string to React nodes using registered patterns
   * Supports both server-side (linkedom) and client-side (DOMParser) rendering
   * @param html - HTML string to transform
   * @returns Array of React nodes
   */
  static transformHTML(html) {
    if (!html.trim()) return [];
    let doc;
    // Server-side: use linkedom if available
    if (typeof window === 'undefined') {
      if (parseHTML) {
        doc = parseHTML(html);
      } else {
        // linkedom not available, return empty for client-side rendering
        console.warn('SSR HTML parsing unavailable - content will render client-side only');
        return [];
      }
    } else {
      // Client-side: use DOMParser
      const parser = new DOMParser();
      doc = parser.parseFromString(html, 'text/html');
    }
    return Array.from(doc.body.children).map((element, index) => ComponentTransformer.transformElement(element, `element-${index}`));
  }
  /**
   * Recursively transform an element and its children
   * @param element - DOM Element to transform
   * @param key - React key for the element
   * @returns React node
   */
  static transformElement(element, key) {
    const transformedNode = ComponentTransformer.transformHTMLElement(element);
    if (transformedNode) {
      // Clone the node and add the key prop
      if (/*#__PURE__*/React.isValidElement(transformedNode)) {
        return /*#__PURE__*/React.cloneElement(transformedNode, {
          key
        });
      }
      return transformedNode;
    }
    const children = Array.from(element.children);
    const hasTransformableChildren = children.some(child => Array.from(patternRegistry.keys()).some(pattern => child.matches(pattern)));
    if (hasTransformableChildren) {
      const transformedChildren = children.map((child, index) => ComponentTransformer.transformElement(child, `${key}-${index}`));
      return /*#__PURE__*/React.createElement(element.tagName.toLowerCase(), {
        key,
        className: element.className || undefined,
        id: element.id || undefined
      }, transformedChildren);
    }
    // Fallback - use ReactNodeTransformer to handle as unregistered HTML
    const tagName = element.tagName.toLowerCase();
    // Void elements (self-closing tags) cannot have innerHTML
    // https://developer.mozilla.org/en-US/docs/Glossary/Void_element
    const voidElements = ['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr'];
    const isVoidElement = voidElements.includes(tagName);
    return ReactNodeTransformer.deserialize({
      type: 'react-element',
      elementType: tagName,
      props: {
        key,
        className: element.className || undefined,
        id: element.id || undefined,
        ...(isVoidElement ? {} : {
          dangerouslySetInnerHTML: {
            __html: element.innerHTML
          }
        })
      }
    });
  }
  /**
   * Get list of registered patterns (for debugging/testing)
   * @returns Array of registered patterns
   */
  static getRegisteredPatterns() {
    return Array.from(patternRegistry.keys());
  }
};

/**
 * Component Registration - Central registry for serializable components
 *
 * This file registers all components that implement the Serializable interface
 * with the ComponentTransformer system. Components must be registered here
 * to support JSON serialization/deserialization functionality.
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
function registerSerializableComponents() {
  // Register Container component - Base layout component with child serialization support
  ComponentTransformer$1.registerComponent(Container$8);
  // Register Code component - First production component with serialization support
  ComponentTransformer$1.registerComponent(Code);
  // Register Section component - Layout container component with child serialization support
  ComponentTransformer$1.registerComponent(Section);
  // Register Button component - Interactive component with action serialization support
  ComponentTransformer$1.registerComponent(Button);
  // Register Image component - Display component with comprehensive image handling and serialization support
  ComponentTransformer$1.registerComponent(Image);
  // Register Text component - Typography component with comprehensive text styling and serialization support
  ComponentTransformer$1.registerComponent(Text$1);
  // Register HeroBlock component - Full-width hero section with nested component serialization support
  ComponentTransformer$1.registerComponent(HeroBlock);
  // Register GridLayout component - Flexible grid layout with nested component serialization support
  ComponentTransformer$1.registerComponent(GridLayout);
  // Register GridCell component - Grid cell wrapper with nested component serialization support
  ComponentTransformer$1.registerComponent(GridCell);
  // Register Form Components - Complete form field components with serialization support
  ComponentTransformer$1.registerComponent(TextInputField);
  ComponentTransformer$1.registerComponent(SelectInputField);
  ComponentTransformer$1.registerComponent(HtmlInputField);
  ComponentTransformer$1.registerComponent(ChoiceInputField);
  ComponentTransformer$1.registerComponent(SwitchInputField);
  ComponentTransformer$1.registerComponent(FormBlock);
  // Future components will be registered here as they implement Serializable
  // etc.
}
/**
 * Auto-registration: Register components immediately when this module is imported
 * This ensures components are available for serialization as soon as the module loads
 */
registerSerializableComponents();

/**
 * HeroSlideshow Component
 *
 * A slideshow built on top of HeroBlock that cycles through multiple slides
 * with auto-rotation, fade transitions, and progress dot navigation.
 *
 * Usage (props-driven, e.g. qwickdocs):
 *   <HeroSlideshow slides={[{ title: 'Slide 1', ... }, ...]} />
 *
 * Usage (CMS-driven, e.g. work-macha):
 *   const slideshow = await payload.findByID({ collection: 'hero-slideshows', id });
 *   <HeroSlideshow slides={slideshow.slides} autoPlayInterval={slideshow.autoPlayInterval} />
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
const TRANSITION_DURATION = 300; // ms
/**
 * HeroSlideshow - Cycles through HeroBlock slides with fade transitions
 */
function HeroSlideshow({
  slides,
  autoPlayInterval = 5000,
  showDots = true,
  blockHeight = 'large',
  textAlign = 'center'
}) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const goToSlide = useCallback(index => {
    if (index === currentIndex) return;
    setIsVisible(false);
    setTimeout(() => {
      setCurrentIndex(index);
      setIsVisible(true);
    }, TRANSITION_DURATION);
  }, [currentIndex]);
  useEffect(() => {
    if (slides.length <= 1 || autoPlayInterval <= 0) return;
    const timer = setTimeout(() => {
      goToSlide((currentIndex + 1) % slides.length);
    }, autoPlayInterval);
    return () => clearTimeout(timer);
  }, [currentIndex, slides.length, autoPlayInterval, goToSlide]);
  if (!slides.length) return null;
  const slide = slides[currentIndex];
  return jsxs(Box, {
    sx: {
      position: 'relative',
      overflow: 'hidden'
    },
    children: [jsx(Box, {
      sx: {
        opacity: isVisible ? 1 : 0,
        transition: `opacity ${TRANSITION_DURATION}ms ease-in-out`
      },
      children: jsx(HeroBlock, {
        title: slide.title,
        subtitle: slide.subtitle,
        backgroundImage: slide.backgroundImage,
        backgroundGradient: slide.backgroundGradient,
        backgroundColor: slide.backgroundColor,
        actions: slide.actions,
        overlayOpacity: slide.overlayOpacity,
        blockHeight: blockHeight,
        textAlign: textAlign
      })
    }), showDots && slides.length > 1 && jsx(Box, {
      sx: {
        position: 'absolute',
        bottom: 20,
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        gap: 1,
        zIndex: 10
      },
      children: slides.map((_, index) => jsx(Box, {
        role: "button",
        "aria-label": `Go to slide ${index + 1}`,
        onClick: () => goToSlide(index),
        sx: {
          width: index === currentIndex ? 28 : 8,
          height: 8,
          borderRadius: 4,
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          opacity: index === currentIndex ? 1 : 0.45,
          cursor: 'pointer',
          transition: 'all 0.3s ease',
          '&:hover': {
            opacity: 0.8
          }
        }
      }, index))
    })]
  });
}

// View component - handles the actual rendering
function ArticleView({
  html = '',
  skipHeader = false,
  ...restProps
}) {
  const {
    styleProps,
    htmlProps,
    restProps: otherProps
  } = useBaseProps(restProps);
  // Mark as QwickApp component
  Object.assign(ArticleView, {
    [QWICKAPP_COMPONENT]: true
  });
  // Return empty state if no HTML content
  if (!html.trim()) {
    return jsxs(Box, {
      component: "article",
      ...htmlProps,
      ...styleProps,
      sx: {
        maxWidth: '800px',
        mx: 'auto',
        p: 4,
        textAlign: 'center',
        opacity: 0.6,
        ...styleProps.sx
      },
      children: [jsx(Typography, {
        variant: "h6",
        color: "var(--theme-text)",
        children: "No Content Available"
      }), jsx(Typography, {
        variant: "body2",
        color: "var(--theme-text)",
        children: "No HTML content provided for this article"
      })]
    });
  }
  return jsx(Html, {
    component: "article",
    stripHeaders: skipHeader,
    placeholder: "No content available",
    ...htmlProps,
    ...otherProps,
    ...styleProps,
    sx: {
      // Modern article layout
      maxWidth: '900px',
      mx: 'auto',
      px: {
        xs: 2,
        sm: 3,
        md: 4
      },
      py: {
        xs: 3,
        md: 5
      },
      // Typography - Modern, readable hierarchy
      '& h1, & h2, & h3, & h4, & h5, & h6': {
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        fontWeight: 700,
        letterSpacing: '-0.02em',
        color: 'var(--theme-text)',
        scrollMarginTop: '100px',
        // For anchor links
        '&:first-of-type': {
          mt: 0
        }
      },
      '& h1': {
        fontSize: {
          xs: '2rem',
          md: '2.75rem'
        },
        lineHeight: 1.15,
        mb: 3,
        mt: 5
      },
      '& h2': {
        fontSize: {
          xs: '1.5rem',
          md: '2rem'
        },
        lineHeight: 1.25,
        mb: 2.5,
        mt: 5,
        pb: 1.5,
        borderBottom: '1px solid var(--theme-border-lighter)'
      },
      '& h3': {
        fontSize: {
          xs: '1.25rem',
          md: '1.5rem'
        },
        lineHeight: 1.3,
        mb: 2,
        mt: 4
      },
      '& h4': {
        fontSize: {
          xs: '1.1rem',
          md: '1.25rem'
        },
        lineHeight: 1.4,
        mb: 1.5,
        mt: 3,
        color: 'var(--theme-text)',
        fontWeight: 600
      },
      // Body text - Optimized for reading
      '& p': {
        fontSize: {
          xs: '1rem',
          md: '1.0625rem'
        },
        lineHeight: 1.75,
        mb: 2,
        color: 'var(--theme-text)',
        fontFamily: 'Georgia, "Times New Roman", serif',
        '&:last-child': {
          mb: 0
        }
      },
      // Lists - Better visual hierarchy
      '& ul, & ol': {
        mb: 3,
        pl: {
          xs: 3,
          md: 4
        },
        '& li': {
          mb: 1.25,
          lineHeight: 1.7,
          fontSize: {
            xs: '1rem',
            md: '1.0625rem'
          },
          color: 'var(--theme-text)',
          fontFamily: 'Georgia, "Times New Roman", serif',
          '&::marker': {
            color: 'var(--theme-primary)',
            fontWeight: 600
          },
          '& p': {
            mb: 0.5
          }
        },
        '& ul, & ol': {
          mt: 1,
          mb: 0
        }
      },
      // Code blocks - Modern syntax highlighting style
      '& pre': {
        backgroundColor: 'var(--theme-surface-elevated)',
        color: 'var(--theme-text)',
        borderRadius: 'var(--theme-border-radius)',
        p: {
          xs: 2,
          md: 3
        },
        mb: 3,
        overflow: 'auto',
        fontSize: '0.9rem',
        lineHeight: 1.6,
        fontFamily: '"Fira Code", "Cascadia Code", "SF Mono", Monaco, Consolas, monospace',
        border: '1px solid var(--theme-border-light)',
        boxShadow: 'var(--theme-elevation-2)',
        '& code': {
          backgroundColor: 'transparent',
          color: 'inherit',
          padding: 0,
          fontSize: 'inherit',
          fontFamily: 'inherit'
        }
      },
      // Inline code - Subtle highlight
      '& code': {
        backgroundColor: 'var(--theme-code-bg)',
        color: 'var(--theme-error)',
        padding: '0.2em 0.4em',
        borderRadius: 'var(--theme-border-radius-small)',
        fontSize: '0.9em',
        fontFamily: '"Fira Code", "Cascadia Code", "SF Mono", Monaco, Consolas, monospace',
        fontWeight: 500
      },
      // Blockquotes - Elegant callouts
      '& blockquote': {
        borderLeft: '4px solid var(--theme-primary)',
        backgroundColor: 'var(--theme-surface-variant)',
        borderRadius: `0 var(--theme-border-radius-small) var(--theme-border-radius-small) 0`,
        pl: 3,
        pr: 3,
        py: 2.5,
        my: 4,
        ml: 0,
        mr: 0,
        '& p': {
          fontSize: {
            xs: '1.05rem',
            md: '1.125rem'
          },
          fontStyle: 'italic',
          lineHeight: 1.6,
          mb: 1.5,
          color: 'var(--theme-text)',
          '&:last-child': {
            mb: 0
          }
        },
        '& cite': {
          display: 'block',
          fontSize: '0.9rem',
          fontStyle: 'normal',
          fontWeight: 500,
          color: 'var(--theme-text)',
          mt: 1,
          '&::before': {
            content: '"— "',
            color: 'var(--theme-primary)'
          }
        }
      },
      // Tables - Clean, modern design
      '& table': {
        width: '100%',
        borderCollapse: 'separate',
        borderSpacing: 0,
        mb: 3,
        fontSize: '0.95rem',
        overflow: 'hidden',
        borderRadius: 'var(--theme-border-radius-small)',
        border: '1px solid var(--theme-border-light)',
        '& thead': {
          backgroundColor: 'var(--theme-surface-variant)',
          '& th': {
            padding: '12px 16px',
            textAlign: 'left',
            fontWeight: 600,
            color: 'var(--theme-text)',
            borderBottom: '2px solid var(--theme-border-main)',
            fontSize: '0.875rem',
            textTransform: 'uppercase',
            letterSpacing: '0.05em'
          }
        },
        '& tbody': {
          '& tr': {
            borderBottom: '1px solid var(--theme-border-lighter)',
            transition: 'background-color 0.2s ease',
            '&:hover': {
              backgroundColor: 'var(--theme-surface-variant)'
            },
            '&:last-child': {
              borderBottom: 'none'
            }
          },
          '& td': {
            padding: '12px 16px',
            color: 'var(--theme-text)',
            lineHeight: 1.6
          }
        }
      },
      // Text emphasis
      '& strong': {
        fontWeight: 700,
        color: 'var(--theme-text)'
      },
      '& em': {
        fontStyle: 'italic',
        color: 'var(--theme-text)'
      },
      // Links - Modern, accessible
      '& a': {
        color: 'var(--theme-primary)',
        textDecoration: 'none',
        fontWeight: 500,
        borderBottom: '1px solid transparent',
        transition: 'border-color 0.2s ease',
        '&:hover': {
          borderBottomColor: 'var(--theme-primary)'
        },
        '&:focus-visible': {
          outline: '2px solid var(--theme-primary)',
          outlineOffset: '2px',
          borderRadius: '2px'
        }
      },
      // Images and figures
      '& img': {
        maxWidth: '100%',
        height: 'auto',
        borderRadius: 'var(--theme-border-radius-small)',
        display: 'block',
        my: 3
      },
      '& figure': {
        margin: '3rem 0',
        '& img': {
          maxWidth: '100%',
          height: 'auto',
          borderRadius: 'var(--theme-border-radius-small)',
          boxShadow: 'var(--theme-elevation-2)'
        },
        '& figcaption': {
          textAlign: 'center',
          fontSize: '0.875rem',
          color: 'var(--theme-text)',
          mt: 1.5,
          fontStyle: 'italic'
        }
      },
      // Horizontal rules
      '& hr': {
        border: 'none',
        borderTop: '1px solid var(--theme-border-light)',
        my: 5
      },
      ...styleProps.sx
    },
    children: html
  });
}
// Main component with data binding support and serialization capability
class Article extends ModelView {
  // Component-specific serialization properties
  getComponentSpecificProps() {
    return {
      html: this.props.html,
      skipHeader: this.props.skipHeader
    };
  }
  // Article component renders traditional props view
  renderView() {
    const {
      ...restProps
    } = this.props;
    return jsx(ArticleView, {
      ...restProps
    });
  }
  // Article component renders data-bound view
  renderWithDataBinding() {
    return jsx(ArticleWithDataBinding, {
      ...this.props
    });
  }
  // Register HTML patterns that Article component can handle
  static registerPatternHandlers(registry) {
    const typedRegistry = registry;
    // Register article elements
    if (typedRegistry.hasPattern && !typedRegistry.hasPattern('article')) {
      typedRegistry.registerPattern?.('article', Article.transformArticle);
    }
  }
  // Transform article elements to Article component
  static transformArticle(element) {
    const skipHeader = element.getAttribute('data-skip-header') === 'true';
    return {
      tagName: 'Article',
      props: {
        html: element.innerHTML,
        skipHeader
      }
    };
  }
}
// Component self-declaration for serialization
Article.tagName = 'Article';
Article.version = '1.0.0';
// Helper component to handle data binding with hooks (since we can't use hooks in class components)
function ArticleWithDataBinding(props) {
  const {
    dataSource,
    bindingOptions,
    ...restProps
  } = props;
  // Use data binding
  const {
    loading,
    error,
    ...articleProps
  } = useDataBinding(dataSource, restProps);
  // Show loading state
  if (loading) {
    return jsxs(Box, {
      component: "article",
      sx: {
        maxWidth: '800px',
        mx: 'auto',
        p: 4,
        textAlign: 'center'
      },
      children: [jsx(Typography, {
        variant: "h6",
        children: "Loading Article..."
      }), jsx(Typography, {
        variant: "body2",
        color: "var(--theme-text)",
        children: "Loading"
      })]
    });
  }
  if (error) {
    console.error('Error loading article:', error);
    return null;
  }
  return jsx(ArticleView, {
    ...articleProps
  });
}

function ContentView({
  title,
  subtitle,
  children,
  actions = [],
  variant = 'default',
  blockSpacing = 'comfortable',
  contentMaxWidth = 'md',
  centered = false,
  ...restProps
}) {
  const {
    styleProps,
    htmlProps,
    restProps: otherProps
  } = useBaseProps(restProps);
  const theme = useTheme$1();
  // Mark as QwickApp component
  Object.assign(ContentView, {
    [QWICKAPP_COMPONENT]: true
  });
  // Map spacing to padding values
  const getPadding = () => {
    switch (blockSpacing) {
      case 'none':
        return 0;
      case 'compact':
        return 2;
      // 16px
      case 'comfortable':
        return 3;
      // 24px
      case 'spacious':
        return 4;
      // 32px
      default:
        return 3;
    }
  };
  // Compute stable wrapper element (avoid recreating component type each render which caused remount & focus loss)
  const paddingValue = getPadding();
  const mappedMaxWidth = mapToMUIBreakpoint(contentMaxWidth === 'false' ? false : contentMaxWidth);
  const commonSx = {
    textAlign: centered ? 'center' : 'left',
    maxWidth: mappedMaxWidth !== false ? theme.breakpoints.values[mappedMaxWidth] : '100%',
    width: '100%',
    ...(centered && contentMaxWidth && {
      mx: 'auto'
    }),
    p: paddingValue,
    ...styleProps.sx
  };
  let Wrapper = Box;
  let wrapperProps = {
    ...htmlProps,
    ...otherProps,
    sx: commonSx
  };
  if (variant === 'elevated') {
    Wrapper = Paper;
    wrapperProps = {
      ...wrapperProps,
      elevation: 4,
      sx: {
        ...commonSx,
        backgroundColor: theme.palette.background.paper
      }
    };
  } else if (variant === 'outlined') {
    Wrapper = Paper;
    wrapperProps = {
      ...wrapperProps,
      variant: 'outlined',
      elevation: 0,
      sx: {
        ...commonSx,
        backgroundColor: 'var(--theme-surface)',
        borderColor: 'var(--theme-border-main)',
        borderWidth: 1,
        borderStyle: 'solid'
      }
    };
  } else if (variant === 'filled') {
    Wrapper = Box;
    wrapperProps = {
      ...wrapperProps,
      sx: {
        ...commonSx,
        backgroundColor: 'var(--theme-surface-variant)',
        borderRadius: 1
      }
    };
  }
  return jsx(Wrapper, {
    ...wrapperProps,
    children: jsxs(Stack, {
      spacing: 2,
      children: [(title || subtitle) && jsxs(Box, {
        children: [title && jsx(Typography, {
          variant: "h4",
          component: "h2",
          gutterBottom: Boolean(subtitle),
          sx: {
            fontWeight: 600,
            ...(centered && {
              textAlign: 'center'
            })
          },
          children: title
        }), subtitle && jsx(Typography, {
          variant: "h6",
          color: "text.secondary",
          sx: {
            ...(centered && {
              textAlign: 'center'
            })
          },
          children: subtitle
        })]
      }), children && jsx(Box, {
        sx: {
          '& > *:not(:last-child)': {
            mb: 2
          },
          ...(centered && {
            textAlign: 'center'
          })
        },
        children: typeof children === 'string' ?
        // Use Html component for string content (from data binding)
        jsx(Html, {
          children: children
        }) :
        // Use React nodes directly (traditional usage)
        children
      }), actions.length > 0 && jsx(Stack, {
        direction: "row",
        spacing: 2,
        sx: {
          ...(centered && {
            justifyContent: 'center',
            alignItems: 'center'
          }),
          flexWrap: 'wrap',
          gap: 1
        },
        children: actions.map((action, index) => jsx(Button, {
          ...action
        }, `action-${index}`))
      })]
    })
  });
}
function Content(props) {
  const {
    dataSource,
    bindingOptions,
    ...restProps
  } = props;
  // Always call hooks unconditionally
  const bindingResult = useDataBinding(dataSource || '', restProps);
  // If no dataSource, use traditional props
  if (!dataSource) {
    return jsx(ContentView, {
      ...restProps
    });
  }
  // Use data binding result
  const {
    loading,
    error,
    ...contentProps
  } = bindingResult;
  // Show loading state
  if (loading) {
    return jsx(ContentView, {
      ...restProps,
      title: "Loading Content...",
      variant: "default",
      blockSpacing: "comfortable"
    });
  }
  if (error) {
    console.error('Error loading content:', error);
    return null;
  }
  return jsx(ContentView, {
    ...contentProps
  });
}

const MoreIcon = MoreVert;
function PageBannerHeaderView({
  coverImage,
  profileImage,
  profileImageAlt = '',
  profileImageSize = 'large',
  overline,
  title,
  subtitle,
  metadata = [],
  tags = [],
  actions = [],
  maxVisibleActions = 3,
  height = 200,
  profilePosition = 'bottom-left',
  ...restProps
}) {
  const {
    gridProps,
    styleProps,
    htmlProps
  } = useBaseProps(restProps);
  const theme = useTheme$1();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [anchorEl, setAnchorEl] = React.useState(null);
  const isMenuOpen = Boolean(anchorEl);
  // Sort and split actions
  const sortedActions = [...actions].sort((a, b) => (a.priority || 999) - (b.priority || 999));
  const visibleActions = sortedActions.slice(0, maxVisibleActions);
  const overflowActions = sortedActions.slice(maxVisibleActions);
  const handleMenuOpen = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const getProfileSize = () => {
    switch (profileImageSize) {
      case 'small':
        return isMobile ? 64 : 80;
      case 'large':
        return isMobile ? 100 : 120;
      default:
        return isMobile ? 80 : 100;
    }
  };
  const renderProfileImage = () => {
    if (!profileImage) return null;
    const size = getProfileSize();
    const offset = profilePosition === 'bottom-left' ? 3 : 0;
    if (typeof profileImage === 'string') {
      return jsx(Avatar, {
        src: profileImage,
        alt: profileImageAlt,
        sx: {
          width: size,
          height: size,
          border: 4,
          borderColor: 'background.paper',
          position: 'absolute',
          bottom: profilePosition.includes('bottom') ? -offset : '50%',
          left: profilePosition === 'bottom-left' ? 3 : profilePosition === 'overlay-center' ? '50%' : 'auto',
          right: profilePosition === 'bottom-center' ? 'auto' : 'auto',
          transform: profilePosition === 'overlay-center' ? 'translate(-50%, 50%)' : profilePosition === 'bottom-center' ? 'translateX(-50%)' : 'none',
          zIndex: 2
        }
      });
    }
    return jsx(Avatar, {
      sx: {
        width: size,
        height: size,
        border: 4,
        borderColor: 'background.paper',
        position: 'absolute',
        bottom: profilePosition.includes('bottom') ? -offset : '50%',
        left: profilePosition === 'bottom-left' ? 3 : profilePosition === 'overlay-center' ? '50%' : 'auto',
        transform: profilePosition === 'overlay-center' ? 'translate(-50%, 50%)' : profilePosition === 'bottom-center' ? 'translateX(-50%)' : 'none',
        zIndex: 2
      },
      children: profileImage
    });
  };
  const renderMetadata = () => {
    if (metadata.length === 0) return null;
    return jsx(Box, {
      sx: {
        display: 'flex',
        gap: 2,
        flexWrap: 'wrap',
        mt: 0.5
      },
      children: metadata.map((item, index) => jsxs(Typography, {
        variant: "body2",
        color: "text.secondary",
        sx: {
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
          fontSize: '0.875rem'
        },
        children: [jsx("strong", {
          children: item.value
        }), " ", item.label]
      }, index))
    });
  };
  const renderTags = () => {
    if (tags.length === 0) return null;
    return jsx(Box, {
      sx: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 0.5,
        mt: 1
      },
      children: tags.map((tag, index) => jsx(Chip, {
        label: tag,
        size: "small",
        variant: "outlined",
        sx: {
          fontSize: '0.75rem',
          height: '24px'
        }
      }, index))
    });
  };
  const renderActions = () => {
    if (actions.length === 0) return null;
    return jsxs(Box, {
      sx: {
        display: 'flex',
        gap: 0.5,
        flexWrap: 'wrap'
      },
      children: [visibleActions.map(action => jsx(Button$1, {
        variant: action.id === visibleActions[0]?.id ? 'contained' : 'outlined',
        size: "small",
        startIcon: action.icon,
        onClick: action.onClick,
        disabled: action.disabled,
        color: action.destructive ? 'error' : 'primary',
        sx: {
          minHeight: 36,
          whiteSpace: 'nowrap',
          ...(isMobile && {
            minWidth: 36,
            '& .MuiButton-startIcon': {
              mr: {
                xs: 0,
                sm: 0.5
              }
            },
            '& .MuiButton-startIcon + *': {
              display: {
                xs: 'none',
                sm: 'inline'
              }
            }
          })
        },
        children: action.label
      }, action.id)), overflowActions.length > 0 && jsxs(Fragment, {
        children: [jsx(IconButton, {
          size: "small",
          onClick: handleMenuOpen,
          "aria-label": "More actions",
          sx: {
            minHeight: 36,
            minWidth: 36,
            borderRadius: 1,
            border: 1,
            borderColor: 'divider'
          },
          children: jsx(MoreIcon, {})
        }), jsx(Menu$1, {
          anchorEl: anchorEl,
          open: isMenuOpen,
          onClose: handleMenuClose,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right'
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'right'
          },
          children: overflowActions.map(action => jsxs(MenuItem, {
            onClick: () => {
              action.onClick();
              handleMenuClose();
            },
            disabled: action.disabled,
            sx: {
              color: action.destructive ? 'error.main' : 'inherit',
              gap: 1.5,
              minWidth: 200
            },
            children: [action.icon && jsx(Box, {
              component: "span",
              sx: {
                display: 'flex'
              },
              children: action.icon
            }), action.label]
          }, action.id))
        })]
      })]
    });
  };
  const profileOffset = profileImage ? getProfileSize() / 2 : 0;
  return jsxs(Paper, {
    component: "header",
    ...htmlProps,
    ...(gridProps && {
      'data-grid-span': gridProps.span,
      'data-grid-xs': gridProps.xs,
      'data-grid-sm': gridProps.sm,
      'data-grid-md': gridProps.md,
      'data-grid-lg': gridProps.lg,
      'data-grid-xl': gridProps.xl
    }),
    sx: {
      borderRadius: 2,
      overflow: 'hidden',
      position: 'relative',
      mb: profilePosition.includes('bottom') ? `${profileOffset}px` : 0,
      ...styleProps.sx
    },
    elevation: 3,
    children: [coverImage && jsx(Box, {
      sx: {
        width: '100%',
        height,
        backgroundImage: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url(${coverImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative'
      }
    }), renderProfileImage(), jsx(Box, {
      sx: {
        p: 3,
        pt: profilePosition === 'bottom-left' && profileImage ? `${profileOffset + 24}px` : 3,
        pl: profilePosition === 'bottom-left' && profileImage ? `${getProfileSize() + 32}px` : 3,
        position: 'relative',
        zIndex: 1
      },
      children: jsxs(Box, {
        sx: {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          flexWrap: {
            xs: 'wrap',
            md: 'nowrap'
          },
          gap: 2
        },
        children: [jsxs(Box, {
          sx: {
            flex: 1,
            minWidth: 0
          },
          children: [overline && jsx(Typography, {
            variant: "overline",
            color: "primary",
            sx: {
              display: 'block',
              fontSize: '0.75rem',
              fontWeight: 600,
              mb: 0.25
            },
            children: overline
          }), jsx(Typography, {
            variant: "h4",
            component: "h1",
            sx: {
              fontWeight: 600,
              lineHeight: 1.2,
              wordBreak: 'break-word',
              mb: subtitle ? 0.5 : 0,
              fontSize: {
                xs: '1.5rem',
                md: '2rem'
              }
            },
            children: title
          }), subtitle && jsx(Typography, {
            variant: "body1",
            color: "text.secondary",
            sx: {
              lineHeight: 1.4,
              mb: 0.5
            },
            children: subtitle
          }), renderMetadata(), renderTags()]
        }), jsx(Box, {
          sx: {
            flexShrink: 0,
            width: {
              xs: '100%',
              md: 'auto'
            },
            display: 'flex',
            justifyContent: {
              xs: 'flex-start',
              md: 'flex-end'
            },
            mt: {
              xs: 2,
              md: 0
            }
          },
          children: renderActions()
        })]
      })
    })]
  });
}
function PageBannerHeader(props) {
  const {
    dataSource,
    bindingOptions,
    ...restProps
  } = props;
  // Always call hooks unconditionally
  const bindingResult = useDataBinding(dataSource || '', restProps);
  // If no dataSource, use traditional props
  if (!dataSource) {
    return jsx(PageBannerHeaderView, {
      ...restProps
    });
  }
  // Use data binding result
  const {
    loading,
    error,
    ...modelProps
  } = bindingResult;
  // Convert HeaderActionModel[] to HeaderAction[] by adding default onClick handlers
  const convertedActions = modelProps.actions?.filter(action => typeof action.id === 'string').map(action => ({
    id: action.id,
    label: action.label,
    icon: action.icon,
    disabled: action.disabled,
    destructive: action.destructive,
    priority: action.priority,
    onClick: () => {
      console.debug(`Action clicked: ${action.id} - ${action.label}`);
      // In a real app, this would dispatch events or call configured handlers
    }
  }));
  const pageBannerHeaderProps = {
    ...modelProps,
    actions: convertedActions
  };
  // Show loading state  
  if (loading) {
    return jsxs(Paper, {
      component: "header",
      sx: {
        borderRadius: 2,
        overflow: 'hidden',
        p: 3,
        textAlign: 'center'
      },
      elevation: 3,
      children: [jsx(Typography, {
        variant: "h4",
        component: "h1",
        sx: {
          mb: 1
        },
        children: "Loading..."
      }), jsx(Typography, {
        variant: "body1",
        color: "text.secondary",
        children: "Loading page banner content..."
      })]
    });
  }
  if (error) {
    console.error('Error loading page banner header:', error);
    return null;
  }
  return jsx(PageBannerHeaderView, {
    ...pageBannerHeaderProps
  });
}

/**
 * TypeScript type definitions for CollapsibleLayout component
 *
 * Provides TypeScript interfaces that extend the schema model with React-specific types
 * and component-level functionality for the CollapsibleLayout component.
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
/**
 * Type guard to check if a component has CollapsibleLayout props
 */
function isCollapsibleLayoutProps(props) {
  return props && typeof props === 'object' && ('collapsed' in props || 'defaultCollapsed' in props);
}
/**
 * Default props for CollapsibleLayout component
 */
const defaultCollapsibleLayoutProps = {
  // Note: collapsed is intentionally omitted so components can be uncontrolled
  defaultCollapsed: false,
  triggerArea: 'both',
  animationStyle: 'slide',
  persistState: false,
  showDivider: true,
  variant: 'default',
  headerSpacing: 'comfortable',
  contentSpacing: 'comfortable',
  animationDuration: 300,
  disableAnimations: false,
  toggleAriaLabel: 'Toggle content visibility'
};
const animationConfigs = {
  fade: {
    duration: 300,
    easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
    opacity: [0, 1]
  },
  slide: {
    duration: 300,
    easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
    transform: 'translateY(-10px)'
  },
  scale: {
    duration: 200,
    easing: 'cubic-bezier(0.34, 1.56, 0.64, 1)',
    transform: 'scale(0.95)',
    opacity: [0, 1]
  }
};
const spacingConfigs = {
  compact: {
    padding: '8px 12px',
    gap: '4px'
  },
  comfortable: {
    padding: '16px 20px',
    gap: '8px'
  },
  spacious: {
    padding: '24px 32px',
    gap: '16px'
  }
};

const ExpandMoreIcon = ExpandMore;
const ExpandLessIcon = ExpandLess;
/**
 * Custom hook for managing collapsible state - simplified approach
 */
function useCollapsibleState(controlled, collapsedProp, defaultCollapsedProp, onToggleProp, persistState, storageKey) {
  const id = useId();
  const finalStorageKey = storageKey || `collapsible-${id}`;
  // For controlled components, use the prop; for uncontrolled, use internal state
  const [internalCollapsed, setInternalCollapsed] = useState(() => {
    if (controlled) {
      return collapsedProp ?? false;
    }
    // Try localStorage first if persistence is enabled
    if (persistState && typeof window !== 'undefined') {
      const stored = localStorage.getItem(finalStorageKey);
      if (stored !== null) {
        return JSON.parse(stored);
      }
    }
    return defaultCollapsedProp ?? false;
  });
  // Sync with controlled prop changes
  useEffect(() => {
    if (controlled && collapsedProp !== undefined) {
      setInternalCollapsed(collapsedProp);
    }
  }, [controlled, collapsedProp]);
  // Persist to localStorage for uncontrolled components
  useEffect(() => {
    if (!controlled && persistState && typeof window !== 'undefined') {
      localStorage.setItem(finalStorageKey, JSON.stringify(internalCollapsed));
    }
  }, [controlled, internalCollapsed, persistState, finalStorageKey]);
  const toggle = useCallback(() => {
    const currentState = controlled ? collapsedProp ?? false : internalCollapsed;
    const newCollapsed = !currentState;
    // Always update internal state for visual updates
    setInternalCollapsed(newCollapsed);
    // Call callback to notify parent
    onToggleProp?.(newCollapsed);
  }, [controlled, collapsedProp, internalCollapsed, onToggleProp]);
  const setCollapsed = useCallback(collapsed => {
    setInternalCollapsed(collapsed);
    onToggleProp?.(collapsed);
  }, [onToggleProp]);
  // Return the appropriate state
  const finalCollapsed = controlled ? collapsedProp ?? false : internalCollapsed;
  return {
    collapsed: finalCollapsed,
    toggle,
    setCollapsed,
    isControlled: controlled
  };
}
/**
 * Core CollapsibleLayout View component
 */
function CollapsibleLayoutView({
  // State props
  collapsed: collapsedProp,
  defaultCollapsed = false,
  onToggle,
  // Content props  
  title,
  subtitle,
  leadIcon,
  headerActions,
  collapsedView,
  children,
  footerView,
  // Behavior props
  triggerArea = 'both',
  animationStyle = 'slide',
  persistState = false,
  storageKey,
  animationDuration = 300,
  disableAnimations = false,
  // Icons
  collapsedIcon,
  expandedIcon,
  // Layout props
  showDivider = true,
  variant = 'default',
  headerSpacing = 'comfortable',
  contentSpacing = 'comfortable',
  // Accessibility
  toggleAriaLabel = 'Toggle content visibility',
  'aria-describedby': ariaDescribedBy,
  contentAriaProps = {},
  // CSS classes
  containerClassName,
  headerClassName,
  contentClassName,
  footerClassName,
  ...restProps
}) {
  const theme = useTheme$1();
  const {
    styleProps,
    htmlProps,
    restProps: otherProps
  } = useBaseProps(restProps);
  // Mark as QwickApp component
  Object.assign(CollapsibleLayoutView, {
    [QWICKAPP_COMPONENT]: true
  });
  // Determine controlled vs uncontrolled usage
  const controlled = collapsedProp !== undefined;
  // State management
  const {
    collapsed,
    toggle
  } = useCollapsibleState(controlled, collapsedProp, defaultCollapsed, onToggle, persistState, storageKey);
  // Get spacing configurations
  const headerSpacingConfig = spacingConfigs[headerSpacing];
  const contentSpacingConfig = spacingConfigs[contentSpacing];
  // Get animation configuration
  const animationConfig = animationConfigs[animationStyle];
  // Generate unique IDs for accessibility
  const headerId = useId();
  const contentId = useId();
  // Handle click events
  const handleHeaderClick = useCallback(event => {
    if (triggerArea === 'header' || triggerArea === 'both') {
      event.preventDefault();
      toggle();
    }
  }, [triggerArea, toggle]);
  const handleButtonClick = useCallback(event => {
    event.stopPropagation();
    toggle();
  }, [toggle]);
  // Render icons
  const renderIcon = useCallback((icon, defaultIcon) => {
    if (/*#__PURE__*/React.isValidElement(icon)) {
      return icon;
    }
    if (typeof icon === 'string') {
      return jsx(Html, {
        children: icon
      });
    }
    return defaultIcon;
  }, []);
  const toggleIcon = renderIcon(collapsed ? collapsedIcon : expandedIcon, collapsed ? jsx(ExpandMoreIcon, {}) : jsx(ExpandLessIcon, {}));
  // Container styles based on variant
  const containerSx = useMemo(() => {
    const baseSx = {
      width: '100%',
      position: 'relative',
      ...styleProps.sx
    };
    switch (variant) {
      case 'outlined':
        return {
          ...baseSx,
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: 1,
          backgroundColor: 'var(--theme-surface)'
        };
      case 'elevated':
        return {
          ...baseSx,
          boxShadow: theme.shadows[2],
          borderRadius: 1,
          backgroundColor: theme.palette.background.paper
        };
      case 'filled':
        return {
          ...baseSx,
          backgroundColor: 'var(--theme-surface-variant)',
          borderRadius: 1
        };
      default:
        return baseSx;
    }
  }, [variant, theme, styleProps.sx]);
  // Header styles
  const headerSx = useMemo(() => ({
    ...headerSpacingConfig,
    cursor: triggerArea === 'header' || triggerArea === 'both' ? 'pointer' : 'default',
    userSelect: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '&:hover': triggerArea === 'header' || triggerArea === 'both' ? {
      backgroundColor: 'rgba(0, 0, 0, 0.04)'
    } : {}
  }), [headerSpacingConfig, triggerArea]);
  // Content styles
  const contentSx = useMemo(() => ({
    ...contentSpacingConfig
  }), [contentSpacingConfig]);
  // Animation props for Collapse component
  const collapseProps = useMemo(() => {
    if (disableAnimations) {
      return {
        timeout: 0
      };
    }
    const baseProps = {
      timeout: animationDuration
    };
    switch (animationStyle) {
      case 'fade':
        return {
          ...baseProps,
          sx: {
            '& .MuiCollapse-wrapper': {
              opacity: collapsed ? 0 : 1,
              transition: `opacity ${animationDuration}ms ${animationConfig.easing}`
            }
          }
        };
      case 'scale':
        return {
          ...baseProps,
          sx: {
            '& .MuiCollapse-wrapper': {
              transform: collapsed ? 'scale(0.95)' : 'scale(1)',
              opacity: collapsed ? 0 : 1,
              transition: `all ${animationDuration}ms ${animationConfig.easing}`
            }
          }
        };
      default:
        // slide
        return baseProps;
    }
  }, [disableAnimations, animationDuration, animationStyle, animationConfig, collapsed]);
  // Render content based on type
  const renderContent = useCallback(content => {
    if (!content) return null;
    if (typeof content === 'string') {
      return jsx(Html, {
        children: content
      });
    }
    return content;
  }, []);
  // Container content that will be wrapped
  const containerContent = jsxs(Fragment, {
    children: [(title || subtitle || leadIcon || headerActions || triggerArea === 'button' || triggerArea === 'both') && jsxs(Fragment, {
      children: [jsxs(Box, {
        id: headerId,
        className: headerClassName,
        sx: headerSx,
        onClick: handleHeaderClick,
        role: triggerArea === 'header' || triggerArea === 'both' ? 'button' : undefined,
        tabIndex: triggerArea === 'header' || triggerArea === 'both' ? 0 : undefined,
        "aria-expanded": !collapsed,
        "aria-controls": contentId,
        "aria-describedby": ariaDescribedBy,
        onKeyDown: e => {
          if ((triggerArea === 'header' || triggerArea === 'both') && (e.key === 'Enter' || e.key === ' ')) {
            e.preventDefault();
            toggle();
          }
        },
        children: [jsxs(Stack, {
          direction: "row",
          spacing: 2,
          alignItems: "center",
          sx: {
            minWidth: 0,
            flex: 1
          },
          children: [leadIcon && jsx(Box, {
            sx: {
              flexShrink: 0
            },
            children: renderContent(leadIcon)
          }), (title || subtitle) && jsxs(Box, {
            sx: {
              minWidth: 0,
              flex: 1
            },
            children: [title && jsx(Typography, {
              variant: "h6",
              component: "h3",
              sx: {
                fontWeight: 600,
                lineHeight: 1.2,
                ...(subtitle && {
                  mb: 0.5
                })
              },
              children: title
            }), subtitle && jsx(Typography, {
              variant: "body2",
              color: "text.secondary",
              sx: {
                lineHeight: 1.3
              },
              children: subtitle
            })]
          })]
        }), jsxs(Stack, {
          direction: "row",
          spacing: 1,
          alignItems: "center",
          sx: {
            flexShrink: 0
          },
          children: [headerActions && jsx(Box, {
            children: renderContent(headerActions)
          }), jsx(IconButton, {
            onClick: handleButtonClick,
            size: "small",
            "aria-label": toggleAriaLabel,
            "aria-expanded": !collapsed,
            "aria-controls": contentId,
            children: toggleIcon
          })]
        })]
      }), showDivider && jsx(Divider, {})]
    }), collapsed && collapsedView && jsxs(Fragment, {
      children: [jsx(Box, {
        className: contentClassName,
        sx: contentSx,
        children: renderContent(collapsedView)
      }), showDivider && footerView && jsx(Divider, {})]
    }), jsxs(Collapse, {
      in: !collapsed,
      ...collapseProps,
      children: [jsx(Box, {
        id: contentId,
        className: contentClassName,
        sx: contentSx,
        role: "region",
        "aria-labelledby": title ? headerId : undefined,
        ...contentAriaProps,
        children: renderContent(children)
      }), showDivider && footerView && jsx(Divider, {})]
    }), footerView && jsx(Box, {
      className: footerClassName,
      sx: contentSx,
      children: renderContent(footerView)
    })]
  });
  // Return appropriate container based on variant
  if (variant === 'outlined') {
    return jsx(Paper, {
      variant: "outlined",
      elevation: 0,
      ...htmlProps,
      ...otherProps,
      className: containerClassName,
      sx: containerSx,
      children: containerContent
    });
  }
  if (variant === 'elevated') {
    return jsx(Paper, {
      elevation: 2,
      ...htmlProps,
      ...otherProps,
      className: containerClassName,
      sx: containerSx,
      children: containerContent
    });
  }
  // Default variant (default, filled)
  return jsx(Box, {
    ...htmlProps,
    ...otherProps,
    className: containerClassName,
    sx: containerSx,
    children: containerContent
  });
}
/**
 * Main CollapsibleLayout component with data binding support
 */
function CollapsibleLayout(props) {
  const {
    dataSource,
    bindingOptions,
    ...restProps
  } = props;
  // Always call hooks unconditionally
  const bindingResult = useDataBinding(dataSource || '', restProps);
  // If no dataSource, use traditional props
  if (!dataSource) {
    return jsx(CollapsibleLayoutView, {
      ...restProps
    });
  }
  // Use data binding result
  const {
    loading,
    error,
    ...collapsibleProps
  } = bindingResult;
  // Show loading state
  if (loading) {
    return jsx(CollapsibleLayoutView, {
      ...restProps,
      title: "Loading...",
      variant: "default",
      headerSpacing: "comfortable",
      contentSpacing: "comfortable"
    });
  }
  if (error) {
    console.error('Error loading collapsible layout:', error);
    return null;
  }
  return jsx(CollapsibleLayoutView, {
    ...collapsibleProps
  });
}
// Set default props
CollapsibleLayout.defaultProps = defaultCollapsibleLayoutProps;

/**
 * Core FeatureCard View component - handles feature card rendering
 */
function FeatureCardView({
  feature,
  features,
  variant = 'standard',
  actions,
  onClick,
  title = 'Key Features',
  elevation = 2,
  ...restProps
}) {
  const {
    styleProps,
    htmlProps
  } = useBaseProps(restProps);
  const theme = useTheme$1();
  // List variant for simple feature lists
  if (variant === 'list' && features) {
    return jsxs(Box, {
      ...htmlProps,
      ...styleProps,
      children: [jsx(Typography, {
        variant: "h6",
        component: "h4",
        sx: {
          mb: 1.5,
          fontSize: '1.1rem',
          fontWeight: 600
        },
        children: title
      }), jsx(Box, {
        component: "ul",
        sx: {
          m: 0,
          p: 0,
          listStyle: 'none'
        },
        children: features.map((featureText, index) => jsxs(Box, {
          component: "li",
          sx: {
            display: 'flex',
            alignItems: 'flex-start',
            mb: 0.5,
            gap: 1.5
          },
          children: [jsx(Box, {
            sx: {
              width: 6,
              height: 6,
              backgroundColor: 'primary.main',
              borderRadius: '50%',
              mt: 1,
              flexShrink: 0
            }
          }), jsx(Typography, {
            variant: "body2",
            sx: {
              fontSize: '0.95rem',
              lineHeight: 1.4,
              opacity: 0.8
            },
            children: featureText
          })]
        }, index))
      })]
    });
  }
  // Standard variant for feature items
  if (!feature) return null;
  const displayActions = actions || (feature.action ? [{
    id: 'default',
    label: 'Learn More',
    variant: 'contained',
    onClick: onClick || (() => {})
  }] : []);
  const handleClick = onClick || htmlProps?.onClick;
  const {
    onClick: _htmlOnClick,
    ...filteredHtmlProps
  } = htmlProps || {};
  return jsxs(Paper, {
    elevation: elevation,
    onClick: handleClick,
    sx: {
      p: 3,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      height: '100%',
      cursor: handleClick ? 'pointer' : 'default',
      transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
      '&:hover': handleClick ? {
        transform: 'translateY(-2px)',
        boxShadow: theme.shadows[4]
      } : {},
      ...styleProps.sx
    },
    style: styleProps.style,
    ...filteredHtmlProps,
    children: [feature.icon && jsx(Box, {
      sx: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 64,
        height: 64,
        mb: 2,
        borderRadius: '50%',
        backgroundColor: 'action.hover',
        color: 'primary.main'
      },
      children: feature.icon
    }), jsx(Typography, {
      variant: "h6",
      component: "h3",
      sx: {
        mb: feature.description ? 1 : 2,
        fontWeight: 600
      },
      children: feature.title
    }), feature.description && jsx(Typography, {
      variant: "body2",
      color: "text.secondary",
      sx: {
        mb: 2,
        flexGrow: 1,
        lineHeight: 1.5
      },
      children: feature.description
    }), feature.action && jsx(Box, {
      sx: {
        mt: 'auto'
      },
      children: feature.action
    }), displayActions.length > 0 && !feature.action && jsx(Box, {
      sx: {
        display: 'flex',
        gap: 1,
        mt: 'auto'
      },
      children: displayActions.map(action => jsx(Button, {
        variant: action.variant || 'contained',
        // color={action.color || 'primary'}
        disabled: action.disabled,
        onClick: action.onClick,
        children: action.label
      }, action.id))
    })]
  });
}
/**
 * FeatureCard component with data binding support
 * Supports both traditional props and dataSource-driven rendering
 */
function FeatureCard(props) {
  const {
    dataSource,
    bindingOptions,
    ...restProps
  } = props;
  // Mark as QwickApp component
  Object.assign(FeatureCard, {
    [QWICKAPP_COMPONENT]: true
  });
  // Always call hooks unconditionally
  const bindingResult = useDataBinding(dataSource || '', restProps);
  // If no dataSource, use traditional props
  if (!dataSource) {
    return jsx(FeatureCardView, {
      ...restProps
    });
  }
  // Use data binding result
  const {
    loading,
    error,
    ...featureProps
  } = bindingResult;
  // Show loading state
  if (loading) {
    return jsx(FeatureCardView, {
      ...restProps,
      feature: {
        id: 'loading-feature',
        title: 'Loading Feature...',
        description: 'Loading feature content from data source',
        icon: '⏳'
      },
      variant: "standard",
      elevation: 2
    });
  }
  if (error) {
    console.error('Error loading feature card:', error);
    return null;
  }
  // Pass through data directly - let component handle missing properties
  const transformedProps = featureProps;
  return jsx(FeatureCardView, {
    ...transformedProps
  });
}

/**
 * Core FeatureGrid View component - handles feature grid rendering
 */
function FeatureGridView({
  features = [],
  columns = 3,
  gap = 'medium',
  equalHeight = true,
  ...restProps
}) {
  const {
    styleProps,
    htmlProps
  } = useBaseProps(restProps);
  // Mark as QwickApp component
  Object.assign(FeatureGridView, {
    [QWICKAPP_COMPONENT]: true
  });
  // Map gap to spacing value for GridLayout
  const getSpacing = () => {
    switch (gap) {
      case 'small':
        return 'small';
      case 'medium':
        return 'medium';
      case 'large':
        return 'large';
      default:
        return 'medium';
    }
  };
  return jsx(GridLayout, {
    columns: columns,
    spacing: getSpacing(),
    equalHeight: equalHeight,
    ...htmlProps,
    ...styleProps,
    children: features.map(feature => jsx(FeatureCard, {
      feature: feature
    }, feature.id))
  });
}
function FeatureGrid(props) {
  const {
    dataSource,
    bindingOptions,
    ...restProps
  } = props;
  // Always call hooks unconditionally
  const bindingResult = useDataBinding(dataSource || '', restProps);
  // If no dataSource, use traditional props
  if (!dataSource) {
    return jsx(FeatureGridView, {
      ...restProps
    });
  }
  // Use data binding result
  const {
    loading,
    error,
    ...featureGridProps
  } = bindingResult;
  // Show loading state
  if (loading) {
    const loadingFeatures = Array.from({
      length: 3
    }, (_, i) => ({
      id: `loading-${i}`,
      title: 'Loading Feature...',
      description: 'Loading feature content from data source'
    }));
    return jsx(FeatureGridView, {
      features: loadingFeatures,
      columns: 3,
      gap: "medium",
      equalHeight: true
    });
  }
  if (error) {
    console.error('Error loading feature grid:', error);
    return null;
  }
  // Ensure features have a non-optional 'id'
  const safeFeatures = Array.isArray(featureGridProps.features) ? featureGridProps.features.map((f, idx) => ({
    ...f,
    id: f.id ?? `feature-${idx}`,
    title: f.title ?? '',
    description: f.description ?? ''
  })) : featureGridProps.features;
  // Ensure columns is one of the allowed values
  const allowedColumns = [1, 2, 3, 4, 5, 6];
  const columns = allowedColumns.includes(featureGridProps.columns) ? featureGridProps.columns : undefined;
  return jsx(FeatureGridView, {
    ...featureGridProps,
    features: safeFeatures,
    columns: columns
  });
}

function FooterView({
  sections = [],
  logo,
  copyright,
  legalText,
  orientation = 'vertical',
  variant = 'default',
  showDivider = true,
  ...restProps
}) {
  const {
    gridProps,
    styleProps,
    htmlProps
  } = useBaseProps(restProps);
  // Mark as QwickApp component
  Object.assign(FooterView, {
    [QWICKAPP_COMPONENT]: true
  });
  const theme = useTheme$1();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  // Force vertical on mobile for better usability
  const effectiveOrientation = isMobile ? 'vertical' : orientation;
  const renderFooterItem = item => {
    const content = jsx(Text$1, {
      variant: "body2",
      customColor: "var(--theme-text-secondary)",
      sx: {
        textDecoration: item.href ? 'none' : 'inherit',
        '&:hover': item.href ? {
          color: 'primary.main'
        } : {},
        cursor: item.href || item.onClick ? 'pointer' : 'default',
        transition: 'color 0.2s'
      },
      onClick: item.onClick,
      children: item.label
    });
    if (item.href) {
      return jsx(Link, {
        href: item.href,
        target: item.external ? '_blank' : undefined,
        rel: item.external ? 'noopener noreferrer' : undefined,
        underline: "none",
        sx: {
          display: 'block',
          mb: 0.5
        },
        children: content
      }, item.id);
    }
    return jsx(Box, {
      sx: {
        mb: 0.5
      },
      children: content
    }, item.id);
  };
  const renderSection = section => jsxs(Box, {
    sx: {
      minWidth: 0
    },
    children: [section.title && jsx(Text$1, {
      variant: "subtitle2",
      component: "h3",
      sx: {
        fontWeight: 600,
        mb: 1.5
      },
      customColor: "var(--theme-text-primary)",
      children: section.title
    }), jsx(Box, {
      children: section.items.map(item => renderFooterItem(item))
    })]
  }, section.id);
  const getContainerProps = () => {
    const baseProps = {
      component: 'footer',
      ...htmlProps,
      ...styleProps,
      ...(gridProps && {
        'data-grid-span': gridProps.span,
        'data-grid-xs': gridProps.xs,
        'data-grid-sm': gridProps.sm,
        'data-grid-md': gridProps.md,
        'data-grid-lg': gridProps.lg,
        'data-grid-xl': gridProps.xl
      }),
      sx: {
        mt: 'auto',
        py: 3,
        px: {
          xs: 2,
          sm: 3
        },
        ...styleProps.sx
      }
    };
    switch (variant) {
      case 'contained':
        return {
          ...baseProps,
          component: Paper,
          sx: {
            ...baseProps.sx,
            borderRadius: 0,
            backgroundColor: 'background.paper'
          }
        };
      case 'outlined':
        return {
          ...baseProps,
          component: Paper,
          sx: {
            ...baseProps.sx,
            borderRadius: 0,
            border: 1,
            borderColor: 'divider',
            backgroundColor: 'transparent'
          },
          variant: 'outlined'
        };
      default:
        return baseProps;
    }
  };
  const containerProps = getContainerProps();
  return jsxs(Fragment, {
    children: [showDivider && jsx(Divider, {}), jsxs(Box, {
      ...containerProps,
      children: [jsxs(Box, {
        sx: {
          maxWidth: 'lg',
          mx: 'auto',
          display: 'flex',
          flexDirection: effectiveOrientation === 'vertical' ? 'column' : 'row',
          gap: effectiveOrientation === 'vertical' ? 3 : 4,
          alignItems: effectiveOrientation === 'horizontal' ? 'flex-start' : 'stretch'
        },
        children: [logo && jsx(Box, {
          sx: {
            flexShrink: 0,
            mb: effectiveOrientation === 'vertical' ? 2 : 0,
            mr: effectiveOrientation === 'horizontal' ? 'auto' : 0
          },
          children: logo
        }), sections.length > 0 && jsx(Box, {
          sx: {
            display: 'flex',
            flexDirection: {
              xs: 'column',
              sm: effectiveOrientation === 'vertical' ? 'column' : 'row'
            },
            gap: {
              xs: 2,
              sm: 4
            },
            flex: 1,
            justifyContent: effectiveOrientation === 'horizontal' ? 'space-between' : 'flex-start'
          },
          children: sections.map(section => renderSection(section))
        })]
      }), (copyright || legalText) && jsx(Box, {
        sx: {
          mt: 3,
          pt: 2,
          borderTop: 1,
          borderColor: 'divider',
          maxWidth: 'lg',
          mx: 'auto'
        },
        children: jsxs(Box, {
          sx: {
            display: 'flex',
            flexDirection: {
              xs: 'column',
              sm: 'row'
            },
            justifyContent: 'space-between',
            alignItems: {
              xs: 'flex-start',
              sm: 'center'
            },
            gap: 1
          },
          children: [copyright && (typeof copyright === 'string' ? jsx(Text$1, {
            variant: "caption",
            customColor: 'var(--theme-text-secondary)',
            children: copyright
          }) : copyright), legalText && jsx(Text$1, {
            variant: "caption",
            customColor: "var(--theme-text-secondary)",
            children: legalText
          })]
        })
      })]
    })]
  });
}
function Footer(props) {
  const {
    dataSource,
    bindingOptions,
    ...restProps
  } = props;
  // Always call hooks unconditionally
  const bindingResult = useDataBinding(dataSource || '', restProps);
  // If no dataSource, use traditional props
  if (!dataSource) {
    return jsx(FooterView, {
      ...restProps
    });
  }
  // Use data binding result
  const {
    loading,
    error,
    ...footerProps
  } = bindingResult;
  // Show loading state
  if (loading) {
    return jsx(Box, {
      component: "footer",
      sx: {
        mt: 'auto',
        py: 3,
        px: {
          xs: 2,
          sm: 3
        },
        textAlign: 'center'
      },
      children: jsx(Text$1, {
        variant: "body2",
        customColor: "var(--theme-text-secondary)",
        children: "Loading Footer..."
      })
    });
  }
  if (error) {
    console.error('Error loading footer:', error);
    return null;
  }
  // Map FooterSectionModel[] to FooterSection[] and ensure id is a string
  const mappedSections = footerProps.sections?.map(section => ({
    ...section,
    id: section.id ?? '',
    // fallback to empty string if id is undefined
    items: section.items?.map(item => ({
      ...item,
      id: item.id ?? '',
      // fallback to empty string if id is undefined
      label: item.label ?? '' // ensure label is always a string
    })) ?? []
  })) ?? [];
  return jsx(FooterView, {
    ...footerProps,
    sections: mappedSections
  });
}

const ComingSoonIcon = Schedule;
const LaunchIcon = Launch;
const PreviewIcon = Visibility;
/**
 * Core ProductCard View component - handles product card rendering
 */
function ProductCardView({
  product,
  variant = 'compact',
  actions,
  onClick,
  showImage = true,
  showTechnologies = true,
  maxFeaturesCompact = 3,
  onAddToCart,
  ...restProps
}) {
  const {
    styleProps,
    htmlProps
  } = useBaseProps(restProps);
  const theme = useTheme$1();
  // Return null if no product data
  if (!product) return null;
  // Detect product type: e-commerce products have price field
  const isEcommerce = product.price !== undefined;
  // E-commerce helpers
  const formatPrice = price => {
    return `$${price.toFixed(2)}`;
  };
  const calculateDiscount = () => {
    if (!product.price || !product.salePrice) return 0;
    return Math.round((product.price - product.salePrice) / product.price * 100);
  };
  const getStatusIcon = status => {
    switch (status) {
      case 'launched':
        return jsx(LaunchIcon, {
          fontSize: "small"
        });
      case 'beta':
        return jsx(PreviewIcon, {
          fontSize: "small"
        });
      case 'coming-soon':
        return jsx(ComingSoonIcon, {
          fontSize: "small"
        });
    }
  };
  const getStatusColor = status => {
    switch (status) {
      default:
      case 'launched':
        return theme.palette.success.main;
      case 'beta':
        return theme.palette.warning.main;
      case 'coming-soon':
        return theme.palette.grey[500];
    }
  };
  const handleProductClick = () => {
    if (onClick) {
      onClick();
    }
    // Note: Navigation is handled by parent wrapper (e.g., Next.js Link in BlockRenderer)
    // For standalone usage, provide onClick prop with navigation logic
  };
  const getDefaultActions = () => {
    // E-commerce products get "Add to Cart" action
    if (isEcommerce) {
      return [{
        id: 'add-to-cart',
        label: 'Add to Cart',
        variant: 'contained',
        color: 'primary',
        onClick: () => {
          if (onAddToCart && product) {
            onAddToCart(product);
          }
        }
      }];
    }
    // Software products get status-based actions
    const actions = [{
      id: 'primary',
      label: product.status === 'launched' ? 'Learn More' : product.status === 'beta' ? 'Try Beta' : product.status === 'coming-soon' ? 'Coming Soon' : product.status,
      variant: 'contained',
      color: 'primary',
      disabled: product.status === 'coming-soon',
      onClick: handleProductClick
    }];
    if (variant === 'detailed' && product.status !== 'coming-soon') {
      actions.push({
        id: 'secondary',
        label: 'Learn More',
        variant: 'outlined',
        color: 'primary',
        onClick: () => window.location.hash = '#/contact'
      });
    }
    return actions;
  };
  const displayActions = actions || getDefaultActions();
  // INLINE WRAPPERS REFACTORED: Instead of inline component declarations (which cause remounts),
  // compute JSX fragments via plain variables/functions and inject directly.
  const featuresListElement = (() => {
    const featuresToShow = variant === 'compact' ? (product.features || []).slice(0, maxFeaturesCompact) : product.features || [];
    return jsxs(Box, {
      sx: {
        mb: variant === 'detailed' ? 2.5 : 2
      },
      children: [jsx(Typography, {
        variant: "h6",
        component: "h4",
        sx: {
          mb: 1.5,
          fontSize: '1.1rem',
          fontWeight: 600
        },
        children: "Key Features:"
      }), jsxs(Box, {
        component: "ul",
        sx: {
          m: 0,
          p: 0,
          listStyle: 'none'
        },
        children: [featuresToShow.map((feature, index) => jsxs(Box, {
          component: "li",
          sx: {
            display: 'flex',
            alignItems: 'flex-start',
            mb: 0.5,
            gap: 1.5
          },
          children: [jsx(Box, {
            sx: {
              width: 6,
              height: 6,
              backgroundColor: 'primary.main',
              borderRadius: '50%',
              mt: 1,
              flexShrink: 0
            }
          }), jsx(Typography, {
            variant: "body2",
            sx: {
              fontSize: '0.95rem',
              lineHeight: 1.4,
              opacity: 0.8
            },
            children: feature
          })]
        }, index)), variant === 'compact' && (product.features || []).length > maxFeaturesCompact && jsxs(Typography, {
          variant: "body2",
          color: "primary",
          sx: {
            fontSize: '0.9rem',
            pl: 2.5,
            fontWeight: 500
          },
          children: ["+", (product.features || []).length - maxFeaturesCompact, " more features"]
        })]
      })]
    });
  })();
  const technologiesSectionElement = !showTechnologies || variant === 'compact' || !product.technologies ? null : jsxs(Box, {
    sx: {
      mb: 3
    },
    children: [jsx(Typography, {
      variant: "h6",
      component: "h4",
      sx: {
        mb: 1.5,
        fontSize: '1rem',
        fontWeight: 600
      },
      children: "Technologies:"
    }), jsx(Box, {
      sx: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 1
      },
      children: product.technologies.map((tech, index) => jsx(Chip, {
        label: tech,
        variant: "outlined",
        size: "small",
        sx: {
          fontSize: '0.8rem',
          fontWeight: 500
        }
      }, index))
    })]
  });
  return jsxs(Box, {
    className: styleProps.className || "product-card",
    onClick: htmlProps.onClick || (variant === 'compact' ? handleProductClick : undefined),
    sx: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: 'background.paper',
      borderRadius: isEcommerce ? 2 : 3,
      border: '1px solid',
      borderColor: 'divider',
      overflow: 'hidden',
      position: 'relative',
      cursor: variant === 'compact' ? 'pointer' : 'default',
      transition: 'transform 0.2s ease, box-shadow 0.2s ease',
      '&:hover': variant === 'compact' ? {
        transform: 'translateY(-4px)',
        boxShadow: 3
      } : {},
      ...(styleProps.sx || {})
    },
    style: styleProps.style,
    children: [!isEcommerce && jsx(Chip, {
      icon: getStatusIcon(product.status),
      label: product.status.replace('-', ' '),
      sx: {
        position: 'absolute',
        top: 16,
        right: 16,
        backgroundColor: getStatusColor(product.status),
        color: 'white',
        fontSize: '0.8rem',
        fontWeight: 500,
        textTransform: 'capitalize',
        zIndex: 2,
        height: '28px',
        px: 1.5,
        '& .MuiChip-icon': {
          color: 'white'
        }
      }
    }), showImage && product.image && jsxs(Box, {
      sx: {
        width: '100%',
        height: isEcommerce ? 280 : variant === 'detailed' ? 240 : 200,
        backgroundColor: 'divider',
        position: 'relative'
      },
      children: [jsx(Box, {
        component: "img",
        src: product.image,
        alt: product.name,
        sx: {
          width: '100%',
          height: '100%',
          objectFit: 'cover'
        },
        onError: e => {
          const target = e.target;
          target.style.display = 'none';
          if (target.parentElement) {
            target.parentElement.style.background = 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';
            target.parentElement.innerHTML = `<div style="display: flex; align-items: center; justify-content: center; height: 100%; color: white; font-size: 1.5rem; font-weight: bold;">${product.name}</div>`;
          }
        }
      }), isEcommerce && jsxs(Fragment, {
        children: [jsxs(Box, {
          sx: {
            position: 'absolute',
            top: 12,
            left: 12,
            display: 'flex',
            flexDirection: 'column',
            gap: 0.5
          },
          children: [product.isNew && jsx(Chip, {
            label: "NEW",
            sx: {
              backgroundColor: 'primary.main',
              color: 'white',
              fontSize: '0.75rem',
              fontWeight: 600,
              height: '24px',
              px: 1
            }
          }), product.featured && jsx(Chip, {
            label: "POPULAR",
            sx: {
              backgroundColor: 'warning.main',
              color: 'white',
              fontSize: '0.75rem',
              fontWeight: 600,
              height: '24px',
              px: 1
            }
          })]
        }), jsx(Box, {
          sx: {
            position: 'absolute',
            top: 12,
            right: 12,
            display: 'flex',
            flexDirection: 'column',
            gap: 0.5
          },
          children: product.salePrice && product.price && jsxs(Fragment, {
            children: [jsx(Chip, {
              label: "ON SALE",
              sx: {
                backgroundColor: 'error.main',
                color: 'white',
                fontSize: '0.75rem',
                fontWeight: 600,
                height: '24px',
                px: 1
              }
            }), jsx(Chip, {
              label: `-${calculateDiscount()}%`,
              sx: {
                backgroundColor: 'error.dark',
                color: 'white',
                fontSize: '0.75rem',
                fontWeight: 600,
                height: '24px',
                px: 1
              }
            })]
          })
        })]
      })]
    }), jsxs(Box, {
      sx: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        p: isEcommerce ? 2 : 3
      },
      children: [isEcommerce ? (/* E-commerce product info */
      jsxs(Box, {
        children: [product.category && jsx(Typography, {
          variant: "caption",
          sx: {
            mb: 0.5,
            color: 'text.secondary',
            display: 'block'
          },
          children: product.category
        }), jsx(Typography, {
          variant: "h6",
          component: "h3",
          sx: {
            mb: 1,
            fontSize: '1rem',
            fontWeight: 500,
            lineHeight: 1.3,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical'
          },
          children: product.name
        }), product.rating !== undefined && product.rating > 0 && jsxs(Box, {
          sx: {
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            mb: 1
          },
          children: [jsx(Rating, {
            value: product.rating,
            readOnly: true,
            size: "small",
            precision: 0.5,
            emptyIcon: jsx(Star, {
              style: {
                opacity: 0.3
              },
              fontSize: "inherit"
            })
          }), product.reviewCount !== undefined && product.reviewCount > 0 && jsxs(Typography, {
            variant: "caption",
            sx: {
              color: 'text.secondary'
            },
            children: ["(", product.reviewCount, ")"]
          })]
        }), jsxs(Box, {
          sx: {
            mt: 'auto',
            display: 'flex',
            alignItems: 'center',
            gap: 1
          },
          children: [jsx(Typography, {
            variant: "h6",
            sx: {
              fontWeight: 600,
              color: product.salePrice ? 'primary.main' : 'inherit'
            },
            children: formatPrice(product.salePrice || product.price)
          }), product.salePrice && jsx(Typography, {
            variant: "body2",
            sx: {
              color: 'text.secondary',
              textDecoration: 'line-through'
            },
            children: formatPrice(product.price)
          })]
        })]
      })) : (/* Software product info */
      jsxs(Box, {
        sx: {
          mb: 3
        },
        children: [jsx(Typography, {
          variant: "h4",
          component: "h3",
          sx: {
            mb: 1,
            fontSize: variant === 'detailed' ? '1.75rem' : '1.5rem',
            fontWeight: 600
          },
          children: product.name
        }), jsx(Typography, {
          variant: "overline",
          sx: {
            mb: 1.5,
            color: 'primary.main',
            fontSize: '0.9rem',
            fontWeight: 500,
            letterSpacing: '0.5px',
            display: 'block'
          },
          children: product.category
        }), jsx(Typography, {
          variant: "body1",
          sx: {
            opacity: 0.8,
            lineHeight: 1.6
          },
          children: variant === 'detailed' ? product.description : product.shortDescription || product.description
        })]
      })), !isEcommerce && product.features && product.features.length > 0 && featuresListElement, !isEcommerce && product.technologies && product.technologies.length > 0 && technologiesSectionElement, jsx(Box, {
        sx: {
          display: 'flex',
          gap: 1.5,
          mt: 'auto',
          ...(variant === 'compact' && {
            justifyContent: 'center'
          })
        },
        children: displayActions.map(action => jsx(Button, {
          variant: action.variant || 'contained',
          // color={action.color || 'primary'}
          disabled: action.disabled,
          onClick: e => {
            // Prevent Link navigation when clicking button (e.g., Add to Cart)
            e.stopPropagation();
            e.preventDefault();
            action.onClick();
          },
          ...(variant === 'compact' && {
            fullWidth: true
          }),
          children: action.label
        }, action.id))
      })]
    })]
  });
}
/**
 * ProductCard component with data binding support
 * Supports both traditional props and dataSource-driven rendering
 */
function ProductCard(props) {
  const {
    dataSource,
    bindingOptions,
    ...restProps
  } = props;
  // Mark as QwickApp component
  Object.assign(ProductCard, {
    [QWICKAPP_COMPONENT]: true
  });
  // Always call hooks unconditionally
  const bindingResult = useDataBinding(dataSource || '', restProps);
  // If no dataSource, use traditional props
  if (!dataSource) {
    return jsx(ProductCardView, {
      ...restProps
    });
  }
  // Use data binding result
  const {
    loading,
    error,
    ...productProps
  } = bindingResult;
  // Show loading state
  if (loading) {
    return jsx(ProductCardView, {
      ...restProps,
      product: {
        id: 'loading-product',
        name: 'Loading Product...',
        category: 'Loading',
        description: 'Loading product information from data source',
        shortDescription: 'Loading...',
        features: ['Loading features...'],
        technologies: ['Loading'],
        status: 'coming-soon'
      },
      variant: restProps.variant || 'compact',
      showImage: false
    });
  }
  if (error) {
    console.error('Error loading product card:', error);
    return null;
  }
  // Pass through data directly - let component handle missing properties
  const transformedProps = productProps;
  return jsx(ProductCardView, {
    ...transformedProps
  });
}

// View component - handles the actual rendering
function ImageGalleryView({
  images = [],
  productName,
  variant = 'thumbnails',
  thumbnailPosition = 'left',
  aspectRatio = '1',
  showZoom = true,
  maxImages,
  dataSource,
  bindingOptions,
  ...restProps
}) {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [zoomOpen, setZoomOpen] = useState(false);
  // Limit images if maxImages is specified
  const displayImages = maxImages ? images.slice(0, maxImages) : images;
  const handlePrevious = useCallback(() => {
    setSelectedIndex(prev => prev === 0 ? displayImages.length - 1 : prev - 1);
  }, [displayImages.length]);
  const handleNext = useCallback(() => {
    setSelectedIndex(prev => prev === displayImages.length - 1 ? 0 : prev + 1);
  }, [displayImages.length]);
  const handleThumbnailClick = useCallback(index => {
    setSelectedIndex(index);
  }, []);
  const handleZoomOpen = useCallback(() => {
    if (showZoom) {
      setZoomOpen(true);
    }
  }, [showZoom]);
  const handleZoomClose = useCallback(() => {
    setZoomOpen(false);
  }, []);
  // Handle empty images
  if (!displayImages || displayImages.length === 0) {
    return jsx(Box, {
      ...restProps,
      sx: {
        backgroundColor: 'var(--theme-surface-variant)',
        borderRadius: 'var(--theme-border-radius)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        aspectRatio,
        minHeight: 400
      },
      children: jsx(Skeleton, {
        variant: "rectangular",
        width: "100%",
        height: "100%",
        sx: {
          borderRadius: 'var(--theme-border-radius)'
        }
      })
    });
  }
  const currentImage = displayImages[selectedIndex];
  // Render thumbnails
  const renderThumbnails = () => jsx(Box, {
    sx: {
      display: 'flex',
      flexDirection: thumbnailPosition === 'left' || thumbnailPosition === 'right' ? 'column' : 'row',
      gap: 1,
      overflow: 'auto',
      maxHeight: thumbnailPosition === 'left' || thumbnailPosition === 'right' ? 500 : 'auto',
      maxWidth: thumbnailPosition === 'bottom' ? '100%' : 'auto'
    },
    children: displayImages.map((image, index) => jsx(Box, {
      onClick: () => handleThumbnailClick(index),
      sx: {
        width: 80,
        height: 80,
        flexShrink: 0,
        cursor: 'pointer',
        border: '2px solid',
        borderColor: index === selectedIndex ? 'var(--theme-primary)' : 'var(--theme-border-main)',
        borderRadius: 'var(--theme-border-radius-small)',
        overflow: 'hidden',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          borderColor: 'var(--theme-border-emphasis)'
        }
      },
      children: jsx("img", {
        src: image.thumbnail || image.url,
        alt: `${productName} thumbnail ${index + 1}`,
        style: {
          width: '100%',
          height: '100%',
          objectFit: 'cover'
        }
      })
    }, index))
  });
  // Render main image container
  const renderMainImage = () => jsxs(Box, {
    sx: {
      position: 'relative',
      width: '100%',
      backgroundColor: 'var(--theme-surface)',
      borderRadius: 'var(--theme-border-radius)',
      border: '1px solid var(--theme-border-main)',
      overflow: 'hidden',
      aspectRatio
    },
    children: [jsx("img", {
      src: currentImage.url,
      alt: currentImage.alt || `${productName} - Image ${selectedIndex + 1}`,
      style: {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
        display: 'block'
      }
    }), showZoom && jsx(IconButton, {
      onClick: handleZoomOpen,
      sx: {
        position: 'absolute',
        top: 8,
        right: 8,
        backgroundColor: 'var(--theme-surface)',
        color: 'var(--theme-text-primary)',
        '&:hover': {
          backgroundColor: 'var(--theme-surface-variant)'
        }
      },
      "aria-label": "Zoom image",
      children: jsx(ZoomInIcon, {})
    }), variant === 'carousel' && displayImages.length > 1 && jsxs(Fragment, {
      children: [jsx(IconButton, {
        onClick: handlePrevious,
        sx: {
          position: 'absolute',
          left: 8,
          top: '50%',
          transform: 'translateY(-50%)',
          backgroundColor: 'var(--theme-surface)',
          color: 'var(--theme-text-primary)',
          '&:hover': {
            backgroundColor: 'var(--theme-surface-variant)'
          }
        },
        "aria-label": "Previous image",
        children: jsx(ChevronLeftIcon, {})
      }), jsx(IconButton, {
        onClick: handleNext,
        sx: {
          position: 'absolute',
          right: 8,
          top: '50%',
          transform: 'translateY(-50%)',
          backgroundColor: 'var(--theme-surface)',
          color: 'var(--theme-text-primary)',
          '&:hover': {
            backgroundColor: 'var(--theme-surface-variant)'
          }
        },
        "aria-label": "Next image",
        children: jsx(ChevronRightIcon, {})
      })]
    })]
  });
  // Render zoom modal
  const renderZoomModal = () => jsx(Modal, {
    open: zoomOpen,
    onClose: handleZoomClose,
    sx: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'rgba(0, 0, 0, 0.9)'
    },
    children: jsxs(Box, {
      sx: {
        position: 'relative',
        maxWidth: '90vw',
        maxHeight: '90vh',
        outline: 'none'
      },
      children: [jsx(IconButton, {
        onClick: handleZoomClose,
        sx: {
          position: 'absolute',
          top: -40,
          right: 0,
          color: 'white',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)'
          }
        },
        "aria-label": "Close zoom",
        children: jsx(Close, {})
      }), jsx("img", {
        src: currentImage.url,
        alt: currentImage.alt || `${productName} - Zoomed view`,
        style: {
          maxWidth: '100%',
          maxHeight: '90vh',
          objectFit: 'contain'
        }
      })]
    })
  });
  // Render thumbnails variant
  if (variant === 'thumbnails') {
    return jsxs(Box, {
      ...restProps,
      children: [jsxs(Box, {
        sx: {
          display: 'flex',
          flexDirection: {
            xs: 'column',
            sm: thumbnailPosition === 'bottom' ? 'column' : 'row'
          },
          gap: 2
        },
        children: [thumbnailPosition === 'left' && jsx(Box, {
          sx: {
            order: {
              xs: 2,
              sm: 1
            }
          },
          children: renderThumbnails()
        }), jsx(Box, {
          sx: {
            flex: 1,
            order: {
              xs: 1,
              sm: thumbnailPosition === 'left' ? 2 : 1
            }
          },
          children: renderMainImage()
        }), thumbnailPosition === 'right' && jsx(Box, {
          sx: {
            order: {
              xs: 2,
              sm: 2
            }
          },
          children: renderThumbnails()
        }), thumbnailPosition === 'bottom' && jsx(Box, {
          sx: {
            order: 2
          },
          children: renderThumbnails()
        })]
      }), renderZoomModal()]
    });
  }
  // Render carousel variant
  if (variant === 'carousel') {
    return jsxs(Box, {
      ...restProps,
      children: [renderMainImage(), displayImages.length > 1 && jsx(Box, {
        sx: {
          display: 'flex',
          justifyContent: 'center',
          gap: 1,
          mt: 2
        },
        children: displayImages.map((_, index) => jsx(Box, {
          onClick: () => handleThumbnailClick(index),
          sx: {
            width: 10,
            height: 10,
            borderRadius: '50%',
            backgroundColor: index === selectedIndex ? 'var(--theme-primary)' : 'var(--theme-border-main)',
            cursor: 'pointer',
            transition: 'all 0.2s ease-in-out',
            '&:hover': {
              backgroundColor: index === selectedIndex ? 'var(--theme-primary)' : 'var(--theme-border-emphasis)'
            }
          }
        }, index))
      }), renderZoomModal()]
    });
  }
  // Render grid variant
  if (variant === 'grid') {
    return jsxs(Box, {
      ...restProps,
      children: [jsx(GridLayout, {
        columns: 4,
        spacing: "medium",
        children: displayImages.map((image, index) => jsx(GridCell, {
          xs: 6,
          sm: 4,
          md: 3,
          children: jsx(Box, {
            onClick: () => {
              setSelectedIndex(index);
              handleZoomOpen();
            },
            sx: {
              width: '100%',
              aspectRatio: '1',
              borderRadius: 'var(--theme-border-radius)',
              border: '1px solid var(--theme-border-main)',
              overflow: 'hidden',
              cursor: showZoom ? 'pointer' : 'default',
              transition: 'all 0.2s ease-in-out',
              '&:hover': {
                borderColor: 'var(--theme-border-emphasis)',
                boxShadow: 'var(--theme-elevation-1)'
              }
            },
            children: jsx("img", {
              src: image.url,
              alt: image.alt || `${productName} - Image ${index + 1}`,
              style: {
                width: '100%',
                height: '100%',
                objectFit: 'cover'
              }
            })
          })
        }, index))
      }), renderZoomModal()]
    });
  }
  return null;
}
// Create the serializable ImageGallery component using the factory
const ImageGallery = createSerializableView({
  tagName: 'ImageGallery',
  version: '1.0.0',
  role: 'view',
  View: ImageGalleryView
});

// View component
function OptionSelectorView({
  options = [],
  selectedOption,
  onOptionSelect,
  displayMode = 'text',
  variant = 'grid',
  layout = 'wrap',
  visualSize = 'medium',
  showLabel = false,
  disabled = false,
  label = 'Select Option',
  dataSource,
  bindingOptions,
  // Exclude ViewProps that conflict with MUI FormControl types
  margin: _margin,
  marginTop: _marginTop,
  marginRight: _marginRight,
  marginBottom: _marginBottom,
  marginLeft: _marginLeft,
  marginX: _marginX,
  marginY: _marginY,
  padding: _padding,
  paddingTop: _paddingTop,
  paddingRight: _paddingRight,
  paddingBottom: _paddingBottom,
  paddingLeft: _paddingLeft,
  paddingX: _paddingX,
  paddingY: _paddingY,
  ...restProps
}) {
  const handleOptionClick = useCallback((optionId, available) => {
    if (!disabled && available && onOptionSelect) {
      onOptionSelect(optionId);
    }
  }, [disabled, onOptionSelect]);
  const handleDropdownChange = useCallback(event => {
    if (onOptionSelect) {
      onOptionSelect(event.target.value);
    }
  }, [onOptionSelect]);
  // Get visual size in pixels
  const getSizePixels = () => {
    if (displayMode === 'text') return 48;
    switch (visualSize) {
      case 'small':
        return 32;
      case 'large':
        return 56;
      case 'medium':
      default:
        return 44;
    }
  };
  const sizeInPx = getSizePixels();
  // Render nothing if no options
  if (!options || options.length === 0) {
    return null;
  }
  // Dropdown variant
  if (variant === 'dropdown') {
    return jsxs(FormControl, {
      fullWidth: true,
      disabled: disabled,
      ...restProps,
      sx: {
        '& .MuiOutlinedInput-root': {
          '& fieldset': {
            borderColor: 'var(--theme-border-main)'
          },
          '&:hover fieldset': {
            borderColor: 'var(--theme-border-emphasis)'
          },
          '&.Mui-focused fieldset': {
            borderColor: 'var(--theme-primary)'
          }
        },
        '& .MuiInputLabel-root': {
          color: 'var(--theme-text-secondary)',
          '&.Mui-focused': {
            color: 'var(--theme-primary)'
          }
        }
      },
      children: [jsx(InputLabel, {
        children: label
      }), jsx(Select, {
        value: selectedOption || '',
        onChange: handleDropdownChange,
        label: label,
        sx: {
          backgroundColor: 'var(--theme-surface)',
          color: 'var(--theme-text-primary)'
        },
        children: options.map(option => jsxs(MenuItem, {
          value: option.id,
          disabled: !option.available,
          sx: {
            color: option.available ? 'var(--theme-text-primary)' : 'var(--theme-text-disabled)'
          },
          children: [displayMode === 'color' && option.hexValue && jsx(Box, {
            sx: {
              width: 20,
              height: 20,
              mr: 1,
              borderRadius: '50%',
              backgroundColor: option.hexValue,
              border: '1px solid var(--theme-border-main)',
              backgroundImage: option.imageUrl ? `url(${option.imageUrl})` : undefined,
              backgroundSize: 'cover'
            }
          }), option.label, !option.available && ' (Out of stock)', option.price && option.price !== 0 && ` (+$${(option.price / 100).toFixed(2)})`]
        }, option.id))
      })]
    });
  }
  // Buttons/Grid variant with visual modes
  const getLayoutStyles = () => {
    if (variant === 'grid') {
      const minWidth = displayMode === 'text' ? 60 : sizeInPx + 16;
      return {
        display: 'grid',
        gridTemplateColumns: `repeat(auto-fill, minmax(${minWidth}px, 1fr))`,
        gap: displayMode === 'text' ? 1 : 2
      };
    }
    return {
      display: 'flex',
      flexDirection: layout === 'vertical' ? 'column' : 'row',
      flexWrap: layout === 'wrap' ? 'wrap' : 'nowrap',
      gap: 1
    };
  };
  return jsxs(Box, {
    ...restProps,
    children: [label && jsx(Box, {
      component: "label",
      sx: {
        display: 'block',
        mb: 1,
        fontSize: '0.875rem',
        fontWeight: 500,
        color: 'var(--theme-text-primary)'
      },
      children: label
    }), jsx(Box, {
      sx: getLayoutStyles(),
      children: options.map(option => {
        const isSelected = selectedOption === option.id;
        const isAvailable = option.available;
        // Text mode - render as buttons
        if (displayMode === 'text') {
          const button = jsx(Button$1, {
            onClick: () => handleOptionClick(option.id, isAvailable),
            disabled: disabled || !isAvailable,
            variant: isSelected ? 'contained' : 'outlined',
            sx: {
              minWidth: variant === 'grid' ? '60px' : '80px',
              height: `${sizeInPx}px`,
              borderRadius: 'var(--theme-border-radius-small)',
              textTransform: 'uppercase',
              fontWeight: 600,
              fontSize: '0.875rem',
              backgroundColor: isSelected ? 'var(--theme-primary)' : 'var(--theme-surface)',
              color: isSelected ? 'var(--theme-text-on-primary)' : 'var(--theme-text-primary)',
              borderColor: isSelected ? 'var(--theme-primary)' : 'var(--theme-border-main)',
              borderWidth: '2px',
              borderStyle: 'solid',
              '&.Mui-disabled': {
                backgroundColor: 'var(--theme-surface-variant)',
                color: 'var(--theme-text-disabled)',
                borderColor: 'var(--theme-border-light)',
                opacity: 0.5,
                textDecoration: 'line-through'
              },
              '&:hover:not(.Mui-disabled)': {
                backgroundColor: !isSelected ? 'var(--theme-surface-variant)' : undefined,
                borderColor: !isSelected ? 'var(--theme-border-emphasis)' : undefined,
                boxShadow: 'var(--theme-elevation-1)'
              },
              transition: 'all 0.2s ease-in-out'
            },
            children: option.label
          }, option.id);
          return !isAvailable ? jsx(Tooltip, {
            title: "Not available",
            arrow: true,
            sx: {
              '& .MuiTooltip-tooltip': {
                backgroundColor: 'var(--theme-surface)',
                color: 'var(--theme-text-primary)',
                border: '1px solid var(--theme-border-main)',
                boxShadow: 'var(--theme-elevation-2)'
              },
              '& .MuiTooltip-arrow': {
                color: 'var(--theme-surface)'
              }
            },
            children: jsx("span", {
              children: button
            })
          }, option.id) : button;
        }
        // Color/Image mode - render as visual swatches
        const swatchContent = jsxs(Box, {
          onClick: () => handleOptionClick(option.id, isAvailable),
          sx: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 0.5,
            cursor: disabled || !isAvailable ? 'not-allowed' : 'pointer',
            opacity: disabled || !isAvailable ? 0.5 : 1
          },
          children: [jsx(Box, {
            sx: {
              position: 'relative',
              width: sizeInPx,
              height: sizeInPx,
              borderRadius: displayMode === 'color' ? '50%' : 'var(--theme-border-radius-small)',
              backgroundColor: option.hexValue || 'var(--theme-surface-variant)',
              backgroundImage: option.imageUrl ? `url(${option.imageUrl})` : undefined,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              border: '2px solid',
              borderColor: isSelected ? 'var(--theme-primary)' : 'var(--theme-border-main)',
              boxShadow: isSelected ? 'var(--theme-elevation-2)' : 'none',
              transition: 'all 0.2s ease-in-out',
              ...(isAvailable && !disabled && !isSelected && {
                '&:hover': {
                  borderColor: 'var(--theme-border-emphasis)',
                  boxShadow: 'var(--theme-elevation-1)',
                  transform: 'scale(1.05)'
                }
              }),
              ...(!isAvailable && {
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  top: '50%',
                  left: '10%',
                  right: '10%',
                  height: '2px',
                  backgroundColor: 'var(--theme-border-emphasis)',
                  transform: 'translateY(-50%) rotate(-45deg)'
                }
              })
            },
            children: isSelected && jsx(Box, {
              sx: {
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100%',
                borderRadius: 'inherit',
                backgroundColor: 'rgba(0, 0, 0, 0.3)'
              },
              children: jsx(Check, {
                sx: {
                  color: 'white',
                  fontSize: sizeInPx * 0.5,
                  filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.5))'
                }
              })
            })
          }), showLabel && jsx(Box, {
            sx: {
              fontSize: '0.75rem',
              color: 'var(--theme-text-secondary)',
              textAlign: 'center',
              maxWidth: sizeInPx + 16,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            },
            children: option.label
          })]
        }, option.id);
        return jsx(Tooltip, {
          title: !isAvailable ? 'Not available' : option.label,
          arrow: true,
          sx: {
            '& .MuiTooltip-tooltip': {
              backgroundColor: 'var(--theme-surface)',
              color: 'var(--theme-text-primary)',
              border: '1px solid var(--theme-border-main)',
              boxShadow: 'var(--theme-elevation-2)'
            },
            '& .MuiTooltip-arrow': {
              color: 'var(--theme-surface)'
            }
          },
          children: swatchContent
        }, option.id);
      })
    })]
  });
}
// Create the serializable component
const OptionSelector = createSerializableView({
  tagName: 'OptionSelector',
  version: '1.0.0',
  role: 'view',
  View: OptionSelectorView
});

// Default render function based on component type
const getDefaultRenderItem = (renderComponent = 'ProductCard', itemProps = {}) => {
  return (item, index) => {
    const key = item?.id || item?.key || index;
    switch (renderComponent) {
      case 'ProductCard':
        return jsx(ProductCard, {
          product: item,
          ...itemProps
        }, key);
      case 'FeatureCard':
        return jsx(FeatureCard, {
          feature: item,
          ...itemProps
        }, key);
      case 'Custom':
      default:
        // For custom components, assume the item contains the component data
        return jsx("div", {
          children: JSON.stringify(item)
        }, key);
    }
  };
};
// View component - handles the actual rendering
function CardListGridView({
  items = [],
  renderItem,
  renderComponent = 'ProductCard',
  itemProps = {},
  columns = 2,
  spacing = 'large',
  equalHeight = true,
  ...restProps
}) {
  const {
    styleProps,
    htmlProps,
    restProps: otherProps
  } = useBaseProps(restProps);
  // Return null if no items and no render function
  if (!items.length && !renderItem) {
    return null;
  }
  // Use provided renderItem or create default based on renderComponent
  const actualRenderItem = renderItem || getDefaultRenderItem(renderComponent, itemProps);
  return jsx(GridLayout, {
    columns: columns,
    spacing: spacing,
    equalHeight: equalHeight,
    ...htmlProps,
    ...styleProps,
    ...otherProps,
    children: items.map((item, index) => actualRenderItem(item, index))
  });
}
// Main component with data binding support
function CardListGrid(props) {
  const {
    dataSource,
    bindingOptions,
    ...restProps
  } = props;
  // Always call hooks unconditionally
  const result = useDataBinding(dataSource || '', restProps);
  // If no dataSource, use traditional props
  if (!dataSource) {
    return jsx(CardListGridView, {
      ...restProps
    });
  }
  // Use data binding result
  const {
    loading,
    error,
    ...cardListGridProps
  } = result;
  // Show loading state
  if (loading) {
    return jsx(GridLayout, {
      columns: restProps.columns || 2,
      spacing: restProps.spacing || 'large',
      style: {
        textAlign: 'center',
        padding: '2rem'
      },
      children: jsx("div", {
        children: "Loading..."
      })
    });
  }
  if (error) {
    console.error('Error loading card list grid:', error);
    return null;
  }
  return jsx(CardListGridView, {
    ...cardListGridProps
  });
}

const DarkModeIcon = DarkMode;
const LightModeIcon = LightMode;
const SystemIcon = SettingsSystemDaydream;
// View component - handles the actual rendering
function ThemeSwitcherView({
  disabled = false,
  size = 'medium',
  tooltipText,
  showTooltip = true,
  menuPosition = 'bottom',
  showLightTheme = true,
  showDarkTheme = true,
  showSystemTheme = true,
  ...restProps
}) {
  const {
    styleProps,
    htmlProps
  } = useBaseProps(restProps);
  const {
    currentTheme,
    actualThemeMode,
    setPreferredTheme
  } = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = event => {
    if (disabled) return;
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleThemeSelect = newTheme => {
    if (disabled) return;
    setPreferredTheme(newTheme);
    handleClose();
  };
  const getCurrentIcon = () => {
    switch (actualThemeMode) {
      case 'dark':
        return jsx(DarkModeIcon, {});
      case 'light':
        return jsx(LightModeIcon, {});
      default:
        return jsx(LightModeIcon, {});
    }
  };
  const getTooltipText = () => {
    if (tooltipText) return tooltipText;
    if (disabled) return 'Theme switcher disabled';
    const modeText = currentTheme === 'system' ? `System (${actualThemeMode})` : currentTheme.charAt(0).toUpperCase() + currentTheme.slice(1);
    return `Current theme: ${modeText}`;
  };
  const getMenuAnchorOrigin = () => {
    switch (menuPosition) {
      case 'top':
        return {
          vertical: 'top',
          horizontal: 'right'
        };
      case 'left':
        return {
          vertical: 'bottom',
          horizontal: 'left'
        };
      case 'right':
        return {
          vertical: 'bottom',
          horizontal: 'right'
        };
      default:
        // bottom
        return {
          vertical: 'bottom',
          horizontal: 'right'
        };
    }
  };
  const getMenuTransformOrigin = () => {
    switch (menuPosition) {
      case 'top':
        return {
          vertical: 'bottom',
          horizontal: 'right'
        };
      case 'left':
        return {
          vertical: 'top',
          horizontal: 'right'
        };
      case 'right':
        return {
          vertical: 'top',
          horizontal: 'left'
        };
      default:
        // bottom
        return {
          vertical: 'top',
          horizontal: 'right'
        };
    }
  };
  // If no theme options are enabled, show error in development
  if (!showLightTheme && !showDarkTheme && !showSystemTheme) {
    return null;
  }
  const themeSwitcher = jsxs("span", {
    suppressHydrationWarning: true,
    children: [jsx(IconButton, {
      ...htmlProps,
      onClick: handleClick,
      disabled: disabled,
      size: size,
      "aria-label": "theme switcher",
      "aria-controls": open ? 'theme-menu' : undefined,
      "aria-haspopup": "true",
      "aria-expanded": open ? 'true' : undefined,
      suppressHydrationWarning: true,
      sx: {
        color: 'var(--theme-on-surface, inherit)',
        '&:hover': {
          backgroundColor: 'var(--menu-hover, rgba(0, 0, 0, 0.04))'
        },
        '&:disabled': {
          color: 'var(--theme-disabled, rgba(0, 0, 0, 0.26))'
        },
        ...styleProps.sx
      },
      className: styleProps.className,
      children: getCurrentIcon()
    }), jsxs(Menu$1, {
      id: "theme-menu",
      anchorEl: anchorEl,
      open: open,
      onClose: handleClose,
      slotProps: {
        paper: {
          'aria-labelledby': 'theme-button'
        }
      },
      anchorOrigin: getMenuAnchorOrigin(),
      transformOrigin: getMenuTransformOrigin(),
      children: [showLightTheme && jsxs(MenuItem, {
        onClick: () => handleThemeSelect('light'),
        selected: currentTheme === 'light',
        children: [jsx(ListItemIcon, {
          children: jsx(LightModeIcon, {
            fontSize: "small"
          })
        }), jsx(ListItemText, {
          children: "Light"
        })]
      }), showDarkTheme && jsxs(MenuItem, {
        onClick: () => handleThemeSelect('dark'),
        selected: currentTheme === 'dark',
        children: [jsx(ListItemIcon, {
          children: jsx(DarkModeIcon, {
            fontSize: "small"
          })
        }), jsx(ListItemText, {
          children: "Dark"
        })]
      }), showSystemTheme && jsxs(MenuItem, {
        onClick: () => handleThemeSelect('system'),
        selected: currentTheme === 'system',
        children: [jsx(ListItemIcon, {
          children: jsx(SystemIcon, {
            fontSize: "small"
          })
        }), jsx(ListItemText, {
          children: "System"
        })]
      })]
    })]
  });
  return showTooltip ? jsx(Tooltip, {
    title: getTooltipText(),
    children: themeSwitcher
  }) : themeSwitcher;
}
/**
 * ThemeSwitcher component with data binding support
 * Supports both traditional props and dataSource-driven rendering
 */
function ThemeSwitcher(props) {
  const {
    dataSource,
    bindingOptions,
    ...restProps
  } = props;
  // Always call hooks unconditionally
  const bindingResult = useDataBinding(dataSource || '', restProps);
  // If no dataSource, use traditional props
  if (!dataSource) {
    return jsx(ThemeSwitcherView, {
      ...restProps
    });
  }
  // Use data binding result
  const {
    loading,
    error,
    ...themeSwitcherProps
  } = bindingResult;
  // Show loading state
  if (loading) {
    return jsx(IconButton, {
      disabled: true,
      size: "medium",
      children: jsx(LightModeIcon, {})
    });
  }
  if (error) {
    console.error('Error loading theme switcher:', error);
    return null;
  }
  return jsx(ThemeSwitcherView, {
    ...themeSwitcherProps
  });
}
// Mark as QwickApp component
Object.assign(ThemeSwitcher, {
  [QWICKAPP_COMPONENT]: true
});

const DimensionsContext = /*#__PURE__*/createContext(undefined);
// Default dimension tokens
const getDefaultTokens = (screenSize, isCompact) => {
  const compactMultiplier = isCompact ? 0.9 : 1.0;
  let baseTokens;
  switch (screenSize) {
    case 'mobile':
      baseTokens = {
        borderRadius: {
          small: 6,
          medium: 10,
          large: 14
        },
        typography: {
          scaleMultiplier: 0.9,
          lineHeightMultiplier: 1.0
        },
        spacing: {
          scaleMultiplier: 0.8
        },
        component: {
          buttonHeight: 44,
          inputHeight: 44,
          iconSize: 20
        }
      };
      break;
    case 'tablet':
      baseTokens = {
        borderRadius: {
          small: 8,
          medium: 12,
          large: 16
        },
        typography: {
          scaleMultiplier: 0.95,
          lineHeightMultiplier: 1.0
        },
        spacing: {
          scaleMultiplier: 0.9
        },
        component: {
          buttonHeight: 40,
          inputHeight: 40,
          iconSize: 22
        }
      };
      break;
    case 'desktop':
    default:
      baseTokens = {
        borderRadius: {
          small: 8,
          medium: 12,
          large: 16
        },
        typography: {
          scaleMultiplier: 1.0,
          lineHeightMultiplier: 1.0
        },
        spacing: {
          scaleMultiplier: 1.0
        },
        component: {
          buttonHeight: 36,
          inputHeight: 36,
          iconSize: 24
        }
      };
      break;
  }
  // Apply compact mode multiplier
  return {
    ...baseTokens,
    typography: {
      scaleMultiplier: baseTokens.typography.scaleMultiplier * compactMultiplier,
      lineHeightMultiplier: baseTokens.typography.lineHeightMultiplier * compactMultiplier
    },
    spacing: {
      scaleMultiplier: baseTokens.spacing.scaleMultiplier * compactMultiplier
    },
    component: {
      buttonHeight: Math.round(baseTokens.component.buttonHeight * compactMultiplier),
      inputHeight: Math.round(baseTokens.component.inputHeight * compactMultiplier),
      iconSize: Math.round(baseTokens.component.iconSize * compactMultiplier)
    }
  };
};
const DimensionsProvider = ({
  children,
  defaultCompactMode = false
}) => {
  const [screenSize, setScreenSize] = useState('desktop');
  const [isCompact, setIsCompact] = useState(defaultCompactMode);
  // Detect screen size
  useEffect(() => {
    const updateScreenSize = () => {
      const width = window.innerWidth;
      if (width < 768) {
        setScreenSize('mobile');
      } else if (width < 1024) {
        setScreenSize('tablet');
      } else {
        setScreenSize('desktop');
      }
    };
    updateScreenSize();
    window.addEventListener('resize', updateScreenSize);
    return () => window.removeEventListener('resize', updateScreenSize);
  }, []);
  const tokens = getDefaultTokens(screenSize, isCompact);
  const contextValue = {
    tokens,
    screenSize,
    isCompact,
    setCompactMode: setIsCompact
  };
  return jsx(DimensionsContext.Provider, {
    value: contextValue,
    children: children
  });
};
const useDimensions = () => {
  const context = useContext(DimensionsContext);
  if (context === undefined) {
    throw new Error('useDimensions must be used within a DimensionsProvider');
  }
  return context;
};

const NavigationContext = /*#__PURE__*/createContext(null);
/**
 * Internal provider that uses React Router hooks
 * Only rendered when we're inside a Router context
 */
function ReactRouterNavigationProvider({
  children
}) {
  const reactRouterNavigate = useNavigate();
  const reactRouterLocation = useLocation();
  const navigate = to => {
    if (typeof to === 'string') {
      reactRouterNavigate(to);
    } else if (typeof to === 'number') {
      reactRouterNavigate(to);
    }
  };
  // Defensive check for location - fall back to window.location if React Router's location is undefined
  const location = reactRouterLocation ? {
    pathname: reactRouterLocation.pathname,
    search: reactRouterLocation.search,
    hash: reactRouterLocation.hash
  } : typeof window !== 'undefined' ? {
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash
  } : undefined;
  return jsx(NavigationContext.Provider, {
    value: {
      navigate,
      location
    },
    children: children
  });
}
/**
 * Internal provider that uses window.location fallback
 * Used when not inside a React Router context
 */
function FallbackNavigationProvider({
  children
}) {
  const navigate = to => {
    if (typeof window === 'undefined') return;
    if (typeof to === 'string') {
      window.location.href = to;
    } else if (typeof to === 'number') {
      window.history.go(to);
    }
  };
  const location = typeof window !== 'undefined' ? {
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash
  } : undefined;
  return jsx(NavigationContext.Provider, {
    value: {
      navigate,
      location
    },
    children: children
  });
}
/**
 * Smart Navigation Provider
 *
 * Automatically detects if the app is inside a React Router context:
 * - If inside Router: uses React Router's useNavigate/useLocation (respects basename)
 * - If outside Router: falls back to window.location
 *
 * This is included automatically by QwickApp - you don't need to add it manually.
 */
function NavigationProvider({
  children
}) {
  // Check if we're inside a React Router using the official hook
  // This is more reliable than checking internal UNSAFE contexts
  const isInRouter = useInRouterContext();
  if (isInRouter) {
    // We're inside a Router, use React Router's navigation
    return jsx(ReactRouterNavigationProvider, {
      children: children
    });
  }
  // Not inside a Router, use window.location fallback
  return jsx(FallbackNavigationProvider, {
    children: children
  });
}
/**
 * Hook to access navigation functions
 *
 * @returns Object containing navigate function and current location
 *
 * @example
 * ```tsx
 * function MyComponent() {
 *   const { navigate, location } = useNavigation();
 *
 *   const handleClick = () => {
 *     navigate('/dashboard');
 *   };
 *
 *   return <button onClick={handleClick}>Go to Dashboard</button>;
 * }
 * ```
 */
function useNavigation() {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error('useNavigation must be used within a NavigationProvider. ' + 'Make sure your component is wrapped in QwickApp or NavigationProvider.');
  }
  return context;
}

const PaletteIcon = Palette;
const CircleIcon = Circle;
// View component - handles the actual rendering
function PaletteSwitcherView({
  disabled = false,
  buttonSize = 'medium',
  tooltipText,
  showActiveBadge = true,
  showDescriptions = true,
  ...restProps
}) {
  const {
    styleProps,
    htmlProps
  } = useBaseProps(restProps);
  const {
    currentPalette,
    setPreferredPalette,
    availablePalettes
  } = usePalette();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handlePaletteSelect = paletteId => {
    setPreferredPalette(paletteId);
    handleClose();
  };
  const getPaletteIcon = palette => {
    const isSelected = palette.id === currentPalette;
    return jsx(CircleIcon, {
      fontSize: "small",
      sx: {
        color: palette.primaryColor,
        filter: isSelected ? 'drop-shadow(0 0 3px currentColor) brightness(1.2)' : 'none',
        transform: isSelected ? 'scale(1.1)' : 'scale(1)',
        transition: 'all 0.2s ease-in-out'
      }
    });
  };
  const getCurrentPalette = () => {
    return availablePalettes.find(p => p.id === currentPalette) || availablePalettes[0];
  };
  // If no palettes available, return empty state
  if (!availablePalettes || availablePalettes.length === 0) {
    return jsx(Paper, {
      ...htmlProps,
      ...styleProps,
      variant: "outlined",
      sx: {
        p: 2,
        textAlign: 'center',
        opacity: 0.6,
        ...styleProps.sx
      },
      children: jsx(Typography, {
        variant: "body2",
        color: "text.secondary",
        children: "No color palettes available"
      })
    });
  }
  const defaultTooltipText = `Switch color palette (current: ${getCurrentPalette().name})`;
  return jsxs(Box, {
    ...htmlProps,
    ...styleProps,
    children: [jsx(Tooltip, {
      title: tooltipText || defaultTooltipText,
      children: jsx(IconButton, {
        onClick: handleClick,
        disabled: disabled,
        size: buttonSize,
        "aria-label": "palette switcher",
        "aria-controls": open ? 'palette-menu' : undefined,
        "aria-haspopup": "true",
        "aria-expanded": open ? 'true' : undefined,
        sx: {
          color: 'var(--theme-on-surface, inherit)',
          '&:hover': {
            backgroundColor: 'var(--menu-hover, rgba(0, 0, 0, 0.04))'
          }
        },
        children: jsx(PaletteIcon, {})
      })
    }), jsx(Menu$1, {
      id: "palette-menu",
      anchorEl: anchorEl,
      open: open,
      onClose: handleClose,
      slotProps: {
        paper: {
          'aria-labelledby': 'palette-button'
        }
      },
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'right'
      },
      children: availablePalettes.map(palette => jsxs(MenuItem, {
        onClick: () => handlePaletteSelect(palette.id),
        selected: currentPalette === palette.id,
        sx: {
          '&:hover': {
            backgroundColor: 'action.hover'
          },
          '&.Mui-selected': {
            backgroundColor: 'action.selected',
            '&:hover': {
              backgroundColor: 'action.selected'
            }
          }
        },
        children: [jsx(ListItemIcon, {
          children: getPaletteIcon(palette)
        }), jsx(ListItemText, {
          primary: jsxs(Box, {
            sx: {
              display: 'flex',
              alignItems: 'center',
              gap: 1
            },
            children: [palette.name, showActiveBadge && currentPalette === palette.id && jsx(Box, {
              component: "span",
              sx: {
                fontSize: '0.75rem',
                px: 1,
                py: 0.25,
                borderRadius: 1,
                backgroundColor: 'primary.main',
                color: 'primary.contrastText'
              },
              children: "Active"
            })]
          }),
          secondary: showDescriptions ? palette.description : undefined
        })]
      }, palette.id))
    })]
  });
}
/**
 * PaletteSwitcher component with data binding support
 * Supports both traditional props and dataSource-driven rendering
 */
function PaletteSwitcher(props) {
  const {
    dataSource,
    bindingOptions,
    ...restProps
  } = props;
  // Always call hooks unconditionally
  const bindingResult = useDataBinding(dataSource || '', restProps);
  // If no dataSource, use traditional props
  if (!dataSource) {
    return jsx(PaletteSwitcherView, {
      ...restProps
    });
  }
  // Use data binding result
  const {
    loading,
    error,
    ...paletteSwitcherProps
  } = bindingResult;
  // Show loading state
  if (loading) {
    return jsxs(Paper, {
      variant: "outlined",
      sx: {
        p: 2,
        textAlign: 'center'
      },
      children: [jsx(Typography, {
        variant: "body2",
        children: "Loading PaletteSwitcher..."
      }), jsx(Typography, {
        variant: "caption",
        color: "text.secondary",
        children: "Loading palette switcher from data source..."
      })]
    });
  }
  if (error) {
    console.error('Error loading palette switcher:', error);
    return null;
  }
  return jsx(PaletteSwitcherView, {
    ...paletteSwitcherProps
  });
}
// Mark as QwickApp component
Object.assign(PaletteSwitcher, {
  [QWICKAPP_COMPONENT]: true
});

/**
 * Themed Dialog component
 */
function Dialog({
  children,
  PaperProps,
  ...props
}) {
  return jsx(Dialog$1, {
    ...props,
    PaperProps: {
      ...PaperProps,
      sx: {
        backgroundColor: 'var(--theme-surface)',
        color: 'var(--theme-text-primary)',
        borderRadius: 'var(--theme-border-radius, 8px)',
        ...PaperProps?.sx
      }
    },
    children: children
  });
}
/**
 * Themed DialogTitle component
 */
function DialogTitle({
  children,
  sx,
  ...props
}) {
  return jsx(DialogTitle$1, {
    ...props,
    sx: {
      color: 'var(--theme-text-primary)',
      backgroundColor: 'var(--theme-surface)',
      borderBottom: '1px solid var(--theme-border)',
      ...sx
    },
    children: children
  });
}
/**
 * Themed DialogContent component
 */
function DialogContent({
  children,
  sx,
  ...props
}) {
  return jsx(DialogContent$1, {
    ...props,
    sx: {
      color: 'var(--theme-text-primary)',
      backgroundColor: 'var(--theme-surface)',
      ...sx
    },
    children: children
  });
}
/**
 * Themed DialogActions component
 */
function DialogActions({
  children,
  sx,
  ...props
}) {
  return jsx(DialogActions$1, {
    ...props,
    sx: {
      backgroundColor: 'var(--theme-surface)',
      borderTop: '1px solid var(--theme-border)',
      padding: '16px 24px',
      ...sx
    },
    children: children
  });
}
/**
 * Themed DialogContentText component
 */
function DialogContentText({
  children,
  sx,
  ...props
}) {
  return jsx(DialogContentText$1, {
    ...props,
    sx: {
      color: 'var(--theme-text-secondary)',
      ...sx
    },
    children: children
  });
}

/**
 * FormFieldView - Pure view component that renders the input field
 */
function FormFieldView({
  label,
  value,
  onChange,
  onChangeRaw,
  type = 'text',
  helperText,
  required = false,
  readOnly = false,
  disabled = false,
  disabledColor,
  fullWidth = true,
  multiline = false,
  rows,
  placeholder,
  name,
  startAdornment,
  endAdornment,
  inputProps,
  error,
  // Exclude ViewProps that conflict with MUI FormControl types
  margin: _margin,
  marginTop: _marginTop,
  marginRight: _marginRight,
  marginBottom: _marginBottom,
  marginLeft: _marginLeft,
  marginX: _marginX,
  marginY: _marginY,
  padding: _padding,
  paddingTop: _paddingTop,
  paddingRight: _paddingRight,
  paddingBottom: _paddingBottom,
  paddingLeft: _paddingLeft,
  paddingX: _paddingX,
  paddingY: _paddingY,
  ...restProps
}) {
  const fieldId = React.useId();
  const handleChange = e => {
    if (onChangeRaw) {
      onChangeRaw(e);
      return;
    }
    if (onChange) {
      const newValue = type === 'number' ? parseInt(e.target.value) || 0 : e.target.value;
      onChange(newValue);
    }
  };
  const inputStyles = {
    p: 1,
    pl: 1.6,
    mt: 3,
    color: disabled && disabledColor ? disabledColor : readOnly ? 'var(--theme-text-secondary)' : 'var(--theme-text-primary)',
    backgroundColor: readOnly ? 'var(--theme-surface-variant)' : 'transparent',
    borderRadius: 1,
    '&.Mui-disabled': disabledColor ? {
      color: disabledColor,
      WebkitTextFillColor: disabledColor
    } : undefined,
    '& input.Mui-disabled': disabledColor ? {
      color: disabledColor,
      WebkitTextFillColor: disabledColor
    } : undefined
  };
  const labelStyles = {
    left: -12,
    fontWeight: 600,
    color: 'var(--theme-text-primary)'
  };
  const helperTextStyles = {
    color: 'var(--theme-secondary)'
  };
  return jsxs(FormControl, {
    fullWidth: fullWidth,
    error: error,
    ...restProps,
    children: [jsx(InputLabel, {
      htmlFor: fieldId,
      sx: labelStyles,
      shrink: true,
      children: label
    }), jsx(Input$5, {
      id: fieldId,
      name: name,
      type: type,
      value: value,
      onChange: handleChange,
      readOnly: readOnly,
      disabled: disabled,
      required: required,
      multiline: multiline,
      rows: rows,
      placeholder: placeholder,
      inputProps: inputProps,
      sx: inputStyles,
      startAdornment: startAdornment ? jsx(InputAdornment, {
        position: "start",
        children: startAdornment
      }) : undefined,
      endAdornment: endAdornment ? jsx(InputAdornment, {
        position: "end",
        children: endAdornment
      }) : undefined
    }), helperText && jsx(FormHelperText, {
      sx: helperTextStyles,
      children: helperText
    })]
  });
}
/**
 * Create FormField component using the factory pattern
 */
const FormField = createSerializableView({
  tagName: 'FormField',
  version: '1.0.0',
  role: 'input',
  View: FormFieldView
});

/**
 * FormSelectView - Pure view component that renders the select field
 */
function FormSelectView({
  label,
  value,
  onChange,
  options,
  helperText,
  required = false,
  disabled = false,
  fullWidth = true,
  size = 'small',
  placeholder,
  name,
  error,
  // Exclude ViewProps that conflict with MUI FormControl types
  margin: _margin,
  marginTop: _marginTop,
  marginRight: _marginRight,
  marginBottom: _marginBottom,
  marginLeft: _marginLeft,
  marginX: _marginX,
  marginY: _marginY,
  padding: _padding,
  paddingTop: _paddingTop,
  paddingRight: _paddingRight,
  paddingBottom: _paddingBottom,
  paddingLeft: _paddingLeft,
  paddingX: _paddingX,
  paddingY: _paddingY,
  ...restProps
}) {
  const handleChange = e => {
    onChange(e.target.value);
  };
  const selectStyles = {
    p: 1,
    pl: 1.6,
    ...(label ? {
      mt: 1,
      color: 'var(--theme-text-primary)'
    } : {}),
    backgroundColor: 'var(--theme-surface-variant)',
    borderColor: 'var(--theme-surface)',
    color: 'var(--theme-text-primary)',
    borderRadius: 1
  };
  const labelStyles = {
    left: -12,
    fontWeight: 600,
    color: 'var(--theme-text-primary)'
  };
  const helperTextStyles = {
    color: 'var(--theme-secondary)'
  };
  return jsxs(FormControl, {
    fullWidth: fullWidth,
    size: size,
    error: error,
    ...restProps,
    children: [label && jsx(InputLabel, {
      sx: labelStyles,
      shrink: true,
      children: label
    }), jsxs(Select, {
      name: name,
      value: value,
      onChange: handleChange,
      disabled: disabled,
      required: required,
      displayEmpty: !!placeholder,
      sx: selectStyles,
      children: [placeholder && jsx(MenuItem, {
        value: "",
        disabled: true,
        children: placeholder
      }), options.map(opt => jsx(MenuItem, {
        value: opt.value,
        children: opt.label
      }, opt.value))]
    }), helperText && jsx(FormHelperText, {
      sx: helperTextStyles,
      children: helperText
    })]
  });
}
/**
 * Create FormSelect component using the factory pattern
 */
const FormSelect = createSerializableView({
  tagName: 'FormSelect',
  version: '1.0.0',
  role: 'input',
  View: FormSelectView
});

/**
 * FormCheckboxView - Pure view component that renders the checkbox
 */
function FormCheckboxView({
  label,
  checked,
  onChange,
  helperText,
  required = false,
  disabled = false,
  // Exclude ViewProps that conflict with MUI FormControl types
  margin: _margin,
  marginTop: _marginTop,
  marginRight: _marginRight,
  marginBottom: _marginBottom,
  marginLeft: _marginLeft,
  marginX: _marginX,
  marginY: _marginY,
  padding: _padding,
  paddingTop: _paddingTop,
  paddingRight: _paddingRight,
  paddingBottom: _paddingBottom,
  paddingLeft: _paddingLeft,
  paddingX: _paddingX,
  paddingY: _paddingY,
  ...restProps
}) {
  const handleChange = e => {
    onChange(e.target.checked);
  };
  const checkboxStyles = {
    color: 'var(--theme-primary)',
    '&.Mui-checked': {
      color: 'var(--theme-primary)'
    },
    '&.Mui-disabled': {
      color: 'var(--theme-text-disabled)'
    }
  };
  const labelStyles = {
    color: 'var(--theme-text-primary)',
    '& .MuiFormControlLabel-label': {
      color: 'var(--theme-text-primary)'
    },
    '& .MuiFormControlLabel-label.Mui-disabled': {
      color: 'var(--theme-text-disabled)'
    }
  };
  const helperTextStyles = {
    color: 'var(--theme-secondary)',
    marginLeft: '32px'
  };
  return jsxs(FormControl, {
    ...restProps,
    children: [jsx(FormControlLabel, {
      control: jsx(Checkbox, {
        checked: checked,
        onChange: handleChange,
        required: required,
        disabled: disabled,
        sx: checkboxStyles
      }),
      label: label,
      sx: labelStyles
    }), helperText && jsx(FormHelperText, {
      sx: helperTextStyles,
      children: helperText
    })]
  });
}
/**
 * Create FormCheckbox component using the factory pattern
 */
const FormCheckbox = createSerializableView({
  tagName: 'FormCheckbox',
  version: '1.0.0',
  role: 'input',
  View: FormCheckboxView
});

/**
 * CaptchaView - Pure view component that renders the CAPTCHA widget
 */
function CaptchaView({
  provider,
  siteKey,
  onVerify,
  onExpire,
  onError,
  theme = 'light',
  size = 'normal',
  action = 'submit',
  ...restProps
}) {
  const containerRef = useRef(null);
  const widgetIdRef = useRef(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(null);
  // Load the appropriate CAPTCHA script
  useEffect(() => {
    const loadScript = () => {
      // Check if script is already loaded
      const isAlreadyLoaded = (() => {
        switch (provider) {
          case 'recaptcha-v2':
          case 'recaptcha-v3':
            return !!window.grecaptcha;
          case 'hcaptcha':
            return !!window.hcaptcha;
          case 'turnstile':
            return !!window.turnstile;
          default:
            return false;
        }
      })();
      if (isAlreadyLoaded) {
        setIsLoaded(true);
        return;
      }
      // Get the script URL for the provider
      const getScriptUrl = () => {
        switch (provider) {
          case 'recaptcha-v2':
            return 'https://www.google.com/recaptcha/api.js?render=explicit';
          case 'recaptcha-v3':
            return `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
          case 'hcaptcha':
            return 'https://js.hcaptcha.com/1/api.js?render=explicit';
          case 'turnstile':
            return 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
          default:
            return '';
        }
      };
      const scriptUrl = getScriptUrl();
      if (!scriptUrl) {
        setError('Unsupported CAPTCHA provider');
        return;
      }
      // Create and load script
      const script = document.createElement('script');
      script.src = scriptUrl;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        setIsLoaded(true);
      };
      script.onerror = () => {
        setError('Failed to load CAPTCHA script');
        onError?.(new Error('Failed to load CAPTCHA script'));
      };
      document.head.appendChild(script);
      return () => {
        // Cleanup: remove script when component unmounts
        document.head.removeChild(script);
      };
    };
    loadScript();
  }, [provider, siteKey, onError]);
  // Render the CAPTCHA widget
  useEffect(() => {
    if (!isLoaded || !containerRef.current) return;
    const renderWidget = () => {
      try {
        switch (provider) {
          case 'recaptcha-v2':
            if (window.grecaptcha?.render) {
              widgetIdRef.current = window.grecaptcha.render(containerRef.current, {
                sitekey: siteKey,
                callback: onVerify,
                'expired-callback': onExpire,
                'error-callback': () => {
                  const err = new Error('reCAPTCHA error');
                  setError(err.message);
                  onError?.(err);
                },
                theme,
                size
              });
            }
            break;
          case 'recaptcha-v3':
            // reCAPTCHA v3 is invisible and executes programmatically
            if (window.grecaptcha?.execute) {
              window.grecaptcha.execute(siteKey, {
                action
              }).then(token => {
                onVerify(token);
              }).catch(err => {
                setError(err.message);
                onError?.(err);
              });
            }
            break;
          case 'hcaptcha':
            if (window.hcaptcha?.render) {
              widgetIdRef.current = window.hcaptcha.render(containerRef.current, {
                sitekey: siteKey,
                callback: onVerify,
                'expired-callback': onExpire,
                'error-callback': () => {
                  const err = new Error('hCaptcha error');
                  setError(err.message);
                  onError?.(err);
                },
                theme,
                size: size === 'normal' ? 'normal' : 'compact'
              });
            }
            break;
          case 'turnstile':
            if (window.turnstile?.render) {
              widgetIdRef.current = window.turnstile.render(containerRef.current, {
                sitekey: siteKey,
                callback: onVerify,
                'expired-callback': onExpire,
                'error-callback': () => {
                  const err = new Error('Turnstile error');
                  setError(err.message);
                  onError?.(err);
                },
                theme,
                size: size === 'compact' ? 'compact' : 'normal'
              });
            }
            break;
        }
      } catch (err) {
        const error = err instanceof Error ? err : new Error('Failed to render CAPTCHA');
        setError(error.message);
        onError?.(error);
      }
    };
    // Small delay to ensure the CAPTCHA library is fully initialized
    const timer = setTimeout(renderWidget, 100);
    return () => {
      clearTimeout(timer);
      // Cleanup widget on unmount
      if (widgetIdRef.current !== null) {
        try {
          switch (provider) {
            case 'recaptcha-v2':
              window.grecaptcha?.reset(widgetIdRef.current);
              break;
            case 'hcaptcha':
              window.hcaptcha?.remove(widgetIdRef.current);
              break;
            case 'turnstile':
              window.turnstile?.remove(widgetIdRef.current);
              break;
          }
        } catch (e) {
          // Ignore cleanup errors
        }
      }
    };
  }, [isLoaded, provider, siteKey, onVerify, onExpire, onError, theme, size, action]);
  // Don't render anything for reCAPTCHA v3 (invisible)
  if (provider === 'recaptcha-v3') {
    return null;
  }
  return jsxs(Box, {
    ...restProps,
    sx: {
      my: 2
    },
    children: [error && jsx(Alert, {
      severity: "error",
      sx: {
        mb: 2
      },
      children: error
    }), jsx("div", {
      ref: containerRef
    })]
  });
}
/**
 * Create Captcha component using the factory pattern
 */
const Captcha = createSerializableView({
  tagName: 'Captcha',
  version: '1.0.0',
  role: 'input',
  View: CaptchaView
});

/**
 * Render a single form field based on its editor configuration
 */
function renderField(field, value, onChange, readOnly) {
  const {
    name,
    required,
    editor
  } = field;
  if (!editor) {
    return null;
  }
  const {
    field_type,
    label,
    description,
    placeholder,
    validation
  } = editor;
  const fieldValue = value ?? '';
  const commonProps = {
    fullWidth: true,
    margin: 'normal',
    required,
    disabled: readOnly,
    label,
    helperText: description
  };
  switch (field_type) {
    case FieldType.TEXT:
    case FieldType.EMAIL:
      return jsx(TextField$1, {
        ...commonProps,
        type: field_type === FieldType.EMAIL ? 'email' : 'text',
        value: fieldValue,
        onChange: e => onChange(name, e.target.value),
        placeholder: placeholder,
        inputProps: {
          minLength: validation?.min,
          maxLength: validation?.max
        }
      });
    case FieldType.TEXTAREA:
      return jsx(TextField$1, {
        ...commonProps,
        multiline: true,
        rows: 4,
        value: fieldValue,
        onChange: e => onChange(name, e.target.value),
        placeholder: placeholder,
        inputProps: {
          minLength: validation?.min,
          maxLength: validation?.max
        }
      });
    case FieldType.NUMBER:
      return jsx(TextField$1, {
        ...commonProps,
        type: "number",
        value: fieldValue,
        onChange: e => {
          const val = e.target.value;
          onChange(name, val === '' ? undefined : parseFloat(val));
        },
        placeholder: placeholder,
        inputProps: {
          min: validation?.min,
          max: validation?.max
        }
      });
    case FieldType.BOOLEAN:
      return jsx(FormControlLabel, {
        control: jsx(Switch, {
          checked: !!fieldValue,
          onChange: e => onChange(name, e.target.checked),
          disabled: readOnly
        }),
        label: jsxs(Box, {
          children: [jsx(Typography, {
            variant: "body2",
            fontWeight: required ? 600 : 400,
            children: label
          }), description && jsx(Typography, {
            variant: "caption",
            color: "text.secondary",
            children: description
          })]
        })
      });
    case FieldType.DATE_TIME:
      return jsx(TextField$1, {
        ...commonProps,
        type: "datetime-local",
        value: fieldValue,
        onChange: e => onChange(name, e.target.value),
        InputLabelProps: {
          shrink: true
        }
      });
    case FieldType.COLOR:
      return jsx(Box, {
        children: jsx(TextField$1, {
          ...commonProps,
          type: "color",
          value: fieldValue || '#000000',
          onChange: e => onChange(name, e.target.value)
        })
      });
    case FieldType.IMAGE:
      return jsxs(Box, {
        children: [jsx(Typography, {
          variant: "body2",
          fontWeight: required ? 600 : 400,
          children: label
        }), jsx(TextField$1, {
          fullWidth: true,
          margin: "normal",
          type: "url",
          value: fieldValue,
          onChange: e => onChange(name, e.target.value),
          placeholder: placeholder || 'https://example.com/image.jpg',
          helperText: description,
          disabled: readOnly
        })]
      });
    case FieldType.FORM:
      // Nested form - would need recursive rendering
      return jsxs(Alert, {
        severity: "info",
        sx: {
          my: 2
        },
        children: ["Nested form for ", name, " (not yet implemented)"]
      });
    case FieldType.MODEL_REPEATER:
      // Array of nested forms
      return jsxs(Alert, {
        severity: "info",
        sx: {
          my: 2
        },
        children: ["Array field ", name, " (not yet implemented)"]
      });
    default:
      return jsx(TextField$1, {
        ...commonProps,
        value: fieldValue,
        onChange: e => onChange(name, e.target.value),
        placeholder: placeholder
      });
  }
}
/**
 * SchemaFormRenderer Component
 */
function SchemaFormRenderer({
  modelClass,
  value,
  onChange,
  showValidation = false,
  validationErrors = [],
  readOnly = false
}) {
  const schema = modelClass.getSchema();
  const handleFieldChange = useCallback((fieldName, fieldValue) => {
    onChange({
      ...value,
      [fieldName]: fieldValue
    });
  }, [value, onChange]);
  return jsxs(Box, {
    children: [showValidation && validationErrors.length > 0 && jsxs(Alert, {
      severity: "error",
      sx: {
        mb: 2
      },
      children: [jsx(Typography, {
        variant: "body2",
        fontWeight: 600,
        gutterBottom: true,
        children: "Please fix the following errors:"
      }), jsx("ul", {
        style: {
          margin: 0,
          paddingLeft: 20
        },
        children: validationErrors.map((error, idx) => jsx("li", {
          children: jsx(Typography, {
            variant: "body2",
            children: error
          })
        }, idx))
      })]
    }), schema.fields.map(field => jsx(Box, {
      children: renderField(field, value[field.name], handleFieldChange, readOnly)
    }, field.name))]
  });
}

const TextField = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    gridProps,
    styleProps,
    htmlProps,
    restProps
  } = useBaseProps(props);
  // Extract commonly used props we may inspect
  const {
    placeholder,
    value,
    defaultValue,
    slotProps,
    InputLabelProps,
    InputProps,
    variant = 'outlined',
    ...other
  } = restProps;
  // Determine whether label should shrink automatically when a placeholder is shown.
  // MUI does not shrink the label for outlined variant with just a placeholder (and empty value) by default.
  // We standardize that behavior for consistency across admin surfaces.
  const hasContent = (() => {
    if (value != null && value !== '') return true;
    if (defaultValue != null && defaultValue !== '') return true;
    return false;
  })();
  const autoShrink = !!placeholder && !hasContent;
  // Allow explicit user override: if consumer supplied slotProps.inputLabel.shrink or InputLabelProps.shrink, respect it.
  const userShrink = slotProps?.inputLabel?.shrink ?? InputLabelProps?.shrink;
  const finalShrink = userShrink !== undefined ? userShrink : autoShrink;
  const mergedSlotProps = {
    ...slotProps,
    inputLabel: {
      ...(slotProps?.inputLabel || {}),
      ...(finalShrink ? {
        shrink: true
      } : {})
    }
  };
  // Prepare InputProps (for OutlinedInput) to ensure notch appears when we auto-shrink.
  let mergedInputProps = InputProps || {};
  if (variant === 'outlined' && finalShrink && placeholder && !hasContent) {
    if (mergedInputProps.notched === undefined) {
      mergedInputProps = {
        ...mergedInputProps,
        notched: true
      };
    }
  }
  // Mark as QwickApp component
  Object.assign(TextField, {
    [QWICKAPP_COMPONENT]: true
  });
  return jsx(TextField$1, {
    ref: ref,
    placeholder: placeholder,
    value: value,
    defaultValue: defaultValue,
    variant: variant,
    slotProps: mergedSlotProps,
    InputProps: mergedInputProps,
    ...other,
    ...htmlProps,
    ...styleProps,
    ...(gridProps && {
      'data-grid-span': gridProps.span,
      'data-grid-xs': gridProps.xs,
      'data-grid-sm': gridProps.sm,
      'data-grid-md': gridProps.md,
      'data-grid-lg': gridProps.lg,
      'data-grid-xl': gridProps.xl
    })
  });
});
TextField.displayName = 'TextField';

/**
 * FormPage component for consistent form page layouts
 */
const FormPage = ({
  title,
  description,
  coverImage,
  form,
  footer,
  status,
  message,
  maxWidth = 'sm',
  background = 'default',
  backgroundImage
}) => {
  return jsx(FormBlock, {
    title: title,
    description: description,
    coverImage: coverImage,
    children: form,
    footer: footer,
    status: status,
    message: message,
    maxWidth: maxWidth,
    background: background,
    backgroundImage: backgroundImage
  });
};

/**
 * Utility functions for CSS value conversions.
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
/**
 * Converts a value to a CSS length string.
 * @param value The value to convert (number, string, etc.).
 * @param opts Options for controlling the conversion.
 * @returns The CSS length string (e.g., "10px", "100%", etc.).
 */
function toCssLength(value, opts = {}) {
  const {
    defaultUnit = 'px',
    allowedUnits = ['px', 'mm', 'cm', 'in', 'pt', 'pc'],
    allowKeywords = false,
    fallback = `0${defaultUnit}`
  } = opts;
  if (value == null) return fallback;
  if (typeof value === 'number' && isFinite(value)) {
    return `${value}${defaultUnit}`;
  }
  const s = String(value).trim();
  if (!s) return fallback;
  if (allowKeywords && /^(auto|inherit|initial|unset)$/.test(s)) return s;
  // Pure numeric string
  if (/^-?\d+(\.\d+)?$/.test(s)) return `${s}${defaultUnit}`;
  // Number + allowed unit
  const unitPattern = new RegExp(`^-?\\d+(?:\\.\\d+)?(${allowedUnits.map(u => u.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')).join('|')})$`);
  if (unitPattern.test(s)) return s;
  return fallback;
}

const PageContext = /*#__PURE__*/createContext(null);
const usePageContext = () => {
  const ctx = useContext(PageContext);
  if (!ctx) throw new Error('usePageContext must be used within PageView');
  return ctx;
};
/* -------------------------------------------------------------------------- */
/* Meta Hook                                                                  */
/* -------------------------------------------------------------------------- */
function usePageMeta(title, description, opts) {
  const {
    openGraph = true,
    removeOnUnmount = false
  } = opts || {};
  useEffect(() => {
    const prevTitle = document.title;
    let createdDesc = false;
    let metaDesc = document.querySelector('meta[name="description"]');
    if (title && document.title !== title) {
      document.title = title;
    }
    if (description) {
      if (!metaDesc) {
        metaDesc = document.createElement('meta');
        metaDesc.name = 'description';
        document.head.appendChild(metaDesc);
        createdDesc = true;
      }
      if (metaDesc.content !== description) metaDesc.content = description;
    }
    let ogTitle = null;
    let ogDesc = null;
    if (openGraph) {
      if (title) {
        ogTitle = document.querySelector('meta[property="og:title"]');
        if (!ogTitle) {
          ogTitle = document.createElement('meta');
          ogTitle.setAttribute('property', 'og:title');
          document.head.appendChild(ogTitle);
        }
        if (ogTitle.content !== title) ogTitle.content = title;
      }
      if (description) {
        ogDesc = document.querySelector('meta[property="og:description"]');
        if (!ogDesc) {
          ogDesc = document.createElement('meta');
          ogDesc.setAttribute('property', 'og:description');
          document.head.appendChild(ogDesc);
        }
        if (ogDesc.content !== description) ogDesc.content = description;
      }
    }
    return () => {
      if (removeOnUnmount) {
        if (document.title === title) document.title = prevTitle;
        if (description && metaDesc && (createdDesc || removeOnUnmount)) {
          metaDesc.parentNode?.removeChild(metaDesc);
        }
        if (openGraph) {
          if (ogTitle && removeOnUnmount) ogTitle.parentNode?.removeChild(ogTitle);
          if (ogDesc && removeOnUnmount) ogDesc.parentNode?.removeChild(ogDesc);
        }
      }
    };
  }, [title, description, openGraph, removeOnUnmount]);
}
const PageView = ({
  renderView,
  renderPrintView,
  template,
  route: routeProp,
  title: titleProp,
  description: descriptionProp,
  name: nameProp,
  slug: slugProp,
  printConfig: printConfigProp,
  variant = 'default',
  padding = 'medium',
  background = 'default',
  maxWidth = 'large',
  children,
  ...rest
}) => {
  // Base props (single invocation early so we can merge styles/classNames)
  const {
    htmlProps,
    styleProps
  } = useBaseProps(rest);
  // State exposed via context
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  // Resolve template / prop derived metadata
  const resolved = {
    route: routeProp ?? (template?.slug ? `/${template.slug}` : undefined),
    title: titleProp ?? template?.title ?? template?.name,
    description: descriptionProp ?? template?.description,
    name: nameProp ?? template?.name,
    slug: slugProp ?? template?.slug,
    printConfig: {
      ...template?.printConfig,
      ...printConfigProp
    }
  };
  // Update head metadata
  usePageMeta(resolved.title, resolved.description);
  // Print integration
  const {
    isPrintMode,
    printConfig,
    onViewLoading,
    onViewReady,
    triggerPrint: triggerPrintBase
  } = usePrintMode();
  const triggerPrint = useCallback(cfg => triggerPrintBase({
    ...resolved.printConfig,
    ...cfg
  }), [triggerPrintBase, resolved.printConfig]);
  // Sync print readiness with loading state
  useLayoutEffect(() => {
    if (!isPrintMode) return;
    if (isLoading) onViewLoading();else onViewReady();
  }, [isPrintMode, isLoading, onViewLoading, onViewReady]);
  // Inject dynamic print sizing styles (header/footer heights & background)
  useEffect(() => {
    if (!isPrintMode) return;
    const styleId = 'qwickapps-print-page-setup';
    const cfg = printConfig;
    const size = cfg.pageSize || 'auto';
    const bg = cfg.printBackground || 'transparent';
    const bgFirst = cfg.printBackgroundFirstPage || bg;
    const hdrEl = document.querySelector('.page-print-header:not(.page-print-header-first-page)');
    const ftrEl = document.querySelector('.page-print-footer:not(.page-print-footer-first-page)');
    const hdr = hdrEl?.getBoundingClientRect ? Math.ceil(hdrEl.getBoundingClientRect().height) : 0;
    const ftr = ftrEl?.getBoundingClientRect ? Math.ceil(ftrEl.getBoundingClientRect().height) : 0;
    const headerH = hdr ? `${hdr}px` : toCssLength(cfg.printHeaderHeight || 0);
    const footerH = ftr ? `${ftr}px` : toCssLength(cfg.printFooterHeight || 0);
    const setCss = (h, f) => `@media print{@page{size:${size};margin:0;} .page-print-mode{--print-header-height:${h};--print-footer-height:${f};--print-background:${bg};--print-background-first-page:${bgFirst};}}`;
    let el = document.getElementById(styleId);
    if (!el) {
      el = document.createElement('style');
      el.id = styleId;
      document.head.appendChild(el);
    }
    el.textContent = setCss(headerH, footerH);
    // Observe late size changes (images/fonts) while in print mode
    let ro = null;
    if (window.ResizeObserver) {
      ro = new ResizeObserver(() => {
        const hdrNow = hdrEl?.getBoundingClientRect ? Math.ceil(hdrEl.getBoundingClientRect().height) : 0;
        const ftrNow = ftrEl?.getBoundingClientRect ? Math.ceil(ftrEl.getBoundingClientRect().height) : 0;
        const finalCss = setCss(hdrNow ? `${hdrNow}px` : headerH, ftrNow ? `${ftrNow}px` : footerH);
        if (el && el.textContent !== finalCss) el.textContent = finalCss;
      });
      if (hdrEl) ro.observe(hdrEl);
      if (ftrEl) ro.observe(ftrEl);
    }
    const cleanup = () => {
      const s = document.getElementById(styleId);
      if (s?.parentNode) s.parentNode.removeChild(s);
      ro?.disconnect();
    };
    window.addEventListener('afterprint', cleanup, {
      once: true
    });
    return () => {
      window.removeEventListener('afterprint', cleanup);
      cleanup();
    };
  }, [isPrintMode, printConfig]);
  // Route (fallback to current location)
  const {
    location
  } = useNavigation();
  const actualRoute = resolved.route || location?.pathname || '';
  // Context value
  const contextValue = useMemo(() => ({
    route: actualRoute,
    isPrintMode,
    printConfig,
    triggerPrint,
    setLoading,
    setError,
    isLoading,
    error
  }), [actualRoute, isPrintMode, printConfig, triggerPrint, isLoading, error]);
  const classes = ['page', `page-variant-${variant}`, `page-padding-${padding}`, `page-background-${background}`, `page-max-width-${maxWidth}`, isPrintMode && 'page-print-mode', isPrintMode && printConfig.pageMargins === '0mm' && 'page-print-borderless', isPrintMode && printConfig.pageMargins === '6mm' && 'page-print-compact', isPrintMode && printConfig.pageMargins === '20mm' && 'page-print-large', isPrintMode && printConfig.pageMargins === '25mm' && 'page-print-formal', isPrintMode && (printConfig.printBackground || printConfig.printBackgroundFirstPage) && 'has-background', styleProps.className].filter(Boolean).join(' ');
  // Resolve mode-specific render output (avoid falsey fallback for '')
  const rendered = (isPrintMode ? renderPrintView : renderView)();
  const mainContent = rendered != null ? rendered : children;
  return jsx(PageContext.Provider, {
    value: contextValue,
    children: jsxs(Box, {
      className: classes,
      sx: styleProps.sx,
      style: styleProps.style,
      ...htmlProps,
      children: [isPrintMode && printConfig.printHeader && jsx("div", {
        className: "page-print-header",
        children: typeof printConfig.printHeader === 'string' ? jsx(SafeSpan, {
          html: t`${printConfig.printHeader}`
        }) : printConfig.printHeader
      }), isPrintMode && printConfig.printHeaderFirstPage && jsx("div", {
        className: "page-print-header page-print-header-first-page",
        children: typeof printConfig.printHeaderFirstPage === 'string' ? jsx(SafeSpan, {
          html: t`${printConfig.printHeaderFirstPage}`
        }) : printConfig.printHeaderFirstPage
      }), isPrintMode && !printConfig.printHeader && printConfig.printTitle && jsxs("div", {
        className: "page-print-header",
        children: [jsx("h1", {
          children: printConfig.printTitle
        }), printConfig.showPrintDate && jsxs("div", {
          className: "page-print-date",
          children: ["Printed on: ", new Date().toLocaleString()]
        })]
      }), resolved.name && resolved.name !== resolved.title && jsx("div", {
        className: "page-heading",
        children: jsx("h1", {
          children: resolved.name
        })
      }), jsx("div", {
        className: "page-content",
        children: mainContent
      }), isPrintMode && printConfig.printFooter && jsx("div", {
        className: "page-print-footer",
        children: typeof printConfig.printFooter === 'string' ? jsx(SafeSpan, {
          html: t`${printConfig.printFooter}`
        }) : printConfig.printFooter
      }), isPrintMode && printConfig.printFooterFirstPage && jsx("div", {
        className: "page-print-footer page-print-footer-first-page",
        children: typeof printConfig.printFooterFirstPage === 'string' ? jsx(SafeSpan, {
          html: t`${printConfig.printFooterFirstPage}`
        }) : printConfig.printFooterFirstPage
      })]
    })
  });
};
/* -------------------------------------------------------------------------- */
/* Page Class                                                                 */
/* -------------------------------------------------------------------------- */
class Page extends React.Component {
  getPageProps() {
    return {};
  }
  renderView() {
    return this.props.children;
  }
  renderPrintView() {
    return this.renderView();
  }
  render() {
    const merged = {
      ...this.props,
      ...this.getPageProps()
    };
    return jsx(PageView, {
      ...merged,
      renderView: () => this.renderView(),
      renderPrintView: () => this.renderPrintView()
    });
  }
}

const StatCard = ({
  label,
  value,
  unit,
  suffix,
  trend,
  status = 'info',
  onClick,
  icon,
  subValue,
  color
}) => {
  // Use suffix as fallback for unit (backward compatibility)
  const displayUnit = unit || suffix;
  const statusColors = {
    healthy: 'text-green-600 dark:text-green-400 bg-green-50 dark:bg-green-900/20',
    warning: 'text-yellow-600 dark:text-yellow-400 bg-yellow-50 dark:bg-yellow-900/20',
    error: 'text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-900/20',
    info: 'text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-900/20'
  };
  const trendIcons = {
    up: '↑',
    down: '↓',
    stable: '→'
  };
  return jsx("div", {
    className: `
        rounded-lg border p-4
        ${statusColors[status]}
        ${onClick ? 'cursor-pointer hover:shadow-md transition-shadow' : ''}
      `,
    onClick: onClick,
    role: onClick ? 'button' : undefined,
    tabIndex: onClick ? 0 : undefined,
    children: jsxs("div", {
      className: "flex items-start justify-between",
      children: [jsxs("div", {
        className: "flex-1",
        children: [jsx("p", {
          className: "text-sm font-medium opacity-80",
          children: label
        }), jsxs("div", {
          className: "mt-1 flex items-baseline gap-2",
          children: [jsx("p", {
            className: "text-2xl font-semibold",
            children: value
          }), displayUnit && jsx("span", {
            className: "text-sm opacity-70",
            children: displayUnit
          })]
        }), subValue && jsx("p", {
          className: "text-xs opacity-70 mt-1",
          children: subValue
        }), trend && jsxs("div", {
          className: "mt-2 flex items-center gap-1 text-sm",
          children: [jsx("span", {
            children: trendIcons[trend.direction]
          }), jsxs("span", {
            children: [trend.value, "%"]
          })]
        })]
      }), icon && jsx("div", {
        className: "ml-4 text-2xl opacity-70",
        style: color ? {
          color
        } : undefined,
        children: icon
      })]
    })
  });
};

function DataTable({
  columns,
  data,
  onRowClick,
  bulkActions = [],
  selectable = bulkActions.length > 0,
  emptyMessage = 'No data available',
  loading = false,
  getRowKey = (row, index) => {
    // Type-safe check for id property
    const rowObj = row;
    const hasValidId = 'id' in rowObj && (typeof rowObj.id === 'string' || typeof rowObj.id === 'number');
    return hasValidId ? rowObj.id : index;
  }
}) {
  const [selectedRows, setSelectedRows] = useState(new Set());
  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState('asc');
  // Sorted data
  const sortedData = useMemo(() => {
    if (!sortColumn) return data;
    return [...data].sort((a, b) => {
      const aVal = a[sortColumn];
      const bVal = b[sortColumn];
      if (aVal === bVal) return 0;
      const comparison = aVal < bVal ? -1 : 1;
      return sortDirection === 'asc' ? comparison : -comparison;
    });
  }, [data, sortColumn, sortDirection]);
  const handleSort = column => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortColumn(column);
      setSortDirection('asc');
    }
  };
  const handleSelectAll = () => {
    if (selectedRows.size === data.length) {
      setSelectedRows(new Set());
    } else {
      setSelectedRows(new Set(data.map((row, index) => getRowKey(row, index))));
    }
  };
  const handleSelectRow = rowKey => {
    const newSelection = new Set(selectedRows);
    if (newSelection.has(rowKey)) {
      newSelection.delete(rowKey);
    } else {
      newSelection.add(rowKey);
    }
    setSelectedRows(newSelection);
  };
  const getSelectedRowData = () => {
    return data.filter((row, index) => selectedRows.has(getRowKey(row, index)));
  };
  if (loading) {
    return jsxs("div", {
      className: "animate-pulse space-y-2",
      children: [jsx("div", {
        className: "h-10 bg-gray-200 dark:bg-gray-700 rounded"
      }), jsx("div", {
        className: "h-16 bg-gray-200 dark:bg-gray-700 rounded"
      }), jsx("div", {
        className: "h-16 bg-gray-200 dark:bg-gray-700 rounded"
      })]
    });
  }
  if (data.length === 0) {
    return jsx("div", {
      className: "text-center py-12 text-gray-500 dark:text-gray-400",
      children: emptyMessage
    });
  }
  return jsxs("div", {
    className: "space-y-4",
    children: [selectable && selectedRows.size > 0 && bulkActions.length > 0 && jsxs("div", {
      className: "flex items-center gap-3 p-3 bg-blue-50 dark:bg-blue-900/20 rounded-lg",
      children: [jsxs("span", {
        className: "text-sm font-medium text-blue-900 dark:text-blue-100",
        children: [selectedRows.size, " selected"]
      }), bulkActions.map((action, index) => jsx("button", {
        onClick: () => action.onClick(getSelectedRowData()),
        className: `
                px-3 py-1.5 rounded text-sm font-medium
                ${action.variant === 'danger' ? 'bg-red-600 hover:bg-red-700 text-white' : 'bg-blue-600 hover:bg-blue-700 text-white'}
              `,
        children: action.label
      }, index))]
    }), jsx("div", {
      className: "overflow-x-auto rounded-lg border border-gray-200 dark:border-gray-700",
      children: jsxs("table", {
        className: "min-w-full divide-y divide-gray-200 dark:divide-gray-700",
        children: [jsx("thead", {
          className: "bg-gray-50 dark:bg-gray-800",
          children: jsxs("tr", {
            children: [selectable && jsx("th", {
              className: "w-12 px-4 py-3",
              children: jsx("input", {
                type: "checkbox",
                checked: selectedRows.size === data.length && data.length > 0,
                onChange: handleSelectAll,
                className: "rounded"
              })
            }), columns.map(column => jsx("th", {
              style: {
                width: column.width
              },
              className: `
                    px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider
                    ${column.sortable ? 'cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700' : ''}
                  `,
              onClick: () => column.sortable && handleSort(column.key),
              children: jsxs("div", {
                className: "flex items-center gap-2",
                children: [column.label, column.sortable && sortColumn === column.key && jsx("span", {
                  children: sortDirection === 'asc' ? '↑' : '↓'
                })]
              })
            }, String(column.key)))]
          })
        }), jsx("tbody", {
          className: "bg-white dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-700",
          children: sortedData.map((row, rowIndex) => {
            const rowKey = getRowKey(row, rowIndex);
            const isSelected = selectedRows.has(rowKey);
            return jsxs("tr", {
              className: `
                    ${onRowClick ? 'cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800' : ''}
                    ${isSelected ? 'bg-blue-50 dark:bg-blue-900/20' : ''}
                  `,
              onClick: () => onRowClick?.(row),
              children: [selectable && jsx("td", {
                className: "px-4 py-3",
                onClick: e => e.stopPropagation(),
                children: jsx("input", {
                  type: "checkbox",
                  checked: isSelected,
                  onChange: () => handleSelectRow(rowKey),
                  className: "rounded"
                })
              }), columns.map(column => jsx("td", {
                className: "px-4 py-3 text-sm text-gray-900 dark:text-gray-100",
                children: column.render ? column.render(row[column.key], row) : String(row[column.key] ?? '')
              }, String(column.key)))]
            }, rowKey);
          })
        })]
      })
    })]
  });
}

const logger$1 = loggers.scaffold;
// Material UI breakpoints
const BREAKPOINTS = {
  mobile: 600,
  // < 600px
  tablet: 1024,
  // 600px - 1024px  
  desktop: 1024 // > 1024px
};
const Scaffold = ({
  children,
  navigationItems = [],
  appBar,
  className = '',
  showAppBar = true,
  appBarHeight = 64,
  appName: propAppName,
  showThemeSwitcher = false,
  showPaletteSwitcher = false,
  onLogoClick
}) => {
  const [screenSize, setScreenSize] = useState('desktop');
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isRailExpanded, setIsRailExpanded] = useState(false);
  const [isMounted, setIsMounted] = useState(false);
  // Navigation (uses React Router if available, falls back to window.location)
  const {
    navigate,
    location
  } = useNavigation();
  const currentPath = isMounted ? location?.pathname : undefined;
  // Debug logging for navigation
  React.useEffect(() => {
    if (currentPath) {
      logger$1.debug('Current path changed to:', currentPath);
    }
  }, [currentPath]);
  // Set mounted state after hydration to prevent hydration mismatch
  useEffect(() => {
    setIsMounted(true);
  }, []);
  const {
    appName: contextAppName,
    logo: contextLogo
  } = useQwickApp$1();
  const appName = propAppName || contextAppName;
  // Page context integration is simplified - only used for route detection if needed
  // Page-specific menu items and actions are now handled by header components
  // Determine current screen size using Material UI breakpoints
  useEffect(() => {
    const updateScreenSize = () => {
      const width = window.innerWidth;
      if (width < BREAKPOINTS.mobile) {
        setScreenSize('mobile');
      } else if (width <= BREAKPOINTS.tablet) {
        setScreenSize('tablet');
      } else {
        setScreenSize('desktop');
      }
    };
    updateScreenSize();
    window.addEventListener('resize', updateScreenSize);
    return () => window.removeEventListener('resize', updateScreenSize);
  }, []);
  // Page context now only contains route information
  // Page-specific actions and menu items are handled by header components
  // Sort items by priority
  const sortedItems = [...navigationItems].sort((a, b) => (a.priority || 999) - (b.priority || 999));
  // Material UI Guidelines: Split items based on screen size
  const getNavigationSplit = () => {
    switch (screenSize) {
      case 'mobile':
        {
          // Bottom Nav: 3-5 items, rest in drawer
          const bottomNavItems = sortedItems.slice(0, 5);
          const drawerItems = sortedItems.slice(5);
          return {
            primaryItems: bottomNavItems,
            drawerItems
          };
        }
      case 'tablet':
        {
          // Nav Rail: 3-7 items, rest in drawer
          const railItems = sortedItems.slice(0, 7);
          const railDrawerItems = sortedItems.slice(7);
          return {
            primaryItems: railItems,
            drawerItems: railDrawerItems
          };
        }
      case 'desktop':
        {
          // App Bar: 5-7 items, rest in drawer
          const appBarItems = sortedItems.slice(0, 7);
          const appBarDrawerItems = sortedItems.slice(7);
          return {
            primaryItems: appBarItems,
            drawerItems: appBarDrawerItems
          };
        }
      default:
        return {
          primaryItems: sortedItems,
          drawerItems: []
        };
    }
  };
  const {
    primaryItems,
    drawerItems
  } = getNavigationSplit();
  // Enhanced app bar configuration with page integration
  const enhancedAppBar = React.useMemo(() => {
    const baseAppBar = appBar || {};
    return {
      ...baseAppBar,
      title: baseAppBar.title || appName,
      actions: baseAppBar.actions
    };
  }, [appBar, appName]);
  // Get the logo to display
  const displayLogo = enhancedAppBar?.logo || contextLogo || jsx(Logo, {
    name: enhancedAppBar?.title || appName,
    size: "small"
  });
  // Toggle drawer
  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };
  // Toggle rail expansion (tablet only)
  const toggleRail = () => {
    setIsRailExpanded(!isRailExpanded);
  };
  // Render menu item with proper touch targets (48px minimum)
  const renderMenuItem = (item, variant = 'appbar') => {
    // Determine if this item is active
    const isActiveItem = item.active || item.route && currentPath === item.route || !item.active && !item.route && currentPath && currentPath === `/${item.id}`;
    // Debug logging for route matching
    if (item.route) {
      logger$1.debug(`Route matching for ${item.id}: ${currentPath} === ${item.route} = ${isActiveItem}`);
    }
    // Handle click - automatic navigation if no onClick provided
    const handleClick = () => {
      if (item.disabled) return;
      // Enhanced same-route detection
      const isSameRoute = isActiveItem && item.route === currentPath;
      if (isSameRoute) {
        logger$1.debug(`Navigation prevented: Already on route ${item.route}`);
        return;
      }
      if (item.onClick) {
        try {
          item.onClick();
        } catch (error) {
          logger$1.error('Menu item onClick error:', error);
        }
      } else if (item.route) {
        // Robust navigation with comprehensive error handling
        try {
          logger$1.debug(`Navigating from ${currentPath} to ${item.route}`);
          // Additional safety check to prevent same-route navigation
          if (currentPath && currentPath === item.route) {
            logger$1.debug('Final check: Same route detected, skipping navigation');
            return;
          }
          // Perform navigation with React Router v6
          navigate(item.route);
        } catch (error) {
          const errorMessage = error instanceof Error ? error.message : 'Unknown error';
          logger$1.error('Navigation error caught:', error);
          logger$1.error('Navigation context:', {
            from: currentPath,
            to: item.route,
            isActiveItem,
            itemId: item.id,
            errorMessage
          });
          // Fallback: use window.location for critical navigation
          if (item.route && item.route !== currentPath) {
            try {
              logger$1.debug('Attempting fallback navigation using window.location');
              window.location.pathname = item.route;
            } catch (fallbackError) {
              logger$1.error('Fallback navigation also failed:', fallbackError);
            }
          }
        }
      }
    };
    // Transform icon string to component, or use provided ReactNode, or fallback to radio_button_unchecked
    const needsIcon = variant !== 'drawer';
    let displayIcon = null;
    if (item.icon) {
      // If icon is a string, transform it to component
      if (typeof item.icon === 'string') {
        displayIcon = getIconComponent(item.icon) || (needsIcon ? getIconComponent('radio_button_unchecked') : null);
      } else {
        // If icon is already a React component, use it
        displayIcon = item.icon;
      }
    } else if (needsIcon) {
      // No icon provided, use default for primary navigation
      displayIcon = getIconComponent('radio_button_unchecked');
    }
    const content = jsxs(Fragment, {
      children: [displayIcon && jsx("span", {
        className: `menu-item-icon menu-item-icon-${variant}`,
        children: displayIcon
      }), jsx("span", {
        className: `menu-item-label menu-item-label-${variant}`,
        children: item.label
      }), item.badge && jsx("span", {
        className: "menu-item-badge",
        children: item.badge
      })]
    });
    const commonProps = {
      className: `menu-item menu-item-${variant} ${isActiveItem ? 'active' : ''} ${item.disabled ? 'disabled' : ''}`,
      'aria-label': item.label,
      'aria-current': isActiveItem ? 'page' : undefined,
      onClick: item.disabled ? undefined : handleClick
    };
    // External links
    if (item.href && !item.disabled) {
      return jsx("a", {
        href: item.href,
        ...commonProps,
        target: "_blank",
        rel: "noopener noreferrer",
        children: content
      });
    }
    // Internal navigation or custom click handlers
    return jsx("button", {
      type: "button",
      ...commonProps,
      disabled: Boolean(item.disabled || isActiveItem && item.route === currentPath),
      children: content
    });
  };
  // Calculate layout spacing
  // Base padding varies by screen size, plus extra space for nav elements
  const getLayoutSpacing = () => {
    // Base padding: 16px mobile, 24px tablet, 32px desktop
    const basePadding = screenSize === 'mobile' ? 16 : screenSize === 'tablet' ? 24 : 32;
    // Add nav element heights/widths to the appropriate side
    const paddingTop = basePadding + (showAppBar ? appBarHeight : 0);
    const paddingBottom = basePadding + (screenSize === 'mobile' ? 80 : 0); // Bottom nav height
    const paddingLeft = basePadding + (screenSize === 'tablet' ? isRailExpanded ? 280 : 80 : 0); // Rail width
    const paddingRight = basePadding;
    return {
      paddingTop,
      paddingBottom,
      paddingLeft,
      paddingRight
    };
  };
  const layoutSpacing = getLayoutSpacing();
  const AppLogo = () => {
    return jsx("div", {
      className: "appbar-logo",
      onClick: onLogoClick,
      style: {
        cursor: onLogoClick ? 'pointer' : 'default'
      },
      children: displayLogo
    });
  };
  return jsxs("div", {
    className: `app-scaffold ${className}`,
    children: [showAppBar && jsx("header", {
      className: "app-scaffold-appbar",
      style: {
        height: appBarHeight
      },
      children: jsxs("div", {
        className: "appbar-content",
        children: [jsxs("div", {
          className: "appbar-left",
          children: [(drawerItems.length > 0 || screenSize === 'tablet') && jsx("button", {
            type: "button",
            className: "menu-button",
            onClick: screenSize === 'tablet' ? toggleRail : toggleDrawer,
            "aria-label": screenSize === 'tablet' ? 'Toggle navigation rail' : 'Open drawer menu',
            children: jsxs("span", {
              className: "hamburger-icon",
              children: [jsx("span", {}, "hamburger-line-1"), jsx("span", {}, "hamburger-line-2"), jsx("span", {}, "hamburger-line-3")]
            })
          }, "menu-button"), (!enhancedAppBar?.logoPosition || enhancedAppBar.logoPosition === 'left') && jsx(AppLogo, {}, "app-logo-left")]
        }), jsxs("div", {
          className: "appbar-center",
          children: [enhancedAppBar?.logoPosition === 'center' && jsx(AppLogo, {}, "app-logo-center"), screenSize === 'desktop' && jsx("nav", {
            className: "appbar-navigation",
            children: primaryItems.map(item => jsx(React.Fragment, {
              children: renderMenuItem(item, 'appbar')
            }, item.id))
          }, "desktop-navigation")]
        }), jsxs("div", {
          className: "appbar-right",
          children: [enhancedAppBar?.actions && jsx("div", {
            className: "appbar-actions",
            children: typeof enhancedAppBar.actions === 'function' ? enhancedAppBar.actions() : enhancedAppBar.actions
          }, "appbar-actions"), jsxs("div", {
            className: "appbar-theme-controls",
            children: [showThemeSwitcher && jsx(ThemeSwitcher, {}, "theme-switcher"), showPaletteSwitcher && jsx(PaletteSwitcher, {}, "palette-switcher")]
          }, "appbar-theme-controls")]
        })]
      })
    }), screenSize === 'tablet' && jsx("nav", {
      className: `navigation-rail ${isRailExpanded ? 'expanded' : 'collapsed'}`,
      children: jsx("div", {
        className: "rail-items",
        children: primaryItems.map(item => jsx(React.Fragment, {
          children: renderMenuItem(item, 'rail')
        }, item.id))
      })
    }), screenSize === 'mobile' && primaryItems.length > 0 && jsx("nav", {
      className: "bottom-navigation",
      children: jsx("div", {
        className: "bottom-nav-items",
        children: primaryItems.map(item => jsx(React.Fragment, {
          children: renderMenuItem(item, 'bottom')
        }, item.id))
      })
    }), isDrawerOpen && drawerItems.length > 0 && jsx("div", {
      className: "drawer-overlay",
      onClick: toggleDrawer,
      children: jsxs("nav", {
        className: "navigation-drawer",
        onClick: e => e.stopPropagation(),
        children: [jsxs("div", {
          className: "drawer-header",
          children: [jsx("h3", {
            children: "Menu"
          }, "drawer-title"), jsx("button", {
            type: "button",
            className: "drawer-close",
            onClick: toggleDrawer,
            "aria-label": "Close drawer",
            children: "\u00D7"
          }, "drawer-close-button")]
        }), jsxs("div", {
          className: "drawer-items",
          children: [jsxs("div", {
            className: "drawer-section",
            children: [jsx("h4", {
              children: "Navigation"
            }, "navigation-header"), primaryItems.map(item => jsx(React.Fragment, {
              children: renderMenuItem(item, 'drawer')
            }, item.id))]
          }), drawerItems.length > 0 && jsxs("div", {
            className: "drawer-section",
            children: [jsx("h4", {
              children: "More"
            }, "more-header"), drawerItems.map(item => jsx(React.Fragment, {
              children: renderMenuItem(item, 'drawer')
            }, item.id))]
          })]
        })]
      })
    }), jsx("main", {
      className: "app-scaffold-content",
      style: {
        paddingTop: `${layoutSpacing.paddingTop}px`,
        paddingBottom: `${layoutSpacing.paddingBottom}px`,
        paddingLeft: `${layoutSpacing.paddingLeft}px`,
        paddingRight: `${layoutSpacing.paddingRight}px`
      },
      children: children
    })]
  });
};

const logger = loggers.menu;
const ResponsiveMenu = props => {
  const {
    styleProps,
    htmlProps,
    restProps
  } = useBaseProps(props);
  const {
    items = [],
    logo,
    showLogo = true,
    logoPosition = 'left',
    brandText,
    onMenuToggle
  } = restProps;
  // Mark as QwickApp component
  Object.assign(ResponsiveMenu, {
    [QWICKAPP_COMPONENT]: true
  });
  const [screenSize, setScreenSize] = useState('desktop');
  const [isNavRailExpanded, setIsNavRailExpanded] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const {
    appName,
    logo: contextLogo
  } = useQwickApp$1();
  // Navigation (uses React Router if available, falls back to window.location)
  const {
    navigate,
    location
  } = useNavigation();
  const currentPath = location?.pathname;
  // Debug logging
  React.useEffect(() => {
    logger.debug('Navigate function available:', !!navigate);
    logger.debug('Current path:', currentPath);
  }, [navigate, currentPath]);
  // Determine current screen size
  useEffect(() => {
    const updateScreenSize = () => {
      const width = window.innerWidth;
      if (width < 768) {
        setScreenSize('mobile');
      } else if (width <= 1024) {
        setScreenSize('tablet');
      } else {
        setScreenSize('desktop');
      }
    };
    updateScreenSize();
    window.addEventListener('resize', updateScreenSize);
    return () => window.removeEventListener('resize', updateScreenSize);
  }, []);
  // Handle nav rail expansion
  const toggleNavRail = () => {
    const newExpanded = !isNavRailExpanded;
    setIsNavRailExpanded(newExpanded);
    onMenuToggle?.(newExpanded);
  };
  // Handle drawer toggle
  const toggleDrawer = () => {
    const newOpen = !isDrawerOpen;
    setIsDrawerOpen(newOpen);
    onMenuToggle?.(newOpen);
  };
  // Get the logo to display
  const displayLogo = logo || contextLogo || jsx(Logo, {
    name: brandText || appName,
    size: "small"
  });
  // Render menu item
  const renderMenuItem = (item, isCompact = false) => {
    // Determine if this item is active
    const isActiveItem = item.active || item.route && currentPath === item.route || !item.active && !item.route && currentPath && currentPath === `/${item.id}`;
    // Handle click - automatic navigation if no onClick provided
    const handleClick = () => {
      logger.debug('handleClick:', {
        itemId: item.id,
        route: item.route,
        disabled: item.disabled,
        isActiveItem,
        currentPath,
        hasNavigate: !!navigate,
        hasOnClick: !!item.onClick
      });
      if (item.disabled) return;
      // Don't navigate if already on this route
      if (isActiveItem && item.route === currentPath) return;
      if (item.onClick) {
        item.onClick();
      } else if (item.route && navigate) {
        // Automatic navigation using React Router
        logger.debug('Navigating to:', item.route);
        navigate(item.route);
      } else {
        logger.warn('Cannot navigate: missing navigate function or route');
      }
    };
    // Transform icon string to component or use provided ReactNode
    let displayIcon = null;
    if (item.icon) {
      if (typeof item.icon === 'string') {
        displayIcon = getIconComponent(item.icon);
      } else {
        displayIcon = item.icon;
      }
    }
    const content = jsxs(Fragment, {
      children: [displayIcon && jsx("span", {
        className: "menu-item-icon",
        children: displayIcon
      }), !isCompact && jsx("span", {
        className: "menu-item-label",
        children: item.label
      }), item.badge && jsx("span", {
        className: "menu-item-badge",
        children: item.badge
      })]
    });
    const buttonProps = {
      className: `menu-item ${isActiveItem ? 'active' : ''} ${item.disabled ? 'disabled' : ''}`,
      'aria-label': item.label,
      'aria-current': isActiveItem ? 'page' : undefined,
      onClick: item.disabled ? undefined : handleClick
    };
    // External links
    if (item.href && !item.disabled) {
      return jsx("a", {
        href: item.href,
        ...buttonProps,
        target: "_blank",
        rel: "noopener noreferrer",
        children: content
      });
    }
    // Internal navigation or custom click handlers
    logger.debug('Rendering menu button for:', item.id, {
      disabled: Boolean(item.disabled || isActiveItem && item.route === currentPath),
      hasOnClick: !!buttonProps.onClick,
      route: item.route
    });
    return jsx("button", {
      type: "button",
      ...buttonProps,
      disabled: Boolean(item.disabled || isActiveItem && item.route === currentPath),
      style: {
        pointerEvents: 'auto',
        cursor: 'pointer'
      },
      onMouseDown: () => logger.debug('Mouse down on:', item.id),
      children: content
    });
  };
  // Mobile: Bottom Navigation
  if (screenSize === 'mobile') {
    return jsx("nav", {
      ...htmlProps,
      ...styleProps,
      className: `responsive-menu mobile-bottom-nav ${styleProps.className || ''}`,
      role: "navigation",
      children: jsx("div", {
        className: "mobile-nav-items",
        children: items.map(item => jsx(React.Fragment, {
          children: renderMenuItem(item, true)
        }, item.id))
      })
    });
  }
  // Tablet: Nav Rail (Expandable Sidebar)
  if (screenSize === 'tablet') {
    return jsxs("nav", {
      ...htmlProps,
      ...styleProps,
      className: `responsive-menu tablet-nav-rail ${isNavRailExpanded ? 'expanded' : 'collapsed'} ${styleProps.className || ''}`,
      role: "navigation",
      children: [jsxs("div", {
        className: "nav-rail-header",
        children: [showLogo && jsx("div", {
          className: "nav-rail-logo",
          children: displayLogo
        }), jsx("button", {
          type: "button",
          className: "nav-rail-toggle",
          onClick: toggleNavRail,
          "aria-label": isNavRailExpanded ? 'Collapse navigation' : 'Expand navigation',
          "aria-expanded": isNavRailExpanded,
          children: jsxs("span", {
            className: "hamburger-icon",
            children: [jsx("span", {}), jsx("span", {}), jsx("span", {})]
          })
        })]
      }), jsx("div", {
        className: "nav-rail-items",
        children: items.map(item => jsx(React.Fragment, {
          children: renderMenuItem(item, !isNavRailExpanded)
        }, item.id))
      })]
    });
  }
  // Desktop: Top Navigation with Drawer
  return jsxs(Fragment, {
    children: [jsx("nav", {
      ...htmlProps,
      ...styleProps,
      className: `responsive-menu desktop-top-nav ${styleProps.className || ''}`,
      role: "navigation",
      children: jsxs("div", {
        className: "top-nav-content",
        children: [(logoPosition === 'left' || logoPosition === 'center') && showLogo && jsx("div", {
          className: `top-nav-logo logo-${logoPosition}`,
          children: displayLogo
        }), jsxs("div", {
          className: "top-nav-items",
          children: [items.slice(0, 5).map(item => jsx(React.Fragment, {
            children: renderMenuItem(item)
          }, item.id)), items.length > 5 && jsx("button", {
            type: "button",
            className: "menu-toggle",
            onClick: toggleDrawer,
            "aria-label": "Open menu drawer",
            "aria-expanded": isDrawerOpen,
            children: jsxs("span", {
              className: "hamburger-icon",
              children: [jsx("span", {}), jsx("span", {}), jsx("span", {})]
            })
          })]
        }), logoPosition === 'right' && showLogo && jsx("div", {
          className: "top-nav-logo logo-right",
          children: displayLogo
        })]
      })
    }), isDrawerOpen && jsx("div", {
      className: "menu-drawer-overlay",
      onClick: toggleDrawer,
      children: jsxs("div", {
        className: "menu-drawer",
        onClick: e => e.stopPropagation(),
        children: [jsxs("div", {
          className: "drawer-header",
          children: [jsx("h3", {
            children: "Menu"
          }), jsx("button", {
            type: "button",
            className: "drawer-close",
            onClick: toggleDrawer,
            "aria-label": "Close menu drawer",
            children: "\u00D7"
          })]
        }), jsx("div", {
          className: "drawer-items",
          children: items.map(item => jsx(React.Fragment, {
            children: renderMenuItem(item)
          }, item.id))
        })]
      })
    })]
  });
};

/**
 * Generic ErrorBoundary component for catching and handling React errors
 *
 * Features:
 * - Catches JavaScript errors anywhere in child component tree
 * - Displays fallback UI with retry functionality
 * - Shows error details in development mode
 * - Customizable error handling and fallback UI
 * - Automatic error logging
 */
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.handleRetry = () => {
      this.setState({
        hasError: false,
        error: null,
        errorInfo: null
      });
    };
    this.handleRefresh = () => {
      if (typeof window !== 'undefined') {
        window.location.reload();
      }
    };
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null
    };
  }
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return {
      hasError: true,
      error,
      errorInfo: null
    };
  }
  componentDidCatch(error, errorInfo) {
    // Log error details
    this.setState({
      error,
      errorInfo
    });
    // Log to console for debugging
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    // Custom error handler
    if (this.props.onError) {
      this.props.onError(error, errorInfo);
    }
    // Send error to logging service if available
    if (typeof window !== 'undefined') {
      const globalWindow = window;
      if (globalWindow.qwickapps?.logError) {
        globalWindow.qwickapps.logError(error, errorInfo);
      }
    }
  }
  render() {
    if (this.state.hasError) {
      // Custom fallback UI
      if (this.props.fallback) {
        return this.props.fallback;
      }
      // Default error UI
      return jsxs("div", {
        className: "error-boundary",
        role: "alert",
        style: {
          padding: '2rem',
          textAlign: 'center',
          backgroundColor: '#fef2f2',
          border: '1px solid #fecaca',
          borderRadius: '8px',
          margin: '1rem',
          color: '#991b1b'
        },
        children: [jsxs("div", {
          style: {
            marginBottom: '1.5rem'
          },
          children: [jsx("h2", {
            style: {
              fontSize: '1.5rem',
              fontWeight: 'bold',
              marginBottom: '0.5rem',
              color: '#991b1b'
            },
            children: "Something went wrong"
          }), jsx("p", {
            style: {
              color: '#7f1d1d',
              marginBottom: '1rem'
            },
            children: "An unexpected error occurred in the application. Please try again or refresh the page."
          })]
        }), jsxs("div", {
          style: {
            display: 'flex',
            gap: '0.75rem',
            justifyContent: 'center',
            marginBottom: '1rem'
          },
          children: [jsx(Button, {
            variant: "contained",
            onClick: this.handleRetry,
            children: "Try Again"
          }), jsx(Button, {
            variant: "outlined",
            onClick: this.handleRefresh,
            children: "Refresh Page"
          })]
        }), (this.props.showErrorDetails) && this.state.error && jsxs("details", {
          style: {
            textAlign: 'left',
            marginTop: '1rem',
            padding: '1rem',
            backgroundColor: '#f9fafb',
            border: '1px solid #d1d5db',
            borderRadius: '6px'
          },
          children: [jsx("summary", {
            style: {
              cursor: 'pointer',
              fontWeight: 'bold',
              marginBottom: '0.5rem',
              color: '#374151'
            },
            children: "Error Details (Development Mode)"
          }), jsxs("pre", {
            style: {
              fontSize: '0.75rem',
              color: '#374151',
              whiteSpace: 'pre-wrap',
              overflow: 'auto'
            },
            children: [this.state.error.toString(), this.state.errorInfo?.componentStack && jsxs(Fragment, {
              children: [jsx("br", {}), jsx("br", {}), "Component Stack:", this.state.errorInfo.componentStack]
            })]
          })]
        })]
      });
    }
    return this.props.children;
  }
}
/**
 * Higher-order component that wraps a component with ErrorBoundary
 */
function withErrorBoundary(WrappedComponent, errorBoundaryProps) {
  const WithErrorBoundaryComponent = props => jsx(ErrorBoundary, {
    ...errorBoundaryProps,
    children: jsx(WrappedComponent, {
      ...props
    })
  });
  WithErrorBoundaryComponent.displayName = `withErrorBoundary(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
  return WithErrorBoundaryComponent;
}

const AccessibilityContext = /*#__PURE__*/createContext(null);
// Reducer
const accessibilityReducer = (state, action) => {
  switch (action.type) {
    case 'SET_HIGH_CONTRAST':
      return {
        ...state,
        highContrast: action.payload
      };
    case 'SET_REDUCED_MOTION':
      return {
        ...state,
        reducedMotion: action.payload
      };
    case 'SET_LARGE_TEXT':
      return {
        ...state,
        largeText: action.payload
      };
    case 'SET_FOCUS_VISIBLE':
      return {
        ...state,
        focusVisible: action.payload
      };
    case 'SET_KEYBOARD_USER':
      return {
        ...state,
        isKeyboardUser: action.payload
      };
    case 'ADD_ISSUE':
      return {
        ...state,
        issues: [...state.issues, action.payload]
      };
    case 'CLEAR_ISSUES':
      return {
        ...state,
        issues: []
      };
    case 'SET_ANNOUNCEMENT':
      return {
        ...state,
        lastAnnouncement: action.payload
      };
    default:
      return state;
  }
};
// Initial state
const initialState = {
  highContrast: false,
  reducedMotion: false,
  largeText: false,
  focusVisible: true,
  isKeyboardUser: false,
  issues: [],
  lastAnnouncement: null,
  preferences: {}
};
// ARIA Live Manager
class AriaLiveManager {
  constructor() {
    this.politeRegion = null;
    this.assertiveRegion = null;
    this.createLiveRegions();
  }
  createLiveRegions() {
    if (typeof document === 'undefined') return;
    // Polite announcements
    this.politeRegion = document.createElement('div');
    this.politeRegion.setAttribute('aria-live', 'polite');
    this.politeRegion.setAttribute('aria-atomic', 'true');
    this.politeRegion.setAttribute('id', 'qwickapps-aria-live-polite');
    this.politeRegion.style.cssText = `
			position: absolute !important;
			left: -10000px !important;
			width: 1px !important;
			height: 1px !important;
			overflow: hidden !important;
		`;
    document.body.appendChild(this.politeRegion);
    // Assertive announcements
    this.assertiveRegion = document.createElement('div');
    this.assertiveRegion.setAttribute('aria-live', 'assertive');
    this.assertiveRegion.setAttribute('aria-atomic', 'true');
    this.assertiveRegion.setAttribute('id', 'qwickapps-aria-live-assertive');
    this.assertiveRegion.style.cssText = `
			position: absolute !important;
			left: -10000px !important;
			width: 1px !important;
			height: 1px !important;
			overflow: hidden !important;
		`;
    document.body.appendChild(this.assertiveRegion);
  }
  announce(message, level = 'polite') {
    if (level === 'assertive') {
      this.announceAssertive(message);
    } else {
      this.announcePolite(message);
    }
  }
  announcePolite(message) {
    if (!this.politeRegion) return;
    this.politeRegion.textContent = '';
    // Small delay ensures screen readers detect the change
    setTimeout(() => {
      if (this.politeRegion) {
        this.politeRegion.textContent = message;
      }
    }, 100);
  }
  announceAssertive(message) {
    if (!this.assertiveRegion) return;
    this.assertiveRegion.textContent = '';
    // Small delay ensures screen readers detect the change
    setTimeout(() => {
      if (this.assertiveRegion) {
        this.assertiveRegion.textContent = message;
      }
    }, 100);
  }
}
const ariaLiveManager = new AriaLiveManager();
/**
 * Accessibility Provider Component
 * Provides comprehensive accessibility context and utilities
 *
 * Features:
 * - System preference detection (high contrast, reduced motion)
 * - Keyboard navigation detection
 * - ARIA live announcements
 * - Focus management
 * - Accessibility auditing
 * - Settings persistence
 */
const AccessibilityProvider = ({
  children,
  enableAudit = "production" === 'development'
}) => {
  const [state, dispatch] = useReducer(accessibilityReducer, initialState);
  useEffect(() => {
    // Detect user preferences from system
    detectUserPreferences();
    // Set up keyboard detection
    const keyboardCleanup = setupKeyboardDetection();
    // Initialize focus management
    initializeFocusManagement();
    // Run initial accessibility audit
    if (enableAudit) {
      runAccessibilityAudit();
    }
    // Cleanup
    return () => {
      if (keyboardCleanup) keyboardCleanup();
    };
  }, [enableAudit]);
  const detectUserPreferences = () => {
    if (typeof window === 'undefined') return;
    // High contrast mode
    if (window.matchMedia && window.matchMedia('(prefers-contrast: high)').matches) {
      dispatch({
        type: 'SET_HIGH_CONTRAST',
        payload: true
      });
    }
    // Reduced motion
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      dispatch({
        type: 'SET_REDUCED_MOTION',
        payload: true
      });
    }
    // Listen for changes
    if (window.matchMedia) {
      const contrastMedia = window.matchMedia('(prefers-contrast: high)');
      const motionMedia = window.matchMedia('(prefers-reduced-motion: reduce)');
      const contrastHandler = e => {
        dispatch({
          type: 'SET_HIGH_CONTRAST',
          payload: e.matches
        });
      };
      const motionHandler = e => {
        dispatch({
          type: 'SET_REDUCED_MOTION',
          payload: e.matches
        });
      };
      contrastMedia.addEventListener('change', contrastHandler);
      motionMedia.addEventListener('change', motionHandler);
      // Return cleanup function
      return () => {
        contrastMedia.removeEventListener('change', contrastHandler);
        motionMedia.removeEventListener('change', motionHandler);
      };
    }
  };
  const setupKeyboardDetection = () => {
    if (typeof document === 'undefined') return;
    let keyboardUser = false;
    const handleKeyDown = e => {
      if (e.key === 'Tab') {
        keyboardUser = true;
        dispatch({
          type: 'SET_KEYBOARD_USER',
          payload: true
        });
        document.body.classList.add('keyboard-user');
      }
    };
    const handleMouseDown = () => {
      if (keyboardUser) {
        keyboardUser = false;
        dispatch({
          type: 'SET_KEYBOARD_USER',
          payload: false
        });
        document.body.classList.remove('keyboard-user');
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('mousedown', handleMouseDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('mousedown', handleMouseDown);
    };
  };
  const initializeFocusManagement = () => {
    if (typeof document === 'undefined') return;
    // Enhanced focus indicators for keyboard users
    const style = document.createElement('style');
    style.textContent = `
			.keyboard-user *:focus {
				outline: 3px solid #005cee !important;
				outline-offset: 2px !important;
			}
			
			.high-contrast *:focus {
				outline: 3px solid #ffffff !important;
				outline-offset: 2px !important;
				box-shadow: 0 0 0 1px #000000 !important;
			}
			
			.reduced-motion * {
				animation-duration: 0.01ms !important;
				animation-iteration-count: 1 !important;
				transition-duration: 0.01ms !important;
			}
			
			.large-text {
				font-size: 1.2em !important;
			}
		`;
    document.head.appendChild(style);
  };
  const runAccessibilityAudit = () => {
    if (typeof document === 'undefined') return;
    setTimeout(() => {
      const issues = [];
      // Check for images without alt text
      const images = document.querySelectorAll('img:not([alt])');
      images.forEach(img => {
        issues.push({
          type: 'missing-alt-text',
          message: 'Image missing alt attribute',
          level: 'error',
          element: img
        });
      });
      // Check for buttons without accessible names
      const buttons = document.querySelectorAll('button:not([aria-label]):not([title])');
      buttons.forEach(button => {
        if (!button.textContent?.trim()) {
          issues.push({
            type: 'unnamed-button',
            message: 'Button missing accessible name',
            level: 'error',
            element: button
          });
        }
      });
      // Check for form inputs without labels
      const inputs = document.querySelectorAll('input:not([aria-label]):not([title])');
      inputs.forEach(input => {
        const id = input.getAttribute('id');
        if (id) {
          const label = document.querySelector(`label[for="${id}"]`);
          if (!label) {
            issues.push({
              type: 'unlabeled-input',
              message: 'Form input missing label',
              level: 'error',
              element: input
            });
          }
        } else {
          issues.push({
            type: 'unlabeled-input',
            message: 'Form input missing label',
            level: 'error',
            element: input
          });
        }
      });
      dispatch({
        type: 'CLEAR_ISSUES'
      });
      issues.forEach(issue => {
        dispatch({
          type: 'ADD_ISSUE',
          payload: issue
        });
      });
      if (issues.length > 0) {
        console.group('🔍 Accessibility Issues Found');
        issues.forEach(issue => {
          const logMethod = issue.level === 'error' ? console.error : console.warn;
          logMethod(`${issue.type}: ${issue.message}`);
        });
        console.groupEnd();
      }
    }, 1000);
  };
  // Context value
  const contextValue = {
    ...state,
    // Actions
    setHighContrast: enabled => dispatch({
      type: 'SET_HIGH_CONTRAST',
      payload: enabled
    }),
    setReducedMotion: enabled => dispatch({
      type: 'SET_REDUCED_MOTION',
      payload: enabled
    }),
    setLargeText: enabled => dispatch({
      type: 'SET_LARGE_TEXT',
      payload: enabled
    }),
    setFocusVisible: enabled => dispatch({
      type: 'SET_FOCUS_VISIBLE',
      payload: enabled
    }),
    // Utilities
    announce: (message, level = 'polite') => {
      ariaLiveManager.announce(message, level);
      dispatch({
        type: 'SET_ANNOUNCEMENT',
        payload: {
          message,
          level,
          timestamp: Date.now()
        }
      });
    },
    announcePolite: message => {
      ariaLiveManager.announcePolite(message);
      dispatch({
        type: 'SET_ANNOUNCEMENT',
        payload: {
          message,
          level: 'polite',
          timestamp: Date.now()
        }
      });
    },
    announceAssertive: message => {
      ariaLiveManager.announceAssertive(message);
      dispatch({
        type: 'SET_ANNOUNCEMENT',
        payload: {
          message,
          level: 'assertive',
          timestamp: Date.now()
        }
      });
    },
    addIssue: issue => dispatch({
      type: 'ADD_ISSUE',
      payload: issue
    }),
    clearIssues: () => dispatch({
      type: 'CLEAR_ISSUES'
    }),
    // Audit function
    runAudit: runAccessibilityAudit
  };
  // Apply CSS classes based on preferences
  useEffect(() => {
    if (typeof document === 'undefined') return;
    const {
      highContrast,
      reducedMotion,
      largeText
    } = state;
    document.body.classList.toggle('high-contrast', highContrast);
    document.body.classList.toggle('reduced-motion', reducedMotion);
    document.body.classList.toggle('large-text', largeText);
    // Using specific properties is more granular than using entire state object
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.highContrast, state.reducedMotion, state.largeText]);
  return jsx(AccessibilityContext.Provider, {
    value: contextValue,
    children: children
  });
};
/**
 * Hook to access accessibility context
 */
const useAccessibility = () => {
  const context = useContext(AccessibilityContext);
  if (!context) {
    throw new Error('useAccessibility must be used within an AccessibilityProvider');
  }
  return context;
};
/**
 * Higher-Order Component for accessibility enhancements
 */
const withAccessibility = WrappedComponent => {
  const AccessibilityEnhancedComponent = props => {
    const accessibility = useAccessibility();
    return jsx(WrappedComponent, {
      ...props,
      accessibility: accessibility
    });
  };
  AccessibilityEnhancedComponent.displayName = `withAccessibility(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
  return AccessibilityEnhancedComponent;
};

const QwickApp = ({
  children,
  className,
  style,
  defaultTheme: defaultThemeProp,
  defaultPalette: defaultPaletteProp,
  appName: appNameProp,
  logo: logoProp,
  appId: appIdProp,
  enableScaffolding: enableScaffoldingProp,
  navigationItems: navigationItemsProp = [],
  appBar,
  showAppBar: showAppBarProp = true,
  appBarHeight: appBarHeightProp = 64,
  showThemeSwitcher: showThemeSwitcherProp,
  showPaletteSwitcher: showPaletteSwitcherProp,
  onLogoClick,
  router,
  dataSource,
  config
}) => {
  // Resolve configuration: explicit props override config defaults
  const resolvedConfig = {
    appName: appNameProp ?? config?.app.name,
    appId: appIdProp ?? config?.app.id,
    logo: logoProp ?? config?.app.logo,
    enableScaffolding: enableScaffoldingProp ?? config?.ui.enableScaffolding ?? false,
    showThemeSwitcher: showThemeSwitcherProp ?? config?.ui.showThemeSwitcher ?? false,
    showPaletteSwitcher: showPaletteSwitcherProp ?? config?.ui.showPaletteSwitcher ?? false,
    defaultTheme: defaultThemeProp ?? config?.ui.defaultTheme,
    defaultPalette: defaultPaletteProp ?? config?.ui.defaultPalette
  };
  // Ensure we have required configuration
  if (!resolvedConfig.appName) {
    throw new Error('QwickApp requires either appName prop or config with app.name');
  }
  // State for app configuration that can be updated via useQwickApp
  const [appConfig, setAppConfig] = useState({
    logo: resolvedConfig.logo,
    enableScaffolding: resolvedConfig.enableScaffolding,
    navigationItems: navigationItemsProp,
    appBar,
    showAppBar: showAppBarProp,
    appBarHeight: appBarHeightProp,
    showThemeSwitcher: resolvedConfig.showThemeSwitcher,
    showPaletteSwitcher: resolvedConfig.showPaletteSwitcher
  });
  const updateConfig = updates => {
    setAppConfig(prev => ({
      ...prev,
      ...updates
    }));
  };
  // Sync logo prop changes with internal state (for dynamic logo updates)
  useEffect(() => {
    if (resolvedConfig.logo !== appConfig.logo) {
      setAppConfig(prev => ({
        ...prev,
        logo: resolvedConfig.logo
      }));
    }
  }, [resolvedConfig.logo]);
  const contextValue = {
    appName: resolvedConfig.appName,
    // Safe to use ! since we validated above
    appId: resolvedConfig.appId,
    ...appConfig,
    onLogoClick,
    updateConfig
    // Navigation removed - now handled by AuthProvider when routing needed
  };
  const content = appConfig.enableScaffolding ? jsx(Scaffold, {
    appName: resolvedConfig.appName,
    navigationItems: appConfig.navigationItems,
    appBar: appConfig.appBar,
    showAppBar: appConfig.showAppBar,
    appBarHeight: appConfig.appBarHeight,
    showThemeSwitcher: appConfig.showThemeSwitcher,
    showPaletteSwitcher: appConfig.showPaletteSwitcher,
    onLogoClick: onLogoClick,
    children: children
  }) : children;
  // Wrap with DataProvider if dataSource is provided (FIRST wrapper)
  const wrappedContent = dataSource ? jsx(DataProvider, {
    dataSource: dataSource,
    children: content
  }) : content;
  const appContent = jsx(ErrorBoundary, {
    children: jsx(AccessibilityProvider, {
      children: jsx(NavigationProvider, {
        children: jsx("div", {
          className: `qwick-app ${className || ''}`,
          style: style,
          children: jsx(ThemeProvider, {
            appId: resolvedConfig.appId,
            defaultTheme: resolvedConfig.defaultTheme,
            defaultPalette: resolvedConfig.defaultPalette,
            children: jsx(QwickAppContext.Provider, {
              value: contextValue,
              children: jsx(PrintModeProvider, {
                children: wrappedContent
              })
            })
          })
        })
      })
    })
  });
  // If router is provided, wrap the entire app with it
  if (router) {
    return /*#__PURE__*/cloneElement(router, {}, appContent);
  }
  return appContent;
};
const useQwickApp = () => {
  const context = React.useContext(QwickAppContext);
  if (!context) {
    throw new Error('useQwickApp must be used within a QwickApp provider');
  }
  return context;
};

// Palette utilities for QwickApps Theme System
/**
 * Available palette options
 */
const AVAILABLE_PALETTES = [{
  id: 'default',
  name: 'Default',
  description: 'Classic blue and neutral colors',
  primaryColor: '#007bff'
}, {
  id: 'winter',
  name: 'Winter',
  description: 'Cool blues and icy whites',
  primaryColor: '#0077be'
}, {
  id: 'autumn',
  name: 'Autumn',
  description: 'Warm oranges and golden yellows',
  primaryColor: '#ea580c'
}, {
  id: 'spring',
  name: 'Spring',
  description: 'Fresh greens and soft pinks',
  primaryColor: '#16a34a'
}, {
  id: 'ocean',
  name: 'Ocean',
  description: 'Deep blues and aqua teals',
  primaryColor: '#0891b2'
}];
/**
 * Get the current palette from CSS variables
 */
const getCurrentPalette = () => {
  if (typeof document === 'undefined') {
    return 'default'; // SSR fallback
  }
  const root = document.documentElement;
  return root.getAttribute('data-palette') || 'default';
};
/**
 * Set palette and update CSS variables
 */
const setPalette = palette => {
  if (typeof document === 'undefined' || typeof window === 'undefined') {
    return; // SSR - no-op
  }
  const root = document.documentElement;
  root.setAttribute('data-palette', palette);
  // Trigger custom event for palette change
  window.dispatchEvent(new CustomEvent('paletteChange', {
    detail: {
      palette
    }
  }));
};
/**
 * Get palette display name
 */
const getPaletteName = paletteId => {
  const palette = AVAILABLE_PALETTES.find(p => p.id === paletteId);
  return palette ? palette.name : paletteId;
};
/**
 * Get palette configuration by ID
 */
const getPaletteConfig = paletteId => {
  return AVAILABLE_PALETTES.find(p => p.id === paletteId);
};
/**
 * Initialize palette system
 */
const initializePalette = () => {
  if (typeof localStorage === 'undefined') {
    return; // SSR - no-op
  }
  const savedPalette = localStorage.getItem('palette') || 'default';
  setPalette(savedPalette);
};
/**
 * Save palette preference to localStorage
 */
const savePalettePreference = palette => {
  if (typeof localStorage === 'undefined') {
    return; // SSR - no-op
  }
  localStorage.setItem('palette', palette);
  setPalette(palette);
};
/**
 * Get CSS custom property value
 */
const getCSSVariable = property => {
  if (typeof document === 'undefined') {
    return ''; // SSR fallback
  }
  return getComputedStyle(document.documentElement).getPropertyValue(property).trim();
};
/**
 * Set CSS custom property value
 */
const setCSSVariable = (property, value) => {
  if (typeof document === 'undefined') {
    return; // SSR - no-op
  }
  document.documentElement.style.setProperty(property, value);
};

/**
 * Generic Breadcrumbs component for navigation hierarchy
 *
 * Features:
 * - Accessible navigation with proper ARIA labels
 * - Customizable separators and icons
 * - Responsive design with item truncation
 * - Support for custom navigation handlers
 * - Keyboard navigation support
 * - Screen reader friendly
 */
const Breadcrumbs = ({
  items,
  separator = '/',
  className = '',
  onNavigate,
  maxItems,
  showRoot = true
}) => {
  // Filter and prepare items
  let displayItems = showRoot ? items : items.slice(1);
  // Handle max items with ellipsis
  if (maxItems && displayItems.length > maxItems) {
    const firstItems = displayItems.slice(0, 1);
    const lastItems = displayItems.slice(-Math.max(1, maxItems - 2));
    displayItems = [...firstItems, {
      label: '...',
      href: undefined,
      current: false
    }, ...lastItems];
  }
  const handleItemClick = (e, item, index) => {
    if (onNavigate) {
      e.preventDefault();
      onNavigate(item, index);
    }
  };
  const handleKeyDown = (e, item, index) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      if (onNavigate) {
        onNavigate(item, index);
      } else if (item.href) {
        window.location.href = item.href;
      }
    }
  };
  if (displayItems.length <= 1) {
    return null;
  }
  return jsx("nav", {
    className: `breadcrumbs ${className}`,
    role: "navigation",
    "aria-label": "Breadcrumb navigation",
    style: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      color: '#6b7280',
      ...defaultStyles.nav
    },
    children: jsx("ol", {
      style: {
        display: 'flex',
        alignItems: 'center',
        listStyle: 'none',
        margin: 0,
        padding: 0,
        gap: '8px'
      },
      children: displayItems.map((item, index) => {
        const isLast = index === displayItems.length - 1;
        const isClickable = (item.href || onNavigate) && !item.current && item.label !== '...';
        return jsxs("li", {
          style: {
            display: 'flex',
            alignItems: 'center'
          },
          children: [isClickable ? jsxs("a", {
            href: item.href,
            onClick: e => handleItemClick(e, item, index),
            onKeyDown: e => handleKeyDown(e, item, index),
            style: {
              ...defaultStyles.link,
              color: isLast ? '#374151' : '#6b7280',
              textDecoration: 'none',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            },
            tabIndex: 0,
            "aria-current": item.current ? 'page' : undefined,
            children: [item.icon && jsx("span", {
              style: {
                display: 'flex',
                alignItems: 'center'
              },
              "aria-hidden": "true",
              children: item.icon
            }), jsx("span", {
              children: item.label
            })]
          }) : jsxs("span", {
            style: {
              ...defaultStyles.current,
              color: isLast ? '#111827' : '#6b7280',
              fontWeight: isLast ? 600 : 400,
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            },
            "aria-current": item.current ? 'page' : undefined,
            children: [item.icon && jsx("span", {
              style: {
                display: 'flex',
                alignItems: 'center'
              },
              "aria-hidden": "true",
              children: item.icon
            }), jsx("span", {
              children: item.label
            })]
          }), !isLast && jsx("span", {
            style: {
              display: 'flex',
              alignItems: 'center',
              marginLeft: '8px',
              color: '#d1d5db',
              fontSize: '12px'
            },
            "aria-hidden": "true",
            children: separator
          })]
        }, `${item.label}-${index}`);
      })
    })
  });
};
// Default styles
const defaultStyles = {
  nav: {
    padding: '8px 0'
  },
  link: {
    transition: 'color 0.2s ease',
    cursor: 'pointer',
    borderRadius: '4px',
    padding: '4px',
    margin: '-4px'
  },
  current: {
    padding: '4px'
  }
};
/**
 * Hook for managing breadcrumb state
 */
const useBreadcrumbs = () => {
  const [breadcrumbs, setBreadcrumbs] = React.useState([]);
  const addBreadcrumb = React.useCallback(item => {
    setBreadcrumbs(prev => [...prev, item]);
  }, []);
  const removeBreadcrumb = React.useCallback(index => {
    setBreadcrumbs(prev => prev.filter((_, i) => i !== index));
  }, []);
  const setBreadcrumbsCurrent = React.useCallback(items => {
    setBreadcrumbs(items);
  }, []);
  const clearBreadcrumbs = React.useCallback(() => {
    setBreadcrumbs([]);
  }, []);
  return {
    breadcrumbs,
    addBreadcrumb,
    removeBreadcrumb,
    setBreadcrumbs: setBreadcrumbsCurrent,
    clearBreadcrumbs
  };
};

const QwickIcon = ({
  size = 48,
  showBackground = true,
  className = '',
  style = {}
}) => jsxs("svg", {
  width: size,
  height: size,
  viewBox: "0 0 225 225",
  className: `qwick-icon ${className}`.trim(),
  style: {
    // Set CSS variable for background opacity based on showBackground prop
    ['--qwick-icon-bg-opacity']: showBackground ? '1' : '0',
    ...style
  },
  role: "img",
  "aria-label": "QwickApps Icon",
  children: [jsx("rect", {
    width: "225",
    height: "225",
    rx: "48",
    fill: "var(--qwick-icon-bg-fill, var(--theme-surface, #f5f5f5))",
    opacity: "var(--qwick-icon-bg-opacity, 1)"
  }), jsx("path", {
    className: "logo-first-part",
    fill: "var(--qwick-icon-primary, #FE6D0F)",
    d: "M47.11201171875 5.950634765625 C48.32529496875 5.943537869625 48.32529496875 5.943537869625 49.56308898975 5.9362976036249995 C52.21878426675 5.924481926625 54.87398784675 5.9322617876249994 57.52968749775 5.941406246625 C59.39027803575 5.9395851056249995 61.250867943749995 5.936962748625 63.11145629475 5.933578487625 C67.00600720575 5.929605617625 70.90039050975 5.935357193625 74.79492187275 5.947998044625 C79.76162383875 5.963341469625 84.72793052475001 5.954543321625 89.69461784775001 5.938352393625 C93.53680333874999 5.928543572625 97.37889692175 5.931725711625 101.22108535575 5.9386974356249995 C103.05092745675 5.940486149624999 104.88077817075 5.938332422625 106.71061020075 5.932002641625 C116.17521986475 5.906454404625 125.03337841575001 5.906314571625 134.09999999775 8.999999996625 C134.89889446575 9.260790431625 135.69778894274998 9.521580875625 136.52089233075 9.790274048625 C149.85061125975 14.337699449625 160.93283047875 25.541335373625003 167.39999999775 37.799999996625 C170.81263961775 45.527064845625 172.94668749674997 52.246565267625 172.90217284875 60.707153318625 C172.90230427575 61.366176455624995 172.90243570274998 62.025199583624996 172.90257110775002 62.704193117624996 C172.90194671475 64.871182400625 172.89495622575 67.03810107862499 172.88789062274998 69.205078121625 C172.88621115075 70.712012858625 172.88493044175 72.218948081625 172.88403167475 73.725883484625 C172.88060252175 77.683744985625 172.87176680775 81.641576561625 172.86179809275 85.59942627262501 C172.85257634175 89.64147537562499 172.84847759775 93.683529338625 172.84394531475 97.725585938625 C172.83430553175 105.650404331625 172.81895299875 113.575198433625 172.79999999774998 121.49999999662501 C171.79533622575002 120.643974140625 170.79140007675 119.78709427462499 169.78776855075 118.929858395625 C169.22862309375 118.452775865625 168.66947762775 117.97569332662499 168.09338836575 117.484153745625 C166.09813016175002 115.750901399625 164.19611427975002 113.927543249625 162.28124999775 112.106249996625 C156.33100204875 106.720092833625 149.65590250575002 102.82119961162499 142.19999999775 99.899999996625 C142.19158886775 98.720266109625 142.18317773775 97.540532222625 142.17451171875 96.325048823625 C142.13840198175 91.913370206625 142.07916440475 87.502243316625 142.01323242075 83.090917967625 C141.98795912475 81.188158487625 141.96880911375 79.285306775625 141.95610351675 77.382421871625 C141.93665641575 74.633899037625 141.89458965075 71.88647035162501 141.84843749775 69.138281246625 C141.84677884274998 67.87912650862499 141.84677884274998 67.87912650862499 141.84508667175 66.594534305625 C141.66253589175 58.260876872625 139.23026681175 50.890028045625 133.19999999775 44.99999999662499 C131.15119608675 43.606444190625 129.12192321975 42.531160910625 126.89999999775 41.399999996625 C126.37524229875 41.075908538625 125.85048459075 40.751817080624996 125.30982513375 40.417904660625 C122.45110889175 39.254541089625 119.93044646475 39.356726720625 116.84904784875 39.338525390625 C115.88472008775 39.329457134625 115.88472008775 39.329457134625 114.90091095375 39.320205692625 C112.77984016575 39.303134699625 110.65902578775 39.299592677625 108.53789062275 39.297656246624996 C107.06062668075 39.291870920625 105.58336377375 39.285815387625 104.10610199175 39.279501338624996 C101.01105050174999 39.268729040625 97.91608941675 39.265388330625 94.82102051174999 39.266455073625 C90.85835865375 39.266638061624995 86.89627687275001 39.242053193625 82.93375253475 39.211065104625 C79.88317154775 39.191036549625 76.83273058275 39.187400846625 73.78209056475 39.188352587625 C72.32130627974999 39.186230675625 70.86051822375 39.178280984625 69.39979877475 39.164354321625 C67.35525642675 39.146684504625 65.31197051475 39.151903604625 63.26740722375 39.162744140625 C62.10511647075 39.160179104625 60.94282571775 39.157614077625 59.745314022749994 39.154971317625 C56.19252742875 39.674159789624994 54.719997738749996 40.694113094624996 52.19999999775 43.199999996624996 C51.040411152749996 45.519177686625 51.15596910075 47.233968827625 51.11520996375 49.830908207624994 C51.09725926575 50.839818143625 51.07930855875 51.848728088625 51.06081390075 52.888211060625 C51.038252034749995 54.527933300624994 51.038252034749995 54.527933300624994 51.015234372749994 56.200781246625 C50.99653139175 57.316915004625 50.977828401749996 58.433048762625 50.95855865475 59.583004763625 C50.90960065275 62.551006403624996 50.864399142749996 65.51903447662501 50.82099609375 68.487121580625 C50.77579289175 71.515553783625 50.72572801575 74.543905292625 50.675976564749995 77.572265621625 C50.57870868675 83.514782066625 50.489578221749994 89.457342692625 50.399999997749994 95.399999996625 C40.00499999775 95.399999996625 29.60999999775 95.399999996625 18.899999997749998 95.399999996625 C18.719510361749997 78.241451369625 18.719510361749997 78.241451369625 18.680273439749996 70.885546871625 C18.653449938749993 65.88068777662501 18.621836736749998 60.876201767625 18.560522463749997 55.871630861625 C18.511361286749995 51.833403212625 18.484664406749996 47.795576045625 18.473052408749997 43.757072069624996 C18.464785206749998 42.222092081625 18.448641789749995 40.687132172625 18.424214745749996 39.15232429162499 C18.273955407749998 29.313235400625 18.834160209749996 21.700320467625 25.358203122749998 13.841015621625 C25.99280859375 13.301542967625 26.627414064749996 12.762070313625 27.28124999775 12.206249996625 C27.908894526749997 11.650535159625 28.536539064749995 11.094820313625 29.183203122749998 10.522265621625 C34.99369777574999 6.704444408625 40.33903429575 5.901161045625 47.11201171875 5.950634765625 Z"
  }), jsx("path", {
    className: "logo-second-part",
    fill: "var(--qwick-icon-secondary, #03BBCA)",
    d: "M18.9 95.4 C29.295 95.4 39.69 95.4 50.4 95.4 C50.437124999999995 98.332875 50.47425 101.26575000000001 50.5125 104.28750000000001 C50.824132092 112.87579127400001 51.912701325 118.67796782100001 58.274107361999995 124.819766235 C64.70917678800001 129.809496384 71.419235382 129.394888434 79.175390625 129.22734375000002 C80.556095853 129.217254363 81.93682060200001 129.209576058 83.31755218199999 129.204190062 C86.92671929400001 129.18371143500002 90.534686265 129.130789383 94.143383793 129.07078857 C97.83572357700001 129.01524399000002 101.52826001100001 128.99082066300002 105.22089844199999 128.96367187500002 C112.44781234800001 128.90600478 119.67375629700001 128.814014898 126.9 128.70000000000002 C124.733917512 126.520772886 122.565238623 124.34414733 120.39609375 122.16796875 C119.47975158599999 121.24597082400001 119.47975158599999 121.24597082400001 118.54489745699999 120.305346678 C115.09467669 116.84673631800001 111.59770755599999 113.51849053500001 107.86640625000001 110.36250000000001 C104.44511046600002 107.359843779 101.19442905899999 104.13797208300001 98.1 100.80000000000001 C98.1 100.503 98.1 100.206 98.1 99.9 C118.57957220700001 99.338797557 118.57957220700001 99.338797557 127.80000000000001 102.60000000000001 C128.7466875 102.91672265400001 129.693375 103.233445317 130.66875 103.55976562500001 C151.404640758 110.968934139 167.222161116 125.291503782 176.77749023100003 145.038867192 C180.614960244 153.334127241 183.735170172 161.741816325 183.68789062500002 170.96132812500002 C183.684990231 171.961962894 183.682089846 172.962597654 183.679101558 173.99355469200003 C183.671560548 175.02899414400002 183.664019529 176.06443359600001 183.65625 177.13125000000002 C183.652189452 178.184091798 183.648128904 179.23693359600003 183.643945308 180.32167969200003 C183.63336237000001 182.91450022200002 183.61857083400002 185.50722639600002 183.60000000000002 188.10000000000002 C181.39706903700002 185.920298532 179.223208524 183.73511060100003 177.134765625 181.444921875 C166.945686399 170.514176571 152.670992688 163.01691866700003 137.572114851 162.404696844 C134.412494319 162.34760957400002 131.256059031 162.338968395 128.096064378 162.367573356 C125.505470979 162.390823326 122.91614032499999 162.386014194 120.325479129 162.374867253 C114.82934134500002 162.35636678100002 109.33361064900001 162.373811823 103.8375 162.39375 C97.452916389 162.41285912400002 91.06874799299999 162.416688057 84.684172437 162.393298533 C82.153075788 162.39030905700002 79.62280562699999 162.409242915 77.091806034 162.429661557 C60.767334495 162.45724293900003 47.464764039 158.467164849 35.353125 146.94960937500002 C34.67559375 146.273238279 33.9980625 145.596867192 33.3 144.9 C32.422921875 144.038583981 32.422921875 144.038583981 31.528125 143.159765625 C21.654945801 132.74529370200003 18.400502456999998 119.541918429 18.73125 105.58125000000001 C18.786937499999997 102.22143750000001 18.842624999999998 98.861625 18.9 95.4 Z"
  })]
});

/**
 * ProductLogo Component
 *
 * Creates a branded product logo by combining a QwickIcon with a product name.
 * The icon is automatically positioned close to the text with proper styling.
 */
const ProductLogo = ({
  icon,
  name,
  size = 'small',
  onClick,
  style,
  className,
  ...restProps
}) => {
  // Calculate icon size based on logo size
  const getIconSize = (logoSize = 'small') => {
    const sizeMap = {
      'tiny': 20,
      'small': 32,
      'medium': 40,
      'large': 52,
      'extra-large': 68
    };
    return sizeMap[logoSize] || 32;
  };
  // Use QwickIcon as default if no icon provided
  const iconElement = icon || jsx(QwickIcon, {});
  // Clone the icon element and apply positioning styles
  const styledIcon = /*#__PURE__*/isValidElement(iconElement) ? /*#__PURE__*/cloneElement(iconElement, {
    size: iconElement.props.size || getIconSize(size),
    style: {
      position: 'relative',
      left: '25px',
      zIndex: 999,
      ...iconElement.props.style
    }
  }) : iconElement;
  return jsx(Logo, {
    name: name,
    size: size,
    image: styledIcon,
    imagePosition: "start",
    style: {
      cursor: onClick ? 'pointer' : 'default',
      zIndex: 1000,
      ...style
    },
    className: className,
    onClick: onClick,
    ...restProps
  });
};

const QwickAppsLogo = props => {
  const {
    styleProps,
    htmlProps,
    restProps
  } = useBaseProps(props);
  const {
    size = 'medium',
    ...svgProps
  } = restProps;
  // Get size dimensions
  const getSizeConfig = size => {
    switch (size) {
      case 'small':
        return {
          width: 32,
          height: 32
        };
      case 'large':
        return {
          width: 80,
          height: 80
        };
      default:
        return {
          width: 48,
          height: 48
        };
      // medium
    }
  };
  const {
    width,
    height
  } = getSizeConfig(size);
  return jsx("svg", {
    width: width,
    height: height,
    viewBox: "0 0 225 225",
    ...htmlProps,
    ...styleProps,
    className: `qwickapps-logo qwickapps-logo-${size} ${styleProps.className || ''}`.trim(),
    style: {
      cursor: htmlProps.onClick ? 'pointer' : 'default',
      ...styleProps.style
    },
    role: "img",
    "aria-label": "QwickApps Logo",
    ...svgProps,
    children: jsxs("g", {
      transform: "translate(-128,-60)",
      children: [jsx("path", {
        d: "M0 0 C1.3480925 -0.00788544 1.3480925 -0.00788544 2.72341919 -0.01593018 C5.67419172 -0.02905871 8.62441792 -0.02041442 11.57519531 -0.01025391 C13.64251813 -0.0122774 15.70984025 -0.01519113 17.77716064 -0.01895142 C22.10443943 -0.02336572 26.43153199 -0.01697508 30.75878906 -0.00292969 C36.2773468 0.01411856 41.79546534 0.00434284 47.31400681 -0.01364708 C51.5831018 -0.02454577 55.85209467 -0.02101006 60.12119293 -0.0132637 C62.15435082 -0.01127624 64.18751828 -0.01366927 66.22066498 -0.02070236 C76.73689794 -0.04908929 86.57929633 -0.04924466 96.65332031 3.38818359 C97.54098083 3.67795074 98.42864136 3.9677179 99.34320068 4.26626587 C114.15399949 9.31896076 126.4675764 21.76744512 133.65332031 35.38818359 C137.44514211 43.9738112 139.81630642 51.43992278 139.7668457 60.84057617 C139.76699173 61.5728241 139.76713776 62.30507202 139.76728821 63.05950928 C139.76659444 65.46727515 139.75882723 67.87496257 139.75097656 70.28271484 C139.74911048 71.95708677 139.74768747 73.63145924 139.74668884 75.30583191 C139.74287867 79.7034558 139.73306121 84.10104644 139.72198486 88.49865723 C139.71173847 92.9898229 139.70718431 97.48099397 139.70214844 101.97216797 C139.69143757 110.77752174 139.6743792 119.58284852 139.65332031 128.38818359 C138.53702723 127.43704375 137.42154262 126.48495501 136.30639648 125.5324707 C135.68512375 125.002379 135.06385101 124.47228729 134.42375183 123.9261322 C132.20679827 122.00029626 130.09344729 119.97434276 127.96582031 117.95068359 C121.3544337 111.96606452 113.93765643 107.63396094 105.65332031 104.38818359 C105.64397461 103.07736816 105.63462891 101.76655273 105.625 100.41601562 C105.58487807 95.51415049 105.51905854 90.61289839 105.44580078 85.71142578 C105.41771934 83.59724858 105.39644155 81.4829689 105.38232422 79.36865234 C105.36071633 76.31473808 105.31397548 73.26203954 105.26269531 70.20849609 C105.26085236 68.80943527 105.26085236 68.80943527 105.25897217 67.3821106 C105.05613797 58.12249123 102.35361677 49.9326592 95.65332031 43.38818359 C93.37687152 41.83978825 91.12212389 40.64502905 88.65332031 39.38818359 C88.0702562 39.02808197 87.48719208 38.66798035 86.88645935 38.29696655 C83.71010797 37.00434036 80.90937194 37.11787995 77.4855957 37.09765625 C76.41412041 37.08758041 76.41412041 37.08758041 75.32099915 37.07730103 C72.96425383 37.05833326 70.60779341 37.05439768 68.25097656 37.05224609 C66.60957218 37.04581795 64.96816895 37.03908958 63.32676697 37.03207397 C59.88782087 37.02010475 56.44897522 37.01639285 53.01000977 37.01757812 C48.60705215 37.01778144 44.20473906 36.99046492 39.80193424 36.95603371 C36.41239981 36.93377976 33.02302096 36.92974009 29.63342094 36.93079758 C28.01032729 36.9284399 26.38722945 36.91960691 24.76420784 36.90413284 C22.49249412 36.88449971 20.22217644 36.89029871 17.95043945 36.90234375 C16.65900528 36.89949371 15.36757111 36.89664368 14.03700256 36.89370728 C10.0894619 37.47058336 8.4533178 38.60386481 5.65332031 41.38818359 C4.36488826 43.96504769 4.49328598 45.87037118 4.44799805 48.75585938 C4.42805283 49.87687042 4.4081076 50.99788147 4.38755798 52.15286255 C4.36248924 53.97477615 4.36248924 53.97477615 4.33691406 55.83349609 C4.31613297 57.07364471 4.29535187 58.31379333 4.27394104 59.59152222 C4.21954326 62.88930182 4.16931936 66.18711079 4.12109375 69.48498535 C4.07086797 72.84991002 4.01524033 76.21474503 3.95996094 79.57958984 C3.85188552 86.18238589 3.75285167 92.78523103 3.65332031 99.38818359 C-7.89667969 99.38818359 -19.44667969 99.38818359 -31.34667969 99.38818359 C-31.54722373 80.32312956 -31.54722373 80.32312956 -31.59082031 72.14990234 C-31.6206242 66.58894779 -31.65574998 61.02840778 -31.72387695 55.46777344 C-31.77850048 50.98085383 -31.80816368 46.4943792 -31.8210659 42.00715256 C-31.83025168 40.30161924 -31.84818881 38.59610823 -31.87532997 36.89076614 C-32.04228479 25.95844515 -31.41983501 17.49965078 -24.17089844 8.76708984 C-23.46578125 8.16767578 -22.76066406 7.56826172 -22.03417969 6.95068359 C-21.33679688 6.33322266 -20.63941406 5.71576172 -19.92089844 5.07958984 C-13.46479327 0.83756627 -7.52553047 -0.0549708 0 0 Z ",
        fill: "#FE6D0F",
        transform: "translate(185.3466796875,71.61181640625)"
      }), jsx("path", {
        d: "M0 0 C11.55 0 23.1 0 35 0 C35.04125 3.25875 35.0825 6.5175 35.125 9.875 C35.47125788 19.41754586 36.68077925 25.86440869 43.74900818 32.68862915 C50.89908532 38.23277376 58.35470598 37.77209826 66.97265625 37.5859375 C68.50677317 37.57472707 70.04091178 37.56619562 71.57505798 37.56021118 C75.58524366 37.53745715 79.59409585 37.47865487 83.60375977 37.4119873 C87.70635953 37.3502711 91.80917779 37.32313407 95.91210938 37.29296875 C103.94201372 37.2288942 111.97084033 37.12668322 120 37 C117.59324168 34.57863654 115.18359847 32.1601637 112.7734375 29.7421875 C111.75527954 28.71774536 111.75527954 28.71774536 110.71655273 27.67260742 C106.8829741 23.82970702 102.99745284 20.13165615 98.8515625 16.625 C95.05012274 13.28871531 91.43825451 9.70885787 88 6 C88 5.67 88 5.34 88 5 C110.75508023 4.37644173 110.75508023 4.37644173 121 8 C122.051875 8.35191406 123.10375 8.70382813 124.1875 9.06640625 C147.22737862 17.29881571 164.80240124 33.21278198 175.41943359 55.15429688 C179.68328916 64.37125249 183.15018908 73.71312925 183.09765625 83.95703125 C183.09443359 85.06884766 183.09121094 86.18066406 183.08789062 87.32617188 C183.07951172 88.47666016 183.07113281 89.62714844 183.0625 90.8125 C183.05798828 91.98232422 183.05347656 93.15214844 183.04882812 94.35742188 C183.0370693 97.23833358 183.02063426 100.11914044 183 103 C180.55229893 100.57810948 178.13689836 98.15012289 175.81640625 95.60546875 C164.49520711 83.46019619 148.63443632 75.12990963 131.85790539 74.44966316 C128.34721591 74.38623286 124.84006559 74.37663155 121.32896042 74.40841484 C118.45052331 74.43424814 115.57348925 74.42890466 112.69497681 74.41651917 C106.58815705 74.39596309 100.48178961 74.41534647 94.375 74.4375 C87.28101821 74.45873236 80.18749777 74.46298673 73.09352493 74.43699837 C70.28119532 74.43367673 67.46978403 74.45471435 64.65756226 74.47740173 C46.51926055 74.50804771 31.73862671 70.07462761 18.28125 57.27734375 C17.5284375 56.52582031 16.775625 55.77429688 16 55 C15.02546875 54.04287109 15.02546875 54.04287109 14.03125 53.06640625 C3.06105089 41.49477078 -0.55499727 26.82435381 -0.1875 11.3125 C-0.125625 7.579375 -0.06375 3.84625 0 0 Z ",
        fill: "#03BBCA",
        transform: "translate(154,171)"
      })]
    })
  });
};

/**
 * marked v4.3.0 - a markdown parser
 * Copyright (c) 2011-2023, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */

/**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */

function getDefaults() {
  return {
    async: false,
    baseUrl: null,
    breaks: false,
    extensions: null,
    gfm: true,
    headerIds: true,
    headerPrefix: '',
    highlight: null,
    hooks: null,
    langPrefix: 'language-',
    mangle: true,
    pedantic: false,
    renderer: null,
    sanitize: false,
    sanitizer: null,
    silent: false,
    smartypants: false,
    tokenizer: null,
    walkTokens: null,
    xhtml: false
  };
}

let defaults = getDefaults();

function changeDefaults(newDefaults) {
  defaults = newDefaults;
}

/**
 * Helpers
 */
const escapeTest = /[&<>"']/;
const escapeReplace = new RegExp(escapeTest.source, 'g');
const escapeTestNoEncode = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/;
const escapeReplaceNoEncode = new RegExp(escapeTestNoEncode.source, 'g');
const escapeReplacements = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
};
const getEscapeReplacement = (ch) => escapeReplacements[ch];
function escape(html, encode) {
  if (encode) {
    if (escapeTest.test(html)) {
      return html.replace(escapeReplace, getEscapeReplacement);
    }
  } else {
    if (escapeTestNoEncode.test(html)) {
      return html.replace(escapeReplaceNoEncode, getEscapeReplacement);
    }
  }

  return html;
}

const unescapeTest = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;

/**
 * @param {string} html
 */
function unescape$1(html) {
  // explicitly match decimal, hex, and named HTML entities
  return html.replace(unescapeTest, (_, n) => {
    n = n.toLowerCase();
    if (n === 'colon') return ':';
    if (n.charAt(0) === '#') {
      return n.charAt(1) === 'x'
        ? String.fromCharCode(parseInt(n.substring(2), 16))
        : String.fromCharCode(+n.substring(1));
    }
    return '';
  });
}

const caret = /(^|[^\[])\^/g;

/**
 * @param {string | RegExp} regex
 * @param {string} opt
 */
function edit(regex, opt) {
  regex = typeof regex === 'string' ? regex : regex.source;
  opt = opt || '';
  const obj = {
    replace: (name, val) => {
      val = val.source || val;
      val = val.replace(caret, '$1');
      regex = regex.replace(name, val);
      return obj;
    },
    getRegex: () => {
      return new RegExp(regex, opt);
    }
  };
  return obj;
}

const nonWordAndColonTest = /[^\w:]/g;
const originIndependentUrl = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;

/**
 * @param {boolean} sanitize
 * @param {string} base
 * @param {string} href
 */
function cleanUrl(sanitize, base, href) {
  if (sanitize) {
    let prot;
    try {
      prot = decodeURIComponent(unescape$1(href))
        .replace(nonWordAndColonTest, '')
        .toLowerCase();
    } catch (e) {
      return null;
    }
    if (prot.indexOf('javascript:') === 0 || prot.indexOf('vbscript:') === 0 || prot.indexOf('data:') === 0) {
      return null;
    }
  }
  if (base && !originIndependentUrl.test(href)) {
    href = resolveUrl(base, href);
  }
  try {
    href = encodeURI(href).replace(/%25/g, '%');
  } catch (e) {
    return null;
  }
  return href;
}

const baseUrls = {};
const justDomain = /^[^:]+:\/*[^/]*$/;
const protocol = /^([^:]+:)[\s\S]*$/;
const domain = /^([^:]+:\/*[^/]*)[\s\S]*$/;

/**
 * @param {string} base
 * @param {string} href
 */
function resolveUrl(base, href) {
  if (!baseUrls[' ' + base]) {
    // we can ignore everything in base after the last slash of its path component,
    // but we might need to add _that_
    // https://tools.ietf.org/html/rfc3986#section-3
    if (justDomain.test(base)) {
      baseUrls[' ' + base] = base + '/';
    } else {
      baseUrls[' ' + base] = rtrim(base, '/', true);
    }
  }
  base = baseUrls[' ' + base];
  const relativeBase = base.indexOf(':') === -1;

  if (href.substring(0, 2) === '//') {
    if (relativeBase) {
      return href;
    }
    return base.replace(protocol, '$1') + href;
  } else if (href.charAt(0) === '/') {
    if (relativeBase) {
      return href;
    }
    return base.replace(domain, '$1') + href;
  } else {
    return base + href;
  }
}

const noopTest = { exec: function noopTest() {} };

function splitCells(tableRow, count) {
  // ensure that every cell-delimiting pipe has a space
  // before it to distinguish it from an escaped pipe
  const row = tableRow.replace(/\|/g, (match, offset, str) => {
      let escaped = false,
        curr = offset;
      while (--curr >= 0 && str[curr] === '\\') escaped = !escaped;
      if (escaped) {
        // odd number of slashes means | is escaped
        // so we leave it alone
        return '|';
      } else {
        // add space before unescaped |
        return ' |';
      }
    }),
    cells = row.split(/ \|/);
  let i = 0;

  // First/last cell in a row cannot be empty if it has no leading/trailing pipe
  if (!cells[0].trim()) { cells.shift(); }
  if (cells.length > 0 && !cells[cells.length - 1].trim()) { cells.pop(); }

  if (cells.length > count) {
    cells.splice(count);
  } else {
    while (cells.length < count) cells.push('');
  }

  for (; i < cells.length; i++) {
    // leading or trailing whitespace is ignored per the gfm spec
    cells[i] = cells[i].trim().replace(/\\\|/g, '|');
  }
  return cells;
}

/**
 * Remove trailing 'c's. Equivalent to str.replace(/c*$/, '').
 * /c*$/ is vulnerable to REDOS.
 *
 * @param {string} str
 * @param {string} c
 * @param {boolean} invert Remove suffix of non-c chars instead. Default falsey.
 */
function rtrim(str, c, invert) {
  const l = str.length;
  if (l === 0) {
    return '';
  }

  // Length of suffix matching the invert condition.
  let suffLen = 0;

  // Step left until we fail to match the invert condition.
  while (suffLen < l) {
    const currChar = str.charAt(l - suffLen - 1);
    if (currChar === c && !invert) {
      suffLen++;
    } else if (currChar !== c && invert) {
      suffLen++;
    } else {
      break;
    }
  }

  return str.slice(0, l - suffLen);
}

function findClosingBracket(str, b) {
  if (str.indexOf(b[1]) === -1) {
    return -1;
  }
  const l = str.length;
  let level = 0,
    i = 0;
  for (; i < l; i++) {
    if (str[i] === '\\') {
      i++;
    } else if (str[i] === b[0]) {
      level++;
    } else if (str[i] === b[1]) {
      level--;
      if (level < 0) {
        return i;
      }
    }
  }
  return -1;
}

function checkSanitizeDeprecation(opt) {
  if (opt && opt.sanitize && !opt.silent) {
    console.warn('marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options');
  }
}

// copied from https://stackoverflow.com/a/5450113/806777
/**
 * @param {string} pattern
 * @param {number} count
 */
function repeatString(pattern, count) {
  if (count < 1) {
    return '';
  }
  let result = '';
  while (count > 1) {
    if (count & 1) {
      result += pattern;
    }
    count >>= 1;
    pattern += pattern;
  }
  return result + pattern;
}

function outputLink(cap, link, raw, lexer) {
  const href = link.href;
  const title = link.title ? escape(link.title) : null;
  const text = cap[1].replace(/\\([\[\]])/g, '$1');

  if (cap[0].charAt(0) !== '!') {
    lexer.state.inLink = true;
    const token = {
      type: 'link',
      raw,
      href,
      title,
      text,
      tokens: lexer.inlineTokens(text)
    };
    lexer.state.inLink = false;
    return token;
  }
  return {
    type: 'image',
    raw,
    href,
    title,
    text: escape(text)
  };
}

function indentCodeCompensation(raw, text) {
  const matchIndentToCode = raw.match(/^(\s+)(?:```)/);

  if (matchIndentToCode === null) {
    return text;
  }

  const indentToCode = matchIndentToCode[1];

  return text
    .split('\n')
    .map(node => {
      const matchIndentInNode = node.match(/^\s+/);
      if (matchIndentInNode === null) {
        return node;
      }

      const [indentInNode] = matchIndentInNode;

      if (indentInNode.length >= indentToCode.length) {
        return node.slice(indentToCode.length);
      }

      return node;
    })
    .join('\n');
}

/**
 * Tokenizer
 */
class Tokenizer {
  constructor(options) {
    this.options = options || defaults;
  }

  space(src) {
    const cap = this.rules.block.newline.exec(src);
    if (cap && cap[0].length > 0) {
      return {
        type: 'space',
        raw: cap[0]
      };
    }
  }

  code(src) {
    const cap = this.rules.block.code.exec(src);
    if (cap) {
      const text = cap[0].replace(/^ {1,4}/gm, '');
      return {
        type: 'code',
        raw: cap[0],
        codeBlockStyle: 'indented',
        text: !this.options.pedantic
          ? rtrim(text, '\n')
          : text
      };
    }
  }

  fences(src) {
    const cap = this.rules.block.fences.exec(src);
    if (cap) {
      const raw = cap[0];
      const text = indentCodeCompensation(raw, cap[3] || '');

      return {
        type: 'code',
        raw,
        lang: cap[2] ? cap[2].trim().replace(this.rules.inline._escapes, '$1') : cap[2],
        text
      };
    }
  }

  heading(src) {
    const cap = this.rules.block.heading.exec(src);
    if (cap) {
      let text = cap[2].trim();

      // remove trailing #s
      if (/#$/.test(text)) {
        const trimmed = rtrim(text, '#');
        if (this.options.pedantic) {
          text = trimmed.trim();
        } else if (!trimmed || / $/.test(trimmed)) {
          // CommonMark requires space before trailing #s
          text = trimmed.trim();
        }
      }

      return {
        type: 'heading',
        raw: cap[0],
        depth: cap[1].length,
        text,
        tokens: this.lexer.inline(text)
      };
    }
  }

  hr(src) {
    const cap = this.rules.block.hr.exec(src);
    if (cap) {
      return {
        type: 'hr',
        raw: cap[0]
      };
    }
  }

  blockquote(src) {
    const cap = this.rules.block.blockquote.exec(src);
    if (cap) {
      const text = cap[0].replace(/^ *>[ \t]?/gm, '');
      const top = this.lexer.state.top;
      this.lexer.state.top = true;
      const tokens = this.lexer.blockTokens(text);
      this.lexer.state.top = top;
      return {
        type: 'blockquote',
        raw: cap[0],
        tokens,
        text
      };
    }
  }

  list(src) {
    let cap = this.rules.block.list.exec(src);
    if (cap) {
      let raw, istask, ischecked, indent, i, blankLine, endsWithBlankLine,
        line, nextLine, rawLine, itemContents, endEarly;

      let bull = cap[1].trim();
      const isordered = bull.length > 1;

      const list = {
        type: 'list',
        raw: '',
        ordered: isordered,
        start: isordered ? +bull.slice(0, -1) : '',
        loose: false,
        items: []
      };

      bull = isordered ? `\\d{1,9}\\${bull.slice(-1)}` : `\\${bull}`;

      if (this.options.pedantic) {
        bull = isordered ? bull : '[*+-]';
      }

      // Get next list item
      const itemRegex = new RegExp(`^( {0,3}${bull})((?:[\t ][^\\n]*)?(?:\\n|$))`);

      // Check if current bullet point can start a new List Item
      while (src) {
        endEarly = false;
        if (!(cap = itemRegex.exec(src))) {
          break;
        }

        if (this.rules.block.hr.test(src)) { // End list if bullet was actually HR (possibly move into itemRegex?)
          break;
        }

        raw = cap[0];
        src = src.substring(raw.length);

        line = cap[2].split('\n', 1)[0].replace(/^\t+/, (t) => ' '.repeat(3 * t.length));
        nextLine = src.split('\n', 1)[0];

        if (this.options.pedantic) {
          indent = 2;
          itemContents = line.trimLeft();
        } else {
          indent = cap[2].search(/[^ ]/); // Find first non-space char
          indent = indent > 4 ? 1 : indent; // Treat indented code blocks (> 4 spaces) as having only 1 indent
          itemContents = line.slice(indent);
          indent += cap[1].length;
        }

        blankLine = false;

        if (!line && /^ *$/.test(nextLine)) { // Items begin with at most one blank line
          raw += nextLine + '\n';
          src = src.substring(nextLine.length + 1);
          endEarly = true;
        }

        if (!endEarly) {
          const nextBulletRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ \t][^\\n]*)?(?:\\n|$))`);
          const hrRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`);
          const fencesBeginRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:\`\`\`|~~~)`);
          const headingBeginRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}#`);

          // Check if following lines should be included in List Item
          while (src) {
            rawLine = src.split('\n', 1)[0];
            nextLine = rawLine;

            // Re-align to follow commonmark nesting rules
            if (this.options.pedantic) {
              nextLine = nextLine.replace(/^ {1,4}(?=( {4})*[^ ])/g, '  ');
            }

            // End list item if found code fences
            if (fencesBeginRegex.test(nextLine)) {
              break;
            }

            // End list item if found start of new heading
            if (headingBeginRegex.test(nextLine)) {
              break;
            }

            // End list item if found start of new bullet
            if (nextBulletRegex.test(nextLine)) {
              break;
            }

            // Horizontal rule found
            if (hrRegex.test(src)) {
              break;
            }

            if (nextLine.search(/[^ ]/) >= indent || !nextLine.trim()) { // Dedent if possible
              itemContents += '\n' + nextLine.slice(indent);
            } else {
              // not enough indentation
              if (blankLine) {
                break;
              }

              // paragraph continuation unless last line was a different block level element
              if (line.search(/[^ ]/) >= 4) { // indented code block
                break;
              }
              if (fencesBeginRegex.test(line)) {
                break;
              }
              if (headingBeginRegex.test(line)) {
                break;
              }
              if (hrRegex.test(line)) {
                break;
              }

              itemContents += '\n' + nextLine;
            }

            if (!blankLine && !nextLine.trim()) { // Check if current line is blank
              blankLine = true;
            }

            raw += rawLine + '\n';
            src = src.substring(rawLine.length + 1);
            line = nextLine.slice(indent);
          }
        }

        if (!list.loose) {
          // If the previous item ended with a blank line, the list is loose
          if (endsWithBlankLine) {
            list.loose = true;
          } else if (/\n *\n *$/.test(raw)) {
            endsWithBlankLine = true;
          }
        }

        // Check for task list items
        if (this.options.gfm) {
          istask = /^\[[ xX]\] /.exec(itemContents);
          if (istask) {
            ischecked = istask[0] !== '[ ] ';
            itemContents = itemContents.replace(/^\[[ xX]\] +/, '');
          }
        }

        list.items.push({
          type: 'list_item',
          raw,
          task: !!istask,
          checked: ischecked,
          loose: false,
          text: itemContents
        });

        list.raw += raw;
      }

      // Do not consume newlines at end of final item. Alternatively, make itemRegex *start* with any newlines to simplify/speed up endsWithBlankLine logic
      list.items[list.items.length - 1].raw = raw.trimRight();
      list.items[list.items.length - 1].text = itemContents.trimRight();
      list.raw = list.raw.trimRight();

      const l = list.items.length;

      // Item child tokens handled here at end because we needed to have the final item to trim it first
      for (i = 0; i < l; i++) {
        this.lexer.state.top = false;
        list.items[i].tokens = this.lexer.blockTokens(list.items[i].text, []);

        if (!list.loose) {
          // Check if list should be loose
          const spacers = list.items[i].tokens.filter(t => t.type === 'space');
          const hasMultipleLineBreaks = spacers.length > 0 && spacers.some(t => /\n.*\n/.test(t.raw));

          list.loose = hasMultipleLineBreaks;
        }
      }

      // Set all items to loose if list is loose
      if (list.loose) {
        for (i = 0; i < l; i++) {
          list.items[i].loose = true;
        }
      }

      return list;
    }
  }

  html(src) {
    const cap = this.rules.block.html.exec(src);
    if (cap) {
      const token = {
        type: 'html',
        raw: cap[0],
        pre: !this.options.sanitizer
          && (cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style'),
        text: cap[0]
      };
      if (this.options.sanitize) {
        const text = this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]);
        token.type = 'paragraph';
        token.text = text;
        token.tokens = this.lexer.inline(text);
      }
      return token;
    }
  }

  def(src) {
    const cap = this.rules.block.def.exec(src);
    if (cap) {
      const tag = cap[1].toLowerCase().replace(/\s+/g, ' ');
      const href = cap[2] ? cap[2].replace(/^<(.*)>$/, '$1').replace(this.rules.inline._escapes, '$1') : '';
      const title = cap[3] ? cap[3].substring(1, cap[3].length - 1).replace(this.rules.inline._escapes, '$1') : cap[3];
      return {
        type: 'def',
        tag,
        raw: cap[0],
        href,
        title
      };
    }
  }

  table(src) {
    const cap = this.rules.block.table.exec(src);
    if (cap) {
      const item = {
        type: 'table',
        header: splitCells(cap[1]).map(c => { return { text: c }; }),
        align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
        rows: cap[3] && cap[3].trim() ? cap[3].replace(/\n[ \t]*$/, '').split('\n') : []
      };

      if (item.header.length === item.align.length) {
        item.raw = cap[0];

        let l = item.align.length;
        let i, j, k, row;
        for (i = 0; i < l; i++) {
          if (/^ *-+: *$/.test(item.align[i])) {
            item.align[i] = 'right';
          } else if (/^ *:-+: *$/.test(item.align[i])) {
            item.align[i] = 'center';
          } else if (/^ *:-+ *$/.test(item.align[i])) {
            item.align[i] = 'left';
          } else {
            item.align[i] = null;
          }
        }

        l = item.rows.length;
        for (i = 0; i < l; i++) {
          item.rows[i] = splitCells(item.rows[i], item.header.length).map(c => { return { text: c }; });
        }

        // parse child tokens inside headers and cells

        // header child tokens
        l = item.header.length;
        for (j = 0; j < l; j++) {
          item.header[j].tokens = this.lexer.inline(item.header[j].text);
        }

        // cell child tokens
        l = item.rows.length;
        for (j = 0; j < l; j++) {
          row = item.rows[j];
          for (k = 0; k < row.length; k++) {
            row[k].tokens = this.lexer.inline(row[k].text);
          }
        }

        return item;
      }
    }
  }

  lheading(src) {
    const cap = this.rules.block.lheading.exec(src);
    if (cap) {
      return {
        type: 'heading',
        raw: cap[0],
        depth: cap[2].charAt(0) === '=' ? 1 : 2,
        text: cap[1],
        tokens: this.lexer.inline(cap[1])
      };
    }
  }

  paragraph(src) {
    const cap = this.rules.block.paragraph.exec(src);
    if (cap) {
      const text = cap[1].charAt(cap[1].length - 1) === '\n'
        ? cap[1].slice(0, -1)
        : cap[1];
      return {
        type: 'paragraph',
        raw: cap[0],
        text,
        tokens: this.lexer.inline(text)
      };
    }
  }

  text(src) {
    const cap = this.rules.block.text.exec(src);
    if (cap) {
      return {
        type: 'text',
        raw: cap[0],
        text: cap[0],
        tokens: this.lexer.inline(cap[0])
      };
    }
  }

  escape(src) {
    const cap = this.rules.inline.escape.exec(src);
    if (cap) {
      return {
        type: 'escape',
        raw: cap[0],
        text: escape(cap[1])
      };
    }
  }

  tag(src) {
    const cap = this.rules.inline.tag.exec(src);
    if (cap) {
      if (!this.lexer.state.inLink && /^<a /i.test(cap[0])) {
        this.lexer.state.inLink = true;
      } else if (this.lexer.state.inLink && /^<\/a>/i.test(cap[0])) {
        this.lexer.state.inLink = false;
      }
      if (!this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
        this.lexer.state.inRawBlock = true;
      } else if (this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
        this.lexer.state.inRawBlock = false;
      }

      return {
        type: this.options.sanitize
          ? 'text'
          : 'html',
        raw: cap[0],
        inLink: this.lexer.state.inLink,
        inRawBlock: this.lexer.state.inRawBlock,
        text: this.options.sanitize
          ? (this.options.sanitizer
            ? this.options.sanitizer(cap[0])
            : escape(cap[0]))
          : cap[0]
      };
    }
  }

  link(src) {
    const cap = this.rules.inline.link.exec(src);
    if (cap) {
      const trimmedUrl = cap[2].trim();
      if (!this.options.pedantic && /^</.test(trimmedUrl)) {
        // commonmark requires matching angle brackets
        if (!(/>$/.test(trimmedUrl))) {
          return;
        }

        // ending angle bracket cannot be escaped
        const rtrimSlash = rtrim(trimmedUrl.slice(0, -1), '\\');
        if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) {
          return;
        }
      } else {
        // find closing parenthesis
        const lastParenIndex = findClosingBracket(cap[2], '()');
        if (lastParenIndex > -1) {
          const start = cap[0].indexOf('!') === 0 ? 5 : 4;
          const linkLen = start + cap[1].length + lastParenIndex;
          cap[2] = cap[2].substring(0, lastParenIndex);
          cap[0] = cap[0].substring(0, linkLen).trim();
          cap[3] = '';
        }
      }
      let href = cap[2];
      let title = '';
      if (this.options.pedantic) {
        // split pedantic href and title
        const link = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(href);

        if (link) {
          href = link[1];
          title = link[3];
        }
      } else {
        title = cap[3] ? cap[3].slice(1, -1) : '';
      }

      href = href.trim();
      if (/^</.test(href)) {
        if (this.options.pedantic && !(/>$/.test(trimmedUrl))) {
          // pedantic allows starting angle bracket without ending angle bracket
          href = href.slice(1);
        } else {
          href = href.slice(1, -1);
        }
      }
      return outputLink(cap, {
        href: href ? href.replace(this.rules.inline._escapes, '$1') : href,
        title: title ? title.replace(this.rules.inline._escapes, '$1') : title
      }, cap[0], this.lexer);
    }
  }

  reflink(src, links) {
    let cap;
    if ((cap = this.rules.inline.reflink.exec(src))
        || (cap = this.rules.inline.nolink.exec(src))) {
      let link = (cap[2] || cap[1]).replace(/\s+/g, ' ');
      link = links[link.toLowerCase()];
      if (!link) {
        const text = cap[0].charAt(0);
        return {
          type: 'text',
          raw: text,
          text
        };
      }
      return outputLink(cap, link, cap[0], this.lexer);
    }
  }

  emStrong(src, maskedSrc, prevChar = '') {
    let match = this.rules.inline.emStrong.lDelim.exec(src);
    if (!match) return;

    // _ can't be between two alphanumerics. \p{L}\p{N} includes non-english alphabet/numbers as well
    if (match[3] && prevChar.match(/[\p{L}\p{N}]/u)) return;

    const nextChar = match[1] || match[2] || '';

    if (!nextChar || (nextChar && (prevChar === '' || this.rules.inline.punctuation.exec(prevChar)))) {
      const lLength = match[0].length - 1;
      let rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;

      const endReg = match[0][0] === '*' ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
      endReg.lastIndex = 0;

      // Clip maskedSrc to same section of string as src (move to lexer?)
      maskedSrc = maskedSrc.slice(-1 * src.length + lLength);

      while ((match = endReg.exec(maskedSrc)) != null) {
        rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];

        if (!rDelim) continue; // skip single * in __abc*abc__

        rLength = rDelim.length;

        if (match[3] || match[4]) { // found another Left Delim
          delimTotal += rLength;
          continue;
        } else if (match[5] || match[6]) { // either Left or Right Delim
          if (lLength % 3 && !((lLength + rLength) % 3)) {
            midDelimTotal += rLength;
            continue; // CommonMark Emphasis Rules 9-10
          }
        }

        delimTotal -= rLength;

        if (delimTotal > 0) continue; // Haven't found enough closing delimiters

        // Remove extra characters. *a*** -> *a*
        rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);

        const raw = src.slice(0, lLength + match.index + (match[0].length - rDelim.length) + rLength);

        // Create `em` if smallest delimiter has odd char count. *a***
        if (Math.min(lLength, rLength) % 2) {
          const text = raw.slice(1, -1);
          return {
            type: 'em',
            raw,
            text,
            tokens: this.lexer.inlineTokens(text)
          };
        }

        // Create 'strong' if smallest delimiter has even char count. **a***
        const text = raw.slice(2, -2);
        return {
          type: 'strong',
          raw,
          text,
          tokens: this.lexer.inlineTokens(text)
        };
      }
    }
  }

  codespan(src) {
    const cap = this.rules.inline.code.exec(src);
    if (cap) {
      let text = cap[2].replace(/\n/g, ' ');
      const hasNonSpaceChars = /[^ ]/.test(text);
      const hasSpaceCharsOnBothEnds = /^ /.test(text) && / $/.test(text);
      if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) {
        text = text.substring(1, text.length - 1);
      }
      text = escape(text, true);
      return {
        type: 'codespan',
        raw: cap[0],
        text
      };
    }
  }

  br(src) {
    const cap = this.rules.inline.br.exec(src);
    if (cap) {
      return {
        type: 'br',
        raw: cap[0]
      };
    }
  }

  del(src) {
    const cap = this.rules.inline.del.exec(src);
    if (cap) {
      return {
        type: 'del',
        raw: cap[0],
        text: cap[2],
        tokens: this.lexer.inlineTokens(cap[2])
      };
    }
  }

  autolink(src, mangle) {
    const cap = this.rules.inline.autolink.exec(src);
    if (cap) {
      let text, href;
      if (cap[2] === '@') {
        text = escape(this.options.mangle ? mangle(cap[1]) : cap[1]);
        href = 'mailto:' + text;
      } else {
        text = escape(cap[1]);
        href = text;
      }

      return {
        type: 'link',
        raw: cap[0],
        text,
        href,
        tokens: [
          {
            type: 'text',
            raw: text,
            text
          }
        ]
      };
    }
  }

  url(src, mangle) {
    let cap;
    if (cap = this.rules.inline.url.exec(src)) {
      let text, href;
      if (cap[2] === '@') {
        text = escape(this.options.mangle ? mangle(cap[0]) : cap[0]);
        href = 'mailto:' + text;
      } else {
        // do extended autolink path validation
        let prevCapZero;
        do {
          prevCapZero = cap[0];
          cap[0] = this.rules.inline._backpedal.exec(cap[0])[0];
        } while (prevCapZero !== cap[0]);
        text = escape(cap[0]);
        if (cap[1] === 'www.') {
          href = 'http://' + cap[0];
        } else {
          href = cap[0];
        }
      }
      return {
        type: 'link',
        raw: cap[0],
        text,
        href,
        tokens: [
          {
            type: 'text',
            raw: text,
            text
          }
        ]
      };
    }
  }

  inlineText(src, smartypants) {
    const cap = this.rules.inline.text.exec(src);
    if (cap) {
      let text;
      if (this.lexer.state.inRawBlock) {
        text = this.options.sanitize ? (this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0])) : cap[0];
      } else {
        text = escape(this.options.smartypants ? smartypants(cap[0]) : cap[0]);
      }
      return {
        type: 'text',
        raw: cap[0],
        text
      };
    }
  }
}

/**
 * Block-Level Grammar
 */
const block = {
  newline: /^(?: *(?:\n|$))+/,
  code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
  fences: /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/,
  hr: /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/,
  heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
  blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
  list: /^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/,
  html: '^ {0,3}(?:' // optional indentation
    + '<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)' // (1)
    + '|comment[^\\n]*(\\n+|$)' // (2)
    + '|<\\?[\\s\\S]*?(?:\\?>\\n*|$)' // (3)
    + '|<![A-Z][\\s\\S]*?(?:>\\n*|$)' // (4)
    + '|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)' // (5)
    + '|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)' // (6)
    + '|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)' // (7) open tag
    + '|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)' // (7) closing tag
    + ')',
  def: /^ {0,3}\[(label)\]: *(?:\n *)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/,
  table: noopTest,
  lheading: /^((?:.|\n(?!\n))+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
  // regex template, placeholders will be replaced according to different paragraph
  // interruption rules of commonmark and the original markdown spec:
  _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/,
  text: /^[^\n]+/
};

block._label = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
block._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/;
block.def = edit(block.def)
  .replace('label', block._label)
  .replace('title', block._title)
  .getRegex();

block.bullet = /(?:[*+-]|\d{1,9}[.)])/;
block.listItemStart = edit(/^( *)(bull) */)
  .replace('bull', block.bullet)
  .getRegex();

block.list = edit(block.list)
  .replace(/bull/g, block.bullet)
  .replace('hr', '\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))')
  .replace('def', '\\n+(?=' + block.def.source + ')')
  .getRegex();

block._tag = 'address|article|aside|base|basefont|blockquote|body|caption'
  + '|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption'
  + '|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe'
  + '|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option'
  + '|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr'
  + '|track|ul';
block._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/;
block.html = edit(block.html, 'i')
  .replace('comment', block._comment)
  .replace('tag', block._tag)
  .replace('attribute', / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/)
  .getRegex();

block.paragraph = edit(block._paragraph)
  .replace('hr', block.hr)
  .replace('heading', ' {0,3}#{1,6} ')
  .replace('|lheading', '') // setex headings don't interrupt commonmark paragraphs
  .replace('|table', '')
  .replace('blockquote', ' {0,3}>')
  .replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n')
  .replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
  .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)')
  .replace('tag', block._tag) // pars can be interrupted by type (6) html blocks
  .getRegex();

block.blockquote = edit(block.blockquote)
  .replace('paragraph', block.paragraph)
  .getRegex();

/**
 * Normal Block Grammar
 */

block.normal = { ...block };

/**
 * GFM Block Grammar
 */

block.gfm = {
  ...block.normal,
  table: '^ *([^\\n ].*\\|.*)\\n' // Header
    + ' {0,3}(?:\\| *)?(:?-+:? *(?:\\| *:?-+:? *)*)(?:\\| *)?' // Align
    + '(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)' // Cells
};

block.gfm.table = edit(block.gfm.table)
  .replace('hr', block.hr)
  .replace('heading', ' {0,3}#{1,6} ')
  .replace('blockquote', ' {0,3}>')
  .replace('code', ' {4}[^\\n]')
  .replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n')
  .replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
  .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)')
  .replace('tag', block._tag) // tables can be interrupted by type (6) html blocks
  .getRegex();

block.gfm.paragraph = edit(block._paragraph)
  .replace('hr', block.hr)
  .replace('heading', ' {0,3}#{1,6} ')
  .replace('|lheading', '') // setex headings don't interrupt commonmark paragraphs
  .replace('table', block.gfm.table) // interrupt paragraphs with table
  .replace('blockquote', ' {0,3}>')
  .replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n')
  .replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
  .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)')
  .replace('tag', block._tag) // pars can be interrupted by type (6) html blocks
  .getRegex();
/**
 * Pedantic grammar (original John Gruber's loose markdown specification)
 */

block.pedantic = {
  ...block.normal,
  html: edit(
    '^ *(?:comment *(?:\\n|\\s*$)'
    + '|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)' // closed tag
    + '|<tag(?:"[^"]*"|\'[^\']*\'|\\s[^\'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))')
    .replace('comment', block._comment)
    .replace(/tag/g, '(?!(?:'
      + 'a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub'
      + '|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)'
      + '\\b)\\w+(?!:|[^\\w\\s@]*@)\\b')
    .getRegex(),
  def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
  heading: /^(#{1,6})(.*)(?:\n+|$)/,
  fences: noopTest, // fences not supported
  lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
  paragraph: edit(block.normal._paragraph)
    .replace('hr', block.hr)
    .replace('heading', ' *#{1,6} *[^\n]')
    .replace('lheading', block.lheading)
    .replace('blockquote', ' {0,3}>')
    .replace('|fences', '')
    .replace('|list', '')
    .replace('|html', '')
    .getRegex()
};

/**
 * Inline-Level Grammar
 */
const inline = {
  escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
  autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
  url: noopTest,
  tag: '^comment'
    + '|^</[a-zA-Z][\\w:-]*\\s*>' // self-closing tag
    + '|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>' // open tag
    + '|^<\\?[\\s\\S]*?\\?>' // processing instruction, e.g. <?php ?>
    + '|^<![a-zA-Z]+\\s[\\s\\S]*?>' // declaration, e.g. <!DOCTYPE html>
    + '|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>', // CDATA section
  link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
  reflink: /^!?\[(label)\]\[(ref)\]/,
  nolink: /^!?\[(ref)\](?:\[\])?/,
  reflinkSearch: 'reflink|nolink(?!\\()',
  emStrong: {
    lDelim: /^(?:\*+(?:([punct_])|[^\s*]))|^_+(?:([punct*])|([^\s_]))/,
    //        (1) and (2) can only be a Right Delimiter. (3) and (4) can only be Left.  (5) and (6) can be either Left or Right.
    //          () Skip orphan inside strong                                      () Consume to delim     (1) #***                (2) a***#, a***                             (3) #***a, ***a                 (4) ***#              (5) #***#                 (6) a***a
    rDelimAst: /^(?:[^_*\\]|\\.)*?\_\_(?:[^_*\\]|\\.)*?\*(?:[^_*\\]|\\.)*?(?=\_\_)|(?:[^*\\]|\\.)+(?=[^*])|[punct_](\*+)(?=[\s]|$)|(?:[^punct*_\s\\]|\\.)(\*+)(?=[punct_\s]|$)|[punct_\s](\*+)(?=[^punct*_\s])|[\s](\*+)(?=[punct_])|[punct_](\*+)(?=[punct_])|(?:[^punct*_\s\\]|\\.)(\*+)(?=[^punct*_\s])/,
    rDelimUnd: /^(?:[^_*\\]|\\.)*?\*\*(?:[^_*\\]|\\.)*?\_(?:[^_*\\]|\\.)*?(?=\*\*)|(?:[^_\\]|\\.)+(?=[^_])|[punct*](\_+)(?=[\s]|$)|(?:[^punct*_\s\\]|\\.)(\_+)(?=[punct*\s]|$)|[punct*\s](\_+)(?=[^punct*_\s])|[\s](\_+)(?=[punct*])|[punct*](\_+)(?=[punct*])/ // ^- Not allowed for _
  },
  code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
  br: /^( {2,}|\\)\n(?!\s*$)/,
  del: noopTest,
  text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
  punctuation: /^([\spunctuation])/
};

// list of punctuation marks from CommonMark spec
// without * and _ to handle the different emphasis markers * and _
inline._punctuation = '!"#$%&\'()+\\-.,/:;<=>?@\\[\\]`^{|}~';
inline.punctuation = edit(inline.punctuation).replace(/punctuation/g, inline._punctuation).getRegex();

// sequences em should skip over [title](link), `code`, <html>
inline.blockSkip = /\[[^\]]*?\]\([^\)]*?\)|`[^`]*?`|<[^>]*?>/g;
// lookbehind is not available on Safari as of version 16
// inline.escapedEmSt = /(?<=(?:^|[^\\)(?:\\[^])*)\\[*_]/g;
inline.escapedEmSt = /(?:^|[^\\])(?:\\\\)*\\[*_]/g;

inline._comment = edit(block._comment).replace('(?:-->|$)', '-->').getRegex();

inline.emStrong.lDelim = edit(inline.emStrong.lDelim)
  .replace(/punct/g, inline._punctuation)
  .getRegex();

inline.emStrong.rDelimAst = edit(inline.emStrong.rDelimAst, 'g')
  .replace(/punct/g, inline._punctuation)
  .getRegex();

inline.emStrong.rDelimUnd = edit(inline.emStrong.rDelimUnd, 'g')
  .replace(/punct/g, inline._punctuation)
  .getRegex();

inline._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g;

inline._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
inline._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
inline.autolink = edit(inline.autolink)
  .replace('scheme', inline._scheme)
  .replace('email', inline._email)
  .getRegex();

inline._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/;

inline.tag = edit(inline.tag)
  .replace('comment', inline._comment)
  .replace('attribute', inline._attribute)
  .getRegex();

inline._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
inline._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/;
inline._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/;

inline.link = edit(inline.link)
  .replace('label', inline._label)
  .replace('href', inline._href)
  .replace('title', inline._title)
  .getRegex();

inline.reflink = edit(inline.reflink)
  .replace('label', inline._label)
  .replace('ref', block._label)
  .getRegex();

inline.nolink = edit(inline.nolink)
  .replace('ref', block._label)
  .getRegex();

inline.reflinkSearch = edit(inline.reflinkSearch, 'g')
  .replace('reflink', inline.reflink)
  .replace('nolink', inline.nolink)
  .getRegex();

/**
 * Normal Inline Grammar
 */

inline.normal = { ...inline };

/**
 * Pedantic Inline Grammar
 */

inline.pedantic = {
  ...inline.normal,
  strong: {
    start: /^__|\*\*/,
    middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
    endAst: /\*\*(?!\*)/g,
    endUnd: /__(?!_)/g
  },
  em: {
    start: /^_|\*/,
    middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
    endAst: /\*(?!\*)/g,
    endUnd: /_(?!_)/g
  },
  link: edit(/^!?\[(label)\]\((.*?)\)/)
    .replace('label', inline._label)
    .getRegex(),
  reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/)
    .replace('label', inline._label)
    .getRegex()
};

/**
 * GFM Inline Grammar
 */

inline.gfm = {
  ...inline.normal,
  escape: edit(inline.escape).replace('])', '~|])').getRegex(),
  _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
  url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
  _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
  del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
  text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
};

inline.gfm.url = edit(inline.gfm.url, 'i')
  .replace('email', inline.gfm._extended_email)
  .getRegex();
/**
 * GFM + Line Breaks Inline Grammar
 */

inline.breaks = {
  ...inline.gfm,
  br: edit(inline.br).replace('{2,}', '*').getRegex(),
  text: edit(inline.gfm.text)
    .replace('\\b_', '\\b_| {2,}\\n')
    .replace(/\{2,\}/g, '*')
    .getRegex()
};

/**
 * smartypants text replacement
 * @param {string} text
 */
function smartypants(text) {
  return text
    // em-dashes
    .replace(/---/g, '\u2014')
    // en-dashes
    .replace(/--/g, '\u2013')
    // opening singles
    .replace(/(^|[-\u2014/(\[{"\s])'/g, '$1\u2018')
    // closing singles & apostrophes
    .replace(/'/g, '\u2019')
    // opening doubles
    .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, '$1\u201c')
    // closing doubles
    .replace(/"/g, '\u201d')
    // ellipses
    .replace(/\.{3}/g, '\u2026');
}

/**
 * mangle email addresses
 * @param {string} text
 */
function mangle(text) {
  let out = '',
    i,
    ch;

  const l = text.length;
  for (i = 0; i < l; i++) {
    ch = text.charCodeAt(i);
    if (Math.random() > 0.5) {
      ch = 'x' + ch.toString(16);
    }
    out += '&#' + ch + ';';
  }

  return out;
}

/**
 * Block Lexer
 */
class Lexer {
  constructor(options) {
    this.tokens = [];
    this.tokens.links = Object.create(null);
    this.options = options || defaults;
    this.options.tokenizer = this.options.tokenizer || new Tokenizer();
    this.tokenizer = this.options.tokenizer;
    this.tokenizer.options = this.options;
    this.tokenizer.lexer = this;
    this.inlineQueue = [];
    this.state = {
      inLink: false,
      inRawBlock: false,
      top: true
    };

    const rules = {
      block: block.normal,
      inline: inline.normal
    };

    if (this.options.pedantic) {
      rules.block = block.pedantic;
      rules.inline = inline.pedantic;
    } else if (this.options.gfm) {
      rules.block = block.gfm;
      if (this.options.breaks) {
        rules.inline = inline.breaks;
      } else {
        rules.inline = inline.gfm;
      }
    }
    this.tokenizer.rules = rules;
  }

  /**
   * Expose Rules
   */
  static get rules() {
    return {
      block,
      inline
    };
  }

  /**
   * Static Lex Method
   */
  static lex(src, options) {
    const lexer = new Lexer(options);
    return lexer.lex(src);
  }

  /**
   * Static Lex Inline Method
   */
  static lexInline(src, options) {
    const lexer = new Lexer(options);
    return lexer.inlineTokens(src);
  }

  /**
   * Preprocessing
   */
  lex(src) {
    src = src
      .replace(/\r\n|\r/g, '\n');

    this.blockTokens(src, this.tokens);

    let next;
    while (next = this.inlineQueue.shift()) {
      this.inlineTokens(next.src, next.tokens);
    }

    return this.tokens;
  }

  /**
   * Lexing
   */
  blockTokens(src, tokens = []) {
    if (this.options.pedantic) {
      src = src.replace(/\t/g, '    ').replace(/^ +$/gm, '');
    } else {
      src = src.replace(/^( *)(\t+)/gm, (_, leading, tabs) => {
        return leading + '    '.repeat(tabs.length);
      });
    }

    let token, lastToken, cutSrc, lastParagraphClipped;

    while (src) {
      if (this.options.extensions
        && this.options.extensions.block
        && this.options.extensions.block.some((extTokenizer) => {
          if (token = extTokenizer.call({ lexer: this }, src, tokens)) {
            src = src.substring(token.raw.length);
            tokens.push(token);
            return true;
          }
          return false;
        })) {
        continue;
      }

      // newline
      if (token = this.tokenizer.space(src)) {
        src = src.substring(token.raw.length);
        if (token.raw.length === 1 && tokens.length > 0) {
          // if there's a single \n as a spacer, it's terminating the last line,
          // so move it there so that we don't get unecessary paragraph tags
          tokens[tokens.length - 1].raw += '\n';
        } else {
          tokens.push(token);
        }
        continue;
      }

      // code
      if (token = this.tokenizer.code(src)) {
        src = src.substring(token.raw.length);
        lastToken = tokens[tokens.length - 1];
        // An indented code block cannot interrupt a paragraph.
        if (lastToken && (lastToken.type === 'paragraph' || lastToken.type === 'text')) {
          lastToken.raw += '\n' + token.raw;
          lastToken.text += '\n' + token.text;
          this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
        } else {
          tokens.push(token);
        }
        continue;
      }

      // fences
      if (token = this.tokenizer.fences(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // heading
      if (token = this.tokenizer.heading(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // hr
      if (token = this.tokenizer.hr(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // blockquote
      if (token = this.tokenizer.blockquote(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // list
      if (token = this.tokenizer.list(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // html
      if (token = this.tokenizer.html(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // def
      if (token = this.tokenizer.def(src)) {
        src = src.substring(token.raw.length);
        lastToken = tokens[tokens.length - 1];
        if (lastToken && (lastToken.type === 'paragraph' || lastToken.type === 'text')) {
          lastToken.raw += '\n' + token.raw;
          lastToken.text += '\n' + token.raw;
          this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
        } else if (!this.tokens.links[token.tag]) {
          this.tokens.links[token.tag] = {
            href: token.href,
            title: token.title
          };
        }
        continue;
      }

      // table (gfm)
      if (token = this.tokenizer.table(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // lheading
      if (token = this.tokenizer.lheading(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // top-level paragraph
      // prevent paragraph consuming extensions by clipping 'src' to extension start
      cutSrc = src;
      if (this.options.extensions && this.options.extensions.startBlock) {
        let startIndex = Infinity;
        const tempSrc = src.slice(1);
        let tempStart;
        this.options.extensions.startBlock.forEach(function(getStartIndex) {
          tempStart = getStartIndex.call({ lexer: this }, tempSrc);
          if (typeof tempStart === 'number' && tempStart >= 0) { startIndex = Math.min(startIndex, tempStart); }
        });
        if (startIndex < Infinity && startIndex >= 0) {
          cutSrc = src.substring(0, startIndex + 1);
        }
      }
      if (this.state.top && (token = this.tokenizer.paragraph(cutSrc))) {
        lastToken = tokens[tokens.length - 1];
        if (lastParagraphClipped && lastToken.type === 'paragraph') {
          lastToken.raw += '\n' + token.raw;
          lastToken.text += '\n' + token.text;
          this.inlineQueue.pop();
          this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
        } else {
          tokens.push(token);
        }
        lastParagraphClipped = (cutSrc.length !== src.length);
        src = src.substring(token.raw.length);
        continue;
      }

      // text
      if (token = this.tokenizer.text(src)) {
        src = src.substring(token.raw.length);
        lastToken = tokens[tokens.length - 1];
        if (lastToken && lastToken.type === 'text') {
          lastToken.raw += '\n' + token.raw;
          lastToken.text += '\n' + token.text;
          this.inlineQueue.pop();
          this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
        } else {
          tokens.push(token);
        }
        continue;
      }

      if (src) {
        const errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
        if (this.options.silent) {
          console.error(errMsg);
          break;
        } else {
          throw new Error(errMsg);
        }
      }
    }

    this.state.top = true;
    return tokens;
  }

  inline(src, tokens = []) {
    this.inlineQueue.push({ src, tokens });
    return tokens;
  }

  /**
   * Lexing/Compiling
   */
  inlineTokens(src, tokens = []) {
    let token, lastToken, cutSrc;

    // String with links masked to avoid interference with em and strong
    let maskedSrc = src;
    let match;
    let keepPrevChar, prevChar;

    // Mask out reflinks
    if (this.tokens.links) {
      const links = Object.keys(this.tokens.links);
      if (links.length > 0) {
        while ((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null) {
          if (links.includes(match[0].slice(match[0].lastIndexOf('[') + 1, -1))) {
            maskedSrc = maskedSrc.slice(0, match.index) + '[' + repeatString('a', match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
          }
        }
      }
    }
    // Mask out other blocks
    while ((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null) {
      maskedSrc = maskedSrc.slice(0, match.index) + '[' + repeatString('a', match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
    }

    // Mask out escaped em & strong delimiters
    while ((match = this.tokenizer.rules.inline.escapedEmSt.exec(maskedSrc)) != null) {
      maskedSrc = maskedSrc.slice(0, match.index + match[0].length - 2) + '++' + maskedSrc.slice(this.tokenizer.rules.inline.escapedEmSt.lastIndex);
      this.tokenizer.rules.inline.escapedEmSt.lastIndex--;
    }

    while (src) {
      if (!keepPrevChar) {
        prevChar = '';
      }
      keepPrevChar = false;

      // extensions
      if (this.options.extensions
        && this.options.extensions.inline
        && this.options.extensions.inline.some((extTokenizer) => {
          if (token = extTokenizer.call({ lexer: this }, src, tokens)) {
            src = src.substring(token.raw.length);
            tokens.push(token);
            return true;
          }
          return false;
        })) {
        continue;
      }

      // escape
      if (token = this.tokenizer.escape(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // tag
      if (token = this.tokenizer.tag(src)) {
        src = src.substring(token.raw.length);
        lastToken = tokens[tokens.length - 1];
        if (lastToken && token.type === 'text' && lastToken.type === 'text') {
          lastToken.raw += token.raw;
          lastToken.text += token.text;
        } else {
          tokens.push(token);
        }
        continue;
      }

      // link
      if (token = this.tokenizer.link(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // reflink, nolink
      if (token = this.tokenizer.reflink(src, this.tokens.links)) {
        src = src.substring(token.raw.length);
        lastToken = tokens[tokens.length - 1];
        if (lastToken && token.type === 'text' && lastToken.type === 'text') {
          lastToken.raw += token.raw;
          lastToken.text += token.text;
        } else {
          tokens.push(token);
        }
        continue;
      }

      // em & strong
      if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // code
      if (token = this.tokenizer.codespan(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // br
      if (token = this.tokenizer.br(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // del (gfm)
      if (token = this.tokenizer.del(src)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // autolink
      if (token = this.tokenizer.autolink(src, mangle)) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // url (gfm)
      if (!this.state.inLink && (token = this.tokenizer.url(src, mangle))) {
        src = src.substring(token.raw.length);
        tokens.push(token);
        continue;
      }

      // text
      // prevent inlineText consuming extensions by clipping 'src' to extension start
      cutSrc = src;
      if (this.options.extensions && this.options.extensions.startInline) {
        let startIndex = Infinity;
        const tempSrc = src.slice(1);
        let tempStart;
        this.options.extensions.startInline.forEach(function(getStartIndex) {
          tempStart = getStartIndex.call({ lexer: this }, tempSrc);
          if (typeof tempStart === 'number' && tempStart >= 0) { startIndex = Math.min(startIndex, tempStart); }
        });
        if (startIndex < Infinity && startIndex >= 0) {
          cutSrc = src.substring(0, startIndex + 1);
        }
      }
      if (token = this.tokenizer.inlineText(cutSrc, smartypants)) {
        src = src.substring(token.raw.length);
        if (token.raw.slice(-1) !== '_') { // Track prevChar before string of ____ started
          prevChar = token.raw.slice(-1);
        }
        keepPrevChar = true;
        lastToken = tokens[tokens.length - 1];
        if (lastToken && lastToken.type === 'text') {
          lastToken.raw += token.raw;
          lastToken.text += token.text;
        } else {
          tokens.push(token);
        }
        continue;
      }

      if (src) {
        const errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
        if (this.options.silent) {
          console.error(errMsg);
          break;
        } else {
          throw new Error(errMsg);
        }
      }
    }

    return tokens;
  }
}

/**
 * Renderer
 */
class Renderer {
  constructor(options) {
    this.options = options || defaults;
  }

  code(code, infostring, escaped) {
    const lang = (infostring || '').match(/\S*/)[0];
    if (this.options.highlight) {
      const out = this.options.highlight(code, lang);
      if (out != null && out !== code) {
        escaped = true;
        code = out;
      }
    }

    code = code.replace(/\n$/, '') + '\n';

    if (!lang) {
      return '<pre><code>'
        + (escaped ? code : escape(code, true))
        + '</code></pre>\n';
    }

    return '<pre><code class="'
      + this.options.langPrefix
      + escape(lang)
      + '">'
      + (escaped ? code : escape(code, true))
      + '</code></pre>\n';
  }

  /**
   * @param {string} quote
   */
  blockquote(quote) {
    return `<blockquote>\n${quote}</blockquote>\n`;
  }

  html(html) {
    return html;
  }

  /**
   * @param {string} text
   * @param {string} level
   * @param {string} raw
   * @param {any} slugger
   */
  heading(text, level, raw, slugger) {
    if (this.options.headerIds) {
      const id = this.options.headerPrefix + slugger.slug(raw);
      return `<h${level} id="${id}">${text}</h${level}>\n`;
    }

    // ignore IDs
    return `<h${level}>${text}</h${level}>\n`;
  }

  hr() {
    return this.options.xhtml ? '<hr/>\n' : '<hr>\n';
  }

  list(body, ordered, start) {
    const type = ordered ? 'ol' : 'ul',
      startatt = (ordered && start !== 1) ? (' start="' + start + '"') : '';
    return '<' + type + startatt + '>\n' + body + '</' + type + '>\n';
  }

  /**
   * @param {string} text
   */
  listitem(text) {
    return `<li>${text}</li>\n`;
  }

  checkbox(checked) {
    return '<input '
      + (checked ? 'checked="" ' : '')
      + 'disabled="" type="checkbox"'
      + (this.options.xhtml ? ' /' : '')
      + '> ';
  }

  /**
   * @param {string} text
   */
  paragraph(text) {
    return `<p>${text}</p>\n`;
  }

  /**
   * @param {string} header
   * @param {string} body
   */
  table(header, body) {
    if (body) body = `<tbody>${body}</tbody>`;

    return '<table>\n'
      + '<thead>\n'
      + header
      + '</thead>\n'
      + body
      + '</table>\n';
  }

  /**
   * @param {string} content
   */
  tablerow(content) {
    return `<tr>\n${content}</tr>\n`;
  }

  tablecell(content, flags) {
    const type = flags.header ? 'th' : 'td';
    const tag = flags.align
      ? `<${type} align="${flags.align}">`
      : `<${type}>`;
    return tag + content + `</${type}>\n`;
  }

  /**
   * span level renderer
   * @param {string} text
   */
  strong(text) {
    return `<strong>${text}</strong>`;
  }

  /**
   * @param {string} text
   */
  em(text) {
    return `<em>${text}</em>`;
  }

  /**
   * @param {string} text
   */
  codespan(text) {
    return `<code>${text}</code>`;
  }

  br() {
    return this.options.xhtml ? '<br/>' : '<br>';
  }

  /**
   * @param {string} text
   */
  del(text) {
    return `<del>${text}</del>`;
  }

  /**
   * @param {string} href
   * @param {string} title
   * @param {string} text
   */
  link(href, title, text) {
    href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
    if (href === null) {
      return text;
    }
    let out = '<a href="' + href + '"';
    if (title) {
      out += ' title="' + title + '"';
    }
    out += '>' + text + '</a>';
    return out;
  }

  /**
   * @param {string} href
   * @param {string} title
   * @param {string} text
   */
  image(href, title, text) {
    href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
    if (href === null) {
      return text;
    }

    let out = `<img src="${href}" alt="${text}"`;
    if (title) {
      out += ` title="${title}"`;
    }
    out += this.options.xhtml ? '/>' : '>';
    return out;
  }

  text(text) {
    return text;
  }
}

/**
 * TextRenderer
 * returns only the textual part of the token
 */
class TextRenderer {
  // no need for block level renderers
  strong(text) {
    return text;
  }

  em(text) {
    return text;
  }

  codespan(text) {
    return text;
  }

  del(text) {
    return text;
  }

  html(text) {
    return text;
  }

  text(text) {
    return text;
  }

  link(href, title, text) {
    return '' + text;
  }

  image(href, title, text) {
    return '' + text;
  }

  br() {
    return '';
  }
}

/**
 * Slugger generates header id
 */
class Slugger {
  constructor() {
    this.seen = {};
  }

  /**
   * @param {string} value
   */
  serialize(value) {
    return value
      .toLowerCase()
      .trim()
      // remove html tags
      .replace(/<[!\/a-z].*?>/ig, '')
      // remove unwanted chars
      .replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, '')
      .replace(/\s/g, '-');
  }

  /**
   * Finds the next safe (unique) slug to use
   * @param {string} originalSlug
   * @param {boolean} isDryRun
   */
  getNextSafeSlug(originalSlug, isDryRun) {
    let slug = originalSlug;
    let occurenceAccumulator = 0;
    if (this.seen.hasOwnProperty(slug)) {
      occurenceAccumulator = this.seen[originalSlug];
      do {
        occurenceAccumulator++;
        slug = originalSlug + '-' + occurenceAccumulator;
      } while (this.seen.hasOwnProperty(slug));
    }
    if (!isDryRun) {
      this.seen[originalSlug] = occurenceAccumulator;
      this.seen[slug] = 0;
    }
    return slug;
  }

  /**
   * Convert string to unique id
   * @param {object} [options]
   * @param {boolean} [options.dryrun] Generates the next unique slug without
   * updating the internal accumulator.
   */
  slug(value, options = {}) {
    const slug = this.serialize(value);
    return this.getNextSafeSlug(slug, options.dryrun);
  }
}

/**
 * Parsing & Compiling
 */
class Parser {
  constructor(options) {
    this.options = options || defaults;
    this.options.renderer = this.options.renderer || new Renderer();
    this.renderer = this.options.renderer;
    this.renderer.options = this.options;
    this.textRenderer = new TextRenderer();
    this.slugger = new Slugger();
  }

  /**
   * Static Parse Method
   */
  static parse(tokens, options) {
    const parser = new Parser(options);
    return parser.parse(tokens);
  }

  /**
   * Static Parse Inline Method
   */
  static parseInline(tokens, options) {
    const parser = new Parser(options);
    return parser.parseInline(tokens);
  }

  /**
   * Parse Loop
   */
  parse(tokens, top = true) {
    let out = '',
      i,
      j,
      k,
      l2,
      l3,
      row,
      cell,
      header,
      body,
      token,
      ordered,
      start,
      loose,
      itemBody,
      item,
      checked,
      task,
      checkbox,
      ret;

    const l = tokens.length;
    for (i = 0; i < l; i++) {
      token = tokens[i];

      // Run any renderer extensions
      if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
        ret = this.options.extensions.renderers[token.type].call({ parser: this }, token);
        if (ret !== false || !['space', 'hr', 'heading', 'code', 'table', 'blockquote', 'list', 'html', 'paragraph', 'text'].includes(token.type)) {
          out += ret || '';
          continue;
        }
      }

      switch (token.type) {
        case 'space': {
          continue;
        }
        case 'hr': {
          out += this.renderer.hr();
          continue;
        }
        case 'heading': {
          out += this.renderer.heading(
            this.parseInline(token.tokens),
            token.depth,
            unescape$1(this.parseInline(token.tokens, this.textRenderer)),
            this.slugger);
          continue;
        }
        case 'code': {
          out += this.renderer.code(token.text,
            token.lang,
            token.escaped);
          continue;
        }
        case 'table': {
          header = '';

          // header
          cell = '';
          l2 = token.header.length;
          for (j = 0; j < l2; j++) {
            cell += this.renderer.tablecell(
              this.parseInline(token.header[j].tokens),
              { header: true, align: token.align[j] }
            );
          }
          header += this.renderer.tablerow(cell);

          body = '';
          l2 = token.rows.length;
          for (j = 0; j < l2; j++) {
            row = token.rows[j];

            cell = '';
            l3 = row.length;
            for (k = 0; k < l3; k++) {
              cell += this.renderer.tablecell(
                this.parseInline(row[k].tokens),
                { header: false, align: token.align[k] }
              );
            }

            body += this.renderer.tablerow(cell);
          }
          out += this.renderer.table(header, body);
          continue;
        }
        case 'blockquote': {
          body = this.parse(token.tokens);
          out += this.renderer.blockquote(body);
          continue;
        }
        case 'list': {
          ordered = token.ordered;
          start = token.start;
          loose = token.loose;
          l2 = token.items.length;

          body = '';
          for (j = 0; j < l2; j++) {
            item = token.items[j];
            checked = item.checked;
            task = item.task;

            itemBody = '';
            if (item.task) {
              checkbox = this.renderer.checkbox(checked);
              if (loose) {
                if (item.tokens.length > 0 && item.tokens[0].type === 'paragraph') {
                  item.tokens[0].text = checkbox + ' ' + item.tokens[0].text;
                  if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === 'text') {
                    item.tokens[0].tokens[0].text = checkbox + ' ' + item.tokens[0].tokens[0].text;
                  }
                } else {
                  item.tokens.unshift({
                    type: 'text',
                    text: checkbox
                  });
                }
              } else {
                itemBody += checkbox;
              }
            }

            itemBody += this.parse(item.tokens, loose);
            body += this.renderer.listitem(itemBody, task, checked);
          }

          out += this.renderer.list(body, ordered, start);
          continue;
        }
        case 'html': {
          // TODO parse inline content if parameter markdown=1
          out += this.renderer.html(token.text);
          continue;
        }
        case 'paragraph': {
          out += this.renderer.paragraph(this.parseInline(token.tokens));
          continue;
        }
        case 'text': {
          body = token.tokens ? this.parseInline(token.tokens) : token.text;
          while (i + 1 < l && tokens[i + 1].type === 'text') {
            token = tokens[++i];
            body += '\n' + (token.tokens ? this.parseInline(token.tokens) : token.text);
          }
          out += top ? this.renderer.paragraph(body) : body;
          continue;
        }

        default: {
          const errMsg = 'Token with "' + token.type + '" type was not found.';
          if (this.options.silent) {
            console.error(errMsg);
            return;
          } else {
            throw new Error(errMsg);
          }
        }
      }
    }

    return out;
  }

  /**
   * Parse Inline Tokens
   */
  parseInline(tokens, renderer) {
    renderer = renderer || this.renderer;
    let out = '',
      i,
      token,
      ret;

    const l = tokens.length;
    for (i = 0; i < l; i++) {
      token = tokens[i];

      // Run any renderer extensions
      if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
        ret = this.options.extensions.renderers[token.type].call({ parser: this }, token);
        if (ret !== false || !['escape', 'html', 'link', 'image', 'strong', 'em', 'codespan', 'br', 'del', 'text'].includes(token.type)) {
          out += ret || '';
          continue;
        }
      }

      switch (token.type) {
        case 'escape': {
          out += renderer.text(token.text);
          break;
        }
        case 'html': {
          out += renderer.html(token.text);
          break;
        }
        case 'link': {
          out += renderer.link(token.href, token.title, this.parseInline(token.tokens, renderer));
          break;
        }
        case 'image': {
          out += renderer.image(token.href, token.title, token.text);
          break;
        }
        case 'strong': {
          out += renderer.strong(this.parseInline(token.tokens, renderer));
          break;
        }
        case 'em': {
          out += renderer.em(this.parseInline(token.tokens, renderer));
          break;
        }
        case 'codespan': {
          out += renderer.codespan(token.text);
          break;
        }
        case 'br': {
          out += renderer.br();
          break;
        }
        case 'del': {
          out += renderer.del(this.parseInline(token.tokens, renderer));
          break;
        }
        case 'text': {
          out += renderer.text(token.text);
          break;
        }
        default: {
          const errMsg = 'Token with "' + token.type + '" type was not found.';
          if (this.options.silent) {
            console.error(errMsg);
            return;
          } else {
            throw new Error(errMsg);
          }
        }
      }
    }
    return out;
  }
}

class Hooks {
  constructor(options) {
    this.options = options || defaults;
  }

  static passThroughHooks = new Set([
    'preprocess',
    'postprocess'
  ]);

  /**
   * Process markdown before marked
   */
  preprocess(markdown) {
    return markdown;
  }

  /**
   * Process HTML after marked is finished
   */
  postprocess(html) {
    return html;
  }
}

function onError(silent, async, callback) {
  return (e) => {
    e.message += '\nPlease report this to https://github.com/markedjs/marked.';

    if (silent) {
      const msg = '<p>An error occurred:</p><pre>'
        + escape(e.message + '', true)
        + '</pre>';
      if (async) {
        return Promise.resolve(msg);
      }
      if (callback) {
        callback(null, msg);
        return;
      }
      return msg;
    }

    if (async) {
      return Promise.reject(e);
    }
    if (callback) {
      callback(e);
      return;
    }
    throw e;
  };
}

function parseMarkdown(lexer, parser) {
  return (src, opt, callback) => {
    if (typeof opt === 'function') {
      callback = opt;
      opt = null;
    }

    const origOpt = { ...opt };
    opt = { ...marked.defaults, ...origOpt };
    const throwError = onError(opt.silent, opt.async, callback);

    // throw error in case of non string input
    if (typeof src === 'undefined' || src === null) {
      return throwError(new Error('marked(): input parameter is undefined or null'));
    }
    if (typeof src !== 'string') {
      return throwError(new Error('marked(): input parameter is of type '
        + Object.prototype.toString.call(src) + ', string expected'));
    }

    checkSanitizeDeprecation(opt);

    if (opt.hooks) {
      opt.hooks.options = opt;
    }

    if (callback) {
      const highlight = opt.highlight;
      let tokens;

      try {
        if (opt.hooks) {
          src = opt.hooks.preprocess(src);
        }
        tokens = lexer(src, opt);
      } catch (e) {
        return throwError(e);
      }

      const done = function(err) {
        let out;

        if (!err) {
          try {
            if (opt.walkTokens) {
              marked.walkTokens(tokens, opt.walkTokens);
            }
            out = parser(tokens, opt);
            if (opt.hooks) {
              out = opt.hooks.postprocess(out);
            }
          } catch (e) {
            err = e;
          }
        }

        opt.highlight = highlight;

        return err
          ? throwError(err)
          : callback(null, out);
      };

      if (!highlight || highlight.length < 3) {
        return done();
      }

      delete opt.highlight;

      if (!tokens.length) return done();

      let pending = 0;
      marked.walkTokens(tokens, function(token) {
        if (token.type === 'code') {
          pending++;
          setTimeout(() => {
            highlight(token.text, token.lang, function(err, code) {
              if (err) {
                return done(err);
              }
              if (code != null && code !== token.text) {
                token.text = code;
                token.escaped = true;
              }

              pending--;
              if (pending === 0) {
                done();
              }
            });
          }, 0);
        }
      });

      if (pending === 0) {
        done();
      }

      return;
    }

    if (opt.async) {
      return Promise.resolve(opt.hooks ? opt.hooks.preprocess(src) : src)
        .then(src => lexer(src, opt))
        .then(tokens => opt.walkTokens ? Promise.all(marked.walkTokens(tokens, opt.walkTokens)).then(() => tokens) : tokens)
        .then(tokens => parser(tokens, opt))
        .then(html => opt.hooks ? opt.hooks.postprocess(html) : html)
        .catch(throwError);
    }

    try {
      if (opt.hooks) {
        src = opt.hooks.preprocess(src);
      }
      const tokens = lexer(src, opt);
      if (opt.walkTokens) {
        marked.walkTokens(tokens, opt.walkTokens);
      }
      let html = parser(tokens, opt);
      if (opt.hooks) {
        html = opt.hooks.postprocess(html);
      }
      return html;
    } catch (e) {
      return throwError(e);
    }
  };
}

/**
 * Marked
 */
function marked(src, opt, callback) {
  return parseMarkdown(Lexer.lex, Parser.parse)(src, opt, callback);
}

/**
 * Options
 */

marked.options =
marked.setOptions = function(opt) {
  marked.defaults = { ...marked.defaults, ...opt };
  changeDefaults(marked.defaults);
  return marked;
};

marked.getDefaults = getDefaults;

marked.defaults = defaults;

/**
 * Use Extension
 */

marked.use = function(...args) {
  const extensions = marked.defaults.extensions || { renderers: {}, childTokens: {} };

  args.forEach((pack) => {
    // copy options to new object
    const opts = { ...pack };

    // set async to true if it was set to true before
    opts.async = marked.defaults.async || opts.async || false;

    // ==-- Parse "addon" extensions --== //
    if (pack.extensions) {
      pack.extensions.forEach((ext) => {
        if (!ext.name) {
          throw new Error('extension name required');
        }
        if (ext.renderer) { // Renderer extensions
          const prevRenderer = extensions.renderers[ext.name];
          if (prevRenderer) {
            // Replace extension with func to run new extension but fall back if false
            extensions.renderers[ext.name] = function(...args) {
              let ret = ext.renderer.apply(this, args);
              if (ret === false) {
                ret = prevRenderer.apply(this, args);
              }
              return ret;
            };
          } else {
            extensions.renderers[ext.name] = ext.renderer;
          }
        }
        if (ext.tokenizer) { // Tokenizer Extensions
          if (!ext.level || (ext.level !== 'block' && ext.level !== 'inline')) {
            throw new Error("extension level must be 'block' or 'inline'");
          }
          if (extensions[ext.level]) {
            extensions[ext.level].unshift(ext.tokenizer);
          } else {
            extensions[ext.level] = [ext.tokenizer];
          }
          if (ext.start) { // Function to check for start of token
            if (ext.level === 'block') {
              if (extensions.startBlock) {
                extensions.startBlock.push(ext.start);
              } else {
                extensions.startBlock = [ext.start];
              }
            } else if (ext.level === 'inline') {
              if (extensions.startInline) {
                extensions.startInline.push(ext.start);
              } else {
                extensions.startInline = [ext.start];
              }
            }
          }
        }
        if (ext.childTokens) { // Child tokens to be visited by walkTokens
          extensions.childTokens[ext.name] = ext.childTokens;
        }
      });
      opts.extensions = extensions;
    }

    // ==-- Parse "overwrite" extensions --== //
    if (pack.renderer) {
      const renderer = marked.defaults.renderer || new Renderer();
      for (const prop in pack.renderer) {
        const prevRenderer = renderer[prop];
        // Replace renderer with func to run extension, but fall back if false
        renderer[prop] = (...args) => {
          let ret = pack.renderer[prop].apply(renderer, args);
          if (ret === false) {
            ret = prevRenderer.apply(renderer, args);
          }
          return ret;
        };
      }
      opts.renderer = renderer;
    }
    if (pack.tokenizer) {
      const tokenizer = marked.defaults.tokenizer || new Tokenizer();
      for (const prop in pack.tokenizer) {
        const prevTokenizer = tokenizer[prop];
        // Replace tokenizer with func to run extension, but fall back if false
        tokenizer[prop] = (...args) => {
          let ret = pack.tokenizer[prop].apply(tokenizer, args);
          if (ret === false) {
            ret = prevTokenizer.apply(tokenizer, args);
          }
          return ret;
        };
      }
      opts.tokenizer = tokenizer;
    }

    // ==-- Parse Hooks extensions --== //
    if (pack.hooks) {
      const hooks = marked.defaults.hooks || new Hooks();
      for (const prop in pack.hooks) {
        const prevHook = hooks[prop];
        if (Hooks.passThroughHooks.has(prop)) {
          hooks[prop] = (arg) => {
            if (marked.defaults.async) {
              return Promise.resolve(pack.hooks[prop].call(hooks, arg)).then(ret => {
                return prevHook.call(hooks, ret);
              });
            }

            const ret = pack.hooks[prop].call(hooks, arg);
            return prevHook.call(hooks, ret);
          };
        } else {
          hooks[prop] = (...args) => {
            let ret = pack.hooks[prop].apply(hooks, args);
            if (ret === false) {
              ret = prevHook.apply(hooks, args);
            }
            return ret;
          };
        }
      }
      opts.hooks = hooks;
    }

    // ==-- Parse WalkTokens extensions --== //
    if (pack.walkTokens) {
      const walkTokens = marked.defaults.walkTokens;
      opts.walkTokens = function(token) {
        let values = [];
        values.push(pack.walkTokens.call(this, token));
        if (walkTokens) {
          values = values.concat(walkTokens.call(this, token));
        }
        return values;
      };
    }

    marked.setOptions(opts);
  });
};

/**
 * Run callback for every token
 */

marked.walkTokens = function(tokens, callback) {
  let values = [];
  for (const token of tokens) {
    values = values.concat(callback.call(marked, token));
    switch (token.type) {
      case 'table': {
        for (const cell of token.header) {
          values = values.concat(marked.walkTokens(cell.tokens, callback));
        }
        for (const row of token.rows) {
          for (const cell of row) {
            values = values.concat(marked.walkTokens(cell.tokens, callback));
          }
        }
        break;
      }
      case 'list': {
        values = values.concat(marked.walkTokens(token.items, callback));
        break;
      }
      default: {
        if (marked.defaults.extensions && marked.defaults.extensions.childTokens && marked.defaults.extensions.childTokens[token.type]) { // Walk any extensions
          marked.defaults.extensions.childTokens[token.type].forEach(function(childTokens) {
            values = values.concat(marked.walkTokens(token[childTokens], callback));
          });
        } else if (token.tokens) {
          values = values.concat(marked.walkTokens(token.tokens, callback));
        }
      }
    }
  }
  return values;
};

/**
 * Parse Inline
 * @param {string} src
 */
marked.parseInline = parseMarkdown(Lexer.lexInline, Parser.parseInline);

/**
 * Expose
 */
marked.Parser = Parser;
marked.parser = Parser.parse;
marked.Renderer = Renderer;
marked.TextRenderer = TextRenderer;
marked.Lexer = Lexer;
marked.lexer = Lexer.lex;
marked.Tokenizer = Tokenizer;
marked.Slugger = Slugger;
marked.Hooks = Hooks;
marked.parse = marked;

marked.options;
marked.setOptions;
marked.use;
marked.walkTokens;
marked.parseInline;
Parser.parse;
Lexer.lex;

/**
 * Transform rules optimized for Markdown content
 */
const defaultMarkdownRules = [
// Pre + Code blocks → Code component (same as article)
{
  selector: 'pre',
  transform: (element, key) => {
    const codeChild = element.querySelector('code');
    if (!codeChild) return null;
    const language = Array.from(codeChild.classList).find(cls => cls.startsWith('language-'))?.replace('language-', '') || 'text';
    // Use ComponentTransformer to create Code component
    const codeData = {
      tagName: 'Code',
      version: '1.0.0',
      data: {
        language,
        showCopy: true,
        showLineNumbers: false,
        children: codeChild.textContent || ''
      }
    };
    return jsx(Box, {
      sx: {
        my: 1.5
      },
      children: ComponentTransformer$1.deserialize(codeData)
    }, key);
  }
},
// Inline code → preserve as regular code element (no transformation)
{
  selector: 'code',
  transform: element => {
    // Skip if inside pre (already handled above)
    if (element.closest('pre')) return null;
    // For Markdown, keep inline code as-is
    return null;
  }
}];

/**
 * Configure marked with security and GitHub Flavored Markdown support
 */
const getMarkedOptions = customOptions => ({
  // GitHub Flavored Markdown
  gfm: true,
  // Convert line breaks to <br> tags
  breaks: false,
  // Pedantic compliance to original markdown.pl
  pedantic: false,
  // Sanitize HTML (we handle this in Html component)
  sanitize: false,
  // Smart punctuation
  smartypants: false,
  // Custom renderer options
  renderer: new marked.Renderer(),
  // Override with user options
  ...customOptions
});
// View component - handles the actual rendering
function MarkdownView({
  children = '',
  htmlTransformConfig,
  sanitize = true,
  sanitizeOptions,
  placeholder,
  component = 'div',
  markedOptions,
  ...restProps
}) {
  const {
    styleProps,
    htmlProps,
    restProps: otherProps
  } = useBaseProps(restProps);
  // Mark as QwickApp component
  Object.assign(MarkdownView, {
    [QWICKAPP_COMPONENT]: true
  });
  // Return placeholder if no Markdown content
  if (!children || !children.trim()) {
    if (placeholder) {
      return jsx(Box, {
        component: component,
        ...htmlProps,
        ...styleProps,
        ...otherProps,
        sx: {
          opacity: 0.6,
          fontStyle: 'italic',
          ...styleProps.sx
        },
        children: placeholder
      });
    }
    return null;
  }
  try {
    // Configure marked
    const options = getMarkedOptions(markedOptions);
    // Convert Markdown to HTML
    const htmlContent = marked(children, options);
    // Use provided transform config or default markdown rules
    const transformConfig = htmlTransformConfig || {
      rules: defaultMarkdownRules,
      sanitize,
      sanitizeOptions
    };
    // Pass HTML to Html component for transformation
    return jsx(Html, {
      transformConfig: transformConfig,
      sanitize: sanitize,
      sanitizeOptions: sanitizeOptions,
      component: component,
      ...htmlProps,
      ...styleProps,
      ...otherProps,
      children: htmlContent
    });
  } catch (error) {
    console.error('Error processing Markdown content:', error);
    // Production fallback - try to use Html component with raw content
    try {
      return jsx(Html, {
        sanitize: sanitize,
        sanitizeOptions: sanitizeOptions,
        component: component,
        ...htmlProps,
        ...styleProps,
        ...otherProps,
        children: children
      });
    } catch (htmlError) {
      // Last resort fallback
      return jsx(SafeSpan, {
        html: children,
        placeholder: placeholder || "Content unavailable",
        ...htmlProps,
        ...styleProps,
        ...otherProps
      });
    }
  }
}
// Main component with data binding support and serialization capability
class Markdown extends ModelView {
  // Component-specific serialization properties
  getComponentSpecificProps() {
    return {
      children: this.props.children,
      sanitize: this.props.sanitize,
      placeholder: this.props.placeholder
    };
  }
  // Markdown component renders traditional props view
  renderView() {
    const {
      ...restProps
    } = this.props;
    return jsx(MarkdownView, {
      ...restProps
    });
  }
  // Markdown component renders data-bound view
  renderWithDataBinding() {
    return jsx(MarkdownWithDataBinding, {
      ...this.props
    });
  }
  // Register HTML patterns that Markdown component can handle
  static registerPatternHandlers(registry) {
    const typedRegistry = registry;
    // Register div elements with specific classes for Markdown transformation
    if (typedRegistry.hasPattern && !typedRegistry.hasPattern('div.markdown-content')) {
      typedRegistry.registerPattern?.('div.markdown-content', Markdown.transformMarkdownDiv);
    }
    // Register elements with data-markdown attribute
    if (typedRegistry.hasPattern && !typedRegistry.hasPattern('[data-markdown]')) {
      typedRegistry.registerPattern?.('[data-markdown]', Markdown.transformDataMarkdown);
    }
  }
  // Transform div with markdown-content class to Markdown component
  static transformMarkdownDiv(element) {
    const sanitize = element.getAttribute('data-sanitize') !== 'false';
    const placeholder = element.getAttribute('data-placeholder');
    return {
      tagName: 'Markdown',
      props: {
        children: element.textContent || '',
        sanitize,
        placeholder: placeholder || undefined
      }
    };
  }
  // Transform elements with data-markdown attribute to Markdown component
  static transformDataMarkdown(element) {
    const markdownContent = element.getAttribute('data-markdown') || element.textContent;
    const sanitize = element.getAttribute('data-sanitize') !== 'false';
    const placeholder = element.getAttribute('data-placeholder');
    return {
      tagName: 'Markdown',
      props: {
        children: markdownContent,
        sanitize,
        placeholder: placeholder || undefined
      }
    };
  }
}
// Component self-declaration for serialization
Markdown.tagName = 'Markdown';
Markdown.version = '1.0.0';
// Helper component to handle data binding with hooks (since we can't use hooks in class components)
function MarkdownWithDataBinding(props) {
  const {
    dataSource,
    bindingOptions,
    ...restProps
  } = props;
  // Use data binding
  const {
    loading,
    error,
    ...markdownProps
  } = useDataBinding(dataSource, restProps);
  // Show loading state
  if (loading) {
    return jsx(Box, {
      sx: {
        p: 2,
        textAlign: 'center',
        opacity: 0.6
      },
      children: "Loading Markdown content..."
    });
  }
  if (error) {
    console.error('Error loading Markdown content:', error);
    return null;
  }
  return jsx(MarkdownView, {
    ...markdownProps
  });
}

/**
 * Custom Palette Manager - Create and manage custom color palettes
 * 
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */

/**
 * Saves a custom palette to localStorage
 * @param {Object} palette - Palette object with id, name, colors, etc.
 */
const saveCustomPalette = palette => {
  const customPalettes = getCustomPalettes();
  const updatedPalettes = customPalettes.filter(p => p.id !== palette.id);
  updatedPalettes.push(palette);
  localStorage.setItem('qwickapps-custom-palettes', JSON.stringify(updatedPalettes));

  // Dispatch event to notify components
  window.dispatchEvent(new CustomEvent('custom-palettes-changed', {
    detail: {
      palettes: updatedPalettes
    }
  }));
};

/**
 * Gets all custom palettes from localStorage
 * @returns {Array} Array of custom palette objects
 */
const getCustomPalettes = () => {
  try {
    const stored = localStorage.getItem('qwickapps-custom-palettes');
    return stored ? JSON.parse(stored) : [];
  } catch (error) {
    console.warn('Failed to load custom palettes:', error);
    return [];
  }
};

/**
 * Deletes a custom palette
 * @param {string} paletteId - ID of the palette to delete
 */
const deleteCustomPalette = paletteId => {
  const customPalettes = getCustomPalettes();
  const updatedPalettes = customPalettes.filter(p => p.id !== paletteId);
  localStorage.setItem('qwickapps-custom-palettes', JSON.stringify(updatedPalettes));

  // Dispatch event to notify components
  window.dispatchEvent(new CustomEvent('custom-palettes-changed', {
    detail: {
      palettes: updatedPalettes
    }
  }));
};

/**
 * Exports a palette to a JSON file
 * @param {Object} palette - Palette to export
 */
const exportPalette = palette => {
  const dataStr = JSON.stringify(palette, null, 2);
  const dataBlob = new Blob([dataStr], {
    type: 'application/json'
  });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(dataBlob);
  link.download = `qwickapps-palette-${palette.id}.json`;
  link.click();
  URL.revokeObjectURL(link.href);
};

/**
 * Imports a palette from a JSON file
 * @param {File} file - JSON file containing palette data
 * @returns {Promise<Object>} Parsed palette object
 */
const importPalette = file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = event => {
      try {
        const palette = JSON.parse(event.target.result);

        // Basic validation
        if (!palette.id || !palette.name || !palette.primaryColor) {
          reject(new Error('Invalid palette format'));
          return;
        }

        // Ensure unique ID
        const customPalettes = getCustomPalettes();
        if (customPalettes.find(p => p.id === palette.id)) {
          palette.id = `${palette.id}-${Date.now()}`;
        }
        resolve(palette);
      } catch (error) {
        reject(new Error('Failed to parse palette file'));
      }
    };
    reader.onerror = () => reject(new Error('Failed to read file'));
    reader.readAsText(file);
  });
};

/**
 * Creates a new custom palette from current theme colors
 * @param {string} name - Name for the new palette
 * @param {string} description - Description for the palette
 * @returns {Object} New palette object
 */
const createPaletteFromCurrentTheme = (name, description) => {
  const root = document.documentElement;
  const style = getComputedStyle(root);

  // Extract current colors
  const palette = {
    id: `custom-${Date.now()}`,
    name,
    description,
    isCustom: true,
    createdAt: new Date().toISOString(),
    primaryColor: style.getPropertyValue('--palette-primary-main').trim(),
    colors: {
      primary: {
        main: style.getPropertyValue('--palette-primary-main').trim(),
        light: style.getPropertyValue('--palette-primary-light').trim(),
        dark: style.getPropertyValue('--palette-primary-dark').trim()
      },
      secondary: {
        main: style.getPropertyValue('--palette-secondary-main').trim(),
        light: style.getPropertyValue('--palette-secondary-light').trim(),
        dark: style.getPropertyValue('--palette-secondary-dark').trim()
      },
      background: {
        main: style.getPropertyValue('--palette-background-main').trim(),
        secondary: style.getPropertyValue('--palette-background-dark').trim()
      },
      surface: {
        main: style.getPropertyValue('--palette-surface-main').trim(),
        variant: style.getPropertyValue('--palette-surface-variant').trim(),
        elevated: style.getPropertyValue('--palette-surface-elevated').trim()
      },
      text: {
        primary: style.getPropertyValue('--palette-text-primary').trim(),
        secondary: style.getPropertyValue('--palette-text-secondary').trim(),
        disabled: style.getPropertyValue('--palette-text-disabled').trim()
      },
      border: {
        main: style.getPropertyValue('--palette-border-main').trim(),
        light: style.getPropertyValue('--palette-border-light').trim(),
        medium: style.getPropertyValue('--palette-border-medium').trim()
      },
      success: {
        main: style.getPropertyValue('--palette-success-main').trim(),
        light: style.getPropertyValue('--palette-success-light').trim(),
        dark: style.getPropertyValue('--palette-success-dark').trim()
      },
      error: {
        main: style.getPropertyValue('--palette-error-main').trim(),
        light: style.getPropertyValue('--palette-error-light').trim(),
        dark: style.getPropertyValue('--palette-error-dark').trim()
      },
      warning: {
        main: style.getPropertyValue('--palette-warning-main').trim(),
        light: style.getPropertyValue('--palette-warning-light').trim(),
        dark: style.getPropertyValue('--palette-warning-dark').trim()
      },
      info: {
        main: style.getPropertyValue('--palette-info-main').trim(),
        light: style.getPropertyValue('--palette-info-light').trim(),
        dark: style.getPropertyValue('--palette-info-dark').trim()
      }
    }
  };
  return palette;
};

/**
 * Applies a custom palette dynamically
 * @param {Object} palette - Custom palette object
 */
const applyCustomPalette = palette => {
  const root = document.documentElement;

  // Apply colors to CSS custom properties
  if (palette.colors) {
    const {
      colors
    } = palette;

    // Apply primary colors
    if (colors.primary) {
      root.style.setProperty('--palette-primary-main', colors.primary.main);
      root.style.setProperty('--palette-primary-light', colors.primary.light);
      root.style.setProperty('--palette-primary-dark', colors.primary.dark);
    }

    // Apply secondary colors
    if (colors.secondary) {
      root.style.setProperty('--palette-secondary-main', colors.secondary.main);
      root.style.setProperty('--palette-secondary-light', colors.secondary.light);
      root.style.setProperty('--palette-secondary-dark', colors.secondary.dark);
    }

    // Apply background colors
    if (colors.background) {
      root.style.setProperty('--palette-background-main', colors.background.main);
      root.style.setProperty('--palette-background-dark', colors.background.secondary);
    }

    // Apply other color categories as needed...
    // (This could be expanded to apply all color categories)
  }
};

/**
 * Theme Performance Monitor - Track theme switching performance
 * 
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */

class ThemePerformanceMonitor {
  constructor() {
    this.measurements = [];
    this.isEnabled = "production" === 'development';
    if (this.isEnabled) {
      this.initializeListeners();
    }
  }
  initializeListeners() {
    // SSR guard - only initialize listeners in browser environment
    if (typeof window === 'undefined') {
      return;
    }

    // Listen for theme changes
    window.addEventListener('theme-changed', event => {
      this.measureThemeSwitch('theme', event.detail?.theme);
    });

    // Listen for palette changes
    window.addEventListener('palette-changed', event => {
      this.measureThemeSwitch('palette', event.detail?.palette);
    });
  }
  measureThemeSwitch(type, value) {
    // SSR guard
    if (!this.isEnabled || typeof window === 'undefined' || typeof performance === 'undefined') {
      return;
    }
    const startTime = performance.now();

    // Use requestAnimationFrame to measure when the visual change is complete
    requestAnimationFrame(() => {
      // Wait for another frame to ensure CSS has been applied
      requestAnimationFrame(() => {
        const endTime = performance.now();
        const duration = endTime - startTime;
        const measurement = {
          type,
          value,
          duration,
          timestamp: new Date().toISOString()
        };
        this.measurements.push(measurement);

        // Keep only last 50 measurements
        if (this.measurements.length > 50) {
          this.measurements.shift();
        }

        // Log if it takes too long
        if (duration > 100) {
          console.warn(`Slow ${type} switch detected:`, measurement);
        } else {
          console.log(`${type} switch performance:`, `${duration.toFixed(2)}ms`);
        }
      });
    });
  }
  getStatistics() {
    if (!this.isEnabled || this.measurements.length === 0) {
      return null;
    }
    const durations = this.measurements.map(m => m.duration);
    const average = durations.reduce((a, b) => a + b, 0) / durations.length;
    const min = Math.min(...durations);
    const max = Math.max(...durations);
    return {
      totalMeasurements: this.measurements.length,
      averageDuration: average.toFixed(2),
      minDuration: min.toFixed(2),
      maxDuration: max.toFixed(2),
      recentMeasurements: this.measurements.slice(-10)
    };
  }
  logStatistics() {
    if (!this.isEnabled) return;
    const stats = this.getStatistics();
    if (stats) {
      console.group('Theme Performance Statistics');
      console.log('Total measurements:', stats.totalMeasurements);
      console.log('Average duration:', stats.averageDuration + 'ms');
      console.log('Min duration:', stats.minDuration + 'ms');
      console.log('Max duration:', stats.maxDuration + 'ms');
      console.log('Recent measurements:', stats.recentMeasurements);
      console.groupEnd();
    }
  }
  reset() {
    this.measurements = [];
  }
}

// Create a singleton instance
const themePerformanceMonitor = new ThemePerformanceMonitor();

// Export methods
const getThemePerformanceStats = () => themePerformanceMonitor.getStatistics();
const logThemePerformanceStats = () => themePerformanceMonitor.logStatistics();
const resetThemePerformanceStats = () => themePerformanceMonitor.reset();

/**
 * Enhanced data with nested property access for template resolution
 * Supports deep nested access like {{company.profile.address.city}}
 */
class DataProxy {
  constructor(content, data = {}) {
    Object.assign(this, content);
    this.data = data;
    // Create proxy to enable nested property access
    return new Proxy(this, {
      get: (target, prop) => {
        // Return existing properties first
        if (prop in target || typeof prop === 'symbol') {
          return target[prop];
        }
        // Handle nested property access for data
        return this.getNestedValue(String(prop));
      }
    });
  }
  /**
   * Get nested value from data using dot notation
   * Supports: company.name, user.profile.avatar.url, etc.
   */
  getNestedValue(path) {
    const keys = path.split('.');
    let current = this.data;
    for (const key of keys) {
      if (current === null || current === undefined) {
        return undefined;
      }
      current = current[key];
    }
    return current;
  }
  /**
   * Set nested value in data using dot notation
   */
  setNestedValue(path, value) {
    const keys = path.split('.');
    const lastKey = keys.pop();
    let current = this.data;
    // Create nested objects as needed
    for (const key of keys) {
      if (!(key in current) || typeof current[key] !== 'object') {
        current[key] = {};
      }
      current = current[key];
    }
    current[lastKey] = value;
  }
  /**
   * Get all data including nested structures
   */
  getData() {
    return this.data;
  }
  /**
   * Update data while preserving nested structure
   */
  updateData(newData) {
    this.data = {
      ...this.data,
      ...newData
    };
  }
}

/**
 * Content Types for QwickApps React Framework
 *
 * These interfaces define the framework-agnostic content structure that can be
 * automatically created and managed across different CMS systems and used
 * for template resolution and component rendering.
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
/**
 * HTTP methods for form submission
 */
var FormMethod;
(function (FormMethod) {
  FormMethod["POST"] = "POST";
  FormMethod["PUT"] = "PUT";
  FormMethod["PATCH"] = "PATCH";
})(FormMethod || (FormMethod = {}));
/**
 * Action types for interactive elements
 */
var ActionType;
(function (ActionType) {
  ActionType["NAVIGATE"] = "navigate";
  ActionType["SUBMIT"] = "submit";
  ActionType["RESET"] = "reset";
  ActionType["CANCEL"] = "cancel";
})(ActionType || (ActionType = {}));

/**
 * QwickApps AppConfig Implementation
 *
 * Immutable configuration object with computed properties for Vite and PWA.
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
/**
 * Immutable application configuration
 */
class AppConfig {
  constructor(config) {
    // Create frozen, immutable configuration
    this.app = Object.freeze({
      ...config.app
    });
    this.build = Object.freeze({
      ...config.build
    });
    this.pwa = Object.freeze({
      ...config.pwa
    });
    this.ui = Object.freeze({
      ...config.ui
    });
    this.copyright = Object.freeze({
      ...config.copyright
    });
    // Freeze the entire object
    Object.freeze(this);
  }
  /**
   * Generate complete Vite configuration
   */
  get viteConfig() {
    return {
      server: {
        port: this.build.port,
        host: true
      },
      preview: {
        port: this.build.previewPort,
        host: true
      },
      build: {
        outDir: this.build.outputDir
      },
      base: this.build.base,
      publicDir: 'public',
      define: {
        __APP_NAME__: JSON.stringify(this.app.name),
        __APP_ID__: JSON.stringify(this.app.id),
        __APP_VERSION__: JSON.stringify(this.app.version)
      }
    };
  }
  /**
   * Generate PWA manifest
   */
  get pwaManifest() {
    return {
      name: this.app.name,
      short_name: this.app.shortName,
      description: this.app.description,
      start_url: this.pwa.startUrl,
      display: this.pwa.display,
      orientation: this.pwa.orientation,
      theme_color: this.pwa.themeColor,
      background_color: this.pwa.backgroundColor,
      scope: this.pwa.scope,
      icons: [{
        src: 'pwa-192x192.png',
        sizes: '192x192',
        type: 'image/png'
      }, {
        src: 'pwa-512x512.png',
        sizes: '512x512',
        type: 'image/png'
      }]
    };
  }
  /**
   * Convert to plain object (for serialization)
   */
  toJSON() {
    return {
      app: this.app,
      build: this.build,
      pwa: this.pwa,
      ui: this.ui,
      copyright: this.copyright
    };
  }
  /**
   * Create a copy with overrides (returns new immutable instance)
   */
  with(overrides) {
    return new AppConfig({
      app: {
        ...this.app,
        ...overrides.app
      },
      build: {
        ...this.build,
        ...overrides.build
      },
      pwa: {
        ...this.pwa,
        ...overrides.pwa
      },
      ui: {
        ...this.ui,
        ...overrides.ui
      },
      copyright: {
        ...this.copyright,
        ...overrides.copyright
      }
    });
  }
}

/**
 * QwickApps AppConfigBuilder
 *
 * Builder pattern for creating validated, immutable AppConfig instances.
 * Supports fluent API and deferred validation.
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
// Node.js imports (only available in build/development environment)
let fs;
let path;
try {
  // Only import if we're in Node.js environment
  if (typeof window === 'undefined' && typeof process !== 'undefined') {
    fs = require('fs');
    path = require('path');
  }
} catch (error) {
  // Browser environment - fs/path not available
}
/**
 * Builder for creating AppConfig instances with validation
 */
class AppConfigBuilder {
  constructor() {
    this.config = {
      app: {},
      build: {},
      pwa: {},
      ui: {},
      copyright: {}
    };
    this.options = {};
  }
  /**
   * Create a new AppConfigBuilder instance
   */
  static create() {
    return new AppConfigBuilder();
  }
  /**
   * Load configuration from JSON file (Node.js only)
   */
  withConfig(configPath) {
    if (!fs || !path) {
      // Only warn in development, not in tests or production browsers
      if (typeof window === 'undefined') {
        console.warn('Warning: File system operations not available in browser environment');
      }
      return this;
    }
    try {
      const fullPath = path.resolve(configPath);
      const configData = JSON.parse(fs.readFileSync(fullPath, 'utf-8'));
      if (configData.app) Object.assign(this.config.app, configData.app);
      if (configData.build) Object.assign(this.config.build, configData.build);
      if (configData.pwa) Object.assign(this.config.pwa, configData.pwa);
      if (configData.ui) Object.assign(this.config.ui, configData.ui);
      if (configData.copyright) Object.assign(this.config.copyright, configData.copyright);
    } catch (error) {
      // Don't throw here - will be handled in build()
      console.warn(`Warning: Could not load config file: ${configPath}`);
    }
    return this;
  }
  /**
   * Set builder options
   */
  withOptions(options) {
    this.options = {
      ...this.options,
      ...options
    };
    return this;
  }
  // App Identity Methods
  withName(name) {
    this.config.app.name = name;
    return this;
  }
  withId(id) {
    this.config.app.id = id;
    return this;
  }
  withShortName(shortName) {
    this.config.app.shortName = shortName;
    return this;
  }
  withDescription(description) {
    this.config.app.description = description;
    return this;
  }
  withVersion(version) {
    this.config.app.version = version;
    return this;
  }
  withLogo(logo) {
    this.config.app.logo = logo;
    return this;
  }
  withAuthor(author) {
    this.config.app.author = author;
    return this;
  }
  withHomepage(homepage) {
    this.config.app.homepage = homepage;
    return this;
  }
  // Build Config Methods
  withPort(port) {
    this.config.build.port = port;
    return this;
  }
  withPreviewPort(previewPort) {
    this.config.build.previewPort = previewPort;
    return this;
  }
  withOutputDir(outputDir) {
    this.config.build.outputDir = outputDir;
    return this;
  }
  withPublicPath(publicPath) {
    this.config.build.publicPath = publicPath;
    return this;
  }
  withBase(base) {
    this.config.build.base = base;
    return this;
  }
  // PWA Config Methods
  withThemeColor(themeColor) {
    this.config.pwa.themeColor = themeColor;
    return this;
  }
  withBackgroundColor(backgroundColor) {
    this.config.pwa.backgroundColor = backgroundColor;
    return this;
  }
  withStartUrl(startUrl) {
    this.config.pwa.startUrl = startUrl;
    return this;
  }
  withScope(scope) {
    this.config.pwa.scope = scope;
    return this;
  }
  withDisplay(display) {
    this.config.pwa.display = display;
    return this;
  }
  withOrientation(orientation) {
    this.config.pwa.orientation = orientation;
    return this;
  }
  // UI Config Methods
  withDefaultTheme(defaultTheme) {
    this.config.ui.defaultTheme = defaultTheme;
    return this;
  }
  withDefaultPalette(defaultPalette) {
    this.config.ui.defaultPalette = defaultPalette;
    return this;
  }
  withScaffolding(enableScaffolding) {
    this.config.ui.enableScaffolding = enableScaffolding;
    return this;
  }
  withThemeSwitcher(showThemeSwitcher) {
    this.config.ui.showThemeSwitcher = showThemeSwitcher;
    return this;
  }
  withPaletteSwitcher(showPaletteSwitcher) {
    this.config.ui.showPaletteSwitcher = showPaletteSwitcher;
    return this;
  }
  // Copyright Methods
  withCopyright(year, author, text) {
    this.config.copyright.year = year;
    this.config.copyright.author = author;
    if (text !== undefined) this.config.copyright.text = text;
    return this;
  }
  withCopyrightYear(year) {
    this.config.copyright.year = year;
    return this;
  }
  withCopyrightAuthor(author) {
    this.config.copyright.author = author;
    return this;
  }
  withCopyrightText(text) {
    this.config.copyright.text = text;
    return this;
  }
  /**
   * Build and validate the configuration
   */
  build() {
    const validation = this.validate();
    // Print warnings
    validation.warnings.forEach(warning => {
      console.warn(`⚠️  AppConfig: ${warning}`);
    });
    // Throw on errors
    if (!validation.isValid) {
      throw new Error(`AppConfig validation failed:\n${validation.errors.map(e => `  - ${e}`).join('\n')}`);
    }
    // Apply defaults and build
    const completeConfig = this.applyDefaults();
    return new AppConfig(completeConfig);
  }
  /**
   * Validate the current configuration
   */
  validate() {
    const warnings = [];
    const errors = [];
    // Required fields validation
    if (!this.config.app.name) errors.push('App name is required');
    if (!this.config.app.id) errors.push('App ID is required');
    // Copyright validation - author will be defaulted if not provided
    if (this.config.copyright.year && this.config.copyright.year !== 'auto' && (!Number.isInteger(this.config.copyright.year) || this.config.copyright.year < 1900)) {
      warnings.push('Copyright year should be "auto" or a valid year >= 1900');
    }
    // Logo file validation (warning only) - only in Node.js environment
    if (this.config.app.logo && !this.options.skipValidation && fs && path) {
      const logoPath = path.resolve(this.options.baseDir || process.cwd(), this.config.app.logo);
      if (!fs.existsSync(logoPath)) {
        warnings.push(`Logo file not found: ${this.config.app.logo} (will use default)`);
      }
    }
    // Port validation
    if (this.config.build.port !== undefined) {
      if (!Number.isInteger(this.config.build.port) || this.config.build.port < 1 || this.config.build.port > 65535) {
        errors.push('Port must be a valid integer between 1 and 65535');
      }
    }
    if (this.config.build.previewPort !== undefined) {
      if (!Number.isInteger(this.config.build.previewPort) || this.config.build.previewPort < 1 || this.config.build.previewPort > 65535) {
        errors.push('Preview port must be a valid integer between 1 and 65535');
      }
    }
    // Color validation (warnings only)
    if (this.config.pwa.themeColor && !this.isValidColor(this.config.pwa.themeColor)) {
      warnings.push(`Theme color may not be valid: ${this.config.pwa.themeColor}`);
    }
    if (this.config.pwa.backgroundColor && !this.isValidColor(this.config.pwa.backgroundColor)) {
      warnings.push(`Background color may not be valid: ${this.config.pwa.backgroundColor}`);
    }
    return {
      warnings,
      errors,
      isValid: errors.length === 0
    };
  }
  /**
   * Apply default values to configuration
   */
  applyDefaults() {
    const app = {
      id: this.config.app.id,
      name: this.config.app.name,
      shortName: this.config.app.shortName || this.config.app.name,
      description: this.config.app.description || this.config.app.name,
      version: this.config.app.version || '1.0.0',
      logo: this.config.app.logo || '/favicon.ico',
      author: this.config.app.author,
      homepage: this.config.app.homepage
    };
    const build = {
      port: this.config.build.port || 3000,
      previewPort: this.config.build.previewPort || 4173,
      outputDir: this.config.build.outputDir || 'dist',
      publicPath: this.config.build.publicPath || '/',
      base: this.config.build.base || '/'
    };
    const pwa = {
      themeColor: this.config.pwa.themeColor || '#000000',
      backgroundColor: this.config.pwa.backgroundColor || '#ffffff',
      startUrl: this.config.pwa.startUrl || '/',
      scope: this.config.pwa.scope || '/',
      display: this.config.pwa.display || 'standalone',
      orientation: this.config.pwa.orientation
    };
    const ui = {
      defaultTheme: this.config.ui.defaultTheme || 'light',
      defaultPalette: this.config.ui.defaultPalette || 'default',
      enableScaffolding: this.config.ui.enableScaffolding ?? true,
      showThemeSwitcher: this.config.ui.showThemeSwitcher ?? false,
      showPaletteSwitcher: this.config.ui.showPaletteSwitcher ?? false
    };
    const copyright = {
      year: this.config.copyright.year || 'auto',
      author: this.config.copyright.author || app.author || app.name,
      text: this.config.copyright.text
    };
    return {
      app,
      build,
      pwa,
      ui,
      copyright
    };
  }
  /**
   * Simple color validation
   */
  isValidColor(color) {
    // Basic hex color validation
    return /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(color) ||
    // Named colors (basic check)
    /^(black|white|red|green|blue|yellow|orange|purple|pink|gray|grey)$/i.test(color) ||
    // RGB/RGBA
    /^rgba?\([^)]+\)$/i.test(color);
  }
}

/**
 * QwickApps Configuration Module Entry
 *
 * Lightweight export for config-only usage at build time.
 * This file only exports configuration types and builders
 * without pulling in React or MUI dependencies.
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
const createAppConfig = AppConfigBuilder.create;

/**
 * Action Schema - Defines data structure for action buttons (Button component)
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
let ActionModel = class ActionModel extends Model {};
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Label',
  description: 'Button label text',
  placeholder: 'Enter button text...'
}), IsOptional(), IsString(), __metadata("design:type", String)], ActionModel.prototype, "label", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Variant',
  description: 'Visual style variant',
  validation: {
    options: [{
      label: 'Primary',
      value: 'primary'
    }, {
      label: 'Secondary',
      value: 'secondary'
    }, {
      label: 'Outlined',
      value: 'outlined'
    }, {
      label: 'Text',
      value: 'text'
    }, {
      label: 'Contained',
      value: 'contained'
    }]
  }
}), IsOptional(), IsIn(['primary', 'secondary', 'outlined', 'text', 'contained']), __metadata("design:type", String)], ActionModel.prototype, "variant", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Size',
  description: 'Button size',
  validation: {
    options: [{
      label: 'Small',
      value: 'small'
    }, {
      label: 'Medium',
      value: 'medium'
    }, {
      label: 'Large',
      value: 'large'
    }]
  }
}), IsOptional(), IsIn(['small', 'medium', 'large']), __metadata("design:type", String)], ActionModel.prototype, "buttonSize", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Icon',
  description: 'Icon to display (before text)',
  placeholder: 'Icon identifier...'
}), IsOptional(), IsString(), __metadata("design:type", String)], ActionModel.prototype, "icon", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'End Icon',
  description: 'Icon to display after text',
  placeholder: 'End icon identifier...'
}), IsOptional(), IsString(), __metadata("design:type", String)], ActionModel.prototype, "endIcon", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.URL,
  label: 'URL',
  description: 'Link URL - button becomes a link',
  placeholder: 'https://...'
}), IsOptional(), IsUrl(), __metadata("design:type", String)], ActionModel.prototype, "href", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Target',
  description: 'Link target (when href is provided)',
  validation: {
    options: [{
      label: 'Blank',
      value: '_blank'
    }, {
      label: 'Self',
      value: '_self'
    }, {
      label: 'Parent',
      value: '_parent'
    }, {
      label: 'Top',
      value: '_top'
    }]
  }
}), IsOptional(), IsIn(['_blank', '_self', '_parent', '_top']), __metadata("design:type", String)], ActionModel.prototype, "target", void 0);
__decorate([Field({
  defaultValue: false
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Disabled',
  description: 'Disabled state'
}), IsOptional(), __metadata("design:type", Boolean)], ActionModel.prototype, "disabled", void 0);
__decorate([Field({
  defaultValue: false
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Loading',
  description: 'Loading state - shows spinner and disables interaction'
}), IsOptional(), __metadata("design:type", Boolean)], ActionModel.prototype, "loading", void 0);
__decorate([Field({
  defaultValue: false
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Full Width',
  description: 'Full width button'
}), IsOptional(), __metadata("design:type", Boolean)], ActionModel.prototype, "fullWidth", void 0);
ActionModel = __decorate([Schema('Action', '1.0.0')], ActionModel);

/**
 * Schema for Article component - HTML content transformer
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
let ArticleModel = class ArticleModel extends Model {};
__decorate([Field(), Editor({
  field_type: FieldType.TEXTAREA,
  label: 'HTML Content',
  description: 'Raw HTML content to transform and render',
  placeholder: 'Enter HTML content...'
}), IsString(), IsOptional(), __metadata("design:type", String)], ArticleModel.prototype, "html", void 0);
__decorate([Field({
  defaultValue: false
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Skip Header',
  description: 'Skip/remove header elements before rendering'
}), IsOptional(), __metadata("design:type", Boolean)], ArticleModel.prototype, "skipHeader", void 0);
ArticleModel = __decorate([Schema('Article', '1.0.0')], ArticleModel);

/**
 * ContainerSchema - Comprehensive base class for all container components
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
let ContainerSchema = class ContainerSchema extends ViewSchema$1 {};
__decorate([Field(), Editor({
  field_type: FieldType.TEXTAREA,
  label: 'Content',
  description: 'Main content shown when expanded (HTML supported)',
  placeholder: 'Enter main content...'
}), IsOptional(), IsString(), __metadata("design:type", Object)], ContainerSchema.prototype, "children", void 0);
ContainerSchema = __decorate([Schema('ContainerSchema', '1.0.0')], ContainerSchema);

/**
 * Schema for CardListGrid component - Generic grid layout for cards
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
let CardListGridModel = class CardListGridModel extends ContainerSchema {};
__decorate([Field(), Editor({
  field_type: FieldType.REPEATER,
  label: 'Grid Items',
  description: 'Array of items to display in the grid'
}), IsArray(), __metadata("design:type", Array)], CardListGridModel.prototype, "items", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Columns',
  description: 'Number of columns in the grid layout',
  validation: {
    options: [{
      value: 1,
      label: '1 Column'
    }, {
      value: 2,
      label: '2 Columns (Default)'
    }, {
      value: 3,
      label: '3 Columns'
    }, {
      value: 4,
      label: '4 Columns'
    }, {
      value: 5,
      label: '5 Columns'
    }, {
      value: 6,
      label: '6 Columns'
    }]
  }
}), IsOptional(), IsNumber(), IsIn([1, 2, 3, 4, 5, 6]), __metadata("design:type", Number)], CardListGridModel.prototype, "columns", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Grid Spacing',
  description: 'Spacing between grid items',
  validation: {
    options: [{
      value: 'none',
      label: 'No Spacing'
    }, {
      value: 'tiny',
      label: 'Tiny'
    }, {
      value: 'small',
      label: 'Small'
    }, {
      value: 'medium',
      label: 'Medium'
    }, {
      value: 'large',
      label: 'Large (Default)'
    }, {
      value: 'huge',
      label: 'Huge'
    }]
  }
}), IsOptional(), IsIn(['none', 'tiny', 'small', 'medium', 'large', 'huge']), __metadata("design:type", String)], CardListGridModel.prototype, "spacing", void 0);
__decorate([Field({
  defaultValue: false
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Equal Height',
  description: 'Whether all cards should have equal height'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], CardListGridModel.prototype, "equalHeight", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Card Component Type',
  description: 'Type of card component to render for each item',
  validation: {
    options: [{
      value: 'ProductCard',
      label: 'Product Card'
    }, {
      value: 'FeatureCard',
      label: 'Feature Card'
    }, {
      value: 'Custom',
      label: 'Custom Component'
    }]
  }
}), IsOptional(), IsIn(['ProductCard', 'FeatureCard', 'Custom']), __metadata("design:type", String)], CardListGridModel.prototype, "renderComponent", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.FORM,
  label: 'Item Properties',
  description: 'Additional properties to pass to each rendered item'
}), IsOptional(), IsObject(), __metadata("design:type", Object)], CardListGridModel.prototype, "itemProps", void 0);
CardListGridModel = __decorate([Schema('CardListGrid', '1.0.0')], CardListGridModel);

/**
 * Schema for ChoiceInputField component - Dynamic option inputs management
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
let ChoiceInputFieldModel = class ChoiceInputFieldModel extends ViewSchema {};
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Field Label',
  description: 'Label/title for the choice input field',
  placeholder: 'Options'
}), IsOptional(), IsString(), __metadata("design:type", String)], ChoiceInputFieldModel.prototype, "label", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXTAREA,
  label: 'Options',
  description: 'Array of option values (HTML content supported) - JSON array format'
}), IsOptional(), IsArray(), IsString({
  each: true
}), __metadata("design:type", Array)], ChoiceInputFieldModel.prototype, "options", void 0);
__decorate([Field({
  defaultValue: false
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Disabled',
  description: 'Whether the input fields are disabled'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], ChoiceInputFieldModel.prototype, "disabled", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Placeholder Text',
  description: 'Placeholder text for option inputs',
  placeholder: 'Enter option text. HTML formatting supported.'
}), IsOptional(), IsString(), __metadata("design:type", String)], ChoiceInputFieldModel.prototype, "placeholder", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Option Label Prefix',
  description: 'Prefix for each option label (e.g., "Option", "Choice")',
  placeholder: 'Option'
}), IsOptional(), IsString(), __metadata("design:type", String)], ChoiceInputFieldModel.prototype, "optionLabelPrefix", void 0);
__decorate([Field({
  defaultValue: 2
}), Editor({
  field_type: FieldType.NUMBER,
  label: 'Input Rows',
  description: 'Number of rows for each option input field'
}), IsOptional(), IsNumber(), __metadata("design:type", Number)], ChoiceInputFieldModel.prototype, "rows", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Add Button Text',
  description: 'Text for the add option button',
  placeholder: 'Add Option'
}), IsOptional(), IsString(), __metadata("design:type", String)], ChoiceInputFieldModel.prototype, "addButtonText", void 0);
ChoiceInputFieldModel = __decorate([Schema('ChoiceInputField', '1.0.0')], ChoiceInputFieldModel);

/**
 * Schema for Code component - Syntax-highlighted code display
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
let CodeModel = class CodeModel extends ViewSchema$1 {};
__decorate([Field(), Editor({
  field_type: FieldType.TEXTAREA,
  label: 'Content',
  description: 'Raw code text. If provided, React children are ignored in serialization.',
  placeholder: 'Enter code content...'
}), IsOptional(), IsString(), __metadata("design:type", String)], CodeModel.prototype, "content", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Language',
  description: 'Programming language for syntax highlighting (e.g., typescript, javascript, python)',
  placeholder: 'javascript'
}), IsOptional(), IsString(), __metadata("design:type", String)], CodeModel.prototype, "language", void 0);
__decorate([Field({
  defaultValue: false
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Show Copy Button',
  description: 'Display a copy-to-clipboard button'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], CodeModel.prototype, "showCopy", void 0);
__decorate([Field({
  defaultValue: false
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Show Line Numbers',
  description: 'Display line numbers alongside the code'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], CodeModel.prototype, "showLineNumbers", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Title',
  description: 'Optional title or filename to display above the code',
  placeholder: 'File name or title'
}), IsOptional(), IsString(), __metadata("design:type", String)], CodeModel.prototype, "title", void 0);
__decorate([Field({
  defaultValue: false
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Wrap Long Lines',
  description: 'Allow long lines to wrap instead of scrolling horizontally'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], CodeModel.prototype, "wrapLines", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Background Color',
  description: 'Custom background color override',
  placeholder: '#f5f5f5'
}), IsOptional(), IsString(), __metadata("design:type", String)], CodeModel.prototype, "codeBackground", void 0);
CodeModel = __decorate([Schema('Code', '1.0.0')], CodeModel);

/**
 * Content Schema - Defines data structure and validation for Content component
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
let ContentModel = class ContentModel extends Model {};
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Title',
  description: 'Main heading for the content block',
  placeholder: 'Enter content title...'
}), IsOptional(), IsString(), __metadata("design:type", String)], ContentModel.prototype, "title", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Subtitle',
  description: 'Secondary heading or description',
  placeholder: 'Enter subtitle...'
}), IsOptional(), IsString(), __metadata("design:type", String)], ContentModel.prototype, "subtitle", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXTAREA,
  label: 'Content',
  description: 'Main content body (HTML supported)',
  placeholder: 'Enter content body...'
}), IsOptional(), IsString(), __metadata("design:type", Object)], ContentModel.prototype, "children", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.REPEATER,
  label: 'Actions',
  description: 'Array of action buttons'
}), IsOptional(), IsArray(), ValidateNested({
  each: true
}), Type(() => ActionModel), __metadata("design:type", Array)], ContentModel.prototype, "actions", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Variant',
  description: 'Background/elevation style',
  validation: {
    options: [{
      label: 'Default',
      value: 'default'
    }, {
      label: 'Elevated',
      value: 'elevated'
    }, {
      label: 'Outlined',
      value: 'outlined'
    }, {
      label: 'Filled',
      value: 'filled'
    }]
  }
}), IsOptional(), IsIn(['default', 'elevated', 'outlined', 'filled']), __metadata("design:type", String)], ContentModel.prototype, "variant", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Block Spacing',
  description: 'Content padding size',
  validation: {
    options: [{
      label: 'None',
      value: 'none'
    }, {
      label: 'Compact',
      value: 'compact'
    }, {
      label: 'Comfortable',
      value: 'comfortable'
    }, {
      label: 'Spacious',
      value: 'spacious'
    }]
  }
}), IsOptional(), IsIn(['none', 'compact', 'comfortable', 'spacious']), __metadata("design:type", String)], ContentModel.prototype, "blockSpacing", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Content Max Width',
  description: 'Maximum content width constraint',
  validation: {
    options: [{
      label: 'XS',
      value: 'xs'
    }, {
      label: 'SM',
      value: 'sm'
    }, {
      label: 'MD',
      value: 'md'
    }, {
      label: 'LG',
      value: 'lg'
    }, {
      label: 'XL',
      value: 'xl'
    }, {
      label: 'Full Width',
      value: 'false'
    }]
  }
}), IsOptional(), IsIn(['xs', 'sm', 'md', 'lg', 'xl', 'false']), __metadata("design:type", String)], ContentModel.prototype, "contentMaxWidth", void 0);
__decorate([Field({
  defaultValue: false
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Centered',
  description: 'Center align content'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], ContentModel.prototype, "centered", void 0);
ContentModel = __decorate([Schema('Content', '1.0.0')], ContentModel);

/**
 * HeaderAction Schema - Defines data structure for header action buttons
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
let HeaderActionModel = class HeaderActionModel extends Model {};
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'ID',
  description: 'Unique identifier for the action',
  placeholder: 'action-id'
}), IsString(), IsNotEmpty(), __metadata("design:type", String)], HeaderActionModel.prototype, "id", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Label',
  description: 'Display label for the action button',
  placeholder: 'Action label'
}), IsString(), __metadata("design:type", String)], HeaderActionModel.prototype, "label", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Icon',
  description: 'Icon component or JSX element',
  placeholder: 'icon-name'
}), IsOptional(), IsString(), __metadata("design:type", String)], HeaderActionModel.prototype, "icon", void 0);
__decorate([Field({
  defaultValue: false
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Disabled',
  description: 'Whether this action is disabled'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], HeaderActionModel.prototype, "disabled", void 0);
__decorate([Field({
  defaultValue: false
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Destructive',
  description: 'Whether this action is destructive (shows with warning styling)'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], HeaderActionModel.prototype, "destructive", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.NUMBER,
  label: 'Priority',
  description: 'Priority for ordering (lower numbers = higher priority)',
  validation: {
    min: 1,
    max: 100
  }
}), IsOptional(), IsNumber(), Min(1), Max(100), __metadata("design:type", Number)], HeaderActionModel.prototype, "priority", void 0);
HeaderActionModel = __decorate([Schema('HeaderAction', '1.0.0')], HeaderActionModel);

/**
 * CoverImageHeader Schema - Defines data structure and validation for CoverImageHeader component
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
let CoverImageHeaderModel = class CoverImageHeaderModel extends Model {};
__decorate([Field(), Editor({
  field_type: FieldType.IMAGE,
  label: 'Image',
  description: 'Image URL or component',
  placeholder: 'Upload image'
}), IsOptional(), IsString(), __metadata("design:type", String)], CoverImageHeaderModel.prototype, "image", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Image Alt Text',
  description: 'Alternative text for image',
  placeholder: 'Descriptive alt text...'
}), IsOptional(), IsString(), __metadata("design:type", String)], CoverImageHeaderModel.prototype, "imageAlt", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Image Size',
  description: 'Size of the image',
  validation: {
    options: [{
      label: 'Small',
      value: 'small'
    }, {
      label: 'Medium',
      value: 'medium'
    }, {
      label: 'Large',
      value: 'large'
    }]
  }
}), IsOptional(), IsIn(['small', 'medium', 'large']), __metadata("design:type", String)], CoverImageHeaderModel.prototype, "imageSize", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Image Shape',
  description: 'Shape of the image',
  validation: {
    options: [{
      label: 'Square',
      value: 'square'
    }, {
      label: 'Circle',
      value: 'circle'
    }, {
      label: 'Rounded',
      value: 'rounded'
    }]
  }
}), IsOptional(), IsIn(['square', 'circle', 'rounded']), __metadata("design:type", String)], CoverImageHeaderModel.prototype, "imageShape", void 0);
__decorate([Field({
  defaultValue: 'transparent'
}), Editor({
  field_type: FieldType.COLOR,
  label: 'Image Background',
  description: 'Image background color',
  placeholder: 'Pick a color for the image background'
}), IsOptional(), IsString(), __metadata("design:type", String)], CoverImageHeaderModel.prototype, "imageBackgroundColor", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Overline',
  description: 'Small text above the main title',
  placeholder: 'Overline text'
}), IsOptional(), IsString(), __metadata("design:type", String)], CoverImageHeaderModel.prototype, "overline", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Title',
  description: 'Main heading/title text',
  placeholder: 'Enter title...'
}), IsString(), __metadata("design:type", String)], CoverImageHeaderModel.prototype, "title", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Subtitle',
  description: 'Secondary text below the title',
  placeholder: 'Enter subtitle...'
}), IsOptional(), IsString(), __metadata("design:type", String)], CoverImageHeaderModel.prototype, "subtitle", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.REPEATER,
  label: 'Tags',
  description: 'Array of tag strings'
}), IsOptional(), IsArray(), IsString({
  each: true
}), __metadata("design:type", Array)], CoverImageHeaderModel.prototype, "tags", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.REPEATER,
  label: 'Actions',
  description: 'Array of header action buttons'
}), IsOptional(), IsArray(), ValidateNested({
  each: true
}), Type(() => HeaderActionModel), __metadata("design:type", Array)], CoverImageHeaderModel.prototype, "actions", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.NUMBER,
  label: 'Max Visible Actions',
  description: 'Maximum visible actions before overflow',
  validation: {
    min: 1,
    max: 10
  }
}), IsOptional(), IsNumber(), Min(1), Max(10), __metadata("design:type", Number)], CoverImageHeaderModel.prototype, "maxVisibleActions", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'CSS Class',
  description: 'Additional CSS class name',
  placeholder: 'custom-class'
}), IsOptional(), IsString(), __metadata("design:type", String)], CoverImageHeaderModel.prototype, "className", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Header Variant',
  description: 'Style variant for the header',
  validation: {
    options: [{
      label: 'Default',
      value: 'default'
    }, {
      label: 'Compact',
      value: 'compact'
    }, {
      label: 'Prominent',
      value: 'prominent'
    }]
  }
}), IsOptional(), IsIn(['default', 'compact', 'prominent']), __metadata("design:type", String)], CoverImageHeaderModel.prototype, "variant", void 0);
__decorate([Field({
  defaultValue: '--var(--theme-primary)'
}), Editor({
  field_type: FieldType.TEXT,
  label: 'Background',
  description: 'Background color or image URL',
  placeholder: 'Pick a color for the background or enter a image URL'
}), IsOptional(), IsString(), __metadata("design:type", String)], CoverImageHeaderModel.prototype, "background", void 0);
__decorate([Field({
  defaultValue: '--var(--theme-on-primary)'
}), Editor({
  field_type: FieldType.COLOR,
  label: 'Color',
  description: 'Foreground color',
  placeholder: '#000000'
}), IsOptional(), IsString(), __metadata("design:type", String)], CoverImageHeaderModel.prototype, "color", void 0);
CoverImageHeaderModel = __decorate([Schema('CoverImageHeader', '1.0.0')], CoverImageHeaderModel);

/**
 * FeatureItem Schema - Defines data structure for individual feature items
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
let FeatureItemModel = class FeatureItemModel extends Model {};
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'ID',
  description: 'Unique identifier for the feature item',
  placeholder: 'feature-id'
}), IsString(), IsNotEmpty(), __metadata("design:type", String)], FeatureItemModel.prototype, "id", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Icon',
  description: 'Feature icon (emoji or icon name)',
  placeholder: '🚀 or icon-name'
}), IsOptional(), IsString(), __metadata("design:type", String)], FeatureItemModel.prototype, "icon", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Title',
  description: 'Feature title',
  placeholder: 'Feature title...'
}), IsString(), __metadata("design:type", String)], FeatureItemModel.prototype, "title", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Description',
  description: 'Feature description',
  placeholder: 'Feature description...'
}), IsString(), __metadata("design:type", String)], FeatureItemModel.prototype, "description", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Action',
  description: 'Optional action/link text or content',
  placeholder: 'Learn more'
}), IsOptional(), IsString(), __metadata("design:type", String)], FeatureItemModel.prototype, "action", void 0);
FeatureItemModel = __decorate([Schema('FeatureItem', '1.0.0')], FeatureItemModel);

/**
 * FeatureCard Schema - Schema definition for FeatureCard component
 *
 * Defines the data structure and form editors for the FeatureCard component
 * using the declarative Model pattern with decorators.
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
let FeatureCardActionModel = class FeatureCardActionModel extends Model {};
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Action ID',
  description: 'Unique identifier for the action',
  placeholder: 'action-1'
}), IsString(), IsNotEmpty(), __metadata("design:type", String)], FeatureCardActionModel.prototype, "id", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Label',
  description: 'Action button label',
  placeholder: 'Button text...'
}), IsString(), __metadata("design:type", String)], FeatureCardActionModel.prototype, "label", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Style',
  description: 'Button style variant',
  validation: {
    options: [{
      label: 'Contained',
      value: 'contained'
    }, {
      label: 'Outlined',
      value: 'outlined'
    }, {
      label: 'Text',
      value: 'text'
    }]
  }
}), IsOptional(), IsIn(['contained', 'outlined', 'text']), __metadata("design:type", String)], FeatureCardActionModel.prototype, "variant", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Color',
  description: 'Button color theme',
  validation: {
    options: [{
      label: 'Primary',
      value: 'primary'
    }, {
      label: 'Secondary',
      value: 'secondary'
    }, {
      label: 'Error',
      value: 'error'
    }]
  }
}), IsOptional(), IsIn(['primary', 'secondary', 'error']), __metadata("design:type", String)], FeatureCardActionModel.prototype, "color", void 0);
__decorate([Field({
  defaultValue: false
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Disabled',
  description: 'Disabled state'
}), IsOptional(), __metadata("design:type", Boolean)], FeatureCardActionModel.prototype, "disabled", void 0);
FeatureCardActionModel = __decorate([Schema('FeatureCardAction', '1.0.0')], FeatureCardActionModel);
let FeatureCardModel = class FeatureCardModel extends Model {};
__decorate([Field({
  type: DataType.OBJECT
}), Editor({
  field_type: FieldType.FORM,
  label: 'Feature Data',
  description: 'Single feature item to display'
}), IsOptional(), ValidateNested(), Type(() => FeatureItemModel), __metadata("design:type", FeatureItemModel)], FeatureCardModel.prototype, "feature", void 0);
__decorate([Field({
  type: DataType.ARRAY
}), Editor({
  field_type: FieldType.REPEATER,
  label: 'Features List',
  description: 'List of feature strings for list variant'
}), IsOptional(), IsArray(), IsString({
  each: true
}), __metadata("design:type", Array)], FeatureCardModel.prototype, "features", void 0);
__decorate([Field({
  defaultValue: 'standard'
}), Editor({
  field_type: FieldType.SELECT,
  label: 'Card Type',
  description: 'Display variant for the feature card',
  validation: {
    options: [{
      label: 'Standard',
      value: 'standard'
    }, {
      label: 'List',
      value: 'list'
    }]
  }
}), IsOptional(), IsIn(['standard', 'list']), __metadata("design:type", String)], FeatureCardModel.prototype, "variant", void 0);
__decorate([Field({
  type: DataType.ARRAY
}), Editor({
  field_type: FieldType.REPEATER,
  label: 'Actions',
  description: 'Custom action buttons'
}), IsOptional(), IsArray(), ValidateNested({
  each: true
}), Type(() => FeatureCardActionModel), __metadata("design:type", Array)], FeatureCardModel.prototype, "actions", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Title',
  description: 'Title for list variant',
  placeholder: 'Enter card title...'
}), IsOptional(), IsString(), __metadata("design:type", String)], FeatureCardModel.prototype, "title", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.NUMBER,
  label: 'Elevation',
  description: 'Card elevation (0-24)',
  validation: {
    min: 0,
    max: 24
  }
}), IsOptional(), IsNumber(), Min(0), Max(24), __metadata("design:type", Number)], FeatureCardModel.prototype, "elevation", void 0);
FeatureCardModel = __decorate([Schema('FeatureCard', '1.0.0')], FeatureCardModel);

/**
 * FeatureGrid Schema - Defines data structure and validation for FeatureGrid component
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
let FeatureGridModel = class FeatureGridModel extends Model {};
__decorate([Field(), Editor({
  field_type: FieldType.REPEATER,
  label: 'Features',
  description: 'Array of feature items'
}), IsArray(), ValidateNested({
  each: true
}), Type(() => FeatureItemModel), __metadata("design:type", Array)], FeatureGridModel.prototype, "features", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Columns',
  description: 'Number of columns in the grid',
  validation: {
    options: [{
      label: '1 Column',
      value: 1
    }, {
      label: '2 Columns',
      value: 2
    }, {
      label: '3 Columns',
      value: 3
    }, {
      label: '4 Columns',
      value: 4
    }, {
      label: '5 Columns',
      value: 5
    }, {
      label: '6 Columns',
      value: 6
    }]
  }
}), IsOptional(), IsNumber(), IsIn([1, 2, 3, 4, 5, 6]), __metadata("design:type", Number)], FeatureGridModel.prototype, "columns", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Gap',
  description: 'Grid gap size',
  validation: {
    options: [{
      label: 'Small',
      value: 'small'
    }, {
      label: 'Medium',
      value: 'medium'
    }, {
      label: 'Large',
      value: 'large'
    }]
  }
}), IsOptional(), IsIn(['small', 'medium', 'large']), __metadata("design:type", String)], FeatureGridModel.prototype, "gap", void 0);
__decorate([Field({
  defaultValue: false
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Equal Height',
  description: 'Whether all grid items should have equal height'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], FeatureGridModel.prototype, "equalHeight", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'CSS Class',
  description: 'Additional CSS class name',
  placeholder: 'custom-class'
}), IsOptional(), IsString(), __metadata("design:type", String)], FeatureGridModel.prototype, "className", void 0);
FeatureGridModel = __decorate([Schema('FeatureGrid', '1.0.0')], FeatureGridModel);

/**
 * FooterItem Schema - Defines data structure for footer navigation items
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
let FooterItemModel = class FooterItemModel extends Model {};
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'ID',
  description: 'Unique identifier for the footer item',
  placeholder: 'footer-item-id'
}), IsString(), IsNotEmpty(), __metadata("design:type", String)], FooterItemModel.prototype, "id", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Label',
  description: 'Display text for the footer item',
  placeholder: 'Navigation label'
}), IsString(), __metadata("design:type", String)], FooterItemModel.prototype, "label", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.URL,
  label: 'URL',
  description: 'Optional URL for links',
  placeholder: 'https://example.com'
}), IsOptional(), IsString(), __metadata("design:type", String)], FooterItemModel.prototype, "href", void 0);
__decorate([Field({
  defaultValue: false
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'External Link',
  description: 'Whether to open links in new tab'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], FooterItemModel.prototype, "external", void 0);
FooterItemModel = __decorate([Schema('FooterItem', '1.0.0')], FooterItemModel);

/**
 * Schema for FormBlock component - Reusable form layout container
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
let FormBlockModel = class FormBlockModel extends ContainerSchema {};
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Title',
  description: 'Title for the default header (ignored if custom header is provided)',
  placeholder: 'Enter form title...'
}), IsOptional(), IsString(), __metadata("design:type", String)], FormBlockModel.prototype, "title", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXTAREA,
  label: 'Description',
  description: 'Description/subtitle for the default header (ignored if custom header is provided)',
  placeholder: 'Enter form description...'
}), IsOptional(), IsString(), __metadata("design:type", String)], FormBlockModel.prototype, "description", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Cover Image URL',
  description: 'Cover image URL for the default header (ignored if custom header is provided)',
  placeholder: 'https://example.com/image.jpg'
}), IsOptional(), IsString(), __metadata("design:type", Object)], FormBlockModel.prototype, "coverImage", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Status Type',
  description: 'Status type for message display (info, success, warning, error)',
  placeholder: 'info'
}), IsOptional(), IsIn(['info', 'success', 'warning', 'error']), __metadata("design:type", String)], FormBlockModel.prototype, "status", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXTAREA,
  label: 'Status Message',
  description: 'Status message to display',
  placeholder: 'Enter status message...'
}), IsOptional(), IsString(), __metadata("design:type", String)], FormBlockModel.prototype, "message", void 0);
__decorate([Field({
  defaultValue: 'sm'
}), Editor({
  field_type: FieldType.TEXT,
  label: 'Maximum Width',
  description: 'Maximum width of the form container (xs, sm, md)',
  placeholder: 'sm'
}), IsOptional(), IsIn(['xs', 'sm', 'md']), __metadata("design:type", String)], FormBlockModel.prototype, "maxWidth", void 0);
__decorate([Field({
  defaultValue: 'default'
}), Editor({
  field_type: FieldType.TEXT,
  label: 'Background Style',
  description: 'Background style variant (default, gradient, image)',
  placeholder: 'default'
}), IsOptional(), IsIn(['default', 'gradient', 'image']), __metadata("design:type", String)], FormBlockModel.prototype, "background", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Background Image URL',
  description: 'Background image URL (when background="image")',
  placeholder: 'https://example.com/background.jpg'
}), IsOptional(), IsString(), __metadata("design:type", String)], FormBlockModel.prototype, "backgroundImage", void 0);
FormBlockModel = __decorate([Schema('FormBlock', '1.0.0')], FormBlockModel);

/**
 * Schema for FormSelect component - Themed dropdown select input
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
let FormSelectModel = class FormSelectModel extends ViewSchema$1 {};
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Label',
  description: 'Label text for the select field',
  placeholder: 'Enter label...'
}), IsOptional(), IsString(), __metadata("design:type", String)], FormSelectModel.prototype, "label", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Value',
  description: 'Current selected value',
  placeholder: ''
}), IsString(), __metadata("design:type", Object)], FormSelectModel.prototype, "value", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXTAREA,
  label: 'Options',
  description: 'Select options as JSON array: [{"value": "1", "label": "Option 1"}]',
  placeholder: '[{"value": "1", "label": "Option 1"}]'
}), IsString(), __metadata("design:type", String)], FormSelectModel.prototype, "options", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Helper Text',
  description: 'Helper text displayed below the select',
  placeholder: 'Enter helper text...'
}), IsOptional(), IsString(), __metadata("design:type", String)], FormSelectModel.prototype, "helperText", void 0);
__decorate([Field({
  defaultValue: false
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Required',
  description: 'Mark field as required'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], FormSelectModel.prototype, "required", void 0);
__decorate([Field({
  defaultValue: false
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Disabled',
  description: 'Disable the select field'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], FormSelectModel.prototype, "disabled", void 0);
__decorate([Field({
  defaultValue: true
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Full Width',
  description: 'Make select take full width of container'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], FormSelectModel.prototype, "fullWidth", void 0);
__decorate([Field({
  defaultValue: 'small'
}), Editor({
  field_type: FieldType.SELECT,
  label: 'Size',
  description: 'Size variant of the select field'
}), IsOptional(), IsIn(['small', 'medium']), __metadata("design:type", String)], FormSelectModel.prototype, "size", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Placeholder',
  description: 'Placeholder text when no value is selected',
  placeholder: 'Select an option...'
}), IsOptional(), IsString(), __metadata("design:type", String)], FormSelectModel.prototype, "placeholder", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Name',
  description: 'Name attribute for the select (for forms and accessibility)',
  placeholder: 'Enter name...'
}), IsOptional(), IsString(), __metadata("design:type", String)], FormSelectModel.prototype, "name", void 0);
FormSelectModel = __decorate([Schema('FormSelect', '1.0.0')], FormSelectModel);

/**
 * Schema for FormField component - Themed text/number input field
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
let FormFieldModel = class FormFieldModel extends ViewSchema$1 {};
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Label',
  description: 'Label text for the input field',
  placeholder: 'Enter label...'
}), IsString(), __metadata("design:type", String)], FormFieldModel.prototype, "label", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Value',
  description: 'Current input value',
  placeholder: ''
}), IsString(), __metadata("design:type", Object)], FormFieldModel.prototype, "value", void 0);
__decorate([Field({
  defaultValue: 'text'
}), Editor({
  field_type: FieldType.SELECT,
  label: 'Input Type',
  description: 'Type of input field'
}), IsOptional(), IsIn(['text', 'number', 'password', 'email', 'tel']), __metadata("design:type", String)], FormFieldModel.prototype, "type", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Helper Text',
  description: 'Helper text displayed below the input',
  placeholder: 'Enter helper text...'
}), IsOptional(), IsString(), __metadata("design:type", String)], FormFieldModel.prototype, "helperText", void 0);
__decorate([Field({
  defaultValue: false
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Required',
  description: 'Mark field as required'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], FormFieldModel.prototype, "required", void 0);
__decorate([Field({
  defaultValue: false
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Read Only',
  description: 'Make field read-only'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], FormFieldModel.prototype, "readOnly", void 0);
__decorate([Field({
  defaultValue: false
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Disabled',
  description: 'Disable the input field'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], FormFieldModel.prototype, "disabled", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Disabled Color',
  description: 'Custom color for disabled state (CSS color value)',
  placeholder: 'var(--theme-text-disabled)'
}), IsOptional(), IsString(), __metadata("design:type", String)], FormFieldModel.prototype, "disabledColor", void 0);
__decorate([Field({
  defaultValue: true
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Full Width',
  description: 'Make input take full width of container'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], FormFieldModel.prototype, "fullWidth", void 0);
__decorate([Field({
  defaultValue: false
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Multiline',
  description: 'Enable multiline textarea mode'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], FormFieldModel.prototype, "multiline", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Rows',
  description: 'Number of rows for multiline textarea',
  placeholder: '4'
}), IsOptional(), IsInt(), Min(1), __metadata("design:type", Number)], FormFieldModel.prototype, "rows", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Placeholder',
  description: 'Placeholder text',
  placeholder: 'Enter text...'
}), IsOptional(), IsString(), __metadata("design:type", String)], FormFieldModel.prototype, "placeholder", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Name',
  description: 'Name attribute for the input (for forms and accessibility)',
  placeholder: 'Enter name...'
}), IsOptional(), IsString(), __metadata("design:type", String)], FormFieldModel.prototype, "name", void 0);
FormFieldModel = __decorate([Schema('FormField', '1.0.0')], FormFieldModel);

/**
 * Schema for FormCheckbox component - Themed checkbox input
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
let FormCheckboxModel = class FormCheckboxModel extends ViewSchema$1 {};
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Label',
  description: 'Label text for the checkbox',
  placeholder: 'Enter label...'
}), IsString(), __metadata("design:type", String)], FormCheckboxModel.prototype, "label", void 0);
__decorate([Field({
  defaultValue: false
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Checked',
  description: 'Checkbox checked state'
}), IsBoolean(), __metadata("design:type", Boolean)], FormCheckboxModel.prototype, "checked", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Helper Text',
  description: 'Helper text displayed below the checkbox',
  placeholder: 'Enter helper text...'
}), IsOptional(), IsString(), __metadata("design:type", String)], FormCheckboxModel.prototype, "helperText", void 0);
__decorate([Field({
  defaultValue: false
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Required',
  description: 'Mark checkbox as required'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], FormCheckboxModel.prototype, "required", void 0);
__decorate([Field({
  defaultValue: false
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Disabled',
  description: 'Disable the checkbox'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], FormCheckboxModel.prototype, "disabled", void 0);
FormCheckboxModel = __decorate([Schema('FormCheckbox', '1.0.0')], FormCheckboxModel);

/**
 * Schema for Captcha component - Universal CAPTCHA widget
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
let CaptchaModel = class CaptchaModel extends ViewSchema$1 {};
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'CAPTCHA Provider',
  description: 'Which CAPTCHA service to use'
}), IsIn(['recaptcha-v2', 'recaptcha-v3', 'hcaptcha', 'turnstile']), __metadata("design:type", String)], CaptchaModel.prototype, "provider", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Site Key',
  description: 'Public site key from CAPTCHA provider',
  placeholder: 'Enter site key...'
}), IsString(), __metadata("design:type", String)], CaptchaModel.prototype, "siteKey", void 0);
__decorate([Field({
  defaultValue: 'light'
}), Editor({
  field_type: FieldType.SELECT,
  label: 'Theme',
  description: 'CAPTCHA widget theme'
}), IsOptional(), IsIn(['light', 'dark']), __metadata("design:type", String)], CaptchaModel.prototype, "theme", void 0);
__decorate([Field({
  defaultValue: 'normal'
}), Editor({
  field_type: FieldType.SELECT,
  label: 'Size',
  description: 'CAPTCHA widget size'
}), IsOptional(), IsIn(['normal', 'compact', 'invisible']), __metadata("design:type", String)], CaptchaModel.prototype, "size", void 0);
__decorate([Field({
  defaultValue: 'submit'
}), Editor({
  field_type: FieldType.TEXT,
  label: 'Action',
  description: 'reCAPTCHA v3 action name',
  placeholder: 'submit'
}), IsOptional(), IsString(), __metadata("design:type", String)], CaptchaModel.prototype, "action", void 0);
CaptchaModel = __decorate([Schema('Captcha', '1.0.0')], CaptchaModel);

/**
 * FooterSection Schema - Defines data structure for footer sections
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
let FooterSectionModel = class FooterSectionModel extends Model {};
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'ID',
  description: 'Unique identifier for the footer section',
  placeholder: 'footer-section-id'
}), IsString(), IsNotEmpty(), __metadata("design:type", String)], FooterSectionModel.prototype, "id", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Title',
  description: 'Section title/heading',
  placeholder: 'Section title'
}), IsOptional(), IsString(), __metadata("design:type", String)], FooterSectionModel.prototype, "title", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.REPEATER,
  label: 'Items',
  description: 'Array of items in this section'
}), IsArray(), ValidateNested({
  each: true
}), Type(() => FooterItemModel), __metadata("design:type", Array)], FooterSectionModel.prototype, "items", void 0);
FooterSectionModel = __decorate([Schema('FooterSection', '1.0.0')], FooterSectionModel);

/**
 * Footer Schema - Defines data structure and validation for Footer component
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
let FooterModel = class FooterModel extends Model {};
__decorate([Field(), Editor({
  field_type: FieldType.REPEATER,
  label: 'Sections',
  description: 'Footer sections with navigation items'
}), IsOptional(), IsArray(), ValidateNested({
  each: true
}), Type(() => FooterSectionModel), __metadata("design:type", Array)], FooterModel.prototype, "sections", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Logo',
  description: 'Optional logo or branding element (HTML or text)',
  placeholder: 'Company Logo or HTML'
}), IsOptional(), IsString(), __metadata("design:type", String)], FooterModel.prototype, "logo", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Copyright',
  description: 'Copyright text',
  placeholder: '© 2025 Company Name'
}), IsOptional(), IsString(), __metadata("design:type", String)], FooterModel.prototype, "copyright", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Legal Text',
  description: 'Additional legal or info text',
  placeholder: 'All rights reserved.'
}), IsOptional(), IsString(), __metadata("design:type", String)], FooterModel.prototype, "legalText", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Orientation',
  description: 'Layout orientation',
  validation: {
    options: [{
      label: 'Vertical',
      value: 'vertical'
    }, {
      label: 'Horizontal',
      value: 'horizontal'
    }]
  }
}), IsOptional(), IsIn(['vertical', 'horizontal']), __metadata("design:type", String)], FooterModel.prototype, "orientation", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Variant',
  description: 'Background variant',
  validation: {
    options: [{
      label: 'Default',
      value: 'default'
    }, {
      label: 'Contained',
      value: 'contained'
    }, {
      label: 'Outlined',
      value: 'outlined'
    }]
  }
}), IsOptional(), IsIn(['default', 'contained', 'outlined']), __metadata("design:type", String)], FooterModel.prototype, "variant", void 0);
__decorate([Field({
  defaultValue: false
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Show Divider',
  description: 'Whether to show divider above footer'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], FooterModel.prototype, "showDivider", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'CSS Class',
  description: 'Additional CSS class name',
  placeholder: 'custom-footer-class'
}), IsOptional(), IsString(), __metadata("design:type", String)], FooterModel.prototype, "className", void 0);
FooterModel = __decorate([Schema('Footer', '1.0.0')], FooterModel);

/**
 * Schema for GridCell component - Grid layout cell wrapper
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
let GridCellModel = class GridCellModel extends ContainerSchema {};
__decorate([Field(), Editor({
  field_type: FieldType.NUMBER,
  label: 'Span',
  description: 'Number of columns to span (1-12)',
  placeholder: '12'
}), IsOptional(), IsNumber(), IsIn([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]), __metadata("design:type", Number)], GridCellModel.prototype, "span", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.NUMBER,
  label: 'XS (Mobile)',
  description: 'Columns on extra small screens (1-12)',
  placeholder: '12'
}), IsOptional(), IsNumber(), IsIn([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]), __metadata("design:type", Number)], GridCellModel.prototype, "xs", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.NUMBER,
  label: 'SM (Tablet)',
  description: 'Columns on small screens (1-12)',
  placeholder: '6'
}), IsOptional(), IsNumber(), IsIn([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]), __metadata("design:type", Number)], GridCellModel.prototype, "sm", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.NUMBER,
  label: 'MD (Desktop)',
  description: 'Columns on medium screens (1-12)',
  placeholder: '4'
}), IsOptional(), IsNumber(), IsIn([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]), __metadata("design:type", Number)], GridCellModel.prototype, "md", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.NUMBER,
  label: 'LG (Large Desktop)',
  description: 'Columns on large screens (1-12)',
  placeholder: '3'
}), IsOptional(), IsNumber(), IsIn([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]), __metadata("design:type", Number)], GridCellModel.prototype, "lg", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.NUMBER,
  label: 'XL (Extra Large)',
  description: 'Columns on extra large screens (1-12)',
  placeholder: '2'
}), IsOptional(), IsNumber(), IsIn([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]), __metadata("design:type", Number)], GridCellModel.prototype, "xl", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Background',
  description: 'Background color or theme color (e.g., "primary.main", "#ffffff")',
  placeholder: 'transparent'
}), IsOptional(), IsString(), __metadata("design:type", String)], GridCellModel.prototype, "background", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Padding',
  description: 'Internal spacing (e.g., "medium", "16px", "1rem")',
  placeholder: 'medium'
}), IsOptional(), IsString(), __metadata("design:type", String)], GridCellModel.prototype, "padding", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Margin',
  description: 'External spacing (e.g., "small", "8px", "0.5rem")',
  placeholder: '0'
}), IsOptional(), IsString(), __metadata("design:type", String)], GridCellModel.prototype, "margin", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Height',
  description: 'Cell height (e.g., "200px", "medium")',
  placeholder: 'auto'
}), IsOptional(), IsString(), __metadata("design:type", String)], GridCellModel.prototype, "height", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Width',
  description: 'Cell width (e.g., "100%", "300px")',
  placeholder: '100%'
}), IsOptional(), IsString(), __metadata("design:type", String)], GridCellModel.prototype, "width", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'CSS Class',
  description: 'Additional CSS class names',
  placeholder: 'custom-cell-class'
}), IsOptional(), IsString(), __metadata("design:type", String)], GridCellModel.prototype, "className", void 0);
GridCellModel = __decorate([Schema('GridCell', '1.0.0')], GridCellModel);

/**
 * Schema for GridLayout component - Flexible grid layout
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
let GridLayoutModel = class GridLayoutModel extends ContainerSchema {};
__decorate([Field(), Editor({
  field_type: FieldType.NUMBER,
  label: 'Columns',
  description: 'Number of equal-width columns for auto-distribution'
}), IsOptional(), IsNumber(), Min(1), __metadata("design:type", Number)], GridLayoutModel.prototype, "columns", void 0);
__decorate([Field({
  defaultValue: 'small'
}), Editor({
  field_type: FieldType.SELECT,
  label: 'Spacing',
  description: 'Spacing between grid items'
}), IsOptional(), IsString(), IsIn(['tiny', 'small', 'medium', 'large', 'huge']), __metadata("design:type", String)], GridLayoutModel.prototype, "spacing", void 0);
__decorate([Field({
  defaultValue: false
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Equal Height',
  description: 'Make all grid items the same height'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], GridLayoutModel.prototype, "equalHeight", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Height',
  description: 'Grid container height (e.g., "400px", "50vh", "medium")',
  placeholder: 'auto'
}), IsOptional(), IsString(), __metadata("design:type", String)], GridLayoutModel.prototype, "height", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Width',
  description: 'Grid container width (e.g., "100%", "800px", "large")',
  placeholder: '100%'
}), IsOptional(), IsString(), __metadata("design:type", String)], GridLayoutModel.prototype, "width", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Min Height',
  description: 'Minimum grid container height',
  placeholder: 'auto'
}), IsOptional(), IsString(), __metadata("design:type", String)], GridLayoutModel.prototype, "minHeight", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Min Width',
  description: 'Minimum grid container width',
  placeholder: 'auto'
}), IsOptional(), IsString(), __metadata("design:type", String)], GridLayoutModel.prototype, "minWidth", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Max Height',
  description: 'Maximum grid container height',
  placeholder: 'none'
}), IsOptional(), IsString(), __metadata("design:type", String)], GridLayoutModel.prototype, "maxHeight", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Max Width',
  description: 'Maximum grid container width',
  placeholder: 'none'
}), IsOptional(), IsString(), __metadata("design:type", String)], GridLayoutModel.prototype, "maxWidth", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'CSS Class',
  description: 'Additional CSS class names',
  placeholder: 'custom-grid-class'
}), IsOptional(), IsString(), __metadata("design:type", String)], GridLayoutModel.prototype, "className", void 0);
GridLayoutModel = __decorate([Schema('GridLayout', '1.0.0')], GridLayoutModel);

/**
 * HeroBlock Schema - Defines data structure and validation for HeroBlock component
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
let HeroBlockModel = class HeroBlockModel extends ContainerSchema {};
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Title',
  description: 'Main headline text',
  placeholder: 'Enter hero title...'
}), IsString(), __metadata("design:type", String)], HeroBlockModel.prototype, "title", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Subtitle',
  description: 'Subtitle or description text',
  placeholder: 'Enter subtitle...'
}), IsOptional(), IsString(), __metadata("design:type", String)], HeroBlockModel.prototype, "subtitle", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.IMAGE,
  label: 'Background Image',
  description: 'Background image URL',
  placeholder: 'https://...'
}), IsOptional(), IsUrl(), __metadata("design:type", String)], HeroBlockModel.prototype, "backgroundImage", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Background Gradient',
  description: 'Background gradient CSS value',
  placeholder: 'linear-gradient(...)'
}), IsOptional(), IsString(), __metadata("design:type", String)], HeroBlockModel.prototype, "backgroundGradient", void 0);
__decorate([Field({
  defaultValue: 'default'
}), Editor({
  field_type: FieldType.SELECT,
  label: 'Background Color',
  description: 'Background color theme variant',
  validation: {
    options: [{
      label: 'Default',
      value: 'default'
    }, {
      label: 'Primary',
      value: 'primary'
    }, {
      label: 'Secondary',
      value: 'secondary'
    }, {
      label: 'Surface',
      value: 'surface'
    }]
  }
}), IsOptional(), IsIn(['default', 'primary', 'secondary', 'surface']), __metadata("design:type", String)], HeroBlockModel.prototype, "backgroundColor", void 0);
__decorate([Field({
  type: DataType.ARRAY
}), Editor({
  field_type: FieldType.REPEATER,
  label: 'Actions',
  description: 'Action buttons for the hero section'
}), IsOptional(), IsArray(), ValidateNested({
  each: true
}), Type(() => ActionModel), __metadata("design:type", Array)], HeroBlockModel.prototype, "actions", void 0);
__decorate([Field({
  defaultValue: 'center'
}), Editor({
  field_type: FieldType.SELECT,
  label: 'Text Alignment',
  description: 'Text alignment',
  validation: {
    options: [{
      label: 'Left',
      value: 'left'
    }, {
      label: 'Center',
      value: 'center'
    }, {
      label: 'Right',
      value: 'right'
    }]
  }
}), IsOptional(), IsIn(['left', 'center', 'right']), __metadata("design:type", String)], HeroBlockModel.prototype, "textAlign", void 0);
__decorate([Field({
  defaultValue: 'medium'
}), Editor({
  field_type: FieldType.SELECT,
  label: 'Block Height',
  description: 'Block height preset',
  validation: {
    options: [{
      label: 'Small',
      value: 'small'
    }, {
      label: 'Medium',
      value: 'medium'
    }, {
      label: 'Large',
      value: 'large'
    }, {
      label: 'Viewport',
      value: 'viewport'
    }]
  }
}), IsOptional(), IsIn(['small', 'medium', 'large', 'viewport']), __metadata("design:type", String)], HeroBlockModel.prototype, "blockHeight", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.NUMBER,
  label: 'Overlay Opacity',
  description: 'Custom overlay opacity (0-1) when using background images',
  validation: {
    min: 0,
    max: 1
  }
}), IsOptional(), IsNumber(), Min(0), Max(1), __metadata("design:type", Number)], HeroBlockModel.prototype, "overlayOpacity", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'CSS Class',
  description: 'Additional CSS class name',
  placeholder: 'custom-hero-class'
}), IsOptional(), IsString(), __metadata("design:type", String)], HeroBlockModel.prototype, "className", void 0);
HeroBlockModel = __decorate([Schema('HeroBlock', '1.0.0')], HeroBlockModel);

/**
 * Schema for Html component - Transforms HTML strings into Framework components
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
let HtmlModel = class HtmlModel extends Model {};
__decorate([Field(), Editor({
  field_type: FieldType.TEXTAREA,
  label: 'HTML Content',
  description: 'HTML content to be transformed into React components',
  placeholder: '<p>Enter HTML content...</p>'
}), IsOptional(), IsString(), __metadata("design:type", String)], HtmlModel.prototype, "children", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.CHECKBOX,
  label: 'Strip Headers',
  description: 'Whether to remove header elements (h1-h6) from the HTML'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], HtmlModel.prototype, "stripHeaders", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Placeholder',
  description: 'Fallback content to display when HTML is empty',
  placeholder: 'No content available'
}), IsOptional(), IsString(), __metadata("design:type", String)], HtmlModel.prototype, "placeholder", void 0);
HtmlModel = __decorate([Schema('Html', '1.0.0')], HtmlModel);

/**
 * Schema for Image component - Comprehensive image display component
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
let ImageModel = class ImageModel extends ViewSchema {};
__decorate([Field({
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.IMAGE,
  label: 'Image Source',
  description: 'Image source URL or path',
  placeholder: 'https://example.com/image.jpg'
}), IsOptional(), IsString(), __metadata("design:type", String)], ImageModel.prototype, "src", void 0);
__decorate([Field({
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.TEXT,
  label: 'Alt Text',
  description: 'Alternative text for accessibility (required for images with src)',
  placeholder: 'Describe the image for screen readers'
}), IsOptional(), IsString(), __metadata("design:type", String)], ImageModel.prototype, "alt", void 0);
__decorate([Field({
  dataType: DataType.NUMBER
}), Editor({
  field_type: FieldType.NUMBER,
  label: 'Width',
  description: 'Image width in pixels (optional)',
  placeholder: '300'
}), IsOptional(), IsNumber(), __metadata("design:type", Number)], ImageModel.prototype, "width", void 0);
__decorate([Field({
  dataType: DataType.NUMBER
}), Editor({
  field_type: FieldType.NUMBER,
  label: 'Height',
  description: 'Image height in pixels (optional)',
  placeholder: '200'
}), IsOptional(), IsNumber(), __metadata("design:type", Number)], ImageModel.prototype, "height", void 0);
__decorate([Field({
  defaultValue: 'cover',
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.SELECT,
  label: 'Object Fit',
  description: 'How the image should be resized to fit its container',
  validation: {
    options: [{
      label: 'Fill',
      value: 'fill'
    }, {
      label: 'Contain',
      value: 'contain'
    }, {
      label: 'Cover',
      value: 'cover'
    }, {
      label: 'None',
      value: 'none'
    }, {
      label: 'Scale Down',
      value: 'scale-down'
    }]
  }
}), IsOptional(), IsString(), IsIn(['fill', 'contain', 'cover', 'none', 'scale-down']), __metadata("design:type", String)], ImageModel.prototype, "objectFit", void 0);
__decorate([Field({
  defaultValue: 'center',
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.SELECT,
  label: 'Object Position',
  description: 'Position of the image within its container',
  validation: {
    options: [{
      label: 'Center',
      value: 'center'
    }, {
      label: 'Top',
      value: 'top'
    }, {
      label: 'Bottom',
      value: 'bottom'
    }, {
      label: 'Left',
      value: 'left'
    }, {
      label: 'Right',
      value: 'right'
    }, {
      label: 'Top Left',
      value: 'top-left'
    }, {
      label: 'Top Right',
      value: 'top-right'
    }, {
      label: 'Bottom Left',
      value: 'bottom-left'
    }, {
      label: 'Bottom Right',
      value: 'bottom-right'
    }]
  }
}), IsOptional(), IsString(), IsIn(['center', 'top', 'bottom', 'left', 'right', 'top-left', 'top-right', 'bottom-left', 'bottom-right']), __metadata("design:type", String)], ImageModel.prototype, "objectPosition", void 0);
__decorate([Field({
  defaultValue: 'lazy',
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.SELECT,
  label: 'Loading',
  description: 'Image loading behavior',
  validation: {
    options: [{
      label: 'Lazy (load when visible)',
      value: 'lazy'
    }, {
      label: 'Eager (load immediately)',
      value: 'eager'
    }]
  }
}), IsOptional(), IsString(), IsIn(['lazy', 'eager']), __metadata("design:type", String)], ImageModel.prototype, "loading", void 0);
__decorate([Field({
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.TEXT,
  label: 'Title',
  description: 'Image title (tooltip text)',
  placeholder: 'Tooltip text on hover'
}), IsOptional(), IsString(), __metadata("design:type", String)], ImageModel.prototype, "title", void 0);
__decorate([Field({
  defaultValue: false,
  dataType: DataType.BOOLEAN
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Draggable',
  description: 'Allow the image to be dragged'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], ImageModel.prototype, "draggable", void 0);
__decorate([Field({
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.TEXT,
  label: 'Border Radius',
  description: 'CSS border radius (e.g., "8px", "50%", "1rem")',
  placeholder: '8px'
}), IsOptional(), IsString(), __metadata("design:type", String)], ImageModel.prototype, "borderRadius", void 0);
__decorate([Field({
  defaultValue: false,
  dataType: DataType.BOOLEAN
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Show Loading State',
  description: 'Display a loading placeholder while the image loads'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], ImageModel.prototype, "showLoading", void 0);
__decorate([Field({
  defaultValue: false,
  dataType: DataType.BOOLEAN
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Show Error State',
  description: 'Display an error message if the image fails to load'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], ImageModel.prototype, "showError", void 0);
__decorate([Field({
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.TEXT,
  label: 'Fallback Image',
  description: 'Fallback image URL to use if the main image fails to load',
  placeholder: 'https://example.com/fallback.jpg'
}), IsOptional(), IsString(), __metadata("design:type", String)], ImageModel.prototype, "fallbackSrc", void 0);
__decorate([Field({
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.TEXTAREA,
  label: 'Responsive Sizes',
  description: 'Responsive image sizes attribute for optimized loading',
  placeholder: '(max-width: 768px) 100vw, 50vw'
}), IsOptional(), IsString(), __metadata("design:type", String)], ImageModel.prototype, "sizes", void 0);
__decorate([Field({
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.TEXTAREA,
  label: 'Source Set',
  description: 'Source set for responsive images (comma-separated)',
  placeholder: 'image-320w.jpg 320w, image-640w.jpg 640w, image-1280w.jpg 1280w'
}), IsOptional(), IsString(), __metadata("design:type", String)], ImageModel.prototype, "srcSet", void 0);
__decorate([Field({
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.TEXTAREA,
  label: 'Loading Placeholder',
  description: 'Custom loading placeholder content (for advanced use)',
  placeholder: 'Custom loading content...'
}), IsOptional(), __metadata("design:type", Object)], ImageModel.prototype, "loadingPlaceholder", void 0);
__decorate([Field({
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.TEXTAREA,
  label: 'Error Placeholder',
  description: 'Custom error placeholder content (for advanced use)',
  placeholder: 'Custom error content...'
}), IsOptional(), __metadata("design:type", Object)], ImageModel.prototype, "errorPlaceholder", void 0);
ImageModel = __decorate([Schema('Image', '1.0.0')], ImageModel);

/**
 * Schema for Markdown component - Transforms Markdown strings into Framework components
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
let MarkdownModel = class MarkdownModel extends Model {};
__decorate([Field(), Editor({
  field_type: FieldType.TEXTAREA,
  label: 'Markdown Content',
  description: 'Markdown content to be transformed into React components',
  placeholder: '# Enter Markdown content...\n\n**Bold text** and *italic text*.'
}), IsOptional(), IsString(), __metadata("design:type", String)], MarkdownModel.prototype, "children", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.CHECKBOX,
  label: 'Sanitize HTML',
  description: 'Whether to sanitize HTML output for security'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], MarkdownModel.prototype, "sanitize", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Placeholder',
  description: 'Fallback content to display when Markdown is empty',
  placeholder: 'No content available'
}), IsOptional(), IsString(), __metadata("design:type", String)], MarkdownModel.prototype, "placeholder", void 0);
MarkdownModel = __decorate([Schema('Markdown', '1.0.0')], MarkdownModel);

/**
 * MetadataItem Schema - Defines data structure for metadata items (followers, posts, etc.)
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
let MetadataItemModel = class MetadataItemModel extends Model {};
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Label',
  description: 'Metadata label (e.g., "followers", "posts")',
  placeholder: 'followers'
}), IsString(), __metadata("design:type", String)], MetadataItemModel.prototype, "label", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Value',
  description: 'Metadata value (e.g., "1.2k", "42")',
  placeholder: '1.2k'
}), IsString(), __metadata("design:type", String)], MetadataItemModel.prototype, "value", void 0);
MetadataItemModel = __decorate([Schema('MetadataItem', '1.0.0')], MetadataItemModel);

/**
 * PageBannerHeader Schema - Defines data structure and validation for PageBannerHeader component
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
let PageBannerHeaderModel = class PageBannerHeaderModel extends Model {};
__decorate([Field(), Editor({
  field_type: FieldType.IMAGE,
  label: 'Cover Image',
  description: 'Large banner/cover image URL',
  placeholder: 'Upload cover image'
}), IsOptional(), IsString(), __metadata("design:type", String)], PageBannerHeaderModel.prototype, "coverImage", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Cover Image Alt Text',
  description: 'Alternative text for cover image',
  placeholder: 'Descriptive alt text...'
}), IsOptional(), IsString(), __metadata("design:type", String)], PageBannerHeaderModel.prototype, "coverImageAlt", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.IMAGE,
  label: 'Profile Image',
  description: 'Profile/avatar image URL',
  placeholder: 'Upload profile image'
}), IsOptional(), IsString(), __metadata("design:type", String)], PageBannerHeaderModel.prototype, "profileImage", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Profile Image Alt Text',
  description: 'Alternative text for profile image',
  placeholder: 'Profile alt text...'
}), IsOptional(), IsString(), __metadata("design:type", String)], PageBannerHeaderModel.prototype, "profileImageAlt", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Profile Image Size',
  description: 'Size of the profile image',
  validation: {
    options: [{
      label: 'Small',
      value: 'small'
    }, {
      label: 'Medium',
      value: 'medium'
    }, {
      label: 'Large',
      value: 'large'
    }]
  }
}), IsOptional(), IsIn(['small', 'medium', 'large']), __metadata("design:type", String)], PageBannerHeaderModel.prototype, "profileImageSize", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Overline',
  description: 'Small text above the main title',
  placeholder: 'Overline text'
}), IsOptional(), IsString(), __metadata("design:type", String)], PageBannerHeaderModel.prototype, "overline", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Title',
  description: 'Main heading/title text',
  placeholder: 'Enter title...'
}), IsString(), __metadata("design:type", String)], PageBannerHeaderModel.prototype, "title", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Subtitle',
  description: 'Secondary text below the title',
  placeholder: 'Enter subtitle...'
}), IsOptional(), IsString(), __metadata("design:type", String)], PageBannerHeaderModel.prototype, "subtitle", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.REPEATER,
  label: 'Metadata',
  description: 'Array of metadata items (followers, posts, etc.)'
}), IsOptional(), IsArray(), ValidateNested({
  each: true
}), Type(() => MetadataItemModel), __metadata("design:type", Array)], PageBannerHeaderModel.prototype, "metadata", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.REPEATER,
  label: 'Tags',
  description: 'Array of tag strings'
}), IsOptional(), IsArray(), IsString({
  each: true
}), __metadata("design:type", Array)], PageBannerHeaderModel.prototype, "tags", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.REPEATER,
  label: 'Actions',
  description: 'Array of action buttons'
}), IsOptional(), IsArray(), ValidateNested({
  each: true
}), Type(() => HeaderActionModel), __metadata("design:type", Array)], PageBannerHeaderModel.prototype, "actions", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.NUMBER,
  label: 'Max Visible Actions',
  description: 'Maximum visible actions before overflow',
  validation: {
    min: 1,
    max: 10
  }
}), IsOptional(), IsNumber(), Min(1), Max(10), __metadata("design:type", Number)], PageBannerHeaderModel.prototype, "maxVisibleActions", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.NUMBER,
  label: 'Banner Height',
  description: 'Height of the banner area in pixels',
  validation: {
    min: 100,
    max: 500
  }
}), IsOptional(), IsNumber(), Min(100), Max(500), __metadata("design:type", Number)], PageBannerHeaderModel.prototype, "height", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'CSS Class',
  description: 'Additional CSS class name',
  placeholder: 'custom-class'
}), IsOptional(), IsString(), __metadata("design:type", String)], PageBannerHeaderModel.prototype, "className", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Profile Position',
  description: 'Position of profile image relative to banner',
  validation: {
    options: [{
      label: 'Bottom Left',
      value: 'bottom-left'
    }, {
      label: 'Bottom Center',
      value: 'bottom-center'
    }, {
      label: 'Overlay Center',
      value: 'overlay-center'
    }]
  }
}), IsOptional(), IsIn(['bottom-left', 'bottom-center', 'overlay-center']), __metadata("design:type", String)], PageBannerHeaderModel.prototype, "profilePosition", void 0);
PageBannerHeaderModel = __decorate([Schema('PageBannerHeader', '1.0.0')], PageBannerHeaderModel);

/**
 * Schema for PaletteSwitcher component - Color palette switching control
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
let PaletteSwitcherModel = class PaletteSwitcherModel extends Model {};
__decorate([Field({
  defaultValue: false
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Disabled',
  description: 'Disable the palette switcher button'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], PaletteSwitcherModel.prototype, "disabled", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Button Size',
  description: 'Size of the palette switcher button',
  placeholder: 'medium'
}), IsOptional(), IsString(), __metadata("design:type", String)], PaletteSwitcherModel.prototype, "buttonSize", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Tooltip Text',
  description: 'Custom tooltip text for the palette switcher',
  placeholder: 'Switch color palette'
}), IsOptional(), IsString(), __metadata("design:type", String)], PaletteSwitcherModel.prototype, "tooltipText", void 0);
__decorate([Field({
  defaultValue: true
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Show Active Badge',
  description: 'Show "Active" badge on currently selected palette'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], PaletteSwitcherModel.prototype, "showActiveBadge", void 0);
__decorate([Field({
  defaultValue: true
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Show Descriptions',
  description: 'Show palette descriptions in menu items'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], PaletteSwitcherModel.prototype, "showDescriptions", void 0);
PaletteSwitcherModel = __decorate([Schema('PaletteSwitcher', '1.0.0')], PaletteSwitcherModel);

/**
 * ProductCard Schema - Schema definition for ProductCard component
 *
 * Defines the data structure and form editors for the ProductCard component
 * using the declarative Model pattern with decorators.
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
let ProductModel = class ProductModel extends Model {};
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Product ID',
  description: 'Unique product identifier',
  placeholder: 'product-1'
}), IsString(), IsNotEmpty(), __metadata("design:type", String)], ProductModel.prototype, "id", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Product Name',
  description: 'The display name of the product',
  placeholder: 'Enter product name...'
}), IsString(), IsNotEmpty(), __metadata("design:type", String)], ProductModel.prototype, "name", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Category',
  description: 'Product category or type',
  placeholder: 'e.g., Software, Hardware, Service'
}), IsString(), __metadata("design:type", String)], ProductModel.prototype, "category", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXTAREA,
  label: 'Description',
  description: 'Full product description',
  placeholder: 'Detailed product description...'
}), IsString(), __metadata("design:type", String)], ProductModel.prototype, "description", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXTAREA,
  label: 'Short Description',
  description: 'Brief product description for compact view',
  placeholder: 'Brief description...'
}), IsOptional(), IsString(), __metadata("design:type", String)], ProductModel.prototype, "shortDescription", void 0);
__decorate([Field({
  type: DataType.ARRAY
}), Editor({
  field_type: FieldType.REPEATER,
  label: 'Features',
  description: 'List of key product features'
}), IsArray(), IsString({
  each: true
}), __metadata("design:type", Array)], ProductModel.prototype, "features", void 0);
__decorate([Field({
  type: DataType.ARRAY
}), Editor({
  field_type: FieldType.REPEATER,
  label: 'Technologies',
  description: 'Technologies used in the product'
}), IsArray(), IsString({
  each: true
}), __metadata("design:type", Array)], ProductModel.prototype, "technologies", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Status',
  description: 'Current product status',
  placeholder: 'e.g., Active, Development, Beta'
}), IsString(), __metadata("design:type", String)], ProductModel.prototype, "status", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.IMAGE,
  label: 'Image URL',
  description: 'Product image or screenshot',
  placeholder: 'https://...'
}), IsOptional(), IsUrl(), __metadata("design:type", String)], ProductModel.prototype, "image", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.URL,
  label: 'Product URL',
  description: 'Live product URL (for launched products)',
  placeholder: 'https://...'
}), IsOptional(), IsUrl(), __metadata("design:type", String)], ProductModel.prototype, "url", void 0);
ProductModel = __decorate([Schema('Product', '1.0.0')], ProductModel);
let ProductCardActionModel = class ProductCardActionModel extends Model {};
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Action ID',
  description: 'Unique action identifier',
  placeholder: 'action-1'
}), IsString(), IsNotEmpty(), __metadata("design:type", String)], ProductCardActionModel.prototype, "id", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Button Label',
  description: 'Action button text',
  placeholder: 'Button text...'
}), IsString(), __metadata("design:type", String)], ProductCardActionModel.prototype, "label", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Button Style',
  description: 'Button style variant',
  validation: {
    options: [{
      label: 'Contained',
      value: 'contained'
    }, {
      label: 'Outlined',
      value: 'outlined'
    }, {
      label: 'Text',
      value: 'text'
    }]
  }
}), IsOptional(), IsIn(['contained', 'outlined', 'text']), __metadata("design:type", String)], ProductCardActionModel.prototype, "variant", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Button Color',
  description: 'Button color theme',
  validation: {
    options: [{
      label: 'Primary',
      value: 'primary'
    }, {
      label: 'Secondary',
      value: 'secondary'
    }, {
      label: 'Error',
      value: 'error'
    }]
  }
}), IsOptional(), IsIn(['primary', 'secondary', 'error']), __metadata("design:type", String)], ProductCardActionModel.prototype, "color", void 0);
__decorate([Field({
  defaultValue: false
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Disabled',
  description: 'Disabled state'
}), IsOptional(), __metadata("design:type", Boolean)], ProductCardActionModel.prototype, "disabled", void 0);
ProductCardActionModel = __decorate([Schema('ProductCardAction', '1.0.0')], ProductCardActionModel);
let ProductCardModel = class ProductCardModel extends Model {};
__decorate([Field({
  type: DataType.OBJECT
}), Editor({
  field_type: FieldType.FORM,
  label: 'Product Data',
  description: 'Product information to display'
}), IsOptional(), ValidateNested(), Type(() => ProductModel), __metadata("design:type", ProductModel)], ProductCardModel.prototype, "product", void 0);
__decorate([Field({
  defaultValue: 'detailed'
}), Editor({
  field_type: FieldType.SELECT,
  label: 'Card Variant',
  description: 'Display variant for the product card',
  validation: {
    options: [{
      label: 'Compact',
      value: 'compact'
    }, {
      label: 'Detailed',
      value: 'detailed'
    }]
  }
}), IsOptional(), IsIn(['compact', 'detailed']), __metadata("design:type", String)], ProductCardModel.prototype, "variant", void 0);
__decorate([Field({
  type: DataType.ARRAY
}), Editor({
  field_type: FieldType.REPEATER,
  label: 'Custom Actions',
  description: 'Custom action buttons'
}), IsOptional(), IsArray(), ValidateNested({
  each: true
}), Type(() => ProductCardActionModel), __metadata("design:type", Array)], ProductCardModel.prototype, "actions", void 0);
__decorate([Field({
  defaultValue: true
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Show Image',
  description: 'Whether to display the product image'
}), IsOptional(), __metadata("design:type", Boolean)], ProductCardModel.prototype, "showImage", void 0);
__decorate([Field({
  defaultValue: true
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Show Technologies',
  description: 'Whether to display technology chips'
}), IsOptional(), __metadata("design:type", Boolean)], ProductCardModel.prototype, "showTechnologies", void 0);
__decorate([Field({
  defaultValue: 3
}), Editor({
  field_type: FieldType.NUMBER,
  label: 'Max Features (Compact)',
  description: 'Maximum features to show in compact mode',
  validation: {
    min: 1,
    max: 10
  }
}), IsOptional(), IsNumber(), Min(1), Max(10), __metadata("design:type", Number)], ProductCardModel.prototype, "maxFeaturesCompact", void 0);
ProductCardModel = __decorate([Schema('ProductCard', '1.0.0')], ProductCardModel);

/**
 * Schema for ImageGallery component - Image gallery with multiple view variants
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
// Product image interface
class GalleryImageModel {}
__decorate([Field({
  dataType: DataType.STRING
}), IsString(), __metadata("design:type", String)], GalleryImageModel.prototype, "url", void 0);
__decorate([Field({
  dataType: DataType.STRING
}), IsString(), __metadata("design:type", String)], GalleryImageModel.prototype, "alt", void 0);
__decorate([Field({
  dataType: DataType.STRING
}), IsOptional(), IsString(), __metadata("design:type", String)], GalleryImageModel.prototype, "thumbnail", void 0);
let ImageGalleryModel = class ImageGalleryModel extends ViewSchema {};
__decorate([Field({
  dataType: DataType.ARRAY
}), Editor({
  field_type: FieldType.ARRAY,
  label: 'Product Images',
  description: 'Array of product images to display in the gallery'
}), IsArray(), ValidateNested({
  each: true
}), Type(() => GalleryImageModel), __metadata("design:type", Array)], ImageGalleryModel.prototype, "images", void 0);
__decorate([Field({
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.TEXT,
  label: 'Product Name',
  description: 'Product name for accessibility',
  placeholder: 'Premium Cotton T-Shirt'
}), IsString(), __metadata("design:type", String)], ImageGalleryModel.prototype, "productName", void 0);
__decorate([Field({
  defaultValue: 'thumbnails',
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.SELECT,
  label: 'Gallery Variant',
  description: 'Display variant for the gallery',
  validation: {
    options: [{
      label: 'Thumbnails',
      value: 'thumbnails'
    }, {
      label: 'Carousel',
      value: 'carousel'
    }, {
      label: 'Grid',
      value: 'grid'
    }]
  }
}), IsOptional(), IsString(), IsIn(['thumbnails', 'carousel', 'grid']), __metadata("design:type", String)], ImageGalleryModel.prototype, "variant", void 0);
__decorate([Field({
  defaultValue: 'left',
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.SELECT,
  label: 'Thumbnail Position',
  description: 'Position of thumbnails (only for thumbnails variant)',
  validation: {
    options: [{
      label: 'Left',
      value: 'left'
    }, {
      label: 'Bottom',
      value: 'bottom'
    }, {
      label: 'Right',
      value: 'right'
    }]
  }
}), IsOptional(), IsString(), IsIn(['left', 'bottom', 'right']), __metadata("design:type", String)], ImageGalleryModel.prototype, "thumbnailPosition", void 0);
__decorate([Field({
  defaultValue: '1',
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.TEXT,
  label: 'Aspect Ratio',
  description: 'Aspect ratio for main image (e.g., "1", "4/3", "16/9")',
  placeholder: '1'
}), IsOptional(), IsString(), __metadata("design:type", String)], ImageGalleryModel.prototype, "aspectRatio", void 0);
__decorate([Field({
  defaultValue: true,
  dataType: DataType.BOOLEAN
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Show Zoom',
  description: 'Enable zoom functionality for images'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], ImageGalleryModel.prototype, "showZoom", void 0);
__decorate([Field({
  dataType: DataType.NUMBER
}), Editor({
  field_type: FieldType.NUMBER,
  label: 'Max Images',
  description: 'Maximum number of images to display (leave empty for all)',
  placeholder: '8'
}), IsOptional(), IsNumber(), __metadata("design:type", Number)], ImageGalleryModel.prototype, "maxImages", void 0);
__decorate([Field({
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.TEXT,
  label: 'Data Source',
  description: 'Data source for dynamic image loading',
  placeholder: 'product-images'
}), IsOptional(), IsString(), __metadata("design:type", String)], ImageGalleryModel.prototype, "dataSource", void 0);
__decorate([Field({
  dataType: DataType.OBJECT
}), Editor({
  field_type: FieldType.TEXTAREA,
  label: 'Binding Options',
  description: 'Data binding configuration (JSON format)',
  placeholder: '{ "filter": {}, "sort": {} }'
}), IsOptional(), __metadata("design:type", Object)], ImageGalleryModel.prototype, "bindingOptions", void 0);
ImageGalleryModel = __decorate([Schema('ImageGallery', '1.0.0')], ImageGalleryModel);

/**
 * Schema for OptionSelector component - Universal option selection with visual modes
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
// Select option model
class SelectOptionModel {}
__decorate([Field({
  dataType: DataType.STRING
}), IsString(), __metadata("design:type", String)], SelectOptionModel.prototype, "id", void 0);
__decorate([Field({
  dataType: DataType.STRING
}), IsString(), __metadata("design:type", String)], SelectOptionModel.prototype, "label", void 0);
__decorate([Field({
  dataType: DataType.BOOLEAN
}), IsBoolean(), __metadata("design:type", Boolean)], SelectOptionModel.prototype, "available", void 0);
__decorate([Field({
  dataType: DataType.NUMBER
}), IsOptional(), IsNumber(), __metadata("design:type", Number)], SelectOptionModel.prototype, "price", void 0);
__decorate([Field({
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.TEXT,
  label: 'Hex Color Value',
  description: 'Hex color code for color swatches (e.g., #FF0000)',
  placeholder: '#FF0000'
}), IsOptional(), IsString(), __metadata("design:type", String)], SelectOptionModel.prototype, "hexValue", void 0);
__decorate([Field({
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.TEXT,
  label: 'Image URL',
  description: 'Image URL for image/pattern display mode',
  placeholder: '/patterns/stripes.jpg'
}), IsOptional(), IsString(), __metadata("design:type", String)], SelectOptionModel.prototype, "imageUrl", void 0);
let OptionSelectorModel = class OptionSelectorModel extends ViewSchema {};
__decorate([Field({
  dataType: DataType.ARRAY
}), Editor({
  field_type: FieldType.ARRAY,
  label: 'Available Options',
  description: 'Array of options to display'
}), IsArray(), ValidateNested({
  each: true
}), Type(() => SelectOptionModel), __metadata("design:type", Array)], OptionSelectorModel.prototype, "options", void 0);
__decorate([Field({
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.TEXT,
  label: 'Selected Option',
  description: 'Currently selected option ID',
  placeholder: 'm'
}), IsOptional(), IsString(), __metadata("design:type", String)], OptionSelectorModel.prototype, "selectedOption", void 0);
__decorate([Field({
  defaultValue: 'text',
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.SELECT,
  label: 'Display Mode',
  description: 'Visual display mode for options',
  validation: {
    options: [{
      label: 'Text (buttons with labels)',
      value: 'text'
    }, {
      label: 'Color (swatches)',
      value: 'color'
    }, {
      label: 'Image (patterns/textures)',
      value: 'image'
    }]
  }
}), IsOptional(), IsString(), IsIn(['text', 'color', 'image']), __metadata("design:type", String)], OptionSelectorModel.prototype, "displayMode", void 0);
__decorate([Field({
  defaultValue: 'grid',
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.SELECT,
  label: 'Display Variant',
  description: 'How to display the selector',
  validation: {
    options: [{
      label: 'Buttons',
      value: 'buttons'
    }, {
      label: 'Dropdown',
      value: 'dropdown'
    }, {
      label: 'Grid',
      value: 'grid'
    }]
  }
}), IsOptional(), IsString(), IsIn(['buttons', 'dropdown', 'grid']), __metadata("design:type", String)], OptionSelectorModel.prototype, "variant", void 0);
__decorate([Field({
  defaultValue: 'wrap',
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.SELECT,
  label: 'Layout Direction',
  description: 'Layout direction for buttons/grid variant',
  validation: {
    options: [{
      label: 'Horizontal',
      value: 'horizontal'
    }, {
      label: 'Vertical',
      value: 'vertical'
    }, {
      label: 'Wrap',
      value: 'wrap'
    }]
  }
}), IsOptional(), IsString(), IsIn(['horizontal', 'vertical', 'wrap']), __metadata("design:type", String)], OptionSelectorModel.prototype, "layout", void 0);
__decorate([Field({
  defaultValue: 'medium',
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.SELECT,
  label: 'Visual Size',
  description: 'Size for color/image display modes',
  validation: {
    options: [{
      label: 'Small (32px)',
      value: 'small'
    }, {
      label: 'Medium (44px)',
      value: 'medium'
    }, {
      label: 'Large (56px)',
      value: 'large'
    }]
  }
}), IsOptional(), IsString(), IsIn(['small', 'medium', 'large']), __metadata("design:type", String)], OptionSelectorModel.prototype, "visualSize", void 0);
__decorate([Field({
  defaultValue: false,
  dataType: DataType.BOOLEAN
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Show Label',
  description: 'Show label below visual (for color/image modes)'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], OptionSelectorModel.prototype, "showLabel", void 0);
__decorate([Field({
  defaultValue: false,
  dataType: DataType.BOOLEAN
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Disabled',
  description: 'Disable all option selections'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], OptionSelectorModel.prototype, "disabled", void 0);
__decorate([Field({
  defaultValue: 'Select Option',
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.TEXT,
  label: 'Label',
  description: 'Label text for the selector',
  placeholder: 'Select Option'
}), IsOptional(), IsString(), __metadata("design:type", String)], OptionSelectorModel.prototype, "label", void 0);
__decorate([Field({
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.TEXT,
  label: 'Data Source',
  description: 'Data source for dynamic option loading',
  placeholder: 'product-options'
}), IsOptional(), IsString(), __metadata("design:type", String)], OptionSelectorModel.prototype, "dataSource", void 0);
__decorate([Field({
  dataType: DataType.OBJECT
}), Editor({
  field_type: FieldType.TEXTAREA,
  label: 'Binding Options',
  description: 'Data binding configuration (JSON format)',
  placeholder: '{ "filter": {}, "sort": {} }'
}), IsOptional(), __metadata("design:type", Object)], OptionSelectorModel.prototype, "bindingOptions", void 0);
OptionSelectorModel = __decorate([Schema('OptionSelector', '1.0.0')], OptionSelectorModel);

/**
 * Schema for SafeSpan component - Safely renders HTML content with sanitization
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
let SafeSpanModel = class SafeSpanModel extends Model {};
__decorate([Field(), Editor({
  field_type: FieldType.TEXTAREA,
  label: 'HTML Content',
  description: 'HTML content to be safely rendered after sanitization',
  placeholder: '<p>Enter HTML content...</p>'
}), IsOptional(), IsString(), __metadata("design:type", String)], SafeSpanModel.prototype, "html", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Placeholder Text',
  description: 'Text to display when no HTML content is available',
  placeholder: 'Loading...'
}), IsOptional(), IsString(), __metadata("design:type", String)], SafeSpanModel.prototype, "placeholder", void 0);
SafeSpanModel = __decorate([Schema('SafeSpan', '1.0.0')], SafeSpanModel);

/**
 * Schema for Section component - Themed, responsive section container
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
let SectionModel = class SectionModel extends ContainerSchema {};
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Background Color',
  description: 'Background color (CSS color, theme path, or palette color)',
  placeholder: '#ffffff or primary.main'
}), IsOptional(), IsString(), __metadata("design:type", String)], SectionModel.prototype, "background", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Text Color',
  description: 'Text color (CSS color, theme path, or palette color)',
  placeholder: '#000000 or text.primary'
}), IsOptional(), IsString(), __metadata("design:type", String)], SectionModel.prototype, "color", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Section Padding',
  description: 'Vertical padding/spacing for the section',
  validation: {
    options: [{
      value: 'none',
      label: 'None'
    }, {
      value: 'tiny',
      label: 'Tiny (8px)'
    }, {
      value: 'small',
      label: 'Small (16px)'
    }, {
      value: 'medium',
      label: 'Medium (32px)'
    }, {
      value: 'large',
      label: 'Large (64px)'
    }, {
      value: 'extra-large',
      label: 'Extra Large (96px)'
    }]
  }
}), IsOptional(), IsIn(['none', 'tiny', 'small', 'medium', 'large', 'extra-large']), __metadata("design:type", String)], SectionModel.prototype, "padding", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'Content Max Width',
  description: 'Maximum width for the content container',
  validation: {
    options: [{
      value: 'xs',
      label: 'Extra Small (444px)'
    }, {
      value: 'sm',
      label: 'Small (600px)'
    }, {
      value: 'md',
      label: 'Medium (900px)'
    }, {
      value: 'lg',
      label: 'Large (1200px)'
    }, {
      value: 'xl',
      label: 'Extra Large (1536px)'
    }, {
      value: 'false',
      label: 'Full Width'
    }]
  }
}), IsOptional(), IsIn(['xs', 'sm', 'md', 'lg', 'xl', 'false']), __metadata("design:type", String)], SectionModel.prototype, "contentMaxWidth", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.SELECT,
  label: 'HTML Element',
  description: 'HTML element type to use for the section',
  validation: {
    options: [{
      value: 'section',
      label: 'Section'
    }, {
      value: 'div',
      label: 'Div'
    }, {
      value: 'article',
      label: 'Article'
    }, {
      value: 'main',
      label: 'Main'
    }]
  }
}), IsOptional(), IsIn(['section', 'div', 'article', 'main']), __metadata("design:type", String)], SectionModel.prototype, "component", void 0);
SectionModel = __decorate([Schema('Section', '1.0.0')], SectionModel);

/**
 * Schema for TextInputField component - Reusable text input with consistent styling
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
let TextInputFieldModel = class TextInputFieldModel extends ViewSchema {};
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Field Label',
  description: 'The label displayed for the text input field',
  placeholder: 'Enter field label...'
}), IsString(), __metadata("design:type", String)], TextInputFieldModel.prototype, "label", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Value',
  description: 'Current field value',
  placeholder: 'Enter value...'
}), IsOptional(), IsString(), __metadata("design:type", String)], TextInputFieldModel.prototype, "value", void 0);
__decorate([Field({
  defaultValue: false
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Required',
  description: 'Whether the field is required'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], TextInputFieldModel.prototype, "required", void 0);
__decorate([Field({
  defaultValue: false
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Disabled',
  description: 'Whether the field is disabled'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], TextInputFieldModel.prototype, "disabled", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Error Message',
  description: 'Error message to display if validation fails',
  placeholder: 'Enter error message...'
}), IsOptional(), IsString(), __metadata("design:type", String)], TextInputFieldModel.prototype, "error", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Helper Text',
  description: 'Helper text to guide the user',
  placeholder: 'Enter helper text...'
}), IsOptional(), IsString(), __metadata("design:type", String)], TextInputFieldModel.prototype, "helperText", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Placeholder',
  description: 'Placeholder text shown when field is empty',
  placeholder: 'Enter placeholder text...'
}), IsOptional(), IsString(), __metadata("design:type", String)], TextInputFieldModel.prototype, "placeholder", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Input Type',
  description: 'HTML input type (text, email, number, password, etc.)',
  placeholder: 'text'
}), IsOptional(), IsString(), __metadata("design:type", String)], TextInputFieldModel.prototype, "type", void 0);
__decorate([Field({
  defaultValue: false
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Multiline',
  description: 'Whether the field supports multiple lines (textarea)'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], TextInputFieldModel.prototype, "multiline", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.NUMBER,
  label: 'Rows',
  description: 'Number of rows for multiline fields'
}), IsOptional(), IsNumber(), __metadata("design:type", Number)], TextInputFieldModel.prototype, "rows", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.NUMBER,
  label: 'Max Rows',
  description: 'Maximum number of rows for multiline fields'
}), IsOptional(), IsNumber(), __metadata("design:type", Number)], TextInputFieldModel.prototype, "maxRows", void 0);
TextInputFieldModel = __decorate([Schema('TextInputField', '1.0.0')], TextInputFieldModel);

/**
 * Schema for Text component - Comprehensive typography component
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
let TextModel = class TextModel extends Model {};
__decorate([Field({
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.TEXTAREA,
  label: 'Text Content',
  description: 'The text content to display',
  placeholder: 'Enter your text content here...'
}), IsOptional(), IsString(), __metadata("design:type", String)], TextModel.prototype, "content", void 0);
__decorate([Field({
  defaultValue: 'body1',
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.SELECT,
  label: 'Typography Variant',
  description: 'Typography variant that determines font size, weight, and line height',
  validation: {
    options: [{
      label: 'Heading 1',
      value: 'h1'
    }, {
      label: 'Heading 2',
      value: 'h2'
    }, {
      label: 'Heading 3',
      value: 'h3'
    }, {
      label: 'Heading 4',
      value: 'h4'
    }, {
      label: 'Heading 5',
      value: 'h5'
    }, {
      label: 'Heading 6',
      value: 'h6'
    }, {
      label: 'Subtitle 1',
      value: 'subtitle1'
    }, {
      label: 'Subtitle 2',
      value: 'subtitle2'
    }, {
      label: 'Body 1',
      value: 'body1'
    }, {
      label: 'Body 2',
      value: 'body2'
    }, {
      label: 'Button',
      value: 'button'
    }, {
      label: 'Caption',
      value: 'caption'
    }, {
      label: 'Overline',
      value: 'overline'
    }]
  }
}), IsOptional(), IsString(), IsIn(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'button', 'caption', 'overline']), __metadata("design:type", String)], TextModel.prototype, "variant", void 0);
__decorate([Field({
  defaultValue: 'inherit',
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.SELECT,
  label: 'Text Color',
  description: 'Color variant for the text',
  validation: {
    options: [{
      label: 'Primary',
      value: 'primary'
    }, {
      label: 'Secondary',
      value: 'secondary'
    }, {
      label: 'Text Primary',
      value: 'textPrimary'
    }, {
      label: 'Text Secondary',
      value: 'textSecondary'
    }, {
      label: 'Error',
      value: 'error'
    }, {
      label: 'Warning',
      value: 'warning'
    }, {
      label: 'Info',
      value: 'info'
    }, {
      label: 'Success',
      value: 'success'
    }, {
      label: 'Inherit',
      value: 'inherit'
    }]
  }
}), IsOptional(), IsString(), IsIn(['primary', 'secondary', 'textPrimary', 'textSecondary', 'error', 'warning', 'info', 'success', 'inherit']), __metadata("design:type", String)], TextModel.prototype, "color", void 0);
__decorate([Field({
  defaultValue: 'inherit',
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.SELECT,
  label: 'Text Alignment',
  description: 'How to align the text horizontally',
  validation: {
    options: [{
      label: 'Left',
      value: 'left'
    }, {
      label: 'Center',
      value: 'center'
    }, {
      label: 'Right',
      value: 'right'
    }, {
      label: 'Justify',
      value: 'justify'
    }, {
      label: 'Inherit',
      value: 'inherit'
    }]
  }
}), IsOptional(), IsString(), IsIn(['left', 'center', 'right', 'justify', 'inherit']), __metadata("design:type", String)], TextModel.prototype, "align", void 0);
__decorate([Field({
  defaultValue: 'p',
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.SELECT,
  label: 'HTML Element',
  description: 'The HTML element to render (affects semantics and accessibility)',
  validation: {
    options: [{
      label: 'Paragraph (p)',
      value: 'p'
    }, {
      label: 'Span',
      value: 'span'
    }, {
      label: 'Div',
      value: 'div'
    }, {
      label: 'Heading 1 (h1)',
      value: 'h1'
    }, {
      label: 'Heading 2 (h2)',
      value: 'h2'
    }, {
      label: 'Heading 3 (h3)',
      value: 'h3'
    }, {
      label: 'Heading 4 (h4)',
      value: 'h4'
    }, {
      label: 'Heading 5 (h5)',
      value: 'h5'
    }, {
      label: 'Heading 6 (h6)',
      value: 'h6'
    }, {
      label: 'Label',
      value: 'label'
    }, {
      label: 'Legend',
      value: 'legend'
    }]
  }
}), IsOptional(), IsString(), IsIn(['p', 'span', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'label', 'legend']), __metadata("design:type", String)], TextModel.prototype, "component", void 0);
__decorate([Field({
  defaultValue: 'inherit',
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.SELECT,
  label: 'Font Weight',
  description: 'The weight (thickness) of the font',
  validation: {
    options: [{
      label: 'Inherit',
      value: 'inherit'
    }, {
      label: 'Lighter',
      value: 'lighter'
    }, {
      label: 'Normal',
      value: 'normal'
    }, {
      label: 'Bold',
      value: 'bold'
    }, {
      label: 'Bolder',
      value: 'bolder'
    }, {
      label: '100',
      value: '100'
    }, {
      label: '200',
      value: '200'
    }, {
      label: '300',
      value: '300'
    }, {
      label: '400',
      value: '400'
    }, {
      label: '500',
      value: '500'
    }, {
      label: '600',
      value: '600'
    }, {
      label: '700',
      value: '700'
    }, {
      label: '800',
      value: '800'
    }, {
      label: '900',
      value: '900'
    }]
  }
}), IsOptional(), IsString(), IsIn(['inherit', 'lighter', 'normal', 'bold', 'bolder', '100', '200', '300', '400', '500', '600', '700', '800', '900']), __metadata("design:type", String)], TextModel.prototype, "fontWeight", void 0);
__decorate([Field({
  defaultValue: 'none',
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.SELECT,
  label: 'Text Decoration',
  description: 'Text decoration style',
  validation: {
    options: [{
      label: 'None',
      value: 'none'
    }, {
      label: 'Underline',
      value: 'underline'
    }, {
      label: 'Overline',
      value: 'overline'
    }, {
      label: 'Line Through',
      value: 'line-through'
    }]
  }
}), IsOptional(), IsString(), IsIn(['none', 'underline', 'overline', 'line-through']), __metadata("design:type", String)], TextModel.prototype, "textDecoration", void 0);
__decorate([Field({
  defaultValue: 'none',
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.SELECT,
  label: 'Text Transform',
  description: 'How to transform the text case',
  validation: {
    options: [{
      label: 'None',
      value: 'none'
    }, {
      label: 'Capitalize',
      value: 'capitalize'
    }, {
      label: 'Uppercase',
      value: 'uppercase'
    }, {
      label: 'Lowercase',
      value: 'lowercase'
    }, {
      label: 'Inherit',
      value: 'inherit'
    }]
  }
}), IsOptional(), IsString(), IsIn(['none', 'capitalize', 'uppercase', 'lowercase', 'inherit']), __metadata("design:type", String)], TextModel.prototype, "textTransform", void 0);
__decorate([Field({
  defaultValue: false,
  dataType: DataType.BOOLEAN
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'No Wrap',
  description: 'Prevent text from wrapping to multiple lines'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], TextModel.prototype, "noWrap", void 0);
__decorate([Field({
  defaultValue: false,
  dataType: DataType.BOOLEAN
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Paragraph Mode',
  description: 'Apply paragraph spacing and formatting'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], TextModel.prototype, "paragraph", void 0);
__decorate([Field({
  defaultValue: false,
  dataType: DataType.BOOLEAN
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Gutter Bottom',
  description: 'Add margin bottom for spacing (useful for headings)'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], TextModel.prototype, "gutterBottom", void 0);
__decorate([Field({
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.TEXT,
  label: 'Font Size',
  description: 'Custom font size (overrides variant sizing, e.g., "16px", "1.2rem")',
  placeholder: '16px'
}), IsOptional(), IsString(), __metadata("design:type", String)], TextModel.prototype, "fontSize", void 0);
__decorate([Field({
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.TEXT,
  label: 'Line Height',
  description: 'Custom line height (e.g., "1.5", "24px", "150%")',
  placeholder: '1.5'
}), IsOptional(), IsString(), __metadata("design:type", String)], TextModel.prototype, "lineHeight", void 0);
__decorate([Field({
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.TEXT,
  label: 'Letter Spacing',
  description: 'Custom letter spacing (e.g., "0.1em", "1px")',
  placeholder: '0.1em'
}), IsOptional(), IsString(), __metadata("design:type", String)], TextModel.prototype, "letterSpacing", void 0);
__decorate([Field({
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.TEXT,
  label: 'Font Family',
  description: 'Custom font family (e.g., "Arial, sans-serif")',
  placeholder: 'Arial, sans-serif'
}), IsOptional(), IsString(), __metadata("design:type", String)], TextModel.prototype, "fontFamily", void 0);
__decorate([Field({
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.TEXTAREA,
  label: 'Custom Color',
  description: 'Custom text color (CSS color value, overrides color variant)',
  placeholder: '#333333 or rgb(51, 51, 51)'
}), IsOptional(), IsString(), __metadata("design:type", String)], TextModel.prototype, "customColor", void 0);
__decorate([Field({
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.TEXTAREA,
  label: 'Max Width',
  description: 'Maximum width for the text (e.g., "300px", "50%")',
  placeholder: '300px'
}), IsOptional(), IsString(), __metadata("design:type", String)], TextModel.prototype, "maxWidth", void 0);
__decorate([Field({
  dataType: DataType.STRING
}), Editor({
  field_type: FieldType.TEXTAREA,
  label: 'Rich Content',
  description: 'Rich text content with React elements (for advanced use)',
  placeholder: 'Rich content...'
}), IsOptional(), __metadata("design:type", Object)], TextModel.prototype, "children", void 0);
TextModel = __decorate([Schema('Text', '1.0.0')], TextModel);

/**
 * Schema for ThemeSwitcher component - Theme selection control
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
let ThemeSwitcherModel = class ThemeSwitcherModel extends Model {};
__decorate([Field({
  defaultValue: false
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Disabled',
  description: 'Disable the theme switcher button'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], ThemeSwitcherModel.prototype, "disabled", void 0);
__decorate([Field({
  defaultValue: 'medium'
}), Editor({
  field_type: FieldType.SELECT,
  label: 'Button Size',
  description: 'Size of the theme switcher button'
}), IsOptional(), IsString(), IsIn(['small', 'medium', 'large']), __metadata("design:type", String)], ThemeSwitcherModel.prototype, "size", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Custom Tooltip',
  description: 'Custom tooltip text override',
  placeholder: 'Current theme: Light'
}), IsOptional(), IsString(), __metadata("design:type", String)], ThemeSwitcherModel.prototype, "tooltipText", void 0);
__decorate([Field({
  defaultValue: true
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Show Tooltip',
  description: 'Show tooltip on hover'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], ThemeSwitcherModel.prototype, "showTooltip", void 0);
__decorate([Field({
  defaultValue: 'bottom'
}), Editor({
  field_type: FieldType.SELECT,
  label: 'Menu Position',
  description: 'Position of the theme selection menu'
}), IsOptional(), IsString(), IsIn(['bottom', 'top', 'left', 'right']), __metadata("design:type", String)], ThemeSwitcherModel.prototype, "menuPosition", void 0);
__decorate([Field({
  defaultValue: true
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Show Light Theme',
  description: 'Show light theme option in menu'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], ThemeSwitcherModel.prototype, "showLightTheme", void 0);
__decorate([Field({
  defaultValue: true
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Show Dark Theme',
  description: 'Show dark theme option in menu'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], ThemeSwitcherModel.prototype, "showDarkTheme", void 0);
__decorate([Field({
  defaultValue: true
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Show System Theme',
  description: 'Show system theme option in menu'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], ThemeSwitcherModel.prototype, "showSystemTheme", void 0);
ThemeSwitcherModel = __decorate([Schema('ThemeSwitcher', '1.0.0')], ThemeSwitcherModel);

/**
 * PrintConfig Schema - Configuration for print mode rendering
 *
 * Defines how components should behave and appear when printed,
 * including theme settings and layout modifications for print media.
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
let PrintConfigSchema = class PrintConfigSchema extends Model {};
__decorate([Field({
  defaultValue: 'light'
}), Editor({
  field_type: FieldType.SELECT,
  label: 'Print Theme',
  description: 'Theme mode to use when printing',
  validation: {
    options: [{
      label: 'Light',
      value: 'light'
    }, {
      label: 'Dark',
      value: 'dark'
    }]
  }
}), IsOptional(), IsIn(['light', 'dark']), __metadata("design:type", String)], PrintConfigSchema.prototype, "theme", void 0);
__decorate([Field({
  defaultValue: 'default'
}), Editor({
  field_type: FieldType.SELECT,
  label: 'Print Palette',
  description: 'Color palette to use for print output',
  validation: {
    options: [{
      label: 'Default',
      value: 'default'
    }, {
      label: 'Autumn',
      value: 'autumn'
    }, {
      label: 'Cosmic',
      value: 'cosmic'
    }, {
      label: 'Ocean',
      value: 'ocean'
    }, {
      label: 'Spring',
      value: 'spring'
    }, {
      label: 'Winter',
      value: 'winter'
    }]
  }
}), IsOptional(), IsString(), __metadata("design:type", String)], PrintConfigSchema.prototype, "palette", void 0);
__decorate([Field({
  defaultValue: true
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Hide Scaffolding',
  description: 'Hide app scaffolding (navigation, headers) when printing'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], PrintConfigSchema.prototype, "hideScaffolding", void 0);
__decorate([Field({
  defaultValue: false
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Hide Interactive Elements',
  description: 'Hide buttons and interactive elements when printing'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], PrintConfigSchema.prototype, "hideInteractiveElements", void 0);
__decorate([Field({
  defaultValue: false
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Optimize For Monochrome',
  description: 'Optimize design for black and white printing'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], PrintConfigSchema.prototype, "optimizeForMonochrome", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Print Title',
  description: 'Custom title to show when printing (optional)',
  placeholder: 'Document Title'
}), IsOptional(), IsString(), __metadata("design:type", String)], PrintConfigSchema.prototype, "printTitle", void 0);
__decorate([Field({
  defaultValue: true
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Show Print Date',
  description: 'Include print date and time in printed output'
}), IsOptional(), IsBoolean(), __metadata("design:type", Boolean)], PrintConfigSchema.prototype, "showPrintDate", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Print Header',
  description: 'Custom header content for printed pages (HTML string or React component)',
  placeholder: '<div>Custom header content...</div>'
}), IsOptional(), __metadata("design:type", Object)], PrintConfigSchema.prototype, "printHeader", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Print Header (First Page)',
  description: 'Different header for the first page only (overrides main header on page 1)',
  placeholder: '<div>First page header...</div>'
}), IsOptional(), __metadata("design:type", Object)], PrintConfigSchema.prototype, "printHeaderFirstPage", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Print Footer',
  description: 'Custom footer content for printed pages (HTML string or React component)',
  placeholder: '<div>Custom footer content...</div>'
}), IsOptional(), __metadata("design:type", Object)], PrintConfigSchema.prototype, "printFooter", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Print Footer (First Page)',
  description: 'Different footer for the first page only (overrides main footer on page 1)',
  placeholder: '<div>First page footer...</div>'
}), IsOptional(), __metadata("design:type", Object)], PrintConfigSchema.prototype, "printFooterFirstPage", void 0);
__decorate([Field({
  defaultValue: '12mm'
}), Editor({
  field_type: FieldType.SELECT,
  label: 'Page Margins',
  description: 'Print page margins',
  validation: {
    options: [{
      label: 'Compact (6mm)',
      value: '6mm'
    }, {
      label: 'Standard (12mm)',
      value: '12mm'
    }, {
      label: 'Large (20mm)',
      value: '20mm'
    }, {
      label: 'Formal (25mm)',
      value: '25mm'
    }]
  }
}), IsOptional(), IsString(), __metadata("design:type", String)], PrintConfigSchema.prototype, "pageMargins", void 0);
__decorate([Field({
  defaultValue: '60px'
}), Editor({
  field_type: FieldType.TEXT,
  label: 'Print Header Height',
  description: 'Height allocated for print header (CSS units: px, mm, etc.)',
  placeholder: '60px'
}), IsOptional(), IsString(), __metadata("design:type", String)], PrintConfigSchema.prototype, "printHeaderHeight", void 0);
__decorate([Field({
  defaultValue: '40px'
}), Editor({
  field_type: FieldType.TEXT,
  label: 'Print Footer Height',
  description: 'Height allocated for print footer (CSS units: px, mm, etc.)',
  placeholder: '40px'
}), IsOptional(), IsString(), __metadata("design:type", String)], PrintConfigSchema.prototype, "printFooterHeight", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Print Background',
  description: 'CSS background for all printed pages (color, gradient, or image)',
  placeholder: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)'
}), IsOptional(), IsString(), __metadata("design:type", String)], PrintConfigSchema.prototype, "printBackground", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Print Background (First Page)',
  description: 'Different background for the first page only',
  placeholder: 'url(/logo-watermark.png) no-repeat center, #ffffff'
}), IsOptional(), IsString(), __metadata("design:type", String)], PrintConfigSchema.prototype, "printBackgroundFirstPage", void 0);
PrintConfigSchema = __decorate([Schema('PrintConfig', '1.0.0')], PrintConfigSchema);

/**
 * PageTemplate Schema - Complete page template configuration
 *
 * Extends ViewSchema to provide comprehensive page-level configuration
 * including metadata, print settings, and content structure.
 *
 * Copyright (c) 2025 QwickApps.com. All rights reserved.
 */
let PageTemplateSchema = class PageTemplateSchema extends ViewSchema {};
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Page Slug',
  description: 'URL-friendly page identifier (e.g., "about-us")',
  placeholder: 'page-slug'
}), IsOptional(), IsString(), __metadata("design:type", String)], PageTemplateSchema.prototype, "slug", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Page Name',
  description: 'Human-readable page name',
  placeholder: 'About Us'
}), IsOptional(), IsString(), __metadata("design:type", String)], PageTemplateSchema.prototype, "name", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXTAREA,
  label: 'Page Description',
  description: 'Description of the page content (used for SEO)',
  placeholder: 'Brief description of this page...'
}), IsOptional(), IsString(), __metadata("design:type", String)], PageTemplateSchema.prototype, "description", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Page Title',
  description: 'HTML title tag content (defaults to name if not provided)',
  placeholder: 'Page Title | Site Name'
}), IsOptional(), IsString(), __metadata("design:type", String)], PageTemplateSchema.prototype, "title", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXTAREA,
  label: 'Meta Keywords',
  description: 'SEO keywords (comma-separated)',
  placeholder: 'keyword1, keyword2, keyword3'
}), IsOptional(), IsString(), __metadata("design:type", String)], PageTemplateSchema.prototype, "metaKeywords", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Meta Author',
  description: 'Page author information',
  placeholder: 'Author Name'
}), IsOptional(), IsString(), __metadata("design:type", String)], PageTemplateSchema.prototype, "metaAuthor", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.URL,
  label: 'Canonical URL',
  description: 'Canonical URL for SEO (optional)',
  placeholder: 'https://example.com/page'
}), IsOptional(), IsString(), __metadata("design:type", String)], PageTemplateSchema.prototype, "canonicalUrl", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXTAREA,
  label: 'Page Content',
  description: 'Main page content - can include React components and HTML'
}), IsOptional(), __metadata("design:type", Object)], PageTemplateSchema.prototype, "children", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.FORM,
  label: 'Print Configuration',
  description: 'Configuration for print mode behavior'
}), IsOptional(), ValidateNested(), Type(() => PrintConfigSchema), __metadata("design:type", PrintConfigSchema)], PageTemplateSchema.prototype, "printConfig", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Layout Template',
  description: 'Layout template identifier to use for this page',
  placeholder: 'default, fullwidth, sidebar, etc.'
}), IsOptional(), IsString(), __metadata("design:type", String)], PageTemplateSchema.prototype, "layout", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Page Icon',
  description: 'Icon identifier for page (used in navigation)',
  placeholder: 'home, about, contact'
}), IsOptional(), IsString(), __metadata("design:type", String)], PageTemplateSchema.prototype, "icon", void 0);
__decorate([Field({
  defaultValue: false
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Requires Authentication',
  description: 'Whether this page requires user authentication'
}), IsOptional(), __metadata("design:type", Boolean)], PageTemplateSchema.prototype, "requiresAuth", void 0);
__decorate([Field(), Editor({
  field_type: FieldType.TEXT,
  label: 'Required Roles',
  description: 'Comma-separated list of roles required to access this page',
  placeholder: 'admin, user, moderator'
}), IsOptional(), IsString(), __metadata("design:type", String)], PageTemplateSchema.prototype, "requiredRoles", void 0);
__decorate([Field({
  defaultValue: true
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Show in Navigation',
  description: 'Whether to include this page in navigation menus'
}), IsOptional(), __metadata("design:type", Boolean)], PageTemplateSchema.prototype, "showInNavigation", void 0);
__decorate([Field({
  defaultValue: 0
}), Editor({
  field_type: FieldType.NUMBER,
  label: 'Navigation Priority',
  description: 'Priority in navigation (lower numbers appear first)'
}), IsOptional(), __metadata("design:type", Number)], PageTemplateSchema.prototype, "navigationPriority", void 0);
__decorate([Field({
  defaultValue: true
}), Editor({
  field_type: FieldType.BOOLEAN,
  label: 'Indexable',
  description: 'Whether search engines should index this page'
}), IsOptional(), __metadata("design:type", Boolean)], PageTemplateSchema.prototype, "indexable", void 0);
PageTemplateSchema = __decorate([Schema('PageTemplate', '1.0.0')], PageTemplateSchema);

export { AVAILABLE_PALETTES, AccessibilityProvider, ActionModel, ActionType, AllPalettes, AppConfig, AppConfigBuilder, Article, ArticleModel, Breadcrumbs, Button, Captcha, CaptchaModel, CardListGrid, CardListGridModel, ChoiceInputField, ChoiceInputFieldModel, Code, CodeModel, CollapsibleLayout, CollapsibleLayoutView, ComponentTransformer$1 as ComponentTransformer, Container$8 as Container, Content, ContentModel, CoverImageHeader, CoverImageHeaderModel, DataProvider, DataProxy, DataTable, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, DimensionsProvider, ErrorBoundary, FeatureCard, FeatureCardActionModel, FeatureCardModel, FeatureGrid, FeatureGridModel, FeatureItemModel, Footer, FooterItemModel, FooterModel, FooterSectionModel, FormBlock, FormBlockModel, FormCheckbox, FormCheckboxModel, FormField, FormFieldModel, FormMethod, FormPage, FormSelect, FormSelectModel, GalleryImageModel, GridCell, GridCellModel, GridLayout, GridLayoutModel, HeaderActionModel, HeroBlock, HeroBlockModel, HeroSlideshow, Html, HtmlInputField, HtmlModel, Image, ImageGallery, ImageGalleryModel, ImageModel, Logo, Markdown, MarkdownModel, MetadataItemModel, ModelView, NavigationProvider, OptionSelector, OptionSelectorModel, Page, PageBannerHeader, PageBannerHeaderModel, PageTemplateSchema, PaletteAutumn, PaletteBoutique, PaletteCosmic, PaletteDefault, PaletteOcean, PaletteProvider, PaletteSpring, PaletteSwitcher, PaletteSwitcherModel, PaletteWinter, PrintConfigSchema, PrintModeProvider, ProductCard, ProductCardActionModel, ProductCardModel, ProductLogo, ProductModel, QWICKAPP_COMPONENT, QwickApp, QwickAppsLogo, QwickIcon, ResponsiveMenu, SafeSpan, SafeSpanModel, Scaffold, SchemaFormRenderer, Section, SectionModel, SelectInputField, SelectOptionModel, StatCard, SwitchInputField, T, Text$1 as Text, TextField, TextInputField, TextInputFieldModel, TextModel, ThemeProvider, ThemeSwitcher, ThemeSwitcherModel, ViewSchema, animationConfigs, applyCustomPalette, clearManifestCache, clearPaletteCache, clearUserPalettePreference, clearUserThemePreference, configurePaletteLoader, createAppConfig, createModelViewClass, createPaletteFromCurrentTheme, createSerializableView, defaultCollapsibleLayoutProps, deleteCustomPalette, exportPalette, extractTextFromReactNode, getAvailablePalettes, getCSSVariable, getComputedTheme, getCurrentPalette, getCurrentTheme, getCustomPalettes, getIconComponent, getIconEmoji, getLogger, getPaletteConfig, getPaletteFromManifest, getPaletteName, getRegisteredIcons, getSystemTheme, getThemePerformanceStats, hasIcon, iconMap, importPalette, initializePalette, initializeTheme, isCollapsibleLayoutProps, isPaletteLoaded, loadPalette, loadPaletteManifest, loadUserPalettePreference, loadUserThemePreference, logThemePerformanceStats, loggers, preloadPalettes, registerCustomPalette, registerIcon, resetThemePerformanceStats, resolveDimension, resolveDimensions, resolveSpacing, resolveSpacingProps, saveCustomPalette, savePalettePreference, saveThemePreference, saveUserPalettePreference, saveUserThemePreference, setCSSVariable, setPalette, setTheme, spacingConfigs, t, toCssLength, useAccessibility, useBaseProps, useBreadcrumbs, useCollapsibleState, useData, useDataBinding, useDataContext, useDataProvider, useDimensions, useNavigation, usePageContext, usePalette, usePrintMode$1 as usePrintMode, usePrintMode as usePrintModeHook, useQwickApp, useResolveTemplate, useTemplate, useTheme, withAccessibility, withErrorBoundary };
